
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec44b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec44b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aPfka", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $7e1a8de1463f8dc5$export$ffb0004e005737fa, (v) => $7e1a8de1463f8dc5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $7e1a8de1463f8dc5$export$34b9dba7ce09269b, (v) => $7e1a8de1463f8dc5$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $7e1a8de1463f8dc5$export$25062201e9e25d76, (v) => $7e1a8de1463f8dc5$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7e1a8de1463f8dc5$export$ffb0004e005737fa;
var $7e1a8de1463f8dc5$export$34b9dba7ce09269b;
var $7e1a8de1463f8dc5$export$25062201e9e25d76;
'use strict';

var $aqdBs = parcelRequire("aqdBs");
var $7e1a8de1463f8dc5$var$k = Symbol.for("react.element"), $7e1a8de1463f8dc5$var$l = Symbol.for("react.fragment"), $7e1a8de1463f8dc5$var$m = Object.prototype.hasOwnProperty, $7e1a8de1463f8dc5$var$n = $aqdBs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $7e1a8de1463f8dc5$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7e1a8de1463f8dc5$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$7e1a8de1463f8dc5$var$m.call(a, b) && !$7e1a8de1463f8dc5$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $7e1a8de1463f8dc5$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $7e1a8de1463f8dc5$var$n.current
    };
}
$7e1a8de1463f8dc5$export$ffb0004e005737fa = $7e1a8de1463f8dc5$var$l;
$7e1a8de1463f8dc5$export$34b9dba7ce09269b = $7e1a8de1463f8dc5$var$q;
$7e1a8de1463f8dc5$export$25062201e9e25d76 = $7e1a8de1463f8dc5$var$q;

});
parcelRegister("aqdBs", function(module, exports) {
'use strict';

module.exports = (parcelRequire("WCsmQ"));

});
parcelRegister("WCsmQ", function(module, exports) {

$parcel$export(module.exports, "Children", () => $0b033f8fda7971e0$export$dca3b0875bd9a954, (v) => $0b033f8fda7971e0$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $0b033f8fda7971e0$export$16fa2f45be04daa8, (v) => $0b033f8fda7971e0$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $0b033f8fda7971e0$export$ffb0004e005737fa, (v) => $0b033f8fda7971e0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $0b033f8fda7971e0$export$e2c29f18771995cb, (v) => $0b033f8fda7971e0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $0b033f8fda7971e0$export$221d75b3f55bb0bd, (v) => $0b033f8fda7971e0$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $0b033f8fda7971e0$export$5f8d39834fd61797, (v) => $0b033f8fda7971e0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0b033f8fda7971e0$export$74bf444e3cd11ea5, (v) => $0b033f8fda7971e0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b033f8fda7971e0$export$ae55be85d98224ed, (v) => $0b033f8fda7971e0$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $0b033f8fda7971e0$export$3ba232387fd5d6dd, (v) => $0b033f8fda7971e0$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $0b033f8fda7971e0$export$e530037191fcd5d7, (v) => $0b033f8fda7971e0$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $0b033f8fda7971e0$export$fd42f52fd3ae1109, (v) => $0b033f8fda7971e0$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $0b033f8fda7971e0$export$c8a8987d4410bf2d, (v) => $0b033f8fda7971e0$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $0b033f8fda7971e0$export$d38cd72104c1f0e9, (v) => $0b033f8fda7971e0$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $0b033f8fda7971e0$export$7d1e3a5e95ceca43, (v) => $0b033f8fda7971e0$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $0b033f8fda7971e0$export$257a8862b851cb5b, (v) => $0b033f8fda7971e0$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $0b033f8fda7971e0$export$a8257692ac88316c, (v) => $0b033f8fda7971e0$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $0b033f8fda7971e0$export$488013bae63b21da, (v) => $0b033f8fda7971e0$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $0b033f8fda7971e0$export$7c73462e0d25e514, (v) => $0b033f8fda7971e0$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $0b033f8fda7971e0$export$7568632d0d33d16d, (v) => $0b033f8fda7971e0$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $0b033f8fda7971e0$export$88948ce120ea2619, (v) => $0b033f8fda7971e0$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $0b033f8fda7971e0$export$35808ee640e87ca7, (v) => $0b033f8fda7971e0$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $0b033f8fda7971e0$export$fae74005e78b1a27, (v) => $0b033f8fda7971e0$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $0b033f8fda7971e0$export$dc8fbce3eb94dc1e, (v) => $0b033f8fda7971e0$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $0b033f8fda7971e0$export$6a7bc4e911dc01cf, (v) => $0b033f8fda7971e0$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $0b033f8fda7971e0$export$6d9c69b0de29b591, (v) => $0b033f8fda7971e0$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $0b033f8fda7971e0$export$f680877a34711e37, (v) => $0b033f8fda7971e0$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $0b033f8fda7971e0$export$d5a552a76deda3c2, (v) => $0b033f8fda7971e0$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $0b033f8fda7971e0$export$aaabe4eda9ed9969, (v) => $0b033f8fda7971e0$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $0b033f8fda7971e0$export$e5c5a5f917a5871c, (v) => $0b033f8fda7971e0$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $0b033f8fda7971e0$export$1538c33de8887b59, (v) => $0b033f8fda7971e0$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $0b033f8fda7971e0$export$13e3392192263954, (v) => $0b033f8fda7971e0$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $0b033f8fda7971e0$export$b8f5890fc79d6aca, (v) => $0b033f8fda7971e0$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $0b033f8fda7971e0$export$60241385465d0a34, (v) => $0b033f8fda7971e0$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $0b033f8fda7971e0$export$306c0aa65ff9ec16, (v) => $0b033f8fda7971e0$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $0b033f8fda7971e0$export$7b286972b8d8ccbf, (v) => $0b033f8fda7971e0$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $0b033f8fda7971e0$export$83d89fbfd8236492, (v) => $0b033f8fda7971e0$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0b033f8fda7971e0$export$dca3b0875bd9a954;
var $0b033f8fda7971e0$export$16fa2f45be04daa8;
var $0b033f8fda7971e0$export$ffb0004e005737fa;
var $0b033f8fda7971e0$export$e2c29f18771995cb;
var $0b033f8fda7971e0$export$221d75b3f55bb0bd;
var $0b033f8fda7971e0$export$5f8d39834fd61797;
var $0b033f8fda7971e0$export$74bf444e3cd11ea5;
var $0b033f8fda7971e0$export$ae55be85d98224ed;
var $0b033f8fda7971e0$export$3ba232387fd5d6dd;
var $0b033f8fda7971e0$export$e530037191fcd5d7;
var $0b033f8fda7971e0$export$fd42f52fd3ae1109;
var $0b033f8fda7971e0$export$c8a8987d4410bf2d;
var $0b033f8fda7971e0$export$d38cd72104c1f0e9;
var $0b033f8fda7971e0$export$7d1e3a5e95ceca43;
var $0b033f8fda7971e0$export$257a8862b851cb5b;
var $0b033f8fda7971e0$export$a8257692ac88316c;
var $0b033f8fda7971e0$export$488013bae63b21da;
var $0b033f8fda7971e0$export$7c73462e0d25e514;
var $0b033f8fda7971e0$export$7568632d0d33d16d;
var $0b033f8fda7971e0$export$88948ce120ea2619;
var $0b033f8fda7971e0$export$35808ee640e87ca7;
var $0b033f8fda7971e0$export$fae74005e78b1a27;
var $0b033f8fda7971e0$export$dc8fbce3eb94dc1e;
var $0b033f8fda7971e0$export$6a7bc4e911dc01cf;
var $0b033f8fda7971e0$export$6d9c69b0de29b591;
var $0b033f8fda7971e0$export$f680877a34711e37;
var $0b033f8fda7971e0$export$d5a552a76deda3c2;
var $0b033f8fda7971e0$export$aaabe4eda9ed9969;
var $0b033f8fda7971e0$export$e5c5a5f917a5871c;
var $0b033f8fda7971e0$export$1538c33de8887b59;
var $0b033f8fda7971e0$export$13e3392192263954;
var $0b033f8fda7971e0$export$b8f5890fc79d6aca;
var $0b033f8fda7971e0$export$60241385465d0a34;
var $0b033f8fda7971e0$export$306c0aa65ff9ec16;
var $0b033f8fda7971e0$export$7b286972b8d8ccbf;
var $0b033f8fda7971e0$export$83d89fbfd8236492;
'use strict';
var $0b033f8fda7971e0$var$l = Symbol.for("react.element"), $0b033f8fda7971e0$var$n = Symbol.for("react.portal"), $0b033f8fda7971e0$var$p = Symbol.for("react.fragment"), $0b033f8fda7971e0$var$q = Symbol.for("react.strict_mode"), $0b033f8fda7971e0$var$r = Symbol.for("react.profiler"), $0b033f8fda7971e0$var$t = Symbol.for("react.provider"), $0b033f8fda7971e0$var$u = Symbol.for("react.context"), $0b033f8fda7971e0$var$v = Symbol.for("react.forward_ref"), $0b033f8fda7971e0$var$w = Symbol.for("react.suspense"), $0b033f8fda7971e0$var$x = Symbol.for("react.memo"), $0b033f8fda7971e0$var$y = Symbol.for("react.lazy"), $0b033f8fda7971e0$var$z = Symbol.iterator;
function $0b033f8fda7971e0$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b033f8fda7971e0$var$z && a[$0b033f8fda7971e0$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b033f8fda7971e0$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0b033f8fda7971e0$var$C = Object.assign, $0b033f8fda7971e0$var$D = {};
function $0b033f8fda7971e0$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0b033f8fda7971e0$var$D;
    this.updater = e || $0b033f8fda7971e0$var$B;
}
$0b033f8fda7971e0$var$E.prototype.isReactComponent = {};
$0b033f8fda7971e0$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0b033f8fda7971e0$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0b033f8fda7971e0$var$F() {}
$0b033f8fda7971e0$var$F.prototype = $0b033f8fda7971e0$var$E.prototype;
function $0b033f8fda7971e0$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0b033f8fda7971e0$var$D;
    this.updater = e || $0b033f8fda7971e0$var$B;
}
var $0b033f8fda7971e0$var$H = $0b033f8fda7971e0$var$G.prototype = new $0b033f8fda7971e0$var$F;
$0b033f8fda7971e0$var$H.constructor = $0b033f8fda7971e0$var$G;
$0b033f8fda7971e0$var$C($0b033f8fda7971e0$var$H, $0b033f8fda7971e0$var$E.prototype);
$0b033f8fda7971e0$var$H.isPureReactComponent = !0;
var $0b033f8fda7971e0$var$I = Array.isArray, $0b033f8fda7971e0$var$J = Object.prototype.hasOwnProperty, $0b033f8fda7971e0$var$K = {
    current: null
}, $0b033f8fda7971e0$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0b033f8fda7971e0$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$0b033f8fda7971e0$var$J.call(b, d) && !$0b033f8fda7971e0$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $0b033f8fda7971e0$var$K.current
    };
}
function $0b033f8fda7971e0$var$N(a, b) {
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0b033f8fda7971e0$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0b033f8fda7971e0$var$l;
}
function $0b033f8fda7971e0$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0b033f8fda7971e0$var$P = /\/+/g;
function $0b033f8fda7971e0$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0b033f8fda7971e0$var$escape("" + a.key) : b.toString(36);
}
function $0b033f8fda7971e0$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0b033f8fda7971e0$var$l:
                case $0b033f8fda7971e0$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $0b033f8fda7971e0$var$Q(h, 0) : d, $0b033f8fda7971e0$var$I(c) ? (e = "", null != a && (e = a.replace($0b033f8fda7971e0$var$P, "$&/") + "/"), $0b033f8fda7971e0$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($0b033f8fda7971e0$var$O(c) && (c = $0b033f8fda7971e0$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($0b033f8fda7971e0$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($0b033f8fda7971e0$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $0b033f8fda7971e0$var$Q(k, g);
        h += $0b033f8fda7971e0$var$R(k, b, e, f, c);
    }
    else if (f = $0b033f8fda7971e0$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $0b033f8fda7971e0$var$Q(k, g++), h += $0b033f8fda7971e0$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $0b033f8fda7971e0$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $0b033f8fda7971e0$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $0b033f8fda7971e0$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $0b033f8fda7971e0$var$U = {
    current: null
}, $0b033f8fda7971e0$var$V = {
    transition: null
}, $0b033f8fda7971e0$var$W = {
    ReactCurrentDispatcher: $0b033f8fda7971e0$var$U,
    ReactCurrentBatchConfig: $0b033f8fda7971e0$var$V,
    ReactCurrentOwner: $0b033f8fda7971e0$var$K
};
function $0b033f8fda7971e0$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$0b033f8fda7971e0$export$dca3b0875bd9a954 = {
    map: $0b033f8fda7971e0$var$S,
    forEach: function(a, b, e) {
        $0b033f8fda7971e0$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $0b033f8fda7971e0$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $0b033f8fda7971e0$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$0b033f8fda7971e0$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$0b033f8fda7971e0$export$16fa2f45be04daa8 = $0b033f8fda7971e0$var$E;
$0b033f8fda7971e0$export$ffb0004e005737fa = $0b033f8fda7971e0$var$p;
$0b033f8fda7971e0$export$e2c29f18771995cb = $0b033f8fda7971e0$var$r;
$0b033f8fda7971e0$export$221d75b3f55bb0bd = $0b033f8fda7971e0$var$G;
$0b033f8fda7971e0$export$5f8d39834fd61797 = $0b033f8fda7971e0$var$q;
$0b033f8fda7971e0$export$74bf444e3cd11ea5 = $0b033f8fda7971e0$var$w;
$0b033f8fda7971e0$export$ae55be85d98224ed = $0b033f8fda7971e0$var$W;
$0b033f8fda7971e0$export$3ba232387fd5d6dd = $0b033f8fda7971e0$var$X;
$0b033f8fda7971e0$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $0b033f8fda7971e0$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $0b033f8fda7971e0$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$0b033f8fda7971e0$var$J.call(b, f) && !$0b033f8fda7971e0$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$0b033f8fda7971e0$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $0b033f8fda7971e0$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $0b033f8fda7971e0$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$0b033f8fda7971e0$export$c8a8987d4410bf2d = $0b033f8fda7971e0$var$M;
$0b033f8fda7971e0$export$d38cd72104c1f0e9 = function(a) {
    var b = $0b033f8fda7971e0$var$M.bind(null, a);
    b.type = a;
    return b;
};
$0b033f8fda7971e0$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0b033f8fda7971e0$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0b033f8fda7971e0$var$v,
        render: a
    };
};
$0b033f8fda7971e0$export$a8257692ac88316c = $0b033f8fda7971e0$var$O;
$0b033f8fda7971e0$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0b033f8fda7971e0$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $0b033f8fda7971e0$var$T
    };
};
$0b033f8fda7971e0$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0b033f8fda7971e0$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0b033f8fda7971e0$export$7568632d0d33d16d = function(a) {
    var b = $0b033f8fda7971e0$var$V.transition;
    $0b033f8fda7971e0$var$V.transition = {};
    try {
        a();
    } finally{
        $0b033f8fda7971e0$var$V.transition = b;
    }
};
$0b033f8fda7971e0$export$88948ce120ea2619 = $0b033f8fda7971e0$var$X;
$0b033f8fda7971e0$export$35808ee640e87ca7 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useCallback(a, b);
};
$0b033f8fda7971e0$export$fae74005e78b1a27 = function(a) {
    return $0b033f8fda7971e0$var$U.current.useContext(a);
};
$0b033f8fda7971e0$export$dc8fbce3eb94dc1e = function() {};
$0b033f8fda7971e0$export$6a7bc4e911dc01cf = function(a) {
    return $0b033f8fda7971e0$var$U.current.useDeferredValue(a);
};
$0b033f8fda7971e0$export$6d9c69b0de29b591 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useEffect(a, b);
};
$0b033f8fda7971e0$export$f680877a34711e37 = function() {
    return $0b033f8fda7971e0$var$U.current.useId();
};
$0b033f8fda7971e0$export$d5a552a76deda3c2 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useImperativeHandle(a, b, e);
};
$0b033f8fda7971e0$export$aaabe4eda9ed9969 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useInsertionEffect(a, b);
};
$0b033f8fda7971e0$export$e5c5a5f917a5871c = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useLayoutEffect(a, b);
};
$0b033f8fda7971e0$export$1538c33de8887b59 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useMemo(a, b);
};
$0b033f8fda7971e0$export$13e3392192263954 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useReducer(a, b, e);
};
$0b033f8fda7971e0$export$b8f5890fc79d6aca = function(a) {
    return $0b033f8fda7971e0$var$U.current.useRef(a);
};
$0b033f8fda7971e0$export$60241385465d0a34 = function(a) {
    return $0b033f8fda7971e0$var$U.current.useState(a);
};
$0b033f8fda7971e0$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useSyncExternalStore(a, b, e);
};
$0b033f8fda7971e0$export$7b286972b8d8ccbf = function() {
    return $0b033f8fda7971e0$var$U.current.useTransition();
};
$0b033f8fda7971e0$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("l8cRS", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $f62453a6e3b4559e$export$ae55be85d98224ed, (v) => $f62453a6e3b4559e$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $f62453a6e3b4559e$export$d39a5bbd09211389, (v) => $f62453a6e3b4559e$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $f62453a6e3b4559e$export$882461b6382ed46c, (v) => $f62453a6e3b4559e$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $f62453a6e3b4559e$export$466bfc07425424d5, (v) => $f62453a6e3b4559e$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $f62453a6e3b4559e$export$cd75ccfd720a3cd4, (v) => $f62453a6e3b4559e$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $f62453a6e3b4559e$export$fa8d919ba61d84db, (v) => $f62453a6e3b4559e$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $f62453a6e3b4559e$export$757ceba2d55c277e, (v) => $f62453a6e3b4559e$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $f62453a6e3b4559e$export$b3890eb0ae9dca99, (v) => $f62453a6e3b4559e$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $f62453a6e3b4559e$export$502457920280e6be, (v) => $f62453a6e3b4559e$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $f62453a6e3b4559e$export$c78a37762a8d58e1, (v) => $f62453a6e3b4559e$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $f62453a6e3b4559e$export$dc54d992c10e8a18, (v) => $f62453a6e3b4559e$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $f62453a6e3b4559e$export$83d89fbfd8236492, (v) => $f62453a6e3b4559e$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f62453a6e3b4559e$export$ae55be85d98224ed;
var $f62453a6e3b4559e$export$d39a5bbd09211389;
var $f62453a6e3b4559e$export$882461b6382ed46c;
var $f62453a6e3b4559e$export$466bfc07425424d5;
var $f62453a6e3b4559e$export$cd75ccfd720a3cd4;
var $f62453a6e3b4559e$export$fa8d919ba61d84db;
var $f62453a6e3b4559e$export$757ceba2d55c277e;
var $f62453a6e3b4559e$export$b3890eb0ae9dca99;
var $f62453a6e3b4559e$export$502457920280e6be;
var $f62453a6e3b4559e$export$c78a37762a8d58e1;
var $f62453a6e3b4559e$export$dc54d992c10e8a18;
var $f62453a6e3b4559e$export$83d89fbfd8236492;
'use strict';

var $aqdBs = parcelRequire("aqdBs");

var $7zDBh = parcelRequire("7zDBh");
function $f62453a6e3b4559e$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f62453a6e3b4559e$var$da = new Set, $f62453a6e3b4559e$var$ea = {};
function $f62453a6e3b4559e$var$fa(a, b) {
    $f62453a6e3b4559e$var$ha(a, b);
    $f62453a6e3b4559e$var$ha(a + "Capture", b);
}
function $f62453a6e3b4559e$var$ha(a, b) {
    $f62453a6e3b4559e$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$f62453a6e3b4559e$var$da.add(b[a]);
}
var $f62453a6e3b4559e$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f62453a6e3b4559e$var$ja = Object.prototype.hasOwnProperty, $f62453a6e3b4559e$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f62453a6e3b4559e$var$la = {}, $f62453a6e3b4559e$var$ma = {};
function $f62453a6e3b4559e$var$oa(a) {
    if ($f62453a6e3b4559e$var$ja.call($f62453a6e3b4559e$var$ma, a)) return !0;
    if ($f62453a6e3b4559e$var$ja.call($f62453a6e3b4559e$var$la, a)) return !1;
    if ($f62453a6e3b4559e$var$ka.test(a)) return $f62453a6e3b4559e$var$ma[a] = !0;
    $f62453a6e3b4559e$var$la[a] = !0;
    return !1;
}
function $f62453a6e3b4559e$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $f62453a6e3b4559e$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $f62453a6e3b4559e$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $f62453a6e3b4559e$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $f62453a6e3b4559e$var$ra = /[\-:]([a-z])/g;
function $f62453a6e3b4559e$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$f62453a6e3b4559e$var$z.xlinkHref = new $f62453a6e3b4559e$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $f62453a6e3b4559e$var$ta(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$z.hasOwnProperty(b) ? $f62453a6e3b4559e$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $f62453a6e3b4559e$var$qa(b, c, e, d) && (c = null), d || null === e ? $f62453a6e3b4559e$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $f62453a6e3b4559e$var$ua = $aqdBs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $f62453a6e3b4559e$var$va = Symbol.for("react.element"), $f62453a6e3b4559e$var$wa = Symbol.for("react.portal"), $f62453a6e3b4559e$var$ya = Symbol.for("react.fragment"), $f62453a6e3b4559e$var$za = Symbol.for("react.strict_mode"), $f62453a6e3b4559e$var$Aa = Symbol.for("react.profiler"), $f62453a6e3b4559e$var$Ba = Symbol.for("react.provider"), $f62453a6e3b4559e$var$Ca = Symbol.for("react.context"), $f62453a6e3b4559e$var$Da = Symbol.for("react.forward_ref"), $f62453a6e3b4559e$var$Ea = Symbol.for("react.suspense"), $f62453a6e3b4559e$var$Fa = Symbol.for("react.suspense_list"), $f62453a6e3b4559e$var$Ga = Symbol.for("react.memo"), $f62453a6e3b4559e$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $f62453a6e3b4559e$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $f62453a6e3b4559e$var$Ja = Symbol.iterator;
function $f62453a6e3b4559e$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f62453a6e3b4559e$var$Ja && a[$f62453a6e3b4559e$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f62453a6e3b4559e$var$A = Object.assign, $f62453a6e3b4559e$var$La;
function $f62453a6e3b4559e$var$Ma(a) {
    if (void 0 === $f62453a6e3b4559e$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $f62453a6e3b4559e$var$La = b && b[1] || "";
    }
    return "\n" + $f62453a6e3b4559e$var$La + a;
}
var $f62453a6e3b4559e$var$Na = !1;
function $f62453a6e3b4559e$var$Oa(a, b) {
    if (!a || $f62453a6e3b4559e$var$Na) return "";
    $f62453a6e3b4559e$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $f62453a6e3b4559e$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $f62453a6e3b4559e$var$Ma(a) : "";
}
function $f62453a6e3b4559e$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $f62453a6e3b4559e$var$Ma(a.type);
        case 16:
            return $f62453a6e3b4559e$var$Ma("Lazy");
        case 13:
            return $f62453a6e3b4559e$var$Ma("Suspense");
        case 19:
            return $f62453a6e3b4559e$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $f62453a6e3b4559e$var$Oa(a.type, !1), a;
        case 11:
            return a = $f62453a6e3b4559e$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $f62453a6e3b4559e$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $f62453a6e3b4559e$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $f62453a6e3b4559e$var$ya:
            return "Fragment";
        case $f62453a6e3b4559e$var$wa:
            return "Portal";
        case $f62453a6e3b4559e$var$Aa:
            return "Profiler";
        case $f62453a6e3b4559e$var$za:
            return "StrictMode";
        case $f62453a6e3b4559e$var$Ea:
            return "Suspense";
        case $f62453a6e3b4559e$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $f62453a6e3b4559e$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $f62453a6e3b4559e$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $f62453a6e3b4559e$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $f62453a6e3b4559e$var$Ga:
            return b = a.displayName || null, null !== b ? b : $f62453a6e3b4559e$var$Qa(a.type) || "Memo";
        case $f62453a6e3b4559e$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $f62453a6e3b4559e$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $f62453a6e3b4559e$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $f62453a6e3b4559e$var$Qa(b);
        case 8:
            return b === $f62453a6e3b4559e$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $f62453a6e3b4559e$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $f62453a6e3b4559e$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $f62453a6e3b4559e$var$Ua(a) {
    var b = $f62453a6e3b4559e$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $f62453a6e3b4559e$var$Va(a) {
    a._valueTracker || (a._valueTracker = $f62453a6e3b4559e$var$Ua(a));
}
function $f62453a6e3b4559e$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $f62453a6e3b4559e$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $f62453a6e3b4559e$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $f62453a6e3b4559e$var$Ya(a, b) {
    var c = b.checked;
    return $f62453a6e3b4559e$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $f62453a6e3b4559e$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $f62453a6e3b4559e$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $f62453a6e3b4559e$var$ab(a, b) {
    b = b.checked;
    null != b && $f62453a6e3b4559e$var$ta(a, "checked", b, !1);
}
function $f62453a6e3b4559e$var$bb(a, b) {
    $f62453a6e3b4559e$var$ab(a, b);
    var c = $f62453a6e3b4559e$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $f62453a6e3b4559e$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $f62453a6e3b4559e$var$cb(a, b.type, $f62453a6e3b4559e$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $f62453a6e3b4559e$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $f62453a6e3b4559e$var$cb(a, b, c) {
    if ("number" !== b || $f62453a6e3b4559e$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $f62453a6e3b4559e$var$eb = Array.isArray;
function $f62453a6e3b4559e$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $f62453a6e3b4559e$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $f62453a6e3b4559e$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($f62453a6e3b4559e$var$p(91));
    return $f62453a6e3b4559e$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $f62453a6e3b4559e$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($f62453a6e3b4559e$var$p(92));
            if ($f62453a6e3b4559e$var$eb(c)) {
                if (1 < c.length) throw Error($f62453a6e3b4559e$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $f62453a6e3b4559e$var$Sa(c)
    };
}
function $f62453a6e3b4559e$var$ib(a, b) {
    var c = $f62453a6e3b4559e$var$Sa(b.value), d = $f62453a6e3b4559e$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $f62453a6e3b4559e$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $f62453a6e3b4559e$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $f62453a6e3b4559e$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $f62453a6e3b4559e$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $f62453a6e3b4559e$var$mb, $f62453a6e3b4559e$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $f62453a6e3b4559e$var$mb = $f62453a6e3b4559e$var$mb || document.createElement("div");
        $f62453a6e3b4559e$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $f62453a6e3b4559e$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $f62453a6e3b4559e$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $f62453a6e3b4559e$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $f62453a6e3b4559e$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($f62453a6e3b4559e$var$pb).forEach(function(a) {
    $f62453a6e3b4559e$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $f62453a6e3b4559e$var$pb[b] = $f62453a6e3b4559e$var$pb[a];
    });
});
function $f62453a6e3b4559e$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $f62453a6e3b4559e$var$pb.hasOwnProperty(a) && $f62453a6e3b4559e$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $f62453a6e3b4559e$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $f62453a6e3b4559e$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $f62453a6e3b4559e$var$tb = $f62453a6e3b4559e$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $f62453a6e3b4559e$var$ub(a, b) {
    if (b) {
        if ($f62453a6e3b4559e$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($f62453a6e3b4559e$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($f62453a6e3b4559e$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($f62453a6e3b4559e$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($f62453a6e3b4559e$var$p(62));
    }
}
function $f62453a6e3b4559e$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f62453a6e3b4559e$var$wb = null;
function $f62453a6e3b4559e$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $f62453a6e3b4559e$var$yb = null, $f62453a6e3b4559e$var$zb = null, $f62453a6e3b4559e$var$Ab = null;
function $f62453a6e3b4559e$var$Bb(a) {
    if (a = $f62453a6e3b4559e$var$Cb(a)) {
        if ("function" !== typeof $f62453a6e3b4559e$var$yb) throw Error($f62453a6e3b4559e$var$p(280));
        var b = a.stateNode;
        b && (b = $f62453a6e3b4559e$var$Db(b), $f62453a6e3b4559e$var$yb(a.stateNode, a.type, b));
    }
}
function $f62453a6e3b4559e$var$Eb(a) {
    $f62453a6e3b4559e$var$zb ? $f62453a6e3b4559e$var$Ab ? $f62453a6e3b4559e$var$Ab.push(a) : $f62453a6e3b4559e$var$Ab = [
        a
    ] : $f62453a6e3b4559e$var$zb = a;
}
function $f62453a6e3b4559e$var$Fb() {
    if ($f62453a6e3b4559e$var$zb) {
        var a = $f62453a6e3b4559e$var$zb, b = $f62453a6e3b4559e$var$Ab;
        $f62453a6e3b4559e$var$Ab = $f62453a6e3b4559e$var$zb = null;
        $f62453a6e3b4559e$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$f62453a6e3b4559e$var$Bb(b[a]);
    }
}
function $f62453a6e3b4559e$var$Gb(a, b) {
    return a(b);
}
function $f62453a6e3b4559e$var$Hb() {}
var $f62453a6e3b4559e$var$Ib = !1;
function $f62453a6e3b4559e$var$Jb(a, b, c) {
    if ($f62453a6e3b4559e$var$Ib) return a(b, c);
    $f62453a6e3b4559e$var$Ib = !0;
    try {
        return $f62453a6e3b4559e$var$Gb(a, b, c);
    } finally{
        if ($f62453a6e3b4559e$var$Ib = !1, null !== $f62453a6e3b4559e$var$zb || null !== $f62453a6e3b4559e$var$Ab) $f62453a6e3b4559e$var$Hb(), $f62453a6e3b4559e$var$Fb();
    }
}
function $f62453a6e3b4559e$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $f62453a6e3b4559e$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($f62453a6e3b4559e$var$p(231, b, typeof c));
    return c;
}
var $f62453a6e3b4559e$var$Lb = !1;
if ($f62453a6e3b4559e$var$ia) try {
    var $f62453a6e3b4559e$var$Mb = {};
    Object.defineProperty($f62453a6e3b4559e$var$Mb, "passive", {
        get: function() {
            $f62453a6e3b4559e$var$Lb = !0;
        }
    });
    window.addEventListener("test", $f62453a6e3b4559e$var$Mb, $f62453a6e3b4559e$var$Mb);
    window.removeEventListener("test", $f62453a6e3b4559e$var$Mb, $f62453a6e3b4559e$var$Mb);
} catch (a) {
    $f62453a6e3b4559e$var$Lb = !1;
}
function $f62453a6e3b4559e$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $f62453a6e3b4559e$var$Ob = !1, $f62453a6e3b4559e$var$Pb = null, $f62453a6e3b4559e$var$Qb = !1, $f62453a6e3b4559e$var$Rb = null, $f62453a6e3b4559e$var$Sb = {
    onError: function(a) {
        $f62453a6e3b4559e$var$Ob = !0;
        $f62453a6e3b4559e$var$Pb = a;
    }
};
function $f62453a6e3b4559e$var$Tb(a, b, c, d, e, f, g, h, k) {
    $f62453a6e3b4559e$var$Ob = !1;
    $f62453a6e3b4559e$var$Pb = null;
    $f62453a6e3b4559e$var$Nb.apply($f62453a6e3b4559e$var$Sb, arguments);
}
function $f62453a6e3b4559e$var$Ub(a, b, c, d, e, f, g, h, k) {
    $f62453a6e3b4559e$var$Tb.apply(this, arguments);
    if ($f62453a6e3b4559e$var$Ob) {
        if ($f62453a6e3b4559e$var$Ob) {
            var l = $f62453a6e3b4559e$var$Pb;
            $f62453a6e3b4559e$var$Ob = !1;
            $f62453a6e3b4559e$var$Pb = null;
        } else throw Error($f62453a6e3b4559e$var$p(198));
        $f62453a6e3b4559e$var$Qb || ($f62453a6e3b4559e$var$Qb = !0, $f62453a6e3b4559e$var$Rb = l);
    }
}
function $f62453a6e3b4559e$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $f62453a6e3b4559e$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $f62453a6e3b4559e$var$Xb(a) {
    if ($f62453a6e3b4559e$var$Vb(a) !== a) throw Error($f62453a6e3b4559e$var$p(188));
}
function $f62453a6e3b4559e$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $f62453a6e3b4559e$var$Vb(a);
        if (null === b) throw Error($f62453a6e3b4559e$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $f62453a6e3b4559e$var$Xb(e), a;
                if (f === d) return $f62453a6e3b4559e$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($f62453a6e3b4559e$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($f62453a6e3b4559e$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($f62453a6e3b4559e$var$p(190));
    }
    if (3 !== c.tag) throw Error($f62453a6e3b4559e$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $f62453a6e3b4559e$var$Zb(a) {
    a = $f62453a6e3b4559e$var$Yb(a);
    return null !== a ? $f62453a6e3b4559e$var$$b(a) : null;
}
function $f62453a6e3b4559e$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $f62453a6e3b4559e$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$ac = $7zDBh.unstable_scheduleCallback, $f62453a6e3b4559e$var$bc = $7zDBh.unstable_cancelCallback, $f62453a6e3b4559e$var$cc = $7zDBh.unstable_shouldYield, $f62453a6e3b4559e$var$dc = $7zDBh.unstable_requestPaint, $f62453a6e3b4559e$var$B = $7zDBh.unstable_now, $f62453a6e3b4559e$var$ec = $7zDBh.unstable_getCurrentPriorityLevel, $f62453a6e3b4559e$var$fc = $7zDBh.unstable_ImmediatePriority, $f62453a6e3b4559e$var$gc = $7zDBh.unstable_UserBlockingPriority, $f62453a6e3b4559e$var$hc = $7zDBh.unstable_NormalPriority, $f62453a6e3b4559e$var$ic = $7zDBh.unstable_LowPriority, $f62453a6e3b4559e$var$jc = $7zDBh.unstable_IdlePriority, $f62453a6e3b4559e$var$kc = null, $f62453a6e3b4559e$var$lc = null;
function $f62453a6e3b4559e$var$mc(a) {
    if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onCommitFiberRoot) try {
        $f62453a6e3b4559e$var$lc.onCommitFiberRoot($f62453a6e3b4559e$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $f62453a6e3b4559e$var$oc = Math.clz32 ? Math.clz32 : $f62453a6e3b4559e$var$nc, $f62453a6e3b4559e$var$pc = Math.log, $f62453a6e3b4559e$var$qc = Math.LN2;
function $f62453a6e3b4559e$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($f62453a6e3b4559e$var$pc(a) / $f62453a6e3b4559e$var$qc | 0) | 0;
}
var $f62453a6e3b4559e$var$rc = 64, $f62453a6e3b4559e$var$sc = 4194304;
function $f62453a6e3b4559e$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $f62453a6e3b4559e$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $f62453a6e3b4559e$var$tc(h) : (f &= g, 0 !== f && (d = $f62453a6e3b4559e$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $f62453a6e3b4559e$var$tc(g) : 0 !== f && (d = $f62453a6e3b4559e$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $f62453a6e3b4559e$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $f62453a6e3b4559e$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f62453a6e3b4559e$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $f62453a6e3b4559e$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $f62453a6e3b4559e$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $f62453a6e3b4559e$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $f62453a6e3b4559e$var$yc() {
    var a = $f62453a6e3b4559e$var$rc;
    $f62453a6e3b4559e$var$rc <<= 1;
    0 === ($f62453a6e3b4559e$var$rc & 4194240) && ($f62453a6e3b4559e$var$rc = 64);
    return a;
}
function $f62453a6e3b4559e$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $f62453a6e3b4559e$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $f62453a6e3b4559e$var$oc(b);
    a[b] = c;
}
function $f62453a6e3b4559e$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $f62453a6e3b4559e$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $f62453a6e3b4559e$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $f62453a6e3b4559e$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $f62453a6e3b4559e$var$C = 0;
function $f62453a6e3b4559e$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $f62453a6e3b4559e$var$Ec, $f62453a6e3b4559e$var$Fc, $f62453a6e3b4559e$var$Gc, $f62453a6e3b4559e$var$Hc, $f62453a6e3b4559e$var$Ic, $f62453a6e3b4559e$var$Jc = !1, $f62453a6e3b4559e$var$Kc = [], $f62453a6e3b4559e$var$Lc = null, $f62453a6e3b4559e$var$Mc = null, $f62453a6e3b4559e$var$Nc = null, $f62453a6e3b4559e$var$Oc = new Map, $f62453a6e3b4559e$var$Pc = new Map, $f62453a6e3b4559e$var$Qc = [], $f62453a6e3b4559e$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $f62453a6e3b4559e$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $f62453a6e3b4559e$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $f62453a6e3b4559e$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $f62453a6e3b4559e$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $f62453a6e3b4559e$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f62453a6e3b4559e$var$Pc.delete(b.pointerId);
    }
}
function $f62453a6e3b4559e$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $f62453a6e3b4559e$var$Cb(b), null !== b && $f62453a6e3b4559e$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $f62453a6e3b4559e$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $f62453a6e3b4559e$var$Lc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $f62453a6e3b4559e$var$Mc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $f62453a6e3b4559e$var$Nc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $f62453a6e3b4559e$var$Oc.set(f, $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $f62453a6e3b4559e$var$Pc.set(f, $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $f62453a6e3b4559e$var$Vc(a) {
    var b = $f62453a6e3b4559e$var$Wc(a.target);
    if (null !== b) {
        var c = $f62453a6e3b4559e$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $f62453a6e3b4559e$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $f62453a6e3b4559e$var$Ic(a.priority, function() {
                        $f62453a6e3b4559e$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $f62453a6e3b4559e$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $f62453a6e3b4559e$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $f62453a6e3b4559e$var$wb = d;
            c.target.dispatchEvent(d);
            $f62453a6e3b4559e$var$wb = null;
        } else return b = $f62453a6e3b4559e$var$Cb(c), null !== b && $f62453a6e3b4559e$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $f62453a6e3b4559e$var$Zc(a, b, c) {
    $f62453a6e3b4559e$var$Xc(a) && c.delete(b);
}
function $f62453a6e3b4559e$var$$c() {
    $f62453a6e3b4559e$var$Jc = !1;
    null !== $f62453a6e3b4559e$var$Lc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Lc) && ($f62453a6e3b4559e$var$Lc = null);
    null !== $f62453a6e3b4559e$var$Mc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Mc) && ($f62453a6e3b4559e$var$Mc = null);
    null !== $f62453a6e3b4559e$var$Nc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Nc) && ($f62453a6e3b4559e$var$Nc = null);
    $f62453a6e3b4559e$var$Oc.forEach($f62453a6e3b4559e$var$Zc);
    $f62453a6e3b4559e$var$Pc.forEach($f62453a6e3b4559e$var$Zc);
}
function $f62453a6e3b4559e$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $f62453a6e3b4559e$var$Jc || ($f62453a6e3b4559e$var$Jc = !0, $7zDBh.unstable_scheduleCallback($7zDBh.unstable_NormalPriority, $f62453a6e3b4559e$var$$c)));
}
function $f62453a6e3b4559e$var$bd(a) {
    function b(b) {
        return $f62453a6e3b4559e$var$ad(b, a);
    }
    if (0 < $f62453a6e3b4559e$var$Kc.length) {
        $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Kc[0], a);
        for(var c = 1; c < $f62453a6e3b4559e$var$Kc.length; c++){
            var d = $f62453a6e3b4559e$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $f62453a6e3b4559e$var$Lc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Lc, a);
    null !== $f62453a6e3b4559e$var$Mc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Mc, a);
    null !== $f62453a6e3b4559e$var$Nc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Nc, a);
    $f62453a6e3b4559e$var$Oc.forEach(b);
    $f62453a6e3b4559e$var$Pc.forEach(b);
    for(c = 0; c < $f62453a6e3b4559e$var$Qc.length; c++)d = $f62453a6e3b4559e$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $f62453a6e3b4559e$var$Qc.length && (c = $f62453a6e3b4559e$var$Qc[0], null === c.blockedOn);)$f62453a6e3b4559e$var$Vc(c), null === c.blockedOn && $f62453a6e3b4559e$var$Qc.shift();
}
var $f62453a6e3b4559e$var$cd = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$dd = !0;
function $f62453a6e3b4559e$var$ed(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$C, f = $f62453a6e3b4559e$var$cd.transition;
    $f62453a6e3b4559e$var$cd.transition = null;
    try {
        $f62453a6e3b4559e$var$C = 1, $f62453a6e3b4559e$var$fd(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$C = e, $f62453a6e3b4559e$var$cd.transition = f;
    }
}
function $f62453a6e3b4559e$var$gd(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$C, f = $f62453a6e3b4559e$var$cd.transition;
    $f62453a6e3b4559e$var$cd.transition = null;
    try {
        $f62453a6e3b4559e$var$C = 4, $f62453a6e3b4559e$var$fd(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$C = e, $f62453a6e3b4559e$var$cd.transition = f;
    }
}
function $f62453a6e3b4559e$var$fd(a, b, c, d) {
    if ($f62453a6e3b4559e$var$dd) {
        var e = $f62453a6e3b4559e$var$Yc(a, b, c, d);
        if (null === e) $f62453a6e3b4559e$var$hd(a, b, d, $f62453a6e3b4559e$var$id, c), $f62453a6e3b4559e$var$Sc(a, d);
        else if ($f62453a6e3b4559e$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($f62453a6e3b4559e$var$Sc(a, d), b & 4 && -1 < $f62453a6e3b4559e$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $f62453a6e3b4559e$var$Cb(e);
                null !== f && $f62453a6e3b4559e$var$Ec(f);
                f = $f62453a6e3b4559e$var$Yc(a, b, c, d);
                null === f && $f62453a6e3b4559e$var$hd(a, b, d, $f62453a6e3b4559e$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $f62453a6e3b4559e$var$hd(a, b, d, null, c);
    }
}
var $f62453a6e3b4559e$var$id = null;
function $f62453a6e3b4559e$var$Yc(a, b, c, d) {
    $f62453a6e3b4559e$var$id = null;
    a = $f62453a6e3b4559e$var$xb(d);
    a = $f62453a6e3b4559e$var$Wc(a);
    if (null !== a) {
        if (b = $f62453a6e3b4559e$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $f62453a6e3b4559e$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $f62453a6e3b4559e$var$id = a;
    return null;
}
function $f62453a6e3b4559e$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($f62453a6e3b4559e$var$ec()){
                case $f62453a6e3b4559e$var$fc:
                    return 1;
                case $f62453a6e3b4559e$var$gc:
                    return 4;
                case $f62453a6e3b4559e$var$hc:
                case $f62453a6e3b4559e$var$ic:
                    return 16;
                case $f62453a6e3b4559e$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $f62453a6e3b4559e$var$kd = null, $f62453a6e3b4559e$var$ld = null, $f62453a6e3b4559e$var$md = null;
function $f62453a6e3b4559e$var$nd() {
    if ($f62453a6e3b4559e$var$md) return $f62453a6e3b4559e$var$md;
    var a, b = $f62453a6e3b4559e$var$ld, c = b.length, d, e = "value" in $f62453a6e3b4559e$var$kd ? $f62453a6e3b4559e$var$kd.value : $f62453a6e3b4559e$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $f62453a6e3b4559e$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $f62453a6e3b4559e$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $f62453a6e3b4559e$var$pd() {
    return !0;
}
function $f62453a6e3b4559e$var$qd() {
    return !1;
}
function $f62453a6e3b4559e$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $f62453a6e3b4559e$var$pd : $f62453a6e3b4559e$var$qd;
        this.isPropagationStopped = $f62453a6e3b4559e$var$qd;
        return this;
    }
    $f62453a6e3b4559e$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $f62453a6e3b4559e$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $f62453a6e3b4559e$var$pd);
        },
        persist: function() {},
        isPersistent: $f62453a6e3b4559e$var$pd
    });
    return b;
}
var $f62453a6e3b4559e$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f62453a6e3b4559e$var$td = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$sd), $f62453a6e3b4559e$var$ud = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    view: 0,
    detail: 0
}), $f62453a6e3b4559e$var$vd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$ud), $f62453a6e3b4559e$var$wd, $f62453a6e3b4559e$var$xd, $f62453a6e3b4559e$var$yd, $f62453a6e3b4559e$var$Ad = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f62453a6e3b4559e$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $f62453a6e3b4559e$var$yd && ($f62453a6e3b4559e$var$yd && "mousemove" === a.type ? ($f62453a6e3b4559e$var$wd = a.screenX - $f62453a6e3b4559e$var$yd.screenX, $f62453a6e3b4559e$var$xd = a.screenY - $f62453a6e3b4559e$var$yd.screenY) : $f62453a6e3b4559e$var$xd = $f62453a6e3b4559e$var$wd = 0, $f62453a6e3b4559e$var$yd = a);
        return $f62453a6e3b4559e$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $f62453a6e3b4559e$var$xd;
    }
}), $f62453a6e3b4559e$var$Bd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ad), $f62453a6e3b4559e$var$Cd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    dataTransfer: 0
}), $f62453a6e3b4559e$var$Dd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Cd), $f62453a6e3b4559e$var$Ed = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    relatedTarget: 0
}), $f62453a6e3b4559e$var$Fd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ed), $f62453a6e3b4559e$var$Gd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f62453a6e3b4559e$var$Hd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Gd), $f62453a6e3b4559e$var$Id = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $f62453a6e3b4559e$var$Jd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Id), $f62453a6e3b4559e$var$Kd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    data: 0
}), $f62453a6e3b4559e$var$Ld = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Kd), $f62453a6e3b4559e$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f62453a6e3b4559e$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f62453a6e3b4559e$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f62453a6e3b4559e$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $f62453a6e3b4559e$var$Od[a]) ? !!b[a] : !1;
}
function $f62453a6e3b4559e$var$zd() {
    return $f62453a6e3b4559e$var$Pd;
}
var $f62453a6e3b4559e$var$Qd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $f62453a6e3b4559e$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $f62453a6e3b4559e$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $f62453a6e3b4559e$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f62453a6e3b4559e$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $f62453a6e3b4559e$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $f62453a6e3b4559e$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $f62453a6e3b4559e$var$Rd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Qd), $f62453a6e3b4559e$var$Sd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f62453a6e3b4559e$var$Td = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Sd), $f62453a6e3b4559e$var$Ud = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f62453a6e3b4559e$var$zd
}), $f62453a6e3b4559e$var$Vd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ud), $f62453a6e3b4559e$var$Wd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f62453a6e3b4559e$var$Xd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Wd), $f62453a6e3b4559e$var$Yd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f62453a6e3b4559e$var$Zd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Yd), $f62453a6e3b4559e$var$$d = [
    9,
    13,
    27,
    32
], $f62453a6e3b4559e$var$ae = $f62453a6e3b4559e$var$ia && "CompositionEvent" in window, $f62453a6e3b4559e$var$be = null;
$f62453a6e3b4559e$var$ia && "documentMode" in document && ($f62453a6e3b4559e$var$be = document.documentMode);
var $f62453a6e3b4559e$var$ce = $f62453a6e3b4559e$var$ia && "TextEvent" in window && !$f62453a6e3b4559e$var$be, $f62453a6e3b4559e$var$de = $f62453a6e3b4559e$var$ia && (!$f62453a6e3b4559e$var$ae || $f62453a6e3b4559e$var$be && 8 < $f62453a6e3b4559e$var$be && 11 >= $f62453a6e3b4559e$var$be), $f62453a6e3b4559e$var$ee = String.fromCharCode(32), $f62453a6e3b4559e$var$fe = !1;
function $f62453a6e3b4559e$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $f62453a6e3b4559e$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $f62453a6e3b4559e$var$ie = !1;
function $f62453a6e3b4559e$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $f62453a6e3b4559e$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $f62453a6e3b4559e$var$fe = !0;
            return $f62453a6e3b4559e$var$ee;
        case "textInput":
            return a = b.data, a === $f62453a6e3b4559e$var$ee && $f62453a6e3b4559e$var$fe ? null : a;
        default:
            return null;
    }
}
function $f62453a6e3b4559e$var$ke(a, b) {
    if ($f62453a6e3b4559e$var$ie) return "compositionend" === a || !$f62453a6e3b4559e$var$ae && $f62453a6e3b4559e$var$ge(a, b) ? (a = $f62453a6e3b4559e$var$nd(), $f62453a6e3b4559e$var$md = $f62453a6e3b4559e$var$ld = $f62453a6e3b4559e$var$kd = null, $f62453a6e3b4559e$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $f62453a6e3b4559e$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $f62453a6e3b4559e$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f62453a6e3b4559e$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$f62453a6e3b4559e$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $f62453a6e3b4559e$var$ne(a, b, c, d) {
    $f62453a6e3b4559e$var$Eb(d);
    b = $f62453a6e3b4559e$var$oe(b, "onChange");
    0 < b.length && (c = new $f62453a6e3b4559e$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $f62453a6e3b4559e$var$pe = null, $f62453a6e3b4559e$var$qe = null;
function $f62453a6e3b4559e$var$re(a) {
    $f62453a6e3b4559e$var$se(a, 0);
}
function $f62453a6e3b4559e$var$te(a) {
    var b = $f62453a6e3b4559e$var$ue(a);
    if ($f62453a6e3b4559e$var$Wa(b)) return a;
}
function $f62453a6e3b4559e$var$ve(a, b) {
    if ("change" === a) return b;
}
var $f62453a6e3b4559e$var$we = !1;
if ($f62453a6e3b4559e$var$ia) {
    var $f62453a6e3b4559e$var$xe;
    if ($f62453a6e3b4559e$var$ia) {
        var $f62453a6e3b4559e$var$ye = "oninput" in document;
        if (!$f62453a6e3b4559e$var$ye) {
            var $f62453a6e3b4559e$var$ze = document.createElement("div");
            $f62453a6e3b4559e$var$ze.setAttribute("oninput", "return;");
            $f62453a6e3b4559e$var$ye = "function" === typeof $f62453a6e3b4559e$var$ze.oninput;
        }
        $f62453a6e3b4559e$var$xe = $f62453a6e3b4559e$var$ye;
    } else $f62453a6e3b4559e$var$xe = !1;
    $f62453a6e3b4559e$var$we = $f62453a6e3b4559e$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $f62453a6e3b4559e$var$Ae() {
    $f62453a6e3b4559e$var$pe && ($f62453a6e3b4559e$var$pe.detachEvent("onpropertychange", $f62453a6e3b4559e$var$Be), $f62453a6e3b4559e$var$qe = $f62453a6e3b4559e$var$pe = null);
}
function $f62453a6e3b4559e$var$Be(a) {
    if ("value" === a.propertyName && $f62453a6e3b4559e$var$te($f62453a6e3b4559e$var$qe)) {
        var b = [];
        $f62453a6e3b4559e$var$ne(b, $f62453a6e3b4559e$var$qe, a, $f62453a6e3b4559e$var$xb(a));
        $f62453a6e3b4559e$var$Jb($f62453a6e3b4559e$var$re, b);
    }
}
function $f62453a6e3b4559e$var$Ce(a, b, c) {
    "focusin" === a ? ($f62453a6e3b4559e$var$Ae(), $f62453a6e3b4559e$var$pe = b, $f62453a6e3b4559e$var$qe = c, $f62453a6e3b4559e$var$pe.attachEvent("onpropertychange", $f62453a6e3b4559e$var$Be)) : "focusout" === a && $f62453a6e3b4559e$var$Ae();
}
function $f62453a6e3b4559e$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $f62453a6e3b4559e$var$te($f62453a6e3b4559e$var$qe);
}
function $f62453a6e3b4559e$var$Ee(a, b) {
    if ("click" === a) return $f62453a6e3b4559e$var$te(b);
}
function $f62453a6e3b4559e$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $f62453a6e3b4559e$var$te(b);
}
function $f62453a6e3b4559e$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f62453a6e3b4559e$var$He = "function" === typeof Object.is ? Object.is : $f62453a6e3b4559e$var$Ge;
function $f62453a6e3b4559e$var$Ie(a, b) {
    if ($f62453a6e3b4559e$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$f62453a6e3b4559e$var$ja.call(b, e) || !$f62453a6e3b4559e$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $f62453a6e3b4559e$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $f62453a6e3b4559e$var$Ke(a, b) {
    var c = $f62453a6e3b4559e$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $f62453a6e3b4559e$var$Je(c);
    }
}
function $f62453a6e3b4559e$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $f62453a6e3b4559e$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $f62453a6e3b4559e$var$Me() {
    for(var a = window, b = $f62453a6e3b4559e$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $f62453a6e3b4559e$var$Xa(a.document);
    }
    return b;
}
function $f62453a6e3b4559e$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $f62453a6e3b4559e$var$Oe(a) {
    var b = $f62453a6e3b4559e$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $f62453a6e3b4559e$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $f62453a6e3b4559e$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $f62453a6e3b4559e$var$Ke(c, f);
                var g = $f62453a6e3b4559e$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $f62453a6e3b4559e$var$Pe = $f62453a6e3b4559e$var$ia && "documentMode" in document && 11 >= document.documentMode, $f62453a6e3b4559e$var$Qe = null, $f62453a6e3b4559e$var$Re = null, $f62453a6e3b4559e$var$Se = null, $f62453a6e3b4559e$var$Te = !1;
function $f62453a6e3b4559e$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $f62453a6e3b4559e$var$Te || null == $f62453a6e3b4559e$var$Qe || $f62453a6e3b4559e$var$Qe !== $f62453a6e3b4559e$var$Xa(d) || (d = $f62453a6e3b4559e$var$Qe, "selectionStart" in d && $f62453a6e3b4559e$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $f62453a6e3b4559e$var$Se && $f62453a6e3b4559e$var$Ie($f62453a6e3b4559e$var$Se, d) || ($f62453a6e3b4559e$var$Se = d, d = $f62453a6e3b4559e$var$oe($f62453a6e3b4559e$var$Re, "onSelect"), 0 < d.length && (b = new $f62453a6e3b4559e$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $f62453a6e3b4559e$var$Qe)));
}
function $f62453a6e3b4559e$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $f62453a6e3b4559e$var$We = {
    animationend: $f62453a6e3b4559e$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $f62453a6e3b4559e$var$Ve("Animation", "AnimationIteration"),
    animationstart: $f62453a6e3b4559e$var$Ve("Animation", "AnimationStart"),
    transitionend: $f62453a6e3b4559e$var$Ve("Transition", "TransitionEnd")
}, $f62453a6e3b4559e$var$Xe = {}, $f62453a6e3b4559e$var$Ye = {};
$f62453a6e3b4559e$var$ia && ($f62453a6e3b4559e$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $f62453a6e3b4559e$var$We.animationend.animation, delete $f62453a6e3b4559e$var$We.animationiteration.animation, delete $f62453a6e3b4559e$var$We.animationstart.animation), "TransitionEvent" in window || delete $f62453a6e3b4559e$var$We.transitionend.transition);
function $f62453a6e3b4559e$var$Ze(a) {
    if ($f62453a6e3b4559e$var$Xe[a]) return $f62453a6e3b4559e$var$Xe[a];
    if (!$f62453a6e3b4559e$var$We[a]) return a;
    var b = $f62453a6e3b4559e$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $f62453a6e3b4559e$var$Ye) return $f62453a6e3b4559e$var$Xe[a] = b[c];
    return a;
}
var $f62453a6e3b4559e$var$$e = $f62453a6e3b4559e$var$Ze("animationend"), $f62453a6e3b4559e$var$af = $f62453a6e3b4559e$var$Ze("animationiteration"), $f62453a6e3b4559e$var$bf = $f62453a6e3b4559e$var$Ze("animationstart"), $f62453a6e3b4559e$var$cf = $f62453a6e3b4559e$var$Ze("transitionend"), $f62453a6e3b4559e$var$df = new Map, $f62453a6e3b4559e$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $f62453a6e3b4559e$var$ff(a, b) {
    $f62453a6e3b4559e$var$df.set(a, b);
    $f62453a6e3b4559e$var$fa(b, [
        a
    ]);
}
for(var $f62453a6e3b4559e$var$gf = 0; $f62453a6e3b4559e$var$gf < $f62453a6e3b4559e$var$ef.length; $f62453a6e3b4559e$var$gf++){
    var $f62453a6e3b4559e$var$hf = $f62453a6e3b4559e$var$ef[$f62453a6e3b4559e$var$gf], $f62453a6e3b4559e$var$jf = $f62453a6e3b4559e$var$hf.toLowerCase(), $f62453a6e3b4559e$var$kf = $f62453a6e3b4559e$var$hf[0].toUpperCase() + $f62453a6e3b4559e$var$hf.slice(1);
    $f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$jf, "on" + $f62453a6e3b4559e$var$kf);
}
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$$e, "onAnimationEnd");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$af, "onAnimationIteration");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$bf, "onAnimationStart");
$f62453a6e3b4559e$var$ff("dblclick", "onDoubleClick");
$f62453a6e3b4559e$var$ff("focusin", "onFocus");
$f62453a6e3b4559e$var$ff("focusout", "onBlur");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$cf, "onTransitionEnd");
$f62453a6e3b4559e$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f62453a6e3b4559e$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f62453a6e3b4559e$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f62453a6e3b4559e$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f62453a6e3b4559e$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f62453a6e3b4559e$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f62453a6e3b4559e$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f62453a6e3b4559e$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f62453a6e3b4559e$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f62453a6e3b4559e$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f62453a6e3b4559e$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f62453a6e3b4559e$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($f62453a6e3b4559e$var$lf));
function $f62453a6e3b4559e$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $f62453a6e3b4559e$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $f62453a6e3b4559e$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f62453a6e3b4559e$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f62453a6e3b4559e$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($f62453a6e3b4559e$var$Qb) throw a = $f62453a6e3b4559e$var$Rb, $f62453a6e3b4559e$var$Qb = !1, $f62453a6e3b4559e$var$Rb = null, a;
}
function $f62453a6e3b4559e$var$D(a, b) {
    var c = b[$f62453a6e3b4559e$var$of];
    void 0 === c && (c = b[$f62453a6e3b4559e$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($f62453a6e3b4559e$var$pf(b, a, 2, !1), c.add(d));
}
function $f62453a6e3b4559e$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $f62453a6e3b4559e$var$pf(c, a, d, b);
}
var $f62453a6e3b4559e$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $f62453a6e3b4559e$var$sf(a) {
    if (!a[$f62453a6e3b4559e$var$rf]) {
        a[$f62453a6e3b4559e$var$rf] = !0;
        $f62453a6e3b4559e$var$da.forEach(function(b) {
            "selectionchange" !== b && ($f62453a6e3b4559e$var$mf.has(b) || $f62453a6e3b4559e$var$qf(b, !1, a), $f62453a6e3b4559e$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$f62453a6e3b4559e$var$rf] || (b[$f62453a6e3b4559e$var$rf] = !0, $f62453a6e3b4559e$var$qf("selectionchange", !1, b));
    }
}
function $f62453a6e3b4559e$var$pf(a, b, c, d) {
    switch($f62453a6e3b4559e$var$jd(b)){
        case 1:
            var e = $f62453a6e3b4559e$var$ed;
            break;
        case 4:
            e = $f62453a6e3b4559e$var$gd;
            break;
        default:
            e = $f62453a6e3b4559e$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$f62453a6e3b4559e$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $f62453a6e3b4559e$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $f62453a6e3b4559e$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $f62453a6e3b4559e$var$Jb(function() {
        var d = f, e = $f62453a6e3b4559e$var$xb(c), g = [];
        a: {
            var h = $f62453a6e3b4559e$var$df.get(a);
            if (void 0 !== h) {
                var k = $f62453a6e3b4559e$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $f62453a6e3b4559e$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $f62453a6e3b4559e$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $f62453a6e3b4559e$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $f62453a6e3b4559e$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $f62453a6e3b4559e$var$Vd;
                        break;
                    case $f62453a6e3b4559e$var$$e:
                    case $f62453a6e3b4559e$var$af:
                    case $f62453a6e3b4559e$var$bf:
                        k = $f62453a6e3b4559e$var$Hd;
                        break;
                    case $f62453a6e3b4559e$var$cf:
                        k = $f62453a6e3b4559e$var$Xd;
                        break;
                    case "scroll":
                        k = $f62453a6e3b4559e$var$vd;
                        break;
                    case "wheel":
                        k = $f62453a6e3b4559e$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $f62453a6e3b4559e$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $f62453a6e3b4559e$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $f62453a6e3b4559e$var$Kb(w, x), null != F && t.push($f62453a6e3b4559e$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $f62453a6e3b4559e$var$wb && (n = c.relatedTarget || c.fromElement) && ($f62453a6e3b4559e$var$Wc(n) || n[$f62453a6e3b4559e$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $f62453a6e3b4559e$var$Wc(n) : null, null !== n && (J = $f62453a6e3b4559e$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $f62453a6e3b4559e$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $f62453a6e3b4559e$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $f62453a6e3b4559e$var$ue(k);
                        u = null == n ? h : $f62453a6e3b4559e$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $f62453a6e3b4559e$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $f62453a6e3b4559e$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $f62453a6e3b4559e$var$vf(F))u++;
                            for(; 0 < w - u;)t = $f62453a6e3b4559e$var$vf(t), w--;
                            for(; 0 < u - w;)x = $f62453a6e3b4559e$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $f62453a6e3b4559e$var$vf(t);
                                x = $f62453a6e3b4559e$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $f62453a6e3b4559e$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $f62453a6e3b4559e$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $f62453a6e3b4559e$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $f62453a6e3b4559e$var$ve;
                else if ($f62453a6e3b4559e$var$me(h)) {
                    if ($f62453a6e3b4559e$var$we) na = $f62453a6e3b4559e$var$Fe;
                    else {
                        na = $f62453a6e3b4559e$var$De;
                        var xa = $f62453a6e3b4559e$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $f62453a6e3b4559e$var$Ee);
                if (na && (na = na(a, d))) {
                    $f62453a6e3b4559e$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $f62453a6e3b4559e$var$cb(h, "number", h.value);
            }
            xa = d ? $f62453a6e3b4559e$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($f62453a6e3b4559e$var$me(xa) || "true" === xa.contentEditable) $f62453a6e3b4559e$var$Qe = xa, $f62453a6e3b4559e$var$Re = d, $f62453a6e3b4559e$var$Se = null;
                    break;
                case "focusout":
                    $f62453a6e3b4559e$var$Se = $f62453a6e3b4559e$var$Re = $f62453a6e3b4559e$var$Qe = null;
                    break;
                case "mousedown":
                    $f62453a6e3b4559e$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f62453a6e3b4559e$var$Te = !1;
                    $f62453a6e3b4559e$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($f62453a6e3b4559e$var$Pe) break;
                case "keydown":
                case "keyup":
                    $f62453a6e3b4559e$var$Ue(g, c, e);
            }
            var $a;
            if ($f62453a6e3b4559e$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $f62453a6e3b4559e$var$ie ? $f62453a6e3b4559e$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($f62453a6e3b4559e$var$de && "ko" !== c.locale && ($f62453a6e3b4559e$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $f62453a6e3b4559e$var$ie && ($a = $f62453a6e3b4559e$var$nd()) : ($f62453a6e3b4559e$var$kd = e, $f62453a6e3b4559e$var$ld = "value" in $f62453a6e3b4559e$var$kd ? $f62453a6e3b4559e$var$kd.value : $f62453a6e3b4559e$var$kd.textContent, $f62453a6e3b4559e$var$ie = !0)), xa = $f62453a6e3b4559e$var$oe(d, ba), 0 < xa.length && (ba = new $f62453a6e3b4559e$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $f62453a6e3b4559e$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $f62453a6e3b4559e$var$ce ? $f62453a6e3b4559e$var$je(a, c) : $f62453a6e3b4559e$var$ke(a, c)) d = $f62453a6e3b4559e$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $f62453a6e3b4559e$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $f62453a6e3b4559e$var$se(g, b);
    });
}
function $f62453a6e3b4559e$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $f62453a6e3b4559e$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $f62453a6e3b4559e$var$Kb(a, c), null != f && d.unshift($f62453a6e3b4559e$var$tf(a, f, e)), f = $f62453a6e3b4559e$var$Kb(a, b), null != f && d.push($f62453a6e3b4559e$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $f62453a6e3b4559e$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $f62453a6e3b4559e$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $f62453a6e3b4559e$var$Kb(c, f), null != k && g.unshift($f62453a6e3b4559e$var$tf(c, k, h))) : e || (k = $f62453a6e3b4559e$var$Kb(c, f), null != k && g.push($f62453a6e3b4559e$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $f62453a6e3b4559e$var$xf = /\r\n?/g, $f62453a6e3b4559e$var$yf = /\u0000|\uFFFD/g;
function $f62453a6e3b4559e$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($f62453a6e3b4559e$var$xf, "\n").replace($f62453a6e3b4559e$var$yf, "");
}
function $f62453a6e3b4559e$var$Af(a, b, c) {
    b = $f62453a6e3b4559e$var$zf(b);
    if ($f62453a6e3b4559e$var$zf(a) !== b && c) throw Error($f62453a6e3b4559e$var$p(425));
}
function $f62453a6e3b4559e$var$Bf() {}
var $f62453a6e3b4559e$var$Cf = null, $f62453a6e3b4559e$var$Df = null;
function $f62453a6e3b4559e$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $f62453a6e3b4559e$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $f62453a6e3b4559e$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $f62453a6e3b4559e$var$Hf = "function" === typeof Promise ? Promise : void 0, $f62453a6e3b4559e$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f62453a6e3b4559e$var$Hf ? function(a) {
    return $f62453a6e3b4559e$var$Hf.resolve(null).then(a).catch($f62453a6e3b4559e$var$If);
} : $f62453a6e3b4559e$var$Ff;
function $f62453a6e3b4559e$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $f62453a6e3b4559e$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $f62453a6e3b4559e$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $f62453a6e3b4559e$var$bd(b);
}
function $f62453a6e3b4559e$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $f62453a6e3b4559e$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$Nf = Math.random().toString(36).slice(2), $f62453a6e3b4559e$var$Of = "__reactFiber$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Pf = "__reactProps$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$uf = "__reactContainer$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$of = "__reactEvents$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Qf = "__reactListeners$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Rf = "__reactHandles$" + $f62453a6e3b4559e$var$Nf;
function $f62453a6e3b4559e$var$Wc(a) {
    var b = a[$f62453a6e3b4559e$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$f62453a6e3b4559e$var$uf] || c[$f62453a6e3b4559e$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $f62453a6e3b4559e$var$Mf(a); null !== a;){
                if (c = a[$f62453a6e3b4559e$var$Of]) return c;
                a = $f62453a6e3b4559e$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $f62453a6e3b4559e$var$Cb(a) {
    a = a[$f62453a6e3b4559e$var$Of] || a[$f62453a6e3b4559e$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $f62453a6e3b4559e$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($f62453a6e3b4559e$var$p(33));
}
function $f62453a6e3b4559e$var$Db(a) {
    return a[$f62453a6e3b4559e$var$Pf] || null;
}
var $f62453a6e3b4559e$var$Sf = [], $f62453a6e3b4559e$var$Tf = -1;
function $f62453a6e3b4559e$var$Uf(a) {
    return {
        current: a
    };
}
function $f62453a6e3b4559e$var$E(a) {
    0 > $f62453a6e3b4559e$var$Tf || (a.current = $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf], $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf] = null, $f62453a6e3b4559e$var$Tf--);
}
function $f62453a6e3b4559e$var$G(a, b) {
    $f62453a6e3b4559e$var$Tf++;
    $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf] = a.current;
    a.current = b;
}
var $f62453a6e3b4559e$var$Vf = {}, $f62453a6e3b4559e$var$H = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$Vf), $f62453a6e3b4559e$var$Wf = $f62453a6e3b4559e$var$Uf(!1), $f62453a6e3b4559e$var$Xf = $f62453a6e3b4559e$var$Vf;
function $f62453a6e3b4559e$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $f62453a6e3b4559e$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $f62453a6e3b4559e$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f62453a6e3b4559e$var$$f() {
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
}
function $f62453a6e3b4559e$var$ag(a, b, c) {
    if ($f62453a6e3b4559e$var$H.current !== $f62453a6e3b4559e$var$Vf) throw Error($f62453a6e3b4559e$var$p(168));
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, b);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, c);
}
function $f62453a6e3b4559e$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($f62453a6e3b4559e$var$p(108, $f62453a6e3b4559e$var$Ra(a) || "Unknown", e));
    return $f62453a6e3b4559e$var$A({}, c, d);
}
function $f62453a6e3b4559e$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $f62453a6e3b4559e$var$Vf;
    $f62453a6e3b4559e$var$Xf = $f62453a6e3b4559e$var$H.current;
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, a);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, $f62453a6e3b4559e$var$Wf.current);
    return !0;
}
function $f62453a6e3b4559e$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($f62453a6e3b4559e$var$p(169));
    c ? (a = $f62453a6e3b4559e$var$bg(a, b, $f62453a6e3b4559e$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H), $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, a)) : $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, c);
}
var $f62453a6e3b4559e$var$eg = null, $f62453a6e3b4559e$var$fg = !1, $f62453a6e3b4559e$var$gg = !1;
function $f62453a6e3b4559e$var$hg(a) {
    null === $f62453a6e3b4559e$var$eg ? $f62453a6e3b4559e$var$eg = [
        a
    ] : $f62453a6e3b4559e$var$eg.push(a);
}
function $f62453a6e3b4559e$var$ig(a) {
    $f62453a6e3b4559e$var$fg = !0;
    $f62453a6e3b4559e$var$hg(a);
}
function $f62453a6e3b4559e$var$jg() {
    if (!$f62453a6e3b4559e$var$gg && null !== $f62453a6e3b4559e$var$eg) {
        $f62453a6e3b4559e$var$gg = !0;
        var a = 0, b = $f62453a6e3b4559e$var$C;
        try {
            var c = $f62453a6e3b4559e$var$eg;
            for($f62453a6e3b4559e$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $f62453a6e3b4559e$var$eg = null;
            $f62453a6e3b4559e$var$fg = !1;
        } catch (e) {
            throw null !== $f62453a6e3b4559e$var$eg && ($f62453a6e3b4559e$var$eg = $f62453a6e3b4559e$var$eg.slice(a + 1)), $f62453a6e3b4559e$var$ac($f62453a6e3b4559e$var$fc, $f62453a6e3b4559e$var$jg), e;
        } finally{
            $f62453a6e3b4559e$var$C = b, $f62453a6e3b4559e$var$gg = !1;
        }
    }
    return null;
}
var $f62453a6e3b4559e$var$kg = [], $f62453a6e3b4559e$var$lg = 0, $f62453a6e3b4559e$var$mg = null, $f62453a6e3b4559e$var$ng = 0, $f62453a6e3b4559e$var$og = [], $f62453a6e3b4559e$var$pg = 0, $f62453a6e3b4559e$var$qg = null, $f62453a6e3b4559e$var$rg = 1, $f62453a6e3b4559e$var$sg = "";
function $f62453a6e3b4559e$var$tg(a, b) {
    $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg++] = $f62453a6e3b4559e$var$ng;
    $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg++] = $f62453a6e3b4559e$var$mg;
    $f62453a6e3b4559e$var$mg = a;
    $f62453a6e3b4559e$var$ng = b;
}
function $f62453a6e3b4559e$var$ug(a, b, c) {
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$rg;
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$sg;
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$qg;
    $f62453a6e3b4559e$var$qg = a;
    var d = $f62453a6e3b4559e$var$rg;
    a = $f62453a6e3b4559e$var$sg;
    var e = 32 - $f62453a6e3b4559e$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $f62453a6e3b4559e$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $f62453a6e3b4559e$var$rg = 1 << 32 - $f62453a6e3b4559e$var$oc(b) + e | c << e | d;
        $f62453a6e3b4559e$var$sg = f + a;
    } else $f62453a6e3b4559e$var$rg = 1 << f | c << e | d, $f62453a6e3b4559e$var$sg = a;
}
function $f62453a6e3b4559e$var$vg(a) {
    null !== a.return && ($f62453a6e3b4559e$var$tg(a, 1), $f62453a6e3b4559e$var$ug(a, 1, 0));
}
function $f62453a6e3b4559e$var$wg(a) {
    for(; a === $f62453a6e3b4559e$var$mg;)$f62453a6e3b4559e$var$mg = $f62453a6e3b4559e$var$kg[--$f62453a6e3b4559e$var$lg], $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg] = null, $f62453a6e3b4559e$var$ng = $f62453a6e3b4559e$var$kg[--$f62453a6e3b4559e$var$lg], $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg] = null;
    for(; a === $f62453a6e3b4559e$var$qg;)$f62453a6e3b4559e$var$qg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null, $f62453a6e3b4559e$var$sg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null, $f62453a6e3b4559e$var$rg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null;
}
var $f62453a6e3b4559e$var$xg = null, $f62453a6e3b4559e$var$yg = null, $f62453a6e3b4559e$var$I = !1, $f62453a6e3b4559e$var$zg = null;
function $f62453a6e3b4559e$var$Ag(a, b) {
    var c = $f62453a6e3b4559e$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $f62453a6e3b4559e$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $f62453a6e3b4559e$var$qg ? {
                id: $f62453a6e3b4559e$var$rg,
                overflow: $f62453a6e3b4559e$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $f62453a6e3b4559e$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $f62453a6e3b4559e$var$Eg(a) {
    if ($f62453a6e3b4559e$var$I) {
        var b = $f62453a6e3b4559e$var$yg;
        if (b) {
            var c = b;
            if (!$f62453a6e3b4559e$var$Cg(a, b)) {
                if ($f62453a6e3b4559e$var$Dg(a)) throw Error($f62453a6e3b4559e$var$p(418));
                b = $f62453a6e3b4559e$var$Lf(c.nextSibling);
                var d = $f62453a6e3b4559e$var$xg;
                b && $f62453a6e3b4559e$var$Cg(a, b) ? $f62453a6e3b4559e$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $f62453a6e3b4559e$var$I = !1, $f62453a6e3b4559e$var$xg = a);
            }
        } else {
            if ($f62453a6e3b4559e$var$Dg(a)) throw Error($f62453a6e3b4559e$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $f62453a6e3b4559e$var$I = !1;
            $f62453a6e3b4559e$var$xg = a;
        }
    }
}
function $f62453a6e3b4559e$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $f62453a6e3b4559e$var$xg = a;
}
function $f62453a6e3b4559e$var$Gg(a) {
    if (a !== $f62453a6e3b4559e$var$xg) return !1;
    if (!$f62453a6e3b4559e$var$I) return $f62453a6e3b4559e$var$Fg(a), $f62453a6e3b4559e$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$f62453a6e3b4559e$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $f62453a6e3b4559e$var$yg)) {
        if ($f62453a6e3b4559e$var$Dg(a)) throw $f62453a6e3b4559e$var$Hg(), Error($f62453a6e3b4559e$var$p(418));
        for(; b;)$f62453a6e3b4559e$var$Ag(a, b), b = $f62453a6e3b4559e$var$Lf(b.nextSibling);
    }
    $f62453a6e3b4559e$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($f62453a6e3b4559e$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $f62453a6e3b4559e$var$yg = null;
        }
    } else $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$xg ? $f62453a6e3b4559e$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $f62453a6e3b4559e$var$Hg() {
    for(var a = $f62453a6e3b4559e$var$yg; a;)a = $f62453a6e3b4559e$var$Lf(a.nextSibling);
}
function $f62453a6e3b4559e$var$Ig() {
    $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$xg = null;
    $f62453a6e3b4559e$var$I = !1;
}
function $f62453a6e3b4559e$var$Jg(a) {
    null === $f62453a6e3b4559e$var$zg ? $f62453a6e3b4559e$var$zg = [
        a
    ] : $f62453a6e3b4559e$var$zg.push(a);
}
var $f62453a6e3b4559e$var$Kg = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig;
function $f62453a6e3b4559e$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($f62453a6e3b4559e$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($f62453a6e3b4559e$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($f62453a6e3b4559e$var$p(284));
        if (!c._owner) throw Error($f62453a6e3b4559e$var$p(290, a));
    }
    return a;
}
function $f62453a6e3b4559e$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($f62453a6e3b4559e$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $f62453a6e3b4559e$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $f62453a6e3b4559e$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $f62453a6e3b4559e$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $f62453a6e3b4559e$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $f62453a6e3b4559e$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $f62453a6e3b4559e$var$Ha && $f62453a6e3b4559e$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $f62453a6e3b4559e$var$Lg(a, b, c), d.return = a, d;
        d = $f62453a6e3b4559e$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $f62453a6e3b4559e$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $f62453a6e3b4559e$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $f62453a6e3b4559e$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $f62453a6e3b4559e$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return c = $f62453a6e3b4559e$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $f62453a6e3b4559e$var$Lg(a, null, b), c.return = a, c;
                case $f62453a6e3b4559e$var$wa:
                    return b = $f62453a6e3b4559e$var$Sg(b, a.mode, c), b.return = a, b;
                case $f62453a6e3b4559e$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($f62453a6e3b4559e$var$eb(b) || $f62453a6e3b4559e$var$Ka(b)) return b = $f62453a6e3b4559e$var$Tg(b, a.mode, c, null), b.return = a, b;
            $f62453a6e3b4559e$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $f62453a6e3b4559e$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $f62453a6e3b4559e$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($f62453a6e3b4559e$var$eb(c) || $f62453a6e3b4559e$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $f62453a6e3b4559e$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $f62453a6e3b4559e$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $f62453a6e3b4559e$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($f62453a6e3b4559e$var$eb(d) || $f62453a6e3b4559e$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $f62453a6e3b4559e$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $f62453a6e3b4559e$var$Ka(h);
        if ("function" !== typeof l) throw Error($f62453a6e3b4559e$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($f62453a6e3b4559e$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $f62453a6e3b4559e$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $f62453a6e3b4559e$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $f62453a6e3b4559e$var$Ha && $f62453a6e3b4559e$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $f62453a6e3b4559e$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $f62453a6e3b4559e$var$ya ? (d = $f62453a6e3b4559e$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $f62453a6e3b4559e$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $f62453a6e3b4559e$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $f62453a6e3b4559e$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $f62453a6e3b4559e$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $f62453a6e3b4559e$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($f62453a6e3b4559e$var$eb(f)) return n(a, d, f, h);
            if ($f62453a6e3b4559e$var$Ka(f)) return t(a, d, f, h);
            $f62453a6e3b4559e$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $f62453a6e3b4559e$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $f62453a6e3b4559e$var$Ug = $f62453a6e3b4559e$var$Og(!0), $f62453a6e3b4559e$var$Vg = $f62453a6e3b4559e$var$Og(!1), $f62453a6e3b4559e$var$Wg = $f62453a6e3b4559e$var$Uf(null), $f62453a6e3b4559e$var$Xg = null, $f62453a6e3b4559e$var$Yg = null, $f62453a6e3b4559e$var$Zg = null;
function $f62453a6e3b4559e$var$$g() {
    $f62453a6e3b4559e$var$Zg = $f62453a6e3b4559e$var$Yg = $f62453a6e3b4559e$var$Xg = null;
}
function $f62453a6e3b4559e$var$ah(a) {
    var b = $f62453a6e3b4559e$var$Wg.current;
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wg);
    a._currentValue = b;
}
function $f62453a6e3b4559e$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $f62453a6e3b4559e$var$ch(a, b) {
    $f62453a6e3b4559e$var$Xg = a;
    $f62453a6e3b4559e$var$Zg = $f62453a6e3b4559e$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($f62453a6e3b4559e$var$dh = !0), a.firstContext = null);
}
function $f62453a6e3b4559e$var$eh(a) {
    var b = a._currentValue;
    if ($f62453a6e3b4559e$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $f62453a6e3b4559e$var$Yg) {
            if (null === $f62453a6e3b4559e$var$Xg) throw Error($f62453a6e3b4559e$var$p(308));
            $f62453a6e3b4559e$var$Yg = a;
            $f62453a6e3b4559e$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $f62453a6e3b4559e$var$Yg = $f62453a6e3b4559e$var$Yg.next = a;
    }
    return b;
}
var $f62453a6e3b4559e$var$fh = null;
function $f62453a6e3b4559e$var$gh(a) {
    null === $f62453a6e3b4559e$var$fh ? $f62453a6e3b4559e$var$fh = [
        a
    ] : $f62453a6e3b4559e$var$fh.push(a);
}
function $f62453a6e3b4559e$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $f62453a6e3b4559e$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $f62453a6e3b4559e$var$ih(a, d);
}
function $f62453a6e3b4559e$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $f62453a6e3b4559e$var$jh = !1;
function $f62453a6e3b4559e$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $f62453a6e3b4559e$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $f62453a6e3b4559e$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f62453a6e3b4559e$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($f62453a6e3b4559e$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $f62453a6e3b4559e$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $f62453a6e3b4559e$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $f62453a6e3b4559e$var$ih(a, c);
}
function $f62453a6e3b4559e$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f62453a6e3b4559e$var$Cc(a, c);
    }
}
function $f62453a6e3b4559e$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $f62453a6e3b4559e$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $f62453a6e3b4559e$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $f62453a6e3b4559e$var$A({}, q, r);
                            break a;
                        case 2:
                            $f62453a6e3b4559e$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $f62453a6e3b4559e$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $f62453a6e3b4559e$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($f62453a6e3b4559e$var$p(191, e));
            e.call(d);
        }
    }
}
var $f62453a6e3b4559e$var$th = {}, $f62453a6e3b4559e$var$uh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th), $f62453a6e3b4559e$var$vh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th), $f62453a6e3b4559e$var$wh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th);
function $f62453a6e3b4559e$var$xh(a) {
    if (a === $f62453a6e3b4559e$var$th) throw Error($f62453a6e3b4559e$var$p(174));
    return a;
}
function $f62453a6e3b4559e$var$yh(a, b) {
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$wh, b);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$vh, a);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, $f62453a6e3b4559e$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $f62453a6e3b4559e$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $f62453a6e3b4559e$var$lb(b, a);
    }
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, b);
}
function $f62453a6e3b4559e$var$zh() {
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$vh);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$wh);
}
function $f62453a6e3b4559e$var$Ah(a) {
    $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
    var b = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
    var c = $f62453a6e3b4559e$var$lb(b, a.type);
    b !== c && ($f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$vh, a), $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, c));
}
function $f62453a6e3b4559e$var$Bh(a) {
    $f62453a6e3b4559e$var$vh.current === a && ($f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$vh));
}
var $f62453a6e3b4559e$var$L = $f62453a6e3b4559e$var$Uf(0);
function $f62453a6e3b4559e$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$Dh = [];
function $f62453a6e3b4559e$var$Eh() {
    for(var a = 0; a < $f62453a6e3b4559e$var$Dh.length; a++)$f62453a6e3b4559e$var$Dh[a]._workInProgressVersionPrimary = null;
    $f62453a6e3b4559e$var$Dh.length = 0;
}
var $f62453a6e3b4559e$var$Fh = $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher, $f62453a6e3b4559e$var$Gh = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$Hh = 0, $f62453a6e3b4559e$var$M = null, $f62453a6e3b4559e$var$N = null, $f62453a6e3b4559e$var$O = null, $f62453a6e3b4559e$var$Ih = !1, $f62453a6e3b4559e$var$Jh = !1, $f62453a6e3b4559e$var$Kh = 0, $f62453a6e3b4559e$var$Lh = 0;
function $f62453a6e3b4559e$var$P() {
    throw Error($f62453a6e3b4559e$var$p(321));
}
function $f62453a6e3b4559e$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$f62453a6e3b4559e$var$He(a[c], b[c])) return !1;
    return !0;
}
function $f62453a6e3b4559e$var$Nh(a, b, c, d, e, f) {
    $f62453a6e3b4559e$var$Hh = f;
    $f62453a6e3b4559e$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $f62453a6e3b4559e$var$Fh.current = null === a || null === a.memoizedState ? $f62453a6e3b4559e$var$Oh : $f62453a6e3b4559e$var$Ph;
    a = c(d, e);
    if ($f62453a6e3b4559e$var$Jh) {
        f = 0;
        do {
            $f62453a6e3b4559e$var$Jh = !1;
            $f62453a6e3b4559e$var$Kh = 0;
            if (25 <= f) throw Error($f62453a6e3b4559e$var$p(301));
            f += 1;
            $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = null;
            b.updateQueue = null;
            $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Qh;
            a = c(d, e);
        }while ($f62453a6e3b4559e$var$Jh);
    }
    $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Rh;
    b = null !== $f62453a6e3b4559e$var$N && null !== $f62453a6e3b4559e$var$N.next;
    $f62453a6e3b4559e$var$Hh = 0;
    $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = $f62453a6e3b4559e$var$M = null;
    $f62453a6e3b4559e$var$Ih = !1;
    if (b) throw Error($f62453a6e3b4559e$var$p(300));
    return a;
}
function $f62453a6e3b4559e$var$Sh() {
    var a = 0 !== $f62453a6e3b4559e$var$Kh;
    $f62453a6e3b4559e$var$Kh = 0;
    return a;
}
function $f62453a6e3b4559e$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState = $f62453a6e3b4559e$var$O = a : $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$O.next = a;
    return $f62453a6e3b4559e$var$O;
}
function $f62453a6e3b4559e$var$Uh() {
    if (null === $f62453a6e3b4559e$var$N) {
        var a = $f62453a6e3b4559e$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $f62453a6e3b4559e$var$N.next;
    var b = null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState : $f62453a6e3b4559e$var$O.next;
    if (null !== b) $f62453a6e3b4559e$var$O = b, $f62453a6e3b4559e$var$N = a;
    else {
        if (null === a) throw Error($f62453a6e3b4559e$var$p(310));
        $f62453a6e3b4559e$var$N = a;
        a = {
            memoizedState: $f62453a6e3b4559e$var$N.memoizedState,
            baseState: $f62453a6e3b4559e$var$N.baseState,
            baseQueue: $f62453a6e3b4559e$var$N.baseQueue,
            queue: $f62453a6e3b4559e$var$N.queue,
            next: null
        };
        null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState = $f62453a6e3b4559e$var$O = a : $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$O.next = a;
    }
    return $f62453a6e3b4559e$var$O;
}
function $f62453a6e3b4559e$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $f62453a6e3b4559e$var$Wh(a) {
    var b = $f62453a6e3b4559e$var$Uh(), c = b.queue;
    if (null === c) throw Error($f62453a6e3b4559e$var$p(311));
    c.lastRenderedReducer = a;
    var d = $f62453a6e3b4559e$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($f62453a6e3b4559e$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $f62453a6e3b4559e$var$M.lanes |= m;
                $f62453a6e3b4559e$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $f62453a6e3b4559e$var$He(d, b.memoizedState) || ($f62453a6e3b4559e$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $f62453a6e3b4559e$var$M.lanes |= f, $f62453a6e3b4559e$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $f62453a6e3b4559e$var$Xh(a) {
    var b = $f62453a6e3b4559e$var$Uh(), c = b.queue;
    if (null === c) throw Error($f62453a6e3b4559e$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $f62453a6e3b4559e$var$He(f, b.memoizedState) || ($f62453a6e3b4559e$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $f62453a6e3b4559e$var$Yh() {}
function $f62453a6e3b4559e$var$Zh(a, b) {
    var c = $f62453a6e3b4559e$var$M, d = $f62453a6e3b4559e$var$Uh(), e = b(), f = !$f62453a6e3b4559e$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $f62453a6e3b4559e$var$dh = !0);
    d = d.queue;
    $f62453a6e3b4559e$var$$h($f62453a6e3b4559e$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $f62453a6e3b4559e$var$O && $f62453a6e3b4559e$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $f62453a6e3b4559e$var$bi(9, $f62453a6e3b4559e$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $f62453a6e3b4559e$var$Q) throw Error($f62453a6e3b4559e$var$p(349));
        0 !== ($f62453a6e3b4559e$var$Hh & 30) || $f62453a6e3b4559e$var$di(c, b, e);
    }
    return e;
}
function $f62453a6e3b4559e$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $f62453a6e3b4559e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f62453a6e3b4559e$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $f62453a6e3b4559e$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $f62453a6e3b4559e$var$ei(b) && $f62453a6e3b4559e$var$fi(a);
}
function $f62453a6e3b4559e$var$ai(a, b, c) {
    return c(function() {
        $f62453a6e3b4559e$var$ei(b) && $f62453a6e3b4559e$var$fi(a);
    });
}
function $f62453a6e3b4559e$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$f62453a6e3b4559e$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $f62453a6e3b4559e$var$fi(a) {
    var b = $f62453a6e3b4559e$var$ih(a, 1);
    null !== b && $f62453a6e3b4559e$var$gi(b, a, 1, -1);
}
function $f62453a6e3b4559e$var$hi(a) {
    var b = $f62453a6e3b4559e$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f62453a6e3b4559e$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $f62453a6e3b4559e$var$ii.bind(null, $f62453a6e3b4559e$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $f62453a6e3b4559e$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $f62453a6e3b4559e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f62453a6e3b4559e$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $f62453a6e3b4559e$var$ji() {
    return $f62453a6e3b4559e$var$Uh().memoizedState;
}
function $f62453a6e3b4559e$var$ki(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$Th();
    $f62453a6e3b4559e$var$M.flags |= a;
    e.memoizedState = $f62453a6e3b4559e$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $f62453a6e3b4559e$var$li(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $f62453a6e3b4559e$var$N) {
        var g = $f62453a6e3b4559e$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $f62453a6e3b4559e$var$Mh(d, g.deps)) {
            e.memoizedState = $f62453a6e3b4559e$var$bi(b, c, f, d);
            return;
        }
    }
    $f62453a6e3b4559e$var$M.flags |= a;
    e.memoizedState = $f62453a6e3b4559e$var$bi(1 | b, c, f, d);
}
function $f62453a6e3b4559e$var$mi(a, b) {
    return $f62453a6e3b4559e$var$ki(8390656, 8, a, b);
}
function $f62453a6e3b4559e$var$$h(a, b) {
    return $f62453a6e3b4559e$var$li(2048, 8, a, b);
}
function $f62453a6e3b4559e$var$ni(a, b) {
    return $f62453a6e3b4559e$var$li(4, 2, a, b);
}
function $f62453a6e3b4559e$var$oi(a, b) {
    return $f62453a6e3b4559e$var$li(4, 4, a, b);
}
function $f62453a6e3b4559e$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $f62453a6e3b4559e$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $f62453a6e3b4559e$var$li(4, 4, $f62453a6e3b4559e$var$pi.bind(null, b, a), c);
}
function $f62453a6e3b4559e$var$ri() {}
function $f62453a6e3b4559e$var$si(a, b) {
    var c = $f62453a6e3b4559e$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f62453a6e3b4559e$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f62453a6e3b4559e$var$ti(a, b) {
    var c = $f62453a6e3b4559e$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f62453a6e3b4559e$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f62453a6e3b4559e$var$ui(a, b, c) {
    if (0 === ($f62453a6e3b4559e$var$Hh & 21)) return a.baseState && (a.baseState = !1, $f62453a6e3b4559e$var$dh = !0), a.memoizedState = c;
    $f62453a6e3b4559e$var$He(c, b) || (c = $f62453a6e3b4559e$var$yc(), $f62453a6e3b4559e$var$M.lanes |= c, $f62453a6e3b4559e$var$rh |= c, a.baseState = !0);
    return b;
}
function $f62453a6e3b4559e$var$vi(a, b) {
    var c = $f62453a6e3b4559e$var$C;
    $f62453a6e3b4559e$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $f62453a6e3b4559e$var$Gh.transition;
    $f62453a6e3b4559e$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $f62453a6e3b4559e$var$C = c, $f62453a6e3b4559e$var$Gh.transition = d;
    }
}
function $f62453a6e3b4559e$var$wi() {
    return $f62453a6e3b4559e$var$Uh().memoizedState;
}
function $f62453a6e3b4559e$var$xi(a, b, c) {
    var d = $f62453a6e3b4559e$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f62453a6e3b4559e$var$zi(a)) $f62453a6e3b4559e$var$Ai(b, c);
    else if (c = $f62453a6e3b4559e$var$hh(a, b, c, d), null !== c) {
        var e = $f62453a6e3b4559e$var$R();
        $f62453a6e3b4559e$var$gi(c, a, d, e);
        $f62453a6e3b4559e$var$Bi(c, b, d);
    }
}
function $f62453a6e3b4559e$var$ii(a, b, c) {
    var d = $f62453a6e3b4559e$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f62453a6e3b4559e$var$zi(a)) $f62453a6e3b4559e$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($f62453a6e3b4559e$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $f62453a6e3b4559e$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $f62453a6e3b4559e$var$hh(a, b, e, d);
        null !== c && (e = $f62453a6e3b4559e$var$R(), $f62453a6e3b4559e$var$gi(c, a, d, e), $f62453a6e3b4559e$var$Bi(c, b, d));
    }
}
function $f62453a6e3b4559e$var$zi(a) {
    var b = a.alternate;
    return a === $f62453a6e3b4559e$var$M || null !== b && b === $f62453a6e3b4559e$var$M;
}
function $f62453a6e3b4559e$var$Ai(a, b) {
    $f62453a6e3b4559e$var$Jh = $f62453a6e3b4559e$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $f62453a6e3b4559e$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f62453a6e3b4559e$var$Cc(a, c);
    }
}
var $f62453a6e3b4559e$var$Rh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$P,
    useContext: $f62453a6e3b4559e$var$P,
    useEffect: $f62453a6e3b4559e$var$P,
    useImperativeHandle: $f62453a6e3b4559e$var$P,
    useInsertionEffect: $f62453a6e3b4559e$var$P,
    useLayoutEffect: $f62453a6e3b4559e$var$P,
    useMemo: $f62453a6e3b4559e$var$P,
    useReducer: $f62453a6e3b4559e$var$P,
    useRef: $f62453a6e3b4559e$var$P,
    useState: $f62453a6e3b4559e$var$P,
    useDebugValue: $f62453a6e3b4559e$var$P,
    useDeferredValue: $f62453a6e3b4559e$var$P,
    useTransition: $f62453a6e3b4559e$var$P,
    useMutableSource: $f62453a6e3b4559e$var$P,
    useSyncExternalStore: $f62453a6e3b4559e$var$P,
    useId: $f62453a6e3b4559e$var$P,
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Oh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: function(a, b) {
        $f62453a6e3b4559e$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $f62453a6e3b4559e$var$ki(4194308, 4, $f62453a6e3b4559e$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $f62453a6e3b4559e$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $f62453a6e3b4559e$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $f62453a6e3b4559e$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $f62453a6e3b4559e$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $f62453a6e3b4559e$var$xi.bind(null, $f62453a6e3b4559e$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $f62453a6e3b4559e$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $f62453a6e3b4559e$var$hi,
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        return $f62453a6e3b4559e$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$hi(!1), b = a[0];
        a = $f62453a6e3b4559e$var$vi.bind(null, a[1]);
        $f62453a6e3b4559e$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $f62453a6e3b4559e$var$M, e = $f62453a6e3b4559e$var$Th();
        if ($f62453a6e3b4559e$var$I) {
            if (void 0 === c) throw Error($f62453a6e3b4559e$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $f62453a6e3b4559e$var$Q) throw Error($f62453a6e3b4559e$var$p(349));
            0 !== ($f62453a6e3b4559e$var$Hh & 30) || $f62453a6e3b4559e$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $f62453a6e3b4559e$var$mi($f62453a6e3b4559e$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $f62453a6e3b4559e$var$bi(9, $f62453a6e3b4559e$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $f62453a6e3b4559e$var$Th(), b = $f62453a6e3b4559e$var$Q.identifierPrefix;
        if ($f62453a6e3b4559e$var$I) {
            var c = $f62453a6e3b4559e$var$sg;
            var d = $f62453a6e3b4559e$var$rg;
            c = (d & ~(1 << 32 - $f62453a6e3b4559e$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $f62453a6e3b4559e$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $f62453a6e3b4559e$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Ph = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$si,
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$$h,
    useImperativeHandle: $f62453a6e3b4559e$var$qi,
    useInsertionEffect: $f62453a6e3b4559e$var$ni,
    useLayoutEffect: $f62453a6e3b4559e$var$oi,
    useMemo: $f62453a6e3b4559e$var$ti,
    useReducer: $f62453a6e3b4559e$var$Wh,
    useRef: $f62453a6e3b4559e$var$ji,
    useState: function() {
        return $f62453a6e3b4559e$var$Wh($f62453a6e3b4559e$var$Vh);
    },
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        var b = $f62453a6e3b4559e$var$Uh();
        return $f62453a6e3b4559e$var$ui(b, $f62453a6e3b4559e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$Wh($f62453a6e3b4559e$var$Vh)[0], b = $f62453a6e3b4559e$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f62453a6e3b4559e$var$Yh,
    useSyncExternalStore: $f62453a6e3b4559e$var$Zh,
    useId: $f62453a6e3b4559e$var$wi,
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Qh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$si,
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$$h,
    useImperativeHandle: $f62453a6e3b4559e$var$qi,
    useInsertionEffect: $f62453a6e3b4559e$var$ni,
    useLayoutEffect: $f62453a6e3b4559e$var$oi,
    useMemo: $f62453a6e3b4559e$var$ti,
    useReducer: $f62453a6e3b4559e$var$Xh,
    useRef: $f62453a6e3b4559e$var$ji,
    useState: function() {
        return $f62453a6e3b4559e$var$Xh($f62453a6e3b4559e$var$Vh);
    },
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        var b = $f62453a6e3b4559e$var$Uh();
        return null === $f62453a6e3b4559e$var$N ? b.memoizedState = a : $f62453a6e3b4559e$var$ui(b, $f62453a6e3b4559e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$Xh($f62453a6e3b4559e$var$Vh)[0], b = $f62453a6e3b4559e$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f62453a6e3b4559e$var$Yh,
    useSyncExternalStore: $f62453a6e3b4559e$var$Zh,
    useId: $f62453a6e3b4559e$var$wi,
    unstable_isNewReconciler: !1
};
function $f62453a6e3b4559e$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $f62453a6e3b4559e$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $f62453a6e3b4559e$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $f62453a6e3b4559e$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $f62453a6e3b4559e$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $f62453a6e3b4559e$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f62453a6e3b4559e$var$R(), e = $f62453a6e3b4559e$var$yi(a), f = $f62453a6e3b4559e$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f62453a6e3b4559e$var$nh(a, f, e);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, e, d), $f62453a6e3b4559e$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f62453a6e3b4559e$var$R(), e = $f62453a6e3b4559e$var$yi(a), f = $f62453a6e3b4559e$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f62453a6e3b4559e$var$nh(a, f, e);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, e, d), $f62453a6e3b4559e$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $f62453a6e3b4559e$var$R(), d = $f62453a6e3b4559e$var$yi(a), e = $f62453a6e3b4559e$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $f62453a6e3b4559e$var$nh(a, e, d);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, d, c), $f62453a6e3b4559e$var$oh(b, a, d));
    }
};
function $f62453a6e3b4559e$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$f62453a6e3b4559e$var$Ie(c, d) || !$f62453a6e3b4559e$var$Ie(e, f) : !0;
}
function $f62453a6e3b4559e$var$Gi(a, b, c) {
    var d = !1, e = $f62453a6e3b4559e$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $f62453a6e3b4559e$var$eh(f) : (e = $f62453a6e3b4559e$var$Zf(b) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $f62453a6e3b4559e$var$Yf(a, e) : $f62453a6e3b4559e$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $f62453a6e3b4559e$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $f62453a6e3b4559e$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $f62453a6e3b4559e$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $f62453a6e3b4559e$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $f62453a6e3b4559e$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $f62453a6e3b4559e$var$eh(f) : (f = $f62453a6e3b4559e$var$Zf(b) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, e.context = $f62453a6e3b4559e$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($f62453a6e3b4559e$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $f62453a6e3b4559e$var$Ei.enqueueReplaceState(e, e.state, null), $f62453a6e3b4559e$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $f62453a6e3b4559e$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $f62453a6e3b4559e$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $f62453a6e3b4559e$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $f62453a6e3b4559e$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $f62453a6e3b4559e$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $f62453a6e3b4559e$var$Ni(a, b, c) {
    c = $f62453a6e3b4559e$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $f62453a6e3b4559e$var$Oi || ($f62453a6e3b4559e$var$Oi = !0, $f62453a6e3b4559e$var$Pi = d);
        $f62453a6e3b4559e$var$Li(a, b);
    };
    return c;
}
function $f62453a6e3b4559e$var$Qi(a, b, c) {
    c = $f62453a6e3b4559e$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $f62453a6e3b4559e$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $f62453a6e3b4559e$var$Li(a, b);
        "function" !== typeof d && (null === $f62453a6e3b4559e$var$Ri ? $f62453a6e3b4559e$var$Ri = new Set([
            this
        ]) : $f62453a6e3b4559e$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $f62453a6e3b4559e$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $f62453a6e3b4559e$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $f62453a6e3b4559e$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $f62453a6e3b4559e$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $f62453a6e3b4559e$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $f62453a6e3b4559e$var$mh(-1, 1), b.tag = 2, $f62453a6e3b4559e$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $f62453a6e3b4559e$var$Wi = $f62453a6e3b4559e$var$ua.ReactCurrentOwner, $f62453a6e3b4559e$var$dh = !1;
function $f62453a6e3b4559e$var$Xi(a, b, c, d) {
    b.child = null === a ? $f62453a6e3b4559e$var$Vg(b, null, c, d) : $f62453a6e3b4559e$var$Ug(b, a.child, c, d);
}
function $f62453a6e3b4559e$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $f62453a6e3b4559e$var$ch(b, e);
    d = $f62453a6e3b4559e$var$Nh(a, b, c, d, f, e);
    c = $f62453a6e3b4559e$var$Sh();
    if (null !== a && !$f62453a6e3b4559e$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f62453a6e3b4559e$var$Zi(a, b, e);
    $f62453a6e3b4559e$var$I && c && $f62453a6e3b4559e$var$vg(b);
    b.flags |= 1;
    $f62453a6e3b4559e$var$Xi(a, b, d, e);
    return b.child;
}
function $f62453a6e3b4559e$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$f62453a6e3b4559e$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $f62453a6e3b4559e$var$bj(a, b, f, d, e);
        a = $f62453a6e3b4559e$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $f62453a6e3b4559e$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $f62453a6e3b4559e$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $f62453a6e3b4559e$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $f62453a6e3b4559e$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($f62453a6e3b4559e$var$Ie(f, d) && a.ref === b.ref) {
            if ($f62453a6e3b4559e$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($f62453a6e3b4559e$var$dh = !0);
            else return b.lanes = a.lanes, $f62453a6e3b4559e$var$Zi(a, b, e);
        }
    }
    return $f62453a6e3b4559e$var$cj(a, b, c, d, e);
}
function $f62453a6e3b4559e$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj);
            $f62453a6e3b4559e$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= d;
    $f62453a6e3b4559e$var$Xi(a, b, e, c);
    return b.child;
}
function $f62453a6e3b4559e$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $f62453a6e3b4559e$var$cj(a, b, c, d, e) {
    var f = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current;
    f = $f62453a6e3b4559e$var$Yf(b, f);
    $f62453a6e3b4559e$var$ch(b, e);
    c = $f62453a6e3b4559e$var$Nh(a, b, c, d, f, e);
    d = $f62453a6e3b4559e$var$Sh();
    if (null !== a && !$f62453a6e3b4559e$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f62453a6e3b4559e$var$Zi(a, b, e);
    $f62453a6e3b4559e$var$I && d && $f62453a6e3b4559e$var$vg(b);
    b.flags |= 1;
    $f62453a6e3b4559e$var$Xi(a, b, c, e);
    return b.child;
}
function $f62453a6e3b4559e$var$hj(a, b, c, d, e) {
    if ($f62453a6e3b4559e$var$Zf(c)) {
        var f = !0;
        $f62453a6e3b4559e$var$cg(b);
    } else f = !1;
    $f62453a6e3b4559e$var$ch(b, e);
    if (null === b.stateNode) $f62453a6e3b4559e$var$ij(a, b), $f62453a6e3b4559e$var$Gi(b, c, d), $f62453a6e3b4559e$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $f62453a6e3b4559e$var$eh(l) : (l = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, l = $f62453a6e3b4559e$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $f62453a6e3b4559e$var$Hi(b, g, d, l);
        $f62453a6e3b4559e$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $f62453a6e3b4559e$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $f62453a6e3b4559e$var$Wf.current || $f62453a6e3b4559e$var$jh ? ("function" === typeof m && ($f62453a6e3b4559e$var$Di(b, c, m, d), k = b.memoizedState), (h = $f62453a6e3b4559e$var$jh || $f62453a6e3b4559e$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $f62453a6e3b4559e$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $f62453a6e3b4559e$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $f62453a6e3b4559e$var$eh(k) : (k = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, k = $f62453a6e3b4559e$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $f62453a6e3b4559e$var$Hi(b, g, d, k);
        $f62453a6e3b4559e$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $f62453a6e3b4559e$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $f62453a6e3b4559e$var$Wf.current || $f62453a6e3b4559e$var$jh ? ("function" === typeof y && ($f62453a6e3b4559e$var$Di(b, c, y, d), n = b.memoizedState), (l = $f62453a6e3b4559e$var$jh || $f62453a6e3b4559e$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $f62453a6e3b4559e$var$jj(a, b, c, d, f, e);
}
function $f62453a6e3b4559e$var$jj(a, b, c, d, e, f) {
    $f62453a6e3b4559e$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $f62453a6e3b4559e$var$dg(b, c, !1), $f62453a6e3b4559e$var$Zi(a, b, f);
    d = b.stateNode;
    $f62453a6e3b4559e$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $f62453a6e3b4559e$var$Ug(b, a.child, null, f), b.child = $f62453a6e3b4559e$var$Ug(b, null, h, f)) : $f62453a6e3b4559e$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $f62453a6e3b4559e$var$dg(b, c, !0);
    return b.child;
}
function $f62453a6e3b4559e$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $f62453a6e3b4559e$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $f62453a6e3b4559e$var$ag(a, b.context, !1);
    $f62453a6e3b4559e$var$yh(a, b.containerInfo);
}
function $f62453a6e3b4559e$var$lj(a, b, c, d, e) {
    $f62453a6e3b4559e$var$Ig();
    $f62453a6e3b4559e$var$Jg(e);
    b.flags |= 256;
    $f62453a6e3b4559e$var$Xi(a, b, c, d);
    return b.child;
}
var $f62453a6e3b4559e$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $f62453a6e3b4559e$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $f62453a6e3b4559e$var$oj(a, b, c) {
    var d = b.pendingProps, e = $f62453a6e3b4559e$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, e & 1);
    if (null === a) {
        $f62453a6e3b4559e$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $f62453a6e3b4559e$var$pj(g, d, 0, null), a = $f62453a6e3b4559e$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $f62453a6e3b4559e$var$nj(c), b.memoizedState = $f62453a6e3b4559e$var$mj, a) : $f62453a6e3b4559e$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $f62453a6e3b4559e$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $f62453a6e3b4559e$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $f62453a6e3b4559e$var$Pg(h, f) : (f = $f62453a6e3b4559e$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $f62453a6e3b4559e$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $f62453a6e3b4559e$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $f62453a6e3b4559e$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $f62453a6e3b4559e$var$qj(a, b) {
    b = $f62453a6e3b4559e$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $f62453a6e3b4559e$var$sj(a, b, c, d) {
    null !== d && $f62453a6e3b4559e$var$Jg(d);
    $f62453a6e3b4559e$var$Ug(b, a.child, null, c);
    a = $f62453a6e3b4559e$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $f62453a6e3b4559e$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $f62453a6e3b4559e$var$Ki(Error($f62453a6e3b4559e$var$p(422))), $f62453a6e3b4559e$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $f62453a6e3b4559e$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $f62453a6e3b4559e$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $f62453a6e3b4559e$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $f62453a6e3b4559e$var$nj(g);
        b.memoizedState = $f62453a6e3b4559e$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $f62453a6e3b4559e$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($f62453a6e3b4559e$var$p(419));
        d = $f62453a6e3b4559e$var$Ki(f, d, void 0);
        return $f62453a6e3b4559e$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($f62453a6e3b4559e$var$dh || h) {
        d = $f62453a6e3b4559e$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $f62453a6e3b4559e$var$ih(a, e), $f62453a6e3b4559e$var$gi(d, a, e, -1));
        }
        $f62453a6e3b4559e$var$tj();
        d = $f62453a6e3b4559e$var$Ki(Error($f62453a6e3b4559e$var$p(421)));
        return $f62453a6e3b4559e$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $f62453a6e3b4559e$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(e.nextSibling);
    $f62453a6e3b4559e$var$xg = b;
    $f62453a6e3b4559e$var$I = !0;
    $f62453a6e3b4559e$var$zg = null;
    null !== a && ($f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$rg, $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$sg, $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$qg, $f62453a6e3b4559e$var$rg = a.id, $f62453a6e3b4559e$var$sg = a.overflow, $f62453a6e3b4559e$var$qg = b);
    b = $f62453a6e3b4559e$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $f62453a6e3b4559e$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $f62453a6e3b4559e$var$bh(a.return, b, c);
}
function $f62453a6e3b4559e$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $f62453a6e3b4559e$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $f62453a6e3b4559e$var$Xi(a, b, d.children, c);
    d = $f62453a6e3b4559e$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $f62453a6e3b4559e$var$vj(a, c, b);
            else if (19 === a.tag) $f62453a6e3b4559e$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $f62453a6e3b4559e$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $f62453a6e3b4559e$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $f62453a6e3b4559e$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $f62453a6e3b4559e$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $f62453a6e3b4559e$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $f62453a6e3b4559e$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $f62453a6e3b4559e$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $f62453a6e3b4559e$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($f62453a6e3b4559e$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $f62453a6e3b4559e$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $f62453a6e3b4559e$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $f62453a6e3b4559e$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $f62453a6e3b4559e$var$kj(b);
            $f62453a6e3b4559e$var$Ig();
            break;
        case 5:
            $f62453a6e3b4559e$var$Ah(b);
            break;
        case 1:
            $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$cg(b);
            break;
        case 4:
            $f62453a6e3b4559e$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $f62453a6e3b4559e$var$oj(a, b, c);
                $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1);
                a = $f62453a6e3b4559e$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $f62453a6e3b4559e$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $f62453a6e3b4559e$var$dj(a, b, c);
    }
    return $f62453a6e3b4559e$var$Zi(a, b, c);
}
var $f62453a6e3b4559e$var$zj, $f62453a6e3b4559e$var$Aj, $f62453a6e3b4559e$var$Bj, $f62453a6e3b4559e$var$Cj;
$f62453a6e3b4559e$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$f62453a6e3b4559e$var$Aj = function() {};
$f62453a6e3b4559e$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $f62453a6e3b4559e$var$Ya(a, e);
                d = $f62453a6e3b4559e$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $f62453a6e3b4559e$var$A({}, e, {
                    value: void 0
                });
                d = $f62453a6e3b4559e$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $f62453a6e3b4559e$var$gb(a, e);
                d = $f62453a6e3b4559e$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $f62453a6e3b4559e$var$Bf);
        }
        $f62453a6e3b4559e$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($f62453a6e3b4559e$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($f62453a6e3b4559e$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $f62453a6e3b4559e$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$f62453a6e3b4559e$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $f62453a6e3b4559e$var$Dj(a, b) {
    if (!$f62453a6e3b4559e$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $f62453a6e3b4559e$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $f62453a6e3b4559e$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $f62453a6e3b4559e$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f62453a6e3b4559e$var$S(b), null;
        case 1:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), $f62453a6e3b4559e$var$S(b), null;
        case 3:
            d = b.stateNode;
            $f62453a6e3b4559e$var$zh();
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
            $f62453a6e3b4559e$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $f62453a6e3b4559e$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $f62453a6e3b4559e$var$zg && ($f62453a6e3b4559e$var$Fj($f62453a6e3b4559e$var$zg), $f62453a6e3b4559e$var$zg = null));
            $f62453a6e3b4559e$var$Aj(a, b);
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 5:
            $f62453a6e3b4559e$var$Bh(b);
            var e = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $f62453a6e3b4559e$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($f62453a6e3b4559e$var$p(166));
                    $f62453a6e3b4559e$var$S(b);
                    return null;
                }
                a = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
                if ($f62453a6e3b4559e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$f62453a6e3b4559e$var$Of] = b;
                    d[$f62453a6e3b4559e$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $f62453a6e3b4559e$var$D("cancel", d);
                            $f62453a6e3b4559e$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $f62453a6e3b4559e$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $f62453a6e3b4559e$var$lf.length; e++)$f62453a6e3b4559e$var$D($f62453a6e3b4559e$var$lf[e], d);
                            break;
                        case "source":
                            $f62453a6e3b4559e$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $f62453a6e3b4559e$var$D("error", d);
                            $f62453a6e3b4559e$var$D("load", d);
                            break;
                        case "details":
                            $f62453a6e3b4559e$var$D("toggle", d);
                            break;
                        case "input":
                            $f62453a6e3b4559e$var$Za(d, f);
                            $f62453a6e3b4559e$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $f62453a6e3b4559e$var$D("invalid", d);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$hb(d, f), $f62453a6e3b4559e$var$D("invalid", d);
                    }
                    $f62453a6e3b4559e$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $f62453a6e3b4559e$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $f62453a6e3b4559e$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $f62453a6e3b4559e$var$Va(d);
                            $f62453a6e3b4559e$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$Va(d);
                            $f62453a6e3b4559e$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $f62453a6e3b4559e$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $f62453a6e3b4559e$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$f62453a6e3b4559e$var$Of] = b;
                    a[$f62453a6e3b4559e$var$Pf] = d;
                    $f62453a6e3b4559e$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $f62453a6e3b4559e$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $f62453a6e3b4559e$var$D("cancel", a);
                                $f62453a6e3b4559e$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $f62453a6e3b4559e$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $f62453a6e3b4559e$var$lf.length; e++)$f62453a6e3b4559e$var$D($f62453a6e3b4559e$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $f62453a6e3b4559e$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $f62453a6e3b4559e$var$D("error", a);
                                $f62453a6e3b4559e$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $f62453a6e3b4559e$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $f62453a6e3b4559e$var$Za(a, d);
                                e = $f62453a6e3b4559e$var$Ya(a, d);
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $f62453a6e3b4559e$var$A({}, d, {
                                    value: void 0
                                });
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            case "textarea":
                                $f62453a6e3b4559e$var$hb(a, d);
                                e = $f62453a6e3b4559e$var$gb(a, d);
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $f62453a6e3b4559e$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $f62453a6e3b4559e$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $f62453a6e3b4559e$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $f62453a6e3b4559e$var$ob(a, k) : "number" === typeof k && $f62453a6e3b4559e$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($f62453a6e3b4559e$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $f62453a6e3b4559e$var$D("scroll", a) : null != k && $f62453a6e3b4559e$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $f62453a6e3b4559e$var$Va(a);
                                $f62453a6e3b4559e$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $f62453a6e3b4559e$var$Va(a);
                                $f62453a6e3b4559e$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $f62453a6e3b4559e$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $f62453a6e3b4559e$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $f62453a6e3b4559e$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $f62453a6e3b4559e$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $f62453a6e3b4559e$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($f62453a6e3b4559e$var$p(166));
                c = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
                $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
                if ($f62453a6e3b4559e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$f62453a6e3b4559e$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $f62453a6e3b4559e$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $f62453a6e3b4559e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$f62453a6e3b4559e$var$Of] = b, b.stateNode = d;
            }
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 13:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($f62453a6e3b4559e$var$I && null !== $f62453a6e3b4559e$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $f62453a6e3b4559e$var$Hg(), $f62453a6e3b4559e$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $f62453a6e3b4559e$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($f62453a6e3b4559e$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($f62453a6e3b4559e$var$p(317));
                        f[$f62453a6e3b4559e$var$Of] = b;
                    } else $f62453a6e3b4559e$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $f62453a6e3b4559e$var$S(b);
                    f = !1;
                } else null !== $f62453a6e3b4559e$var$zg && ($f62453a6e3b4559e$var$Fj($f62453a6e3b4559e$var$zg), $f62453a6e3b4559e$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($f62453a6e3b4559e$var$L.current & 1) ? 0 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 3) : $f62453a6e3b4559e$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 4:
            return $f62453a6e3b4559e$var$zh(), $f62453a6e3b4559e$var$Aj(a, b), null === a && $f62453a6e3b4559e$var$sf(b.stateNode.containerInfo), $f62453a6e3b4559e$var$S(b), null;
        case 10:
            return $f62453a6e3b4559e$var$ah(b.type._context), $f62453a6e3b4559e$var$S(b), null;
        case 17:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), $f62453a6e3b4559e$var$S(b), null;
        case 19:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            f = b.memoizedState;
            if (null === f) return $f62453a6e3b4559e$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $f62453a6e3b4559e$var$Dj(f, !1);
                else {
                    if (0 !== $f62453a6e3b4559e$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $f62453a6e3b4559e$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $f62453a6e3b4559e$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $f62453a6e3b4559e$var$B() > $f62453a6e3b4559e$var$Gj && (b.flags |= 128, d = !0, $f62453a6e3b4559e$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $f62453a6e3b4559e$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $f62453a6e3b4559e$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$f62453a6e3b4559e$var$I) return $f62453a6e3b4559e$var$S(b), null;
                    } else 2 * $f62453a6e3b4559e$var$B() - f.renderingStartTime > $f62453a6e3b4559e$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $f62453a6e3b4559e$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $f62453a6e3b4559e$var$B(), b.sibling = null, c = $f62453a6e3b4559e$var$L.current, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, d ? c & 1 | 2 : c & 1), b;
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 22:
        case 23:
            return $f62453a6e3b4559e$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($f62453a6e3b4559e$var$fj & 1073741824) && ($f62453a6e3b4559e$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $f62453a6e3b4559e$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($f62453a6e3b4559e$var$p(156, b.tag));
}
function $f62453a6e3b4559e$var$Ij(a, b) {
    $f62453a6e3b4559e$var$wg(b);
    switch(b.tag){
        case 1:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $f62453a6e3b4559e$var$zh(), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H), $f62453a6e3b4559e$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $f62453a6e3b4559e$var$Bh(b), null;
        case 13:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($f62453a6e3b4559e$var$p(340));
                $f62453a6e3b4559e$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L), null;
        case 4:
            return $f62453a6e3b4559e$var$zh(), null;
        case 10:
            return $f62453a6e3b4559e$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $f62453a6e3b4559e$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $f62453a6e3b4559e$var$Jj = !1, $f62453a6e3b4559e$var$U = !1, $f62453a6e3b4559e$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $f62453a6e3b4559e$var$V = null;
function $f62453a6e3b4559e$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $f62453a6e3b4559e$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $f62453a6e3b4559e$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $f62453a6e3b4559e$var$W(a, b, d);
    }
}
var $f62453a6e3b4559e$var$Nj = !1;
function $f62453a6e3b4559e$var$Oj(a, b) {
    $f62453a6e3b4559e$var$Cf = $f62453a6e3b4559e$var$dd;
    a = $f62453a6e3b4559e$var$Me();
    if ($f62453a6e3b4559e$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $f62453a6e3b4559e$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $f62453a6e3b4559e$var$dd = !1;
    for($f62453a6e3b4559e$var$V = b; null !== $f62453a6e3b4559e$var$V;)if (b = $f62453a6e3b4559e$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $f62453a6e3b4559e$var$V = a;
    else for(; null !== $f62453a6e3b4559e$var$V;){
        b = $f62453a6e3b4559e$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $f62453a6e3b4559e$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(163));
            }
        } catch (F) {
            $f62453a6e3b4559e$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $f62453a6e3b4559e$var$V = a;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
    n = $f62453a6e3b4559e$var$Nj;
    $f62453a6e3b4559e$var$Nj = !1;
    return n;
}
function $f62453a6e3b4559e$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $f62453a6e3b4559e$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $f62453a6e3b4559e$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $f62453a6e3b4559e$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $f62453a6e3b4559e$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $f62453a6e3b4559e$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$f62453a6e3b4559e$var$Of], delete b[$f62453a6e3b4559e$var$Pf], delete b[$f62453a6e3b4559e$var$of], delete b[$f62453a6e3b4559e$var$Qf], delete b[$f62453a6e3b4559e$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $f62453a6e3b4559e$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $f62453a6e3b4559e$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $f62453a6e3b4559e$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $f62453a6e3b4559e$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $f62453a6e3b4559e$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($f62453a6e3b4559e$var$Vj(a, b, c), a = a.sibling; null !== a;)$f62453a6e3b4559e$var$Vj(a, b, c), a = a.sibling;
}
function $f62453a6e3b4559e$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($f62453a6e3b4559e$var$Wj(a, b, c), a = a.sibling; null !== a;)$f62453a6e3b4559e$var$Wj(a, b, c), a = a.sibling;
}
var $f62453a6e3b4559e$var$X = null, $f62453a6e3b4559e$var$Xj = !1;
function $f62453a6e3b4559e$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$f62453a6e3b4559e$var$Zj(a, b, c), c = c.sibling;
}
function $f62453a6e3b4559e$var$Zj(a, b, c) {
    if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onCommitFiberUnmount) try {
        $f62453a6e3b4559e$var$lc.onCommitFiberUnmount($f62453a6e3b4559e$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $f62453a6e3b4559e$var$U || $f62453a6e3b4559e$var$Lj(c, b);
        case 6:
            var d = $f62453a6e3b4559e$var$X, e = $f62453a6e3b4559e$var$Xj;
            $f62453a6e3b4559e$var$X = null;
            $f62453a6e3b4559e$var$Yj(a, b, c);
            $f62453a6e3b4559e$var$X = d;
            $f62453a6e3b4559e$var$Xj = e;
            null !== $f62453a6e3b4559e$var$X && ($f62453a6e3b4559e$var$Xj ? (a = $f62453a6e3b4559e$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $f62453a6e3b4559e$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $f62453a6e3b4559e$var$X && ($f62453a6e3b4559e$var$Xj ? (a = $f62453a6e3b4559e$var$X, c = c.stateNode, 8 === a.nodeType ? $f62453a6e3b4559e$var$Kf(a.parentNode, c) : 1 === a.nodeType && $f62453a6e3b4559e$var$Kf(a, c), $f62453a6e3b4559e$var$bd(a)) : $f62453a6e3b4559e$var$Kf($f62453a6e3b4559e$var$X, c.stateNode));
            break;
        case 4:
            d = $f62453a6e3b4559e$var$X;
            e = $f62453a6e3b4559e$var$Xj;
            $f62453a6e3b4559e$var$X = c.stateNode.containerInfo;
            $f62453a6e3b4559e$var$Xj = !0;
            $f62453a6e3b4559e$var$Yj(a, b, c);
            $f62453a6e3b4559e$var$X = d;
            $f62453a6e3b4559e$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$f62453a6e3b4559e$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $f62453a6e3b4559e$var$Mj(c, b, g) : 0 !== (f & 4) && $f62453a6e3b4559e$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 1:
            if (!$f62453a6e3b4559e$var$U && ($f62453a6e3b4559e$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $f62453a6e3b4559e$var$W(c, b, h);
            }
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 21:
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($f62453a6e3b4559e$var$U = (d = $f62453a6e3b4559e$var$U) || null !== c.memoizedState, $f62453a6e3b4559e$var$Yj(a, b, c), $f62453a6e3b4559e$var$U = d) : $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        default:
            $f62453a6e3b4559e$var$Yj(a, b, c);
    }
}
function $f62453a6e3b4559e$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $f62453a6e3b4559e$var$Kj);
        b.forEach(function(b) {
            var d = $f62453a6e3b4559e$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $f62453a6e3b4559e$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $f62453a6e3b4559e$var$X = h.stateNode;
                        $f62453a6e3b4559e$var$Xj = !1;
                        break a;
                    case 3:
                        $f62453a6e3b4559e$var$X = h.stateNode.containerInfo;
                        $f62453a6e3b4559e$var$Xj = !0;
                        break a;
                    case 4:
                        $f62453a6e3b4559e$var$X = h.stateNode.containerInfo;
                        $f62453a6e3b4559e$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $f62453a6e3b4559e$var$X) throw Error($f62453a6e3b4559e$var$p(160));
            $f62453a6e3b4559e$var$Zj(f, g, e);
            $f62453a6e3b4559e$var$X = null;
            $f62453a6e3b4559e$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $f62453a6e3b4559e$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$f62453a6e3b4559e$var$dk(b, a), b = b.sibling;
}
function $f62453a6e3b4559e$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4) {
                try {
                    $f62453a6e3b4559e$var$Pj(3, a, a.return), $f62453a6e3b4559e$var$Qj(3, a);
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
                try {
                    $f62453a6e3b4559e$var$Pj(5, a, a.return);
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 512 && null !== c && $f62453a6e3b4559e$var$Lj(c, c.return);
            break;
        case 5:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 512 && null !== c && $f62453a6e3b4559e$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $f62453a6e3b4559e$var$ob(e, "");
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $f62453a6e3b4559e$var$ab(e, f);
                    $f62453a6e3b4559e$var$vb(h, g);
                    var l = $f62453a6e3b4559e$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $f62453a6e3b4559e$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $f62453a6e3b4559e$var$nb(e, q) : "children" === m ? $f62453a6e3b4559e$var$ob(e, q) : $f62453a6e3b4559e$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $f62453a6e3b4559e$var$bb(e, f);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $f62453a6e3b4559e$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $f62453a6e3b4559e$var$fb(e, !!f.multiple, f.defaultValue, !0) : $f62453a6e3b4559e$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$f62453a6e3b4559e$var$Pf] = f;
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($f62453a6e3b4559e$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $f62453a6e3b4559e$var$bd(b.containerInfo);
            } catch (t) {
                $f62453a6e3b4559e$var$W(a, a.return, t);
            }
            break;
        case 4:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            break;
        case 13:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($f62453a6e3b4559e$var$fk = $f62453a6e3b4559e$var$B()));
            d & 4 && $f62453a6e3b4559e$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($f62453a6e3b4559e$var$U = (l = $f62453a6e3b4559e$var$U) || m, $f62453a6e3b4559e$var$ck(b, a), $f62453a6e3b4559e$var$U = l) : $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($f62453a6e3b4559e$var$V = a, m = a.child; null !== m;){
                    for(q = $f62453a6e3b4559e$var$V = m; null !== $f62453a6e3b4559e$var$V;){
                        r = $f62453a6e3b4559e$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $f62453a6e3b4559e$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $f62453a6e3b4559e$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $f62453a6e3b4559e$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $f62453a6e3b4559e$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $f62453a6e3b4559e$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $f62453a6e3b4559e$var$V = y) : $f62453a6e3b4559e$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $f62453a6e3b4559e$var$rb("display", g));
                            } catch (t) {
                                $f62453a6e3b4559e$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $f62453a6e3b4559e$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 4 && $f62453a6e3b4559e$var$ak(a);
            break;
        case 21:
            break;
        default:
            $f62453a6e3b4559e$var$ck(b, a), $f62453a6e3b4559e$var$ek(a);
    }
}
function $f62453a6e3b4559e$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($f62453a6e3b4559e$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($f62453a6e3b4559e$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($f62453a6e3b4559e$var$ob(e, ""), d.flags &= -33);
                    var f = $f62453a6e3b4559e$var$Uj(a);
                    $f62453a6e3b4559e$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $f62453a6e3b4559e$var$Uj(a);
                    $f62453a6e3b4559e$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(161));
            }
        } catch (k) {
            $f62453a6e3b4559e$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $f62453a6e3b4559e$var$hk(a, b, c) {
    $f62453a6e3b4559e$var$V = a;
    $f62453a6e3b4559e$var$ik(a, b, c);
}
function $f62453a6e3b4559e$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $f62453a6e3b4559e$var$V;){
        var e = $f62453a6e3b4559e$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $f62453a6e3b4559e$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $f62453a6e3b4559e$var$U;
                h = $f62453a6e3b4559e$var$Jj;
                var l = $f62453a6e3b4559e$var$U;
                $f62453a6e3b4559e$var$Jj = g;
                if (($f62453a6e3b4559e$var$U = k) && !l) for($f62453a6e3b4559e$var$V = e; null !== $f62453a6e3b4559e$var$V;)g = $f62453a6e3b4559e$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $f62453a6e3b4559e$var$jk(e) : null !== k ? (k.return = g, $f62453a6e3b4559e$var$V = k) : $f62453a6e3b4559e$var$jk(e);
                for(; null !== f;)$f62453a6e3b4559e$var$V = f, $f62453a6e3b4559e$var$ik(f, b, c), f = f.sibling;
                $f62453a6e3b4559e$var$V = e;
                $f62453a6e3b4559e$var$Jj = h;
                $f62453a6e3b4559e$var$U = l;
            }
            $f62453a6e3b4559e$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $f62453a6e3b4559e$var$V = f) : $f62453a6e3b4559e$var$kk(a, b, c);
    }
}
function $f62453a6e3b4559e$var$kk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $f62453a6e3b4559e$var$U || $f62453a6e3b4559e$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$f62453a6e3b4559e$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $f62453a6e3b4559e$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $f62453a6e3b4559e$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $f62453a6e3b4559e$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $f62453a6e3b4559e$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($f62453a6e3b4559e$var$p(163));
                }
                $f62453a6e3b4559e$var$U || b.flags & 512 && $f62453a6e3b4559e$var$Rj(b);
            } catch (r) {
                $f62453a6e3b4559e$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f62453a6e3b4559e$var$V = c;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
function $f62453a6e3b4559e$var$gk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f62453a6e3b4559e$var$V = c;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
function $f62453a6e3b4559e$var$jk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $f62453a6e3b4559e$var$Qj(4, b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $f62453a6e3b4559e$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $f62453a6e3b4559e$var$Rj(b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $f62453a6e3b4559e$var$Rj(b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $f62453a6e3b4559e$var$W(b, b.return, k);
        }
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $f62453a6e3b4559e$var$V = h;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
var $f62453a6e3b4559e$var$lk = Math.ceil, $f62453a6e3b4559e$var$mk = $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher, $f62453a6e3b4559e$var$nk = $f62453a6e3b4559e$var$ua.ReactCurrentOwner, $f62453a6e3b4559e$var$ok = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$K = 0, $f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Y = null, $f62453a6e3b4559e$var$Z = 0, $f62453a6e3b4559e$var$fj = 0, $f62453a6e3b4559e$var$ej = $f62453a6e3b4559e$var$Uf(0), $f62453a6e3b4559e$var$T = 0, $f62453a6e3b4559e$var$pk = null, $f62453a6e3b4559e$var$rh = 0, $f62453a6e3b4559e$var$qk = 0, $f62453a6e3b4559e$var$rk = 0, $f62453a6e3b4559e$var$sk = null, $f62453a6e3b4559e$var$tk = null, $f62453a6e3b4559e$var$fk = 0, $f62453a6e3b4559e$var$Gj = Infinity, $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Oi = !1, $f62453a6e3b4559e$var$Pi = null, $f62453a6e3b4559e$var$Ri = null, $f62453a6e3b4559e$var$vk = !1, $f62453a6e3b4559e$var$wk = null, $f62453a6e3b4559e$var$xk = 0, $f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = null, $f62453a6e3b4559e$var$Ak = -1, $f62453a6e3b4559e$var$Bk = 0;
function $f62453a6e3b4559e$var$R() {
    return 0 !== ($f62453a6e3b4559e$var$K & 6) ? $f62453a6e3b4559e$var$B() : -1 !== $f62453a6e3b4559e$var$Ak ? $f62453a6e3b4559e$var$Ak : $f62453a6e3b4559e$var$Ak = $f62453a6e3b4559e$var$B();
}
function $f62453a6e3b4559e$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($f62453a6e3b4559e$var$K & 2) && 0 !== $f62453a6e3b4559e$var$Z) return $f62453a6e3b4559e$var$Z & -$f62453a6e3b4559e$var$Z;
    if (null !== $f62453a6e3b4559e$var$Kg.transition) return 0 === $f62453a6e3b4559e$var$Bk && ($f62453a6e3b4559e$var$Bk = $f62453a6e3b4559e$var$yc()), $f62453a6e3b4559e$var$Bk;
    a = $f62453a6e3b4559e$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $f62453a6e3b4559e$var$jd(a.type);
    return a;
}
function $f62453a6e3b4559e$var$gi(a, b, c, d) {
    if (50 < $f62453a6e3b4559e$var$yk) throw $f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = null, Error($f62453a6e3b4559e$var$p(185));
    $f62453a6e3b4559e$var$Ac(a, c, d);
    if (0 === ($f62453a6e3b4559e$var$K & 2) || a !== $f62453a6e3b4559e$var$Q) a === $f62453a6e3b4559e$var$Q && (0 === ($f62453a6e3b4559e$var$K & 2) && ($f62453a6e3b4559e$var$qk |= c), 4 === $f62453a6e3b4559e$var$T && $f62453a6e3b4559e$var$Ck(a, $f62453a6e3b4559e$var$Z)), $f62453a6e3b4559e$var$Dk(a, d), 1 === c && 0 === $f62453a6e3b4559e$var$K && 0 === (b.mode & 1) && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$fg && $f62453a6e3b4559e$var$jg());
}
function $f62453a6e3b4559e$var$Dk(a, b) {
    var c = a.callbackNode;
    $f62453a6e3b4559e$var$wc(a, b);
    var d = $f62453a6e3b4559e$var$uc(a, a === $f62453a6e3b4559e$var$Q ? $f62453a6e3b4559e$var$Z : 0);
    if (0 === d) null !== c && $f62453a6e3b4559e$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $f62453a6e3b4559e$var$bc(c);
        if (1 === b) 0 === a.tag ? $f62453a6e3b4559e$var$ig($f62453a6e3b4559e$var$Ek.bind(null, a)) : $f62453a6e3b4559e$var$hg($f62453a6e3b4559e$var$Ek.bind(null, a)), $f62453a6e3b4559e$var$Jf(function() {
            0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$jg();
        }), c = null;
        else {
            switch($f62453a6e3b4559e$var$Dc(d)){
                case 1:
                    c = $f62453a6e3b4559e$var$fc;
                    break;
                case 4:
                    c = $f62453a6e3b4559e$var$gc;
                    break;
                case 16:
                    c = $f62453a6e3b4559e$var$hc;
                    break;
                case 536870912:
                    c = $f62453a6e3b4559e$var$jc;
                    break;
                default:
                    c = $f62453a6e3b4559e$var$hc;
            }
            c = $f62453a6e3b4559e$var$Fk(c, $f62453a6e3b4559e$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $f62453a6e3b4559e$var$Gk(a, b) {
    $f62453a6e3b4559e$var$Ak = -1;
    $f62453a6e3b4559e$var$Bk = 0;
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    var c = a.callbackNode;
    if ($f62453a6e3b4559e$var$Hk() && a.callbackNode !== c) return null;
    var d = $f62453a6e3b4559e$var$uc(a, a === $f62453a6e3b4559e$var$Q ? $f62453a6e3b4559e$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $f62453a6e3b4559e$var$Ik(a, d);
    else {
        b = d;
        var e = $f62453a6e3b4559e$var$K;
        $f62453a6e3b4559e$var$K |= 2;
        var f = $f62453a6e3b4559e$var$Jk();
        if ($f62453a6e3b4559e$var$Q !== a || $f62453a6e3b4559e$var$Z !== b) $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$Kk(a, b);
        for(;;)try {
            $f62453a6e3b4559e$var$Lk();
            break;
        } catch (h) {
            $f62453a6e3b4559e$var$Mk(a, h);
        }
        $f62453a6e3b4559e$var$$g();
        $f62453a6e3b4559e$var$mk.current = f;
        $f62453a6e3b4559e$var$K = e;
        null !== $f62453a6e3b4559e$var$Y ? b = 0 : ($f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Z = 0, b = $f62453a6e3b4559e$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $f62453a6e3b4559e$var$xc(a), 0 !== e && (d = e, b = $f62453a6e3b4559e$var$Nk(a, e)));
        if (1 === b) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, d), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
        if (6 === b) $f62453a6e3b4559e$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$f62453a6e3b4559e$var$Ok(e) && (b = $f62453a6e3b4559e$var$Ik(a, d), 2 === b && (f = $f62453a6e3b4559e$var$xc(a), 0 !== f && (d = f, b = $f62453a6e3b4559e$var$Nk(a, f))), 1 === b)) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, d), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($f62453a6e3b4559e$var$p(345));
                case 2:
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 3:
                    $f62453a6e3b4559e$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $f62453a6e3b4559e$var$fk + 500 - $f62453a6e3b4559e$var$B(), 10 < b)) {
                        if (0 !== $f62453a6e3b4559e$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $f62453a6e3b4559e$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $f62453a6e3b4559e$var$Ff($f62453a6e3b4559e$var$Pk.bind(null, a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk), b);
                        break;
                    }
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 4:
                    $f62453a6e3b4559e$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $f62453a6e3b4559e$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $f62453a6e3b4559e$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $f62453a6e3b4559e$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $f62453a6e3b4559e$var$Ff($f62453a6e3b4559e$var$Pk.bind(null, a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk), d);
                        break;
                    }
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 5:
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(329));
            }
        }
    }
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    return a.callbackNode === c ? $f62453a6e3b4559e$var$Gk.bind(null, a) : null;
}
function $f62453a6e3b4559e$var$Nk(a, b) {
    var c = $f62453a6e3b4559e$var$sk;
    a.current.memoizedState.isDehydrated && ($f62453a6e3b4559e$var$Kk(a, b).flags |= 256);
    a = $f62453a6e3b4559e$var$Ik(a, b);
    2 !== a && (b = $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$tk = c, null !== b && $f62453a6e3b4559e$var$Fj(b));
    return a;
}
function $f62453a6e3b4559e$var$Fj(a) {
    null === $f62453a6e3b4559e$var$tk ? $f62453a6e3b4559e$var$tk = a : $f62453a6e3b4559e$var$tk.push.apply($f62453a6e3b4559e$var$tk, a);
}
function $f62453a6e3b4559e$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$f62453a6e3b4559e$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $f62453a6e3b4559e$var$Ck(a, b) {
    b &= ~$f62453a6e3b4559e$var$rk;
    b &= ~$f62453a6e3b4559e$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $f62453a6e3b4559e$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $f62453a6e3b4559e$var$Ek(a) {
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    $f62453a6e3b4559e$var$Hk();
    var b = $f62453a6e3b4559e$var$uc(a, 0);
    if (0 === (b & 1)) return $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), null;
    var c = $f62453a6e3b4559e$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $f62453a6e3b4559e$var$xc(a);
        0 !== d && (b = d, c = $f62453a6e3b4559e$var$Nk(a, d));
    }
    if (1 === c) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, b), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
    if (6 === c) throw Error($f62453a6e3b4559e$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    return null;
}
function $f62453a6e3b4559e$var$Qk(a, b) {
    var c = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 1;
    try {
        return a(b);
    } finally{
        $f62453a6e3b4559e$var$K = c, 0 === $f62453a6e3b4559e$var$K && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$fg && $f62453a6e3b4559e$var$jg());
    }
}
function $f62453a6e3b4559e$var$Rk(a) {
    null !== $f62453a6e3b4559e$var$wk && 0 === $f62453a6e3b4559e$var$wk.tag && 0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$Hk();
    var b = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 1;
    var c = $f62453a6e3b4559e$var$ok.transition, d = $f62453a6e3b4559e$var$C;
    try {
        if ($f62453a6e3b4559e$var$ok.transition = null, $f62453a6e3b4559e$var$C = 1, a) return a();
    } finally{
        $f62453a6e3b4559e$var$C = d, $f62453a6e3b4559e$var$ok.transition = c, $f62453a6e3b4559e$var$K = b, 0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$jg();
    }
}
function $f62453a6e3b4559e$var$Hj() {
    $f62453a6e3b4559e$var$fj = $f62453a6e3b4559e$var$ej.current;
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$ej);
}
function $f62453a6e3b4559e$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $f62453a6e3b4559e$var$Gf(c));
    if (null !== $f62453a6e3b4559e$var$Y) for(c = $f62453a6e3b4559e$var$Y.return; null !== c;){
        var d = c;
        $f62453a6e3b4559e$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f62453a6e3b4559e$var$$f();
                break;
            case 3:
                $f62453a6e3b4559e$var$zh();
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
                $f62453a6e3b4559e$var$Eh();
                break;
            case 5:
                $f62453a6e3b4559e$var$Bh(d);
                break;
            case 4:
                $f62453a6e3b4559e$var$zh();
                break;
            case 13:
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
                break;
            case 19:
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
                break;
            case 10:
                $f62453a6e3b4559e$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $f62453a6e3b4559e$var$Hj();
        }
        c = c.return;
    }
    $f62453a6e3b4559e$var$Q = a;
    $f62453a6e3b4559e$var$Y = a = $f62453a6e3b4559e$var$Pg(a.current, null);
    $f62453a6e3b4559e$var$Z = $f62453a6e3b4559e$var$fj = b;
    $f62453a6e3b4559e$var$T = 0;
    $f62453a6e3b4559e$var$pk = null;
    $f62453a6e3b4559e$var$rk = $f62453a6e3b4559e$var$qk = $f62453a6e3b4559e$var$rh = 0;
    $f62453a6e3b4559e$var$tk = $f62453a6e3b4559e$var$sk = null;
    if (null !== $f62453a6e3b4559e$var$fh) {
        for(b = 0; b < $f62453a6e3b4559e$var$fh.length; b++)if (c = $f62453a6e3b4559e$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $f62453a6e3b4559e$var$fh = null;
    }
    return a;
}
function $f62453a6e3b4559e$var$Mk(a, b) {
    do {
        var c = $f62453a6e3b4559e$var$Y;
        try {
            $f62453a6e3b4559e$var$$g();
            $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Rh;
            if ($f62453a6e3b4559e$var$Ih) {
                for(var d = $f62453a6e3b4559e$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $f62453a6e3b4559e$var$Ih = !1;
            }
            $f62453a6e3b4559e$var$Hh = 0;
            $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = $f62453a6e3b4559e$var$M = null;
            $f62453a6e3b4559e$var$Jh = !1;
            $f62453a6e3b4559e$var$Kh = 0;
            $f62453a6e3b4559e$var$nk.current = null;
            if (null === c || null === c.return) {
                $f62453a6e3b4559e$var$T = 1;
                $f62453a6e3b4559e$var$pk = b;
                $f62453a6e3b4559e$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $f62453a6e3b4559e$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $f62453a6e3b4559e$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $f62453a6e3b4559e$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $f62453a6e3b4559e$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $f62453a6e3b4559e$var$Si(f, l, b);
                            $f62453a6e3b4559e$var$tj();
                            break a;
                        }
                        k = Error($f62453a6e3b4559e$var$p(426));
                    }
                } else if ($f62453a6e3b4559e$var$I && h.mode & 1) {
                    var J = $f62453a6e3b4559e$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $f62453a6e3b4559e$var$Vi(J, g, h, f, b);
                        $f62453a6e3b4559e$var$Jg($f62453a6e3b4559e$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $f62453a6e3b4559e$var$Ji(k, h);
                4 !== $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 2);
                null === $f62453a6e3b4559e$var$sk ? $f62453a6e3b4559e$var$sk = [
                    f
                ] : $f62453a6e3b4559e$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $f62453a6e3b4559e$var$Ni(f, k, b);
                            $f62453a6e3b4559e$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $f62453a6e3b4559e$var$Ri || !$f62453a6e3b4559e$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $f62453a6e3b4559e$var$Qi(f, h, b);
                                $f62453a6e3b4559e$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $f62453a6e3b4559e$var$Sk(c);
        } catch (na) {
            b = na;
            $f62453a6e3b4559e$var$Y === c && null !== c && ($f62453a6e3b4559e$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $f62453a6e3b4559e$var$Jk() {
    var a = $f62453a6e3b4559e$var$mk.current;
    $f62453a6e3b4559e$var$mk.current = $f62453a6e3b4559e$var$Rh;
    return null === a ? $f62453a6e3b4559e$var$Rh : a;
}
function $f62453a6e3b4559e$var$tj() {
    if (0 === $f62453a6e3b4559e$var$T || 3 === $f62453a6e3b4559e$var$T || 2 === $f62453a6e3b4559e$var$T) $f62453a6e3b4559e$var$T = 4;
    null === $f62453a6e3b4559e$var$Q || 0 === ($f62453a6e3b4559e$var$rh & 268435455) && 0 === ($f62453a6e3b4559e$var$qk & 268435455) || $f62453a6e3b4559e$var$Ck($f62453a6e3b4559e$var$Q, $f62453a6e3b4559e$var$Z);
}
function $f62453a6e3b4559e$var$Ik(a, b) {
    var c = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 2;
    var d = $f62453a6e3b4559e$var$Jk();
    if ($f62453a6e3b4559e$var$Q !== a || $f62453a6e3b4559e$var$Z !== b) $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Kk(a, b);
    for(;;)try {
        $f62453a6e3b4559e$var$Tk();
        break;
    } catch (e) {
        $f62453a6e3b4559e$var$Mk(a, e);
    }
    $f62453a6e3b4559e$var$$g();
    $f62453a6e3b4559e$var$K = c;
    $f62453a6e3b4559e$var$mk.current = d;
    if (null !== $f62453a6e3b4559e$var$Y) throw Error($f62453a6e3b4559e$var$p(261));
    $f62453a6e3b4559e$var$Q = null;
    $f62453a6e3b4559e$var$Z = 0;
    return $f62453a6e3b4559e$var$T;
}
function $f62453a6e3b4559e$var$Tk() {
    for(; null !== $f62453a6e3b4559e$var$Y;)$f62453a6e3b4559e$var$Uk($f62453a6e3b4559e$var$Y);
}
function $f62453a6e3b4559e$var$Lk() {
    for(; null !== $f62453a6e3b4559e$var$Y && !$f62453a6e3b4559e$var$cc();)$f62453a6e3b4559e$var$Uk($f62453a6e3b4559e$var$Y);
}
function $f62453a6e3b4559e$var$Uk(a) {
    var b = $f62453a6e3b4559e$var$Vk(a.alternate, a, $f62453a6e3b4559e$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $f62453a6e3b4559e$var$Sk(a) : $f62453a6e3b4559e$var$Y = b;
    $f62453a6e3b4559e$var$nk.current = null;
}
function $f62453a6e3b4559e$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $f62453a6e3b4559e$var$Ej(c, b, $f62453a6e3b4559e$var$fj), null !== c) {
                $f62453a6e3b4559e$var$Y = c;
                return;
            }
        } else {
            c = $f62453a6e3b4559e$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $f62453a6e3b4559e$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $f62453a6e3b4559e$var$T = 6;
                $f62453a6e3b4559e$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $f62453a6e3b4559e$var$Y = b;
            return;
        }
        $f62453a6e3b4559e$var$Y = b = a;
    }while (null !== b);
    0 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 5);
}
function $f62453a6e3b4559e$var$Pk(a, b, c) {
    var d = $f62453a6e3b4559e$var$C, e = $f62453a6e3b4559e$var$ok.transition;
    try {
        $f62453a6e3b4559e$var$ok.transition = null, $f62453a6e3b4559e$var$C = 1, $f62453a6e3b4559e$var$Wk(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$ok.transition = e, $f62453a6e3b4559e$var$C = d;
    }
    return null;
}
function $f62453a6e3b4559e$var$Wk(a, b, c, d) {
    do $f62453a6e3b4559e$var$Hk();
    while (null !== $f62453a6e3b4559e$var$wk);
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($f62453a6e3b4559e$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $f62453a6e3b4559e$var$Bc(a, f);
    a === $f62453a6e3b4559e$var$Q && ($f62453a6e3b4559e$var$Y = $f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $f62453a6e3b4559e$var$vk || ($f62453a6e3b4559e$var$vk = !0, $f62453a6e3b4559e$var$Fk($f62453a6e3b4559e$var$hc, function() {
        $f62453a6e3b4559e$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $f62453a6e3b4559e$var$ok.transition;
        $f62453a6e3b4559e$var$ok.transition = null;
        var g = $f62453a6e3b4559e$var$C;
        $f62453a6e3b4559e$var$C = 1;
        var h = $f62453a6e3b4559e$var$K;
        $f62453a6e3b4559e$var$K |= 4;
        $f62453a6e3b4559e$var$nk.current = null;
        $f62453a6e3b4559e$var$Oj(a, c);
        $f62453a6e3b4559e$var$dk(c, a);
        $f62453a6e3b4559e$var$Oe($f62453a6e3b4559e$var$Df);
        $f62453a6e3b4559e$var$dd = !!$f62453a6e3b4559e$var$Cf;
        $f62453a6e3b4559e$var$Df = $f62453a6e3b4559e$var$Cf = null;
        a.current = c;
        $f62453a6e3b4559e$var$hk(c, a, e);
        $f62453a6e3b4559e$var$dc();
        $f62453a6e3b4559e$var$K = h;
        $f62453a6e3b4559e$var$C = g;
        $f62453a6e3b4559e$var$ok.transition = f;
    } else a.current = c;
    $f62453a6e3b4559e$var$vk && ($f62453a6e3b4559e$var$vk = !1, $f62453a6e3b4559e$var$wk = a, $f62453a6e3b4559e$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($f62453a6e3b4559e$var$Ri = null);
    $f62453a6e3b4559e$var$mc(c.stateNode, d);
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($f62453a6e3b4559e$var$Oi) throw $f62453a6e3b4559e$var$Oi = !1, a = $f62453a6e3b4559e$var$Pi, $f62453a6e3b4559e$var$Pi = null, a;
    0 !== ($f62453a6e3b4559e$var$xk & 1) && 0 !== a.tag && $f62453a6e3b4559e$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $f62453a6e3b4559e$var$zk ? $f62453a6e3b4559e$var$yk++ : ($f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = a) : $f62453a6e3b4559e$var$yk = 0;
    $f62453a6e3b4559e$var$jg();
    return null;
}
function $f62453a6e3b4559e$var$Hk() {
    if (null !== $f62453a6e3b4559e$var$wk) {
        var a = $f62453a6e3b4559e$var$Dc($f62453a6e3b4559e$var$xk), b = $f62453a6e3b4559e$var$ok.transition, c = $f62453a6e3b4559e$var$C;
        try {
            $f62453a6e3b4559e$var$ok.transition = null;
            $f62453a6e3b4559e$var$C = 16 > a ? 16 : a;
            if (null === $f62453a6e3b4559e$var$wk) var d = !1;
            else {
                a = $f62453a6e3b4559e$var$wk;
                $f62453a6e3b4559e$var$wk = null;
                $f62453a6e3b4559e$var$xk = 0;
                if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(331));
                var e = $f62453a6e3b4559e$var$K;
                $f62453a6e3b4559e$var$K |= 4;
                for($f62453a6e3b4559e$var$V = a.current; null !== $f62453a6e3b4559e$var$V;){
                    var f = $f62453a6e3b4559e$var$V, g = f.child;
                    if (0 !== ($f62453a6e3b4559e$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($f62453a6e3b4559e$var$V = l; null !== $f62453a6e3b4559e$var$V;){
                                    var m = $f62453a6e3b4559e$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $f62453a6e3b4559e$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $f62453a6e3b4559e$var$V = q;
                                    else for(; null !== $f62453a6e3b4559e$var$V;){
                                        m = $f62453a6e3b4559e$var$V;
                                        var r = m.sibling, y = m.return;
                                        $f62453a6e3b4559e$var$Sj(m);
                                        if (m === l) {
                                            $f62453a6e3b4559e$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $f62453a6e3b4559e$var$V = r;
                                            break;
                                        }
                                        $f62453a6e3b4559e$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $f62453a6e3b4559e$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $f62453a6e3b4559e$var$V = g;
                    else b: for(; null !== $f62453a6e3b4559e$var$V;){
                        f = $f62453a6e3b4559e$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $f62453a6e3b4559e$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $f62453a6e3b4559e$var$V = x;
                            break b;
                        }
                        $f62453a6e3b4559e$var$V = f.return;
                    }
                }
                var w = a.current;
                for($f62453a6e3b4559e$var$V = w; null !== $f62453a6e3b4559e$var$V;){
                    g = $f62453a6e3b4559e$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $f62453a6e3b4559e$var$V = u;
                    else b: for(g = w; null !== $f62453a6e3b4559e$var$V;){
                        h = $f62453a6e3b4559e$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $f62453a6e3b4559e$var$Qj(9, h);
                            }
                        } catch (na) {
                            $f62453a6e3b4559e$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $f62453a6e3b4559e$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $f62453a6e3b4559e$var$V = F;
                            break b;
                        }
                        $f62453a6e3b4559e$var$V = h.return;
                    }
                }
                $f62453a6e3b4559e$var$K = e;
                $f62453a6e3b4559e$var$jg();
                if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onPostCommitFiberRoot) try {
                    $f62453a6e3b4559e$var$lc.onPostCommitFiberRoot($f62453a6e3b4559e$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $f62453a6e3b4559e$var$C = c, $f62453a6e3b4559e$var$ok.transition = b;
        }
    }
    return !1;
}
function $f62453a6e3b4559e$var$Xk(a, b, c) {
    b = $f62453a6e3b4559e$var$Ji(c, b);
    b = $f62453a6e3b4559e$var$Ni(a, b, 1);
    a = $f62453a6e3b4559e$var$nh(a, b, 1);
    b = $f62453a6e3b4559e$var$R();
    null !== a && ($f62453a6e3b4559e$var$Ac(a, 1, b), $f62453a6e3b4559e$var$Dk(a, b));
}
function $f62453a6e3b4559e$var$W(a, b, c) {
    if (3 === a.tag) $f62453a6e3b4559e$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $f62453a6e3b4559e$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $f62453a6e3b4559e$var$Ri || !$f62453a6e3b4559e$var$Ri.has(d))) {
                a = $f62453a6e3b4559e$var$Ji(c, a);
                a = $f62453a6e3b4559e$var$Qi(b, a, 1);
                b = $f62453a6e3b4559e$var$nh(b, a, 1);
                a = $f62453a6e3b4559e$var$R();
                null !== b && ($f62453a6e3b4559e$var$Ac(b, 1, a), $f62453a6e3b4559e$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $f62453a6e3b4559e$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $f62453a6e3b4559e$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $f62453a6e3b4559e$var$Q === a && ($f62453a6e3b4559e$var$Z & c) === c && (4 === $f62453a6e3b4559e$var$T || 3 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$Z & 130023424) === $f62453a6e3b4559e$var$Z && 500 > $f62453a6e3b4559e$var$B() - $f62453a6e3b4559e$var$fk ? $f62453a6e3b4559e$var$Kk(a, 0) : $f62453a6e3b4559e$var$rk |= c);
    $f62453a6e3b4559e$var$Dk(a, b);
}
function $f62453a6e3b4559e$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $f62453a6e3b4559e$var$sc, $f62453a6e3b4559e$var$sc <<= 1, 0 === ($f62453a6e3b4559e$var$sc & 130023424) && ($f62453a6e3b4559e$var$sc = 4194304)));
    var c = $f62453a6e3b4559e$var$R();
    a = $f62453a6e3b4559e$var$ih(a, b);
    null !== a && ($f62453a6e3b4559e$var$Ac(a, b, c), $f62453a6e3b4559e$var$Dk(a, c));
}
function $f62453a6e3b4559e$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $f62453a6e3b4559e$var$Yk(a, c);
}
function $f62453a6e3b4559e$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($f62453a6e3b4559e$var$p(314));
    }
    null !== d && d.delete(b);
    $f62453a6e3b4559e$var$Yk(a, c);
}
var $f62453a6e3b4559e$var$Vk;
$f62453a6e3b4559e$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $f62453a6e3b4559e$var$Wf.current) $f62453a6e3b4559e$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $f62453a6e3b4559e$var$dh = !1, $f62453a6e3b4559e$var$yj(a, b, c);
            $f62453a6e3b4559e$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $f62453a6e3b4559e$var$dh = !1, $f62453a6e3b4559e$var$I && 0 !== (b.flags & 1048576) && $f62453a6e3b4559e$var$ug(b, $f62453a6e3b4559e$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $f62453a6e3b4559e$var$ij(a, b);
            a = b.pendingProps;
            var e = $f62453a6e3b4559e$var$Yf(b, $f62453a6e3b4559e$var$H.current);
            $f62453a6e3b4559e$var$ch(b, c);
            e = $f62453a6e3b4559e$var$Nh(null, b, d, a, e, c);
            var f = $f62453a6e3b4559e$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $f62453a6e3b4559e$var$Zf(d) ? (f = !0, $f62453a6e3b4559e$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $f62453a6e3b4559e$var$kh(b), e.updater = $f62453a6e3b4559e$var$Ei, b.stateNode = e, e._reactInternals = b, $f62453a6e3b4559e$var$Ii(b, d, a, c), b = $f62453a6e3b4559e$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $f62453a6e3b4559e$var$I && f && $f62453a6e3b4559e$var$vg(b), $f62453a6e3b4559e$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $f62453a6e3b4559e$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $f62453a6e3b4559e$var$Zk(d);
                a = $f62453a6e3b4559e$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $f62453a6e3b4559e$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $f62453a6e3b4559e$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $f62453a6e3b4559e$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $f62453a6e3b4559e$var$$i(null, b, d, $f62453a6e3b4559e$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($f62453a6e3b4559e$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $f62453a6e3b4559e$var$kj(b);
                if (null === a) throw Error($f62453a6e3b4559e$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $f62453a6e3b4559e$var$lh(a, b);
                $f62453a6e3b4559e$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $f62453a6e3b4559e$var$Ji(Error($f62453a6e3b4559e$var$p(423)), b);
                        b = $f62453a6e3b4559e$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $f62453a6e3b4559e$var$Ji(Error($f62453a6e3b4559e$var$p(424)), b);
                        b = $f62453a6e3b4559e$var$lj(a, b, d, c, e);
                        break a;
                    } else for($f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(b.stateNode.containerInfo.firstChild), $f62453a6e3b4559e$var$xg = b, $f62453a6e3b4559e$var$I = !0, $f62453a6e3b4559e$var$zg = null, c = $f62453a6e3b4559e$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $f62453a6e3b4559e$var$Ig();
                    if (d === e) {
                        b = $f62453a6e3b4559e$var$Zi(a, b, c);
                        break a;
                    }
                    $f62453a6e3b4559e$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $f62453a6e3b4559e$var$Ah(b), null === a && $f62453a6e3b4559e$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $f62453a6e3b4559e$var$Ef(d, e) ? g = null : null !== f && $f62453a6e3b4559e$var$Ef(d, f) && (b.flags |= 32), $f62453a6e3b4559e$var$gj(a, b), $f62453a6e3b4559e$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $f62453a6e3b4559e$var$Eg(b), null;
        case 13:
            return $f62453a6e3b4559e$var$oj(a, b, c);
        case 4:
            return $f62453a6e3b4559e$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $f62453a6e3b4559e$var$Ug(b, null, d, c) : $f62453a6e3b4559e$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$Yi(a, b, d, e, c);
        case 7:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($f62453a6e3b4559e$var$He(f.value, g)) {
                        if (f.children === e.children && !$f62453a6e3b4559e$var$Wf.current) {
                            b = $f62453a6e3b4559e$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $f62453a6e3b4559e$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $f62453a6e3b4559e$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($f62453a6e3b4559e$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $f62453a6e3b4559e$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $f62453a6e3b4559e$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $f62453a6e3b4559e$var$ch(b, c), e = $f62453a6e3b4559e$var$eh(e), d = d(e), b.flags |= 1, $f62453a6e3b4559e$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $f62453a6e3b4559e$var$Ci(d, b.pendingProps), e = $f62453a6e3b4559e$var$Ci(d.type, e), $f62453a6e3b4559e$var$$i(a, b, d, e, c);
        case 15:
            return $f62453a6e3b4559e$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$ij(a, b), b.tag = 1, $f62453a6e3b4559e$var$Zf(d) ? (a = !0, $f62453a6e3b4559e$var$cg(b)) : a = !1, $f62453a6e3b4559e$var$ch(b, c), $f62453a6e3b4559e$var$Gi(b, d, e), $f62453a6e3b4559e$var$Ii(b, d, e, c), $f62453a6e3b4559e$var$jj(null, b, d, !0, a, c);
        case 19:
            return $f62453a6e3b4559e$var$xj(a, b, c);
        case 22:
            return $f62453a6e3b4559e$var$dj(a, b, c);
    }
    throw Error($f62453a6e3b4559e$var$p(156, b.tag));
};
function $f62453a6e3b4559e$var$Fk(a, b) {
    return $f62453a6e3b4559e$var$ac(a, b);
}
function $f62453a6e3b4559e$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f62453a6e3b4559e$var$Bg(a, b, c, d) {
    return new $f62453a6e3b4559e$var$$k(a, b, c, d);
}
function $f62453a6e3b4559e$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $f62453a6e3b4559e$var$Zk(a) {
    if ("function" === typeof a) return $f62453a6e3b4559e$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $f62453a6e3b4559e$var$Da) return 11;
        if (a === $f62453a6e3b4559e$var$Ga) return 14;
    }
    return 2;
}
function $f62453a6e3b4559e$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $f62453a6e3b4559e$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $f62453a6e3b4559e$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $f62453a6e3b4559e$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $f62453a6e3b4559e$var$ya:
            return $f62453a6e3b4559e$var$Tg(c.children, e, f, b);
        case $f62453a6e3b4559e$var$za:
            g = 8;
            e |= 8;
            break;
        case $f62453a6e3b4559e$var$Aa:
            return a = $f62453a6e3b4559e$var$Bg(12, c, b, e | 2), a.elementType = $f62453a6e3b4559e$var$Aa, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Ea:
            return a = $f62453a6e3b4559e$var$Bg(13, c, b, e), a.elementType = $f62453a6e3b4559e$var$Ea, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Fa:
            return a = $f62453a6e3b4559e$var$Bg(19, c, b, e), a.elementType = $f62453a6e3b4559e$var$Fa, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Ia:
            return $f62453a6e3b4559e$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $f62453a6e3b4559e$var$Ba:
                    g = 10;
                    break a;
                case $f62453a6e3b4559e$var$Ca:
                    g = 9;
                    break a;
                case $f62453a6e3b4559e$var$Da:
                    g = 11;
                    break a;
                case $f62453a6e3b4559e$var$Ga:
                    g = 14;
                    break a;
                case $f62453a6e3b4559e$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($f62453a6e3b4559e$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $f62453a6e3b4559e$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $f62453a6e3b4559e$var$Tg(a, b, c, d) {
    a = $f62453a6e3b4559e$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $f62453a6e3b4559e$var$pj(a, b, c, d) {
    a = $f62453a6e3b4559e$var$Bg(22, a, d, b);
    a.elementType = $f62453a6e3b4559e$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $f62453a6e3b4559e$var$Qg(a, b, c) {
    a = $f62453a6e3b4559e$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $f62453a6e3b4559e$var$Sg(a, b, c) {
    b = $f62453a6e3b4559e$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $f62453a6e3b4559e$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $f62453a6e3b4559e$var$zc(0);
    this.expirationTimes = $f62453a6e3b4559e$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f62453a6e3b4559e$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $f62453a6e3b4559e$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $f62453a6e3b4559e$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $f62453a6e3b4559e$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $f62453a6e3b4559e$var$kh(f);
    return a;
}
function $f62453a6e3b4559e$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $f62453a6e3b4559e$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $f62453a6e3b4559e$var$dl(a) {
    if (!a) return $f62453a6e3b4559e$var$Vf;
    a = a._reactInternals;
    a: {
        if ($f62453a6e3b4559e$var$Vb(a) !== a || 1 !== a.tag) throw Error($f62453a6e3b4559e$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($f62453a6e3b4559e$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($f62453a6e3b4559e$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($f62453a6e3b4559e$var$Zf(c)) return $f62453a6e3b4559e$var$bg(a, c, b);
    }
    return b;
}
function $f62453a6e3b4559e$var$el(a, b, c, d, e, f, g, h, k) {
    a = $f62453a6e3b4559e$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $f62453a6e3b4559e$var$dl(null);
    c = a.current;
    d = $f62453a6e3b4559e$var$R();
    e = $f62453a6e3b4559e$var$yi(c);
    f = $f62453a6e3b4559e$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $f62453a6e3b4559e$var$nh(c, f, e);
    a.current.lanes = e;
    $f62453a6e3b4559e$var$Ac(a, e, d);
    $f62453a6e3b4559e$var$Dk(a, d);
    return a;
}
function $f62453a6e3b4559e$var$fl(a, b, c, d) {
    var e = b.current, f = $f62453a6e3b4559e$var$R(), g = $f62453a6e3b4559e$var$yi(e);
    c = $f62453a6e3b4559e$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $f62453a6e3b4559e$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $f62453a6e3b4559e$var$nh(e, b, g);
    null !== a && ($f62453a6e3b4559e$var$gi(a, e, g, f), $f62453a6e3b4559e$var$oh(a, e, g));
    return g;
}
function $f62453a6e3b4559e$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $f62453a6e3b4559e$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $f62453a6e3b4559e$var$il(a, b) {
    $f62453a6e3b4559e$var$hl(a, b);
    (a = a.alternate) && $f62453a6e3b4559e$var$hl(a, b);
}
function $f62453a6e3b4559e$var$jl() {
    return null;
}
var $f62453a6e3b4559e$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $f62453a6e3b4559e$var$ll(a) {
    this._internalRoot = a;
}
$f62453a6e3b4559e$var$ml.prototype.render = $f62453a6e3b4559e$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($f62453a6e3b4559e$var$p(409));
    $f62453a6e3b4559e$var$fl(a, b, null, null);
};
$f62453a6e3b4559e$var$ml.prototype.unmount = $f62453a6e3b4559e$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $f62453a6e3b4559e$var$Rk(function() {
            $f62453a6e3b4559e$var$fl(null, a, null, null);
        });
        b[$f62453a6e3b4559e$var$uf] = null;
    }
};
function $f62453a6e3b4559e$var$ml(a) {
    this._internalRoot = a;
}
$f62453a6e3b4559e$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $f62453a6e3b4559e$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $f62453a6e3b4559e$var$Qc.length && 0 !== b && b < $f62453a6e3b4559e$var$Qc[c].priority; c++);
        $f62453a6e3b4559e$var$Qc.splice(c, 0, a);
        0 === c && $f62453a6e3b4559e$var$Vc(a);
    }
};
function $f62453a6e3b4559e$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $f62453a6e3b4559e$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $f62453a6e3b4559e$var$pl() {}
function $f62453a6e3b4559e$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $f62453a6e3b4559e$var$gl(g);
                f.call(a);
            };
        }
        var g = $f62453a6e3b4559e$var$el(b, d, a, 0, null, !1, !1, "", $f62453a6e3b4559e$var$pl);
        a._reactRootContainer = g;
        a[$f62453a6e3b4559e$var$uf] = g.current;
        $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
        $f62453a6e3b4559e$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $f62453a6e3b4559e$var$gl(k);
            h.call(a);
        };
    }
    var k = $f62453a6e3b4559e$var$bl(a, 0, !1, null, null, !1, !1, "", $f62453a6e3b4559e$var$pl);
    a._reactRootContainer = k;
    a[$f62453a6e3b4559e$var$uf] = k.current;
    $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
    $f62453a6e3b4559e$var$Rk(function() {
        $f62453a6e3b4559e$var$fl(b, k, c, d);
    });
    return k;
}
function $f62453a6e3b4559e$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $f62453a6e3b4559e$var$gl(g);
                h.call(a);
            };
        }
        $f62453a6e3b4559e$var$fl(b, g, a, e);
    } else g = $f62453a6e3b4559e$var$ql(c, b, a, e, d);
    return $f62453a6e3b4559e$var$gl(g);
}
$f62453a6e3b4559e$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $f62453a6e3b4559e$var$tc(b.pendingLanes);
                0 !== c && ($f62453a6e3b4559e$var$Cc(b, c | 1), $f62453a6e3b4559e$var$Dk(b, $f62453a6e3b4559e$var$B()), 0 === ($f62453a6e3b4559e$var$K & 6) && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$jg()));
            }
            break;
        case 13:
            $f62453a6e3b4559e$var$Rk(function() {
                var b = $f62453a6e3b4559e$var$ih(a, 1);
                if (null !== b) {
                    var c = $f62453a6e3b4559e$var$R();
                    $f62453a6e3b4559e$var$gi(b, a, 1, c);
                }
            }), $f62453a6e3b4559e$var$il(a, 1);
    }
};
$f62453a6e3b4559e$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $f62453a6e3b4559e$var$ih(a, 134217728);
        if (null !== b) {
            var c = $f62453a6e3b4559e$var$R();
            $f62453a6e3b4559e$var$gi(b, a, 134217728, c);
        }
        $f62453a6e3b4559e$var$il(a, 134217728);
    }
};
$f62453a6e3b4559e$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $f62453a6e3b4559e$var$yi(a), c = $f62453a6e3b4559e$var$ih(a, b);
        if (null !== c) {
            var d = $f62453a6e3b4559e$var$R();
            $f62453a6e3b4559e$var$gi(c, a, b, d);
        }
        $f62453a6e3b4559e$var$il(a, b);
    }
};
$f62453a6e3b4559e$var$Hc = function() {
    return $f62453a6e3b4559e$var$C;
};
$f62453a6e3b4559e$var$Ic = function(a, b) {
    var c = $f62453a6e3b4559e$var$C;
    try {
        return $f62453a6e3b4559e$var$C = a, b();
    } finally{
        $f62453a6e3b4559e$var$C = c;
    }
};
$f62453a6e3b4559e$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $f62453a6e3b4559e$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $f62453a6e3b4559e$var$Db(d);
                        if (!e) throw Error($f62453a6e3b4559e$var$p(90));
                        $f62453a6e3b4559e$var$Wa(d);
                        $f62453a6e3b4559e$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $f62453a6e3b4559e$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $f62453a6e3b4559e$var$fb(a, !!c.multiple, b, !1);
    }
};
$f62453a6e3b4559e$var$Gb = $f62453a6e3b4559e$var$Qk;
$f62453a6e3b4559e$var$Hb = $f62453a6e3b4559e$var$Rk;
var $f62453a6e3b4559e$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $f62453a6e3b4559e$var$Cb,
        $f62453a6e3b4559e$var$ue,
        $f62453a6e3b4559e$var$Db,
        $f62453a6e3b4559e$var$Eb,
        $f62453a6e3b4559e$var$Fb,
        $f62453a6e3b4559e$var$Qk
    ]
}, $f62453a6e3b4559e$var$tl = {
    findFiberByHostInstance: $f62453a6e3b4559e$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $f62453a6e3b4559e$var$ul = {
    bundleType: $f62453a6e3b4559e$var$tl.bundleType,
    version: $f62453a6e3b4559e$var$tl.version,
    rendererPackageName: $f62453a6e3b4559e$var$tl.rendererPackageName,
    rendererConfig: $f62453a6e3b4559e$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $f62453a6e3b4559e$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $f62453a6e3b4559e$var$tl.findFiberByHostInstance || $f62453a6e3b4559e$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f62453a6e3b4559e$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f62453a6e3b4559e$var$vl.isDisabled && $f62453a6e3b4559e$var$vl.supportsFiber) try {
        $f62453a6e3b4559e$var$kc = $f62453a6e3b4559e$var$vl.inject($f62453a6e3b4559e$var$ul), $f62453a6e3b4559e$var$lc = $f62453a6e3b4559e$var$vl;
    } catch (a) {}
}
$f62453a6e3b4559e$export$ae55be85d98224ed = $f62453a6e3b4559e$var$sl;
$f62453a6e3b4559e$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$f62453a6e3b4559e$var$nl(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$cl(a, b, null, c);
};
$f62453a6e3b4559e$export$882461b6382ed46c = function(a, b) {
    if (!$f62453a6e3b4559e$var$nl(a)) throw Error($f62453a6e3b4559e$var$p(299));
    var c = !1, d = "", e = $f62453a6e3b4559e$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $f62453a6e3b4559e$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$f62453a6e3b4559e$var$uf] = b.current;
    $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $f62453a6e3b4559e$var$ll(b);
};
$f62453a6e3b4559e$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($f62453a6e3b4559e$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($f62453a6e3b4559e$var$p(268, a));
    }
    a = $f62453a6e3b4559e$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$f62453a6e3b4559e$export$cd75ccfd720a3cd4 = function(a) {
    return $f62453a6e3b4559e$var$Rk(a);
};
$f62453a6e3b4559e$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$ol(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$rl(null, a, b, !0, c);
};
$f62453a6e3b4559e$export$757ceba2d55c277e = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$nl(a)) throw Error($f62453a6e3b4559e$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $f62453a6e3b4559e$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $f62453a6e3b4559e$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$f62453a6e3b4559e$var$uf] = b.current;
    $f62453a6e3b4559e$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $f62453a6e3b4559e$var$ml(b);
};
$f62453a6e3b4559e$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$ol(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$rl(null, a, b, !1, c);
};
$f62453a6e3b4559e$export$502457920280e6be = function(a) {
    if (!$f62453a6e3b4559e$var$ol(a)) throw Error($f62453a6e3b4559e$var$p(40));
    return a._reactRootContainer ? ($f62453a6e3b4559e$var$Rk(function() {
        $f62453a6e3b4559e$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$f62453a6e3b4559e$var$uf] = null;
        });
    }), !0) : !1;
};
$f62453a6e3b4559e$export$c78a37762a8d58e1 = $f62453a6e3b4559e$var$Qk;
$f62453a6e3b4559e$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$f62453a6e3b4559e$var$ol(c)) throw Error($f62453a6e3b4559e$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($f62453a6e3b4559e$var$p(38));
    return $f62453a6e3b4559e$var$rl(a, b, c, !1, d);
};
$f62453a6e3b4559e$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("7zDBh", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1uxJf"));

});
parcelRegister("1uxJf", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $1162c1a406d3f6f8$export$c4744153514ff05d, (v) => $1162c1a406d3f6f8$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7, (v) => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $1162c1a406d3f6f8$export$e26fe2ed2fa76875, (v) => $1162c1a406d3f6f8$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $1162c1a406d3f6f8$export$502329bbf4b505b1, (v) => $1162c1a406d3f6f8$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $1162c1a406d3f6f8$export$6e3807111c4874c4, (v) => $1162c1a406d3f6f8$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $1162c1a406d3f6f8$export$c27134553091fb3a, (v) => $1162c1a406d3f6f8$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2, (v) => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $1162c1a406d3f6f8$export$b00a404bbd5edef2, (v) => $1162c1a406d3f6f8$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $1162c1a406d3f6f8$export$8352ce38b91d0c62, (v) => $1162c1a406d3f6f8$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $1162c1a406d3f6f8$export$d66a1c1c77bd778b, (v) => $1162c1a406d3f6f8$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $1162c1a406d3f6f8$export$d3dfb8e4810cb555, (v) => $1162c1a406d3f6f8$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $1162c1a406d3f6f8$export$839f9183b0465a69, (v) => $1162c1a406d3f6f8$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $1162c1a406d3f6f8$export$72fdf0e06517287b, (v) => $1162c1a406d3f6f8$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $1162c1a406d3f6f8$export$4b844e58a3e414b4, (v) => $1162c1a406d3f6f8$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $1162c1a406d3f6f8$export$816d2913ae6b83b1, (v) => $1162c1a406d3f6f8$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $1162c1a406d3f6f8$export$61bcfe829111a1d0, (v) => $1162c1a406d3f6f8$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f, (v) => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $1162c1a406d3f6f8$export$b5836b71941fa3ed, (v) => $1162c1a406d3f6f8$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $1162c1a406d3f6f8$export$cf845f2c119da08a, (v) => $1162c1a406d3f6f8$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1162c1a406d3f6f8$export$c4744153514ff05d;
var $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7;
var $1162c1a406d3f6f8$export$e26fe2ed2fa76875;
var $1162c1a406d3f6f8$export$502329bbf4b505b1;
var $1162c1a406d3f6f8$export$6e3807111c4874c4;
var $1162c1a406d3f6f8$export$c27134553091fb3a;
var $1162c1a406d3f6f8$export$33ee1acdc04fd2a2;
var $1162c1a406d3f6f8$export$b00a404bbd5edef2;
var $1162c1a406d3f6f8$export$8352ce38b91d0c62;
var $1162c1a406d3f6f8$export$d66a1c1c77bd778b;
var $1162c1a406d3f6f8$export$d3dfb8e4810cb555;
var $1162c1a406d3f6f8$export$839f9183b0465a69;
var $1162c1a406d3f6f8$export$72fdf0e06517287b;
var $1162c1a406d3f6f8$export$4b844e58a3e414b4;
var $1162c1a406d3f6f8$export$816d2913ae6b83b1;
var $1162c1a406d3f6f8$export$61bcfe829111a1d0;
var $1162c1a406d3f6f8$export$7ee8c9beb337bc3f;
var $1162c1a406d3f6f8$export$b5836b71941fa3ed;
var $1162c1a406d3f6f8$export$cf845f2c119da08a;
'use strict';
function $1162c1a406d3f6f8$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1162c1a406d3f6f8$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1162c1a406d3f6f8$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1162c1a406d3f6f8$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1162c1a406d3f6f8$var$g(C, c)) n < e && 0 > $1162c1a406d3f6f8$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1162c1a406d3f6f8$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1162c1a406d3f6f8$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1162c1a406d3f6f8$var$l = performance;
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$l.now();
    };
} else {
    var $1162c1a406d3f6f8$var$p = Date, $1162c1a406d3f6f8$var$q = $1162c1a406d3f6f8$var$p.now();
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$p.now() - $1162c1a406d3f6f8$var$q;
    };
}
var $1162c1a406d3f6f8$var$r = [], $1162c1a406d3f6f8$var$t = [], $1162c1a406d3f6f8$var$u = 1, $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = 3, $1162c1a406d3f6f8$var$z = !1, $1162c1a406d3f6f8$var$A = !1, $1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$D = "function" === typeof setTimeout ? setTimeout : null, $1162c1a406d3f6f8$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1162c1a406d3f6f8$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1162c1a406d3f6f8$var$G(a) {
    for(var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t); null !== b;){
        if (null === b.callback) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t);
        else if (b.startTime <= a) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t), b.sortIndex = b.expirationTime, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, b);
        else break;
        b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
    }
}
function $1162c1a406d3f6f8$var$H(a) {
    $1162c1a406d3f6f8$var$B = !1;
    $1162c1a406d3f6f8$var$G(a);
    if (!$1162c1a406d3f6f8$var$A) {
        if (null !== $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r)) $1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J);
        else {
            var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== b && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, b.startTime - a);
        }
    }
}
function $1162c1a406d3f6f8$var$J(a, b) {
    $1162c1a406d3f6f8$var$A = !1;
    $1162c1a406d3f6f8$var$B && ($1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1);
    $1162c1a406d3f6f8$var$z = !0;
    var c = $1162c1a406d3f6f8$var$y;
    try {
        $1162c1a406d3f6f8$var$G(b);
        for($1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r); null !== $1162c1a406d3f6f8$var$v && (!($1162c1a406d3f6f8$var$v.expirationTime > b) || a && !$1162c1a406d3f6f8$var$M());){
            var d = $1162c1a406d3f6f8$var$v.callback;
            if ("function" === typeof d) {
                $1162c1a406d3f6f8$var$v.callback = null;
                $1162c1a406d3f6f8$var$y = $1162c1a406d3f6f8$var$v.priorityLevel;
                var e = d($1162c1a406d3f6f8$var$v.expirationTime <= b);
                b = $1162c1a406d3f6f8$export$c4744153514ff05d();
                "function" === typeof e ? $1162c1a406d3f6f8$var$v.callback = e : $1162c1a406d3f6f8$var$v === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
                $1162c1a406d3f6f8$var$G(b);
            } else $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
            $1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
        }
        if (null !== $1162c1a406d3f6f8$var$v) var w = !0;
        else {
            var m = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== m && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = c, $1162c1a406d3f6f8$var$z = !1;
    }
}
var $1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null, $1162c1a406d3f6f8$var$L = -1, $1162c1a406d3f6f8$var$P = 5, $1162c1a406d3f6f8$var$Q = -1;
function $1162c1a406d3f6f8$var$M() {
    return $1162c1a406d3f6f8$export$c4744153514ff05d() - $1162c1a406d3f6f8$var$Q < $1162c1a406d3f6f8$var$P ? !1 : !0;
}
function $1162c1a406d3f6f8$var$R() {
    if (null !== $1162c1a406d3f6f8$var$O) {
        var a = $1162c1a406d3f6f8$export$c4744153514ff05d();
        $1162c1a406d3f6f8$var$Q = a;
        var b = !0;
        try {
            b = $1162c1a406d3f6f8$var$O(!0, a);
        } finally{
            b ? $1162c1a406d3f6f8$var$S() : ($1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null);
        }
    } else $1162c1a406d3f6f8$var$N = !1;
}
var $1162c1a406d3f6f8$var$S;
if ("function" === typeof $1162c1a406d3f6f8$var$F) $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$F($1162c1a406d3f6f8$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1162c1a406d3f6f8$var$T = new MessageChannel, $1162c1a406d3f6f8$var$U = $1162c1a406d3f6f8$var$T.port2;
    $1162c1a406d3f6f8$var$T.port1.onmessage = $1162c1a406d3f6f8$var$R;
    $1162c1a406d3f6f8$var$S = function() {
        $1162c1a406d3f6f8$var$U.postMessage(null);
    };
} else $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$D($1162c1a406d3f6f8$var$R, 0);
};
function $1162c1a406d3f6f8$var$I(a) {
    $1162c1a406d3f6f8$var$O = a;
    $1162c1a406d3f6f8$var$N || ($1162c1a406d3f6f8$var$N = !0, $1162c1a406d3f6f8$var$S());
}
function $1162c1a406d3f6f8$var$K(a, b) {
    $1162c1a406d3f6f8$var$L = $1162c1a406d3f6f8$var$D(function() {
        a($1162c1a406d3f6f8$export$c4744153514ff05d());
    }, b);
}
$1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = 5;
$1162c1a406d3f6f8$export$e26fe2ed2fa76875 = 1;
$1162c1a406d3f6f8$export$502329bbf4b505b1 = 4;
$1162c1a406d3f6f8$export$6e3807111c4874c4 = 3;
$1162c1a406d3f6f8$export$c27134553091fb3a = null;
$1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = 2;
$1162c1a406d3f6f8$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1162c1a406d3f6f8$export$8352ce38b91d0c62 = function() {
    $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J));
};
$1162c1a406d3f6f8$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1162c1a406d3f6f8$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1162c1a406d3f6f8$export$d3dfb8e4810cb555 = function() {
    return $1162c1a406d3f6f8$var$y;
};
$1162c1a406d3f6f8$export$839f9183b0465a69 = function() {
    return $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
};
$1162c1a406d3f6f8$export$72fdf0e06517287b = function(a) {
    switch($1162c1a406d3f6f8$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1162c1a406d3f6f8$var$y;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = b;
    try {
        return a();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$4b844e58a3e414b4 = function() {};
$1162c1a406d3f6f8$export$816d2913ae6b83b1 = function() {};
$1162c1a406d3f6f8$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = a;
    try {
        return b();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1162c1a406d3f6f8$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1162c1a406d3f6f8$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$t, a), null === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && a === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t) && ($1162c1a406d3f6f8$var$B ? ($1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1) : $1162c1a406d3f6f8$var$B = !0, $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, c - d))) : (a.sortIndex = e, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, a), $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J)));
    return a;
};
$1162c1a406d3f6f8$export$b5836b71941fa3ed = $1162c1a406d3f6f8$var$M;
$1162c1a406d3f6f8$export$cf845f2c119da08a = function(a) {
    var b = $1162c1a406d3f6f8$var$y;
    return function() {
        var c = $1162c1a406d3f6f8$var$y;
        $1162c1a406d3f6f8$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1162c1a406d3f6f8$var$y = c;
        }
    };
};

});



parcelRegister("2A4qT", function(module, exports) {

$parcel$export(module.exports, "ConcurrentRoot", () => $1e1261cdd1e46abc$export$816aac48d41c2f81, (v) => $1e1261cdd1e46abc$export$816aac48d41c2f81 = v);
$parcel$export(module.exports, "ContinuousEventPriority", () => $1e1261cdd1e46abc$export$3bb88615cd12cb3b, (v) => $1e1261cdd1e46abc$export$3bb88615cd12cb3b = v);
$parcel$export(module.exports, "DefaultEventPriority", () => $1e1261cdd1e46abc$export$d46163d5c045f347, (v) => $1e1261cdd1e46abc$export$d46163d5c045f347 = v);
$parcel$export(module.exports, "DiscreteEventPriority", () => $1e1261cdd1e46abc$export$8ee75c97f0333f15, (v) => $1e1261cdd1e46abc$export$8ee75c97f0333f15 = v);
$parcel$export(module.exports, "IdleEventPriority", () => $1e1261cdd1e46abc$export$d1c113b83e1f881a, (v) => $1e1261cdd1e46abc$export$d1c113b83e1f881a = v);
$parcel$export(module.exports, "LegacyRoot", () => $1e1261cdd1e46abc$export$ff78c4883554845d, (v) => $1e1261cdd1e46abc$export$ff78c4883554845d = v);
/**
 * @license React
 * react-reconciler-constants.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1e1261cdd1e46abc$export$816aac48d41c2f81;
var $1e1261cdd1e46abc$export$3bb88615cd12cb3b;
var $1e1261cdd1e46abc$export$d46163d5c045f347;
var $1e1261cdd1e46abc$export$8ee75c97f0333f15;
var $1e1261cdd1e46abc$export$d1c113b83e1f881a;
var $1e1261cdd1e46abc$export$ff78c4883554845d;
'use strict';
$1e1261cdd1e46abc$export$816aac48d41c2f81 = 1;
$1e1261cdd1e46abc$export$3bb88615cd12cb3b = 4;
$1e1261cdd1e46abc$export$d46163d5c045f347 = 16;
$1e1261cdd1e46abc$export$8ee75c97f0333f15 = 1;
$1e1261cdd1e46abc$export$d1c113b83e1f881a = 536870912;
$1e1261cdd1e46abc$export$ff78c4883554845d = 0;

});

parcelRegister("iSsHE", function(module, exports) {
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 

module.exports = function $$$reconciler($$$hostConfig) {
    var exports = {};
    'use strict';
    var aa = (parcelRequire("aqdBs")), ba = (parcelRequire("bdSvy")), ca = Object.assign;
    function n(a) {
        for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var ea = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, fa = Symbol.for("react.element"), ha = Symbol.for("react.portal"), ia = Symbol.for("react.fragment"), ja = Symbol.for("react.strict_mode"), ka = Symbol.for("react.profiler"), la = Symbol.for("react.provider"), ma = Symbol.for("react.context"), na = Symbol.for("react.forward_ref"), oa = Symbol.for("react.suspense"), pa = Symbol.for("react.suspense_list"), qa = Symbol.for("react.memo"), ra = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    Symbol.for("react.debug_trace_mode");
    var sa = Symbol.for("react.offscreen");
    Symbol.for("react.legacy_hidden");
    Symbol.for("react.cache");
    Symbol.for("react.tracing_marker");
    var ta = Symbol.iterator;
    function ua(a) {
        if (null === a || "object" !== typeof a) return null;
        a = ta && a[ta] || a["@@iterator"];
        return "function" === typeof a ? a : null;
    }
    function va(a) {
        if (null == a) return null;
        if ("function" === typeof a) return a.displayName || a.name || null;
        if ("string" === typeof a) return a;
        switch(a){
            case ia:
                return "Fragment";
            case ha:
                return "Portal";
            case ka:
                return "Profiler";
            case ja:
                return "StrictMode";
            case oa:
                return "Suspense";
            case pa:
                return "SuspenseList";
        }
        if ("object" === typeof a) switch(a.$$typeof){
            case ma:
                return (a.displayName || "Context") + ".Consumer";
            case la:
                return (a._context.displayName || "Context") + ".Provider";
            case na:
                var b = a.render;
                a = a.displayName;
                a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
                return a;
            case qa:
                return b = a.displayName || null, null !== b ? b : va(a.type) || "Memo";
            case ra:
                b = a._payload;
                a = a._init;
                try {
                    return va(a(b));
                } catch (c) {}
        }
        return null;
    }
    function xa(a) {
        var b = a.type;
        switch(a.tag){
            case 24:
                return "Cache";
            case 9:
                return (b.displayName || "Context") + ".Consumer";
            case 10:
                return (b._context.displayName || "Context") + ".Provider";
            case 18:
                return "DehydratedFragment";
            case 11:
                return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            case 7:
                return "Fragment";
            case 5:
                return b;
            case 4:
                return "Portal";
            case 3:
                return "Root";
            case 6:
                return "Text";
            case 16:
                return va(b);
            case 8:
                return b === ja ? "StrictMode" : "Mode";
            case 22:
                return "Offscreen";
            case 12:
                return "Profiler";
            case 21:
                return "Scope";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 25:
                return "TracingMarker";
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
                if ("function" === typeof b) return b.displayName || b.name || null;
                if ("string" === typeof b) return b;
        }
        return null;
    }
    function ya(a) {
        var b = a, c = a;
        if (a.alternate) for(; b.return;)b = b.return;
        else {
            a = b;
            do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
            while (a);
        }
        return 3 === b.tag ? c : null;
    }
    function za(a) {
        if (ya(a) !== a) throw Error(n(188));
    }
    function Aa(a) {
        var b = a.alternate;
        if (!b) {
            b = ya(a);
            if (null === b) throw Error(n(188));
            return b !== a ? null : a;
        }
        for(var c = a, d = b;;){
            var e = c.return;
            if (null === e) break;
            var f = e.alternate;
            if (null === f) {
                d = e.return;
                if (null !== d) {
                    c = d;
                    continue;
                }
                break;
            }
            if (e.child === f.child) {
                for(f = e.child; f;){
                    if (f === c) return za(e), a;
                    if (f === d) return za(e), b;
                    f = f.sibling;
                }
                throw Error(n(188));
            }
            if (c.return !== d.return) c = e, d = f;
            else {
                for(var g = !1, h = e.child; h;){
                    if (h === c) {
                        g = !0;
                        c = e;
                        d = f;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = e;
                        c = f;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) {
                    for(h = f.child; h;){
                        if (h === c) {
                            g = !0;
                            c = f;
                            d = e;
                            break;
                        }
                        if (h === d) {
                            g = !0;
                            d = f;
                            c = e;
                            break;
                        }
                        h = h.sibling;
                    }
                    if (!g) throw Error(n(189));
                }
            }
            if (c.alternate !== d) throw Error(n(190));
        }
        if (3 !== c.tag) throw Error(n(188));
        return c.stateNode.current === c ? a : b;
    }
    function Ba(a) {
        a = Aa(a);
        return null !== a ? Ca(a) : null;
    }
    function Ca(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            var b = Ca(a);
            if (null !== b) return b;
            a = a.sibling;
        }
        return null;
    }
    function Da(a) {
        if (5 === a.tag || 6 === a.tag) return a;
        for(a = a.child; null !== a;){
            if (4 !== a.tag) {
                var b = Da(a);
                if (null !== b) return b;
            }
            a = a.sibling;
        }
        return null;
    }
    var Ea = Array.isArray, Fa = $$$hostConfig.getPublicInstance, Ga = $$$hostConfig.getRootHostContext, Ha = $$$hostConfig.getChildHostContext, Ia = $$$hostConfig.prepareForCommit, Ja = $$$hostConfig.resetAfterCommit, Ka = $$$hostConfig.createInstance, La = $$$hostConfig.appendInitialChild, Ma = $$$hostConfig.finalizeInitialChildren, Na = $$$hostConfig.prepareUpdate, Oa = $$$hostConfig.shouldSetTextContent, Pa = $$$hostConfig.createTextInstance, Qa = $$$hostConfig.scheduleTimeout, Ra = $$$hostConfig.cancelTimeout, Sa = $$$hostConfig.noTimeout, Ta = $$$hostConfig.isPrimaryRenderer, Ua = $$$hostConfig.supportsMutation, Va = $$$hostConfig.supportsPersistence, p = $$$hostConfig.supportsHydration, Wa = $$$hostConfig.getInstanceFromNode, Xa = $$$hostConfig.preparePortalMount, Ya = $$$hostConfig.getCurrentEventPriority, Za = $$$hostConfig.detachDeletedInstance, $a = $$$hostConfig.supportsMicrotasks, ab = $$$hostConfig.scheduleMicrotask, bb = $$$hostConfig.supportsTestSelectors, cb = $$$hostConfig.findFiberRoot, db = $$$hostConfig.getBoundingRect, eb = $$$hostConfig.getTextContent, fb = $$$hostConfig.isHiddenSubtree, gb = $$$hostConfig.matchAccessibilityRole, hb = $$$hostConfig.setFocusIfFocusable, ib = $$$hostConfig.setupIntersectionObserver, jb = $$$hostConfig.appendChild, kb = $$$hostConfig.appendChildToContainer, lb = $$$hostConfig.commitTextUpdate, mb = $$$hostConfig.commitMount, nb = $$$hostConfig.commitUpdate, ob = $$$hostConfig.insertBefore, pb = $$$hostConfig.insertInContainerBefore, qb = $$$hostConfig.removeChild, rb = $$$hostConfig.removeChildFromContainer, sb = $$$hostConfig.resetTextContent, tb = $$$hostConfig.hideInstance, ub = $$$hostConfig.hideTextInstance, vb = $$$hostConfig.unhideInstance, wb = $$$hostConfig.unhideTextInstance, xb = $$$hostConfig.clearContainer, yb = $$$hostConfig.cloneInstance, zb = $$$hostConfig.createContainerChildSet, Ab = $$$hostConfig.appendChildToContainerChildSet, Bb = $$$hostConfig.finalizeContainerChildren, Cb = $$$hostConfig.replaceContainerChildren, Db = $$$hostConfig.cloneHiddenInstance, Eb = $$$hostConfig.cloneHiddenTextInstance, Fb = $$$hostConfig.canHydrateInstance, Gb = $$$hostConfig.canHydrateTextInstance, Hb = $$$hostConfig.canHydrateSuspenseInstance, Ib = $$$hostConfig.isSuspenseInstancePending, Jb = $$$hostConfig.isSuspenseInstanceFallback, Kb = $$$hostConfig.registerSuspenseInstanceRetry, Lb = $$$hostConfig.getNextHydratableSibling, Mb = $$$hostConfig.getFirstHydratableChild, Nb = $$$hostConfig.getFirstHydratableChildWithinContainer, Ob = $$$hostConfig.getFirstHydratableChildWithinSuspenseInstance, Pb = $$$hostConfig.hydrateInstance, Qb = $$$hostConfig.hydrateTextInstance, Rb = $$$hostConfig.hydrateSuspenseInstance, Sb = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, Tb = $$$hostConfig.commitHydratedContainer, Ub = $$$hostConfig.commitHydratedSuspenseInstance, Vb = $$$hostConfig.clearSuspenseBoundary, Wb = $$$hostConfig.clearSuspenseBoundaryFromContainer, Xb = $$$hostConfig.shouldDeleteUnhydratedTailInstances, Yb = $$$hostConfig.didNotMatchHydratedContainerTextInstance, Zb = $$$hostConfig.didNotMatchHydratedTextInstance, $b;
    function ac(a) {
        if (void 0 === $b) try {
            throw Error();
        } catch (c) {
            var b = c.stack.trim().match(/\n( *(at )?)/);
            $b = b && b[1] || "";
        }
        return "\n" + $b + a;
    }
    var bc = !1;
    function cc(a, b) {
        if (!a || bc) return "";
        bc = !0;
        var c = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            if (b) {
                if (b = function() {
                    throw Error();
                }, Object.defineProperty(b.prototype, "props", {
                    set: function() {
                        throw Error();
                    }
                }), "object" === typeof Reflect && Reflect.construct) {
                    try {
                        Reflect.construct(b, []);
                    } catch (l) {
                        var d = l;
                    }
                    Reflect.construct(a, [], b);
                } else {
                    try {
                        b.call();
                    } catch (l) {
                        d = l;
                    }
                    a.call(b.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (l) {
                    d = l;
                }
                a();
            }
        } catch (l) {
            if (l && d && "string" === typeof l.stack) {
                for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
                for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                    if (1 !== g || 1 !== h) {
                        do if (g--, h--, 0 > h || e[g] !== f[h]) {
                            var k = "\n" + e[g].replace(" at new ", " at ");
                            a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                            return k;
                        }
                        while (1 <= g && 0 <= h);
                    }
                    break;
                }
            }
        } finally{
            bc = !1, Error.prepareStackTrace = c;
        }
        return (a = a ? a.displayName || a.name : "") ? ac(a) : "";
    }
    var dc = Object.prototype.hasOwnProperty, ec = [], fc = -1;
    function gc(a) {
        return {
            current: a
        };
    }
    function x(a) {
        0 > fc || (a.current = ec[fc], ec[fc] = null, fc--);
    }
    function y(a, b) {
        fc++;
        ec[fc] = a.current;
        a.current = b;
    }
    var hc = {}, A = gc(hc), B = gc(!1), ic = hc;
    function jc(a, b) {
        var c = a.type.contextTypes;
        if (!c) return hc;
        var d = a.stateNode;
        if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
        var e = {}, f;
        for(f in c)e[f] = b[f];
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
        return e;
    }
    function C(a) {
        a = a.childContextTypes;
        return null !== a && void 0 !== a;
    }
    function kc() {
        x(B);
        x(A);
    }
    function lc(a, b, c) {
        if (A.current !== hc) throw Error(n(168));
        y(A, b);
        y(B, c);
    }
    function mc(a, b, c) {
        var d = a.stateNode;
        b = b.childContextTypes;
        if ("function" !== typeof d.getChildContext) return c;
        d = d.getChildContext();
        for(var e in d)if (!(e in b)) throw Error(n(108, xa(a) || "Unknown", e));
        return ca({}, c, d);
    }
    function nc(a) {
        a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || hc;
        ic = A.current;
        y(A, a);
        y(B, B.current);
        return !0;
    }
    function oc(a, b, c) {
        var d = a.stateNode;
        if (!d) throw Error(n(169));
        c ? (a = mc(a, b, ic), d.__reactInternalMemoizedMergedChildContext = a, x(B), x(A), y(A, a)) : x(B);
        y(B, c);
    }
    var qc = Math.clz32 ? Math.clz32 : pc, rc = Math.log, sc = Math.LN2;
    function pc(a) {
        a >>>= 0;
        return 0 === a ? 32 : 31 - (rc(a) / sc | 0) | 0;
    }
    var tc = 64, uc = 4194304;
    function vc(a) {
        switch(a & -a){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return a & 4194240;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return a & 130023424;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 1073741824;
            default:
                return a;
        }
    }
    function wc(a, b) {
        var c = a.pendingLanes;
        if (0 === c) return 0;
        var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
        if (0 !== g) {
            var h = g & ~e;
            0 !== h ? d = vc(h) : (f &= g, 0 !== f && (d = vc(f)));
        } else g = c & ~e, 0 !== g ? d = vc(g) : 0 !== f && (d = vc(f));
        if (0 === d) return 0;
        if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
        0 !== (d & 4) && (d |= c & 16);
        b = a.entangledLanes;
        if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - qc(b), e = 1 << c, d |= a[c], b &= ~e;
        return d;
    }
    function xc(a, b) {
        switch(a){
            case 1:
            case 2:
            case 4:
                return b + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return b + 5E3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
                return -1;
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return -1;
        }
    }
    function yc(a, b) {
        for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
            var g = 31 - qc(f), h = 1 << g, k = e[g];
            if (-1 === k) {
                if (0 === (h & c) || 0 !== (h & d)) e[g] = xc(h, b);
            } else k <= b && (a.expiredLanes |= h);
            f &= ~h;
        }
    }
    function zc(a) {
        a = a.pendingLanes & -1073741825;
        return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
    }
    function Ac(a) {
        for(var b = [], c = 0; 31 > c; c++)b.push(a);
        return b;
    }
    function Bc(a, b, c) {
        a.pendingLanes |= b;
        536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
        a = a.eventTimes;
        b = 31 - qc(b);
        a[b] = c;
    }
    function Cc(a, b) {
        var c = a.pendingLanes & ~b;
        a.pendingLanes = b;
        a.suspendedLanes = 0;
        a.pingedLanes = 0;
        a.expiredLanes &= b;
        a.mutableReadLanes &= b;
        a.entangledLanes &= b;
        b = a.entanglements;
        var d = a.eventTimes;
        for(a = a.expirationTimes; 0 < c;){
            var e = 31 - qc(c), f = 1 << e;
            b[e] = 0;
            d[e] = -1;
            a[e] = -1;
            c &= ~f;
        }
    }
    function Dc(a, b) {
        var c = a.entangledLanes |= b;
        for(a = a.entanglements; c;){
            var d = 31 - qc(c), e = 1 << d;
            e & b | a[d] & b && (a[d] |= b);
            c &= ~e;
        }
    }
    var D = 0;
    function Ec(a) {
        a &= -a;
        return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
    }
    var Fc = ba.unstable_scheduleCallback, Gc = ba.unstable_cancelCallback, Hc = ba.unstable_shouldYield, Ic = ba.unstable_requestPaint, E = ba.unstable_now, Jc = ba.unstable_ImmediatePriority, Kc = ba.unstable_UserBlockingPriority, Lc = ba.unstable_NormalPriority, Mc = ba.unstable_IdlePriority, Nc = null, Oc = null;
    function Pc(a) {
        if (Oc && "function" === typeof Oc.onCommitFiberRoot) try {
            Oc.onCommitFiberRoot(Nc, a, void 0, 128 === (a.current.flags & 128));
        } catch (b) {}
    }
    function Qc(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var Rc = "function" === typeof Object.is ? Object.is : Qc, Sc = null, Tc = !1, Uc = !1;
    function Vc(a) {
        null === Sc ? Sc = [
            a
        ] : Sc.push(a);
    }
    function Wc(a) {
        Tc = !0;
        Vc(a);
    }
    function Xc() {
        if (!Uc && null !== Sc) {
            Uc = !0;
            var a = 0, b = D;
            try {
                var c = Sc;
                for(D = 1; a < c.length; a++){
                    var d = c[a];
                    do d = d(!0);
                    while (null !== d);
                }
                Sc = null;
                Tc = !1;
            } catch (e) {
                throw null !== Sc && (Sc = Sc.slice(a + 1)), Fc(Jc, Xc), e;
            } finally{
                D = b, Uc = !1;
            }
        }
        return null;
    }
    var Yc = ea.ReactCurrentBatchConfig;
    function Zc(a, b) {
        if (Rc(a, b)) return !0;
        if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
        var c = Object.keys(a), d = Object.keys(b);
        if (c.length !== d.length) return !1;
        for(d = 0; d < c.length; d++){
            var e = c[d];
            if (!dc.call(b, e) || !Rc(a[e], b[e])) return !1;
        }
        return !0;
    }
    function $c(a) {
        switch(a.tag){
            case 5:
                return ac(a.type);
            case 16:
                return ac("Lazy");
            case 13:
                return ac("Suspense");
            case 19:
                return ac("SuspenseList");
            case 0:
            case 2:
            case 15:
                return a = cc(a.type, !1), a;
            case 11:
                return a = cc(a.type.render, !1), a;
            case 1:
                return a = cc(a.type, !0), a;
            default:
                return "";
        }
    }
    function ad(a, b) {
        if (a && a.defaultProps) {
            b = ca({}, b);
            a = a.defaultProps;
            for(var c in a)void 0 === b[c] && (b[c] = a[c]);
            return b;
        }
        return b;
    }
    var bd = gc(null), cd = null, dd = null, ed = null;
    function fd() {
        ed = dd = cd = null;
    }
    function gd(a, b, c) {
        Ta ? (y(bd, b._currentValue), b._currentValue = c) : (y(bd, b._currentValue2), b._currentValue2 = c);
    }
    function hd(a) {
        var b = bd.current;
        x(bd);
        Ta ? a._currentValue = b : a._currentValue2 = b;
    }
    function id(a, b, c) {
        for(; null !== a;){
            var d = a.alternate;
            (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
            if (a === c) break;
            a = a.return;
        }
    }
    function jd(a, b) {
        cd = a;
        ed = dd = null;
        a = a.dependencies;
        null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (kd = !0), a.firstContext = null);
    }
    function ld(a) {
        var b = Ta ? a._currentValue : a._currentValue2;
        if (ed !== a) {
            if (a = {
                context: a,
                memoizedValue: b,
                next: null
            }, null === dd) {
                if (null === cd) throw Error(n(308));
                dd = a;
                cd.dependencies = {
                    lanes: 0,
                    firstContext: a
                };
            } else dd = dd.next = a;
        }
        return b;
    }
    var md = null, nd = !1;
    function od(a) {
        a.updateQueue = {
            baseState: a.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: 0
            },
            effects: null
        };
    }
    function pd(a, b) {
        a = a.updateQueue;
        b.updateQueue === a && (b.updateQueue = {
            baseState: a.baseState,
            firstBaseUpdate: a.firstBaseUpdate,
            lastBaseUpdate: a.lastBaseUpdate,
            shared: a.shared,
            effects: a.effects
        });
    }
    function qd(a, b) {
        return {
            eventTime: a,
            lane: b,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function rd(a, b) {
        var c = a.updateQueue;
        null !== c && (c = c.shared, null !== F && 0 !== (a.mode & 1) && 0 === (G & 2) ? (a = c.interleaved, null === a ? (b.next = b, null === md ? md = [
            c
        ] : md.push(c)) : (b.next = a.next, a.next = b), c.interleaved = b) : (a = c.pending, null === a ? b.next = b : (b.next = a.next, a.next = b), c.pending = b));
    }
    function sd(a, b, c) {
        b = b.updateQueue;
        if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Dc(a, c);
        }
    }
    function td(a, b) {
        var c = a.updateQueue, d = a.alternate;
        if (null !== d && (d = d.updateQueue, c === d)) {
            var e = null, f = null;
            c = c.firstBaseUpdate;
            if (null !== c) {
                do {
                    var g = {
                        eventTime: c.eventTime,
                        lane: c.lane,
                        tag: c.tag,
                        payload: c.payload,
                        callback: c.callback,
                        next: null
                    };
                    null === f ? e = f = g : f = f.next = g;
                    c = c.next;
                }while (null !== c);
                null === f ? e = f = b : f = f.next = b;
            } else e = f = b;
            c = {
                baseState: d.baseState,
                firstBaseUpdate: e,
                lastBaseUpdate: f,
                shared: d.shared,
                effects: d.effects
            };
            a.updateQueue = c;
            return;
        }
        a = c.lastBaseUpdate;
        null === a ? c.firstBaseUpdate = b : a.next = b;
        c.lastBaseUpdate = b;
    }
    function ud(a, b, c, d) {
        var e = a.updateQueue;
        nd = !1;
        var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
        if (null !== h) {
            e.shared.pending = null;
            var k = h, l = k.next;
            k.next = null;
            null === g ? f = l : g.next = l;
            g = k;
            var m = a.alternate;
            null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
        }
        if (null !== f) {
            var v = e.baseState;
            g = 0;
            m = l = k = null;
            h = f;
            do {
                var r = h.lane, z = h.eventTime;
                if ((d & r) === r) {
                    null !== m && (m = m.next = {
                        eventTime: z,
                        lane: 0,
                        tag: h.tag,
                        payload: h.payload,
                        callback: h.callback,
                        next: null
                    });
                    a: {
                        var q = a, N = h;
                        r = b;
                        z = c;
                        switch(N.tag){
                            case 1:
                                q = N.payload;
                                if ("function" === typeof q) {
                                    v = q.call(z, v, r);
                                    break a;
                                }
                                v = q;
                                break a;
                            case 3:
                                q.flags = q.flags & -65537 | 128;
                            case 0:
                                q = N.payload;
                                r = "function" === typeof q ? q.call(z, v, r) : q;
                                if (null === r || void 0 === r) break a;
                                v = ca({}, v, r);
                                break a;
                            case 2:
                                nd = !0;
                        }
                    }
                    null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                        h
                    ] : r.push(h));
                } else z = {
                    eventTime: z,
                    lane: r,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                }, null === m ? (l = m = z, k = v) : m = m.next = z, g |= r;
                h = h.next;
                if (null === h) {
                    if (h = e.shared.pending, null === h) break;
                    else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
                }
            }while (1);
            null === m && (k = v);
            e.baseState = k;
            e.firstBaseUpdate = l;
            e.lastBaseUpdate = m;
            b = e.shared.interleaved;
            if (null !== b) {
                e = b;
                do g |= e.lane, e = e.next;
                while (e !== b);
            } else null === f && (e.shared.lanes = 0);
            vd |= g;
            a.lanes = g;
            a.memoizedState = v;
        }
    }
    function wd(a, b, c) {
        a = b.effects;
        b.effects = null;
        if (null !== a) for(b = 0; b < a.length; b++){
            var d = a[b], e = d.callback;
            if (null !== e) {
                d.callback = null;
                d = c;
                if ("function" !== typeof e) throw Error(n(191, e));
                e.call(d);
            }
        }
    }
    var xd = (new aa.Component).refs;
    function yd(a, b, c, d) {
        b = a.memoizedState;
        c = c(d, b);
        c = null === c || void 0 === c ? b : ca({}, b, c);
        a.memoizedState = c;
        0 === a.lanes && (a.updateQueue.baseState = c);
    }
    var Bd = {
        isMounted: function(a) {
            return (a = a._reactInternals) ? ya(a) === a : !1;
        },
        enqueueSetState: function(a, b, c) {
            a = a._reactInternals;
            var d = H(), e = zd(a), f = qd(d, e);
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            rd(a, f);
            b = Ad(a, e, d);
            null !== b && sd(b, a, e);
        },
        enqueueReplaceState: function(a, b, c) {
            a = a._reactInternals;
            var d = H(), e = zd(a), f = qd(d, e);
            f.tag = 1;
            f.payload = b;
            void 0 !== c && null !== c && (f.callback = c);
            rd(a, f);
            b = Ad(a, e, d);
            null !== b && sd(b, a, e);
        },
        enqueueForceUpdate: function(a, b) {
            a = a._reactInternals;
            var c = H(), d = zd(a), e = qd(c, d);
            e.tag = 2;
            void 0 !== b && null !== b && (e.callback = b);
            rd(a, e);
            b = Ad(a, d, c);
            null !== b && sd(b, a, d);
        }
    };
    function Cd(a, b, c, d, e, f, g) {
        a = a.stateNode;
        return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Zc(c, d) || !Zc(e, f) : !0;
    }
    function Dd(a, b, c) {
        var d = !1, e = hc;
        var f = b.contextType;
        "object" === typeof f && null !== f ? f = ld(f) : (e = C(b) ? ic : A.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? jc(a, e) : hc);
        b = new b(c, f);
        a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
        b.updater = Bd;
        a.stateNode = b;
        b._reactInternals = a;
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
        return b;
    }
    function Ed(a, b, c, d) {
        a = b.state;
        "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
        "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
        b.state !== a && Bd.enqueueReplaceState(b, b.state, null);
    }
    function Fd(a, b, c, d) {
        var e = a.stateNode;
        e.props = c;
        e.state = a.memoizedState;
        e.refs = xd;
        od(a);
        var f = b.contextType;
        "object" === typeof f && null !== f ? e.context = ld(f) : (f = C(b) ? ic : A.current, e.context = jc(a, f));
        e.state = a.memoizedState;
        f = b.getDerivedStateFromProps;
        "function" === typeof f && (yd(a, b, f, c), e.state = a.memoizedState);
        "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Bd.enqueueReplaceState(e, e.state, null), ud(a, c, e, d), e.state = a.memoizedState);
        "function" === typeof e.componentDidMount && (a.flags |= 4194308);
    }
    var Gd = [], Hd = 0, Id = null, Jd = 0, Kd = [], Ld = 0, Md = null, Nd = 1, Od = "";
    function Pd(a, b) {
        Gd[Hd++] = Jd;
        Gd[Hd++] = Id;
        Id = a;
        Jd = b;
    }
    function Qd(a, b, c) {
        Kd[Ld++] = Nd;
        Kd[Ld++] = Od;
        Kd[Ld++] = Md;
        Md = a;
        var d = Nd;
        a = Od;
        var e = 32 - qc(d) - 1;
        d &= ~(1 << e);
        c += 1;
        var f = 32 - qc(b) + e;
        if (30 < f) {
            var g = e - e % 5;
            f = (d & (1 << g) - 1).toString(32);
            d >>= g;
            e -= g;
            Nd = 1 << 32 - qc(b) + e | c << e | d;
            Od = f + a;
        } else Nd = 1 << f | c << e | d, Od = a;
    }
    function Rd(a) {
        null !== a.return && (Pd(a, 1), Qd(a, 1, 0));
    }
    function Sd(a) {
        for(; a === Id;)Id = Gd[--Hd], Gd[Hd] = null, Jd = Gd[--Hd], Gd[Hd] = null;
        for(; a === Md;)Md = Kd[--Ld], Kd[Ld] = null, Od = Kd[--Ld], Kd[Ld] = null, Nd = Kd[--Ld], Kd[Ld] = null;
    }
    var Td = null, Ud = null, I = !1, Vd = !1, Wd = null;
    function Xd(a, b) {
        var c = Yd(5, null, null, 0);
        c.elementType = "DELETED";
        c.stateNode = b;
        c.return = a;
        b = a.deletions;
        null === b ? (a.deletions = [
            c
        ], a.flags |= 16) : b.push(c);
    }
    function Zd(a, b) {
        switch(a.tag){
            case 5:
                return b = Fb(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, Td = a, Ud = Mb(b), !0) : !1;
            case 6:
                return b = Gb(b, a.pendingProps), null !== b ? (a.stateNode = b, Td = a, Ud = null, !0) : !1;
            case 13:
                b = Hb(b);
                if (null !== b) {
                    var c = null !== Md ? {
                        id: Nd,
                        overflow: Od
                    } : null;
                    a.memoizedState = {
                        dehydrated: b,
                        treeContext: c,
                        retryLane: 1073741824
                    };
                    c = Yd(18, null, null, 0);
                    c.stateNode = b;
                    c.return = a;
                    a.child = c;
                    Td = a;
                    Ud = null;
                    return !0;
                }
                return !1;
            default:
                return !1;
        }
    }
    function $d(a) {
        return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
    }
    function ae(a) {
        if (I) {
            var b = Ud;
            if (b) {
                var c = b;
                if (!Zd(a, b)) {
                    if ($d(a)) throw Error(n(418));
                    b = Lb(c);
                    var d = Td;
                    b && Zd(a, b) ? Xd(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, Td = a);
                }
            } else {
                if ($d(a)) throw Error(n(418));
                a.flags = a.flags & -4097 | 2;
                I = !1;
                Td = a;
            }
        }
    }
    function be(a) {
        for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
        Td = a;
    }
    function ce(a) {
        if (!p || a !== Td) return !1;
        if (!I) return be(a), I = !0, !1;
        if (3 !== a.tag && (5 !== a.tag || Xb(a.type) && !Oa(a.type, a.memoizedProps))) {
            var b = Ud;
            if (b) {
                if ($d(a)) {
                    for(a = Ud; a;)a = Lb(a);
                    throw Error(n(418));
                }
                for(; b;)Xd(a, b), b = Lb(b);
            }
        }
        be(a);
        if (13 === a.tag) {
            if (!p) throw Error(n(316));
            a = a.memoizedState;
            a = null !== a ? a.dehydrated : null;
            if (!a) throw Error(n(317));
            Ud = Sb(a);
        } else Ud = Td ? Lb(a.stateNode) : null;
        return !0;
    }
    function de() {
        p && (Ud = Td = null, Vd = I = !1);
    }
    function ee(a) {
        null === Wd ? Wd = [
            a
        ] : Wd.push(a);
    }
    function fe(a, b, c) {
        a = c.ref;
        if (null !== a && "function" !== typeof a && "object" !== typeof a) {
            if (c._owner) {
                c = c._owner;
                if (c) {
                    if (1 !== c.tag) throw Error(n(309));
                    var d = c.stateNode;
                }
                if (!d) throw Error(n(147, a));
                var e = d, f = "" + a;
                if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
                b = function(a) {
                    var b = e.refs;
                    b === xd && (b = e.refs = {});
                    null === a ? delete b[f] : b[f] = a;
                };
                b._stringRef = f;
                return b;
            }
            if ("string" !== typeof a) throw Error(n(284));
            if (!c._owner) throw Error(n(290, a));
        }
        return a;
    }
    function ge(a, b) {
        a = Object.prototype.toString.call(b);
        throw Error(n(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
    }
    function he(a) {
        var b = a._init;
        return b(a._payload);
    }
    function ie(a) {
        function b(b, c) {
            if (a) {
                var d = b.deletions;
                null === d ? (b.deletions = [
                    c
                ], b.flags |= 16) : d.push(c);
            }
        }
        function c(c, d) {
            if (!a) return null;
            for(; null !== d;)b(c, d), d = d.sibling;
            return null;
        }
        function d(a, b) {
            for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
            return a;
        }
        function e(a, b) {
            a = je(a, b);
            a.index = 0;
            a.sibling = null;
            return a;
        }
        function f(b, c, d) {
            b.index = d;
            if (!a) return b.flags |= 1048576, c;
            d = b.alternate;
            if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
            b.flags |= 2;
            return c;
        }
        function g(b) {
            a && null === b.alternate && (b.flags |= 2);
            return b;
        }
        function h(a, b, c, d) {
            if (null === b || 6 !== b.tag) return b = ke(c, a.mode, d), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function k(a, b, c, d) {
            var f = c.type;
            if (f === ia) return m(a, b, c.props.children, d, c.key);
            if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === ra && he(f) === b.type)) return d = e(b, c.props), d.ref = fe(a, b, c), d.return = a, d;
            d = le(c.type, c.key, c.props, null, a.mode, d);
            d.ref = fe(a, b, c);
            d.return = a;
            return d;
        }
        function l(a, b, c, d) {
            if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = me(c, a.mode, d), b.return = a, b;
            b = e(b, c.children || []);
            b.return = a;
            return b;
        }
        function m(a, b, c, d, f) {
            if (null === b || 7 !== b.tag) return b = ne(c, a.mode, d, f), b.return = a, b;
            b = e(b, c);
            b.return = a;
            return b;
        }
        function v(a, b, c) {
            if ("string" === typeof b && "" !== b || "number" === typeof b) return b = ke("" + b, a.mode, c), b.return = a, b;
            if ("object" === typeof b && null !== b) {
                switch(b.$$typeof){
                    case fa:
                        return c = le(b.type, b.key, b.props, null, a.mode, c), c.ref = fe(a, null, b), c.return = a, c;
                    case ha:
                        return b = me(b, a.mode, c), b.return = a, b;
                    case ra:
                        var d = b._init;
                        return v(a, d(b._payload), c);
                }
                if (Ea(b) || ua(b)) return b = ne(b, a.mode, c, null), b.return = a, b;
                ge(a, b);
            }
            return null;
        }
        function r(a, b, c, d) {
            var e = null !== b ? b.key : null;
            if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
            if ("object" === typeof c && null !== c) {
                switch(c.$$typeof){
                    case fa:
                        return c.key === e ? k(a, b, c, d) : null;
                    case ha:
                        return c.key === e ? l(a, b, c, d) : null;
                    case ra:
                        return e = c._init, r(a, b, e(c._payload), d);
                }
                if (Ea(c) || ua(c)) return null !== e ? null : m(a, b, c, d, null);
                ge(a, c);
            }
            return null;
        }
        function z(a, b, c, d, e) {
            if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
            if ("object" === typeof d && null !== d) {
                switch(d.$$typeof){
                    case fa:
                        return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                    case ha:
                        return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                    case ra:
                        var f = d._init;
                        return z(a, b, c, f(d._payload), e);
                }
                if (Ea(d) || ua(d)) return a = a.get(c) || null, m(b, a, d, e, null);
                ge(b, d);
            }
            return null;
        }
        function q(e, g, h, k) {
            for(var l = null, m = null, w = g, u = g = 0, t = null; null !== w && u < h.length; u++){
                w.index > u ? (t = w, w = null) : t = w.sibling;
                var q = r(e, w, h[u], k);
                if (null === q) {
                    null === w && (w = t);
                    break;
                }
                a && w && null === q.alternate && b(e, w);
                g = f(q, g, u);
                null === m ? l = q : m.sibling = q;
                m = q;
                w = t;
            }
            if (u === h.length) return c(e, w), I && Pd(e, u), l;
            if (null === w) {
                for(; u < h.length; u++)w = v(e, h[u], k), null !== w && (g = f(w, g, u), null === m ? l = w : m.sibling = w, m = w);
                I && Pd(e, u);
                return l;
            }
            for(w = d(e, w); u < h.length; u++)t = z(w, e, u, h[u], k), null !== t && (a && null !== t.alternate && w.delete(null === t.key ? u : t.key), g = f(t, g, u), null === m ? l = t : m.sibling = t, m = t);
            a && w.forEach(function(a) {
                return b(e, a);
            });
            I && Pd(e, u);
            return l;
        }
        function N(e, g, h, k) {
            var l = ua(h);
            if ("function" !== typeof l) throw Error(n(150));
            h = l.call(h);
            if (null == h) throw Error(n(151));
            for(var w = l = null, m = g, u = g = 0, q = null, t = h.next(); null !== m && !t.done; u++, t = h.next()){
                m.index > u ? (q = m, m = null) : q = m.sibling;
                var V = r(e, m, t.value, k);
                if (null === V) {
                    null === m && (m = q);
                    break;
                }
                a && m && null === V.alternate && b(e, m);
                g = f(V, g, u);
                null === w ? l = V : w.sibling = V;
                w = V;
                m = q;
            }
            if (t.done) return c(e, m), I && Pd(e, u), l;
            if (null === m) {
                for(; !t.done; u++, t = h.next())t = v(e, t.value, k), null !== t && (g = f(t, g, u), null === w ? l = t : w.sibling = t, w = t);
                I && Pd(e, u);
                return l;
            }
            for(m = d(e, m); !t.done; u++, t = h.next())t = z(m, e, u, t.value, k), null !== t && (a && null !== t.alternate && m.delete(null === t.key ? u : t.key), g = f(t, g, u), null === w ? l = t : w.sibling = t, w = t);
            a && m.forEach(function(a) {
                return b(e, a);
            });
            I && Pd(e, u);
            return l;
        }
        function da(a, d, f, h) {
            "object" === typeof f && null !== f && f.type === ia && null === f.key && (f = f.props.children);
            if ("object" === typeof f && null !== f) {
                switch(f.$$typeof){
                    case fa:
                        a: {
                            for(var k = f.key, l = d; null !== l;){
                                if (l.key === k) {
                                    k = f.type;
                                    if (k === ia) {
                                        if (7 === l.tag) {
                                            c(a, l.sibling);
                                            d = e(l, f.props.children);
                                            d.return = a;
                                            a = d;
                                            break a;
                                        }
                                    } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === ra && he(k) === l.type) {
                                        c(a, l.sibling);
                                        d = e(l, f.props);
                                        d.ref = fe(a, l, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    c(a, l);
                                    break;
                                } else b(a, l);
                                l = l.sibling;
                            }
                            f.type === ia ? (d = ne(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = le(f.type, f.key, f.props, null, a.mode, h), h.ref = fe(a, d, f), h.return = a, a = h);
                        }
                        return g(a);
                    case ha:
                        a: {
                            for(l = f.key; null !== d;){
                                if (d.key === l) {
                                    if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                        c(a, d.sibling);
                                        d = e(d, f.children || []);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    } else {
                                        c(a, d);
                                        break;
                                    }
                                } else b(a, d);
                                d = d.sibling;
                            }
                            d = me(f, a.mode, h);
                            d.return = a;
                            a = d;
                        }
                        return g(a);
                    case ra:
                        return l = f._init, da(a, d, l(f._payload), h);
                }
                if (Ea(f)) return q(a, d, f, h);
                if (ua(f)) return N(a, d, f, h);
                ge(a, f);
            }
            return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = ke(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
        }
        return da;
    }
    var oe = ie(!0), pe = ie(!1), qe = {}, re = gc(qe), se = gc(qe), te = gc(qe);
    function ue(a) {
        if (a === qe) throw Error(n(174));
        return a;
    }
    function ve(a, b) {
        y(te, b);
        y(se, a);
        y(re, qe);
        a = Ga(b);
        x(re);
        y(re, a);
    }
    function we() {
        x(re);
        x(se);
        x(te);
    }
    function xe(a) {
        var b = ue(te.current), c = ue(re.current);
        b = Ha(c, a.type, b);
        c !== b && (y(se, a), y(re, b));
    }
    function ye(a) {
        se.current === a && (x(re), x(se));
    }
    var J = gc(0);
    function ze(a) {
        for(var b = a; null !== b;){
            if (13 === b.tag) {
                var c = b.memoizedState;
                if (null !== c && (c = c.dehydrated, null === c || Ib(c) || Jb(c))) return b;
            } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
                if (0 !== (b.flags & 128)) return b;
            } else if (null !== b.child) {
                b.child.return = b;
                b = b.child;
                continue;
            }
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
        return null;
    }
    var Ae = [];
    function Be() {
        for(var a = 0; a < Ae.length; a++){
            var b = Ae[a];
            Ta ? b._workInProgressVersionPrimary = null : b._workInProgressVersionSecondary = null;
        }
        Ae.length = 0;
    }
    var Ce = ea.ReactCurrentDispatcher, De = ea.ReactCurrentBatchConfig, Ee = 0, K = null, L = null, M = null, Fe = !1, Ge = !1, He = 0, Ie = 0;
    function O() {
        throw Error(n(321));
    }
    function Je(a, b) {
        if (null === b) return !1;
        for(var c = 0; c < b.length && c < a.length; c++)if (!Rc(a[c], b[c])) return !1;
        return !0;
    }
    function Ke(a, b, c, d, e, f) {
        Ee = f;
        K = b;
        b.memoizedState = null;
        b.updateQueue = null;
        b.lanes = 0;
        Ce.current = null === a || null === a.memoizedState ? Le : Me;
        a = c(d, e);
        if (Ge) {
            f = 0;
            do {
                Ge = !1;
                He = 0;
                if (25 <= f) throw Error(n(301));
                f += 1;
                M = L = null;
                b.updateQueue = null;
                Ce.current = Ne;
                a = c(d, e);
            }while (Ge);
        }
        Ce.current = Oe;
        b = null !== L && null !== L.next;
        Ee = 0;
        M = L = K = null;
        Fe = !1;
        if (b) throw Error(n(300));
        return a;
    }
    function Pe() {
        var a = 0 !== He;
        He = 0;
        return a;
    }
    function Qe() {
        var a = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === M ? K.memoizedState = M = a : M = M.next = a;
        return M;
    }
    function Re() {
        if (null === L) {
            var a = K.alternate;
            a = null !== a ? a.memoizedState : null;
        } else a = L.next;
        var b = null === M ? K.memoizedState : M.next;
        if (null !== b) M = b, L = a;
        else {
            if (null === a) throw Error(n(310));
            L = a;
            a = {
                memoizedState: L.memoizedState,
                baseState: L.baseState,
                baseQueue: L.baseQueue,
                queue: L.queue,
                next: null
            };
            null === M ? K.memoizedState = M = a : M = M.next = a;
        }
        return M;
    }
    function Se(a, b) {
        return "function" === typeof b ? b(a) : b;
    }
    function Te(a) {
        var b = Re(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        var d = L, e = d.baseQueue, f = c.pending;
        if (null !== f) {
            if (null !== e) {
                var g = e.next;
                e.next = f.next;
                f.next = g;
            }
            d.baseQueue = e = f;
            c.pending = null;
        }
        if (null !== e) {
            f = e.next;
            d = d.baseState;
            var h = g = null, k = null, l = f;
            do {
                var m = l.lane;
                if ((Ee & m) === m) null !== k && (k = k.next = {
                    lane: 0,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
                else {
                    var v = {
                        lane: m,
                        action: l.action,
                        hasEagerState: l.hasEagerState,
                        eagerState: l.eagerState,
                        next: null
                    };
                    null === k ? (h = k = v, g = d) : k = k.next = v;
                    K.lanes |= m;
                    vd |= m;
                }
                l = l.next;
            }while (null !== l && l !== f);
            null === k ? g = d : k.next = h;
            Rc(d, b.memoizedState) || (kd = !0);
            b.memoizedState = d;
            b.baseState = g;
            b.baseQueue = k;
            c.lastRenderedState = d;
        }
        a = c.interleaved;
        if (null !== a) {
            e = a;
            do f = e.lane, K.lanes |= f, vd |= f, e = e.next;
            while (e !== a);
        } else null === e && (c.lanes = 0);
        return [
            b.memoizedState,
            c.dispatch
        ];
    }
    function Ue(a) {
        var b = Re(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        var d = c.dispatch, e = c.pending, f = b.memoizedState;
        if (null !== e) {
            c.pending = null;
            var g = e = e.next;
            do f = a(f, g.action), g = g.next;
            while (g !== e);
            Rc(f, b.memoizedState) || (kd = !0);
            b.memoizedState = f;
            null === b.baseQueue && (b.baseState = f);
            c.lastRenderedState = f;
        }
        return [
            f,
            d
        ];
    }
    function Ve() {}
    function We(a, b) {
        var c = K, d = Re(), e = b(), f = !Rc(d.memoizedState, e);
        f && (d.memoizedState = e, kd = !0);
        d = d.queue;
        Xe(Ye.bind(null, c, d, a), [
            a
        ]);
        if (d.getSnapshot !== b || f || null !== M && M.memoizedState.tag & 1) {
            c.flags |= 2048;
            Ze(9, $e.bind(null, c, d, e, b), void 0, null);
            if (null === F) throw Error(n(349));
            0 !== (Ee & 30) || af(c, b, e);
        }
        return e;
    }
    function af(a, b, c) {
        a.flags |= 16384;
        a = {
            getSnapshot: b,
            value: c
        };
        b = K.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, K.updateQueue = b, b.stores = [
            a
        ]) : (c = b.stores, null === c ? b.stores = [
            a
        ] : c.push(a));
    }
    function $e(a, b, c, d) {
        b.value = c;
        b.getSnapshot = d;
        bf(b) && Ad(a, 1, -1);
    }
    function Ye(a, b, c) {
        return c(function() {
            bf(b) && Ad(a, 1, -1);
        });
    }
    function bf(a) {
        var b = a.getSnapshot;
        a = a.value;
        try {
            var c = b();
            return !Rc(a, c);
        } catch (d) {
            return !0;
        }
    }
    function cf(a) {
        var b = Qe();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: Se,
            lastRenderedState: a
        };
        b.queue = a;
        a = a.dispatch = df.bind(null, K, a);
        return [
            b.memoizedState,
            a
        ];
    }
    function Ze(a, b, c, d) {
        a = {
            tag: a,
            create: b,
            destroy: c,
            deps: d,
            next: null
        };
        b = K.updateQueue;
        null === b ? (b = {
            lastEffect: null,
            stores: null
        }, K.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
        return a;
    }
    function ef() {
        return Re().memoizedState;
    }
    function ff(a, b, c, d) {
        var e = Qe();
        K.flags |= a;
        e.memoizedState = Ze(1 | b, c, void 0, void 0 === d ? null : d);
    }
    function gf(a, b, c, d) {
        var e = Re();
        d = void 0 === d ? null : d;
        var f = void 0;
        if (null !== L) {
            var g = L.memoizedState;
            f = g.destroy;
            if (null !== d && Je(d, g.deps)) {
                e.memoizedState = Ze(b, c, f, d);
                return;
            }
        }
        K.flags |= a;
        e.memoizedState = Ze(1 | b, c, f, d);
    }
    function hf(a, b) {
        return ff(8390656, 8, a, b);
    }
    function Xe(a, b) {
        return gf(2048, 8, a, b);
    }
    function jf(a, b) {
        return gf(4, 2, a, b);
    }
    function kf(a, b) {
        return gf(4, 4, a, b);
    }
    function lf(a, b) {
        if ("function" === typeof b) return a = a(), b(a), function() {
            b(null);
        };
        if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
            b.current = null;
        };
    }
    function mf(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return gf(4, 4, lf.bind(null, b, a), c);
    }
    function nf() {}
    function of(a, b) {
        var c = Re();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Je(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function pf(a, b) {
        var c = Re();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Je(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function qf(a, b) {
        var c = D;
        D = 0 !== c && 4 > c ? c : 4;
        a(!0);
        var d = De.transition;
        De.transition = {};
        try {
            a(!1), b();
        } finally{
            D = c, De.transition = d;
        }
    }
    function rf() {
        return Re().memoizedState;
    }
    function sf(a, b, c) {
        var d = zd(a);
        c = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        tf(a) ? uf(b, c) : (vf(a, b, c), c = H(), a = Ad(a, d, c), null !== a && wf(a, b, d));
    }
    function df(a, b, c) {
        var d = zd(a), e = {
            lane: d,
            action: c,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (tf(a)) uf(b, e);
        else {
            vf(a, b, e);
            var f = a.alternate;
            if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
                var g = b.lastRenderedState, h = f(g, c);
                e.hasEagerState = !0;
                e.eagerState = h;
                if (Rc(h, g)) return;
            } catch (k) {} finally{}
            c = H();
            a = Ad(a, d, c);
            null !== a && wf(a, b, d);
        }
    }
    function tf(a) {
        var b = a.alternate;
        return a === K || null !== b && b === K;
    }
    function uf(a, b) {
        Ge = Fe = !0;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
    function vf(a, b, c) {
        null !== F && 0 !== (a.mode & 1) && 0 === (G & 2) ? (a = b.interleaved, null === a ? (c.next = c, null === md ? md = [
            b
        ] : md.push(b)) : (c.next = a.next, a.next = c), b.interleaved = c) : (a = b.pending, null === a ? c.next = c : (c.next = a.next, a.next = c), b.pending = c);
    }
    function wf(a, b, c) {
        if (0 !== (c & 4194240)) {
            var d = b.lanes;
            d &= a.pendingLanes;
            c |= d;
            b.lanes = c;
            Dc(a, c);
        }
    }
    var Oe = {
        readContext: ld,
        useCallback: O,
        useContext: O,
        useEffect: O,
        useImperativeHandle: O,
        useInsertionEffect: O,
        useLayoutEffect: O,
        useMemo: O,
        useReducer: O,
        useRef: O,
        useState: O,
        useDebugValue: O,
        useDeferredValue: O,
        useTransition: O,
        useMutableSource: O,
        useSyncExternalStore: O,
        useId: O,
        unstable_isNewReconciler: !1
    }, Le = {
        readContext: ld,
        useCallback: function(a, b) {
            Qe().memoizedState = [
                a,
                void 0 === b ? null : b
            ];
            return a;
        },
        useContext: ld,
        useEffect: hf,
        useImperativeHandle: function(a, b, c) {
            c = null !== c && void 0 !== c ? c.concat([
                a
            ]) : null;
            return ff(4194308, 4, lf.bind(null, b, a), c);
        },
        useLayoutEffect: function(a, b) {
            return ff(4194308, 4, a, b);
        },
        useInsertionEffect: function(a, b) {
            return ff(4, 2, a, b);
        },
        useMemo: function(a, b) {
            var c = Qe();
            b = void 0 === b ? null : b;
            a = a();
            c.memoizedState = [
                a,
                b
            ];
            return a;
        },
        useReducer: function(a, b, c) {
            var d = Qe();
            b = void 0 !== c ? c(b) : b;
            d.memoizedState = d.baseState = b;
            a = {
                pending: null,
                interleaved: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: a,
                lastRenderedState: b
            };
            d.queue = a;
            a = a.dispatch = sf.bind(null, K, a);
            return [
                d.memoizedState,
                a
            ];
        },
        useRef: function(a) {
            var b = Qe();
            a = {
                current: a
            };
            return b.memoizedState = a;
        },
        useState: cf,
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = cf(a), c = b[0], d = b[1];
            hf(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = cf(!1), b = a[0];
            a = qf.bind(null, a[1]);
            Qe().memoizedState = a;
            return [
                b,
                a
            ];
        },
        useMutableSource: function() {},
        useSyncExternalStore: function(a, b, c) {
            var d = K, e = Qe();
            if (I) {
                if (void 0 === c) throw Error(n(407));
                c = c();
            } else {
                c = b();
                if (null === F) throw Error(n(349));
                0 !== (Ee & 30) || af(d, b, c);
            }
            e.memoizedState = c;
            var f = {
                value: c,
                getSnapshot: b
            };
            e.queue = f;
            hf(Ye.bind(null, d, f, a), [
                a
            ]);
            d.flags |= 2048;
            Ze(9, $e.bind(null, d, f, c, b), void 0, null);
            return c;
        },
        useId: function() {
            var a = Qe(), b = F.identifierPrefix;
            if (I) {
                var c = Od;
                var d = Nd;
                c = (d & ~(1 << 32 - qc(d) - 1)).toString(32) + c;
                b = ":" + b + "R" + c;
                c = He++;
                0 < c && (b += "H" + c.toString(32));
                b += ":";
            } else c = Ie++, b = ":" + b + "r" + c.toString(32) + ":";
            return a.memoizedState = b;
        },
        unstable_isNewReconciler: !1
    }, Me = {
        readContext: ld,
        useCallback: of,
        useContext: ld,
        useEffect: Xe,
        useImperativeHandle: mf,
        useInsertionEffect: jf,
        useLayoutEffect: kf,
        useMemo: pf,
        useReducer: Te,
        useRef: ef,
        useState: function() {
            return Te(Se);
        },
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = Te(Se), c = b[0], d = b[1];
            Xe(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = Te(Se)[0], b = Re().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: Ve,
        useSyncExternalStore: We,
        useId: rf,
        unstable_isNewReconciler: !1
    }, Ne = {
        readContext: ld,
        useCallback: of,
        useContext: ld,
        useEffect: Xe,
        useImperativeHandle: mf,
        useInsertionEffect: jf,
        useLayoutEffect: kf,
        useMemo: pf,
        useReducer: Ue,
        useRef: ef,
        useState: function() {
            return Ue(Se);
        },
        useDebugValue: nf,
        useDeferredValue: function(a) {
            var b = Ue(Se), c = b[0], d = b[1];
            Xe(function() {
                var b = De.transition;
                De.transition = {};
                try {
                    d(a);
                } finally{
                    De.transition = b;
                }
            }, [
                a
            ]);
            return c;
        },
        useTransition: function() {
            var a = Ue(Se)[0], b = Re().memoizedState;
            return [
                a,
                b
            ];
        },
        useMutableSource: Ve,
        useSyncExternalStore: We,
        useId: rf,
        unstable_isNewReconciler: !1
    };
    function xf(a, b) {
        try {
            var c = "", d = b;
            do c += $c(d), d = d.return;
            while (d);
            var e = c;
        } catch (f) {
            e = "\nError generating stack: " + f.message + "\n" + f.stack;
        }
        return {
            value: a,
            source: b,
            stack: e
        };
    }
    function yf(a, b) {
        try {
            console.error(b.value);
        } catch (c) {
            setTimeout(function() {
                throw c;
            });
        }
    }
    var zf = "function" === typeof WeakMap ? WeakMap : Map;
    function Af(a, b, c) {
        c = qd(-1, c);
        c.tag = 3;
        c.payload = {
            element: null
        };
        var d = b.value;
        c.callback = function() {
            Bf || (Bf = !0, Cf = d);
            yf(a, b);
        };
        return c;
    }
    function Df(a, b, c) {
        c = qd(-1, c);
        c.tag = 3;
        var d = a.type.getDerivedStateFromError;
        if ("function" === typeof d) {
            var e = b.value;
            c.payload = function() {
                return d(e);
            };
            c.callback = function() {
                yf(a, b);
            };
        }
        var f = a.stateNode;
        null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
            yf(a, b);
            "function" !== typeof d && (null === Ef ? Ef = new Set([
                this
            ]) : Ef.add(this));
            var c = b.stack;
            this.componentDidCatch(b.value, {
                componentStack: null !== c ? c : ""
            });
        });
        return c;
    }
    function Ff(a, b, c) {
        var d = a.pingCache;
        if (null === d) {
            d = a.pingCache = new zf;
            var e = new Set;
            d.set(b, e);
        } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
        e.has(c) || (e.add(c), a = Gf.bind(null, a, b, c), b.then(a, a));
    }
    function Hf(a) {
        do {
            var b;
            if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
            if (b) return a;
            a = a.return;
        }while (null !== a);
        return null;
    }
    function If(a, b, c, d, e) {
        if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = qd(-1, 1), b.tag = 2, rd(c, b))), c.lanes |= 1), a;
        a.flags |= 65536;
        a.lanes = e;
        return a;
    }
    function Jf(a) {
        a.flags |= 4;
    }
    function Kf(a, b) {
        if (null !== a && a.child === b.child) return !0;
        if (0 !== (b.flags & 16)) return !1;
        for(a = b.child; null !== a;){
            if (0 !== (a.flags & 12854) || 0 !== (a.subtreeFlags & 12854)) return !1;
            a = a.sibling;
        }
        return !0;
    }
    var Lf, Mf, Nf, Of;
    if (Ua) Lf = function(a, b) {
        for(var c = b.child; null !== c;){
            if (5 === c.tag || 6 === c.tag) La(a, c.stateNode);
            else if (4 !== c.tag && null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }, Mf = function() {}, Nf = function(a, b, c, d, e) {
        a = a.memoizedProps;
        if (a !== d) {
            var f = b.stateNode, g = ue(re.current);
            c = Na(f, c, a, d, e, g);
            (b.updateQueue = c) && Jf(b);
        }
    }, Of = function(a, b, c, d) {
        c !== d && Jf(b);
    };
    else if (Va) {
        Lf = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Db(f, e.type, e.memoizedProps, e));
                    La(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Eb(f, e.memoizedProps, e)), La(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), Lf(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        var Pf = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = Db(f, e.type, e.memoizedProps, e));
                    Ab(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = Eb(f, e.memoizedProps, e)), Ab(a, f);
                else if (4 !== e.tag) {
                    if (22 === e.tag && null !== e.memoizedState) f = e.child, null !== f && (f.return = e), Pf(a, e, !0, !0);
                    else if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        Mf = function(a, b) {
            var c = b.stateNode;
            if (!Kf(a, b)) {
                a = c.containerInfo;
                var d = zb(a);
                Pf(d, b, !1, !1);
                c.pendingChildren = d;
                Jf(b);
                Bb(a, d);
            }
        };
        Nf = function(a, b, c, d, e) {
            var f = a.stateNode, g = a.memoizedProps;
            if ((a = Kf(a, b)) && g === d) b.stateNode = f;
            else {
                var h = b.stateNode, k = ue(re.current), l = null;
                g !== d && (l = Na(h, c, g, d, e, k));
                a && null === l ? b.stateNode = f : (f = yb(f, l, c, g, d, b, a, h), Ma(f, c, d, e, k) && Jf(b), b.stateNode = f, a ? Jf(b) : Lf(f, b, !1, !1));
            }
        };
        Of = function(a, b, c, d) {
            c !== d ? (a = ue(te.current), c = ue(re.current), b.stateNode = Pa(d, a, c, b), Jf(b)) : b.stateNode = a.stateNode;
        };
    } else Mf = function() {}, Nf = function() {}, Of = function() {};
    function Qf(a, b) {
        if (!I) switch(a.tailMode){
            case "hidden":
                b = a.tail;
                for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
                null === c ? a.tail = null : c.sibling = null;
                break;
            case "collapsed":
                c = a.tail;
                for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
                null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
        }
    }
    function P(a) {
        var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
        if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
        else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
        a.subtreeFlags |= d;
        a.childLanes = c;
        return b;
    }
    function Rf(a, b, c) {
        var d = b.pendingProps;
        Sd(b);
        switch(b.tag){
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return P(b), null;
            case 1:
                return C(b.type) && kc(), P(b), null;
            case 3:
                d = b.stateNode;
                we();
                x(B);
                x(A);
                Be();
                d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
                if (null === a || null === a.child) ce(b) ? Jf(b) : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== Wd && (Sf(Wd), Wd = null));
                Mf(a, b);
                P(b);
                return null;
            case 5:
                ye(b);
                c = ue(te.current);
                var e = b.type;
                if (null !== a && null != b.stateNode) Nf(a, b, e, d, c), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                else {
                    if (!d) {
                        if (null === b.stateNode) throw Error(n(166));
                        P(b);
                        return null;
                    }
                    a = ue(re.current);
                    if (ce(b)) {
                        if (!p) throw Error(n(175));
                        a = Pb(b.stateNode, b.type, b.memoizedProps, c, a, b, !Vd);
                        b.updateQueue = a;
                        null !== a && Jf(b);
                    } else {
                        var f = Ka(e, d, c, a, b);
                        Lf(f, b, !1, !1);
                        b.stateNode = f;
                        Ma(f, e, d, c, a) && Jf(b);
                    }
                    null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
                }
                P(b);
                return null;
            case 6:
                if (a && null != b.stateNode) Of(a, b, a.memoizedProps, d);
                else {
                    if ("string" !== typeof d && null === b.stateNode) throw Error(n(166));
                    a = ue(te.current);
                    c = ue(re.current);
                    if (ce(b)) {
                        if (!p) throw Error(n(176));
                        a = b.stateNode;
                        d = b.memoizedProps;
                        if (c = Qb(a, d, b, !Vd)) {
                            if (e = Td, null !== e) switch(f = 0 !== (e.mode & 1), e.tag){
                                case 3:
                                    Yb(e.stateNode.containerInfo, a, d, f);
                                    break;
                                case 5:
                                    Zb(e.type, e.memoizedProps, e.stateNode, a, d, f);
                            }
                        }
                        c && Jf(b);
                    } else b.stateNode = Pa(d, a, c, b);
                }
                P(b);
                return null;
            case 13:
                x(J);
                d = b.memoizedState;
                if (I && null !== Ud && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) {
                    for(a = Ud; a;)a = Lb(a);
                    de();
                    b.flags |= 98560;
                    return b;
                }
                if (null !== d && null !== d.dehydrated) {
                    d = ce(b);
                    if (null === a) {
                        if (!d) throw Error(n(318));
                        if (!p) throw Error(n(344));
                        a = b.memoizedState;
                        a = null !== a ? a.dehydrated : null;
                        if (!a) throw Error(n(317));
                        Rb(a, b);
                    } else de(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    P(b);
                    return null;
                }
                null !== Wd && (Sf(Wd), Wd = null);
                if (0 !== (b.flags & 128)) return b.lanes = c, b;
                d = null !== d;
                c = !1;
                null === a ? ce(b) : c = null !== a.memoizedState;
                d && !c && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (J.current & 1) ? 0 === Q && (Q = 3) : Tf()));
                null !== b.updateQueue && (b.flags |= 4);
                P(b);
                return null;
            case 4:
                return we(), Mf(a, b), null === a && Xa(b.stateNode.containerInfo), P(b), null;
            case 10:
                return hd(b.type._context), P(b), null;
            case 17:
                return C(b.type) && kc(), P(b), null;
            case 19:
                x(J);
                e = b.memoizedState;
                if (null === e) return P(b), null;
                d = 0 !== (b.flags & 128);
                f = e.rendering;
                if (null === f) {
                    if (d) Qf(e, !1);
                    else {
                        if (0 !== Q || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                            f = ze(a);
                            if (null !== f) {
                                b.flags |= 128;
                                Qf(e, !1);
                                a = f.updateQueue;
                                null !== a && (b.updateQueue = a, b.flags |= 4);
                                b.subtreeFlags = 0;
                                a = c;
                                for(d = b.child; null !== d;)c = d, e = a, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = e, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, e = f.dependencies, c.dependencies = null === e ? null : {
                                    lanes: e.lanes,
                                    firstContext: e.firstContext
                                }), d = d.sibling;
                                y(J, J.current & 1 | 2);
                                return b.child;
                            }
                            a = a.sibling;
                        }
                        null !== e.tail && E() > Uf && (b.flags |= 128, d = !0, Qf(e, !1), b.lanes = 4194304);
                    }
                } else {
                    if (!d) {
                        if (a = ze(f), null !== a) {
                            if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), Qf(e, !0), null === e.tail && "hidden" === e.tailMode && !f.alternate && !I) return P(b), null;
                        } else 2 * E() - e.renderingStartTime > Uf && 1073741824 !== c && (b.flags |= 128, d = !0, Qf(e, !1), b.lanes = 4194304);
                    }
                    e.isBackwards ? (f.sibling = b.child, b.child = f) : (a = e.last, null !== a ? a.sibling = f : b.child = f, e.last = f);
                }
                if (null !== e.tail) return b = e.tail, e.rendering = b, e.tail = b.sibling, e.renderingStartTime = E(), b.sibling = null, a = J.current, y(J, d ? a & 1 | 2 : a & 1), b;
                P(b);
                return null;
            case 22:
            case 23:
                return Vf(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (Wf & 1073741824) && (P(b), Ua && b.subtreeFlags & 6 && (b.flags |= 8192)) : P(b), null;
            case 24:
                return null;
            case 25:
                return null;
        }
        throw Error(n(156, b.tag));
    }
    var Xf = ea.ReactCurrentOwner, kd = !1;
    function R(a, b, c, d) {
        b.child = null === a ? pe(b, null, c, d) : oe(b, a.child, c, d);
    }
    function Yf(a, b, c, d, e) {
        c = c.render;
        var f = b.ref;
        jd(b, e);
        d = Ke(a, b, c, d, f, e);
        c = Pe();
        if (null !== a && !kd) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zf(a, b, e);
        I && c && Rd(b);
        b.flags |= 1;
        R(a, b, d, e);
        return b.child;
    }
    function $f(a, b, c, d, e) {
        if (null === a) {
            var f = c.type;
            if ("function" === typeof f && !ag(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bg(a, b, f, d, e);
            a = le(c.type, null, d, b, b.mode, e);
            a.ref = b.ref;
            a.return = b;
            return b.child = a;
        }
        f = a.child;
        if (0 === (a.lanes & e)) {
            var g = f.memoizedProps;
            c = c.compare;
            c = null !== c ? c : Zc;
            if (c(g, d) && a.ref === b.ref) return Zf(a, b, e);
        }
        b.flags |= 1;
        a = je(f, d);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    function bg(a, b, c, d, e) {
        if (null !== a && Zc(a.memoizedProps, d) && a.ref === b.ref) {
            if (kd = !1, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (kd = !0);
            else return b.lanes = a.lanes, Zf(a, b, e);
        }
        return cg(a, b, c, d, e);
    }
    function dg(a, b, c) {
        var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
        if ("hidden" === d.mode) {
            if (0 === (b.mode & 1)) b.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, y(eg, Wf), Wf |= c;
            else if (0 !== (c & 1073741824)) b.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, d = null !== f ? f.baseLanes : c, y(eg, Wf), Wf |= d;
            else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null
            }, b.updateQueue = null, y(eg, Wf), Wf |= a, null;
        } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, y(eg, Wf), Wf |= d;
        R(a, b, e, c);
        return b.child;
    }
    function fg(a, b) {
        var c = b.ref;
        if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
    }
    function cg(a, b, c, d, e) {
        var f = C(c) ? ic : A.current;
        f = jc(b, f);
        jd(b, e);
        c = Ke(a, b, c, d, f, e);
        d = Pe();
        if (null !== a && !kd) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zf(a, b, e);
        I && d && Rd(b);
        b.flags |= 1;
        R(a, b, c, e);
        return b.child;
    }
    function gg(a, b, c, d, e) {
        if (C(c)) {
            var f = !0;
            nc(b);
        } else f = !1;
        jd(b, e);
        if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Dd(b, c, d), Fd(b, c, d, e), d = !0;
        else if (null === a) {
            var g = b.stateNode, h = b.memoizedProps;
            g.props = h;
            var k = g.context, l = c.contextType;
            "object" === typeof l && null !== l ? l = ld(l) : (l = C(c) ? ic : A.current, l = jc(b, l));
            var m = c.getDerivedStateFromProps, v = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
            v || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ed(b, g, d, l);
            nd = !1;
            var r = b.memoizedState;
            g.state = r;
            ud(b, d, g, e);
            k = b.memoizedState;
            h !== d || r !== k || B.current || nd ? ("function" === typeof m && (yd(b, c, m, d), k = b.memoizedState), (h = nd || Cd(b, c, h, d, r, k, l)) ? (v || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
        } else {
            g = b.stateNode;
            pd(a, b);
            h = b.memoizedProps;
            l = b.type === b.elementType ? h : ad(b.type, h);
            g.props = l;
            v = b.pendingProps;
            r = g.context;
            k = c.contextType;
            "object" === typeof k && null !== k ? k = ld(k) : (k = C(c) ? ic : A.current, k = jc(b, k));
            var z = c.getDerivedStateFromProps;
            (m = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== v || r !== k) && Ed(b, g, d, k);
            nd = !1;
            r = b.memoizedState;
            g.state = r;
            ud(b, d, g, e);
            var q = b.memoizedState;
            h !== v || r !== q || B.current || nd ? ("function" === typeof z && (yd(b, c, z, d), q = b.memoizedState), (l = nd || Cd(b, c, l, d, r, q, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, q, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, q, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = q), g.props = d, g.state = q, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
        }
        return hg(a, b, c, d, f, e);
    }
    function hg(a, b, c, d, e, f) {
        fg(a, b);
        var g = 0 !== (b.flags & 128);
        if (!d && !g) return e && oc(b, c, !1), Zf(a, b, f);
        d = b.stateNode;
        Xf.current = b;
        var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
        b.flags |= 1;
        null !== a && g ? (b.child = oe(b, a.child, null, f), b.child = oe(b, null, h, f)) : R(a, b, h, f);
        b.memoizedState = d.state;
        e && oc(b, c, !0);
        return b.child;
    }
    function ig(a) {
        var b = a.stateNode;
        b.pendingContext ? lc(a, b.pendingContext, b.pendingContext !== b.context) : b.context && lc(a, b.context, !1);
        ve(a, b.containerInfo);
    }
    function jg(a, b, c, d, e) {
        de();
        ee(e);
        b.flags |= 256;
        R(a, b, c, d);
        return b.child;
    }
    var kg = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0
    };
    function lg(a) {
        return {
            baseLanes: a,
            cachePool: null
        };
    }
    function mg(a, b, c) {
        var d = b.pendingProps, e = J.current, f = !1, g = 0 !== (b.flags & 128), h;
        (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
        if (h) f = !0, b.flags &= -129;
        else if (null === a || null !== a.memoizedState) e |= 1;
        y(J, e & 1);
        if (null === a) {
            ae(b);
            a = b.memoizedState;
            if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : Jb(a) ? b.lanes = 8 : b.lanes = 1073741824, null;
            e = d.children;
            a = d.fallback;
            return f ? (d = b.mode, f = b.child, e = {
                mode: "hidden",
                children: e
            }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = e) : f = ng(e, d, 0, null), a = ne(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = lg(c), b.memoizedState = kg, a) : og(b, e);
        }
        e = a.memoizedState;
        if (null !== e) {
            h = e.dehydrated;
            if (null !== h) {
                if (g) {
                    if (b.flags & 256) return b.flags &= -257, pg(a, b, c, Error(n(422)));
                    if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
                    f = d.fallback;
                    e = b.mode;
                    d = ng({
                        mode: "visible",
                        children: d.children
                    }, e, 0, null);
                    f = ne(f, e, c, null);
                    f.flags |= 2;
                    d.return = b;
                    f.return = b;
                    d.sibling = f;
                    b.child = d;
                    0 !== (b.mode & 1) && oe(b, a.child, null, c);
                    b.child.memoizedState = lg(c);
                    b.memoizedState = kg;
                    return f;
                }
                if (0 === (b.mode & 1)) b = pg(a, b, c, null);
                else if (Jb(h)) b = pg(a, b, c, Error(n(419)));
                else if (d = 0 !== (c & a.childLanes), kd || d) {
                    d = F;
                    if (null !== d) {
                        switch(c & -c){
                            case 4:
                                f = 2;
                                break;
                            case 16:
                                f = 8;
                                break;
                            case 64:
                            case 128:
                            case 256:
                            case 512:
                            case 1024:
                            case 2048:
                            case 4096:
                            case 8192:
                            case 16384:
                            case 32768:
                            case 65536:
                            case 131072:
                            case 262144:
                            case 524288:
                            case 1048576:
                            case 2097152:
                            case 4194304:
                            case 8388608:
                            case 16777216:
                            case 33554432:
                            case 67108864:
                                f = 32;
                                break;
                            case 536870912:
                                f = 268435456;
                                break;
                            default:
                                f = 0;
                        }
                        d = 0 !== (f & (d.suspendedLanes | c)) ? 0 : f;
                        0 !== d && d !== e.retryLane && (e.retryLane = d, Ad(a, d, -1));
                    }
                    Tf();
                    b = pg(a, b, c, Error(n(421)));
                } else Ib(h) ? (b.flags |= 128, b.child = a.child, b = qg.bind(null, a), Kb(h, b), b = null) : (c = e.treeContext, p && (Ud = Ob(h), Td = b, I = !0, Wd = null, Vd = !1, null !== c && (Kd[Ld++] = Nd, Kd[Ld++] = Od, Kd[Ld++] = Md, Nd = c.id, Od = c.overflow, Md = b)), b = og(b, b.pendingProps.children), b.flags |= 4096);
                return b;
            }
            if (f) return d = rg(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? lg(c) : {
                baseLanes: e.baseLanes | c,
                cachePool: null
            }, f.childLanes = a.childLanes & ~c, b.memoizedState = kg, d;
            c = sg(a, b, d.children, c);
            b.memoizedState = null;
            return c;
        }
        if (f) return d = rg(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? lg(c) : {
            baseLanes: e.baseLanes | c,
            cachePool: null
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = kg, d;
        c = sg(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    function og(a, b) {
        b = ng({
            mode: "visible",
            children: b
        }, a.mode, 0, null);
        b.return = a;
        return a.child = b;
    }
    function sg(a, b, c, d) {
        var e = a.child;
        a = e.sibling;
        c = je(e, {
            mode: "visible",
            children: c
        });
        0 === (b.mode & 1) && (c.lanes = d);
        c.return = b;
        c.sibling = null;
        null !== a && (d = b.deletions, null === d ? (b.deletions = [
            a
        ], b.flags |= 16) : d.push(a));
        return b.child = c;
    }
    function rg(a, b, c, d, e) {
        var f = b.mode;
        a = a.child;
        var g = a.sibling, h = {
            mode: "hidden",
            children: c
        };
        0 === (f & 1) && b.child !== a ? (c = b.child, c.childLanes = 0, c.pendingProps = h, b.deletions = null) : (c = je(a, h), c.subtreeFlags = a.subtreeFlags & 14680064);
        null !== g ? d = je(g, d) : (d = ne(d, f, e, null), d.flags |= 2);
        d.return = b;
        c.return = b;
        c.sibling = d;
        b.child = c;
        return d;
    }
    function pg(a, b, c, d) {
        null !== d && ee(d);
        oe(b, a.child, null, c);
        a = og(b, b.pendingProps.children);
        a.flags |= 2;
        b.memoizedState = null;
        return a;
    }
    function tg(a, b, c) {
        a.lanes |= b;
        var d = a.alternate;
        null !== d && (d.lanes |= b);
        id(a.return, b, c);
    }
    function ug(a, b, c, d, e) {
        var f = a.memoizedState;
        null === f ? a.memoizedState = {
            isBackwards: b,
            rendering: null,
            renderingStartTime: 0,
            last: d,
            tail: c,
            tailMode: e
        } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
    }
    function vg(a, b, c) {
        var d = b.pendingProps, e = d.revealOrder, f = d.tail;
        R(a, b, d.children, c);
        d = J.current;
        if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
        else {
            if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
                if (13 === a.tag) null !== a.memoizedState && tg(a, c, b);
                else if (19 === a.tag) tg(a, c, b);
                else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === b) break a;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === b) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            d &= 1;
        }
        y(J, d);
        if (0 === (b.mode & 1)) b.memoizedState = null;
        else switch(e){
            case "forwards":
                c = b.child;
                for(e = null; null !== c;)a = c.alternate, null !== a && null === ze(a) && (e = c), c = c.sibling;
                c = e;
                null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
                ug(b, !1, e, c, f);
                break;
            case "backwards":
                c = null;
                e = b.child;
                for(b.child = null; null !== e;){
                    a = e.alternate;
                    if (null !== a && null === ze(a)) {
                        b.child = e;
                        break;
                    }
                    a = e.sibling;
                    e.sibling = c;
                    c = e;
                    e = a;
                }
                ug(b, !0, c, null, f);
                break;
            case "together":
                ug(b, !1, null, null, void 0);
                break;
            default:
                b.memoizedState = null;
        }
        return b.child;
    }
    function Zf(a, b, c) {
        null !== a && (b.dependencies = a.dependencies);
        vd |= b.lanes;
        if (0 === (c & b.childLanes)) return null;
        if (null !== a && b.child !== a.child) throw Error(n(153));
        if (null !== b.child) {
            a = b.child;
            c = je(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = je(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    function wg(a, b, c) {
        switch(b.tag){
            case 3:
                ig(b);
                de();
                break;
            case 5:
                xe(b);
                break;
            case 1:
                C(b.type) && nc(b);
                break;
            case 4:
                ve(b, b.stateNode.containerInfo);
                break;
            case 10:
                gd(b, b.type._context, b.memoizedProps.value);
                break;
            case 13:
                var d = b.memoizedState;
                if (null !== d) {
                    if (null !== d.dehydrated) return y(J, J.current & 1), b.flags |= 128, null;
                    if (0 !== (c & b.child.childLanes)) return mg(a, b, c);
                    y(J, J.current & 1);
                    a = Zf(a, b, c);
                    return null !== a ? a.sibling : null;
                }
                y(J, J.current & 1);
                break;
            case 19:
                d = 0 !== (c & b.childLanes);
                if (0 !== (a.flags & 128)) {
                    if (d) return vg(a, b, c);
                    b.flags |= 128;
                }
                var e = b.memoizedState;
                null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                y(J, J.current);
                if (d) break;
                else return null;
            case 22:
            case 23:
                return b.lanes = 0, dg(a, b, c);
        }
        return Zf(a, b, c);
    }
    function xg(a, b) {
        Sd(b);
        switch(b.tag){
            case 1:
                return C(b.type) && kc(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 3:
                return we(), x(B), x(A), Be(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
            case 5:
                return ye(b), null;
            case 13:
                x(J);
                a = b.memoizedState;
                if (null !== a && null !== a.dehydrated) {
                    if (null === b.alternate) throw Error(n(340));
                    de();
                }
                a = b.flags;
                return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
            case 19:
                return x(J), null;
            case 4:
                return we(), null;
            case 10:
                return hd(b.type._context), null;
            case 22:
            case 23:
                return Vf(), null;
            case 24:
                return null;
            default:
                return null;
        }
    }
    var yg = !1, zg = !1, Ag = "function" === typeof WeakSet ? WeakSet : Set, S = null;
    function Bg(a, b) {
        var c = a.ref;
        if (null !== c) {
            if ("function" === typeof c) try {
                c(null);
            } catch (d) {
                T(a, b, d);
            }
            else c.current = null;
        }
    }
    function Cg(a, b, c) {
        try {
            c();
        } catch (d) {
            T(a, b, d);
        }
    }
    var Dg = !1;
    function Eg(a, b) {
        Ia(a.containerInfo);
        for(S = b; null !== S;)if (a = S, b = a.child, 0 !== (a.subtreeFlags & 1028) && null !== b) b.return = a, S = b;
        else for(; null !== S;){
            a = S;
            try {
                var c = a.alternate;
                if (0 !== (a.flags & 1024)) switch(a.tag){
                    case 0:
                    case 11:
                    case 15:
                        break;
                    case 1:
                        if (null !== c) {
                            var d = c.memoizedProps, e = c.memoizedState, f = a.stateNode, g = f.getSnapshotBeforeUpdate(a.elementType === a.type ? d : ad(a.type, d), e);
                            f.__reactInternalSnapshotBeforeUpdate = g;
                        }
                        break;
                    case 3:
                        Ua && xb(a.stateNode.containerInfo);
                        break;
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        break;
                    default:
                        throw Error(n(163));
                }
            } catch (h) {
                T(a, a.return, h);
            }
            b = a.sibling;
            if (null !== b) {
                b.return = a.return;
                S = b;
                break;
            }
            S = a.return;
        }
        c = Dg;
        Dg = !1;
        return c;
    }
    function Fg(a, b, c) {
        var d = b.updateQueue;
        d = null !== d ? d.lastEffect : null;
        if (null !== d) {
            var e = d = d.next;
            do {
                if ((e.tag & a) === a) {
                    var f = e.destroy;
                    e.destroy = void 0;
                    void 0 !== f && Cg(b, c, f);
                }
                e = e.next;
            }while (e !== d);
        }
    }
    function Gg(a, b) {
        b = b.updateQueue;
        b = null !== b ? b.lastEffect : null;
        if (null !== b) {
            var c = b = b.next;
            do {
                if ((c.tag & a) === a) {
                    var d = c.create;
                    c.destroy = d();
                }
                c = c.next;
            }while (c !== b);
        }
    }
    function Hg(a) {
        var b = a.ref;
        if (null !== b) {
            var c = a.stateNode;
            switch(a.tag){
                case 5:
                    a = Fa(c);
                    break;
                default:
                    a = c;
            }
            "function" === typeof b ? b(a) : b.current = a;
        }
    }
    function Ig(a, b, c) {
        if (Oc && "function" === typeof Oc.onCommitFiberUnmount) try {
            Oc.onCommitFiberUnmount(Nc, b);
        } catch (g) {}
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                a = b.updateQueue;
                if (null !== a && (a = a.lastEffect, null !== a)) {
                    var d = a = a.next;
                    do {
                        var e = d, f = e.destroy;
                        e = e.tag;
                        void 0 !== f && (0 !== (e & 2) ? Cg(b, c, f) : 0 !== (e & 4) && Cg(b, c, f));
                        d = d.next;
                    }while (d !== a);
                }
                break;
            case 1:
                Bg(b, c);
                a = b.stateNode;
                if ("function" === typeof a.componentWillUnmount) try {
                    a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
                } catch (g) {
                    T(b, c, g);
                }
                break;
            case 5:
                Bg(b, c);
                break;
            case 4:
                Ua ? Jg(a, b, c) : Va && Va && (b = b.stateNode.containerInfo, c = zb(b), Cb(b, c));
        }
    }
    function Kg(a, b, c) {
        for(var d = b;;)if (Ig(a, d, c), null === d.child || Ua && 4 === d.tag) {
            if (d === b) break;
            for(; null === d.sibling;){
                if (null === d.return || d.return === b) return;
                d = d.return;
            }
            d.sibling.return = d.return;
            d = d.sibling;
        } else d.child.return = d, d = d.child;
    }
    function Lg(a) {
        var b = a.alternate;
        null !== b && (a.alternate = null, Lg(b));
        a.child = null;
        a.deletions = null;
        a.sibling = null;
        5 === a.tag && (b = a.stateNode, null !== b && Za(b));
        a.stateNode = null;
        a.return = null;
        a.dependencies = null;
        a.memoizedProps = null;
        a.memoizedState = null;
        a.pendingProps = null;
        a.stateNode = null;
        a.updateQueue = null;
    }
    function Mg(a) {
        return 5 === a.tag || 3 === a.tag || 4 === a.tag;
    }
    function Ng(a) {
        a: for(;;){
            for(; null === a.sibling;){
                if (null === a.return || Mg(a.return)) return null;
                a = a.return;
            }
            a.sibling.return = a.return;
            for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
                if (a.flags & 2) continue a;
                if (null === a.child || 4 === a.tag) continue a;
                else a.child.return = a, a = a.child;
            }
            if (!(a.flags & 2)) return a.stateNode;
        }
    }
    function Og(a) {
        if (Ua) {
            a: {
                for(var b = a.return; null !== b;){
                    if (Mg(b)) break a;
                    b = b.return;
                }
                throw Error(n(160));
            }
            var c = b;
            switch(c.tag){
                case 5:
                    b = c.stateNode;
                    c.flags & 32 && (sb(b), c.flags &= -33);
                    c = Ng(a);
                    Pg(a, c, b);
                    break;
                case 3:
                case 4:
                    b = c.stateNode.containerInfo;
                    c = Ng(a);
                    Qg(a, c, b);
                    break;
                default:
                    throw Error(n(161));
            }
        }
    }
    function Qg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? pb(c, a, b) : kb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Qg(a, b, c), a = a.sibling; null !== a;)Qg(a, b, c), a = a.sibling;
    }
    function Pg(a, b, c) {
        var d = a.tag;
        if (5 === d || 6 === d) a = a.stateNode, b ? ob(c, a, b) : jb(c, a);
        else if (4 !== d && (a = a.child, null !== a)) for(Pg(a, b, c), a = a.sibling; null !== a;)Pg(a, b, c), a = a.sibling;
    }
    function Jg(a, b, c) {
        for(var d = b, e = !1, f, g;;){
            if (!e) {
                e = d.return;
                a: for(;;){
                    if (null === e) throw Error(n(160));
                    f = e.stateNode;
                    switch(e.tag){
                        case 5:
                            g = !1;
                            break a;
                        case 3:
                            f = f.containerInfo;
                            g = !0;
                            break a;
                        case 4:
                            f = f.containerInfo;
                            g = !0;
                            break a;
                    }
                    e = e.return;
                }
                e = !0;
            }
            if (5 === d.tag || 6 === d.tag) Kg(a, d, c), g ? rb(f, d.stateNode) : qb(f, d.stateNode);
            else if (18 === d.tag) g ? Wb(f, d.stateNode) : Vb(f, d.stateNode);
            else if (4 === d.tag) {
                if (null !== d.child) {
                    f = d.stateNode.containerInfo;
                    g = !0;
                    d.child.return = d;
                    d = d.child;
                    continue;
                }
            } else if (Ig(a, d, c), null !== d.child) {
                d.child.return = d;
                d = d.child;
                continue;
            }
            if (d === b) break;
            for(; null === d.sibling;){
                if (null === d.return || d.return === b) return;
                d = d.return;
                4 === d.tag && (e = !1);
            }
            d.sibling.return = d.return;
            d = d.sibling;
        }
    }
    function Rg(a, b) {
        if (Ua) {
            switch(b.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    Fg(3, b, b.return);
                    Gg(3, b);
                    Fg(5, b, b.return);
                    return;
                case 1:
                    return;
                case 5:
                    var c = b.stateNode;
                    if (null != c) {
                        var d = b.memoizedProps;
                        a = null !== a ? a.memoizedProps : d;
                        var e = b.type, f = b.updateQueue;
                        b.updateQueue = null;
                        null !== f && nb(c, f, e, a, d, b);
                    }
                    return;
                case 6:
                    if (null === b.stateNode) throw Error(n(162));
                    c = b.memoizedProps;
                    lb(b.stateNode, null !== a ? a.memoizedProps : c, c);
                    return;
                case 3:
                    p && null !== a && a.memoizedState.isDehydrated && Tb(b.stateNode.containerInfo);
                    return;
                case 12:
                    return;
                case 13:
                    Sg(b);
                    return;
                case 19:
                    Sg(b);
                    return;
                case 17:
                    return;
            }
            throw Error(n(163));
        }
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                Fg(3, b, b.return);
                Gg(3, b);
                Fg(5, b, b.return);
                return;
            case 12:
                return;
            case 13:
                Sg(b);
                return;
            case 19:
                Sg(b);
                return;
            case 3:
                p && null !== a && a.memoizedState.isDehydrated && Tb(b.stateNode.containerInfo);
                break;
            case 22:
            case 23:
                return;
        }
        a: if (Va) {
            switch(b.tag){
                case 1:
                case 5:
                case 6:
                    break a;
                case 3:
                case 4:
                    b = b.stateNode;
                    Cb(b.containerInfo, b.pendingChildren);
                    break a;
            }
            throw Error(n(163));
        }
    }
    function Sg(a) {
        var b = a.updateQueue;
        if (null !== b) {
            a.updateQueue = null;
            var c = a.stateNode;
            null === c && (c = a.stateNode = new Ag);
            b.forEach(function(b) {
                var d = Tg.bind(null, a, b);
                c.has(b) || (c.add(b), b.then(d, d));
            });
        }
    }
    function Ug(a, b) {
        for(S = b; null !== S;){
            b = S;
            var c = b.deletions;
            if (null !== c) for(var d = 0; d < c.length; d++){
                var e = c[d];
                try {
                    var f = a;
                    Ua ? Jg(f, e, b) : Kg(f, e, b);
                    var g = e.alternate;
                    null !== g && (g.return = null);
                    e.return = null;
                } catch (wa) {
                    T(e, b, wa);
                }
            }
            c = b.child;
            if (0 !== (b.subtreeFlags & 12854) && null !== c) c.return = b, S = c;
            else for(; null !== S;){
                b = S;
                try {
                    var h = b.flags;
                    h & 32 && Ua && sb(b.stateNode);
                    if (h & 512) {
                        var k = b.alternate;
                        if (null !== k) {
                            var l = k.ref;
                            null !== l && ("function" === typeof l ? l(null) : l.current = null);
                        }
                    }
                    if (h & 8192) switch(b.tag){
                        case 13:
                            if (null !== b.memoizedState) {
                                var m = b.alternate;
                                if (null === m || null === m.memoizedState) Vg = E();
                            }
                            break;
                        case 22:
                            var v = null !== b.memoizedState, r = b.alternate, z = null !== r && null !== r.memoizedState;
                            c = b;
                            if (Ua) {
                                a: if (d = c, e = v, f = null, Ua) for(var q = d;;){
                                    if (5 === q.tag) {
                                        if (null === f) {
                                            f = q;
                                            var N = q.stateNode;
                                            e ? tb(N) : vb(q.stateNode, q.memoizedProps);
                                        }
                                    } else if (6 === q.tag) {
                                        if (null === f) {
                                            var da = q.stateNode;
                                            e ? ub(da) : wb(da, q.memoizedProps);
                                        }
                                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === d) && null !== q.child) {
                                        q.child.return = q;
                                        q = q.child;
                                        continue;
                                    }
                                    if (q === d) break;
                                    for(; null === q.sibling;){
                                        if (null === q.return || q.return === d) break a;
                                        f === q && (f = null);
                                        q = q.return;
                                    }
                                    f === q && (f = null);
                                    q.sibling.return = q.return;
                                    q = q.sibling;
                                }
                            }
                            if (v && !z && 0 !== (c.mode & 1)) {
                                S = c;
                                for(var t = c.child; null !== t;){
                                    for(c = S = t; null !== S;){
                                        d = S;
                                        var w = d.child;
                                        switch(d.tag){
                                            case 0:
                                            case 11:
                                            case 14:
                                            case 15:
                                                Fg(4, d, d.return);
                                                break;
                                            case 1:
                                                Bg(d, d.return);
                                                var u = d.stateNode;
                                                if ("function" === typeof u.componentWillUnmount) {
                                                    var V = d.return;
                                                    try {
                                                        u.props = d.memoizedProps, u.state = d.memoizedState, u.componentWillUnmount();
                                                    } catch (wa) {
                                                        T(d, V, wa);
                                                    }
                                                }
                                                break;
                                            case 5:
                                                Bg(d, d.return);
                                                break;
                                            case 22:
                                                if (null !== d.memoizedState) {
                                                    Wg(c);
                                                    continue;
                                                }
                                        }
                                        null !== w ? (w.return = d, S = w) : Wg(c);
                                    }
                                    t = t.sibling;
                                }
                            }
                    }
                    switch(h & 4102){
                        case 2:
                            Og(b);
                            b.flags &= -3;
                            break;
                        case 6:
                            Og(b);
                            b.flags &= -3;
                            Rg(b.alternate, b);
                            break;
                        case 4096:
                            b.flags &= -4097;
                            break;
                        case 4100:
                            b.flags &= -4097;
                            Rg(b.alternate, b);
                            break;
                        case 4:
                            Rg(b.alternate, b);
                    }
                } catch (wa) {
                    T(b, b.return, wa);
                }
                c = b.sibling;
                if (null !== c) {
                    c.return = b.return;
                    S = c;
                    break;
                }
                S = b.return;
            }
        }
    }
    function Xg(a, b, c) {
        S = a;
        Yg(a, b, c);
    }
    function Yg(a, b, c) {
        for(var d = 0 !== (a.mode & 1); null !== S;){
            var e = S, f = e.child;
            if (22 === e.tag && d) {
                var g = null !== e.memoizedState || yg;
                if (!g) {
                    var h = e.alternate, k = null !== h && null !== h.memoizedState || zg;
                    h = yg;
                    var l = zg;
                    yg = g;
                    if ((zg = k) && !l) for(S = e; null !== S;)g = S, k = g.child, 22 === g.tag && null !== g.memoizedState ? Zg(e) : null !== k ? (k.return = g, S = k) : Zg(e);
                    for(; null !== f;)S = f, Yg(f, b, c), f = f.sibling;
                    S = e;
                    yg = h;
                    zg = l;
                }
                $g(a, b, c);
            } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, S = f) : $g(a, b, c);
        }
    }
    function $g(a) {
        for(; null !== S;){
            var b = S;
            if (0 !== (b.flags & 8772)) {
                var c = b.alternate;
                try {
                    if (0 !== (b.flags & 8772)) switch(b.tag){
                        case 0:
                        case 11:
                        case 15:
                            zg || Gg(5, b);
                            break;
                        case 1:
                            var d = b.stateNode;
                            if (b.flags & 4 && !zg) {
                                if (null === c) d.componentDidMount();
                                else {
                                    var e = b.elementType === b.type ? c.memoizedProps : ad(b.type, c.memoizedProps);
                                    d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                                }
                            }
                            var f = b.updateQueue;
                            null !== f && wd(b, f, d);
                            break;
                        case 3:
                            var g = b.updateQueue;
                            if (null !== g) {
                                c = null;
                                if (null !== b.child) switch(b.child.tag){
                                    case 5:
                                        c = Fa(b.child.stateNode);
                                        break;
                                    case 1:
                                        c = b.child.stateNode;
                                }
                                wd(b, g, c);
                            }
                            break;
                        case 5:
                            var h = b.stateNode;
                            null === c && b.flags & 4 && mb(h, b.type, b.memoizedProps, b);
                            break;
                        case 6:
                            break;
                        case 4:
                            break;
                        case 12:
                            break;
                        case 13:
                            if (p && null === b.memoizedState) {
                                var k = b.alternate;
                                if (null !== k) {
                                    var l = k.memoizedState;
                                    if (null !== l) {
                                        var m = l.dehydrated;
                                        null !== m && Ub(m);
                                    }
                                }
                            }
                            break;
                        case 19:
                        case 17:
                        case 21:
                        case 22:
                        case 23:
                            break;
                        default:
                            throw Error(n(163));
                    }
                    zg || b.flags & 512 && Hg(b);
                } catch (v) {
                    T(b, b.return, v);
                }
            }
            if (b === a) {
                S = null;
                break;
            }
            c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                S = c;
                break;
            }
            S = b.return;
        }
    }
    function Wg(a) {
        for(; null !== S;){
            var b = S;
            if (b === a) {
                S = null;
                break;
            }
            var c = b.sibling;
            if (null !== c) {
                c.return = b.return;
                S = c;
                break;
            }
            S = b.return;
        }
    }
    function Zg(a) {
        for(; null !== S;){
            var b = S;
            try {
                switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        var c = b.return;
                        try {
                            Gg(4, b);
                        } catch (k) {
                            T(b, c, k);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if ("function" === typeof d.componentDidMount) {
                            var e = b.return;
                            try {
                                d.componentDidMount();
                            } catch (k) {
                                T(b, e, k);
                            }
                        }
                        var f = b.return;
                        try {
                            Hg(b);
                        } catch (k) {
                            T(b, f, k);
                        }
                        break;
                    case 5:
                        var g = b.return;
                        try {
                            Hg(b);
                        } catch (k) {
                            T(b, g, k);
                        }
                }
            } catch (k) {
                T(b, b.return, k);
            }
            if (b === a) {
                S = null;
                break;
            }
            var h = b.sibling;
            if (null !== h) {
                h.return = b.return;
                S = h;
                break;
            }
            S = b.return;
        }
    }
    var ah = 0, bh = 1, ch = 2, dh = 3, eh = 4;
    if ("function" === typeof Symbol && Symbol.for) {
        var fh = Symbol.for;
        ah = fh("selector.component");
        bh = fh("selector.has_pseudo_class");
        ch = fh("selector.role");
        dh = fh("selector.test_id");
        eh = fh("selector.text");
    }
    function gh(a) {
        var b = Wa(a);
        if (null != b) {
            if ("string" !== typeof b.memoizedProps["data-testname"]) throw Error(n(364));
            return b;
        }
        a = cb(a);
        if (null === a) throw Error(n(362));
        return a.stateNode.current;
    }
    function hh(a, b) {
        switch(b.$$typeof){
            case ah:
                if (a.type === b.value) return !0;
                break;
            case bh:
                a: {
                    b = b.value;
                    a = [
                        a,
                        0
                    ];
                    for(var c = 0; c < a.length;){
                        var d = a[c++], e = a[c++], f = b[e];
                        if (5 !== d.tag || !fb(d)) {
                            for(; null != f && hh(d, f);)e++, f = b[e];
                            if (e === b.length) {
                                b = !0;
                                break a;
                            } else for(d = d.child; null !== d;)a.push(d, e), d = d.sibling;
                        }
                    }
                    b = !1;
                }
                return b;
            case ch:
                if (5 === a.tag && gb(a.stateNode, b.value)) return !0;
                break;
            case eh:
                if (5 === a.tag || 6 === a.tag) {
                    if (a = eb(a), null !== a && 0 <= a.indexOf(b.value)) return !0;
                }
                break;
            case dh:
                if (5 === a.tag && (a = a.memoizedProps["data-testname"], "string" === typeof a && a.toLowerCase() === b.value.toLowerCase())) return !0;
                break;
            default:
                throw Error(n(365));
        }
        return !1;
    }
    function ih(a) {
        switch(a.$$typeof){
            case ah:
                return "<" + (va(a.value) || "Unknown") + ">";
            case bh:
                return ":has(" + (ih(a) || "") + ")";
            case ch:
                return '[role="' + a.value + '"]';
            case eh:
                return '"' + a.value + '"';
            case dh:
                return '[data-testname="' + a.value + '"]';
            default:
                throw Error(n(365));
        }
    }
    function jh(a, b) {
        var c = [];
        a = [
            a,
            0
        ];
        for(var d = 0; d < a.length;){
            var e = a[d++], f = a[d++], g = b[f];
            if (5 !== e.tag || !fb(e)) {
                for(; null != g && hh(e, g);)f++, g = b[f];
                if (f === b.length) c.push(e);
                else for(e = e.child; null !== e;)a.push(e, f), e = e.sibling;
            }
        }
        return c;
    }
    function kh(a, b) {
        if (!bb) throw Error(n(363));
        a = gh(a);
        a = jh(a, b);
        b = [];
        a = Array.from(a);
        for(var c = 0; c < a.length;){
            var d = a[c++];
            if (5 === d.tag) fb(d) || b.push(d.stateNode);
            else for(d = d.child; null !== d;)a.push(d), d = d.sibling;
        }
        return b;
    }
    var lh = Math.ceil, mh = ea.ReactCurrentDispatcher, nh = ea.ReactCurrentOwner, U = ea.ReactCurrentBatchConfig, G = 0, F = null, W = null, X = 0, Wf = 0, eg = gc(0), Q = 0, oh = null, vd = 0, ph = 0, qh = 0, rh = null, Y = null, Vg = 0, Uf = Infinity;
    function sh() {
        Uf = E() + 500;
    }
    var Bf = !1, Cf = null, Ef = null, th = !1, uh = null, vh = 0, wh = 0, xh = null, yh = -1, zh = 0;
    function H() {
        return 0 !== (G & 6) ? E() : -1 !== yh ? yh : yh = E();
    }
    function zd(a) {
        if (0 === (a.mode & 1)) return 1;
        if (0 !== (G & 2) && 0 !== X) return X & -X;
        if (null !== Yc.transition) return 0 === zh && (a = tc, tc <<= 1, 0 === (tc & 4194240) && (tc = 64), zh = a), zh;
        a = D;
        return 0 !== a ? a : Ya();
    }
    function Ad(a, b, c) {
        if (50 < wh) throw wh = 0, xh = null, Error(n(185));
        var d = Ah(a, b);
        if (null === d) return null;
        Bc(d, b, c);
        if (0 === (G & 2) || d !== F) d === F && (0 === (G & 2) && (ph |= b), 4 === Q && Bh(d, X)), Z(d, c), 1 === b && 0 === G && 0 === (a.mode & 1) && (sh(), Tc && Xc());
        return d;
    }
    function Ah(a, b) {
        a.lanes |= b;
        var c = a.alternate;
        null !== c && (c.lanes |= b);
        c = a;
        for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
        return 3 === c.tag ? c.stateNode : null;
    }
    function Z(a, b) {
        var c = a.callbackNode;
        yc(a, b);
        var d = wc(a, a === F ? X : 0);
        if (0 === d) null !== c && Gc(c), a.callbackNode = null, a.callbackPriority = 0;
        else if (b = d & -d, a.callbackPriority !== b) {
            null != c && Gc(c);
            if (1 === b) 0 === a.tag ? Wc(Ch.bind(null, a)) : Vc(Ch.bind(null, a)), $a ? ab(function() {
                0 === G && Xc();
            }) : Fc(Jc, Xc), c = null;
            else {
                switch(Ec(d)){
                    case 1:
                        c = Jc;
                        break;
                    case 4:
                        c = Kc;
                        break;
                    case 16:
                        c = Lc;
                        break;
                    case 536870912:
                        c = Mc;
                        break;
                    default:
                        c = Lc;
                }
                c = Dh(c, Eh.bind(null, a));
            }
            a.callbackPriority = b;
            a.callbackNode = c;
        }
    }
    function Eh(a, b) {
        yh = -1;
        zh = 0;
        if (0 !== (G & 6)) throw Error(n(327));
        var c = a.callbackNode;
        if (Fh() && a.callbackNode !== c) return null;
        var d = wc(a, a === F ? X : 0);
        if (0 === d) return null;
        if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Gh(a, d);
        else {
            b = d;
            var e = G;
            G |= 2;
            var f = Hh();
            if (F !== a || X !== b) sh(), Ih(a, b);
            for(;;)try {
                Jh();
                break;
            } catch (h) {
                Kh(a, h);
            }
            fd();
            mh.current = f;
            G = e;
            null !== W ? b = 0 : (F = null, X = 0, b = Q);
        }
        if (0 !== b) {
            2 === b && (e = zc(a), 0 !== e && (d = e, b = Lh(a, e)));
            if (1 === b) throw c = oh, Ih(a, 0), Bh(a, d), Z(a, E()), c;
            if (6 === b) Bh(a, d);
            else {
                e = a.current.alternate;
                if (0 === (d & 30) && !Mh(e) && (b = Gh(a, d), 2 === b && (f = zc(a), 0 !== f && (d = f, b = Lh(a, f))), 1 === b)) throw c = oh, Ih(a, 0), Bh(a, d), Z(a, E()), c;
                a.finishedWork = e;
                a.finishedLanes = d;
                switch(b){
                    case 0:
                    case 1:
                        throw Error(n(345));
                    case 2:
                        Nh(a, Y);
                        break;
                    case 3:
                        Bh(a, d);
                        if ((d & 130023424) === d && (b = Vg + 500 - E(), 10 < b)) {
                            if (0 !== wc(a, 0)) break;
                            e = a.suspendedLanes;
                            if ((e & d) !== d) {
                                H();
                                a.pingedLanes |= a.suspendedLanes & e;
                                break;
                            }
                            a.timeoutHandle = Qa(Nh.bind(null, a, Y), b);
                            break;
                        }
                        Nh(a, Y);
                        break;
                    case 4:
                        Bh(a, d);
                        if ((d & 4194240) === d) break;
                        b = a.eventTimes;
                        for(e = -1; 0 < d;){
                            var g = 31 - qc(d);
                            f = 1 << g;
                            g = b[g];
                            g > e && (e = g);
                            d &= ~f;
                        }
                        d = e;
                        d = E() - d;
                        d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lh(d / 1960)) - d;
                        if (10 < d) {
                            a.timeoutHandle = Qa(Nh.bind(null, a, Y), d);
                            break;
                        }
                        Nh(a, Y);
                        break;
                    case 5:
                        Nh(a, Y);
                        break;
                    default:
                        throw Error(n(329));
                }
            }
        }
        Z(a, E());
        return a.callbackNode === c ? Eh.bind(null, a) : null;
    }
    function Lh(a, b) {
        var c = rh;
        a.current.memoizedState.isDehydrated && (Ih(a, b).flags |= 256);
        a = Gh(a, b);
        2 !== a && (b = Y, Y = c, null !== b && Sf(b));
        return a;
    }
    function Sf(a) {
        null === Y ? Y = a : Y.push.apply(Y, a);
    }
    function Mh(a) {
        for(var b = a;;){
            if (b.flags & 16384) {
                var c = b.updateQueue;
                if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                    var e = c[d], f = e.getSnapshot;
                    e = e.value;
                    try {
                        if (!Rc(f(), e)) return !1;
                    } catch (g) {
                        return !1;
                    }
                }
            }
            c = b.child;
            if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
            else {
                if (b === a) break;
                for(; null === b.sibling;){
                    if (null === b.return || b.return === a) return !0;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
        return !0;
    }
    function Bh(a, b) {
        b &= ~qh;
        b &= ~ph;
        a.suspendedLanes |= b;
        a.pingedLanes &= ~b;
        for(a = a.expirationTimes; 0 < b;){
            var c = 31 - qc(b), d = 1 << c;
            a[c] = -1;
            b &= ~d;
        }
    }
    function Ch(a) {
        if (0 !== (G & 6)) throw Error(n(327));
        Fh();
        var b = wc(a, 0);
        if (0 === (b & 1)) return Z(a, E()), null;
        var c = Gh(a, b);
        if (0 !== a.tag && 2 === c) {
            var d = zc(a);
            0 !== d && (b = d, c = Lh(a, d));
        }
        if (1 === c) throw c = oh, Ih(a, 0), Bh(a, b), Z(a, E()), c;
        if (6 === c) throw Error(n(345));
        a.finishedWork = a.current.alternate;
        a.finishedLanes = b;
        Nh(a, Y);
        Z(a, E());
        return null;
    }
    function Oh(a) {
        null !== uh && 0 === uh.tag && 0 === (G & 6) && Fh();
        var b = G;
        G |= 1;
        var c = U.transition, d = D;
        try {
            if (U.transition = null, D = 1, a) return a();
        } finally{
            D = d, U.transition = c, G = b, 0 === (G & 6) && Xc();
        }
    }
    function Vf() {
        Wf = eg.current;
        x(eg);
    }
    function Ih(a, b) {
        a.finishedWork = null;
        a.finishedLanes = 0;
        var c = a.timeoutHandle;
        c !== Sa && (a.timeoutHandle = Sa, Ra(c));
        if (null !== W) for(c = W.return; null !== c;){
            var d = c;
            Sd(d);
            switch(d.tag){
                case 1:
                    d = d.type.childContextTypes;
                    null !== d && void 0 !== d && kc();
                    break;
                case 3:
                    we();
                    x(B);
                    x(A);
                    Be();
                    break;
                case 5:
                    ye(d);
                    break;
                case 4:
                    we();
                    break;
                case 13:
                    x(J);
                    break;
                case 19:
                    x(J);
                    break;
                case 10:
                    hd(d.type._context);
                    break;
                case 22:
                case 23:
                    Vf();
            }
            c = c.return;
        }
        F = a;
        W = a = je(a.current, null);
        X = Wf = b;
        Q = 0;
        oh = null;
        qh = ph = vd = 0;
        Y = rh = null;
        if (null !== md) {
            for(b = 0; b < md.length; b++)if (c = md[b], d = c.interleaved, null !== d) {
                c.interleaved = null;
                var e = d.next, f = c.pending;
                if (null !== f) {
                    var g = f.next;
                    f.next = e;
                    d.next = g;
                }
                c.pending = d;
            }
            md = null;
        }
        return a;
    }
    function Kh(a, b) {
        do {
            var c = W;
            try {
                fd();
                Ce.current = Oe;
                if (Fe) {
                    for(var d = K.memoizedState; null !== d;){
                        var e = d.queue;
                        null !== e && (e.pending = null);
                        d = d.next;
                    }
                    Fe = !1;
                }
                Ee = 0;
                M = L = K = null;
                Ge = !1;
                He = 0;
                nh.current = null;
                if (null === c || null === c.return) {
                    Q = 1;
                    oh = b;
                    W = null;
                    break;
                }
                a: {
                    var f = a, g = c.return, h = c, k = b;
                    b = X;
                    h.flags |= 32768;
                    if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                        var l = k, m = h, v = m.tag;
                        if (0 === (m.mode & 1) && (0 === v || 11 === v || 15 === v)) {
                            var r = m.alternate;
                            r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                        }
                        var z = Hf(g);
                        if (null !== z) {
                            z.flags &= -257;
                            If(z, g, h, f, b);
                            z.mode & 1 && Ff(f, l, b);
                            b = z;
                            k = l;
                            var q = b.updateQueue;
                            if (null === q) {
                                var N = new Set;
                                N.add(k);
                                b.updateQueue = N;
                            } else q.add(k);
                            break a;
                        } else {
                            if (0 === (b & 1)) {
                                Ff(f, l, b);
                                Tf();
                                break a;
                            }
                            k = Error(n(426));
                        }
                    } else if (I && h.mode & 1) {
                        var da = Hf(g);
                        if (null !== da) {
                            0 === (da.flags & 65536) && (da.flags |= 256);
                            If(da, g, h, f, b);
                            ee(k);
                            break a;
                        }
                    }
                    f = k;
                    4 !== Q && (Q = 2);
                    null === rh ? rh = [
                        f
                    ] : rh.push(f);
                    k = xf(k, h);
                    h = g;
                    do {
                        switch(h.tag){
                            case 3:
                                h.flags |= 65536;
                                b &= -b;
                                h.lanes |= b;
                                var t = Af(h, k, b);
                                td(h, t);
                                break a;
                            case 1:
                                f = k;
                                var w = h.type, u = h.stateNode;
                                if (0 === (h.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ef || !Ef.has(u)))) {
                                    h.flags |= 65536;
                                    b &= -b;
                                    h.lanes |= b;
                                    var V = Df(h, f, b);
                                    td(h, V);
                                    break a;
                                }
                        }
                        h = h.return;
                    }while (null !== h);
                }
                Ph(c);
            } catch (wa) {
                b = wa;
                W === c && null !== c && (W = c = c.return);
                continue;
            }
            break;
        }while (1);
    }
    function Hh() {
        var a = mh.current;
        mh.current = Oe;
        return null === a ? Oe : a;
    }
    function Tf() {
        if (0 === Q || 3 === Q || 2 === Q) Q = 4;
        null === F || 0 === (vd & 268435455) && 0 === (ph & 268435455) || Bh(F, X);
    }
    function Gh(a, b) {
        var c = G;
        G |= 2;
        var d = Hh();
        F === a && X === b || Ih(a, b);
        for(;;)try {
            Qh();
            break;
        } catch (e) {
            Kh(a, e);
        }
        fd();
        G = c;
        mh.current = d;
        if (null !== W) throw Error(n(261));
        F = null;
        X = 0;
        return Q;
    }
    function Qh() {
        for(; null !== W;)Rh(W);
    }
    function Jh() {
        for(; null !== W && !Hc();)Rh(W);
    }
    function Rh(a) {
        var b = Sh(a.alternate, a, Wf);
        a.memoizedProps = a.pendingProps;
        null === b ? Ph(a) : W = b;
        nh.current = null;
    }
    function Ph(a) {
        var b = a;
        do {
            var c = b.alternate;
            a = b.return;
            if (0 === (b.flags & 32768)) {
                if (c = Rf(c, b, Wf), null !== c) {
                    W = c;
                    return;
                }
            } else {
                c = xg(c, b);
                if (null !== c) {
                    c.flags &= 32767;
                    W = c;
                    return;
                }
                if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
                else {
                    Q = 6;
                    W = null;
                    return;
                }
            }
            b = b.sibling;
            if (null !== b) {
                W = b;
                return;
            }
            W = b = a;
        }while (null !== b);
        0 === Q && (Q = 5);
    }
    function Nh(a, b) {
        var c = D, d = U.transition;
        try {
            U.transition = null, D = 1, Th(a, b, c);
        } finally{
            U.transition = d, D = c;
        }
        return null;
    }
    function Th(a, b, c) {
        do Fh();
        while (null !== uh);
        if (0 !== (G & 6)) throw Error(n(327));
        var d = a.finishedWork, e = a.finishedLanes;
        if (null === d) return null;
        a.finishedWork = null;
        a.finishedLanes = 0;
        if (d === a.current) throw Error(n(177));
        a.callbackNode = null;
        a.callbackPriority = 0;
        var f = d.lanes | d.childLanes;
        Cc(a, f);
        a === F && (W = F = null, X = 0);
        0 === (d.subtreeFlags & 2064) && 0 === (d.flags & 2064) || th || (th = !0, Dh(Lc, function() {
            Fh();
            return null;
        }));
        f = 0 !== (d.flags & 15990);
        if (0 !== (d.subtreeFlags & 15990) || f) {
            f = U.transition;
            U.transition = null;
            var g = D;
            D = 1;
            var h = G;
            G |= 4;
            nh.current = null;
            Eg(a, d);
            Ug(a, d, e);
            Ja(a.containerInfo);
            a.current = d;
            Xg(d, a, e);
            Ic();
            G = h;
            D = g;
            U.transition = f;
        } else a.current = d;
        th && (th = !1, uh = a, vh = e);
        f = a.pendingLanes;
        0 === f && (Ef = null);
        Pc(d.stateNode, c);
        Z(a, E());
        if (null !== b) for(c = a.onRecoverableError, d = 0; d < b.length; d++)c(b[d]);
        if (Bf) throw Bf = !1, a = Cf, Cf = null, a;
        0 !== (vh & 1) && 0 !== a.tag && Fh();
        f = a.pendingLanes;
        0 !== (f & 1) ? a === xh ? wh++ : (wh = 0, xh = a) : wh = 0;
        Xc();
        return null;
    }
    function Fh() {
        if (null !== uh) {
            var a = Ec(vh), b = U.transition, c = D;
            try {
                U.transition = null;
                D = 16 > a ? 16 : a;
                if (null === uh) var d = !1;
                else {
                    a = uh;
                    uh = null;
                    vh = 0;
                    if (0 !== (G & 6)) throw Error(n(331));
                    var e = G;
                    G |= 4;
                    for(S = a.current; null !== S;){
                        var f = S, g = f.child;
                        if (0 !== (S.flags & 16)) {
                            var h = f.deletions;
                            if (null !== h) {
                                for(var k = 0; k < h.length; k++){
                                    var l = h[k];
                                    for(S = l; null !== S;){
                                        var m = S;
                                        switch(m.tag){
                                            case 0:
                                            case 11:
                                            case 15:
                                                Fg(8, m, f);
                                        }
                                        var v = m.child;
                                        if (null !== v) v.return = m, S = v;
                                        else for(; null !== S;){
                                            m = S;
                                            var r = m.sibling, z = m.return;
                                            Lg(m);
                                            if (m === l) {
                                                S = null;
                                                break;
                                            }
                                            if (null !== r) {
                                                r.return = z;
                                                S = r;
                                                break;
                                            }
                                            S = z;
                                        }
                                    }
                                }
                                var q = f.alternate;
                                if (null !== q) {
                                    var N = q.child;
                                    if (null !== N) {
                                        q.child = null;
                                        do {
                                            var da = N.sibling;
                                            N.sibling = null;
                                            N = da;
                                        }while (null !== N);
                                    }
                                }
                                S = f;
                            }
                        }
                        if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, S = g;
                        else b: for(; null !== S;){
                            f = S;
                            if (0 !== (f.flags & 2048)) switch(f.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Fg(9, f, f.return);
                            }
                            var t = f.sibling;
                            if (null !== t) {
                                t.return = f.return;
                                S = t;
                                break b;
                            }
                            S = f.return;
                        }
                    }
                    var w = a.current;
                    for(S = w; null !== S;){
                        g = S;
                        var u = g.child;
                        if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, S = u;
                        else b: for(g = w; null !== S;){
                            h = S;
                            if (0 !== (h.flags & 2048)) try {
                                switch(h.tag){
                                    case 0:
                                    case 11:
                                    case 15:
                                        Gg(9, h);
                                }
                            } catch (wa) {
                                T(h, h.return, wa);
                            }
                            if (h === g) {
                                S = null;
                                break b;
                            }
                            var V = h.sibling;
                            if (null !== V) {
                                V.return = h.return;
                                S = V;
                                break b;
                            }
                            S = h.return;
                        }
                    }
                    G = e;
                    Xc();
                    if (Oc && "function" === typeof Oc.onPostCommitFiberRoot) try {
                        Oc.onPostCommitFiberRoot(Nc, a);
                    } catch (wa) {}
                    d = !0;
                }
                return d;
            } finally{
                D = c, U.transition = b;
            }
        }
        return !1;
    }
    function Uh(a, b, c) {
        b = xf(c, b);
        b = Af(a, b, 1);
        rd(a, b);
        b = H();
        a = Ah(a, 1);
        null !== a && (Bc(a, 1, b), Z(a, b));
    }
    function T(a, b, c) {
        if (3 === a.tag) Uh(a, a, c);
        else for(; null !== b;){
            if (3 === b.tag) {
                Uh(b, a, c);
                break;
            } else if (1 === b.tag) {
                var d = b.stateNode;
                if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ef || !Ef.has(d))) {
                    a = xf(c, a);
                    a = Df(b, a, 1);
                    rd(b, a);
                    a = H();
                    b = Ah(b, 1);
                    null !== b && (Bc(b, 1, a), Z(b, a));
                    break;
                }
            }
            b = b.return;
        }
    }
    function Gf(a, b, c) {
        var d = a.pingCache;
        null !== d && d.delete(b);
        b = H();
        a.pingedLanes |= a.suspendedLanes & c;
        F === a && (X & c) === c && (4 === Q || 3 === Q && (X & 130023424) === X && 500 > E() - Vg ? Ih(a, 0) : qh |= c);
        Z(a, b);
    }
    function Vh(a, b) {
        0 === b && (0 === (a.mode & 1) ? b = 1 : (b = uc, uc <<= 1, 0 === (uc & 130023424) && (uc = 4194304)));
        var c = H();
        a = Ah(a, b);
        null !== a && (Bc(a, b, c), Z(a, c));
    }
    function qg(a) {
        var b = a.memoizedState, c = 0;
        null !== b && (c = b.retryLane);
        Vh(a, c);
    }
    function Tg(a, b) {
        var c = 0;
        switch(a.tag){
            case 13:
                var d = a.stateNode;
                var e = a.memoizedState;
                null !== e && (c = e.retryLane);
                break;
            case 19:
                d = a.stateNode;
                break;
            default:
                throw Error(n(314));
        }
        null !== d && d.delete(b);
        Vh(a, c);
    }
    var Sh;
    Sh = function(a, b, c) {
        if (null !== a) {
            if (a.memoizedProps !== b.pendingProps || B.current) kd = !0;
            else {
                if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return kd = !1, wg(a, b, c);
                kd = 0 !== (a.flags & 131072) ? !0 : !1;
            }
        } else kd = !1, I && 0 !== (b.flags & 1048576) && Qd(b, Jd, b.index);
        b.lanes = 0;
        switch(b.tag){
            case 2:
                var d = b.type;
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                var e = jc(b, A.current);
                jd(b, c);
                e = Ke(null, b, d, a, e, c);
                var f = Pe();
                b.flags |= 1;
                "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, C(d) ? (f = !0, nc(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, od(b), e.updater = Bd, b.stateNode = e, e._reactInternals = b, Fd(b, d, a, c), b = hg(null, b, d, !0, f, c)) : (b.tag = 0, I && f && Rd(b), R(null, b, e, c), b = b.child);
                return b;
            case 16:
                d = b.elementType;
                a: {
                    null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                    a = b.pendingProps;
                    e = d._init;
                    d = e(d._payload);
                    b.type = d;
                    e = b.tag = Wh(d);
                    a = ad(d, a);
                    switch(e){
                        case 0:
                            b = cg(null, b, d, a, c);
                            break a;
                        case 1:
                            b = gg(null, b, d, a, c);
                            break a;
                        case 11:
                            b = Yf(null, b, d, a, c);
                            break a;
                        case 14:
                            b = $f(null, b, d, ad(d.type, a), c);
                            break a;
                    }
                    throw Error(n(306, d, ""));
                }
                return b;
            case 0:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), cg(a, b, d, e, c);
            case 1:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), gg(a, b, d, e, c);
            case 3:
                a: {
                    ig(b);
                    if (null === a) throw Error(n(387));
                    d = b.pendingProps;
                    f = b.memoizedState;
                    e = f.element;
                    pd(a, b);
                    ud(b, d, null, c);
                    var g = b.memoizedState;
                    d = g.element;
                    if (p && f.isDehydrated) {
                        if (f = {
                            element: d,
                            isDehydrated: !1,
                            cache: g.cache,
                            transitions: g.transitions
                        }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                            e = Error(n(423));
                            b = jg(a, b, d, c, e);
                            break a;
                        } else if (d !== e) {
                            e = Error(n(424));
                            b = jg(a, b, d, c, e);
                            break a;
                        } else for(p && (Ud = Nb(b.stateNode.containerInfo), Td = b, I = !0, Wd = null, Vd = !1), c = pe(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                    } else {
                        de();
                        if (d === e) {
                            b = Zf(a, b, c);
                            break a;
                        }
                        R(a, b, d, c);
                    }
                    b = b.child;
                }
                return b;
            case 5:
                return xe(b), null === a && ae(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Oa(d, e) ? g = null : null !== f && Oa(d, f) && (b.flags |= 32), fg(a, b), R(a, b, g, c), b.child;
            case 6:
                return null === a && ae(b), null;
            case 13:
                return mg(a, b, c);
            case 4:
                return ve(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = oe(b, null, d, c) : R(a, b, d, c), b.child;
            case 11:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), Yf(a, b, d, e, c);
            case 7:
                return R(a, b, b.pendingProps, c), b.child;
            case 8:
                return R(a, b, b.pendingProps.children, c), b.child;
            case 12:
                return R(a, b, b.pendingProps.children, c), b.child;
            case 10:
                a: {
                    d = b.type._context;
                    e = b.pendingProps;
                    f = b.memoizedProps;
                    g = e.value;
                    gd(b, d, g);
                    if (null !== f) {
                        if (Rc(f.value, g)) {
                            if (f.children === e.children && !B.current) {
                                b = Zf(a, b, c);
                                break a;
                            }
                        } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                            var h = f.dependencies;
                            if (null !== h) {
                                g = f.child;
                                for(var k = h.firstContext; null !== k;){
                                    if (k.context === d) {
                                        if (1 === f.tag) {
                                            k = qd(-1, c & -c);
                                            k.tag = 2;
                                            var l = f.updateQueue;
                                            if (null !== l) {
                                                l = l.shared;
                                                var m = l.pending;
                                                null === m ? k.next = k : (k.next = m.next, m.next = k);
                                                l.pending = k;
                                            }
                                        }
                                        f.lanes |= c;
                                        k = f.alternate;
                                        null !== k && (k.lanes |= c);
                                        id(f.return, c, b);
                                        h.lanes |= c;
                                        break;
                                    }
                                    k = k.next;
                                }
                            } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                            else if (18 === f.tag) {
                                g = f.return;
                                if (null === g) throw Error(n(341));
                                g.lanes |= c;
                                h = g.alternate;
                                null !== h && (h.lanes |= c);
                                id(g, c, b);
                                g = f.sibling;
                            } else g = f.child;
                            if (null !== g) g.return = f;
                            else for(g = f; null !== g;){
                                if (g === b) {
                                    g = null;
                                    break;
                                }
                                f = g.sibling;
                                if (null !== f) {
                                    f.return = g.return;
                                    g = f;
                                    break;
                                }
                                g = g.return;
                            }
                            f = g;
                        }
                    }
                    R(a, b, e.children, c);
                    b = b.child;
                }
                return b;
            case 9:
                return e = b.type, d = b.pendingProps.children, jd(b, c), e = ld(e), d = d(e), b.flags |= 1, R(a, b, d, c), b.child;
            case 14:
                return d = b.type, e = ad(d, b.pendingProps), e = ad(d.type, e), $f(a, b, d, e, c);
            case 15:
                return bg(a, b, b.type, b.pendingProps, c);
            case 17:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ad(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, C(d) ? (a = !0, nc(b)) : a = !1, jd(b, c), Dd(b, d, e), Fd(b, d, e, c), hg(null, b, d, !0, a, c);
            case 19:
                return vg(a, b, c);
            case 22:
                return dg(a, b, c);
        }
        throw Error(n(156, b.tag));
    };
    function Dh(a, b) {
        return Fc(a, b);
    }
    function Xh(a, b, c, d) {
        this.tag = a;
        this.key = c;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = b;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = d;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
    }
    function Yd(a, b, c, d) {
        return new Xh(a, b, c, d);
    }
    function ag(a) {
        a = a.prototype;
        return !(!a || !a.isReactComponent);
    }
    function Wh(a) {
        if ("function" === typeof a) return ag(a) ? 1 : 0;
        if (void 0 !== a && null !== a) {
            a = a.$$typeof;
            if (a === na) return 11;
            if (a === qa) return 14;
        }
        return 2;
    }
    function je(a, b) {
        var c = a.alternate;
        null === c ? (c = Yd(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
        c.flags = a.flags & 14680064;
        c.childLanes = a.childLanes;
        c.lanes = a.lanes;
        c.child = a.child;
        c.memoizedProps = a.memoizedProps;
        c.memoizedState = a.memoizedState;
        c.updateQueue = a.updateQueue;
        b = a.dependencies;
        c.dependencies = null === b ? null : {
            lanes: b.lanes,
            firstContext: b.firstContext
        };
        c.sibling = a.sibling;
        c.index = a.index;
        c.ref = a.ref;
        return c;
    }
    function le(a, b, c, d, e, f) {
        var g = 2;
        d = a;
        if ("function" === typeof a) ag(a) && (g = 1);
        else if ("string" === typeof a) g = 5;
        else a: switch(a){
            case ia:
                return ne(c.children, e, f, b);
            case ja:
                g = 8;
                e |= 8;
                break;
            case ka:
                return a = Yd(12, c, b, e | 2), a.elementType = ka, a.lanes = f, a;
            case oa:
                return a = Yd(13, c, b, e), a.elementType = oa, a.lanes = f, a;
            case pa:
                return a = Yd(19, c, b, e), a.elementType = pa, a.lanes = f, a;
            case sa:
                return ng(c, e, f, b);
            default:
                if ("object" === typeof a && null !== a) switch(a.$$typeof){
                    case la:
                        g = 10;
                        break a;
                    case ma:
                        g = 9;
                        break a;
                    case na:
                        g = 11;
                        break a;
                    case qa:
                        g = 14;
                        break a;
                    case ra:
                        g = 16;
                        d = null;
                        break a;
                }
                throw Error(n(130, null == a ? a : typeof a, ""));
        }
        b = Yd(g, c, b, e);
        b.elementType = a;
        b.type = d;
        b.lanes = f;
        return b;
    }
    function ne(a, b, c, d) {
        a = Yd(7, a, d, b);
        a.lanes = c;
        return a;
    }
    function ng(a, b, c, d) {
        a = Yd(22, a, d, b);
        a.elementType = sa;
        a.lanes = c;
        a.stateNode = {};
        return a;
    }
    function ke(a, b, c) {
        a = Yd(6, a, null, b);
        a.lanes = c;
        return a;
    }
    function me(a, b, c) {
        b = Yd(4, null !== a.children ? a.children : [], a.key, b);
        b.lanes = c;
        b.stateNode = {
            containerInfo: a.containerInfo,
            pendingChildren: null,
            implementation: a.implementation
        };
        return b;
    }
    function Yh(a, b, c, d, e) {
        this.tag = b;
        this.containerInfo = a;
        this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = Sa;
        this.callbackNode = this.pendingContext = this.context = null;
        this.callbackPriority = 0;
        this.eventTimes = Ac(0);
        this.expirationTimes = Ac(-1);
        this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = Ac(0);
        this.identifierPrefix = d;
        this.onRecoverableError = e;
        p && (this.mutableSourceEagerHydrationData = null);
    }
    function Zh(a, b, c, d, e, f, g, h, k) {
        a = new Yh(a, b, c, h, k);
        1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
        f = Yd(3, null, null, b);
        a.current = f;
        f.stateNode = a;
        f.memoizedState = {
            element: d,
            isDehydrated: c,
            cache: null,
            transitions: null
        };
        od(f);
        return a;
    }
    function $h(a) {
        if (!a) return hc;
        a = a._reactInternals;
        a: {
            if (ya(a) !== a || 1 !== a.tag) throw Error(n(170));
            var b = a;
            do {
                switch(b.tag){
                    case 3:
                        b = b.stateNode.context;
                        break a;
                    case 1:
                        if (C(b.type)) {
                            b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                            break a;
                        }
                }
                b = b.return;
            }while (null !== b);
            throw Error(n(171));
        }
        if (1 === a.tag) {
            var c = a.type;
            if (C(c)) return mc(a, c, b);
        }
        return b;
    }
    function ai(a) {
        var b = a._reactInternals;
        if (void 0 === b) {
            if ("function" === typeof a.render) throw Error(n(188));
            a = Object.keys(a).join(",");
            throw Error(n(268, a));
        }
        a = Ba(b);
        return null === a ? null : a.stateNode;
    }
    function bi(a, b) {
        a = a.memoizedState;
        if (null !== a && null !== a.dehydrated) {
            var c = a.retryLane;
            a.retryLane = 0 !== c && c < b ? c : b;
        }
    }
    function ci(a, b) {
        bi(a, b);
        (a = a.alternate) && bi(a, b);
    }
    function di(a) {
        a = Ba(a);
        return null === a ? null : a.stateNode;
    }
    function ei() {
        return null;
    }
    exports.attemptContinuousHydration = function(a) {
        if (13 === a.tag) {
            var b = H();
            Ad(a, 134217728, b);
            ci(a, 134217728);
        }
    };
    exports.attemptHydrationAtCurrentPriority = function(a) {
        if (13 === a.tag) {
            var b = H(), c = zd(a);
            Ad(a, c, b);
            ci(a, c);
        }
    };
    exports.attemptSynchronousHydration = function(a) {
        switch(a.tag){
            case 3:
                var b = a.stateNode;
                if (b.current.memoizedState.isDehydrated) {
                    var c = vc(b.pendingLanes);
                    0 !== c && (Dc(b, c | 1), Z(b, E()), 0 === (G & 6) && (sh(), Xc()));
                }
                break;
            case 13:
                var d = H();
                Oh(function() {
                    return Ad(a, 1, d);
                });
                ci(a, 1);
        }
    };
    exports.batchedUpdates = function(a, b) {
        var c = G;
        G |= 1;
        try {
            return a(b);
        } finally{
            G = c, 0 === G && (sh(), Tc && Xc());
        }
    };
    exports.createComponentSelector = function(a) {
        return {
            $$typeof: ah,
            value: a
        };
    };
    exports.createContainer = function(a, b, c, d, e, f, g) {
        return Zh(a, b, !1, null, c, d, e, f, g);
    };
    exports.createHasPseudoClassSelector = function(a) {
        return {
            $$typeof: bh,
            value: a
        };
    };
    exports.createHydrationContainer = function(a, b, c, d, e, f, g, h, k) {
        a = Zh(c, d, !0, a, e, f, g, h, k);
        a.context = $h(null);
        c = a.current;
        d = H();
        e = zd(c);
        f = qd(d, e);
        f.callback = void 0 !== b && null !== b ? b : null;
        rd(c, f);
        a.current.lanes = e;
        Bc(a, e, d);
        Z(a, d);
        return a;
    };
    exports.createPortal = function(a, b, c) {
        var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
            $$typeof: ha,
            key: null == d ? null : "" + d,
            children: a,
            containerInfo: b,
            implementation: c
        };
    };
    exports.createRoleSelector = function(a) {
        return {
            $$typeof: ch,
            value: a
        };
    };
    exports.createTestNameSelector = function(a) {
        return {
            $$typeof: dh,
            value: a
        };
    };
    exports.createTextSelector = function(a) {
        return {
            $$typeof: eh,
            value: a
        };
    };
    exports.deferredUpdates = function(a) {
        var b = D, c = U.transition;
        try {
            return U.transition = null, D = 16, a();
        } finally{
            D = b, U.transition = c;
        }
    };
    exports.discreteUpdates = function(a, b, c, d, e) {
        var f = D, g = U.transition;
        try {
            return U.transition = null, D = 1, a(b, c, d, e);
        } finally{
            D = f, U.transition = g, 0 === G && sh();
        }
    };
    exports.findAllNodes = kh;
    exports.findBoundingRects = function(a, b) {
        if (!bb) throw Error(n(363));
        b = kh(a, b);
        a = [];
        for(var c = 0; c < b.length; c++)a.push(db(b[c]));
        for(b = a.length - 1; 0 < b; b--){
            c = a[b];
            for(var d = c.x, e = d + c.width, f = c.y, g = f + c.height, h = b - 1; 0 <= h; h--)if (b !== h) {
                var k = a[h], l = k.x, m = l + k.width, v = k.y, r = v + k.height;
                if (d >= l && f >= v && e <= m && g <= r) {
                    a.splice(b, 1);
                    break;
                } else if (!(d !== l || c.width !== k.width || r < f || v > g)) {
                    v > f && (k.height += v - f, k.y = f);
                    r < g && (k.height = g - v);
                    a.splice(b, 1);
                    break;
                } else if (!(f !== v || c.height !== k.height || m < d || l > e)) {
                    l > d && (k.width += l - d, k.x = d);
                    m < e && (k.width = e - l);
                    a.splice(b, 1);
                    break;
                }
            }
        }
        return a;
    };
    exports.findHostInstance = ai;
    exports.findHostInstanceWithNoPortals = function(a) {
        a = Aa(a);
        a = null !== a ? Da(a) : null;
        return null === a ? null : a.stateNode;
    };
    exports.findHostInstanceWithWarning = function(a) {
        return ai(a);
    };
    exports.flushControlled = function(a) {
        var b = G;
        G |= 1;
        var c = U.transition, d = D;
        try {
            U.transition = null, D = 1, a();
        } finally{
            D = d, U.transition = c, G = b, 0 === G && (sh(), Xc());
        }
    };
    exports.flushPassiveEffects = Fh;
    exports.flushSync = Oh;
    exports.focusWithin = function(a, b) {
        if (!bb) throw Error(n(363));
        a = gh(a);
        b = jh(a, b);
        b = Array.from(b);
        for(a = 0; a < b.length;){
            var c = b[a++];
            if (!fb(c)) {
                if (5 === c.tag && hb(c.stateNode)) return !0;
                for(c = c.child; null !== c;)b.push(c), c = c.sibling;
            }
        }
        return !1;
    };
    exports.getCurrentUpdatePriority = function() {
        return D;
    };
    exports.getFindAllNodesFailureDescription = function(a, b) {
        if (!bb) throw Error(n(363));
        var c = 0, d = [];
        a = [
            gh(a),
            0
        ];
        for(var e = 0; e < a.length;){
            var f = a[e++], g = a[e++], h = b[g];
            if (5 !== f.tag || !fb(f)) {
                if (hh(f, h) && (d.push(ih(h)), g++, g > c && (c = g)), g < b.length) for(f = f.child; null !== f;)a.push(f, g), f = f.sibling;
            }
        }
        if (c < b.length) {
            for(a = []; c < b.length; c++)a.push(ih(b[c]));
            return "findAllNodes was able to match part of the selector:\n  " + (d.join(" > ") + "\n\nNo matching component was found for:\n  ") + a.join(" > ");
        }
        return null;
    };
    exports.getPublicRootInstance = function(a) {
        a = a.current;
        if (!a.child) return null;
        switch(a.child.tag){
            case 5:
                return Fa(a.child.stateNode);
            default:
                return a.child.stateNode;
        }
    };
    exports.injectIntoDevTools = function(a) {
        a = {
            bundleType: a.bundleType,
            version: a.version,
            rendererPackageName: a.rendererPackageName,
            rendererConfig: a.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setErrorHandler: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: ea.ReactCurrentDispatcher,
            findHostInstanceByFiber: di,
            findFiberByHostInstance: a.findFiberByHostInstance || ei,
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
            reconcilerVersion: "18.0.0-fc46dba67-20220329"
        };
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) a = !1;
        else {
            var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (b.isDisabled || !b.supportsFiber) a = !0;
            else {
                try {
                    Nc = b.inject(a), Oc = b;
                } catch (c) {}
                a = b.checkDCE ? !0 : !1;
            }
        }
        return a;
    };
    exports.isAlreadyRendering = function() {
        return !1;
    };
    exports.observeVisibleRects = function(a, b, c, d) {
        if (!bb) throw Error(n(363));
        a = kh(a, b);
        var e = ib(a, c, d).disconnect;
        return {
            disconnect: function() {
                e();
            }
        };
    };
    exports.registerMutableSourceForHydration = function(a, b) {
        var c = b._getVersion;
        c = c(b._source);
        null == a.mutableSourceEagerHydrationData ? a.mutableSourceEagerHydrationData = [
            b,
            c
        ] : a.mutableSourceEagerHydrationData.push(b, c);
    };
    exports.runWithPriority = function(a, b) {
        var c = D;
        try {
            return D = a, b();
        } finally{
            D = c;
        }
    };
    exports.shouldError = function() {
        return null;
    };
    exports.shouldSuspend = function() {
        return !1;
    };
    exports.updateContainer = function(a, b, c, d) {
        var e = b.current, f = H(), g = zd(e);
        c = $h(c);
        null === b.context ? b.context = c : b.pendingContext = c;
        b = qd(f, g);
        b.payload = {
            element: a
        };
        d = void 0 === d ? null : d;
        null !== d && (b.callback = d);
        rd(e, b);
        a = Ad(e, g, f);
        null !== a && sd(a, e, g);
        return g;
    };
    return exports;
};

});
parcelRegister("bdSvy", function(module, exports) {
'use strict';

module.exports = (parcelRequire("78ACX"));

});
parcelRegister("78ACX", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $5325b12d08f38424$export$c4744153514ff05d, (v) => $5325b12d08f38424$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $5325b12d08f38424$export$3e506c1ccc9cc1a7, (v) => $5325b12d08f38424$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $5325b12d08f38424$export$e26fe2ed2fa76875, (v) => $5325b12d08f38424$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $5325b12d08f38424$export$502329bbf4b505b1, (v) => $5325b12d08f38424$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $5325b12d08f38424$export$6e3807111c4874c4, (v) => $5325b12d08f38424$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $5325b12d08f38424$export$c27134553091fb3a, (v) => $5325b12d08f38424$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $5325b12d08f38424$export$33ee1acdc04fd2a2, (v) => $5325b12d08f38424$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $5325b12d08f38424$export$b00a404bbd5edef2, (v) => $5325b12d08f38424$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $5325b12d08f38424$export$8352ce38b91d0c62, (v) => $5325b12d08f38424$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $5325b12d08f38424$export$d66a1c1c77bd778b, (v) => $5325b12d08f38424$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $5325b12d08f38424$export$d3dfb8e4810cb555, (v) => $5325b12d08f38424$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $5325b12d08f38424$export$839f9183b0465a69, (v) => $5325b12d08f38424$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $5325b12d08f38424$export$72fdf0e06517287b, (v) => $5325b12d08f38424$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $5325b12d08f38424$export$4b844e58a3e414b4, (v) => $5325b12d08f38424$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $5325b12d08f38424$export$816d2913ae6b83b1, (v) => $5325b12d08f38424$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $5325b12d08f38424$export$61bcfe829111a1d0, (v) => $5325b12d08f38424$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $5325b12d08f38424$export$7ee8c9beb337bc3f, (v) => $5325b12d08f38424$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $5325b12d08f38424$export$b5836b71941fa3ed, (v) => $5325b12d08f38424$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $5325b12d08f38424$export$cf845f2c119da08a, (v) => $5325b12d08f38424$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5325b12d08f38424$export$c4744153514ff05d;
var $5325b12d08f38424$export$3e506c1ccc9cc1a7;
var $5325b12d08f38424$export$e26fe2ed2fa76875;
var $5325b12d08f38424$export$502329bbf4b505b1;
var $5325b12d08f38424$export$6e3807111c4874c4;
var $5325b12d08f38424$export$c27134553091fb3a;
var $5325b12d08f38424$export$33ee1acdc04fd2a2;
var $5325b12d08f38424$export$b00a404bbd5edef2;
var $5325b12d08f38424$export$8352ce38b91d0c62;
var $5325b12d08f38424$export$d66a1c1c77bd778b;
var $5325b12d08f38424$export$d3dfb8e4810cb555;
var $5325b12d08f38424$export$839f9183b0465a69;
var $5325b12d08f38424$export$72fdf0e06517287b;
var $5325b12d08f38424$export$4b844e58a3e414b4;
var $5325b12d08f38424$export$816d2913ae6b83b1;
var $5325b12d08f38424$export$61bcfe829111a1d0;
var $5325b12d08f38424$export$7ee8c9beb337bc3f;
var $5325b12d08f38424$export$b5836b71941fa3ed;
var $5325b12d08f38424$export$cf845f2c119da08a;
'use strict';
function $5325b12d08f38424$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $5325b12d08f38424$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $5325b12d08f38424$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $5325b12d08f38424$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $5325b12d08f38424$var$g(C, c)) n < e && 0 > $5325b12d08f38424$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $5325b12d08f38424$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $5325b12d08f38424$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $5325b12d08f38424$var$l = performance;
    $5325b12d08f38424$export$c4744153514ff05d = function() {
        return $5325b12d08f38424$var$l.now();
    };
} else {
    var $5325b12d08f38424$var$p = Date, $5325b12d08f38424$var$q = $5325b12d08f38424$var$p.now();
    $5325b12d08f38424$export$c4744153514ff05d = function() {
        return $5325b12d08f38424$var$p.now() - $5325b12d08f38424$var$q;
    };
}
var $5325b12d08f38424$var$r = [], $5325b12d08f38424$var$t = [], $5325b12d08f38424$var$u = 1, $5325b12d08f38424$var$v = null, $5325b12d08f38424$var$y = 3, $5325b12d08f38424$var$z = !1, $5325b12d08f38424$var$A = !1, $5325b12d08f38424$var$B = !1, $5325b12d08f38424$var$D = "function" === typeof setTimeout ? setTimeout : null, $5325b12d08f38424$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $5325b12d08f38424$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $5325b12d08f38424$var$G(a) {
    for(var b = $5325b12d08f38424$var$h($5325b12d08f38424$var$t); null !== b;){
        if (null === b.callback) $5325b12d08f38424$var$k($5325b12d08f38424$var$t);
        else if (b.startTime <= a) $5325b12d08f38424$var$k($5325b12d08f38424$var$t), b.sortIndex = b.expirationTime, $5325b12d08f38424$var$f($5325b12d08f38424$var$r, b);
        else break;
        b = $5325b12d08f38424$var$h($5325b12d08f38424$var$t);
    }
}
function $5325b12d08f38424$var$H(a) {
    $5325b12d08f38424$var$B = !1;
    $5325b12d08f38424$var$G(a);
    if (!$5325b12d08f38424$var$A) {
        if (null !== $5325b12d08f38424$var$h($5325b12d08f38424$var$r)) $5325b12d08f38424$var$A = !0, $5325b12d08f38424$var$I($5325b12d08f38424$var$J);
        else {
            var b = $5325b12d08f38424$var$h($5325b12d08f38424$var$t);
            null !== b && $5325b12d08f38424$var$K($5325b12d08f38424$var$H, b.startTime - a);
        }
    }
}
function $5325b12d08f38424$var$J(a, b) {
    $5325b12d08f38424$var$A = !1;
    $5325b12d08f38424$var$B && ($5325b12d08f38424$var$B = !1, $5325b12d08f38424$var$E($5325b12d08f38424$var$L), $5325b12d08f38424$var$L = -1);
    $5325b12d08f38424$var$z = !0;
    var c = $5325b12d08f38424$var$y;
    try {
        $5325b12d08f38424$var$G(b);
        for($5325b12d08f38424$var$v = $5325b12d08f38424$var$h($5325b12d08f38424$var$r); null !== $5325b12d08f38424$var$v && (!($5325b12d08f38424$var$v.expirationTime > b) || a && !$5325b12d08f38424$var$M());){
            var d = $5325b12d08f38424$var$v.callback;
            if ("function" === typeof d) {
                $5325b12d08f38424$var$v.callback = null;
                $5325b12d08f38424$var$y = $5325b12d08f38424$var$v.priorityLevel;
                var e = d($5325b12d08f38424$var$v.expirationTime <= b);
                b = $5325b12d08f38424$export$c4744153514ff05d();
                "function" === typeof e ? $5325b12d08f38424$var$v.callback = e : $5325b12d08f38424$var$v === $5325b12d08f38424$var$h($5325b12d08f38424$var$r) && $5325b12d08f38424$var$k($5325b12d08f38424$var$r);
                $5325b12d08f38424$var$G(b);
            } else $5325b12d08f38424$var$k($5325b12d08f38424$var$r);
            $5325b12d08f38424$var$v = $5325b12d08f38424$var$h($5325b12d08f38424$var$r);
        }
        if (null !== $5325b12d08f38424$var$v) var w = !0;
        else {
            var m = $5325b12d08f38424$var$h($5325b12d08f38424$var$t);
            null !== m && $5325b12d08f38424$var$K($5325b12d08f38424$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $5325b12d08f38424$var$v = null, $5325b12d08f38424$var$y = c, $5325b12d08f38424$var$z = !1;
    }
}
var $5325b12d08f38424$var$N = !1, $5325b12d08f38424$var$O = null, $5325b12d08f38424$var$L = -1, $5325b12d08f38424$var$P = 5, $5325b12d08f38424$var$Q = -1;
function $5325b12d08f38424$var$M() {
    return $5325b12d08f38424$export$c4744153514ff05d() - $5325b12d08f38424$var$Q < $5325b12d08f38424$var$P ? !1 : !0;
}
function $5325b12d08f38424$var$R() {
    if (null !== $5325b12d08f38424$var$O) {
        var a = $5325b12d08f38424$export$c4744153514ff05d();
        $5325b12d08f38424$var$Q = a;
        var b = !0;
        try {
            b = $5325b12d08f38424$var$O(!0, a);
        } finally{
            b ? $5325b12d08f38424$var$S() : ($5325b12d08f38424$var$N = !1, $5325b12d08f38424$var$O = null);
        }
    } else $5325b12d08f38424$var$N = !1;
}
var $5325b12d08f38424$var$S;
if ("function" === typeof $5325b12d08f38424$var$F) $5325b12d08f38424$var$S = function() {
    $5325b12d08f38424$var$F($5325b12d08f38424$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $5325b12d08f38424$var$T = new MessageChannel, $5325b12d08f38424$var$U = $5325b12d08f38424$var$T.port2;
    $5325b12d08f38424$var$T.port1.onmessage = $5325b12d08f38424$var$R;
    $5325b12d08f38424$var$S = function() {
        $5325b12d08f38424$var$U.postMessage(null);
    };
} else $5325b12d08f38424$var$S = function() {
    $5325b12d08f38424$var$D($5325b12d08f38424$var$R, 0);
};
function $5325b12d08f38424$var$I(a) {
    $5325b12d08f38424$var$O = a;
    $5325b12d08f38424$var$N || ($5325b12d08f38424$var$N = !0, $5325b12d08f38424$var$S());
}
function $5325b12d08f38424$var$K(a, b) {
    $5325b12d08f38424$var$L = $5325b12d08f38424$var$D(function() {
        a($5325b12d08f38424$export$c4744153514ff05d());
    }, b);
}
$5325b12d08f38424$export$3e506c1ccc9cc1a7 = 5;
$5325b12d08f38424$export$e26fe2ed2fa76875 = 1;
$5325b12d08f38424$export$502329bbf4b505b1 = 4;
$5325b12d08f38424$export$6e3807111c4874c4 = 3;
$5325b12d08f38424$export$c27134553091fb3a = null;
$5325b12d08f38424$export$33ee1acdc04fd2a2 = 2;
$5325b12d08f38424$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$5325b12d08f38424$export$8352ce38b91d0c62 = function() {
    $5325b12d08f38424$var$A || $5325b12d08f38424$var$z || ($5325b12d08f38424$var$A = !0, $5325b12d08f38424$var$I($5325b12d08f38424$var$J));
};
$5325b12d08f38424$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $5325b12d08f38424$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$5325b12d08f38424$export$d3dfb8e4810cb555 = function() {
    return $5325b12d08f38424$var$y;
};
$5325b12d08f38424$export$839f9183b0465a69 = function() {
    return $5325b12d08f38424$var$h($5325b12d08f38424$var$r);
};
$5325b12d08f38424$export$72fdf0e06517287b = function(a) {
    switch($5325b12d08f38424$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $5325b12d08f38424$var$y;
    }
    var c = $5325b12d08f38424$var$y;
    $5325b12d08f38424$var$y = b;
    try {
        return a();
    } finally{
        $5325b12d08f38424$var$y = c;
    }
};
$5325b12d08f38424$export$4b844e58a3e414b4 = function() {};
$5325b12d08f38424$export$816d2913ae6b83b1 = function() {};
$5325b12d08f38424$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $5325b12d08f38424$var$y;
    $5325b12d08f38424$var$y = a;
    try {
        return b();
    } finally{
        $5325b12d08f38424$var$y = c;
    }
};
$5325b12d08f38424$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $5325b12d08f38424$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $5325b12d08f38424$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $5325b12d08f38424$var$f($5325b12d08f38424$var$t, a), null === $5325b12d08f38424$var$h($5325b12d08f38424$var$r) && a === $5325b12d08f38424$var$h($5325b12d08f38424$var$t) && ($5325b12d08f38424$var$B ? ($5325b12d08f38424$var$E($5325b12d08f38424$var$L), $5325b12d08f38424$var$L = -1) : $5325b12d08f38424$var$B = !0, $5325b12d08f38424$var$K($5325b12d08f38424$var$H, c - d))) : (a.sortIndex = e, $5325b12d08f38424$var$f($5325b12d08f38424$var$r, a), $5325b12d08f38424$var$A || $5325b12d08f38424$var$z || ($5325b12d08f38424$var$A = !0, $5325b12d08f38424$var$I($5325b12d08f38424$var$J)));
    return a;
};
$5325b12d08f38424$export$b5836b71941fa3ed = $5325b12d08f38424$var$M;
$5325b12d08f38424$export$cf845f2c119da08a = function(a) {
    var b = $5325b12d08f38424$var$y;
    return function() {
        var c = $5325b12d08f38424$var$y;
        $5325b12d08f38424$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $5325b12d08f38424$var$y = c;
        }
    };
};

});



var $14024a6d51999040$exports = {};
'use strict';

$14024a6d51999040$exports = (parcelRequire("aPfka"));


parcelRequire("aqdBs");
var $c920eedc27eaef64$export$882461b6382ed46c;
var $c920eedc27eaef64$export$757ceba2d55c277e;
'use strict';
var $e813d4480671d45c$exports = {};
'use strict';
function $e813d4480671d45c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e813d4480671d45c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e813d4480671d45c$var$checkDCE();

$e813d4480671d45c$exports = (parcelRequire("l8cRS"));


var $c920eedc27eaef64$var$i;
$c920eedc27eaef64$export$882461b6382ed46c = $e813d4480671d45c$exports.createRoot;
$c920eedc27eaef64$export$757ceba2d55c277e = $e813d4480671d45c$exports.hydrateRoot;




var $aqdBs = parcelRequire("aqdBs");
function $c2edeac9f1827d96$export$2e2bcd8739ae039() {
    return $c2edeac9f1827d96$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c2edeac9f1827d96$export$2e2bcd8739ae039.apply(null, arguments);
}



var $aqdBs = parcelRequire("aqdBs");

var $548f161e17fc6f48$exports = {};

$parcel$export($548f161e17fc6f48$exports, "REVISION", () => $548f161e17fc6f48$export$3545e07a80636437);
$parcel$export($548f161e17fc6f48$exports, "MOUSE", () => $548f161e17fc6f48$export$7177b3e430c2d7ca);
$parcel$export($548f161e17fc6f48$exports, "TOUCH", () => $548f161e17fc6f48$export$d46bd3ead7cc759b);
$parcel$export($548f161e17fc6f48$exports, "CullFaceNone", () => $548f161e17fc6f48$export$3237e1f2c1ea1f44);
$parcel$export($548f161e17fc6f48$exports, "CullFaceBack", () => $548f161e17fc6f48$export$b9a7b4fc5cb15f9b);
$parcel$export($548f161e17fc6f48$exports, "CullFaceFront", () => $548f161e17fc6f48$export$b8058bcc7037d3f3);
$parcel$export($548f161e17fc6f48$exports, "CullFaceFrontBack", () => $548f161e17fc6f48$export$f24be24dcddeac0d);
$parcel$export($548f161e17fc6f48$exports, "BasicShadowMap", () => $548f161e17fc6f48$export$346307dbae2b7447);
$parcel$export($548f161e17fc6f48$exports, "PCFShadowMap", () => $548f161e17fc6f48$export$5813f879eee7cd88);
$parcel$export($548f161e17fc6f48$exports, "PCFSoftShadowMap", () => $548f161e17fc6f48$export$a47c4b43a1be34f0);
$parcel$export($548f161e17fc6f48$exports, "VSMShadowMap", () => $548f161e17fc6f48$export$896ae1ade6c829c4);
$parcel$export($548f161e17fc6f48$exports, "FrontSide", () => $548f161e17fc6f48$export$2ede184fc2998901);
$parcel$export($548f161e17fc6f48$exports, "BackSide", () => $548f161e17fc6f48$export$d9f0486e75b5ace);
$parcel$export($548f161e17fc6f48$exports, "DoubleSide", () => $548f161e17fc6f48$export$3b296b6f144d5b03);
$parcel$export($548f161e17fc6f48$exports, "TwoPassDoubleSide", () => $548f161e17fc6f48$export$211211c00f97204d);
$parcel$export($548f161e17fc6f48$exports, "NoBlending", () => $548f161e17fc6f48$export$63b8d6b580fc65ba);
$parcel$export($548f161e17fc6f48$exports, "NormalBlending", () => $548f161e17fc6f48$export$5b29a26d96ee6af0);
$parcel$export($548f161e17fc6f48$exports, "AdditiveBlending", () => $548f161e17fc6f48$export$777d8f9551c2216b);
$parcel$export($548f161e17fc6f48$exports, "SubtractiveBlending", () => $548f161e17fc6f48$export$cdfa06f868e2e467);
$parcel$export($548f161e17fc6f48$exports, "MultiplyBlending", () => $548f161e17fc6f48$export$4138e1c684b46a20);
$parcel$export($548f161e17fc6f48$exports, "CustomBlending", () => $548f161e17fc6f48$export$eda4864c68df1fa2);
$parcel$export($548f161e17fc6f48$exports, "AddEquation", () => $548f161e17fc6f48$export$20183a0484ce21a0);
$parcel$export($548f161e17fc6f48$exports, "SubtractEquation", () => $548f161e17fc6f48$export$73e0df5177988548);
$parcel$export($548f161e17fc6f48$exports, "ReverseSubtractEquation", () => $548f161e17fc6f48$export$28e582859cbec660);
$parcel$export($548f161e17fc6f48$exports, "MinEquation", () => $548f161e17fc6f48$export$c8c1508da8d0600c);
$parcel$export($548f161e17fc6f48$exports, "MaxEquation", () => $548f161e17fc6f48$export$99948c02fb51055f);
$parcel$export($548f161e17fc6f48$exports, "ZeroFactor", () => $548f161e17fc6f48$export$2110f05edf778d3d);
$parcel$export($548f161e17fc6f48$exports, "OneFactor", () => $548f161e17fc6f48$export$8805bad65e24940e);
$parcel$export($548f161e17fc6f48$exports, "SrcColorFactor", () => $548f161e17fc6f48$export$7fbe15b28d28cf52);
$parcel$export($548f161e17fc6f48$exports, "OneMinusSrcColorFactor", () => $548f161e17fc6f48$export$947829af9f2c17f6);
$parcel$export($548f161e17fc6f48$exports, "SrcAlphaFactor", () => $548f161e17fc6f48$export$d5773124e86cf28c);
$parcel$export($548f161e17fc6f48$exports, "OneMinusSrcAlphaFactor", () => $548f161e17fc6f48$export$11d468cc7f19e971);
$parcel$export($548f161e17fc6f48$exports, "DstAlphaFactor", () => $548f161e17fc6f48$export$a78aed1ca2a87192);
$parcel$export($548f161e17fc6f48$exports, "OneMinusDstAlphaFactor", () => $548f161e17fc6f48$export$5d0fe17fd8773bac);
$parcel$export($548f161e17fc6f48$exports, "DstColorFactor", () => $548f161e17fc6f48$export$ef5f2dd8ffac5574);
$parcel$export($548f161e17fc6f48$exports, "OneMinusDstColorFactor", () => $548f161e17fc6f48$export$56b85b2686ab16);
$parcel$export($548f161e17fc6f48$exports, "SrcAlphaSaturateFactor", () => $548f161e17fc6f48$export$c05e2a1fc8609506);
$parcel$export($548f161e17fc6f48$exports, "NeverDepth", () => $548f161e17fc6f48$export$69025ce147cee220);
$parcel$export($548f161e17fc6f48$exports, "AlwaysDepth", () => $548f161e17fc6f48$export$7182eb52ea3b3f04);
$parcel$export($548f161e17fc6f48$exports, "LessDepth", () => $548f161e17fc6f48$export$eedccec66ab7ebe);
$parcel$export($548f161e17fc6f48$exports, "LessEqualDepth", () => $548f161e17fc6f48$export$296f78a0b892f81a);
$parcel$export($548f161e17fc6f48$exports, "EqualDepth", () => $548f161e17fc6f48$export$a60d398fc7b7590e);
$parcel$export($548f161e17fc6f48$exports, "GreaterEqualDepth", () => $548f161e17fc6f48$export$7d7234c1240a1fc4);
$parcel$export($548f161e17fc6f48$exports, "GreaterDepth", () => $548f161e17fc6f48$export$c5e2c52991f30937);
$parcel$export($548f161e17fc6f48$exports, "NotEqualDepth", () => $548f161e17fc6f48$export$2f843afa843d8916);
$parcel$export($548f161e17fc6f48$exports, "MultiplyOperation", () => $548f161e17fc6f48$export$e50ac29801f1774d);
$parcel$export($548f161e17fc6f48$exports, "MixOperation", () => $548f161e17fc6f48$export$9f9d94f963c85479);
$parcel$export($548f161e17fc6f48$exports, "AddOperation", () => $548f161e17fc6f48$export$e641dc52bc3494aa);
$parcel$export($548f161e17fc6f48$exports, "NoToneMapping", () => $548f161e17fc6f48$export$9fcb6b4294603b2);
$parcel$export($548f161e17fc6f48$exports, "LinearToneMapping", () => $548f161e17fc6f48$export$98f52c2a46c598ca);
$parcel$export($548f161e17fc6f48$exports, "ReinhardToneMapping", () => $548f161e17fc6f48$export$74b25e54b3bcd548);
$parcel$export($548f161e17fc6f48$exports, "CineonToneMapping", () => $548f161e17fc6f48$export$932b3dd283d4a366);
$parcel$export($548f161e17fc6f48$exports, "ACESFilmicToneMapping", () => $548f161e17fc6f48$export$a0d98fe6d7e4af64);
$parcel$export($548f161e17fc6f48$exports, "CustomToneMapping", () => $548f161e17fc6f48$export$2c7b09c1e9abfb5e);
$parcel$export($548f161e17fc6f48$exports, "UVMapping", () => $548f161e17fc6f48$export$1beec6768cbb3d2d);
$parcel$export($548f161e17fc6f48$exports, "CubeReflectionMapping", () => $548f161e17fc6f48$export$8759762a6477f2c4);
$parcel$export($548f161e17fc6f48$exports, "CubeRefractionMapping", () => $548f161e17fc6f48$export$dc59f8aed047f61d);
$parcel$export($548f161e17fc6f48$exports, "EquirectangularReflectionMapping", () => $548f161e17fc6f48$export$d64030b316d3b087);
$parcel$export($548f161e17fc6f48$exports, "EquirectangularRefractionMapping", () => $548f161e17fc6f48$export$ee99d97d46898098);
$parcel$export($548f161e17fc6f48$exports, "CubeUVReflectionMapping", () => $548f161e17fc6f48$export$dbf3e70ff37af79);
$parcel$export($548f161e17fc6f48$exports, "RepeatWrapping", () => $548f161e17fc6f48$export$533346c8e8dac0f5);
$parcel$export($548f161e17fc6f48$exports, "ClampToEdgeWrapping", () => $548f161e17fc6f48$export$9d9334239a5a5e06);
$parcel$export($548f161e17fc6f48$exports, "MirroredRepeatWrapping", () => $548f161e17fc6f48$export$c7e7c00b14f51a4f);
$parcel$export($548f161e17fc6f48$exports, "NearestFilter", () => $548f161e17fc6f48$export$727aa5ec3fe39bf0);
$parcel$export($548f161e17fc6f48$exports, "NearestMipmapNearestFilter", () => $548f161e17fc6f48$export$d129e38cf6feaa8c);
$parcel$export($548f161e17fc6f48$exports, "NearestMipMapNearestFilter", () => $548f161e17fc6f48$export$14a4936464a36496);
$parcel$export($548f161e17fc6f48$exports, "NearestMipmapLinearFilter", () => $548f161e17fc6f48$export$d2327c1afe5bfdf2);
$parcel$export($548f161e17fc6f48$exports, "NearestMipMapLinearFilter", () => $548f161e17fc6f48$export$cbc5b7f5647595d8);
$parcel$export($548f161e17fc6f48$exports, "LinearFilter", () => $548f161e17fc6f48$export$8a72f490b25c56c8);
$parcel$export($548f161e17fc6f48$exports, "LinearMipmapNearestFilter", () => $548f161e17fc6f48$export$19a719f377145a13);
$parcel$export($548f161e17fc6f48$exports, "LinearMipMapNearestFilter", () => $548f161e17fc6f48$export$dbe96bee3fe9dbf0);
$parcel$export($548f161e17fc6f48$exports, "LinearMipmapLinearFilter", () => $548f161e17fc6f48$export$5d8599b6a933fb1b);
$parcel$export($548f161e17fc6f48$exports, "LinearMipMapLinearFilter", () => $548f161e17fc6f48$export$90d80f1e3506775f);
$parcel$export($548f161e17fc6f48$exports, "UnsignedByteType", () => $548f161e17fc6f48$export$2e8ce08d3f6f5e10);
$parcel$export($548f161e17fc6f48$exports, "ByteType", () => $548f161e17fc6f48$export$545fce0311a9796a);
$parcel$export($548f161e17fc6f48$exports, "ShortType", () => $548f161e17fc6f48$export$88572337f312435f);
$parcel$export($548f161e17fc6f48$exports, "UnsignedShortType", () => $548f161e17fc6f48$export$c63dc51868b06a9d);
$parcel$export($548f161e17fc6f48$exports, "IntType", () => $548f161e17fc6f48$export$5c612977753abe2);
$parcel$export($548f161e17fc6f48$exports, "UnsignedIntType", () => $548f161e17fc6f48$export$c3c7fc4518ebba96);
$parcel$export($548f161e17fc6f48$exports, "FloatType", () => $548f161e17fc6f48$export$f6d331659b644596);
$parcel$export($548f161e17fc6f48$exports, "HalfFloatType", () => $548f161e17fc6f48$export$2697304443f382bc);
$parcel$export($548f161e17fc6f48$exports, "UnsignedShort4444Type", () => $548f161e17fc6f48$export$b3969b01faf587f2);
$parcel$export($548f161e17fc6f48$exports, "UnsignedShort5551Type", () => $548f161e17fc6f48$export$18886f8ae33e90de);
$parcel$export($548f161e17fc6f48$exports, "UnsignedInt248Type", () => $548f161e17fc6f48$export$6c8ea339bfab1301);
$parcel$export($548f161e17fc6f48$exports, "AlphaFormat", () => $548f161e17fc6f48$export$988473390501ed4b);
$parcel$export($548f161e17fc6f48$exports, "RGBAFormat", () => $548f161e17fc6f48$export$3f8bb04b555a363c);
$parcel$export($548f161e17fc6f48$exports, "LuminanceFormat", () => $548f161e17fc6f48$export$cc09ccbf6d1ed449);
$parcel$export($548f161e17fc6f48$exports, "LuminanceAlphaFormat", () => $548f161e17fc6f48$export$9053a81c4a69c289);
$parcel$export($548f161e17fc6f48$exports, "DepthFormat", () => $548f161e17fc6f48$export$c1b6b5136be58045);
$parcel$export($548f161e17fc6f48$exports, "DepthStencilFormat", () => $548f161e17fc6f48$export$1e113ac2d0905829);
$parcel$export($548f161e17fc6f48$exports, "RedFormat", () => $548f161e17fc6f48$export$4e041a7967d15c4b);
$parcel$export($548f161e17fc6f48$exports, "RedIntegerFormat", () => $548f161e17fc6f48$export$aa92e870a709d190);
$parcel$export($548f161e17fc6f48$exports, "RGFormat", () => $548f161e17fc6f48$export$6cdf0b461c7ce8a0);
$parcel$export($548f161e17fc6f48$exports, "RGIntegerFormat", () => $548f161e17fc6f48$export$1ba1c45f9f77d4d7);
$parcel$export($548f161e17fc6f48$exports, "RGBAIntegerFormat", () => $548f161e17fc6f48$export$c200e7d26f592f21);
$parcel$export($548f161e17fc6f48$exports, "RGB_S3TC_DXT1_Format", () => $548f161e17fc6f48$export$21d1799c6d552fc0);
$parcel$export($548f161e17fc6f48$exports, "RGBA_S3TC_DXT1_Format", () => $548f161e17fc6f48$export$afa304c3e981b668);
$parcel$export($548f161e17fc6f48$exports, "RGBA_S3TC_DXT3_Format", () => $548f161e17fc6f48$export$d2a1a68024a3e56c);
$parcel$export($548f161e17fc6f48$exports, "RGBA_S3TC_DXT5_Format", () => $548f161e17fc6f48$export$9a79c424327dacf9);
$parcel$export($548f161e17fc6f48$exports, "RGB_PVRTC_4BPPV1_Format", () => $548f161e17fc6f48$export$19ada9bbb1af3573);
$parcel$export($548f161e17fc6f48$exports, "RGB_PVRTC_2BPPV1_Format", () => $548f161e17fc6f48$export$d0f0355bb3d948e4);
$parcel$export($548f161e17fc6f48$exports, "RGBA_PVRTC_4BPPV1_Format", () => $548f161e17fc6f48$export$b82296714358084c);
$parcel$export($548f161e17fc6f48$exports, "RGBA_PVRTC_2BPPV1_Format", () => $548f161e17fc6f48$export$b71692456c47b6c3);
$parcel$export($548f161e17fc6f48$exports, "RGB_ETC1_Format", () => $548f161e17fc6f48$export$6ab91af2d757aee7);
$parcel$export($548f161e17fc6f48$exports, "RGB_ETC2_Format", () => $548f161e17fc6f48$export$7800993ef8106a6a);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ETC2_EAC_Format", () => $548f161e17fc6f48$export$23ed8300a860e7d8);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ASTC_4x4_Format", () => $548f161e17fc6f48$export$dc5570b4a2b92d48);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ASTC_5x4_Format", () => $548f161e17fc6f48$export$68880cd325f8b2fb);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ASTC_5x5_Format", () => $548f161e17fc6f48$export$7d2c0be323373d95);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ASTC_6x5_Format", () => $548f161e17fc6f48$export$22b52da301fc3a3e);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ASTC_6x6_Format", () => $548f161e17fc6f48$export$c009e2cb4a66485e);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ASTC_8x5_Format", () => $548f161e17fc6f48$export$118fff5afa255b63);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ASTC_8x6_Format", () => $548f161e17fc6f48$export$120713c829ae0667);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ASTC_8x8_Format", () => $548f161e17fc6f48$export$c79eeabbf53313e9);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ASTC_10x5_Format", () => $548f161e17fc6f48$export$443cf6567cdd6424);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ASTC_10x6_Format", () => $548f161e17fc6f48$export$6573984fc9840780);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ASTC_10x8_Format", () => $548f161e17fc6f48$export$e7aee563f30091de);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ASTC_10x10_Format", () => $548f161e17fc6f48$export$2eb8634622ddeab7);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ASTC_12x10_Format", () => $548f161e17fc6f48$export$202b1ce7b5d25742);
$parcel$export($548f161e17fc6f48$exports, "RGBA_ASTC_12x12_Format", () => $548f161e17fc6f48$export$18ab77abd087e467);
$parcel$export($548f161e17fc6f48$exports, "RGBA_BPTC_Format", () => $548f161e17fc6f48$export$ce40b115e188bc81);
$parcel$export($548f161e17fc6f48$exports, "RGB_BPTC_SIGNED_Format", () => $548f161e17fc6f48$export$d279c5c4bac5121e);
$parcel$export($548f161e17fc6f48$exports, "RGB_BPTC_UNSIGNED_Format", () => $548f161e17fc6f48$export$cde52d17225fdbd3);
$parcel$export($548f161e17fc6f48$exports, "RED_RGTC1_Format", () => $548f161e17fc6f48$export$b1688df4c4c21670);
$parcel$export($548f161e17fc6f48$exports, "SIGNED_RED_RGTC1_Format", () => $548f161e17fc6f48$export$fc15e5d8261eed58);
$parcel$export($548f161e17fc6f48$exports, "RED_GREEN_RGTC2_Format", () => $548f161e17fc6f48$export$d220f6ade8463a0f);
$parcel$export($548f161e17fc6f48$exports, "SIGNED_RED_GREEN_RGTC2_Format", () => $548f161e17fc6f48$export$768646d09dc1b6ef);
$parcel$export($548f161e17fc6f48$exports, "LoopOnce", () => $548f161e17fc6f48$export$d62fdc9d1b1cccad);
$parcel$export($548f161e17fc6f48$exports, "LoopRepeat", () => $548f161e17fc6f48$export$dfaf4422ce096e29);
$parcel$export($548f161e17fc6f48$exports, "LoopPingPong", () => $548f161e17fc6f48$export$f8f6f2041b78e210);
$parcel$export($548f161e17fc6f48$exports, "InterpolateDiscrete", () => $548f161e17fc6f48$export$995b32462a65e855);
$parcel$export($548f161e17fc6f48$exports, "InterpolateLinear", () => $548f161e17fc6f48$export$30fac1aace31cf4d);
$parcel$export($548f161e17fc6f48$exports, "InterpolateSmooth", () => $548f161e17fc6f48$export$198b11ff4c72bb30);
$parcel$export($548f161e17fc6f48$exports, "ZeroCurvatureEnding", () => $548f161e17fc6f48$export$7f795934b84ab523);
$parcel$export($548f161e17fc6f48$exports, "ZeroSlopeEnding", () => $548f161e17fc6f48$export$24a4ccb5099273b5);
$parcel$export($548f161e17fc6f48$exports, "WrapAroundEnding", () => $548f161e17fc6f48$export$8e8c3ecdcd8e1fee);
$parcel$export($548f161e17fc6f48$exports, "NormalAnimationBlendMode", () => $548f161e17fc6f48$export$bcfbbdcf8de7f8cd);
$parcel$export($548f161e17fc6f48$exports, "AdditiveAnimationBlendMode", () => $548f161e17fc6f48$export$d875e029ef558d3);
$parcel$export($548f161e17fc6f48$exports, "TrianglesDrawMode", () => $548f161e17fc6f48$export$4c28c87c2dc84758);
$parcel$export($548f161e17fc6f48$exports, "TriangleStripDrawMode", () => $548f161e17fc6f48$export$b23a071aa286eb29);
$parcel$export($548f161e17fc6f48$exports, "TriangleFanDrawMode", () => $548f161e17fc6f48$export$f0d8293634f88842);
$parcel$export($548f161e17fc6f48$exports, "LinearEncoding", () => $548f161e17fc6f48$export$7207336e4151a112);
$parcel$export($548f161e17fc6f48$exports, "sRGBEncoding", () => $548f161e17fc6f48$export$f32388edbb32674);
$parcel$export($548f161e17fc6f48$exports, "BasicDepthPacking", () => $548f161e17fc6f48$export$deeb383078690b50);
$parcel$export($548f161e17fc6f48$exports, "RGBADepthPacking", () => $548f161e17fc6f48$export$8f910f4c4f73df11);
$parcel$export($548f161e17fc6f48$exports, "TangentSpaceNormalMap", () => $548f161e17fc6f48$export$2852a58ebdac27b8);
$parcel$export($548f161e17fc6f48$exports, "ObjectSpaceNormalMap", () => $548f161e17fc6f48$export$9990ad26f9db5b2c);
$parcel$export($548f161e17fc6f48$exports, "NoColorSpace", () => $548f161e17fc6f48$export$bfcb490c2dd3db51);
$parcel$export($548f161e17fc6f48$exports, "SRGBColorSpace", () => $548f161e17fc6f48$export$561f394b24edfcaa);
$parcel$export($548f161e17fc6f48$exports, "LinearSRGBColorSpace", () => $548f161e17fc6f48$export$42429b3acfb233a4);
$parcel$export($548f161e17fc6f48$exports, "DisplayP3ColorSpace", () => $548f161e17fc6f48$export$626af19ae879bdf6);
$parcel$export($548f161e17fc6f48$exports, "LinearDisplayP3ColorSpace", () => $548f161e17fc6f48$export$c0dc1bc7e964761);
$parcel$export($548f161e17fc6f48$exports, "LinearTransfer", () => $548f161e17fc6f48$export$f197347d588c1b4a);
$parcel$export($548f161e17fc6f48$exports, "SRGBTransfer", () => $548f161e17fc6f48$export$8d0a61916cc26abb);
$parcel$export($548f161e17fc6f48$exports, "Rec709Primaries", () => $548f161e17fc6f48$export$ce9118f9eaae3bb2);
$parcel$export($548f161e17fc6f48$exports, "P3Primaries", () => $548f161e17fc6f48$export$ef371755dbe7f98a);
$parcel$export($548f161e17fc6f48$exports, "ZeroStencilOp", () => $548f161e17fc6f48$export$69433f11f42d5527);
$parcel$export($548f161e17fc6f48$exports, "KeepStencilOp", () => $548f161e17fc6f48$export$9f542ae4b5baca34);
$parcel$export($548f161e17fc6f48$exports, "ReplaceStencilOp", () => $548f161e17fc6f48$export$8a4f28336ef203d3);
$parcel$export($548f161e17fc6f48$exports, "IncrementStencilOp", () => $548f161e17fc6f48$export$2928c0231297c036);
$parcel$export($548f161e17fc6f48$exports, "DecrementStencilOp", () => $548f161e17fc6f48$export$c0e9611c8a15f9a8);
$parcel$export($548f161e17fc6f48$exports, "IncrementWrapStencilOp", () => $548f161e17fc6f48$export$9c2c08927385dcc4);
$parcel$export($548f161e17fc6f48$exports, "DecrementWrapStencilOp", () => $548f161e17fc6f48$export$7c74ea00fa1315e6);
$parcel$export($548f161e17fc6f48$exports, "InvertStencilOp", () => $548f161e17fc6f48$export$22e2e5726612443);
$parcel$export($548f161e17fc6f48$exports, "NeverStencilFunc", () => $548f161e17fc6f48$export$1343870698229224);
$parcel$export($548f161e17fc6f48$exports, "LessStencilFunc", () => $548f161e17fc6f48$export$8e1d8ed281997fa6);
$parcel$export($548f161e17fc6f48$exports, "EqualStencilFunc", () => $548f161e17fc6f48$export$55648a1cde8329a7);
$parcel$export($548f161e17fc6f48$exports, "LessEqualStencilFunc", () => $548f161e17fc6f48$export$2dff107857e6aca2);
$parcel$export($548f161e17fc6f48$exports, "GreaterStencilFunc", () => $548f161e17fc6f48$export$6f93765ab2f451a2);
$parcel$export($548f161e17fc6f48$exports, "NotEqualStencilFunc", () => $548f161e17fc6f48$export$6f3fb2d2440f2b76);
$parcel$export($548f161e17fc6f48$exports, "GreaterEqualStencilFunc", () => $548f161e17fc6f48$export$4119cf7b4c98fd5a);
$parcel$export($548f161e17fc6f48$exports, "AlwaysStencilFunc", () => $548f161e17fc6f48$export$14cf96713ddd97a8);
$parcel$export($548f161e17fc6f48$exports, "NeverCompare", () => $548f161e17fc6f48$export$d9e2d19a747baaab);
$parcel$export($548f161e17fc6f48$exports, "LessCompare", () => $548f161e17fc6f48$export$36bcf49c713b3eb7);
$parcel$export($548f161e17fc6f48$exports, "EqualCompare", () => $548f161e17fc6f48$export$66f28d946fc6a0d5);
$parcel$export($548f161e17fc6f48$exports, "LessEqualCompare", () => $548f161e17fc6f48$export$64eea11eb407ddf1);
$parcel$export($548f161e17fc6f48$exports, "GreaterCompare", () => $548f161e17fc6f48$export$155af022118f3a38);
$parcel$export($548f161e17fc6f48$exports, "NotEqualCompare", () => $548f161e17fc6f48$export$67ab95dde6bed156);
$parcel$export($548f161e17fc6f48$exports, "GreaterEqualCompare", () => $548f161e17fc6f48$export$1cdcb70d53d65f61);
$parcel$export($548f161e17fc6f48$exports, "AlwaysCompare", () => $548f161e17fc6f48$export$187b73a3e352c145);
$parcel$export($548f161e17fc6f48$exports, "StaticDrawUsage", () => $548f161e17fc6f48$export$763e8360f4d7f77d);
$parcel$export($548f161e17fc6f48$exports, "DynamicDrawUsage", () => $548f161e17fc6f48$export$8505d14ac8546ca);
$parcel$export($548f161e17fc6f48$exports, "StreamDrawUsage", () => $548f161e17fc6f48$export$721e63549e51d81e);
$parcel$export($548f161e17fc6f48$exports, "StaticReadUsage", () => $548f161e17fc6f48$export$415731dc4f48e299);
$parcel$export($548f161e17fc6f48$exports, "DynamicReadUsage", () => $548f161e17fc6f48$export$9e809946455f13bc);
$parcel$export($548f161e17fc6f48$exports, "StreamReadUsage", () => $548f161e17fc6f48$export$2ed9499a35b5f832);
$parcel$export($548f161e17fc6f48$exports, "StaticCopyUsage", () => $548f161e17fc6f48$export$32ab2503ea19469a);
$parcel$export($548f161e17fc6f48$exports, "DynamicCopyUsage", () => $548f161e17fc6f48$export$ab4022c2c3f86315);
$parcel$export($548f161e17fc6f48$exports, "StreamCopyUsage", () => $548f161e17fc6f48$export$ba7f1db36a76a970);
$parcel$export($548f161e17fc6f48$exports, "GLSL1", () => $548f161e17fc6f48$export$43600cc67fabd9f);
$parcel$export($548f161e17fc6f48$exports, "GLSL3", () => $548f161e17fc6f48$export$f63012db5506e7dd);
$parcel$export($548f161e17fc6f48$exports, "_SRGBAFormat", () => $548f161e17fc6f48$export$ca1dce8b5e1de74d);
$parcel$export($548f161e17fc6f48$exports, "WebGLCoordinateSystem", () => $548f161e17fc6f48$export$5a0e9190d10875d3);
$parcel$export($548f161e17fc6f48$exports, "WebGPUCoordinateSystem", () => $548f161e17fc6f48$export$cc83beedcb9be9ac);
$parcel$export($548f161e17fc6f48$exports, "EventDispatcher", () => $548f161e17fc6f48$export$ec8b666c5fe2c75a);
$parcel$export($548f161e17fc6f48$exports, "MathUtils", () => $548f161e17fc6f48$export$6a7ef315a0d1ef07);
$parcel$export($548f161e17fc6f48$exports, "Vector2", () => $548f161e17fc6f48$export$c977b3e384af9ae1);
$parcel$export($548f161e17fc6f48$exports, "Matrix3", () => $548f161e17fc6f48$export$8ff26dafa08918);
$parcel$export($548f161e17fc6f48$exports, "createCanvasElement", () => $548f161e17fc6f48$export$1033a2df66368859);
$parcel$export($548f161e17fc6f48$exports, "ColorManagement", () => $548f161e17fc6f48$export$5e6fd513f44698c);
$parcel$export($548f161e17fc6f48$exports, "ImageUtils", () => $548f161e17fc6f48$export$698882cf06df44aa);
$parcel$export($548f161e17fc6f48$exports, "Source", () => $548f161e17fc6f48$export$1d2df86270c81ecb);
$parcel$export($548f161e17fc6f48$exports, "Texture", () => $548f161e17fc6f48$export$5431306cf43de24a);
$parcel$export($548f161e17fc6f48$exports, "Vector4", () => $548f161e17fc6f48$export$fa7daccca11cdbe3);
$parcel$export($548f161e17fc6f48$exports, "RenderTarget", () => $548f161e17fc6f48$export$efcb1f8bf367cbfb);
$parcel$export($548f161e17fc6f48$exports, "WebGLRenderTarget", () => $548f161e17fc6f48$export$3c052beb2e51e23f);
$parcel$export($548f161e17fc6f48$exports, "DataArrayTexture", () => $548f161e17fc6f48$export$dfac6c8e811406a3);
$parcel$export($548f161e17fc6f48$exports, "WebGLArrayRenderTarget", () => $548f161e17fc6f48$export$c77a02c11ed180c7);
$parcel$export($548f161e17fc6f48$exports, "Data3DTexture", () => $548f161e17fc6f48$export$d7a3086320f856db);
$parcel$export($548f161e17fc6f48$exports, "WebGL3DRenderTarget", () => $548f161e17fc6f48$export$7ee06591009639df);
$parcel$export($548f161e17fc6f48$exports, "WebGLMultipleRenderTargets", () => $548f161e17fc6f48$export$bd934554fb721730);
$parcel$export($548f161e17fc6f48$exports, "Quaternion", () => $548f161e17fc6f48$export$23d6a54f0bbc85a3);
$parcel$export($548f161e17fc6f48$exports, "Vector3", () => $548f161e17fc6f48$export$64b5c384219d3699);
$parcel$export($548f161e17fc6f48$exports, "Box3", () => $548f161e17fc6f48$export$6f7d5a9418ab2aa3);
$parcel$export($548f161e17fc6f48$exports, "Sphere", () => $548f161e17fc6f48$export$805e8b72413ccaba);
$parcel$export($548f161e17fc6f48$exports, "Ray", () => $548f161e17fc6f48$export$a186db52eed6d40e);
$parcel$export($548f161e17fc6f48$exports, "Matrix4", () => $548f161e17fc6f48$export$2ae72fc923e5eb5);
$parcel$export($548f161e17fc6f48$exports, "Euler", () => $548f161e17fc6f48$export$d93cc409a0768c5f);
$parcel$export($548f161e17fc6f48$exports, "Layers", () => $548f161e17fc6f48$export$89312ce47c0ca777);
$parcel$export($548f161e17fc6f48$exports, "Object3D", () => $548f161e17fc6f48$export$e4dd07dff30cc924);
$parcel$export($548f161e17fc6f48$exports, "Triangle", () => $548f161e17fc6f48$export$5a465592bfe74b48);
$parcel$export($548f161e17fc6f48$exports, "Material", () => $548f161e17fc6f48$export$a2d8b23205c25948);
$parcel$export($548f161e17fc6f48$exports, "Color", () => $548f161e17fc6f48$export$892596cec99bc70e);
$parcel$export($548f161e17fc6f48$exports, "MeshBasicMaterial", () => $548f161e17fc6f48$export$55cbcc9b622fe1f5);
$parcel$export($548f161e17fc6f48$exports, "DataUtils", () => $548f161e17fc6f48$export$11ce8b759162cc80);
$parcel$export($548f161e17fc6f48$exports, "BufferAttribute", () => $548f161e17fc6f48$export$8dea267bd6bde117);
$parcel$export($548f161e17fc6f48$exports, "Int8BufferAttribute", () => $548f161e17fc6f48$export$f9ff2d6a20248cbf);
$parcel$export($548f161e17fc6f48$exports, "Uint8BufferAttribute", () => $548f161e17fc6f48$export$cacc90cf35d11cdd);
$parcel$export($548f161e17fc6f48$exports, "Uint8ClampedBufferAttribute", () => $548f161e17fc6f48$export$baaa85a1a812c157);
$parcel$export($548f161e17fc6f48$exports, "Int16BufferAttribute", () => $548f161e17fc6f48$export$2b755a102ccdcefe);
$parcel$export($548f161e17fc6f48$exports, "Uint16BufferAttribute", () => $548f161e17fc6f48$export$640a853f68025f2e);
$parcel$export($548f161e17fc6f48$exports, "Int32BufferAttribute", () => $548f161e17fc6f48$export$46b369aed2968a0a);
$parcel$export($548f161e17fc6f48$exports, "Uint32BufferAttribute", () => $548f161e17fc6f48$export$7eb8c9fa25cd5bd6);
$parcel$export($548f161e17fc6f48$exports, "Float16BufferAttribute", () => $548f161e17fc6f48$export$dbd3698c64958d69);
$parcel$export($548f161e17fc6f48$exports, "Float32BufferAttribute", () => $548f161e17fc6f48$export$cbe7a62641830ebd);
$parcel$export($548f161e17fc6f48$exports, "Float64BufferAttribute", () => $548f161e17fc6f48$export$9e0ade74842adbb8);
$parcel$export($548f161e17fc6f48$exports, "BufferGeometry", () => $548f161e17fc6f48$export$b7be63a67df8959);
$parcel$export($548f161e17fc6f48$exports, "Mesh", () => $548f161e17fc6f48$export$e176487c05830cc5);
$parcel$export($548f161e17fc6f48$exports, "BoxGeometry", () => $548f161e17fc6f48$export$33e43285f7406bd5);
$parcel$export($548f161e17fc6f48$exports, "UniformsUtils", () => $548f161e17fc6f48$export$d8ecdf8615bfea69);
$parcel$export($548f161e17fc6f48$exports, "ShaderMaterial", () => $548f161e17fc6f48$export$83c7d75d550a8b0d);
$parcel$export($548f161e17fc6f48$exports, "Camera", () => $548f161e17fc6f48$export$79f141de891a5fed);
$parcel$export($548f161e17fc6f48$exports, "PerspectiveCamera", () => $548f161e17fc6f48$export$74e4ae24825f68d7);
$parcel$export($548f161e17fc6f48$exports, "CubeCamera", () => $548f161e17fc6f48$export$d0cdd0bd804995de);
$parcel$export($548f161e17fc6f48$exports, "CubeTexture", () => $548f161e17fc6f48$export$ee2e5a18258a4049);
$parcel$export($548f161e17fc6f48$exports, "WebGLCubeRenderTarget", () => $548f161e17fc6f48$export$ac386671d651941e);
$parcel$export($548f161e17fc6f48$exports, "Plane", () => $548f161e17fc6f48$export$7ff5ac152ef991b0);
$parcel$export($548f161e17fc6f48$exports, "Frustum", () => $548f161e17fc6f48$export$35efe6f4c85463d2);
$parcel$export($548f161e17fc6f48$exports, "PlaneGeometry", () => $548f161e17fc6f48$export$967d831af31f69ce);
$parcel$export($548f161e17fc6f48$exports, "ShaderChunk", () => $548f161e17fc6f48$export$955f9f2e84c43c8b);
$parcel$export($548f161e17fc6f48$exports, "UniformsLib", () => $548f161e17fc6f48$export$6643083551874bf5);
$parcel$export($548f161e17fc6f48$exports, "ShaderLib", () => $548f161e17fc6f48$export$bee4a7d47f8f5014);
$parcel$export($548f161e17fc6f48$exports, "OrthographicCamera", () => $548f161e17fc6f48$export$9ebf355ee4ed261b);
$parcel$export($548f161e17fc6f48$exports, "PMREMGenerator", () => $548f161e17fc6f48$export$6add42717753e221);
$parcel$export($548f161e17fc6f48$exports, "MeshDepthMaterial", () => $548f161e17fc6f48$export$2698c22ec13825db);
$parcel$export($548f161e17fc6f48$exports, "MeshDistanceMaterial", () => $548f161e17fc6f48$export$33e187ed002f2a19);
$parcel$export($548f161e17fc6f48$exports, "WebGLUtils", () => $548f161e17fc6f48$export$ddaebcad857649a8);
$parcel$export($548f161e17fc6f48$exports, "ArrayCamera", () => $548f161e17fc6f48$export$56b937d9e5581166);
$parcel$export($548f161e17fc6f48$exports, "Group", () => $548f161e17fc6f48$export$eb2fcfdbd7ba97d4);
$parcel$export($548f161e17fc6f48$exports, "DepthTexture", () => $548f161e17fc6f48$export$fc830aa069cc8c2f);
$parcel$export($548f161e17fc6f48$exports, "WebGLRenderer", () => $548f161e17fc6f48$export$f6cc00ef28d7cf97);
$parcel$export($548f161e17fc6f48$exports, "WebGL1Renderer", () => $548f161e17fc6f48$export$a2f65229194348f9);
$parcel$export($548f161e17fc6f48$exports, "FogExp2", () => $548f161e17fc6f48$export$6f1519f023b8d0f6);
$parcel$export($548f161e17fc6f48$exports, "Fog", () => $548f161e17fc6f48$export$3c890837b09508d4);
$parcel$export($548f161e17fc6f48$exports, "Scene", () => $548f161e17fc6f48$export$38af1803e3442a7f);
$parcel$export($548f161e17fc6f48$exports, "InterleavedBuffer", () => $548f161e17fc6f48$export$3d5cd879f108f53f);
$parcel$export($548f161e17fc6f48$exports, "InterleavedBufferAttribute", () => $548f161e17fc6f48$export$920b6d07334599c7);
$parcel$export($548f161e17fc6f48$exports, "SpriteMaterial", () => $548f161e17fc6f48$export$5ec7dd1c6994bf8e);
$parcel$export($548f161e17fc6f48$exports, "Sprite", () => $548f161e17fc6f48$export$3075603db8e6204c);
$parcel$export($548f161e17fc6f48$exports, "LOD", () => $548f161e17fc6f48$export$112e7237be0c5f30);
$parcel$export($548f161e17fc6f48$exports, "SkinnedMesh", () => $548f161e17fc6f48$export$b303577035157ecf);
$parcel$export($548f161e17fc6f48$exports, "Bone", () => $548f161e17fc6f48$export$b127726e56765aa4);
$parcel$export($548f161e17fc6f48$exports, "DataTexture", () => $548f161e17fc6f48$export$b691f601014eabe1);
$parcel$export($548f161e17fc6f48$exports, "Skeleton", () => $548f161e17fc6f48$export$8f31e4c4a37b8e9c);
$parcel$export($548f161e17fc6f48$exports, "InstancedBufferAttribute", () => $548f161e17fc6f48$export$32ea87a8b54d744a);
$parcel$export($548f161e17fc6f48$exports, "InstancedMesh", () => $548f161e17fc6f48$export$f3c979c331175ad7);
$parcel$export($548f161e17fc6f48$exports, "LineBasicMaterial", () => $548f161e17fc6f48$export$fbaaa33907730a0c);
$parcel$export($548f161e17fc6f48$exports, "Line", () => $548f161e17fc6f48$export$17d680238e50603e);
$parcel$export($548f161e17fc6f48$exports, "LineSegments", () => $548f161e17fc6f48$export$ff1ed10fedfdd604);
$parcel$export($548f161e17fc6f48$exports, "LineLoop", () => $548f161e17fc6f48$export$f85a24d745e4f17d);
$parcel$export($548f161e17fc6f48$exports, "PointsMaterial", () => $548f161e17fc6f48$export$a178c45366ce5d6b);
$parcel$export($548f161e17fc6f48$exports, "Points", () => $548f161e17fc6f48$export$1c787534cb11aa3e);
$parcel$export($548f161e17fc6f48$exports, "VideoTexture", () => $548f161e17fc6f48$export$6e09d1edf8d5a25c);
$parcel$export($548f161e17fc6f48$exports, "FramebufferTexture", () => $548f161e17fc6f48$export$9270d786f73ce6fe);
$parcel$export($548f161e17fc6f48$exports, "CompressedTexture", () => $548f161e17fc6f48$export$3466bac9141a5cc4);
$parcel$export($548f161e17fc6f48$exports, "CompressedArrayTexture", () => $548f161e17fc6f48$export$5fe6b8e34b274fcb);
$parcel$export($548f161e17fc6f48$exports, "CompressedCubeTexture", () => $548f161e17fc6f48$export$d80173634de65bff);
$parcel$export($548f161e17fc6f48$exports, "CanvasTexture", () => $548f161e17fc6f48$export$f7189e49152d1c13);
$parcel$export($548f161e17fc6f48$exports, "Curve", () => $548f161e17fc6f48$export$b0e83c3ef8d2db1);
$parcel$export($548f161e17fc6f48$exports, "EllipseCurve", () => $548f161e17fc6f48$export$3f87a931616cde04);
$parcel$export($548f161e17fc6f48$exports, "ArcCurve", () => $548f161e17fc6f48$export$b1eedc9aab6300e8);
$parcel$export($548f161e17fc6f48$exports, "CatmullRomCurve3", () => $548f161e17fc6f48$export$b9146b27c24b744c);
$parcel$export($548f161e17fc6f48$exports, "CubicBezierCurve", () => $548f161e17fc6f48$export$e36650d36468bb39);
$parcel$export($548f161e17fc6f48$exports, "CubicBezierCurve3", () => $548f161e17fc6f48$export$13d5f1c9525f246c);
$parcel$export($548f161e17fc6f48$exports, "LineCurve", () => $548f161e17fc6f48$export$ab2e07e76531a47e);
$parcel$export($548f161e17fc6f48$exports, "LineCurve3", () => $548f161e17fc6f48$export$1fdfd9d9cf487600);
$parcel$export($548f161e17fc6f48$exports, "QuadraticBezierCurve", () => $548f161e17fc6f48$export$5938c4ee491a43ad);
$parcel$export($548f161e17fc6f48$exports, "QuadraticBezierCurve3", () => $548f161e17fc6f48$export$bf3f4c7e459f90fc);
$parcel$export($548f161e17fc6f48$exports, "SplineCurve", () => $548f161e17fc6f48$export$d3bdd77da77afc1b);
$parcel$export($548f161e17fc6f48$exports, "CurvePath", () => $548f161e17fc6f48$export$4aaf9b66af1bbf2c);
$parcel$export($548f161e17fc6f48$exports, "Path", () => $548f161e17fc6f48$export$4b2950bdac9b6ee9);
$parcel$export($548f161e17fc6f48$exports, "LatheGeometry", () => $548f161e17fc6f48$export$6d839803fcd1882c);
$parcel$export($548f161e17fc6f48$exports, "CapsuleGeometry", () => $548f161e17fc6f48$export$41680e8551036033);
$parcel$export($548f161e17fc6f48$exports, "CircleGeometry", () => $548f161e17fc6f48$export$d5c0e8d607467193);
$parcel$export($548f161e17fc6f48$exports, "CylinderGeometry", () => $548f161e17fc6f48$export$68f745719dbe5198);
$parcel$export($548f161e17fc6f48$exports, "ConeGeometry", () => $548f161e17fc6f48$export$a7a48974f285c9b3);
$parcel$export($548f161e17fc6f48$exports, "PolyhedronGeometry", () => $548f161e17fc6f48$export$60e57a7d3f20ff65);
$parcel$export($548f161e17fc6f48$exports, "DodecahedronGeometry", () => $548f161e17fc6f48$export$c0babfeb8708fc9c);
$parcel$export($548f161e17fc6f48$exports, "EdgesGeometry", () => $548f161e17fc6f48$export$4730b1542707547f);
$parcel$export($548f161e17fc6f48$exports, "Shape", () => $548f161e17fc6f48$export$6428a7f2611ef1fa);
$parcel$export($548f161e17fc6f48$exports, "ShapeUtils", () => $548f161e17fc6f48$export$96bdf6d9c66d7ba8);
$parcel$export($548f161e17fc6f48$exports, "ExtrudeGeometry", () => $548f161e17fc6f48$export$598697a1efa63ca7);
$parcel$export($548f161e17fc6f48$exports, "IcosahedronGeometry", () => $548f161e17fc6f48$export$9567cc828c9535da);
$parcel$export($548f161e17fc6f48$exports, "OctahedronGeometry", () => $548f161e17fc6f48$export$1954e2b809fe361e);
$parcel$export($548f161e17fc6f48$exports, "RingGeometry", () => $548f161e17fc6f48$export$68cb731f50f614af);
$parcel$export($548f161e17fc6f48$exports, "ShapeGeometry", () => $548f161e17fc6f48$export$57a29a1c803e9065);
$parcel$export($548f161e17fc6f48$exports, "SphereGeometry", () => $548f161e17fc6f48$export$1b417fc3b307a251);
$parcel$export($548f161e17fc6f48$exports, "TetrahedronGeometry", () => $548f161e17fc6f48$export$fb3f7adc68bd6e02);
$parcel$export($548f161e17fc6f48$exports, "TorusGeometry", () => $548f161e17fc6f48$export$a2312a2a1fa56495);
$parcel$export($548f161e17fc6f48$exports, "TorusKnotGeometry", () => $548f161e17fc6f48$export$77e9bfadfb9ab8c8);
$parcel$export($548f161e17fc6f48$exports, "TubeGeometry", () => $548f161e17fc6f48$export$7897d9d48904490c);
$parcel$export($548f161e17fc6f48$exports, "WireframeGeometry", () => $548f161e17fc6f48$export$4b739da06d24892b);
$parcel$export($548f161e17fc6f48$exports, "ShadowMaterial", () => $548f161e17fc6f48$export$e8564da406055a3);
$parcel$export($548f161e17fc6f48$exports, "RawShaderMaterial", () => $548f161e17fc6f48$export$21c421a2e1df9d22);
$parcel$export($548f161e17fc6f48$exports, "MeshStandardMaterial", () => $548f161e17fc6f48$export$f2980790215acccd);
$parcel$export($548f161e17fc6f48$exports, "MeshPhysicalMaterial", () => $548f161e17fc6f48$export$28d04986c4269c9f);
$parcel$export($548f161e17fc6f48$exports, "MeshPhongMaterial", () => $548f161e17fc6f48$export$24c72f71cbaf0678);
$parcel$export($548f161e17fc6f48$exports, "MeshToonMaterial", () => $548f161e17fc6f48$export$df893cf97e765622);
$parcel$export($548f161e17fc6f48$exports, "MeshNormalMaterial", () => $548f161e17fc6f48$export$bfe8c0a091f41ae7);
$parcel$export($548f161e17fc6f48$exports, "MeshLambertMaterial", () => $548f161e17fc6f48$export$5023a9a8114806b8);
$parcel$export($548f161e17fc6f48$exports, "MeshMatcapMaterial", () => $548f161e17fc6f48$export$6f5fef6235ec12ee);
$parcel$export($548f161e17fc6f48$exports, "LineDashedMaterial", () => $548f161e17fc6f48$export$327886a3efaeaebe);
$parcel$export($548f161e17fc6f48$exports, "AnimationUtils", () => $548f161e17fc6f48$export$7ee8caa573e71ad1);
$parcel$export($548f161e17fc6f48$exports, "Interpolant", () => $548f161e17fc6f48$export$b558baee9c0f72d3);
$parcel$export($548f161e17fc6f48$exports, "CubicInterpolant", () => $548f161e17fc6f48$export$3646682e7a3959);
$parcel$export($548f161e17fc6f48$exports, "LinearInterpolant", () => $548f161e17fc6f48$export$a8e6009059f51e1a);
$parcel$export($548f161e17fc6f48$exports, "DiscreteInterpolant", () => $548f161e17fc6f48$export$fb9758ef7ef8d5cc);
$parcel$export($548f161e17fc6f48$exports, "KeyframeTrack", () => $548f161e17fc6f48$export$b0e479f45b7006d6);
$parcel$export($548f161e17fc6f48$exports, "BooleanKeyframeTrack", () => $548f161e17fc6f48$export$d3a344b98cf0b775);
$parcel$export($548f161e17fc6f48$exports, "ColorKeyframeTrack", () => $548f161e17fc6f48$export$83444c5d885347d8);
$parcel$export($548f161e17fc6f48$exports, "NumberKeyframeTrack", () => $548f161e17fc6f48$export$d45f0d1a4d9a9314);
$parcel$export($548f161e17fc6f48$exports, "QuaternionLinearInterpolant", () => $548f161e17fc6f48$export$2db1cfb7923d931e);
$parcel$export($548f161e17fc6f48$exports, "QuaternionKeyframeTrack", () => $548f161e17fc6f48$export$b8043f12b5aafbd7);
$parcel$export($548f161e17fc6f48$exports, "StringKeyframeTrack", () => $548f161e17fc6f48$export$6ce41d4f3a8df9cd);
$parcel$export($548f161e17fc6f48$exports, "VectorKeyframeTrack", () => $548f161e17fc6f48$export$5ce2dcb4cc9f2bff);
$parcel$export($548f161e17fc6f48$exports, "AnimationClip", () => $548f161e17fc6f48$export$d942c706bf23829c);
$parcel$export($548f161e17fc6f48$exports, "Cache", () => $548f161e17fc6f48$export$94affb487e701bf2);
$parcel$export($548f161e17fc6f48$exports, "LoadingManager", () => $548f161e17fc6f48$export$99cc795e99919eed);
$parcel$export($548f161e17fc6f48$exports, "DefaultLoadingManager", () => $548f161e17fc6f48$export$b033c3f9a95c6a16);
$parcel$export($548f161e17fc6f48$exports, "Loader", () => $548f161e17fc6f48$export$3b0d6d7590275603);
$parcel$export($548f161e17fc6f48$exports, "FileLoader", () => $548f161e17fc6f48$export$98435a25b5cf7b2b);
$parcel$export($548f161e17fc6f48$exports, "AnimationLoader", () => $548f161e17fc6f48$export$29711c7e14f61db);
$parcel$export($548f161e17fc6f48$exports, "CompressedTextureLoader", () => $548f161e17fc6f48$export$bd73ce947a280350);
$parcel$export($548f161e17fc6f48$exports, "ImageLoader", () => $548f161e17fc6f48$export$8905ce1c7a2464a1);
$parcel$export($548f161e17fc6f48$exports, "CubeTextureLoader", () => $548f161e17fc6f48$export$2ec114afc2cf6308);
$parcel$export($548f161e17fc6f48$exports, "DataTextureLoader", () => $548f161e17fc6f48$export$792d8a18f2c55855);
$parcel$export($548f161e17fc6f48$exports, "TextureLoader", () => $548f161e17fc6f48$export$fd1bfc71f64c538c);
$parcel$export($548f161e17fc6f48$exports, "Light", () => $548f161e17fc6f48$export$6ecadb6ed240d696);
$parcel$export($548f161e17fc6f48$exports, "HemisphereLight", () => $548f161e17fc6f48$export$8d474f55edbb9624);
$parcel$export($548f161e17fc6f48$exports, "SpotLight", () => $548f161e17fc6f48$export$81495cbb73897362);
$parcel$export($548f161e17fc6f48$exports, "PointLight", () => $548f161e17fc6f48$export$4c9c1cb3f0b6f455);
$parcel$export($548f161e17fc6f48$exports, "DirectionalLight", () => $548f161e17fc6f48$export$3fea33cc9972c868);
$parcel$export($548f161e17fc6f48$exports, "AmbientLight", () => $548f161e17fc6f48$export$af279bfef9ec2c96);
$parcel$export($548f161e17fc6f48$exports, "RectAreaLight", () => $548f161e17fc6f48$export$61db2d908bbd2429);
$parcel$export($548f161e17fc6f48$exports, "SphericalHarmonics3", () => $548f161e17fc6f48$export$ba61ce607e1f405a);
$parcel$export($548f161e17fc6f48$exports, "LightProbe", () => $548f161e17fc6f48$export$e7ef036e309b38d2);
$parcel$export($548f161e17fc6f48$exports, "MaterialLoader", () => $548f161e17fc6f48$export$3bd6d323353dcf96);
$parcel$export($548f161e17fc6f48$exports, "LoaderUtils", () => $548f161e17fc6f48$export$b5d2dc08d867e41a);
$parcel$export($548f161e17fc6f48$exports, "InstancedBufferGeometry", () => $548f161e17fc6f48$export$231f009cbe414146);
$parcel$export($548f161e17fc6f48$exports, "BufferGeometryLoader", () => $548f161e17fc6f48$export$dc275bb96327833a);
$parcel$export($548f161e17fc6f48$exports, "ObjectLoader", () => $548f161e17fc6f48$export$40110c8505c5ad19);
$parcel$export($548f161e17fc6f48$exports, "ImageBitmapLoader", () => $548f161e17fc6f48$export$52286b55c4a9b51f);
$parcel$export($548f161e17fc6f48$exports, "AudioContext", () => $548f161e17fc6f48$export$fcbc63750ec2a81f);
$parcel$export($548f161e17fc6f48$exports, "AudioLoader", () => $548f161e17fc6f48$export$d8d5fccfbf47714e);
$parcel$export($548f161e17fc6f48$exports, "StereoCamera", () => $548f161e17fc6f48$export$bc7f73a1065bee0c);
$parcel$export($548f161e17fc6f48$exports, "Clock", () => $548f161e17fc6f48$export$9735c82c4bae3302);
$parcel$export($548f161e17fc6f48$exports, "AudioListener", () => $548f161e17fc6f48$export$8a1b810c6fde8951);
$parcel$export($548f161e17fc6f48$exports, "Audio", () => $548f161e17fc6f48$export$153755f98d9861de);
$parcel$export($548f161e17fc6f48$exports, "PositionalAudio", () => $548f161e17fc6f48$export$4b3e397ef1832507);
$parcel$export($548f161e17fc6f48$exports, "AudioAnalyser", () => $548f161e17fc6f48$export$d47da1ef3d382827);
$parcel$export($548f161e17fc6f48$exports, "PropertyMixer", () => $548f161e17fc6f48$export$dfe0af1ca1acb78a);
$parcel$export($548f161e17fc6f48$exports, "PropertyBinding", () => $548f161e17fc6f48$export$7bf70fcf9f891893);
$parcel$export($548f161e17fc6f48$exports, "AnimationObjectGroup", () => $548f161e17fc6f48$export$30619c2afd3f34db);
$parcel$export($548f161e17fc6f48$exports, "AnimationAction", () => $548f161e17fc6f48$export$6946940a69e799e);
$parcel$export($548f161e17fc6f48$exports, "AnimationMixer", () => $548f161e17fc6f48$export$fbd77e5aefaa0102);
$parcel$export($548f161e17fc6f48$exports, "Uniform", () => $548f161e17fc6f48$export$2947cebfe91c02f8);
$parcel$export($548f161e17fc6f48$exports, "UniformsGroup", () => $548f161e17fc6f48$export$c412d5ffe1f79209);
$parcel$export($548f161e17fc6f48$exports, "InstancedInterleavedBuffer", () => $548f161e17fc6f48$export$25ec0e1af1389358);
$parcel$export($548f161e17fc6f48$exports, "GLBufferAttribute", () => $548f161e17fc6f48$export$6b7339ae8dbddf73);
$parcel$export($548f161e17fc6f48$exports, "Raycaster", () => $548f161e17fc6f48$export$8b7aaceff00bd2f);
$parcel$export($548f161e17fc6f48$exports, "Spherical", () => $548f161e17fc6f48$export$d712cd887b4a00f7);
$parcel$export($548f161e17fc6f48$exports, "Cylindrical", () => $548f161e17fc6f48$export$287165bb2177f4fd);
$parcel$export($548f161e17fc6f48$exports, "Box2", () => $548f161e17fc6f48$export$60f553fa130f08b0);
$parcel$export($548f161e17fc6f48$exports, "Line3", () => $548f161e17fc6f48$export$e0ba6359f1954fd3);
$parcel$export($548f161e17fc6f48$exports, "SpotLightHelper", () => $548f161e17fc6f48$export$4b14638ffdd81e68);
$parcel$export($548f161e17fc6f48$exports, "SkeletonHelper", () => $548f161e17fc6f48$export$5277df3c9e732259);
$parcel$export($548f161e17fc6f48$exports, "PointLightHelper", () => $548f161e17fc6f48$export$9a9291685b9e4023);
$parcel$export($548f161e17fc6f48$exports, "HemisphereLightHelper", () => $548f161e17fc6f48$export$8dca15f13f4f8172);
$parcel$export($548f161e17fc6f48$exports, "GridHelper", () => $548f161e17fc6f48$export$3875d39926561055);
$parcel$export($548f161e17fc6f48$exports, "PolarGridHelper", () => $548f161e17fc6f48$export$361430a10f533cd3);
$parcel$export($548f161e17fc6f48$exports, "DirectionalLightHelper", () => $548f161e17fc6f48$export$f8e434dc14203e7d);
$parcel$export($548f161e17fc6f48$exports, "CameraHelper", () => $548f161e17fc6f48$export$ed8e93f853cd795);
$parcel$export($548f161e17fc6f48$exports, "BoxHelper", () => $548f161e17fc6f48$export$38a664cc862a6a9d);
$parcel$export($548f161e17fc6f48$exports, "Box3Helper", () => $548f161e17fc6f48$export$ce39f4bb96c9a290);
$parcel$export($548f161e17fc6f48$exports, "PlaneHelper", () => $548f161e17fc6f48$export$a34fe8156c66e5d7);
$parcel$export($548f161e17fc6f48$exports, "ArrowHelper", () => $548f161e17fc6f48$export$a3008e7bd8d2cbe7);
$parcel$export($548f161e17fc6f48$exports, "AxesHelper", () => $548f161e17fc6f48$export$6c8303f35b8578fd);
$parcel$export($548f161e17fc6f48$exports, "ShapePath", () => $548f161e17fc6f48$export$148534a3c727230b);
/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $548f161e17fc6f48$export$3545e07a80636437 = '157';
const $548f161e17fc6f48$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $548f161e17fc6f48$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $548f161e17fc6f48$export$3237e1f2c1ea1f44 = 0;
const $548f161e17fc6f48$export$b9a7b4fc5cb15f9b = 1;
const $548f161e17fc6f48$export$b8058bcc7037d3f3 = 2;
const $548f161e17fc6f48$export$f24be24dcddeac0d = 3;
const $548f161e17fc6f48$export$346307dbae2b7447 = 0;
const $548f161e17fc6f48$export$5813f879eee7cd88 = 1;
const $548f161e17fc6f48$export$a47c4b43a1be34f0 = 2;
const $548f161e17fc6f48$export$896ae1ade6c829c4 = 3;
const $548f161e17fc6f48$export$2ede184fc2998901 = 0;
const $548f161e17fc6f48$export$d9f0486e75b5ace = 1;
const $548f161e17fc6f48$export$3b296b6f144d5b03 = 2;
const $548f161e17fc6f48$export$211211c00f97204d = 2; // r149
const $548f161e17fc6f48$export$63b8d6b580fc65ba = 0;
const $548f161e17fc6f48$export$5b29a26d96ee6af0 = 1;
const $548f161e17fc6f48$export$777d8f9551c2216b = 2;
const $548f161e17fc6f48$export$cdfa06f868e2e467 = 3;
const $548f161e17fc6f48$export$4138e1c684b46a20 = 4;
const $548f161e17fc6f48$export$eda4864c68df1fa2 = 5;
const $548f161e17fc6f48$export$20183a0484ce21a0 = 100;
const $548f161e17fc6f48$export$73e0df5177988548 = 101;
const $548f161e17fc6f48$export$28e582859cbec660 = 102;
const $548f161e17fc6f48$export$c8c1508da8d0600c = 103;
const $548f161e17fc6f48$export$99948c02fb51055f = 104;
const $548f161e17fc6f48$export$2110f05edf778d3d = 200;
const $548f161e17fc6f48$export$8805bad65e24940e = 201;
const $548f161e17fc6f48$export$7fbe15b28d28cf52 = 202;
const $548f161e17fc6f48$export$947829af9f2c17f6 = 203;
const $548f161e17fc6f48$export$d5773124e86cf28c = 204;
const $548f161e17fc6f48$export$11d468cc7f19e971 = 205;
const $548f161e17fc6f48$export$a78aed1ca2a87192 = 206;
const $548f161e17fc6f48$export$5d0fe17fd8773bac = 207;
const $548f161e17fc6f48$export$ef5f2dd8ffac5574 = 208;
const $548f161e17fc6f48$export$56b85b2686ab16 = 209;
const $548f161e17fc6f48$export$c05e2a1fc8609506 = 210;
const $548f161e17fc6f48$export$69025ce147cee220 = 0;
const $548f161e17fc6f48$export$7182eb52ea3b3f04 = 1;
const $548f161e17fc6f48$export$eedccec66ab7ebe = 2;
const $548f161e17fc6f48$export$296f78a0b892f81a = 3;
const $548f161e17fc6f48$export$a60d398fc7b7590e = 4;
const $548f161e17fc6f48$export$7d7234c1240a1fc4 = 5;
const $548f161e17fc6f48$export$c5e2c52991f30937 = 6;
const $548f161e17fc6f48$export$2f843afa843d8916 = 7;
const $548f161e17fc6f48$export$e50ac29801f1774d = 0;
const $548f161e17fc6f48$export$9f9d94f963c85479 = 1;
const $548f161e17fc6f48$export$e641dc52bc3494aa = 2;
const $548f161e17fc6f48$export$9fcb6b4294603b2 = 0;
const $548f161e17fc6f48$export$98f52c2a46c598ca = 1;
const $548f161e17fc6f48$export$74b25e54b3bcd548 = 2;
const $548f161e17fc6f48$export$932b3dd283d4a366 = 3;
const $548f161e17fc6f48$export$a0d98fe6d7e4af64 = 4;
const $548f161e17fc6f48$export$2c7b09c1e9abfb5e = 5;
const $548f161e17fc6f48$export$1beec6768cbb3d2d = 300;
const $548f161e17fc6f48$export$8759762a6477f2c4 = 301;
const $548f161e17fc6f48$export$dc59f8aed047f61d = 302;
const $548f161e17fc6f48$export$d64030b316d3b087 = 303;
const $548f161e17fc6f48$export$ee99d97d46898098 = 304;
const $548f161e17fc6f48$export$dbf3e70ff37af79 = 306;
const $548f161e17fc6f48$export$533346c8e8dac0f5 = 1000;
const $548f161e17fc6f48$export$9d9334239a5a5e06 = 1001;
const $548f161e17fc6f48$export$c7e7c00b14f51a4f = 1002;
const $548f161e17fc6f48$export$727aa5ec3fe39bf0 = 1003;
const $548f161e17fc6f48$export$d129e38cf6feaa8c = 1004;
const $548f161e17fc6f48$export$14a4936464a36496 = 1004;
const $548f161e17fc6f48$export$d2327c1afe5bfdf2 = 1005;
const $548f161e17fc6f48$export$cbc5b7f5647595d8 = 1005;
const $548f161e17fc6f48$export$8a72f490b25c56c8 = 1006;
const $548f161e17fc6f48$export$19a719f377145a13 = 1007;
const $548f161e17fc6f48$export$dbe96bee3fe9dbf0 = 1007;
const $548f161e17fc6f48$export$5d8599b6a933fb1b = 1008;
const $548f161e17fc6f48$export$90d80f1e3506775f = 1008;
const $548f161e17fc6f48$export$2e8ce08d3f6f5e10 = 1009;
const $548f161e17fc6f48$export$545fce0311a9796a = 1010;
const $548f161e17fc6f48$export$88572337f312435f = 1011;
const $548f161e17fc6f48$export$c63dc51868b06a9d = 1012;
const $548f161e17fc6f48$export$5c612977753abe2 = 1013;
const $548f161e17fc6f48$export$c3c7fc4518ebba96 = 1014;
const $548f161e17fc6f48$export$f6d331659b644596 = 1015;
const $548f161e17fc6f48$export$2697304443f382bc = 1016;
const $548f161e17fc6f48$export$b3969b01faf587f2 = 1017;
const $548f161e17fc6f48$export$18886f8ae33e90de = 1018;
const $548f161e17fc6f48$export$6c8ea339bfab1301 = 1020;
const $548f161e17fc6f48$export$988473390501ed4b = 1021;
const $548f161e17fc6f48$export$3f8bb04b555a363c = 1023;
const $548f161e17fc6f48$export$cc09ccbf6d1ed449 = 1024;
const $548f161e17fc6f48$export$9053a81c4a69c289 = 1025;
const $548f161e17fc6f48$export$c1b6b5136be58045 = 1026;
const $548f161e17fc6f48$export$1e113ac2d0905829 = 1027;
const $548f161e17fc6f48$export$4e041a7967d15c4b = 1028;
const $548f161e17fc6f48$export$aa92e870a709d190 = 1029;
const $548f161e17fc6f48$export$6cdf0b461c7ce8a0 = 1030;
const $548f161e17fc6f48$export$1ba1c45f9f77d4d7 = 1031;
const $548f161e17fc6f48$export$c200e7d26f592f21 = 1033;
const $548f161e17fc6f48$export$21d1799c6d552fc0 = 33776;
const $548f161e17fc6f48$export$afa304c3e981b668 = 33777;
const $548f161e17fc6f48$export$d2a1a68024a3e56c = 33778;
const $548f161e17fc6f48$export$9a79c424327dacf9 = 33779;
const $548f161e17fc6f48$export$19ada9bbb1af3573 = 35840;
const $548f161e17fc6f48$export$d0f0355bb3d948e4 = 35841;
const $548f161e17fc6f48$export$b82296714358084c = 35842;
const $548f161e17fc6f48$export$b71692456c47b6c3 = 35843;
const $548f161e17fc6f48$export$6ab91af2d757aee7 = 36196;
const $548f161e17fc6f48$export$7800993ef8106a6a = 37492;
const $548f161e17fc6f48$export$23ed8300a860e7d8 = 37496;
const $548f161e17fc6f48$export$dc5570b4a2b92d48 = 37808;
const $548f161e17fc6f48$export$68880cd325f8b2fb = 37809;
const $548f161e17fc6f48$export$7d2c0be323373d95 = 37810;
const $548f161e17fc6f48$export$22b52da301fc3a3e = 37811;
const $548f161e17fc6f48$export$c009e2cb4a66485e = 37812;
const $548f161e17fc6f48$export$118fff5afa255b63 = 37813;
const $548f161e17fc6f48$export$120713c829ae0667 = 37814;
const $548f161e17fc6f48$export$c79eeabbf53313e9 = 37815;
const $548f161e17fc6f48$export$443cf6567cdd6424 = 37816;
const $548f161e17fc6f48$export$6573984fc9840780 = 37817;
const $548f161e17fc6f48$export$e7aee563f30091de = 37818;
const $548f161e17fc6f48$export$2eb8634622ddeab7 = 37819;
const $548f161e17fc6f48$export$202b1ce7b5d25742 = 37820;
const $548f161e17fc6f48$export$18ab77abd087e467 = 37821;
const $548f161e17fc6f48$export$ce40b115e188bc81 = 36492;
const $548f161e17fc6f48$export$d279c5c4bac5121e = 36494;
const $548f161e17fc6f48$export$cde52d17225fdbd3 = 36495;
const $548f161e17fc6f48$export$b1688df4c4c21670 = 36283;
const $548f161e17fc6f48$export$fc15e5d8261eed58 = 36284;
const $548f161e17fc6f48$export$d220f6ade8463a0f = 36285;
const $548f161e17fc6f48$export$768646d09dc1b6ef = 36286;
const $548f161e17fc6f48$export$d62fdc9d1b1cccad = 2200;
const $548f161e17fc6f48$export$dfaf4422ce096e29 = 2201;
const $548f161e17fc6f48$export$f8f6f2041b78e210 = 2202;
const $548f161e17fc6f48$export$995b32462a65e855 = 2300;
const $548f161e17fc6f48$export$30fac1aace31cf4d = 2301;
const $548f161e17fc6f48$export$198b11ff4c72bb30 = 2302;
const $548f161e17fc6f48$export$7f795934b84ab523 = 2400;
const $548f161e17fc6f48$export$24a4ccb5099273b5 = 2401;
const $548f161e17fc6f48$export$8e8c3ecdcd8e1fee = 2402;
const $548f161e17fc6f48$export$bcfbbdcf8de7f8cd = 2500;
const $548f161e17fc6f48$export$d875e029ef558d3 = 2501;
const $548f161e17fc6f48$export$4c28c87c2dc84758 = 0;
const $548f161e17fc6f48$export$b23a071aa286eb29 = 1;
const $548f161e17fc6f48$export$f0d8293634f88842 = 2;
/** @deprecated Use LinearSRGBColorSpace or NoColorSpace in three.js r152+. */ const $548f161e17fc6f48$export$7207336e4151a112 = 3000;
/** @deprecated Use SRGBColorSpace in three.js r152+. */ const $548f161e17fc6f48$export$f32388edbb32674 = 3001;
const $548f161e17fc6f48$export$deeb383078690b50 = 3200;
const $548f161e17fc6f48$export$8f910f4c4f73df11 = 3201;
const $548f161e17fc6f48$export$2852a58ebdac27b8 = 0;
const $548f161e17fc6f48$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $548f161e17fc6f48$export$bfcb490c2dd3db51 = '';
const $548f161e17fc6f48$export$561f394b24edfcaa = 'srgb';
const $548f161e17fc6f48$export$42429b3acfb233a4 = 'srgb-linear';
const $548f161e17fc6f48$export$626af19ae879bdf6 = 'display-p3';
const $548f161e17fc6f48$export$c0dc1bc7e964761 = 'display-p3-linear';
const $548f161e17fc6f48$export$f197347d588c1b4a = 'linear';
const $548f161e17fc6f48$export$8d0a61916cc26abb = 'srgb';
const $548f161e17fc6f48$export$ce9118f9eaae3bb2 = 'rec709';
const $548f161e17fc6f48$export$ef371755dbe7f98a = 'p3';
const $548f161e17fc6f48$export$69433f11f42d5527 = 0;
const $548f161e17fc6f48$export$9f542ae4b5baca34 = 7680;
const $548f161e17fc6f48$export$8a4f28336ef203d3 = 7681;
const $548f161e17fc6f48$export$2928c0231297c036 = 7682;
const $548f161e17fc6f48$export$c0e9611c8a15f9a8 = 7683;
const $548f161e17fc6f48$export$9c2c08927385dcc4 = 34055;
const $548f161e17fc6f48$export$7c74ea00fa1315e6 = 34056;
const $548f161e17fc6f48$export$22e2e5726612443 = 5386;
const $548f161e17fc6f48$export$1343870698229224 = 512;
const $548f161e17fc6f48$export$8e1d8ed281997fa6 = 513;
const $548f161e17fc6f48$export$55648a1cde8329a7 = 514;
const $548f161e17fc6f48$export$2dff107857e6aca2 = 515;
const $548f161e17fc6f48$export$6f93765ab2f451a2 = 516;
const $548f161e17fc6f48$export$6f3fb2d2440f2b76 = 517;
const $548f161e17fc6f48$export$4119cf7b4c98fd5a = 518;
const $548f161e17fc6f48$export$14cf96713ddd97a8 = 519;
const $548f161e17fc6f48$export$d9e2d19a747baaab = 512;
const $548f161e17fc6f48$export$36bcf49c713b3eb7 = 513;
const $548f161e17fc6f48$export$66f28d946fc6a0d5 = 514;
const $548f161e17fc6f48$export$64eea11eb407ddf1 = 515;
const $548f161e17fc6f48$export$155af022118f3a38 = 516;
const $548f161e17fc6f48$export$67ab95dde6bed156 = 517;
const $548f161e17fc6f48$export$1cdcb70d53d65f61 = 518;
const $548f161e17fc6f48$export$187b73a3e352c145 = 519;
const $548f161e17fc6f48$export$763e8360f4d7f77d = 35044;
const $548f161e17fc6f48$export$8505d14ac8546ca = 35048;
const $548f161e17fc6f48$export$721e63549e51d81e = 35040;
const $548f161e17fc6f48$export$415731dc4f48e299 = 35045;
const $548f161e17fc6f48$export$9e809946455f13bc = 35049;
const $548f161e17fc6f48$export$2ed9499a35b5f832 = 35041;
const $548f161e17fc6f48$export$32ab2503ea19469a = 35046;
const $548f161e17fc6f48$export$ab4022c2c3f86315 = 35050;
const $548f161e17fc6f48$export$ba7f1db36a76a970 = 35042;
const $548f161e17fc6f48$export$43600cc67fabd9f = '100';
const $548f161e17fc6f48$export$f63012db5506e7dd = '300 es';
const $548f161e17fc6f48$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
const $548f161e17fc6f48$export$5a0e9190d10875d3 = 2000;
const $548f161e17fc6f48$export$cc83beedcb9be9ac = 2001;
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $548f161e17fc6f48$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $548f161e17fc6f48$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $548f161e17fc6f48$var$_seed = 1234567;
const $548f161e17fc6f48$var$DEG2RAD = Math.PI / 180;
const $548f161e17fc6f48$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $548f161e17fc6f48$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $548f161e17fc6f48$var$_lut[d0 & 0xff] + $548f161e17fc6f48$var$_lut[d0 >> 8 & 0xff] + $548f161e17fc6f48$var$_lut[d0 >> 16 & 0xff] + $548f161e17fc6f48$var$_lut[d0 >> 24 & 0xff] + '-' + $548f161e17fc6f48$var$_lut[d1 & 0xff] + $548f161e17fc6f48$var$_lut[d1 >> 8 & 0xff] + '-' + $548f161e17fc6f48$var$_lut[d1 >> 16 & 0x0f | 0x40] + $548f161e17fc6f48$var$_lut[d1 >> 24 & 0xff] + '-' + $548f161e17fc6f48$var$_lut[d2 & 0x3f | 0x80] + $548f161e17fc6f48$var$_lut[d2 >> 8 & 0xff] + '-' + $548f161e17fc6f48$var$_lut[d2 >> 16 & 0xff] + $548f161e17fc6f48$var$_lut[d2 >> 24 & 0xff] + $548f161e17fc6f48$var$_lut[d3 & 0xff] + $548f161e17fc6f48$var$_lut[d3 >> 8 & 0xff] + $548f161e17fc6f48$var$_lut[d3 >> 16 & 0xff] + $548f161e17fc6f48$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $548f161e17fc6f48$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $548f161e17fc6f48$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $548f161e17fc6f48$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $548f161e17fc6f48$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $548f161e17fc6f48$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $548f161e17fc6f48$var$damp(x, y, lambda, dt) {
    return $548f161e17fc6f48$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $548f161e17fc6f48$var$pingpong(x, length = 1) {
    return length - Math.abs($548f161e17fc6f48$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $548f161e17fc6f48$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $548f161e17fc6f48$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $548f161e17fc6f48$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $548f161e17fc6f48$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $548f161e17fc6f48$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $548f161e17fc6f48$var$seededRandom(s) {
    if (s !== undefined) $548f161e17fc6f48$var$_seed = s;
    // Mulberry32 generator
    let t = $548f161e17fc6f48$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $548f161e17fc6f48$var$degToRad(degrees) {
    return degrees * $548f161e17fc6f48$var$DEG2RAD;
}
function $548f161e17fc6f48$var$radToDeg(radians) {
    return radians * $548f161e17fc6f48$var$RAD2DEG;
}
function $548f161e17fc6f48$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $548f161e17fc6f48$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $548f161e17fc6f48$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $548f161e17fc6f48$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
function $548f161e17fc6f48$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
function $548f161e17fc6f48$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
const $548f161e17fc6f48$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $548f161e17fc6f48$var$DEG2RAD,
    RAD2DEG: $548f161e17fc6f48$var$RAD2DEG,
    generateUUID: $548f161e17fc6f48$var$generateUUID,
    clamp: $548f161e17fc6f48$var$clamp,
    euclideanModulo: $548f161e17fc6f48$var$euclideanModulo,
    mapLinear: $548f161e17fc6f48$var$mapLinear,
    inverseLerp: $548f161e17fc6f48$var$inverseLerp,
    lerp: $548f161e17fc6f48$var$lerp,
    damp: $548f161e17fc6f48$var$damp,
    pingpong: $548f161e17fc6f48$var$pingpong,
    smoothstep: $548f161e17fc6f48$var$smoothstep,
    smootherstep: $548f161e17fc6f48$var$smootherstep,
    randInt: $548f161e17fc6f48$var$randInt,
    randFloat: $548f161e17fc6f48$var$randFloat,
    randFloatSpread: $548f161e17fc6f48$var$randFloatSpread,
    seededRandom: $548f161e17fc6f48$var$seededRandom,
    degToRad: $548f161e17fc6f48$var$degToRad,
    radToDeg: $548f161e17fc6f48$var$radToDeg,
    isPowerOfTwo: $548f161e17fc6f48$var$isPowerOfTwo,
    ceilPowerOfTwo: $548f161e17fc6f48$var$ceilPowerOfTwo,
    floorPowerOfTwo: $548f161e17fc6f48$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $548f161e17fc6f48$var$setQuaternionFromProperEuler,
    normalize: $548f161e17fc6f48$var$normalize,
    denormalize: $548f161e17fc6f48$var$denormalize
};
class $548f161e17fc6f48$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $548f161e17fc6f48$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($548f161e17fc6f48$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $548f161e17fc6f48$export$8ff26dafa08918 {
    constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        $548f161e17fc6f48$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($548f161e17fc6f48$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($548f161e17fc6f48$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($548f161e17fc6f48$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $548f161e17fc6f48$var$_m3 = /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918();
function $548f161e17fc6f48$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $548f161e17fc6f48$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $548f161e17fc6f48$var$getTypedArray(type, buffer) {
    return new $548f161e17fc6f48$var$TYPED_ARRAYS[type](buffer);
}
function $548f161e17fc6f48$var$createElementNS(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $548f161e17fc6f48$export$1033a2df66368859() {
    const canvas = $548f161e17fc6f48$var$createElementNS('canvas');
    canvas.style.display = 'block';
    return canvas;
}
const $548f161e17fc6f48$var$_cache = {};
function $548f161e17fc6f48$var$warnOnce(message) {
    if (message in $548f161e17fc6f48$var$_cache) return;
    $548f161e17fc6f48$var$_cache[message] = true;
    console.warn(message);
}
/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */ const $548f161e17fc6f48$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918().set(0.8224621, 0.177538, 0.0, 0.0331941, 0.9668058, 0.0, 0.0170827, 0.0723974, 0.9105199);
const $548f161e17fc6f48$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918().set(1.2249401, -0.2249404, 0.0, -0.0420569, 1.0420571, 0.0, -0.0196376, -0.0786361, 1.0982735);
/**
 * Defines supported color spaces by transfer function and primaries,
 * and provides conversions to/from the Linear-sRGB reference space.
 */ const $548f161e17fc6f48$var$COLOR_SPACES = {
    [$548f161e17fc6f48$export$42429b3acfb233a4]: {
        transfer: $548f161e17fc6f48$export$f197347d588c1b4a,
        primaries: $548f161e17fc6f48$export$ce9118f9eaae3bb2,
        toReference: (color)=>color,
        fromReference: (color)=>color
    },
    [$548f161e17fc6f48$export$561f394b24edfcaa]: {
        transfer: $548f161e17fc6f48$export$8d0a61916cc26abb,
        primaries: $548f161e17fc6f48$export$ce9118f9eaae3bb2,
        toReference: (color)=>color.convertSRGBToLinear(),
        fromReference: (color)=>color.convertLinearToSRGB()
    },
    [$548f161e17fc6f48$export$c0dc1bc7e964761]: {
        transfer: $548f161e17fc6f48$export$f197347d588c1b4a,
        primaries: $548f161e17fc6f48$export$ef371755dbe7f98a,
        toReference: (color)=>color.applyMatrix3($548f161e17fc6f48$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB),
        fromReference: (color)=>color.applyMatrix3($548f161e17fc6f48$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3)
    },
    [$548f161e17fc6f48$export$626af19ae879bdf6]: {
        transfer: $548f161e17fc6f48$export$8d0a61916cc26abb,
        primaries: $548f161e17fc6f48$export$ef371755dbe7f98a,
        toReference: (color)=>color.convertSRGBToLinear().applyMatrix3($548f161e17fc6f48$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB),
        fromReference: (color)=>color.applyMatrix3($548f161e17fc6f48$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB()
    }
};
const $548f161e17fc6f48$var$SUPPORTED_WORKING_COLOR_SPACES = new Set([
    $548f161e17fc6f48$export$42429b3acfb233a4,
    $548f161e17fc6f48$export$c0dc1bc7e964761
]);
const $548f161e17fc6f48$export$5e6fd513f44698c = {
    enabled: true,
    _workingColorSpace: $548f161e17fc6f48$export$42429b3acfb233a4,
    get legacyMode () {
        console.warn('THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.');
        return !this.enabled;
    },
    set legacyMode (legacyMode){
        console.warn('THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.');
        this.enabled = !legacyMode;
    },
    get workingColorSpace () {
        return this._workingColorSpace;
    },
    set workingColorSpace (colorSpace){
        if (!$548f161e17fc6f48$var$SUPPORTED_WORKING_COLOR_SPACES.has(colorSpace)) throw new Error(`Unsupported working color space, "${colorSpace}".`);
        this._workingColorSpace = colorSpace;
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        const sourceToReference = $548f161e17fc6f48$var$COLOR_SPACES[sourceColorSpace].toReference;
        const targetFromReference = $548f161e17fc6f48$var$COLOR_SPACES[targetColorSpace].fromReference;
        return targetFromReference(sourceToReference(color));
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this._workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this._workingColorSpace);
    },
    getPrimaries: function(colorSpace1) {
        return $548f161e17fc6f48$var$COLOR_SPACES[colorSpace1].primaries;
    },
    getTransfer: function(colorSpace1) {
        if (colorSpace1 === $548f161e17fc6f48$export$bfcb490c2dd3db51) return $548f161e17fc6f48$export$f197347d588c1b4a;
        return $548f161e17fc6f48$var$COLOR_SPACES[colorSpace1].transfer;
    }
};
function $548f161e17fc6f48$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $548f161e17fc6f48$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let $548f161e17fc6f48$var$_canvas;
class $548f161e17fc6f48$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($548f161e17fc6f48$var$_canvas === undefined) $548f161e17fc6f48$var$_canvas = $548f161e17fc6f48$var$createElementNS('canvas');
            $548f161e17fc6f48$var$_canvas.width = image.width;
            $548f161e17fc6f48$var$_canvas.height = image.height;
            const context = $548f161e17fc6f48$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $548f161e17fc6f48$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn('THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image);
            return canvas.toDataURL('image/jpeg', 0.6);
        } else return canvas.toDataURL('image/png');
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $548f161e17fc6f48$var$createElementNS('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $548f161e17fc6f48$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($548f161e17fc6f48$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $548f161e17fc6f48$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
let $548f161e17fc6f48$var$_sourceId = 0;
class $548f161e17fc6f48$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        Object.defineProperty(this, 'id', {
            value: $548f161e17fc6f48$var$_sourceId++
        });
        this.uuid = $548f161e17fc6f48$var$generateUUID();
        this.data = data;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($548f161e17fc6f48$var$serializeImage(data[i].image));
                else url.push($548f161e17fc6f48$var$serializeImage(data[i]));
            } else // texture
            url = $548f161e17fc6f48$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $548f161e17fc6f48$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $548f161e17fc6f48$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $548f161e17fc6f48$var$_textureId = 0;
class $548f161e17fc6f48$export$5431306cf43de24a extends $548f161e17fc6f48$export$ec8b666c5fe2c75a {
    constructor(image = $548f161e17fc6f48$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $548f161e17fc6f48$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $548f161e17fc6f48$export$9d9334239a5a5e06, wrapT = $548f161e17fc6f48$export$9d9334239a5a5e06, magFilter = $548f161e17fc6f48$export$8a72f490b25c56c8, minFilter = $548f161e17fc6f48$export$5d8599b6a933fb1b, format = $548f161e17fc6f48$export$3f8bb04b555a363c, type = $548f161e17fc6f48$export$2e8ce08d3f6f5e10, anisotropy = $548f161e17fc6f48$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace1 = $548f161e17fc6f48$export$bfcb490c2dd3db51){
        super();
        this.isTexture = true;
        Object.defineProperty(this, 'id', {
            value: $548f161e17fc6f48$var$_textureId++
        });
        this.uuid = $548f161e17fc6f48$var$generateUUID();
        this.name = '';
        this.source = new $548f161e17fc6f48$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $548f161e17fc6f48$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $548f161e17fc6f48$export$c977b3e384af9ae1(1, 1);
        this.center = new $548f161e17fc6f48$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $548f161e17fc6f48$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        if (typeof colorSpace1 === 'string') this.colorSpace = colorSpace1;
        else {
            $548f161e17fc6f48$var$warnOnce('THREE.Texture: Property .encoding has been replaced by .colorSpace.');
            this.colorSpace = colorSpace1 === $548f161e17fc6f48$export$f32388edbb32674 ? $548f161e17fc6f48$export$561f394b24edfcaa : $548f161e17fc6f48$export$bfcb490c2dd3db51;
        }
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    transformUv(uv) {
        if (this.mapping !== $548f161e17fc6f48$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $548f161e17fc6f48$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $548f161e17fc6f48$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $548f161e17fc6f48$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $548f161e17fc6f48$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $548f161e17fc6f48$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $548f161e17fc6f48$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    get encoding() {
        $548f161e17fc6f48$var$warnOnce('THREE.Texture: Property .encoding has been replaced by .colorSpace.');
        return this.colorSpace === $548f161e17fc6f48$export$561f394b24edfcaa ? $548f161e17fc6f48$export$f32388edbb32674 : $548f161e17fc6f48$export$7207336e4151a112;
    }
    set encoding(encoding) {
        $548f161e17fc6f48$var$warnOnce('THREE.Texture: Property .encoding has been replaced by .colorSpace.');
        this.colorSpace = encoding === $548f161e17fc6f48$export$f32388edbb32674 ? $548f161e17fc6f48$export$561f394b24edfcaa : $548f161e17fc6f48$export$bfcb490c2dd3db51;
    }
}
$548f161e17fc6f48$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$548f161e17fc6f48$export$5431306cf43de24a.DEFAULT_MAPPING = $548f161e17fc6f48$export$1beec6768cbb3d2d;
$548f161e17fc6f48$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $548f161e17fc6f48$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $548f161e17fc6f48$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $548f161e17fc6f48$export$efcb1f8bf367cbfb extends $548f161e17fc6f48$export$ec8b666c5fe2c75a {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $548f161e17fc6f48$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $548f161e17fc6f48$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $548f161e17fc6f48$var$warnOnce('THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace.');
            options.colorSpace = options.encoding === $548f161e17fc6f48$export$f32388edbb32674 ? $548f161e17fc6f48$export$561f394b24edfcaa : $548f161e17fc6f48$export$bfcb490c2dd3db51;
        }
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $548f161e17fc6f48$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            depthTexture: null,
            samples: 0
        }, options);
        this.texture = new $548f161e17fc6f48$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        this.texture.isRenderTargetTexture = true;
        this.texture.flipY = false;
        this.texture.generateMipmaps = options.generateMipmaps;
        this.texture.internalFormat = options.internalFormat;
        this.depthBuffer = options.depthBuffer;
        this.stencilBuffer = options.stencilBuffer;
        this.depthTexture = options.depthTexture;
        this.samples = options.samples;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.texture.isRenderTargetTexture = true;
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $548f161e17fc6f48$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class $548f161e17fc6f48$export$3c052beb2e51e23f extends $548f161e17fc6f48$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        this.isWebGLRenderTarget = true;
    }
}
class $548f161e17fc6f48$export$dfac6c8e811406a3 extends $548f161e17fc6f48$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $548f161e17fc6f48$export$727aa5ec3fe39bf0;
        this.minFilter = $548f161e17fc6f48$export$727aa5ec3fe39bf0;
        this.wrapR = $548f161e17fc6f48$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $548f161e17fc6f48$export$c77a02c11ed180c7 extends $548f161e17fc6f48$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $548f161e17fc6f48$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $548f161e17fc6f48$export$d7a3086320f856db extends $548f161e17fc6f48$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $548f161e17fc6f48$export$727aa5ec3fe39bf0;
        this.minFilter = $548f161e17fc6f48$export$727aa5ec3fe39bf0;
        this.wrapR = $548f161e17fc6f48$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $548f161e17fc6f48$export$7ee06591009639df extends $548f161e17fc6f48$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $548f161e17fc6f48$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $548f161e17fc6f48$export$bd934554fb721730 extends $548f161e17fc6f48$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, count = 1, options = {}){
        super(width, height, options);
        this.isWebGLMultipleRenderTargets = true;
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++){
            this.texture[i] = texture.clone();
            this.texture[i].isRenderTargetTexture = true;
        }
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++){
            this.texture[i] = source.texture[i].clone();
            this.texture[i].isRenderTargetTexture = true;
        }
        return this;
    }
}
class $548f161e17fc6f48$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($548f161e17fc6f48$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $548f161e17fc6f48$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $548f161e17fc6f48$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($548f161e17fc6f48$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($548f161e17fc6f48$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $548f161e17fc6f48$var$_vector$b.copy(this).projectOnVector(planeNormal);
        return this.sub($548f161e17fc6f48$var$_vector$b);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($548f161e17fc6f48$var$_vector$b.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($548f161e17fc6f48$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $548f161e17fc6f48$var$_vector$b = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_quaternion$4 = /*@__PURE__*/ new $548f161e17fc6f48$export$23d6a54f0bbc85a3();
class $548f161e17fc6f48$export$6f7d5a9418ab2aa3 {
    constructor(min = new $548f161e17fc6f48$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $548f161e17fc6f48$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($548f161e17fc6f48$var$_vector$a.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($548f161e17fc6f48$var$_vector$a.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $548f161e17fc6f48$var$_vector$a.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        if (object.boundingBox !== undefined) {
            if (object.boundingBox === null) object.computeBoundingBox();
            $548f161e17fc6f48$var$_box$3.copy(object.boundingBox);
            $548f161e17fc6f48$var$_box$3.applyMatrix4(object.matrixWorld);
            this.union($548f161e17fc6f48$var$_box$3);
        } else {
            const geometry = object.geometry;
            if (geometry !== undefined) {
                if (precise && geometry.attributes !== undefined && geometry.attributes.position !== undefined) {
                    const position = geometry.attributes.position;
                    for(let i = 0, l = position.count; i < l; i++){
                        $548f161e17fc6f48$var$_vector$a.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
                        this.expandByPoint($548f161e17fc6f48$var$_vector$a);
                    }
                } else {
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $548f161e17fc6f48$var$_box$3.copy(geometry.boundingBox);
                    $548f161e17fc6f48$var$_box$3.applyMatrix4(object.matrixWorld);
                    this.union($548f161e17fc6f48$var$_box$3);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $548f161e17fc6f48$var$_vector$a);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $548f161e17fc6f48$var$_vector$a.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($548f161e17fc6f48$var$_center);
        $548f161e17fc6f48$var$_extents.subVectors(this.max, $548f161e17fc6f48$var$_center);
        // translate triangle to aabb origin
        $548f161e17fc6f48$var$_v0$2.subVectors(triangle.a, $548f161e17fc6f48$var$_center);
        $548f161e17fc6f48$var$_v1$7.subVectors(triangle.b, $548f161e17fc6f48$var$_center);
        $548f161e17fc6f48$var$_v2$4.subVectors(triangle.c, $548f161e17fc6f48$var$_center);
        // compute edge vectors for triangle
        $548f161e17fc6f48$var$_f0.subVectors($548f161e17fc6f48$var$_v1$7, $548f161e17fc6f48$var$_v0$2);
        $548f161e17fc6f48$var$_f1.subVectors($548f161e17fc6f48$var$_v2$4, $548f161e17fc6f48$var$_v1$7);
        $548f161e17fc6f48$var$_f2.subVectors($548f161e17fc6f48$var$_v0$2, $548f161e17fc6f48$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$548f161e17fc6f48$var$_f0.z,
            $548f161e17fc6f48$var$_f0.y,
            0,
            -$548f161e17fc6f48$var$_f1.z,
            $548f161e17fc6f48$var$_f1.y,
            0,
            -$548f161e17fc6f48$var$_f2.z,
            $548f161e17fc6f48$var$_f2.y,
            $548f161e17fc6f48$var$_f0.z,
            0,
            -$548f161e17fc6f48$var$_f0.x,
            $548f161e17fc6f48$var$_f1.z,
            0,
            -$548f161e17fc6f48$var$_f1.x,
            $548f161e17fc6f48$var$_f2.z,
            0,
            -$548f161e17fc6f48$var$_f2.x,
            -$548f161e17fc6f48$var$_f0.y,
            $548f161e17fc6f48$var$_f0.x,
            0,
            -$548f161e17fc6f48$var$_f1.y,
            $548f161e17fc6f48$var$_f1.x,
            0,
            -$548f161e17fc6f48$var$_f2.y,
            $548f161e17fc6f48$var$_f2.x,
            0
        ];
        if (!$548f161e17fc6f48$var$satForAxes(axes, $548f161e17fc6f48$var$_v0$2, $548f161e17fc6f48$var$_v1$7, $548f161e17fc6f48$var$_v2$4, $548f161e17fc6f48$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$548f161e17fc6f48$var$satForAxes(axes, $548f161e17fc6f48$var$_v0$2, $548f161e17fc6f48$var$_v1$7, $548f161e17fc6f48$var$_v2$4, $548f161e17fc6f48$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $548f161e17fc6f48$var$_triangleNormal.crossVectors($548f161e17fc6f48$var$_f0, $548f161e17fc6f48$var$_f1);
        axes = [
            $548f161e17fc6f48$var$_triangleNormal.x,
            $548f161e17fc6f48$var$_triangleNormal.y,
            $548f161e17fc6f48$var$_triangleNormal.z
        ];
        return $548f161e17fc6f48$var$satForAxes(axes, $548f161e17fc6f48$var$_v0$2, $548f161e17fc6f48$var$_v1$7, $548f161e17fc6f48$var$_v2$4, $548f161e17fc6f48$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $548f161e17fc6f48$var$_vector$a).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($548f161e17fc6f48$var$_vector$a).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $548f161e17fc6f48$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $548f161e17fc6f48$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $548f161e17fc6f48$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $548f161e17fc6f48$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $548f161e17fc6f48$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $548f161e17fc6f48$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $548f161e17fc6f48$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $548f161e17fc6f48$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($548f161e17fc6f48$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $548f161e17fc6f48$var$_points = [
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699()
];
const $548f161e17fc6f48$var$_vector$a = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_box$3 = /*@__PURE__*/ new $548f161e17fc6f48$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $548f161e17fc6f48$var$_v0$2 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_v1$7 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_v2$4 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
// triangle edge vectors
const $548f161e17fc6f48$var$_f0 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_f1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_f2 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_center = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_extents = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_triangleNormal = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_testAxis = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
function $548f161e17fc6f48$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $548f161e17fc6f48$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($548f161e17fc6f48$var$_testAxis.x) + extents.y * Math.abs($548f161e17fc6f48$var$_testAxis.y) + extents.z * Math.abs($548f161e17fc6f48$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($548f161e17fc6f48$var$_testAxis);
        const p1 = v1.dot($548f161e17fc6f48$var$_testAxis);
        const p2 = v2.dot($548f161e17fc6f48$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $548f161e17fc6f48$var$_box$2 = /*@__PURE__*/ new $548f161e17fc6f48$export$6f7d5a9418ab2aa3();
const $548f161e17fc6f48$var$_v1$6 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_v2$3 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$export$805e8b72413ccaba {
    constructor(center = new $548f161e17fc6f48$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $548f161e17fc6f48$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $548f161e17fc6f48$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $548f161e17fc6f48$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($548f161e17fc6f48$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $548f161e17fc6f48$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($548f161e17fc6f48$var$_v1$6.copy(sphere.center).add($548f161e17fc6f48$var$_v2$3));
            this.expandByPoint($548f161e17fc6f48$var$_v1$6.copy(sphere.center).sub($548f161e17fc6f48$var$_v2$3));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $548f161e17fc6f48$var$_vector$9 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_segCenter = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_segDir = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_diff = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_edge1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_edge2 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_normal$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$export$a186db52eed6d40e {
    constructor(origin = new $548f161e17fc6f48$export$64b5c384219d3699(), direction = new $548f161e17fc6f48$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $548f161e17fc6f48$var$_vector$9));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $548f161e17fc6f48$var$_vector$9.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $548f161e17fc6f48$var$_vector$9.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $548f161e17fc6f48$var$_vector$9.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $548f161e17fc6f48$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $548f161e17fc6f48$var$_segDir.copy(v1).sub(v0).normalize();
        $548f161e17fc6f48$var$_diff.copy(this.origin).sub($548f161e17fc6f48$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($548f161e17fc6f48$var$_segDir);
        const b0 = $548f161e17fc6f48$var$_diff.dot(this.direction);
        const b1 = -$548f161e17fc6f48$var$_diff.dot($548f161e17fc6f48$var$_segDir);
        const c = $548f161e17fc6f48$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($548f161e17fc6f48$var$_segCenter).addScaledVector($548f161e17fc6f48$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $548f161e17fc6f48$var$_vector$9.subVectors(sphere.center, this.origin);
        const tca = $548f161e17fc6f48$var$_vector$9.dot(this.direction);
        const d2 = $548f161e17fc6f48$var$_vector$9.dot($548f161e17fc6f48$var$_vector$9) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $548f161e17fc6f48$var$_vector$9) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $548f161e17fc6f48$var$_edge1.subVectors(b, a);
        $548f161e17fc6f48$var$_edge2.subVectors(c, a);
        $548f161e17fc6f48$var$_normal$1.crossVectors($548f161e17fc6f48$var$_edge1, $548f161e17fc6f48$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($548f161e17fc6f48$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $548f161e17fc6f48$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($548f161e17fc6f48$var$_edge2.crossVectors($548f161e17fc6f48$var$_diff, $548f161e17fc6f48$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($548f161e17fc6f48$var$_edge1.cross($548f161e17fc6f48$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $548f161e17fc6f48$var$_diff.dot($548f161e17fc6f48$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $548f161e17fc6f48$export$2ae72fc923e5eb5 {
    constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        $548f161e17fc6f48$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $548f161e17fc6f48$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $548f161e17fc6f48$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $548f161e17fc6f48$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $548f161e17fc6f48$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($548f161e17fc6f48$var$_zero, q, $548f161e17fc6f48$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $548f161e17fc6f48$var$_z.subVectors(eye, target);
        if ($548f161e17fc6f48$var$_z.lengthSq() === 0) // eye and target are in the same position
        $548f161e17fc6f48$var$_z.z = 1;
        $548f161e17fc6f48$var$_z.normalize();
        $548f161e17fc6f48$var$_x.crossVectors(up, $548f161e17fc6f48$var$_z);
        if ($548f161e17fc6f48$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $548f161e17fc6f48$var$_z.x += 0.0001;
            else $548f161e17fc6f48$var$_z.z += 0.0001;
            $548f161e17fc6f48$var$_z.normalize();
            $548f161e17fc6f48$var$_x.crossVectors(up, $548f161e17fc6f48$var$_z);
        }
        $548f161e17fc6f48$var$_x.normalize();
        $548f161e17fc6f48$var$_y.crossVectors($548f161e17fc6f48$var$_z, $548f161e17fc6f48$var$_x);
        te[0] = $548f161e17fc6f48$var$_x.x;
        te[4] = $548f161e17fc6f48$var$_y.x;
        te[8] = $548f161e17fc6f48$var$_z.x;
        te[1] = $548f161e17fc6f48$var$_x.y;
        te[5] = $548f161e17fc6f48$var$_y.y;
        te[9] = $548f161e17fc6f48$var$_z.y;
        te[2] = $548f161e17fc6f48$var$_x.z;
        te[6] = $548f161e17fc6f48$var$_y.z;
        te[10] = $548f161e17fc6f48$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $548f161e17fc6f48$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $548f161e17fc6f48$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $548f161e17fc6f48$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $548f161e17fc6f48$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $548f161e17fc6f48$var$_m1$2.elements[0] *= invSX;
        $548f161e17fc6f48$var$_m1$2.elements[1] *= invSX;
        $548f161e17fc6f48$var$_m1$2.elements[2] *= invSX;
        $548f161e17fc6f48$var$_m1$2.elements[4] *= invSY;
        $548f161e17fc6f48$var$_m1$2.elements[5] *= invSY;
        $548f161e17fc6f48$var$_m1$2.elements[6] *= invSY;
        $548f161e17fc6f48$var$_m1$2.elements[8] *= invSZ;
        $548f161e17fc6f48$var$_m1$2.elements[9] *= invSZ;
        $548f161e17fc6f48$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($548f161e17fc6f48$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far, coordinateSystem = $548f161e17fc6f48$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $548f161e17fc6f48$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $548f161e17fc6f48$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $548f161e17fc6f48$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $548f161e17fc6f48$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $548f161e17fc6f48$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $548f161e17fc6f48$var$_v1$5 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_m1$2 = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_zero = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(0, 0, 0);
const $548f161e17fc6f48$var$_one = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(1, 1, 1);
const $548f161e17fc6f48$var$_x = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_y = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_z = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_matrix = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_quaternion$3 = /*@__PURE__*/ new $548f161e17fc6f48$export$23d6a54f0bbc85a3();
class $548f161e17fc6f48$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $548f161e17fc6f48$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($548f161e17fc6f48$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$548f161e17fc6f48$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($548f161e17fc6f48$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$548f161e17fc6f48$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($548f161e17fc6f48$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$548f161e17fc6f48$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $548f161e17fc6f48$var$_matrix.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($548f161e17fc6f48$var$_matrix, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $548f161e17fc6f48$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($548f161e17fc6f48$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
$548f161e17fc6f48$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
class $548f161e17fc6f48$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $548f161e17fc6f48$var$_object3DId = 0;
const $548f161e17fc6f48$var$_v1$4 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_q1 = /*@__PURE__*/ new $548f161e17fc6f48$export$23d6a54f0bbc85a3();
const $548f161e17fc6f48$var$_m1$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_target = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_position$3 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_scale$2 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_quaternion$2 = /*@__PURE__*/ new $548f161e17fc6f48$export$23d6a54f0bbc85a3();
const $548f161e17fc6f48$var$_xAxis = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(1, 0, 0);
const $548f161e17fc6f48$var$_yAxis = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(0, 1, 0);
const $548f161e17fc6f48$var$_zAxis = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(0, 0, 1);
const $548f161e17fc6f48$var$_addedEvent = {
    type: 'added'
};
const $548f161e17fc6f48$var$_removedEvent = {
    type: 'removed'
};
class $548f161e17fc6f48$export$e4dd07dff30cc924 extends $548f161e17fc6f48$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, 'id', {
            value: $548f161e17fc6f48$var$_object3DId++
        });
        this.uuid = $548f161e17fc6f48$var$generateUUID();
        this.name = '';
        this.type = 'Object3D';
        this.parent = null;
        this.children = [];
        this.up = $548f161e17fc6f48$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $548f161e17fc6f48$export$64b5c384219d3699();
        const rotation = new $548f161e17fc6f48$export$d93cc409a0768c5f();
        const quaternion = new $548f161e17fc6f48$export$23d6a54f0bbc85a3();
        const scale = new $548f161e17fc6f48$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $548f161e17fc6f48$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $548f161e17fc6f48$export$8ff26dafa08918()
            }
        });
        this.matrix = new $548f161e17fc6f48$export$2ae72fc923e5eb5();
        this.matrixWorld = new $548f161e17fc6f48$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $548f161e17fc6f48$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldNeedsUpdate = false;
        this.matrixWorldAutoUpdate = $548f161e17fc6f48$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.layers = new $548f161e17fc6f48$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $548f161e17fc6f48$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($548f161e17fc6f48$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $548f161e17fc6f48$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($548f161e17fc6f48$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($548f161e17fc6f48$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($548f161e17fc6f48$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($548f161e17fc6f48$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $548f161e17fc6f48$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($548f161e17fc6f48$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($548f161e17fc6f48$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($548f161e17fc6f48$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($548f161e17fc6f48$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($548f161e17fc6f48$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $548f161e17fc6f48$var$_target.copy(x);
        else $548f161e17fc6f48$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $548f161e17fc6f48$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $548f161e17fc6f48$var$_m1$1.lookAt($548f161e17fc6f48$var$_position$3, $548f161e17fc6f48$var$_target, this.up);
        else $548f161e17fc6f48$var$_m1$1.lookAt($548f161e17fc6f48$var$_target, $548f161e17fc6f48$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($548f161e17fc6f48$var$_m1$1);
        if (parent) {
            $548f161e17fc6f48$var$_m1$1.extractRotation(parent.matrixWorld);
            $548f161e17fc6f48$var$_q1.setFromRotationMatrix($548f161e17fc6f48$var$_m1$1);
            this.quaternion.premultiply($548f161e17fc6f48$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($548f161e17fc6f48$var$_addedEvent);
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($548f161e17fc6f48$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        return this.remove(...this.children);
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $548f161e17fc6f48$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $548f161e17fc6f48$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($548f161e17fc6f48$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value) {
        let result = [];
        if (this[name] === value) result.push(this);
        for(let i = 0, l = this.children.length; i < l; i++){
            const childResult = this.children[i].getObjectsByProperty(name, value);
            if (childResult.length > 0) result = result.concat(childResult);
        }
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($548f161e17fc6f48$var$_position$3, target, $548f161e17fc6f48$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($548f161e17fc6f48$var$_position$3, $548f161e17fc6f48$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            if (child.matrixWorldAutoUpdate === true || force === true) child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null && parent.matrixWorldAutoUpdate === true) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                if (child.matrixWorldAutoUpdate === true) child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$548f161e17fc6f48$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(0, 1, 0);
$548f161e17fc6f48$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$548f161e17fc6f48$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $548f161e17fc6f48$var$_v0$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_v1$3 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_v2$2 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_v3$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_vab = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_vac = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_vbc = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_vap = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_vbp = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_vcp = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
let $548f161e17fc6f48$var$warnedGetUV = false;
class $548f161e17fc6f48$export$5a465592bfe74b48 {
    constructor(a = new $548f161e17fc6f48$export$64b5c384219d3699(), b = new $548f161e17fc6f48$export$64b5c384219d3699(), c = new $548f161e17fc6f48$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $548f161e17fc6f48$var$_v0$1.subVectors(a, b);
        target.cross($548f161e17fc6f48$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $548f161e17fc6f48$var$_v0$1.subVectors(c, a);
        $548f161e17fc6f48$var$_v1$3.subVectors(b, a);
        $548f161e17fc6f48$var$_v2$2.subVectors(point, a);
        const dot00 = $548f161e17fc6f48$var$_v0$1.dot($548f161e17fc6f48$var$_v0$1);
        const dot01 = $548f161e17fc6f48$var$_v0$1.dot($548f161e17fc6f48$var$_v1$3);
        const dot02 = $548f161e17fc6f48$var$_v0$1.dot($548f161e17fc6f48$var$_v2$2);
        const dot11 = $548f161e17fc6f48$var$_v1$3.dot($548f161e17fc6f48$var$_v1$3);
        const dot12 = $548f161e17fc6f48$var$_v1$3.dot($548f161e17fc6f48$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $548f161e17fc6f48$var$_v3$1);
        return $548f161e17fc6f48$var$_v3$1.x >= 0 && $548f161e17fc6f48$var$_v3$1.y >= 0 && $548f161e17fc6f48$var$_v3$1.x + $548f161e17fc6f48$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        if ($548f161e17fc6f48$var$warnedGetUV === false) {
            console.warn('THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().');
            $548f161e17fc6f48$var$warnedGetUV = true;
        }
        return this.getInterpolation(point, p1, p2, p3, uv1, uv2, uv3, target);
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        this.getBarycoord(point, p1, p2, p3, $548f161e17fc6f48$var$_v3$1);
        target.setScalar(0);
        target.addScaledVector(v1, $548f161e17fc6f48$var$_v3$1.x);
        target.addScaledVector(v2, $548f161e17fc6f48$var$_v3$1.y);
        target.addScaledVector(v3, $548f161e17fc6f48$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $548f161e17fc6f48$var$_v0$1.subVectors(c, b);
        $548f161e17fc6f48$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $548f161e17fc6f48$var$_v0$1.cross($548f161e17fc6f48$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $548f161e17fc6f48$var$_v0$1.subVectors(this.c, this.b);
        $548f161e17fc6f48$var$_v1$3.subVectors(this.a, this.b);
        return $548f161e17fc6f48$var$_v0$1.cross($548f161e17fc6f48$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $548f161e17fc6f48$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $548f161e17fc6f48$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        if ($548f161e17fc6f48$var$warnedGetUV === false) {
            console.warn('THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().');
            $548f161e17fc6f48$var$warnedGetUV = true;
        }
        return $548f161e17fc6f48$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $548f161e17fc6f48$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $548f161e17fc6f48$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $548f161e17fc6f48$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $548f161e17fc6f48$var$_vab.subVectors(b, a);
        $548f161e17fc6f48$var$_vac.subVectors(c, a);
        $548f161e17fc6f48$var$_vap.subVectors(p, a);
        const d1 = $548f161e17fc6f48$var$_vab.dot($548f161e17fc6f48$var$_vap);
        const d2 = $548f161e17fc6f48$var$_vac.dot($548f161e17fc6f48$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $548f161e17fc6f48$var$_vbp.subVectors(p, b);
        const d3 = $548f161e17fc6f48$var$_vab.dot($548f161e17fc6f48$var$_vbp);
        const d4 = $548f161e17fc6f48$var$_vac.dot($548f161e17fc6f48$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($548f161e17fc6f48$var$_vab, v);
        }
        $548f161e17fc6f48$var$_vcp.subVectors(p, c);
        const d5 = $548f161e17fc6f48$var$_vab.dot($548f161e17fc6f48$var$_vcp);
        const d6 = $548f161e17fc6f48$var$_vac.dot($548f161e17fc6f48$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($548f161e17fc6f48$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $548f161e17fc6f48$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($548f161e17fc6f48$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($548f161e17fc6f48$var$_vab, v).addScaledVector($548f161e17fc6f48$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
let $548f161e17fc6f48$var$_materialId = 0;
class $548f161e17fc6f48$export$a2d8b23205c25948 extends $548f161e17fc6f48$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, 'id', {
            value: $548f161e17fc6f48$var$_materialId++
        });
        this.uuid = $548f161e17fc6f48$var$generateUUID();
        this.name = '';
        this.type = 'Material';
        this.blending = $548f161e17fc6f48$export$5b29a26d96ee6af0;
        this.side = $548f161e17fc6f48$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.alphaHash = false;
        this.blendSrc = $548f161e17fc6f48$export$d5773124e86cf28c;
        this.blendDst = $548f161e17fc6f48$export$11d468cc7f19e971;
        this.blendEquation = $548f161e17fc6f48$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $548f161e17fc6f48$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $548f161e17fc6f48$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $548f161e17fc6f48$export$9f542ae4b5baca34;
        this.stencilZFail = $548f161e17fc6f48$export$9f542ae4b5baca34;
        this.stencilZPass = $548f161e17fc6f48$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $548f161e17fc6f48$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $548f161e17fc6f48$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
const $548f161e17fc6f48$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $548f161e17fc6f48$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $548f161e17fc6f48$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $548f161e17fc6f48$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $548f161e17fc6f48$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
    }
    set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $548f161e17fc6f48$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $548f161e17fc6f48$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $548f161e17fc6f48$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $548f161e17fc6f48$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $548f161e17fc6f48$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $548f161e17fc6f48$var$euclideanModulo(h, 1);
        s = $548f161e17fc6f48$var$clamp(s, 0, 1);
        l = $548f161e17fc6f48$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $548f161e17fc6f48$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $548f161e17fc6f48$var$hue2rgb(q, p, h);
            this.b = $548f161e17fc6f48$var$hue2rgb(q, p, h - 1 / 3);
        }
        $548f161e17fc6f48$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $548f161e17fc6f48$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace1);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace1);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace1);
                    }
                    break;
                default:
                    console.warn('THREE.Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace1);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace1);
            else console.warn('THREE.Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $548f161e17fc6f48$export$561f394b24edfcaa) {
        // color keywords
        const hex = $548f161e17fc6f48$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $548f161e17fc6f48$var$SRGBToLinear(color.r);
        this.g = $548f161e17fc6f48$var$SRGBToLinear(color.g);
        this.b = $548f161e17fc6f48$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $548f161e17fc6f48$var$LinearToSRGB(color.r);
        this.g = $548f161e17fc6f48$var$LinearToSRGB(color.g);
        this.b = $548f161e17fc6f48$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $548f161e17fc6f48$export$561f394b24edfcaa) {
        $548f161e17fc6f48$export$5e6fd513f44698c.fromWorkingColorSpace($548f161e17fc6f48$var$_color.copy(this), colorSpace1);
        return Math.round($548f161e17fc6f48$var$clamp($548f161e17fc6f48$var$_color.r * 255, 0, 255)) * 65536 + Math.round($548f161e17fc6f48$var$clamp($548f161e17fc6f48$var$_color.g * 255, 0, 255)) * 256 + Math.round($548f161e17fc6f48$var$clamp($548f161e17fc6f48$var$_color.b * 255, 0, 255));
    }
    getHexString(colorSpace1 = $548f161e17fc6f48$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $548f161e17fc6f48$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $548f161e17fc6f48$export$5e6fd513f44698c.fromWorkingColorSpace($548f161e17fc6f48$var$_color.copy(this), colorSpace1);
        const r = $548f161e17fc6f48$var$_color.r, g = $548f161e17fc6f48$var$_color.g, b = $548f161e17fc6f48$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $548f161e17fc6f48$export$5e6fd513f44698c.workingColorSpace) {
        $548f161e17fc6f48$export$5e6fd513f44698c.fromWorkingColorSpace($548f161e17fc6f48$var$_color.copy(this), colorSpace1);
        target.r = $548f161e17fc6f48$var$_color.r;
        target.g = $548f161e17fc6f48$var$_color.g;
        target.b = $548f161e17fc6f48$var$_color.b;
        return target;
    }
    getStyle(colorSpace1 = $548f161e17fc6f48$export$561f394b24edfcaa) {
        $548f161e17fc6f48$export$5e6fd513f44698c.fromWorkingColorSpace($548f161e17fc6f48$var$_color.copy(this), colorSpace1);
        const r = $548f161e17fc6f48$var$_color.r, g = $548f161e17fc6f48$var$_color.g, b = $548f161e17fc6f48$var$_color.b;
        if (colorSpace1 !== $548f161e17fc6f48$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($548f161e17fc6f48$var$_hslA);
        return this.setHSL($548f161e17fc6f48$var$_hslA.h + h, $548f161e17fc6f48$var$_hslA.s + s, $548f161e17fc6f48$var$_hslA.l + l);
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($548f161e17fc6f48$var$_hslA);
        color.getHSL($548f161e17fc6f48$var$_hslB);
        const h = $548f161e17fc6f48$var$lerp($548f161e17fc6f48$var$_hslA.h, $548f161e17fc6f48$var$_hslB.h, alpha);
        const s = $548f161e17fc6f48$var$lerp($548f161e17fc6f48$var$_hslA.s, $548f161e17fc6f48$var$_hslB.s, alpha);
        const l = $548f161e17fc6f48$var$lerp($548f161e17fc6f48$var$_hslA.l, $548f161e17fc6f48$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $548f161e17fc6f48$var$_color = /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e();
$548f161e17fc6f48$export$892596cec99bc70e.NAMES = $548f161e17fc6f48$var$_colorKeywords;
class $548f161e17fc6f48$export$55cbcc9b622fe1f5 extends $548f161e17fc6f48$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $548f161e17fc6f48$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $548f161e17fc6f48$var$_tables = /*@__PURE__*/ $548f161e17fc6f48$var$_generateTables();
function $548f161e17fc6f48$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $548f161e17fc6f48$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
    val = $548f161e17fc6f48$var$clamp(val, -65504, 65504);
    $548f161e17fc6f48$var$_tables.floatView[0] = val;
    const f = $548f161e17fc6f48$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $548f161e17fc6f48$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $548f161e17fc6f48$var$_tables.shiftTable[e]);
}
// float16 to float32
function $548f161e17fc6f48$var$fromHalfFloat(val) {
    const m = val >> 10;
    $548f161e17fc6f48$var$_tables.uint32View[0] = $548f161e17fc6f48$var$_tables.mantissaTable[$548f161e17fc6f48$var$_tables.offsetTable[m] + (val & 0x3ff)] + $548f161e17fc6f48$var$_tables.exponentTable[m];
    return $548f161e17fc6f48$var$_tables.floatView[0];
}
const $548f161e17fc6f48$export$11ce8b759162cc80 = {
    toHalfFloat: $548f161e17fc6f48$var$toHalfFloat,
    fromHalfFloat: $548f161e17fc6f48$var$fromHalfFloat
};
const $548f161e17fc6f48$var$_vector$8 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_vector2$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1();
class $548f161e17fc6f48$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        this.isBufferAttribute = true;
        this.name = '';
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $548f161e17fc6f48$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.gpuType = $548f161e17fc6f48$export$f6d331659b644596;
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $548f161e17fc6f48$var$_vector2$1.fromBufferAttribute(this, i);
            $548f161e17fc6f48$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $548f161e17fc6f48$var$_vector2$1.x, $548f161e17fc6f48$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $548f161e17fc6f48$var$_vector$8.fromBufferAttribute(this, i);
            $548f161e17fc6f48$var$_vector$8.applyMatrix3(m);
            this.setXYZ(i, $548f161e17fc6f48$var$_vector$8.x, $548f161e17fc6f48$var$_vector$8.y, $548f161e17fc6f48$var$_vector$8.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $548f161e17fc6f48$var$_vector$8.fromBufferAttribute(this, i);
            $548f161e17fc6f48$var$_vector$8.applyMatrix4(m);
            this.setXYZ(i, $548f161e17fc6f48$var$_vector$8.x, $548f161e17fc6f48$var$_vector$8.y, $548f161e17fc6f48$var$_vector$8.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $548f161e17fc6f48$var$_vector$8.fromBufferAttribute(this, i);
            $548f161e17fc6f48$var$_vector$8.applyNormalMatrix(m);
            this.setXYZ(i, $548f161e17fc6f48$var$_vector$8.x, $548f161e17fc6f48$var$_vector$8.y, $548f161e17fc6f48$var$_vector$8.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $548f161e17fc6f48$var$_vector$8.fromBufferAttribute(this, i);
            $548f161e17fc6f48$var$_vector$8.transformDirection(m);
            this.setXYZ(i, $548f161e17fc6f48$var$_vector$8.x, $548f161e17fc6f48$var$_vector$8.y, $548f161e17fc6f48$var$_vector$8.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $548f161e17fc6f48$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $548f161e17fc6f48$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $548f161e17fc6f48$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $548f161e17fc6f48$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $548f161e17fc6f48$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $548f161e17fc6f48$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $548f161e17fc6f48$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $548f161e17fc6f48$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $548f161e17fc6f48$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $548f161e17fc6f48$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $548f161e17fc6f48$var$normalize(x, this.array);
            y = $548f161e17fc6f48$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $548f161e17fc6f48$var$normalize(x, this.array);
            y = $548f161e17fc6f48$var$normalize(y, this.array);
            z = $548f161e17fc6f48$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $548f161e17fc6f48$var$normalize(x, this.array);
            y = $548f161e17fc6f48$var$normalize(y, this.array);
            z = $548f161e17fc6f48$var$normalize(z, this.array);
            w = $548f161e17fc6f48$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $548f161e17fc6f48$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
}
//
class $548f161e17fc6f48$export$f9ff2d6a20248cbf extends $548f161e17fc6f48$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $548f161e17fc6f48$export$cacc90cf35d11cdd extends $548f161e17fc6f48$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $548f161e17fc6f48$export$baaa85a1a812c157 extends $548f161e17fc6f48$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $548f161e17fc6f48$export$2b755a102ccdcefe extends $548f161e17fc6f48$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $548f161e17fc6f48$export$640a853f68025f2e extends $548f161e17fc6f48$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $548f161e17fc6f48$export$46b369aed2968a0a extends $548f161e17fc6f48$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $548f161e17fc6f48$export$7eb8c9fa25cd5bd6 extends $548f161e17fc6f48$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $548f161e17fc6f48$export$dbd3698c64958d69 extends $548f161e17fc6f48$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $548f161e17fc6f48$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $548f161e17fc6f48$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $548f161e17fc6f48$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $548f161e17fc6f48$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $548f161e17fc6f48$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $548f161e17fc6f48$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $548f161e17fc6f48$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $548f161e17fc6f48$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $548f161e17fc6f48$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $548f161e17fc6f48$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $548f161e17fc6f48$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $548f161e17fc6f48$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $548f161e17fc6f48$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $548f161e17fc6f48$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $548f161e17fc6f48$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $548f161e17fc6f48$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $548f161e17fc6f48$var$normalize(x, this.array);
            y = $548f161e17fc6f48$var$normalize(y, this.array);
        }
        this.array[index + 0] = $548f161e17fc6f48$var$toHalfFloat(x);
        this.array[index + 1] = $548f161e17fc6f48$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $548f161e17fc6f48$var$normalize(x, this.array);
            y = $548f161e17fc6f48$var$normalize(y, this.array);
            z = $548f161e17fc6f48$var$normalize(z, this.array);
        }
        this.array[index + 0] = $548f161e17fc6f48$var$toHalfFloat(x);
        this.array[index + 1] = $548f161e17fc6f48$var$toHalfFloat(y);
        this.array[index + 2] = $548f161e17fc6f48$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $548f161e17fc6f48$var$normalize(x, this.array);
            y = $548f161e17fc6f48$var$normalize(y, this.array);
            z = $548f161e17fc6f48$var$normalize(z, this.array);
            w = $548f161e17fc6f48$var$normalize(w, this.array);
        }
        this.array[index + 0] = $548f161e17fc6f48$var$toHalfFloat(x);
        this.array[index + 1] = $548f161e17fc6f48$var$toHalfFloat(y);
        this.array[index + 2] = $548f161e17fc6f48$var$toHalfFloat(z);
        this.array[index + 3] = $548f161e17fc6f48$var$toHalfFloat(w);
        return this;
    }
}
class $548f161e17fc6f48$export$cbe7a62641830ebd extends $548f161e17fc6f48$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $548f161e17fc6f48$export$9e0ade74842adbb8 extends $548f161e17fc6f48$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
let $548f161e17fc6f48$var$_id$2 = 0;
const $548f161e17fc6f48$var$_m1 = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_obj = /*@__PURE__*/ new $548f161e17fc6f48$export$e4dd07dff30cc924();
const $548f161e17fc6f48$var$_offset = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_box$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$6f7d5a9418ab2aa3();
const $548f161e17fc6f48$var$_boxMorphTargets = /*@__PURE__*/ new $548f161e17fc6f48$export$6f7d5a9418ab2aa3();
const $548f161e17fc6f48$var$_vector$7 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$export$b7be63a67df8959 extends $548f161e17fc6f48$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, 'id', {
            value: $548f161e17fc6f48$var$_id$2++
        });
        this.uuid = $548f161e17fc6f48$var$generateUUID();
        this.name = '';
        this.type = 'BufferGeometry';
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($548f161e17fc6f48$var$arrayNeedsUint32(index) ? $548f161e17fc6f48$export$7eb8c9fa25cd5bd6 : $548f161e17fc6f48$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $548f161e17fc6f48$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $548f161e17fc6f48$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($548f161e17fc6f48$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $548f161e17fc6f48$var$_m1.makeRotationX(angle);
        this.applyMatrix4($548f161e17fc6f48$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $548f161e17fc6f48$var$_m1.makeRotationY(angle);
        this.applyMatrix4($548f161e17fc6f48$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $548f161e17fc6f48$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($548f161e17fc6f48$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $548f161e17fc6f48$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($548f161e17fc6f48$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $548f161e17fc6f48$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($548f161e17fc6f48$var$_m1);
        return this;
    }
    lookAt(vector) {
        $548f161e17fc6f48$var$_obj.lookAt(vector);
        $548f161e17fc6f48$var$_obj.updateMatrix();
        this.applyMatrix4($548f161e17fc6f48$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($548f161e17fc6f48$var$_offset).negate();
        this.translate($548f161e17fc6f48$var$_offset.x, $548f161e17fc6f48$var$_offset.y, $548f161e17fc6f48$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $548f161e17fc6f48$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $548f161e17fc6f48$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $548f161e17fc6f48$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $548f161e17fc6f48$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $548f161e17fc6f48$var$_vector$7.addVectors(this.boundingBox.min, $548f161e17fc6f48$var$_box$1.min);
                    this.boundingBox.expandByPoint($548f161e17fc6f48$var$_vector$7);
                    $548f161e17fc6f48$var$_vector$7.addVectors(this.boundingBox.max, $548f161e17fc6f48$var$_box$1.max);
                    this.boundingBox.expandByPoint($548f161e17fc6f48$var$_vector$7);
                } else {
                    this.boundingBox.expandByPoint($548f161e17fc6f48$var$_box$1.min);
                    this.boundingBox.expandByPoint($548f161e17fc6f48$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $548f161e17fc6f48$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $548f161e17fc6f48$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $548f161e17fc6f48$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $548f161e17fc6f48$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $548f161e17fc6f48$var$_vector$7.addVectors($548f161e17fc6f48$var$_box$1.min, $548f161e17fc6f48$var$_boxMorphTargets.min);
                    $548f161e17fc6f48$var$_box$1.expandByPoint($548f161e17fc6f48$var$_vector$7);
                    $548f161e17fc6f48$var$_vector$7.addVectors($548f161e17fc6f48$var$_box$1.max, $548f161e17fc6f48$var$_boxMorphTargets.max);
                    $548f161e17fc6f48$var$_box$1.expandByPoint($548f161e17fc6f48$var$_vector$7);
                } else {
                    $548f161e17fc6f48$var$_box$1.expandByPoint($548f161e17fc6f48$var$_boxMorphTargets.min);
                    $548f161e17fc6f48$var$_box$1.expandByPoint($548f161e17fc6f48$var$_boxMorphTargets.max);
                }
            }
            $548f161e17fc6f48$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $548f161e17fc6f48$var$_vector$7.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($548f161e17fc6f48$var$_vector$7));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $548f161e17fc6f48$var$_vector$7.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $548f161e17fc6f48$var$_offset.fromBufferAttribute(position, j);
                        $548f161e17fc6f48$var$_vector$7.add($548f161e17fc6f48$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($548f161e17fc6f48$var$_vector$7));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $548f161e17fc6f48$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = this.getAttribute('tangent').array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $548f161e17fc6f48$export$64b5c384219d3699();
            tan2[i] = new $548f161e17fc6f48$export$64b5c384219d3699();
        }
        const vA = new $548f161e17fc6f48$export$64b5c384219d3699(), vB = new $548f161e17fc6f48$export$64b5c384219d3699(), vC = new $548f161e17fc6f48$export$64b5c384219d3699(), uvA = new $548f161e17fc6f48$export$c977b3e384af9ae1(), uvB = new $548f161e17fc6f48$export$c977b3e384af9ae1(), uvC = new $548f161e17fc6f48$export$c977b3e384af9ae1(), sdir = new $548f161e17fc6f48$export$64b5c384219d3699(), tdir = new $548f161e17fc6f48$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $548f161e17fc6f48$export$64b5c384219d3699(), tmp2 = new $548f161e17fc6f48$export$64b5c384219d3699();
        const n = new $548f161e17fc6f48$export$64b5c384219d3699(), n2 = new $548f161e17fc6f48$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $548f161e17fc6f48$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $548f161e17fc6f48$export$64b5c384219d3699(), pB = new $548f161e17fc6f48$export$64b5c384219d3699(), pC = new $548f161e17fc6f48$export$64b5c384219d3699();
            const nA = new $548f161e17fc6f48$export$64b5c384219d3699(), nB = new $548f161e17fc6f48$export$64b5c384219d3699(), nC = new $548f161e17fc6f48$export$64b5c384219d3699();
            const cb = new $548f161e17fc6f48$export$64b5c384219d3699(), ab = new $548f161e17fc6f48$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $548f161e17fc6f48$var$_vector$7.fromBufferAttribute(normals, i);
            $548f161e17fc6f48$var$_vector$7.normalize();
            normals.setXYZ(i, $548f161e17fc6f48$var$_vector$7.x, $548f161e17fc6f48$var$_vector$7.y, $548f161e17fc6f48$var$_vector$7.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $548f161e17fc6f48$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $548f161e17fc6f48$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const $548f161e17fc6f48$var$_inverseMatrix$3 = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_ray$3 = /*@__PURE__*/ new $548f161e17fc6f48$export$a186db52eed6d40e();
const $548f161e17fc6f48$var$_sphere$5 = /*@__PURE__*/ new $548f161e17fc6f48$export$805e8b72413ccaba();
const $548f161e17fc6f48$var$_sphereHitAt = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_vA$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_vB$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_vC$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_tempA = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_morphA = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_uvA$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1();
const $548f161e17fc6f48$var$_uvB$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1();
const $548f161e17fc6f48$var$_uvC$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1();
const $548f161e17fc6f48$var$_normalA = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_normalB = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_normalC = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_intersectionPoint = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_intersectionPointWorld = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$export$e176487c05830cc5 extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(geometry = new $548f161e17fc6f48$export$b7be63a67df8959(), material = new $548f161e17fc6f48$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = 'Mesh';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $548f161e17fc6f48$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $548f161e17fc6f48$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $548f161e17fc6f48$var$_morphA.addScaledVector($548f161e17fc6f48$var$_tempA, influence);
                else $548f161e17fc6f48$var$_morphA.addScaledVector($548f161e17fc6f48$var$_tempA.sub(target), influence);
            }
            target.add($548f161e17fc6f48$var$_morphA);
        }
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $548f161e17fc6f48$var$_sphere$5.copy(geometry.boundingSphere);
        $548f161e17fc6f48$var$_sphere$5.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $548f161e17fc6f48$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($548f161e17fc6f48$var$_sphere$5.containsPoint($548f161e17fc6f48$var$_ray$3.origin) === false) {
            if ($548f161e17fc6f48$var$_ray$3.intersectSphere($548f161e17fc6f48$var$_sphere$5, $548f161e17fc6f48$var$_sphereHitAt) === null) return;
            if ($548f161e17fc6f48$var$_ray$3.origin.distanceToSquared($548f161e17fc6f48$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $548f161e17fc6f48$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $548f161e17fc6f48$var$_ray$3.copy(raycaster.ray).applyMatrix4($548f161e17fc6f48$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($548f161e17fc6f48$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $548f161e17fc6f48$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $548f161e17fc6f48$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $548f161e17fc6f48$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $548f161e17fc6f48$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $548f161e17fc6f48$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $548f161e17fc6f48$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $548f161e17fc6f48$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $548f161e17fc6f48$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $548f161e17fc6f48$var$_intersectionPointWorld.copy(point);
    $548f161e17fc6f48$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($548f161e17fc6f48$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $548f161e17fc6f48$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $548f161e17fc6f48$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $548f161e17fc6f48$var$_vA$1);
    object.getVertexPosition(b, $548f161e17fc6f48$var$_vB$1);
    object.getVertexPosition(c, $548f161e17fc6f48$var$_vC$1);
    const intersection = $548f161e17fc6f48$var$checkIntersection(object, material, raycaster, ray, $548f161e17fc6f48$var$_vA$1, $548f161e17fc6f48$var$_vB$1, $548f161e17fc6f48$var$_vC$1, $548f161e17fc6f48$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $548f161e17fc6f48$var$_uvA$1.fromBufferAttribute(uv, a);
            $548f161e17fc6f48$var$_uvB$1.fromBufferAttribute(uv, b);
            $548f161e17fc6f48$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $548f161e17fc6f48$export$5a465592bfe74b48.getInterpolation($548f161e17fc6f48$var$_intersectionPoint, $548f161e17fc6f48$var$_vA$1, $548f161e17fc6f48$var$_vB$1, $548f161e17fc6f48$var$_vC$1, $548f161e17fc6f48$var$_uvA$1, $548f161e17fc6f48$var$_uvB$1, $548f161e17fc6f48$var$_uvC$1, new $548f161e17fc6f48$export$c977b3e384af9ae1());
        }
        if (uv1) {
            $548f161e17fc6f48$var$_uvA$1.fromBufferAttribute(uv1, a);
            $548f161e17fc6f48$var$_uvB$1.fromBufferAttribute(uv1, b);
            $548f161e17fc6f48$var$_uvC$1.fromBufferAttribute(uv1, c);
            intersection.uv1 = $548f161e17fc6f48$export$5a465592bfe74b48.getInterpolation($548f161e17fc6f48$var$_intersectionPoint, $548f161e17fc6f48$var$_vA$1, $548f161e17fc6f48$var$_vB$1, $548f161e17fc6f48$var$_vC$1, $548f161e17fc6f48$var$_uvA$1, $548f161e17fc6f48$var$_uvB$1, $548f161e17fc6f48$var$_uvC$1, new $548f161e17fc6f48$export$c977b3e384af9ae1());
            intersection.uv2 = intersection.uv1; // @deprecated, r152
        }
        if (normal) {
            $548f161e17fc6f48$var$_normalA.fromBufferAttribute(normal, a);
            $548f161e17fc6f48$var$_normalB.fromBufferAttribute(normal, b);
            $548f161e17fc6f48$var$_normalC.fromBufferAttribute(normal, c);
            intersection.normal = $548f161e17fc6f48$export$5a465592bfe74b48.getInterpolation($548f161e17fc6f48$var$_intersectionPoint, $548f161e17fc6f48$var$_vA$1, $548f161e17fc6f48$var$_vB$1, $548f161e17fc6f48$var$_vC$1, $548f161e17fc6f48$var$_normalA, $548f161e17fc6f48$var$_normalB, $548f161e17fc6f48$var$_normalC, new $548f161e17fc6f48$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $548f161e17fc6f48$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $548f161e17fc6f48$export$5a465592bfe74b48.getNormal($548f161e17fc6f48$var$_vA$1, $548f161e17fc6f48$var$_vB$1, $548f161e17fc6f48$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $548f161e17fc6f48$export$33e43285f7406bd5 extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $548f161e17fc6f48$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $548f161e17fc6f48$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $548f161e17fc6f48$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $548f161e17fc6f48$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $548f161e17fc6f48$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $548f161e17fc6f48$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $548f161e17fc6f48$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $548f161e17fc6f48$var$getUnlitUniformColorSpace(renderer) {
    if (renderer.getRenderTarget() === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    return $548f161e17fc6f48$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
const $548f161e17fc6f48$export$d8ecdf8615bfea69 = {
    clone: $548f161e17fc6f48$var$cloneUniforms,
    merge: $548f161e17fc6f48$var$mergeUniforms
};
var $548f161e17fc6f48$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $548f161e17fc6f48$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $548f161e17fc6f48$export$83c7d75d550a8b0d extends $548f161e17fc6f48$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $548f161e17fc6f48$var$default_vertex;
        this.fragmentShader = $548f161e17fc6f48$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $548f161e17fc6f48$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $548f161e17fc6f48$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $548f161e17fc6f48$export$79f141de891a5fed extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = 'Camera';
        this.matrixWorldInverse = new $548f161e17fc6f48$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $548f161e17fc6f48$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $548f161e17fc6f48$export$2ae72fc923e5eb5();
        this.coordinateSystem = $548f161e17fc6f48$export$5a0e9190d10875d3;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $548f161e17fc6f48$export$74e4ae24825f68d7 extends $548f161e17fc6f48$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $548f161e17fc6f48$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($548f161e17fc6f48$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $548f161e17fc6f48$var$RAD2DEG * 2 * Math.atan(Math.tan($548f161e17fc6f48$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($548f161e17fc6f48$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $548f161e17fc6f48$var$fov = -90; // negative fov is not an error
const $548f161e17fc6f48$var$aspect = 1;
class $548f161e17fc6f48$export$d0cdd0bd804995de extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        this.renderTarget = renderTarget;
        this.coordinateSystem = null;
        this.activeMipmapLevel = 0;
        const cameraPX = new $548f161e17fc6f48$export$74e4ae24825f68d7($548f161e17fc6f48$var$fov, $548f161e17fc6f48$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $548f161e17fc6f48$export$74e4ae24825f68d7($548f161e17fc6f48$var$fov, $548f161e17fc6f48$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $548f161e17fc6f48$export$74e4ae24825f68d7($548f161e17fc6f48$var$fov, $548f161e17fc6f48$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $548f161e17fc6f48$export$74e4ae24825f68d7($548f161e17fc6f48$var$fov, $548f161e17fc6f48$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $548f161e17fc6f48$export$74e4ae24825f68d7($548f161e17fc6f48$var$fov, $548f161e17fc6f48$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $548f161e17fc6f48$export$74e4ae24825f68d7($548f161e17fc6f48$var$fov, $548f161e17fc6f48$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $548f161e17fc6f48$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $548f161e17fc6f48$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $548f161e17fc6f48$export$ee2e5a18258a4049 extends $548f161e17fc6f48$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $548f161e17fc6f48$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $548f161e17fc6f48$export$ac386671d651941e extends $548f161e17fc6f48$export$3c052beb2e51e23f {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $548f161e17fc6f48$var$warnOnce('THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace.');
            options.colorSpace = options.encoding === $548f161e17fc6f48$export$f32388edbb32674 ? $548f161e17fc6f48$export$561f394b24edfcaa : $548f161e17fc6f48$export$bfcb490c2dd3db51;
        }
        this.texture = new $548f161e17fc6f48$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $548f161e17fc6f48$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $548f161e17fc6f48$export$33e43285f7406bd5(5, 5, 5);
        const material = new $548f161e17fc6f48$export$83c7d75d550a8b0d({
            name: 'CubemapFromEquirect',
            uniforms: $548f161e17fc6f48$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $548f161e17fc6f48$export$d9f0486e75b5ace,
            blending: $548f161e17fc6f48$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $548f161e17fc6f48$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $548f161e17fc6f48$export$5d8599b6a933fb1b) texture.minFilter = $548f161e17fc6f48$export$8a72f490b25c56c8;
        const camera = new $548f161e17fc6f48$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $548f161e17fc6f48$var$_vector1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_vector2 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_normalMatrix = /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918();
class $548f161e17fc6f48$export$7ff5ac152ef991b0 {
    constructor(normal = new $548f161e17fc6f48$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $548f161e17fc6f48$var$_vector1.subVectors(c, b).cross($548f161e17fc6f48$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($548f161e17fc6f48$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $548f161e17fc6f48$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($548f161e17fc6f48$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $548f161e17fc6f48$var$_sphere$4 = /*@__PURE__*/ new $548f161e17fc6f48$export$805e8b72413ccaba();
const $548f161e17fc6f48$var$_vector$6 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$export$35efe6f4c85463d2 {
    constructor(p0 = new $548f161e17fc6f48$export$7ff5ac152ef991b0(), p1 = new $548f161e17fc6f48$export$7ff5ac152ef991b0(), p2 = new $548f161e17fc6f48$export$7ff5ac152ef991b0(), p3 = new $548f161e17fc6f48$export$7ff5ac152ef991b0(), p4 = new $548f161e17fc6f48$export$7ff5ac152ef991b0(), p5 = new $548f161e17fc6f48$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m, coordinateSystem = $548f161e17fc6f48$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $548f161e17fc6f48$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $548f161e17fc6f48$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $548f161e17fc6f48$var$_sphere$4.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $548f161e17fc6f48$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($548f161e17fc6f48$var$_sphere$4);
    }
    intersectsSprite(sprite) {
        $548f161e17fc6f48$var$_sphere$4.center.set(0, 0, 0);
        $548f161e17fc6f48$var$_sphere$4.radius = 0.7071067811865476;
        $548f161e17fc6f48$var$_sphere$4.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($548f161e17fc6f48$var$_sphere$4);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $548f161e17fc6f48$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $548f161e17fc6f48$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $548f161e17fc6f48$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($548f161e17fc6f48$var$_vector$6) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $548f161e17fc6f48$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $548f161e17fc6f48$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = gl.HALF_FLOAT;
                else throw new Error('THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.');
            } else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $548f161e17fc6f48$export$967d831af31f69ce extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $548f161e17fc6f48$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $548f161e17fc6f48$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $548f161e17fc6f48$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $548f161e17fc6f48$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $548f161e17fc6f48$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $548f161e17fc6f48$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $548f161e17fc6f48$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif";
var $548f161e17fc6f48$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $548f161e17fc6f48$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $548f161e17fc6f48$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $548f161e17fc6f48$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $548f161e17fc6f48$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $548f161e17fc6f48$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $548f161e17fc6f48$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $548f161e17fc6f48$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = dFdx( surf_pos.xyz );\n\t\tvec3 vSigmaY = dFdy( surf_pos.xyz );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $548f161e17fc6f48$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif";
var $548f161e17fc6f48$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $548f161e17fc6f48$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $548f161e17fc6f48$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $548f161e17fc6f48$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $548f161e17fc6f48$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $548f161e17fc6f48$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $548f161e17fc6f48$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";
var $548f161e17fc6f48$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n\treturn dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $548f161e17fc6f48$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_v0 0.339\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_v1 0.276\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_v4 0.046\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_v5 0.016\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_v6 0.0038\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $548f161e17fc6f48$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $548f161e17fc6f48$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $548f161e17fc6f48$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $548f161e17fc6f48$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $548f161e17fc6f48$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $548f161e17fc6f48$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $548f161e17fc6f48$var$colorspace_pars_fragment = "\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\n\tvec3( 0.8224621, 0.177538, 0.0 ),\n\tvec3( 0.0331941, 0.9668058, 0.0 ),\n\tvec3( 0.0170827, 0.0723974, 0.9105199 )\n);\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.2249401, - 0.2249404, 0.0 ),\n\tvec3( - 0.0420569, 1.0420571, 0.0 ),\n\tvec3( - 0.0196376, - 0.0786361, 1.0982735 )\n);\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\n\treturn vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\n}\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\n\treturn vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\n}\nvec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn sRGBTransferOETF( value );\n}";
var $548f161e17fc6f48$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $548f161e17fc6f48$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $548f161e17fc6f48$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $548f161e17fc6f48$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $548f161e17fc6f48$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $548f161e17fc6f48$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $548f161e17fc6f48$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $548f161e17fc6f48$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $548f161e17fc6f48$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $548f161e17fc6f48$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $548f161e17fc6f48$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var $548f161e17fc6f48$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $548f161e17fc6f48$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $548f161e17fc6f48$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $548f161e17fc6f48$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( LEGACY_LIGHTS )\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#else\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $548f161e17fc6f48$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $548f161e17fc6f48$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $548f161e17fc6f48$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $548f161e17fc6f48$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $548f161e17fc6f48$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $548f161e17fc6f48$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tanisotropyV /= material.anisotropy;\n\tmaterial.anisotropy = saturate( material.anisotropy );\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\n#endif";
var $548f161e17fc6f48$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecular += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $548f161e17fc6f48$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal;\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $548f161e17fc6f48$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $548f161e17fc6f48$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $548f161e17fc6f48$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $548f161e17fc6f48$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $548f161e17fc6f48$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif";
var $548f161e17fc6f48$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif";
var $548f161e17fc6f48$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $548f161e17fc6f48$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $548f161e17fc6f48$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $548f161e17fc6f48$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $548f161e17fc6f48$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $548f161e17fc6f48$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $548f161e17fc6f48$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $548f161e17fc6f48$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif";
var $548f161e17fc6f48$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif";
var $548f161e17fc6f48$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif";
var $548f161e17fc6f48$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $548f161e17fc6f48$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $548f161e17fc6f48$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $548f161e17fc6f48$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $548f161e17fc6f48$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $548f161e17fc6f48$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $548f161e17fc6f48$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $548f161e17fc6f48$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $548f161e17fc6f48$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $548f161e17fc6f48$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $548f161e17fc6f48$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $548f161e17fc6f48$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n\treturn packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n\treturn unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $548f161e17fc6f48$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $548f161e17fc6f48$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $548f161e17fc6f48$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $548f161e17fc6f48$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $548f161e17fc6f48$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $548f161e17fc6f48$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $548f161e17fc6f48$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif";
var $548f161e17fc6f48$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $548f161e17fc6f48$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $548f161e17fc6f48$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $548f161e17fc6f48$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $548f161e17fc6f48$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tuniform int boneTextureSize;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tfloat j = i * 4.0;\n\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\ty = dy * ( y + 0.5 );\n\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\treturn bone;\n\t}\n#endif";
var $548f161e17fc6f48$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $548f161e17fc6f48$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $548f161e17fc6f48$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $548f161e17fc6f48$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $548f161e17fc6f48$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $548f161e17fc6f48$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $548f161e17fc6f48$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $548f161e17fc6f48$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $548f161e17fc6f48$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $548f161e17fc6f48$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $548f161e17fc6f48$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $548f161e17fc6f48$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $548f161e17fc6f48$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $548f161e17fc6f48$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $548f161e17fc6f48$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $548f161e17fc6f48$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $548f161e17fc6f48$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $548f161e17fc6f48$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $548f161e17fc6f48$var$vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $548f161e17fc6f48$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";
const $548f161e17fc6f48$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $548f161e17fc6f48$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
const $548f161e17fc6f48$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $548f161e17fc6f48$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $548f161e17fc6f48$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $548f161e17fc6f48$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $548f161e17fc6f48$var$vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $548f161e17fc6f48$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $548f161e17fc6f48$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $548f161e17fc6f48$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $548f161e17fc6f48$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $548f161e17fc6f48$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $548f161e17fc6f48$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $548f161e17fc6f48$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $548f161e17fc6f48$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $548f161e17fc6f48$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $548f161e17fc6f48$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $548f161e17fc6f48$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $548f161e17fc6f48$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $548f161e17fc6f48$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $548f161e17fc6f48$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $548f161e17fc6f48$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $548f161e17fc6f48$var$vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $548f161e17fc6f48$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $548f161e17fc6f48$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $548f161e17fc6f48$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $548f161e17fc6f48$export$955f9f2e84c43c8b = {
    alphahash_fragment: $548f161e17fc6f48$var$alphahash_fragment,
    alphahash_pars_fragment: $548f161e17fc6f48$var$alphahash_pars_fragment,
    alphamap_fragment: $548f161e17fc6f48$var$alphamap_fragment,
    alphamap_pars_fragment: $548f161e17fc6f48$var$alphamap_pars_fragment,
    alphatest_fragment: $548f161e17fc6f48$var$alphatest_fragment,
    alphatest_pars_fragment: $548f161e17fc6f48$var$alphatest_pars_fragment,
    aomap_fragment: $548f161e17fc6f48$var$aomap_fragment,
    aomap_pars_fragment: $548f161e17fc6f48$var$aomap_pars_fragment,
    begin_vertex: $548f161e17fc6f48$var$begin_vertex,
    beginnormal_vertex: $548f161e17fc6f48$var$beginnormal_vertex,
    bsdfs: $548f161e17fc6f48$var$bsdfs,
    iridescence_fragment: $548f161e17fc6f48$var$iridescence_fragment,
    bumpmap_pars_fragment: $548f161e17fc6f48$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $548f161e17fc6f48$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $548f161e17fc6f48$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $548f161e17fc6f48$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $548f161e17fc6f48$var$clipping_planes_vertex,
    color_fragment: $548f161e17fc6f48$var$color_fragment,
    color_pars_fragment: $548f161e17fc6f48$var$color_pars_fragment,
    color_pars_vertex: $548f161e17fc6f48$var$color_pars_vertex,
    color_vertex: $548f161e17fc6f48$var$color_vertex,
    common: $548f161e17fc6f48$var$common,
    cube_uv_reflection_fragment: $548f161e17fc6f48$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $548f161e17fc6f48$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $548f161e17fc6f48$var$displacementmap_pars_vertex,
    displacementmap_vertex: $548f161e17fc6f48$var$displacementmap_vertex,
    emissivemap_fragment: $548f161e17fc6f48$var$emissivemap_fragment,
    emissivemap_pars_fragment: $548f161e17fc6f48$var$emissivemap_pars_fragment,
    colorspace_fragment: $548f161e17fc6f48$var$colorspace_fragment,
    colorspace_pars_fragment: $548f161e17fc6f48$var$colorspace_pars_fragment,
    envmap_fragment: $548f161e17fc6f48$var$envmap_fragment,
    envmap_common_pars_fragment: $548f161e17fc6f48$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $548f161e17fc6f48$var$envmap_pars_fragment,
    envmap_pars_vertex: $548f161e17fc6f48$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $548f161e17fc6f48$var$envmap_physical_pars_fragment,
    envmap_vertex: $548f161e17fc6f48$var$envmap_vertex,
    fog_vertex: $548f161e17fc6f48$var$fog_vertex,
    fog_pars_vertex: $548f161e17fc6f48$var$fog_pars_vertex,
    fog_fragment: $548f161e17fc6f48$var$fog_fragment,
    fog_pars_fragment: $548f161e17fc6f48$var$fog_pars_fragment,
    gradientmap_pars_fragment: $548f161e17fc6f48$var$gradientmap_pars_fragment,
    lightmap_fragment: $548f161e17fc6f48$var$lightmap_fragment,
    lightmap_pars_fragment: $548f161e17fc6f48$var$lightmap_pars_fragment,
    lights_lambert_fragment: $548f161e17fc6f48$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $548f161e17fc6f48$var$lights_lambert_pars_fragment,
    lights_pars_begin: $548f161e17fc6f48$var$lights_pars_begin,
    lights_toon_fragment: $548f161e17fc6f48$var$lights_toon_fragment,
    lights_toon_pars_fragment: $548f161e17fc6f48$var$lights_toon_pars_fragment,
    lights_phong_fragment: $548f161e17fc6f48$var$lights_phong_fragment,
    lights_phong_pars_fragment: $548f161e17fc6f48$var$lights_phong_pars_fragment,
    lights_physical_fragment: $548f161e17fc6f48$var$lights_physical_fragment,
    lights_physical_pars_fragment: $548f161e17fc6f48$var$lights_physical_pars_fragment,
    lights_fragment_begin: $548f161e17fc6f48$var$lights_fragment_begin,
    lights_fragment_maps: $548f161e17fc6f48$var$lights_fragment_maps,
    lights_fragment_end: $548f161e17fc6f48$var$lights_fragment_end,
    logdepthbuf_fragment: $548f161e17fc6f48$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $548f161e17fc6f48$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $548f161e17fc6f48$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $548f161e17fc6f48$var$logdepthbuf_vertex,
    map_fragment: $548f161e17fc6f48$var$map_fragment,
    map_pars_fragment: $548f161e17fc6f48$var$map_pars_fragment,
    map_particle_fragment: $548f161e17fc6f48$var$map_particle_fragment,
    map_particle_pars_fragment: $548f161e17fc6f48$var$map_particle_pars_fragment,
    metalnessmap_fragment: $548f161e17fc6f48$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $548f161e17fc6f48$var$metalnessmap_pars_fragment,
    morphcolor_vertex: $548f161e17fc6f48$var$morphcolor_vertex,
    morphnormal_vertex: $548f161e17fc6f48$var$morphnormal_vertex,
    morphtarget_pars_vertex: $548f161e17fc6f48$var$morphtarget_pars_vertex,
    morphtarget_vertex: $548f161e17fc6f48$var$morphtarget_vertex,
    normal_fragment_begin: $548f161e17fc6f48$var$normal_fragment_begin,
    normal_fragment_maps: $548f161e17fc6f48$var$normal_fragment_maps,
    normal_pars_fragment: $548f161e17fc6f48$var$normal_pars_fragment,
    normal_pars_vertex: $548f161e17fc6f48$var$normal_pars_vertex,
    normal_vertex: $548f161e17fc6f48$var$normal_vertex,
    normalmap_pars_fragment: $548f161e17fc6f48$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $548f161e17fc6f48$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $548f161e17fc6f48$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $548f161e17fc6f48$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $548f161e17fc6f48$var$iridescence_pars_fragment,
    opaque_fragment: $548f161e17fc6f48$var$opaque_fragment,
    packing: $548f161e17fc6f48$var$packing,
    premultiplied_alpha_fragment: $548f161e17fc6f48$var$premultiplied_alpha_fragment,
    project_vertex: $548f161e17fc6f48$var$project_vertex,
    dithering_fragment: $548f161e17fc6f48$var$dithering_fragment,
    dithering_pars_fragment: $548f161e17fc6f48$var$dithering_pars_fragment,
    roughnessmap_fragment: $548f161e17fc6f48$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $548f161e17fc6f48$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $548f161e17fc6f48$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $548f161e17fc6f48$var$shadowmap_pars_vertex,
    shadowmap_vertex: $548f161e17fc6f48$var$shadowmap_vertex,
    shadowmask_pars_fragment: $548f161e17fc6f48$var$shadowmask_pars_fragment,
    skinbase_vertex: $548f161e17fc6f48$var$skinbase_vertex,
    skinning_pars_vertex: $548f161e17fc6f48$var$skinning_pars_vertex,
    skinning_vertex: $548f161e17fc6f48$var$skinning_vertex,
    skinnormal_vertex: $548f161e17fc6f48$var$skinnormal_vertex,
    specularmap_fragment: $548f161e17fc6f48$var$specularmap_fragment,
    specularmap_pars_fragment: $548f161e17fc6f48$var$specularmap_pars_fragment,
    tonemapping_fragment: $548f161e17fc6f48$var$tonemapping_fragment,
    tonemapping_pars_fragment: $548f161e17fc6f48$var$tonemapping_pars_fragment,
    transmission_fragment: $548f161e17fc6f48$var$transmission_fragment,
    transmission_pars_fragment: $548f161e17fc6f48$var$transmission_pars_fragment,
    uv_pars_fragment: $548f161e17fc6f48$var$uv_pars_fragment,
    uv_pars_vertex: $548f161e17fc6f48$var$uv_pars_vertex,
    uv_vertex: $548f161e17fc6f48$var$uv_vertex,
    worldpos_vertex: $548f161e17fc6f48$var$worldpos_vertex,
    background_vert: $548f161e17fc6f48$var$vertex$h,
    background_frag: $548f161e17fc6f48$var$fragment$h,
    backgroundCube_vert: $548f161e17fc6f48$var$vertex$g,
    backgroundCube_frag: $548f161e17fc6f48$var$fragment$g,
    cube_vert: $548f161e17fc6f48$var$vertex$f,
    cube_frag: $548f161e17fc6f48$var$fragment$f,
    depth_vert: $548f161e17fc6f48$var$vertex$e,
    depth_frag: $548f161e17fc6f48$var$fragment$e,
    distanceRGBA_vert: $548f161e17fc6f48$var$vertex$d,
    distanceRGBA_frag: $548f161e17fc6f48$var$fragment$d,
    equirect_vert: $548f161e17fc6f48$var$vertex$c,
    equirect_frag: $548f161e17fc6f48$var$fragment$c,
    linedashed_vert: $548f161e17fc6f48$var$vertex$b,
    linedashed_frag: $548f161e17fc6f48$var$fragment$b,
    meshbasic_vert: $548f161e17fc6f48$var$vertex$a,
    meshbasic_frag: $548f161e17fc6f48$var$fragment$a,
    meshlambert_vert: $548f161e17fc6f48$var$vertex$9,
    meshlambert_frag: $548f161e17fc6f48$var$fragment$9,
    meshmatcap_vert: $548f161e17fc6f48$var$vertex$8,
    meshmatcap_frag: $548f161e17fc6f48$var$fragment$8,
    meshnormal_vert: $548f161e17fc6f48$var$vertex$7,
    meshnormal_frag: $548f161e17fc6f48$var$fragment$7,
    meshphong_vert: $548f161e17fc6f48$var$vertex$6,
    meshphong_frag: $548f161e17fc6f48$var$fragment$6,
    meshphysical_vert: $548f161e17fc6f48$var$vertex$5,
    meshphysical_frag: $548f161e17fc6f48$var$fragment$5,
    meshtoon_vert: $548f161e17fc6f48$var$vertex$4,
    meshtoon_frag: $548f161e17fc6f48$var$fragment$4,
    points_vert: $548f161e17fc6f48$var$vertex$3,
    points_frag: $548f161e17fc6f48$var$fragment$3,
    shadow_vert: $548f161e17fc6f48$var$vertex$2,
    shadow_frag: $548f161e17fc6f48$var$fragment$2,
    sprite_vert: $548f161e17fc6f48$var$vertex$1,
    sprite_frag: $548f161e17fc6f48$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $548f161e17fc6f48$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        },
        normalScale: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $548f161e17fc6f48$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $548f161e17fc6f48$var$mergeUniforms([
            $548f161e17fc6f48$export$6643083551874bf5.common,
            $548f161e17fc6f48$export$6643083551874bf5.specularmap,
            $548f161e17fc6f48$export$6643083551874bf5.envmap,
            $548f161e17fc6f48$export$6643083551874bf5.aomap,
            $548f161e17fc6f48$export$6643083551874bf5.lightmap,
            $548f161e17fc6f48$export$6643083551874bf5.fog
        ]),
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $548f161e17fc6f48$var$mergeUniforms([
            $548f161e17fc6f48$export$6643083551874bf5.common,
            $548f161e17fc6f48$export$6643083551874bf5.specularmap,
            $548f161e17fc6f48$export$6643083551874bf5.envmap,
            $548f161e17fc6f48$export$6643083551874bf5.aomap,
            $548f161e17fc6f48$export$6643083551874bf5.lightmap,
            $548f161e17fc6f48$export$6643083551874bf5.emissivemap,
            $548f161e17fc6f48$export$6643083551874bf5.bumpmap,
            $548f161e17fc6f48$export$6643083551874bf5.normalmap,
            $548f161e17fc6f48$export$6643083551874bf5.displacementmap,
            $548f161e17fc6f48$export$6643083551874bf5.fog,
            $548f161e17fc6f48$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $548f161e17fc6f48$var$mergeUniforms([
            $548f161e17fc6f48$export$6643083551874bf5.common,
            $548f161e17fc6f48$export$6643083551874bf5.specularmap,
            $548f161e17fc6f48$export$6643083551874bf5.envmap,
            $548f161e17fc6f48$export$6643083551874bf5.aomap,
            $548f161e17fc6f48$export$6643083551874bf5.lightmap,
            $548f161e17fc6f48$export$6643083551874bf5.emissivemap,
            $548f161e17fc6f48$export$6643083551874bf5.bumpmap,
            $548f161e17fc6f48$export$6643083551874bf5.normalmap,
            $548f161e17fc6f48$export$6643083551874bf5.displacementmap,
            $548f161e17fc6f48$export$6643083551874bf5.fog,
            $548f161e17fc6f48$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $548f161e17fc6f48$var$mergeUniforms([
            $548f161e17fc6f48$export$6643083551874bf5.common,
            $548f161e17fc6f48$export$6643083551874bf5.envmap,
            $548f161e17fc6f48$export$6643083551874bf5.aomap,
            $548f161e17fc6f48$export$6643083551874bf5.lightmap,
            $548f161e17fc6f48$export$6643083551874bf5.emissivemap,
            $548f161e17fc6f48$export$6643083551874bf5.bumpmap,
            $548f161e17fc6f48$export$6643083551874bf5.normalmap,
            $548f161e17fc6f48$export$6643083551874bf5.displacementmap,
            $548f161e17fc6f48$export$6643083551874bf5.roughnessmap,
            $548f161e17fc6f48$export$6643083551874bf5.metalnessmap,
            $548f161e17fc6f48$export$6643083551874bf5.fog,
            $548f161e17fc6f48$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $548f161e17fc6f48$var$mergeUniforms([
            $548f161e17fc6f48$export$6643083551874bf5.common,
            $548f161e17fc6f48$export$6643083551874bf5.aomap,
            $548f161e17fc6f48$export$6643083551874bf5.lightmap,
            $548f161e17fc6f48$export$6643083551874bf5.emissivemap,
            $548f161e17fc6f48$export$6643083551874bf5.bumpmap,
            $548f161e17fc6f48$export$6643083551874bf5.normalmap,
            $548f161e17fc6f48$export$6643083551874bf5.displacementmap,
            $548f161e17fc6f48$export$6643083551874bf5.gradientmap,
            $548f161e17fc6f48$export$6643083551874bf5.fog,
            $548f161e17fc6f48$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $548f161e17fc6f48$var$mergeUniforms([
            $548f161e17fc6f48$export$6643083551874bf5.common,
            $548f161e17fc6f48$export$6643083551874bf5.bumpmap,
            $548f161e17fc6f48$export$6643083551874bf5.normalmap,
            $548f161e17fc6f48$export$6643083551874bf5.displacementmap,
            $548f161e17fc6f48$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $548f161e17fc6f48$var$mergeUniforms([
            $548f161e17fc6f48$export$6643083551874bf5.points,
            $548f161e17fc6f48$export$6643083551874bf5.fog
        ]),
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $548f161e17fc6f48$var$mergeUniforms([
            $548f161e17fc6f48$export$6643083551874bf5.common,
            $548f161e17fc6f48$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $548f161e17fc6f48$var$mergeUniforms([
            $548f161e17fc6f48$export$6643083551874bf5.common,
            $548f161e17fc6f48$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $548f161e17fc6f48$var$mergeUniforms([
            $548f161e17fc6f48$export$6643083551874bf5.common,
            $548f161e17fc6f48$export$6643083551874bf5.bumpmap,
            $548f161e17fc6f48$export$6643083551874bf5.normalmap,
            $548f161e17fc6f48$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $548f161e17fc6f48$var$mergeUniforms([
            $548f161e17fc6f48$export$6643083551874bf5.sprite,
            $548f161e17fc6f48$export$6643083551874bf5.fog
        ]),
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $548f161e17fc6f48$var$mergeUniforms([
            $548f161e17fc6f48$export$6643083551874bf5.common,
            $548f161e17fc6f48$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $548f161e17fc6f48$var$mergeUniforms([
            $548f161e17fc6f48$export$6643083551874bf5.lights,
            $548f161e17fc6f48$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.shadow_frag
    }
};
$548f161e17fc6f48$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $548f161e17fc6f48$var$mergeUniforms([
        $548f161e17fc6f48$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new $548f161e17fc6f48$export$8ff26dafa08918()
            }
        }
    ]),
    vertexShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $548f161e17fc6f48$export$955f9f2e84c43c8b.meshphysical_frag
};
const $548f161e17fc6f48$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
function $548f161e17fc6f48$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $548f161e17fc6f48$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $548f161e17fc6f48$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $548f161e17fc6f48$export$e176487c05830cc5(new $548f161e17fc6f48$export$33e43285f7406bd5(1, 1, 1), new $548f161e17fc6f48$export$83c7d75d550a8b0d({
                    name: 'BackgroundCubeMaterial',
                    uniforms: $548f161e17fc6f48$var$cloneUniforms($548f161e17fc6f48$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $548f161e17fc6f48$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $548f161e17fc6f48$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: $548f161e17fc6f48$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.toneMapped = $548f161e17fc6f48$export$5e6fd513f44698c.getTransfer(background.colorSpace) !== $548f161e17fc6f48$export$8d0a61916cc26abb;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $548f161e17fc6f48$export$e176487c05830cc5(new $548f161e17fc6f48$export$967d831af31f69ce(2, 2), new $548f161e17fc6f48$export$83c7d75d550a8b0d({
                    name: 'BackgroundMaterial',
                    uniforms: $548f161e17fc6f48$var$cloneUniforms($548f161e17fc6f48$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $548f161e17fc6f48$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $548f161e17fc6f48$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $548f161e17fc6f48$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = $548f161e17fc6f48$export$5e6fd513f44698c.getTransfer(background.colorSpace) !== $548f161e17fc6f48$export$8d0a61916cc26abb;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($548f161e17fc6f48$var$_rgb, $548f161e17fc6f48$var$getUnlitUniformColorSpace(renderer));
        state.buffers.color.setClear($548f161e17fc6f48$var$_rgb.r, $548f161e17fc6f48$var$_rgb.g, $548f161e17fc6f48$var$_rgb.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $548f161e17fc6f48$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const extension = capabilities.isWebGL2 ? null : extensions.get('OES_vertex_array_object');
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(object, geometry, program, index);
            if (updateBuffers) saveCache(object, geometry, program, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get('ANGLE_instanced_arrays');
            extension[capabilities.isWebGL2 ? 'vertexAttribDivisor' : 'vertexAttribDivisorANGLE'](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get('ANGLE_instanced_arrays') === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes (WebGL 2 only)
                    const integer = capabilities.isWebGL2 === true && (type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === $548f161e17fc6f48$export$5c612977753abe2);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $548f161e17fc6f48$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawArraysInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawArraysInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $548f161e17fc6f48$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    const isWebGL2 = typeof WebGL2RenderingContext !== 'undefined' && gl.constructor.name === 'WebGL2RenderingContext';
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has('WEBGL_draw_buffers');
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has('OES_texture_float');
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(gl.MAX_SAMPLES) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $548f161e17fc6f48$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $548f161e17fc6f48$export$7ff5ac152ef991b0(), viewNormalMatrix = new $548f161e17fc6f48$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $548f161e17fc6f48$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $548f161e17fc6f48$export$d64030b316d3b087) texture.mapping = $548f161e17fc6f48$export$8759762a6477f2c4;
        else if (mapping === $548f161e17fc6f48$export$ee99d97d46898098) texture.mapping = $548f161e17fc6f48$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
            const mapping = texture.mapping;
            if (mapping === $548f161e17fc6f48$export$d64030b316d3b087 || mapping === $548f161e17fc6f48$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $548f161e17fc6f48$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $548f161e17fc6f48$export$9ebf355ee4ed261b extends $548f161e17fc6f48$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $548f161e17fc6f48$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $548f161e17fc6f48$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $548f161e17fc6f48$var$MAX_SAMPLES = 20;
const $548f161e17fc6f48$var$_flatCamera = /*@__PURE__*/ new $548f161e17fc6f48$export$9ebf355ee4ed261b();
const $548f161e17fc6f48$var$_clearColor = /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e();
let $548f161e17fc6f48$var$_oldTarget = null;
// Golden Ratio
const $548f161e17fc6f48$var$PHI = (1 + Math.sqrt(5)) / 2;
const $548f161e17fc6f48$var$INV_PHI = 1 / $548f161e17fc6f48$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $548f161e17fc6f48$var$_axisDirections = [
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(0, $548f161e17fc6f48$var$PHI, $548f161e17fc6f48$var$INV_PHI),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(0, $548f161e17fc6f48$var$PHI, -$548f161e17fc6f48$var$INV_PHI),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699($548f161e17fc6f48$var$INV_PHI, 0, $548f161e17fc6f48$var$PHI),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(-$548f161e17fc6f48$var$INV_PHI, 0, $548f161e17fc6f48$var$PHI),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699($548f161e17fc6f48$var$PHI, $548f161e17fc6f48$var$INV_PHI, 0),
    /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699(-$548f161e17fc6f48$var$PHI, $548f161e17fc6f48$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $548f161e17fc6f48$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $548f161e17fc6f48$var$_oldTarget = this._renderer.getRenderTarget();
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $548f161e17fc6f48$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $548f161e17fc6f48$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($548f161e17fc6f48$var$_oldTarget);
        outputTarget.scissorTest = false;
        $548f161e17fc6f48$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $548f161e17fc6f48$export$8759762a6477f2c4 || texture.mapping === $548f161e17fc6f48$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $548f161e17fc6f48$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $548f161e17fc6f48$export$8a72f490b25c56c8,
            minFilter: $548f161e17fc6f48$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $548f161e17fc6f48$export$2697304443f382bc,
            format: $548f161e17fc6f48$export$3f8bb04b555a363c,
            colorSpace: $548f161e17fc6f48$export$42429b3acfb233a4,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $548f161e17fc6f48$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $548f161e17fc6f48$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $548f161e17fc6f48$var$_createPlanes(_lodMax));
            this._blurMaterial = $548f161e17fc6f48$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $548f161e17fc6f48$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $548f161e17fc6f48$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $548f161e17fc6f48$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($548f161e17fc6f48$var$_clearColor);
        renderer.toneMapping = $548f161e17fc6f48$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $548f161e17fc6f48$export$55cbcc9b622fe1f5({
            name: 'PMREM.Background',
            side: $548f161e17fc6f48$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $548f161e17fc6f48$export$e176487c05830cc5(new $548f161e17fc6f48$export$33e43285f7406bd5(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($548f161e17fc6f48$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $548f161e17fc6f48$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $548f161e17fc6f48$export$8759762a6477f2c4 || texture.mapping === $548f161e17fc6f48$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $548f161e17fc6f48$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $548f161e17fc6f48$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $548f161e17fc6f48$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $548f161e17fc6f48$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $548f161e17fc6f48$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < this._lodPlanes.length; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $548f161e17fc6f48$var$_axisDirections[(i - 1) % $548f161e17fc6f48$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $548f161e17fc6f48$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $548f161e17fc6f48$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $548f161e17fc6f48$var$MAX_SAMPLES;
        if (samples > $548f161e17fc6f48$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$548f161e17fc6f48$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $548f161e17fc6f48$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $548f161e17fc6f48$var$LOD_MIN ? lodOut - _lodMax + $548f161e17fc6f48$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $548f161e17fc6f48$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $548f161e17fc6f48$var$_flatCamera);
    }
}
function $548f161e17fc6f48$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $548f161e17fc6f48$var$LOD_MIN + 1 + $548f161e17fc6f48$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $548f161e17fc6f48$var$LOD_MIN) sigma = $548f161e17fc6f48$var$EXTRA_LOD_SIGMA[i - lodMax + $548f161e17fc6f48$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $548f161e17fc6f48$export$b7be63a67df8959();
        planes.setAttribute('position', new $548f161e17fc6f48$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute('uv', new $548f161e17fc6f48$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute('faceIndex', new $548f161e17fc6f48$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $548f161e17fc6f48$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $548f161e17fc6f48$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $548f161e17fc6f48$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $548f161e17fc6f48$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $548f161e17fc6f48$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $548f161e17fc6f48$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($548f161e17fc6f48$var$MAX_SAMPLES);
    const poleAxis = new $548f161e17fc6f48$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $548f161e17fc6f48$export$83c7d75d550a8b0d({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $548f161e17fc6f48$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $548f161e17fc6f48$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $548f161e17fc6f48$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $548f161e17fc6f48$var$_getEquirectMaterial() {
    return new $548f161e17fc6f48$export$83c7d75d550a8b0d({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $548f161e17fc6f48$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $548f161e17fc6f48$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $548f161e17fc6f48$var$_getCubemapMaterial() {
    return new $548f161e17fc6f48$export$83c7d75d550a8b0d({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $548f161e17fc6f48$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $548f161e17fc6f48$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $548f161e17fc6f48$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $548f161e17fc6f48$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $548f161e17fc6f48$export$d64030b316d3b087 || mapping === $548f161e17fc6f48$export$ee99d97d46898098;
            const isCubeMap = mapping === $548f161e17fc6f48$export$8759762a6477f2c4 || mapping === $548f161e17fc6f48$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    let renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new $548f161e17fc6f48$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (cubeUVmaps.has(texture)) return cubeUVmaps.get(texture).texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $548f161e17fc6f48$export$6add42717753e221(renderer);
                            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $548f161e17fc6f48$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension('EXT_color_buffer_float');
            else {
                getExtension('WEBGL_depth_texture');
                getExtension('OES_texture_float');
                getExtension('OES_texture_half_float');
                getExtension('OES_texture_half_float_linear');
                getExtension('OES_standard_derivatives');
                getExtension('OES_element_index_uint');
                getExtension('OES_vertex_array_object');
                getExtension('ANGLE_instanced_arrays');
            }
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $548f161e17fc6f48$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        for(const name in geometry.morphAttributes){
            const array = geometry.morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.remove(array[i]);
        }
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], gl.ARRAY_BUFFER);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ($548f161e17fc6f48$var$arrayNeedsUint32(indices) ? $548f161e17fc6f48$export$7eb8c9fa25cd5bd6 : $548f161e17fc6f48$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $548f161e17fc6f48$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawElementsInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawElementsInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $548f161e17fc6f48$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $548f161e17fc6f48$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $548f161e17fc6f48$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $548f161e17fc6f48$var$WebGLMorphtargets(gl, capabilities, textures) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const morphTextures = new WeakMap();
    const morph = new $548f161e17fc6f48$export$fa7daccca11cdbe3();
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        if (capabilities.isWebGL2 === true) {
            // instead of using attributes, the WebGL 2 code path encodes morph targets
            // into an array of data textures. Each layer represents a single morph target.
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            let entry = morphTextures.get(geometry);
            if (entry === undefined || entry.count !== morphTargetsCount) {
                if (entry !== undefined) entry.texture.dispose();
                const hasMorphPosition = geometry.morphAttributes.position !== undefined;
                const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                const hasMorphColors = geometry.morphAttributes.color !== undefined;
                const morphTargets = geometry.morphAttributes.position || [];
                const morphNormals = geometry.morphAttributes.normal || [];
                const morphColors = geometry.morphAttributes.color || [];
                let vertexDataCount = 0;
                if (hasMorphPosition === true) vertexDataCount = 1;
                if (hasMorphNormals === true) vertexDataCount = 2;
                if (hasMorphColors === true) vertexDataCount = 3;
                let width = geometry.attributes.position.count * vertexDataCount;
                let height = 1;
                if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                }
                const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
                const texture = new $548f161e17fc6f48$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
                texture.type = $548f161e17fc6f48$export$f6d331659b644596;
                texture.needsUpdate = true;
                // fill buffer
                const vertexDataStride = vertexDataCount * 4;
                for(let i = 0; i < morphTargetsCount; i++){
                    const morphTarget = morphTargets[i];
                    const morphNormal = morphNormals[i];
                    const morphColor = morphColors[i];
                    const offset = width * height * 4 * i;
                    for(let j = 0; j < morphTarget.count; j++){
                        const stride = j * vertexDataStride;
                        if (hasMorphPosition === true) {
                            morph.fromBufferAttribute(morphTarget, j);
                            buffer[offset + stride + 0] = morph.x;
                            buffer[offset + stride + 1] = morph.y;
                            buffer[offset + stride + 2] = morph.z;
                            buffer[offset + stride + 3] = 0;
                        }
                        if (hasMorphNormals === true) {
                            morph.fromBufferAttribute(morphNormal, j);
                            buffer[offset + stride + 4] = morph.x;
                            buffer[offset + stride + 5] = morph.y;
                            buffer[offset + stride + 6] = morph.z;
                            buffer[offset + stride + 7] = 0;
                        }
                        if (hasMorphColors === true) {
                            morph.fromBufferAttribute(morphColor, j);
                            buffer[offset + stride + 8] = morph.x;
                            buffer[offset + stride + 9] = morph.y;
                            buffer[offset + stride + 10] = morph.z;
                            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                        }
                    }
                }
                entry = {
                    count: morphTargetsCount,
                    texture: texture,
                    size: new $548f161e17fc6f48$export$c977b3e384af9ae1(width, height)
                };
                morphTextures.set(geometry, entry);
                function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener('dispose', disposeTexture);
                }
                geometry.addEventListener('dispose', disposeTexture);
            }
            //
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
            program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
            program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
        } else {
            // When object doesn't have morph target influences defined, we treat it as a 0-length array
            // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
            const length = objectInfluences === undefined ? 0 : objectInfluences.length;
            let influences = influencesList[geometry.id];
            if (influences === undefined || influences.length !== length) {
                // initialise list
                influences = [];
                for(let i = 0; i < length; i++)influences[i] = [
                    i,
                    0
                ];
                influencesList[geometry.id] = influences;
            }
            // Collect influences
            for(let i = 0; i < length; i++){
                const influence = influences[i];
                influence[0] = i;
                influence[1] = objectInfluences[i];
            }
            influences.sort($548f161e17fc6f48$var$absNumericalSort);
            for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
            workInfluences.sort($548f161e17fc6f48$var$numericalSort);
            const morphTargets = geometry.morphAttributes.position;
            const morphNormals = geometry.morphAttributes.normal;
            let morphInfluencesSum = 0;
            for(let i = 0; i < 8; i++){
                const influence = workInfluences[i];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    if (morphTargets && geometry.getAttribute('morphTarget' + i) !== morphTargets[index]) geometry.setAttribute('morphTarget' + i, morphTargets[index]);
                    if (morphNormals && geometry.getAttribute('morphNormal' + i) !== morphNormals[index]) geometry.setAttribute('morphNormal' + i, morphNormals[index]);
                    morphInfluences[i] = value;
                    morphInfluencesSum += value;
                } else {
                    if (morphTargets && geometry.hasAttribute('morphTarget' + i) === true) geometry.deleteAttribute('morphTarget' + i);
                    if (morphNormals && geometry.hasAttribute('morphNormal' + i) === true) geometry.deleteAttribute('morphNormal' + i);
                    morphInfluences[i] = 0;
                }
            }
            // GLSL shader uses formula baseinfluence * base + sum(target * influence)
            // This allows us to switch between absolute morphs and relative morphs without changing shader code
            // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', morphInfluences);
        }
    }
    return {
        update: update
    };
}
function $548f161e17fc6f48$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $548f161e17fc6f48$var$emptyTexture = /*@__PURE__*/ new $548f161e17fc6f48$export$5431306cf43de24a();
const $548f161e17fc6f48$var$emptyArrayTexture = /*@__PURE__*/ new $548f161e17fc6f48$export$dfac6c8e811406a3();
const $548f161e17fc6f48$var$empty3dTexture = /*@__PURE__*/ new $548f161e17fc6f48$export$d7a3086320f856db();
const $548f161e17fc6f48$var$emptyCubeTexture = /*@__PURE__*/ new $548f161e17fc6f48$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $548f161e17fc6f48$var$arrayCacheF32 = [];
const $548f161e17fc6f48$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $548f161e17fc6f48$var$mat4array = new Float32Array(16);
const $548f161e17fc6f48$var$mat3array = new Float32Array(9);
const $548f161e17fc6f48$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $548f161e17fc6f48$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $548f161e17fc6f48$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $548f161e17fc6f48$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $548f161e17fc6f48$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $548f161e17fc6f48$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $548f161e17fc6f48$var$allocTexUnits(textures, n) {
    let r = $548f161e17fc6f48$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $548f161e17fc6f48$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $548f161e17fc6f48$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $548f161e17fc6f48$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($548f161e17fc6f48$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $548f161e17fc6f48$var$copyArray(cache, v);
    }
}
function $548f161e17fc6f48$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($548f161e17fc6f48$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $548f161e17fc6f48$var$copyArray(cache, v);
    }
}
function $548f161e17fc6f48$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($548f161e17fc6f48$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $548f161e17fc6f48$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $548f161e17fc6f48$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($548f161e17fc6f48$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $548f161e17fc6f48$var$copyArray(cache, v);
    } else {
        if ($548f161e17fc6f48$var$arraysEqual(cache, elements)) return;
        $548f161e17fc6f48$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $548f161e17fc6f48$var$mat2array);
        $548f161e17fc6f48$var$copyArray(cache, elements);
    }
}
function $548f161e17fc6f48$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($548f161e17fc6f48$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $548f161e17fc6f48$var$copyArray(cache, v);
    } else {
        if ($548f161e17fc6f48$var$arraysEqual(cache, elements)) return;
        $548f161e17fc6f48$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $548f161e17fc6f48$var$mat3array);
        $548f161e17fc6f48$var$copyArray(cache, elements);
    }
}
function $548f161e17fc6f48$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($548f161e17fc6f48$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $548f161e17fc6f48$var$copyArray(cache, v);
    } else {
        if ($548f161e17fc6f48$var$arraysEqual(cache, elements)) return;
        $548f161e17fc6f48$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $548f161e17fc6f48$var$mat4array);
        $548f161e17fc6f48$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $548f161e17fc6f48$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $548f161e17fc6f48$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($548f161e17fc6f48$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $548f161e17fc6f48$var$copyArray(cache, v);
    }
}
function $548f161e17fc6f48$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($548f161e17fc6f48$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $548f161e17fc6f48$var$copyArray(cache, v);
    }
}
function $548f161e17fc6f48$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($548f161e17fc6f48$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $548f161e17fc6f48$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $548f161e17fc6f48$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $548f161e17fc6f48$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($548f161e17fc6f48$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $548f161e17fc6f48$var$copyArray(cache, v);
    }
}
function $548f161e17fc6f48$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($548f161e17fc6f48$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $548f161e17fc6f48$var$copyArray(cache, v);
    }
}
function $548f161e17fc6f48$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($548f161e17fc6f48$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $548f161e17fc6f48$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $548f161e17fc6f48$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2D(v || $548f161e17fc6f48$var$emptyTexture, unit);
}
function $548f161e17fc6f48$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $548f161e17fc6f48$var$empty3dTexture, unit);
}
function $548f161e17fc6f48$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $548f161e17fc6f48$var$emptyCubeTexture, unit);
}
function $548f161e17fc6f48$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $548f161e17fc6f48$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $548f161e17fc6f48$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $548f161e17fc6f48$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $548f161e17fc6f48$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $548f161e17fc6f48$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $548f161e17fc6f48$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $548f161e17fc6f48$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $548f161e17fc6f48$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $548f161e17fc6f48$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $548f161e17fc6f48$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $548f161e17fc6f48$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $548f161e17fc6f48$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $548f161e17fc6f48$var$setValueV4i; // _VEC4
        case 0x1405:
            return $548f161e17fc6f48$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $548f161e17fc6f48$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $548f161e17fc6f48$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $548f161e17fc6f48$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $548f161e17fc6f48$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $548f161e17fc6f48$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $548f161e17fc6f48$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $548f161e17fc6f48$var$setValueT2DArray1;
    }
}
// Array of scalars
function $548f161e17fc6f48$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $548f161e17fc6f48$var$setValueV2fArray(gl, v) {
    const data = $548f161e17fc6f48$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $548f161e17fc6f48$var$setValueV3fArray(gl, v) {
    const data = $548f161e17fc6f48$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $548f161e17fc6f48$var$setValueV4fArray(gl, v) {
    const data = $548f161e17fc6f48$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $548f161e17fc6f48$var$setValueM2Array(gl, v) {
    const data = $548f161e17fc6f48$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $548f161e17fc6f48$var$setValueM3Array(gl, v) {
    const data = $548f161e17fc6f48$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $548f161e17fc6f48$var$setValueM4Array(gl, v) {
    const data = $548f161e17fc6f48$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $548f161e17fc6f48$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $548f161e17fc6f48$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $548f161e17fc6f48$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $548f161e17fc6f48$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $548f161e17fc6f48$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $548f161e17fc6f48$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $548f161e17fc6f48$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $548f161e17fc6f48$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $548f161e17fc6f48$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $548f161e17fc6f48$var$allocTexUnits(textures, n);
    if (!$548f161e17fc6f48$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $548f161e17fc6f48$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $548f161e17fc6f48$var$emptyTexture, units[i]);
}
function $548f161e17fc6f48$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $548f161e17fc6f48$var$allocTexUnits(textures, n);
    if (!$548f161e17fc6f48$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $548f161e17fc6f48$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $548f161e17fc6f48$var$empty3dTexture, units[i]);
}
function $548f161e17fc6f48$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $548f161e17fc6f48$var$allocTexUnits(textures, n);
    if (!$548f161e17fc6f48$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $548f161e17fc6f48$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $548f161e17fc6f48$var$emptyCubeTexture, units[i]);
}
function $548f161e17fc6f48$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $548f161e17fc6f48$var$allocTexUnits(textures, n);
    if (!$548f161e17fc6f48$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $548f161e17fc6f48$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $548f161e17fc6f48$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $548f161e17fc6f48$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $548f161e17fc6f48$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $548f161e17fc6f48$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $548f161e17fc6f48$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $548f161e17fc6f48$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $548f161e17fc6f48$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $548f161e17fc6f48$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $548f161e17fc6f48$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $548f161e17fc6f48$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $548f161e17fc6f48$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $548f161e17fc6f48$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $548f161e17fc6f48$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $548f161e17fc6f48$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $548f161e17fc6f48$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $548f161e17fc6f48$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $548f161e17fc6f48$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $548f161e17fc6f48$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $548f161e17fc6f48$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $548f161e17fc6f48$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $548f161e17fc6f48$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $548f161e17fc6f48$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.setValue = $548f161e17fc6f48$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $548f161e17fc6f48$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.size = activeInfo.size;
        this.setValue = $548f161e17fc6f48$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $548f161e17fc6f48$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $548f161e17fc6f48$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $548f161e17fc6f48$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $548f161e17fc6f48$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $548f161e17fc6f48$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $548f161e17fc6f48$var$RePathPart.exec(path), matchEnd = $548f161e17fc6f48$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $548f161e17fc6f48$var$addUniform(container, subscript === undefined ? new $548f161e17fc6f48$var$SingleUniform(id, activeInfo, addr) : new $548f161e17fc6f48$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $548f161e17fc6f48$var$StructuredUniform(id);
                $548f161e17fc6f48$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $548f161e17fc6f48$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $548f161e17fc6f48$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $548f161e17fc6f48$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $548f161e17fc6f48$var$programIdCount = 0;
function $548f161e17fc6f48$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
function $548f161e17fc6f48$var$getEncodingComponents(colorSpace1) {
    const workingPrimaries = $548f161e17fc6f48$export$5e6fd513f44698c.getPrimaries($548f161e17fc6f48$export$5e6fd513f44698c.workingColorSpace);
    const encodingPrimaries = $548f161e17fc6f48$export$5e6fd513f44698c.getPrimaries(colorSpace1);
    let gamutMapping;
    if (workingPrimaries === encodingPrimaries) gamutMapping = '';
    else if (workingPrimaries === $548f161e17fc6f48$export$ef371755dbe7f98a && encodingPrimaries === $548f161e17fc6f48$export$ce9118f9eaae3bb2) gamutMapping = 'LinearDisplayP3ToLinearSRGB';
    else if (workingPrimaries === $548f161e17fc6f48$export$ce9118f9eaae3bb2 && encodingPrimaries === $548f161e17fc6f48$export$ef371755dbe7f98a) gamutMapping = 'LinearSRGBToLinearDisplayP3';
    switch(colorSpace1){
        case $548f161e17fc6f48$export$42429b3acfb233a4:
        case $548f161e17fc6f48$export$c0dc1bc7e964761:
            return [
                gamutMapping,
                'LinearTransferOETF'
            ];
        case $548f161e17fc6f48$export$561f394b24edfcaa:
        case $548f161e17fc6f48$export$626af19ae879bdf6:
            return [
                gamutMapping,
                'sRGBTransferOETF'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported color space:', colorSpace1);
            return [
                gamutMapping,
                'LinearTransferOETF'
            ];
    }
}
function $548f161e17fc6f48$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $548f161e17fc6f48$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $548f161e17fc6f48$var$getTexelEncodingFunction(functionName, colorSpace1) {
    const components = $548f161e17fc6f48$var$getEncodingComponents(colorSpace1);
    return `vec4 ${functionName}( vec4 value ) { return ${components[0]}( ${components[1]}( value ) ); }`;
}
function $548f161e17fc6f48$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $548f161e17fc6f48$export$98f52c2a46c598ca:
            toneMappingName = 'Linear';
            break;
        case $548f161e17fc6f48$export$74b25e54b3bcd548:
            toneMappingName = 'Reinhard';
            break;
        case $548f161e17fc6f48$export$932b3dd283d4a366:
            toneMappingName = 'OptimizedCineon';
            break;
        case $548f161e17fc6f48$export$a0d98fe6d7e4af64:
            toneMappingName = 'ACESFilmic';
            break;
        case $548f161e17fc6f48$export$2c7b09c1e9abfb5e:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
function $548f161e17fc6f48$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.normalMapTangentSpace || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === 'physical' ? '#extension GL_OES_standard_derivatives : enable' : '',
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? '#extension GL_EXT_frag_depth : enable' : '',
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? '#extension GL_EXT_draw_buffers : require' : '',
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? '#extension GL_EXT_shader_texture_lod : enable' : ''
    ];
    return chunks.filter($548f161e17fc6f48$var$filterEmptyLine).join('\n');
}
function $548f161e17fc6f48$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $548f161e17fc6f48$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $548f161e17fc6f48$var$filterEmptyLine(string) {
    return string !== '';
}
function $548f161e17fc6f48$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $548f161e17fc6f48$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $548f161e17fc6f48$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $548f161e17fc6f48$var$resolveIncludes(string) {
    return string.replace($548f161e17fc6f48$var$includePattern, $548f161e17fc6f48$var$includeReplacer);
}
const $548f161e17fc6f48$var$shaderChunkMap = new Map([
    [
        'encodings_fragment',
        'colorspace_fragment'
    ],
    [
        'encodings_pars_fragment',
        'colorspace_pars_fragment'
    ],
    [
        'output_fragment',
        'opaque_fragment'
    ]
]);
function $548f161e17fc6f48$var$includeReplacer(match, include) {
    let string = $548f161e17fc6f48$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $548f161e17fc6f48$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $548f161e17fc6f48$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $548f161e17fc6f48$var$resolveIncludes(string);
}
// Unroll Loops
const $548f161e17fc6f48$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $548f161e17fc6f48$var$unrollLoops(string) {
    return string.replace($548f161e17fc6f48$var$unrollLoopPattern, $548f161e17fc6f48$var$loopReplacer);
}
function $548f161e17fc6f48$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $548f161e17fc6f48$var$generatePrecision(parameters) {
    let precisionstring = 'precision ' + parameters.precision + ' float;\nprecision ' + parameters.precision + ' int;';
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $548f161e17fc6f48$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === $548f161e17fc6f48$export$5813f879eee7cd88) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === $548f161e17fc6f48$export$a47c4b43a1be34f0) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === $548f161e17fc6f48$export$896ae1ade6c829c4) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $548f161e17fc6f48$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $548f161e17fc6f48$export$8759762a6477f2c4:
        case $548f161e17fc6f48$export$dc59f8aed047f61d:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case $548f161e17fc6f48$export$dbf3e70ff37af79:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $548f161e17fc6f48$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $548f161e17fc6f48$export$dc59f8aed047f61d:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $548f161e17fc6f48$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case $548f161e17fc6f48$export$e50ac29801f1774d:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case $548f161e17fc6f48$export$9f9d94f963c85479:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case $548f161e17fc6f48$export$e641dc52bc3494aa:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $548f161e17fc6f48$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $548f161e17fc6f48$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $548f161e17fc6f48$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $548f161e17fc6f48$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $548f161e17fc6f48$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $548f161e17fc6f48$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $548f161e17fc6f48$var$generateCubeUVSize(parameters);
    const customExtensions = parameters.isWebGL2 ? '' : $548f161e17fc6f48$var$generateExtensions(parameters);
    const customDefines = $548f161e17fc6f48$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($548f161e17fc6f48$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            customExtensions,
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($548f161e17fc6f48$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $548f161e17fc6f48$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors && parameters.isWebGL2 ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE' : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.useLegacyLights ? '#define LEGACY_LIGHTS' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )',
            '	attribute vec3 morphTarget0;',
            '	attribute vec3 morphTarget1;',
            '	attribute vec3 morphTarget2;',
            '	attribute vec3 morphTarget3;',
            '	#ifdef USE_MORPHNORMALS',
            '		attribute vec3 morphNormal0;',
            '		attribute vec3 morphNormal1;',
            '		attribute vec3 morphNormal2;',
            '		attribute vec3 morphNormal3;',
            '	#else',
            '		attribute vec3 morphTarget4;',
            '		attribute vec3 morphTarget5;',
            '		attribute vec3 morphTarget6;',
            '		attribute vec3 morphTarget7;',
            '	#endif',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($548f161e17fc6f48$var$filterEmptyLine).join('\n');
        prefixFragment = [
            customExtensions,
            $548f161e17fc6f48$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.useLegacyLights ? '#define LEGACY_LIGHTS' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== $548f161e17fc6f48$export$9fcb6b4294603b2 ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== $548f161e17fc6f48$export$9fcb6b4294603b2 ? $548f161e17fc6f48$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== $548f161e17fc6f48$export$9fcb6b4294603b2 ? $548f161e17fc6f48$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $548f161e17fc6f48$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $548f161e17fc6f48$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($548f161e17fc6f48$var$filterEmptyLine).join('\n');
    }
    vertexShader = $548f161e17fc6f48$var$resolveIncludes(vertexShader);
    vertexShader = $548f161e17fc6f48$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $548f161e17fc6f48$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $548f161e17fc6f48$var$resolveIncludes(fragmentShader);
    fragmentShader = $548f161e17fc6f48$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $548f161e17fc6f48$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $548f161e17fc6f48$var$unrollLoops(vertexShader);
    fragmentShader = $548f161e17fc6f48$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            'precision mediump sampler2DArray;',
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === $548f161e17fc6f48$export$f63012db5506e7dd ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === $548f161e17fc6f48$export$f63012db5506e7dd ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $548f161e17fc6f48$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $548f161e17fc6f48$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
            runnable = false;
            if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
            else {
                // default error reporting
                const vertexErrors = $548f161e17fc6f48$var$getShaderErrors(gl, glVertexShader, 'vertex');
                const fragmentErrors = $548f161e17fc6f48$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
            }
        } else if (programLog !== '') console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
        else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $548f161e17fc6f48$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $548f161e17fc6f48$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $548f161e17fc6f48$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $548f161e17fc6f48$var$_id$1 = 0;
class $548f161e17fc6f48$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $548f161e17fc6f48$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $548f161e17fc6f48$var$WebGLShaderStage {
    constructor(code){
        this.id = $548f161e17fc6f48$var$_id$1++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $548f161e17fc6f48$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $548f161e17fc6f48$export$89312ce47c0ca777();
    const _customShaders = new $548f161e17fc6f48$var$WebGLShaderCache();
    const programs = [];
    const IS_WEBGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        if (value === 0) return 'uv';
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $548f161e17fc6f48$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $548f161e17fc6f48$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        const HAS_ATTRIBUTE_UV1 = !!geometry.attributes.uv1;
        const HAS_ATTRIBUTE_UV2 = !!geometry.attributes.uv2;
        const HAS_ATTRIBUTE_UV3 = !!geometry.attributes.uv3;
        let toneMapping = $548f161e17fc6f48$export$9fcb6b4294603b2;
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            isWebGL2: IS_WEBGL2,
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : $548f161e17fc6f48$export$42429b3acfb233a4,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === $548f161e17fc6f48$export$9990ad26f9db5b2c,
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === $548f161e17fc6f48$export$2852a58ebdac27b8,
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === $548f161e17fc6f48$export$5b29a26d96ee6af0,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            vertexUv1s: HAS_ATTRIBUTE_UV1,
            vertexUv2s: HAS_ATTRIBUTE_UV2,
            vertexUv3s: HAS_ATTRIBUTE_UV3,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            useLegacyLights: renderer._useLegacyLights,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && $548f161e17fc6f48$export$5e6fd513f44698c.getTransfer(material.map.colorSpace) === $548f161e17fc6f48$export$8d0a61916cc26abb,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $548f161e17fc6f48$export$3b296b6f144d5b03,
            flipSided: material.side === $548f161e17fc6f48$export$d9f0486e75b5ace,
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: HAS_EXTENSIONS && material.extensions.derivatives === true,
            extensionFragDepth: HAS_EXTENSIONS && material.extensions.fragDepth === true,
            extensionDrawBuffers: HAS_EXTENSIONS && material.extensions.drawBuffers === true,
            extensionShaderTextureLOD: HAS_EXTENSIONS && material.extensions.shaderTextureLOD === true,
            rendererExtensionFragDepth: IS_WEBGL2 || extensions.has('EXT_frag_depth'),
            rendererExtensionDrawBuffers: IS_WEBGL2 || extensions.has('WEBGL_draw_buffers'),
            rendererExtensionShaderTextureLod: IS_WEBGL2 || extensions.has('EXT_shader_texture_lod'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.isWebGL2) _programLayers.enable(0);
        if (parameters.supportsVertexTextures) _programLayers.enable(1);
        if (parameters.instancing) _programLayers.enable(2);
        if (parameters.instancingColor) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.skinning) _programLayers.enable(4);
        if (parameters.morphTargets) _programLayers.enable(5);
        if (parameters.morphNormals) _programLayers.enable(6);
        if (parameters.morphColors) _programLayers.enable(7);
        if (parameters.premultipliedAlpha) _programLayers.enable(8);
        if (parameters.shadowMapEnabled) _programLayers.enable(9);
        if (parameters.useLegacyLights) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $548f161e17fc6f48$export$bee4a7d47f8f5014[shaderID];
            uniforms = $548f161e17fc6f48$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $548f161e17fc6f48$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $548f161e17fc6f48$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $548f161e17fc6f48$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $548f161e17fc6f48$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $548f161e17fc6f48$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $548f161e17fc6f48$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $548f161e17fc6f48$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $548f161e17fc6f48$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $548f161e17fc6f48$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $548f161e17fc6f48$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $548f161e17fc6f48$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $548f161e17fc6f48$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new $548f161e17fc6f48$export$64b5c384219d3699(),
                        color: new $548f161e17fc6f48$export$892596cec99bc70e()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new $548f161e17fc6f48$export$64b5c384219d3699(),
                        direction: new $548f161e17fc6f48$export$64b5c384219d3699(),
                        color: new $548f161e17fc6f48$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new $548f161e17fc6f48$export$64b5c384219d3699(),
                        color: new $548f161e17fc6f48$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new $548f161e17fc6f48$export$64b5c384219d3699(),
                        skyColor: new $548f161e17fc6f48$export$892596cec99bc70e(),
                        groundColor: new $548f161e17fc6f48$export$892596cec99bc70e()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new $548f161e17fc6f48$export$892596cec99bc70e(),
                        position: new $548f161e17fc6f48$export$64b5c384219d3699(),
                        halfWidth: new $548f161e17fc6f48$export$64b5c384219d3699(),
                        halfHeight: new $548f161e17fc6f48$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $548f161e17fc6f48$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $548f161e17fc6f48$export$c977b3e384af9ae1()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $548f161e17fc6f48$export$c977b3e384af9ae1()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $548f161e17fc6f48$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $548f161e17fc6f48$var$nextVersion = 0;
function $548f161e17fc6f48$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $548f161e17fc6f48$var$WebGLLights(extensions, capabilities) {
    const cache = new $548f161e17fc6f48$var$UniformsCache();
    const shadowCache = $548f161e17fc6f48$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $548f161e17fc6f48$export$64b5c384219d3699());
    const vector3 = new $548f161e17fc6f48$export$64b5c384219d3699();
    const matrix4 = new $548f161e17fc6f48$export$2ae72fc923e5eb5();
    const matrix42 = new $548f161e17fc6f48$export$2ae72fc923e5eb5();
    function setup(lights, useLegacyLights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($548f161e17fc6f48$var$shadowCastingAndTexturingLightsFirst);
        // artist-friendly light intensity scaling factor
        const scaleFactor = useLegacyLights === true ? Math.PI : 1;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity * scaleFactor;
                g += color.g * intensity * scaleFactor;
                b += color.b * intensity * scaleFactor;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $548f161e17fc6f48$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $548f161e17fc6f48$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has('OES_texture_float_linear') === true) {
                    state.rectAreaLTC1 = $548f161e17fc6f48$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $548f161e17fc6f48$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has('OES_texture_half_float_linear') === true) {
                    state.rectAreaLTC1 = $548f161e17fc6f48$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $548f161e17fc6f48$export$6643083551874bf5.LTC_HALF_2;
                } else console.error('THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.');
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $548f161e17fc6f48$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $548f161e17fc6f48$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $548f161e17fc6f48$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights(useLegacyLights) {
        lights.setup(lightsArray, useLegacyLights);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $548f161e17fc6f48$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $548f161e17fc6f48$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $548f161e17fc6f48$var$WebGLRenderState(extensions, capabilities);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $548f161e17fc6f48$export$2698c22ec13825db extends $548f161e17fc6f48$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        this.depthPacking = $548f161e17fc6f48$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $548f161e17fc6f48$export$33e187ed002f2a19 extends $548f161e17fc6f48$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $548f161e17fc6f48$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $548f161e17fc6f48$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $548f161e17fc6f48$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $548f161e17fc6f48$export$35efe6f4c85463d2();
    const _shadowMapSize = new $548f161e17fc6f48$export$c977b3e384af9ae1(), _viewportSize = new $548f161e17fc6f48$export$c977b3e384af9ae1(), _viewport = new $548f161e17fc6f48$export$fa7daccca11cdbe3(), _depthMaterial = new $548f161e17fc6f48$export$2698c22ec13825db({
        depthPacking: $548f161e17fc6f48$export$8f910f4c4f73df11
    }), _distanceMaterial = new $548f161e17fc6f48$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        [$548f161e17fc6f48$export$2ede184fc2998901]: $548f161e17fc6f48$export$d9f0486e75b5ace,
        [$548f161e17fc6f48$export$d9f0486e75b5ace]: $548f161e17fc6f48$export$2ede184fc2998901,
        [$548f161e17fc6f48$export$3b296b6f144d5b03]: $548f161e17fc6f48$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $548f161e17fc6f48$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $548f161e17fc6f48$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $548f161e17fc6f48$var$vertex,
        fragmentShader: $548f161e17fc6f48$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $548f161e17fc6f48$export$b7be63a67df8959();
    fullScreenTri.setAttribute('position', new $548f161e17fc6f48$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $548f161e17fc6f48$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $548f161e17fc6f48$export$5813f879eee7cd88;
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($548f161e17fc6f48$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== $548f161e17fc6f48$export$896ae1ade6c829c4 && this.type === $548f161e17fc6f48$export$896ae1ade6c829c4;
        const fromVSM = _previousType === $548f161e17fc6f48$export$896ae1ade6c829c4 && this.type !== $548f161e17fc6f48$export$896ae1ade6c829c4;
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== $548f161e17fc6f48$export$896ae1ade6c829c4 ? {
                    minFilter: $548f161e17fc6f48$export$727aa5ec3fe39bf0,
                    magFilter: $548f161e17fc6f48$export$727aa5ec3fe39bf0
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new $548f161e17fc6f48$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $548f161e17fc6f48$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $548f161e17fc6f48$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (_renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $548f161e17fc6f48$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = _renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $548f161e17fc6f48$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $548f161e17fc6f48$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $548f161e17fc6f48$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $548f161e17fc6f48$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case $548f161e17fc6f48$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case $548f161e17fc6f48$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case $548f161e17fc6f48$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case $548f161e17fc6f48$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case $548f161e17fc6f48$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case $548f161e17fc6f48$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case $548f161e17fc6f48$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case $548f161e17fc6f48$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new $548f161e17fc6f48$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $548f161e17fc6f48$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (isWebGL2 && (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY)) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    if (isWebGL2) {
        emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
        emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    }
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc($548f161e17fc6f48$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($548f161e17fc6f48$export$b9a7b4fc5cb15f9b);
    enable(gl.CULL_FACE);
    setBlending($548f161e17fc6f48$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
                if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
                if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            if (renderTarget.isWebGLMultipleRenderTargets) {
                const textures = renderTarget.texture;
                if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                    for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                }
            } else if (drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                drawBuffers[0] = gl.COLOR_ATTACHMENT0;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) {
            if (capabilities.isWebGL2) gl.drawBuffers(drawBuffers);
            else extensions.get('WEBGL_draw_buffers').drawBuffersWEBGL(drawBuffers);
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$548f161e17fc6f48$export$20183a0484ce21a0]: gl.FUNC_ADD,
        [$548f161e17fc6f48$export$73e0df5177988548]: gl.FUNC_SUBTRACT,
        [$548f161e17fc6f48$export$28e582859cbec660]: gl.FUNC_REVERSE_SUBTRACT
    };
    if (isWebGL2) {
        equationToGL[$548f161e17fc6f48$export$c8c1508da8d0600c] = gl.MIN;
        equationToGL[$548f161e17fc6f48$export$99948c02fb51055f] = gl.MAX;
    } else {
        const extension = extensions.get('EXT_blend_minmax');
        if (extension !== null) {
            equationToGL[$548f161e17fc6f48$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$548f161e17fc6f48$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$548f161e17fc6f48$export$2110f05edf778d3d]: gl.ZERO,
        [$548f161e17fc6f48$export$8805bad65e24940e]: gl.ONE,
        [$548f161e17fc6f48$export$7fbe15b28d28cf52]: gl.SRC_COLOR,
        [$548f161e17fc6f48$export$d5773124e86cf28c]: gl.SRC_ALPHA,
        [$548f161e17fc6f48$export$c05e2a1fc8609506]: gl.SRC_ALPHA_SATURATE,
        [$548f161e17fc6f48$export$ef5f2dd8ffac5574]: gl.DST_COLOR,
        [$548f161e17fc6f48$export$a78aed1ca2a87192]: gl.DST_ALPHA,
        [$548f161e17fc6f48$export$947829af9f2c17f6]: gl.ONE_MINUS_SRC_COLOR,
        [$548f161e17fc6f48$export$11d468cc7f19e971]: gl.ONE_MINUS_SRC_ALPHA,
        [$548f161e17fc6f48$export$56b85b2686ab16]: gl.ONE_MINUS_DST_COLOR,
        [$548f161e17fc6f48$export$5d0fe17fd8773bac]: gl.ONE_MINUS_DST_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $548f161e17fc6f48$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== $548f161e17fc6f48$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $548f161e17fc6f48$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $548f161e17fc6f48$export$20183a0484ce21a0) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = $548f161e17fc6f48$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $548f161e17fc6f48$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $548f161e17fc6f48$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $548f161e17fc6f48$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case $548f161e17fc6f48$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $548f161e17fc6f48$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case $548f161e17fc6f48$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $548f161e17fc6f48$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case $548f161e17fc6f48$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $548f161e17fc6f48$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $548f161e17fc6f48$export$3b296b6f144d5b03 ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === $548f161e17fc6f48$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $548f161e17fc6f48$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($548f161e17fc6f48$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $548f161e17fc6f48$export$3237e1f2c1ea1f44) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === $548f161e17fc6f48$export$b9a7b4fc5cb15f9b) gl.cullFace(gl.BACK);
                else if (cullFace === $548f161e17fc6f48$export$b8058bcc7037d3f3) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
            gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $548f161e17fc6f48$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $548f161e17fc6f48$var$createElementNS('canvas');
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $548f161e17fc6f48$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + image.width + 'x' + image.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + image.width + 'x' + image.height + ').');
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $548f161e17fc6f48$var$isPowerOfTwo(image.width) && $548f161e17fc6f48$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $548f161e17fc6f48$export$9d9334239a5a5e06 || texture.wrapT !== $548f161e17fc6f48$export$9d9334239a5a5e06 || texture.minFilter !== $548f161e17fc6f48$export$727aa5ec3fe39bf0 && texture.minFilter !== $548f161e17fc6f48$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $548f161e17fc6f48$export$727aa5ec3fe39bf0 && texture.minFilter !== $548f161e17fc6f48$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace1, forceLinearTransfer = false) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? $548f161e17fc6f48$export$f197347d588c1b4a : $548f161e17fc6f48$export$5e6fd513f44698c.getTransfer(colorSpace1);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getMipLevels(texture, image, supportsMips) {
        if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== $548f161e17fc6f48$export$727aa5ec3fe39bf0 && texture.minFilter !== $548f161e17fc6f48$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $548f161e17fc6f48$export$727aa5ec3fe39bf0 || f === $548f161e17fc6f48$export$d129e38cf6feaa8c || f === $548f161e17fc6f48$export$d2327c1afe5bfdf2) return _gl.NEAREST;
        return _gl.LINEAR;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [$548f161e17fc6f48$export$533346c8e8dac0f5]: _gl.REPEAT,
        [$548f161e17fc6f48$export$9d9334239a5a5e06]: _gl.CLAMP_TO_EDGE,
        [$548f161e17fc6f48$export$c7e7c00b14f51a4f]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [$548f161e17fc6f48$export$727aa5ec3fe39bf0]: _gl.NEAREST,
        [$548f161e17fc6f48$export$d129e38cf6feaa8c]: _gl.NEAREST_MIPMAP_NEAREST,
        [$548f161e17fc6f48$export$d2327c1afe5bfdf2]: _gl.NEAREST_MIPMAP_LINEAR,
        [$548f161e17fc6f48$export$8a72f490b25c56c8]: _gl.LINEAR,
        [$548f161e17fc6f48$export$19a719f377145a13]: _gl.LINEAR_MIPMAP_NEAREST,
        [$548f161e17fc6f48$export$5d8599b6a933fb1b]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [$548f161e17fc6f48$export$d9e2d19a747baaab]: _gl.NEVER,
        [$548f161e17fc6f48$export$187b73a3e352c145]: _gl.ALWAYS,
        [$548f161e17fc6f48$export$36bcf49c713b3eb7]: _gl.LESS,
        [$548f161e17fc6f48$export$64eea11eb407ddf1]: _gl.LEQUAL,
        [$548f161e17fc6f48$export$66f28d946fc6a0d5]: _gl.EQUAL,
        [$548f161e17fc6f48$export$1cdcb70d53d65f61]: _gl.GEQUAL,
        [$548f161e17fc6f48$export$155af022118f3a38]: _gl.GREATER,
        [$548f161e17fc6f48$export$67ab95dde6bed156]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, _gl.CLAMP_TO_EDGE);
            if (texture.wrapS !== $548f161e17fc6f48$export$9d9334239a5a5e06 || texture.wrapT !== $548f161e17fc6f48$export$9d9334239a5a5e06) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.');
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterFallback(texture.minFilter));
            if (texture.minFilter !== $548f161e17fc6f48$export$727aa5ec3fe39bf0 && texture.minFilter !== $548f161e17fc6f48$export$8a72f490b25c56c8) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.');
        }
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            if (texture.magFilter === $548f161e17fc6f48$export$727aa5ec3fe39bf0) return;
            if (texture.minFilter !== $548f161e17fc6f48$export$d2327c1afe5bfdf2 && texture.minFilter !== $548f161e17fc6f48$export$5d8599b6a933fb1b) return;
            if (texture.type === $548f161e17fc6f48$export$f6d331659b644596 && extensions.has('OES_texture_float_linear') === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $548f161e17fc6f48$export$2697304443f382bc && extensions.has('OES_texture_half_float_linear') === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = $548f161e17fc6f48$export$5e6fd513f44698c.getPrimaries($548f161e17fc6f48$export$5e6fd513f44698c.workingColorSpace);
            const texturePrimaries = texture.colorSpace === $548f161e17fc6f48$export$bfcb490c2dd3db51 ? null : $548f161e17fc6f48$export$5e6fd513f44698c.getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === $548f161e17fc6f48$export$bfcb490c2dd3db51 || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
            let image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
            image = verifyColorSpace(texture, image);
            const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace);
            let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture, supportsMips);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const levels = getMipLevels(texture, image, supportsMips);
            if (texture.isDepthTexture) {
                // populate depth texture with dummy data
                glInternalFormat = _gl.DEPTH_COMPONENT;
                if (isWebGL2) {
                    if (texture.type === $548f161e17fc6f48$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (texture.type === $548f161e17fc6f48$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                    else if (texture.type === $548f161e17fc6f48$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH24_STENCIL8;
                    else glInternalFormat = _gl.DEPTH_COMPONENT16; // WebGL2 requires sized internalformat for glTexImage2D
                } else if (texture.type === $548f161e17fc6f48$export$f6d331659b644596) console.error('WebGLRenderer: Floating point depth texture requires WebGL2.');
                // validation checks for WebGL 1
                if (texture.format === $548f161e17fc6f48$export$c1b6b5136be58045 && glInternalFormat === _gl.DEPTH_COMPONENT) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                {
                    if (texture.type !== $548f161e17fc6f48$export$c63dc51868b06a9d && texture.type !== $548f161e17fc6f48$export$c3c7fc4518ebba96) {
                        console.warn('THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.');
                        texture.type = $548f161e17fc6f48$export$c3c7fc4518ebba96;
                        glType = utils.convert(texture.type);
                    }
                }
                if (texture.format === $548f161e17fc6f48$export$1e113ac2d0905829 && glInternalFormat === _gl.DEPTH_COMPONENT) {
                    // Depth stencil textures need the DEPTH_STENCIL internal format
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    glInternalFormat = _gl.DEPTH_STENCIL;
                    // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                    // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    if (texture.type !== $548f161e17fc6f48$export$6c8ea339bfab1301) {
                        console.warn('THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.');
                        texture.type = $548f161e17fc6f48$export$6c8ea339bfab1301;
                        glType = utils.convert(texture.type);
                    }
                }
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $548f161e17fc6f48$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0);
                                else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else if (useTexStorage) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                        else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $548f161e17fc6f48$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = $548f161e17fc6f48$export$5e6fd513f44698c.getPrimaries($548f161e17fc6f48$export$5e6fd513f44698c.workingColorSpace);
            const texturePrimaries = texture.colorSpace === $548f161e17fc6f48$export$bfcb490c2dd3db51 ? null : $548f161e17fc6f48$export$5e6fd513f44698c.getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === $548f161e17fc6f48$export$bfcb490c2dd3db51 || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            let levels = getMipLevels(texture, image, supportsMips);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $548f161e17fc6f48$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = isWebGL2 === true ? _gl.DEPTH_COMPONENT24 : _gl.DEPTH_COMPONENT16;
            if (isMultisample || useMultisampledRTT(renderTarget)) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $548f161e17fc6f48$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (depthTexture.type === $548f161e17fc6f48$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                }
                const samples = getRenderTargetSamples(renderTarget);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
                renderTarget.texture
            ];
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $548f161e17fc6f48$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $548f161e17fc6f48$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn('THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.');
            }
            if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                const textures = isMultipleRenderTargets ? texture : [
                    texture
                ];
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            for(let i = 0; i < 6; i++){
                if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
                if (isWebGL2) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
                else console.error('THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.');
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
            const textures = renderTarget.isWebGLMultipleRenderTargets ? renderTarget.texture : [
                renderTarget.texture
            ];
            const width = renderTarget.width;
            const height = renderTarget.height;
            let mask = _gl.COLOR_BUFFER_BIT;
            const invalidationArray = [];
            const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            const renderTargetProperties = properties.get(renderTarget);
            const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
            // If MRT we need to remove FBO attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            for(let i = 0; i < textures.length; i++){
                invalidationArray.push(_gl.COLOR_ATTACHMENT0 + i);
                if (renderTarget.depthBuffer) invalidationArray.push(depthStyle);
                const ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;
                if (ignoreDepthValues === false) {
                    if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                    if (renderTarget.stencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                }
                if (isMultipleRenderTargets) _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                if (ignoreDepthValues === true) {
                    _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, [
                        depthStyle
                    ]);
                    _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                        depthStyle
                    ]);
                }
                if (isMultipleRenderTargets) {
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                }
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                if (supportsInvalidateFramebuffer) _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArray);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                const webglTexture = properties.get(textures[i]).__webglTexture;
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
            }
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return isWebGL2 && renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace1 = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true || texture.format === $548f161e17fc6f48$export$ca1dce8b5e1de74d) return image;
        if (colorSpace1 !== $548f161e17fc6f48$export$42429b3acfb233a4 && colorSpace1 !== $548f161e17fc6f48$export$bfcb490c2dd3db51) {
            // sRGB
            if ($548f161e17fc6f48$export$5e6fd513f44698c.getTransfer(colorSpace1) === $548f161e17fc6f48$export$8d0a61916cc26abb) {
                if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has('EXT_sRGB') === true && format === $548f161e17fc6f48$export$3f8bb04b555a363c) {
                        texture.format = $548f161e17fc6f48$export$ca1dce8b5e1de74d;
                        // it's not possible to generate mips in WebGL 1 with this extension
                        texture.minFilter = $548f161e17fc6f48$export$8a72f490b25c56c8;
                        texture.generateMipmaps = false;
                    } else // slow fallback (CPU decode)
                    image = $548f161e17fc6f48$export$698882cf06df44aa.sRGBToLinear(image);
                } else // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                if (format !== $548f161e17fc6f48$export$3f8bb04b555a363c || type !== $548f161e17fc6f48$export$2e8ce08d3f6f5e10) console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else console.error('THREE.WebGLTextures: Unsupported texture color space:', colorSpace1);
        }
        return image;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $548f161e17fc6f48$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p, colorSpace1 = $548f161e17fc6f48$export$bfcb490c2dd3db51) {
        let extension;
        const transfer = $548f161e17fc6f48$export$5e6fd513f44698c.getTransfer(colorSpace1);
        if (p === $548f161e17fc6f48$export$2e8ce08d3f6f5e10) return gl.UNSIGNED_BYTE;
        if (p === $548f161e17fc6f48$export$b3969b01faf587f2) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === $548f161e17fc6f48$export$18886f8ae33e90de) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === $548f161e17fc6f48$export$545fce0311a9796a) return gl.BYTE;
        if (p === $548f161e17fc6f48$export$88572337f312435f) return gl.SHORT;
        if (p === $548f161e17fc6f48$export$c63dc51868b06a9d) return gl.UNSIGNED_SHORT;
        if (p === $548f161e17fc6f48$export$5c612977753abe2) return gl.INT;
        if (p === $548f161e17fc6f48$export$c3c7fc4518ebba96) return gl.UNSIGNED_INT;
        if (p === $548f161e17fc6f48$export$f6d331659b644596) return gl.FLOAT;
        if (p === $548f161e17fc6f48$export$2697304443f382bc) {
            if (isWebGL2) return gl.HALF_FLOAT;
            extension = extensions.get('OES_texture_half_float');
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $548f161e17fc6f48$export$988473390501ed4b) return gl.ALPHA;
        if (p === $548f161e17fc6f48$export$3f8bb04b555a363c) return gl.RGBA;
        if (p === $548f161e17fc6f48$export$cc09ccbf6d1ed449) return gl.LUMINANCE;
        if (p === $548f161e17fc6f48$export$9053a81c4a69c289) return gl.LUMINANCE_ALPHA;
        if (p === $548f161e17fc6f48$export$c1b6b5136be58045) return gl.DEPTH_COMPONENT;
        if (p === $548f161e17fc6f48$export$1e113ac2d0905829) return gl.DEPTH_STENCIL;
        // WebGL 1 sRGB fallback
        if (p === $548f161e17fc6f48$export$ca1dce8b5e1de74d) {
            extension = extensions.get('EXT_sRGB');
            if (extension !== null) return extension.SRGB_ALPHA_EXT;
            else return null;
        }
        // WebGL2 formats.
        if (p === $548f161e17fc6f48$export$4e041a7967d15c4b) return gl.RED;
        if (p === $548f161e17fc6f48$export$aa92e870a709d190) return gl.RED_INTEGER;
        if (p === $548f161e17fc6f48$export$6cdf0b461c7ce8a0) return gl.RG;
        if (p === $548f161e17fc6f48$export$1ba1c45f9f77d4d7) return gl.RG_INTEGER;
        if (p === $548f161e17fc6f48$export$c200e7d26f592f21) return gl.RGBA_INTEGER;
        // S3TC
        if (p === $548f161e17fc6f48$export$21d1799c6d552fc0 || p === $548f161e17fc6f48$export$afa304c3e981b668 || p === $548f161e17fc6f48$export$d2a1a68024a3e56c || p === $548f161e17fc6f48$export$9a79c424327dacf9) {
            if (transfer === $548f161e17fc6f48$export$8d0a61916cc26abb) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === $548f161e17fc6f48$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $548f161e17fc6f48$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $548f161e17fc6f48$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $548f161e17fc6f48$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === $548f161e17fc6f48$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $548f161e17fc6f48$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $548f161e17fc6f48$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $548f161e17fc6f48$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $548f161e17fc6f48$export$19ada9bbb1af3573 || p === $548f161e17fc6f48$export$d0f0355bb3d948e4 || p === $548f161e17fc6f48$export$b82296714358084c || p === $548f161e17fc6f48$export$b71692456c47b6c3) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === $548f161e17fc6f48$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $548f161e17fc6f48$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $548f161e17fc6f48$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $548f161e17fc6f48$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC1
        if (p === $548f161e17fc6f48$export$6ab91af2d757aee7) {
            extension = extensions.get('WEBGL_compressed_texture_etc1');
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        // ETC2
        if (p === $548f161e17fc6f48$export$7800993ef8106a6a || p === $548f161e17fc6f48$export$23ed8300a860e7d8) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === $548f161e17fc6f48$export$7800993ef8106a6a) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $548f161e17fc6f48$export$23ed8300a860e7d8) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $548f161e17fc6f48$export$dc5570b4a2b92d48 || p === $548f161e17fc6f48$export$68880cd325f8b2fb || p === $548f161e17fc6f48$export$7d2c0be323373d95 || p === $548f161e17fc6f48$export$22b52da301fc3a3e || p === $548f161e17fc6f48$export$c009e2cb4a66485e || p === $548f161e17fc6f48$export$118fff5afa255b63 || p === $548f161e17fc6f48$export$120713c829ae0667 || p === $548f161e17fc6f48$export$c79eeabbf53313e9 || p === $548f161e17fc6f48$export$443cf6567cdd6424 || p === $548f161e17fc6f48$export$6573984fc9840780 || p === $548f161e17fc6f48$export$e7aee563f30091de || p === $548f161e17fc6f48$export$2eb8634622ddeab7 || p === $548f161e17fc6f48$export$202b1ce7b5d25742 || p === $548f161e17fc6f48$export$18ab77abd087e467) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === $548f161e17fc6f48$export$dc5570b4a2b92d48) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $548f161e17fc6f48$export$68880cd325f8b2fb) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $548f161e17fc6f48$export$7d2c0be323373d95) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $548f161e17fc6f48$export$22b52da301fc3a3e) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $548f161e17fc6f48$export$c009e2cb4a66485e) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $548f161e17fc6f48$export$118fff5afa255b63) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $548f161e17fc6f48$export$120713c829ae0667) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $548f161e17fc6f48$export$c79eeabbf53313e9) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $548f161e17fc6f48$export$443cf6567cdd6424) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $548f161e17fc6f48$export$6573984fc9840780) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $548f161e17fc6f48$export$e7aee563f30091de) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $548f161e17fc6f48$export$2eb8634622ddeab7) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $548f161e17fc6f48$export$202b1ce7b5d25742) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $548f161e17fc6f48$export$18ab77abd087e467) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $548f161e17fc6f48$export$ce40b115e188bc81 || p === $548f161e17fc6f48$export$d279c5c4bac5121e || p === $548f161e17fc6f48$export$cde52d17225fdbd3) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === $548f161e17fc6f48$export$ce40b115e188bc81) return transfer === $548f161e17fc6f48$export$8d0a61916cc26abb ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === $548f161e17fc6f48$export$d279c5c4bac5121e) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === $548f161e17fc6f48$export$cde52d17225fdbd3) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === $548f161e17fc6f48$export$b1688df4c4c21670 || p === $548f161e17fc6f48$export$fc15e5d8261eed58 || p === $548f161e17fc6f48$export$d220f6ade8463a0f || p === $548f161e17fc6f48$export$768646d09dc1b6ef) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === $548f161e17fc6f48$export$ce40b115e188bc81) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === $548f161e17fc6f48$export$fc15e5d8261eed58) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === $548f161e17fc6f48$export$d220f6ade8463a0f) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === $548f161e17fc6f48$export$768646d09dc1b6ef) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === $548f161e17fc6f48$export$6c8ea339bfab1301) {
            if (isWebGL2) return gl.UNSIGNED_INT_24_8;
            extension = extensions.get('WEBGL_depth_texture');
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $548f161e17fc6f48$export$56b937d9e5581166 extends $548f161e17fc6f48$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $548f161e17fc6f48$export$eb2fcfdbd7ba97d4 extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = 'Group';
    }
}
const $548f161e17fc6f48$var$_moveEvent = {
    type: 'move'
};
class $548f161e17fc6f48$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $548f161e17fc6f48$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $548f161e17fc6f48$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $548f161e17fc6f48$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $548f161e17fc6f48$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $548f161e17fc6f48$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $548f161e17fc6f48$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $548f161e17fc6f48$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: 'connected',
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($548f161e17fc6f48$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $548f161e17fc6f48$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
class $548f161e17fc6f48$export$fc830aa069cc8c2f extends $548f161e17fc6f48$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $548f161e17fc6f48$export$c1b6b5136be58045;
        if (format !== $548f161e17fc6f48$export$c1b6b5136be58045 && format !== $548f161e17fc6f48$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        if (type === undefined && format === $548f161e17fc6f48$export$c1b6b5136be58045) type = $548f161e17fc6f48$export$c3c7fc4518ebba96;
        if (type === undefined && format === $548f161e17fc6f48$export$1e113ac2d0905829) type = $548f161e17fc6f48$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $548f161e17fc6f48$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $548f161e17fc6f48$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
class $548f161e17fc6f48$var$WebXRManager extends $548f161e17fc6f48$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        //
        const cameraL = new $548f161e17fc6f48$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $548f161e17fc6f48$export$fa7daccca11cdbe3();
        const cameraR = new $548f161e17fc6f48$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $548f161e17fc6f48$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new $548f161e17fc6f48$export$56b937d9e5581166();
        cameraXR.layers.enable(1);
        cameraXR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $548f161e17fc6f48$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $548f161e17fc6f48$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $548f161e17fc6f48$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                    const layerInit = {
                        antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    newRenderTarget = new $548f161e17fc6f48$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $548f161e17fc6f48$export$3f8bb04b555a363c,
                        type: $548f161e17fc6f48$export$2e8ce08d3f6f5e10,
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? $548f161e17fc6f48$export$1e113ac2d0905829 : $548f161e17fc6f48$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $548f161e17fc6f48$export$6c8ea339bfab1301 : $548f161e17fc6f48$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    newRenderTarget = new $548f161e17fc6f48$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $548f161e17fc6f48$export$3f8bb04b555a363c,
                        type: $548f161e17fc6f48$export$2e8ce08d3f6f5e10,
                        depthTexture: new $548f161e17fc6f48$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0
                    });
                    const renderTargetProperties = renderer.properties.get(newRenderTarget);
                    renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new $548f161e17fc6f48$export$64b5c384219d3699();
        const cameraRPos = new $548f161e17fc6f48$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
            camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            cameraXR.near = cameraR.near = cameraL.near = camera.near;
            cameraXR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = $548f161e17fc6f48$var$RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getCamera = function() {
            return cameraXR;
        };
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $548f161e17fc6f48$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $548f161e17fc6f48$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $548f161e17fc6f48$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $548f161e17fc6f48$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, $548f161e17fc6f48$var$getUnlitUniformColorSpace(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $548f161e17fc6f48$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $548f161e17fc6f48$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            // artist-friendly light intensity scaling factor
            const scaleFactor = renderer._useLegacyLights === true ? Math.PI : 1;
            uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === $548f161e17fc6f48$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $548f161e17fc6f48$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = capabilities.isWebGL2 ? gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS) : 0; // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniform = uniforms[i];
            // partly update the buffer if necessary
            if (hasUniformChanged(uniform, i, cache) === true) {
                const offset = uniform.__offset;
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                let arrayOffset = 0;
                for(let i = 0; i < values.length; i++){
                    const value = values[i];
                    const info = getUniformSize(value);
                    if (typeof value === 'number') {
                        uniform.__data[0] = value;
                        gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                    } else if (value.isMatrix3) {
                        // manually converting 3x3 to 3x4
                        uniform.__data[0] = value.elements[0];
                        uniform.__data[1] = value.elements[1];
                        uniform.__data[2] = value.elements[2];
                        uniform.__data[3] = value.elements[0];
                        uniform.__data[4] = value.elements[3];
                        uniform.__data[5] = value.elements[4];
                        uniform.__data[6] = value.elements[5];
                        uniform.__data[7] = value.elements[0];
                        uniform.__data[8] = value.elements[6];
                        uniform.__data[9] = value.elements[7];
                        uniform.__data[10] = value.elements[8];
                        uniform.__data[11] = value.elements[0];
                    } else {
                        value.toArray(uniform.__data, arrayOffset);
                        arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                    }
                }
                gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, cache) {
        const value = uniform.value;
        if (cache[index] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number') cache[index] = value;
            else {
                const values = Array.isArray(value) ? value : [
                    value
                ];
                const tempValues = [];
                for(let i = 0; i < values.length; i++)tempValues.push(values[i].clone());
                cache[index] = tempValues;
            }
            return true;
        } else {
            // compare current value with cached entry
            if (typeof value === 'number') {
                if (cache[index] !== value) {
                    cache[index] = value;
                    return true;
                }
            } else {
                const cachedObjects = Array.isArray(cache[index]) ? cache[index] : [
                    cache[index]
                ];
                const values = Array.isArray(value) ? value : [
                    value
                ];
                for(let i = 0; i < cachedObjects.length; i++){
                    const cachedObject = cachedObjects[i];
                    if (cachedObject.equals(values[i]) === false) {
                        cachedObject.copy(values[i]);
                        return true;
                    }
                }
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        let chunkOffset = 0; // offset within a single chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniform = uniforms[i];
            const infos = {
                boundary: 0,
                storage: 0 // bytes
            };
            const values = Array.isArray(uniform.value) ? uniform.value : [
                uniform.value
            ];
            for(let j = 0, jl = values.length; j < jl; j++){
                const value = values[j];
                const info = getUniformSize(value);
                infos.boundary += info.boundary;
                infos.storage += info.storage;
            }
            // the following two properties will be used for partial buffer updates
            uniform.__data = new Float32Array(infos.storage / Float32Array.BYTES_PER_ELEMENT);
            uniform.__offset = offset;
            //
            if (i > 0) {
                chunkOffset = offset % chunkSize;
                const remainingSizeInChunk = chunkSize - chunkOffset;
                // check for chunk overflow
                if (chunkOffset !== 0 && remainingSizeInChunk - infos.boundary < 0) {
                    // add padding and adjust offset
                    offset += chunkSize - chunkOffset;
                    uniform.__offset = offset;
                }
            }
            offset += infos.storage;
        }
        // ensure correct final padding
        chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number') {
            // float/int
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
class $548f161e17fc6f48$export$f6cc00ef28d7cf97 {
    constructor(parameters = {}){
        const { canvas: canvas = $548f161e17fc6f48$export$1033a2df66368859(), context: context = null, depth: depth = true, stencil: stencil = true, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = 'default', failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) _alpha = context.getContextAttributes().alpha;
        else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this._outputColorSpace = $548f161e17fc6f48$export$561f394b24edfcaa;
        // physical lights
        this._useLegacyLights = false;
        // tone mapping
        this.toneMapping = $548f161e17fc6f48$export$9fcb6b4294603b2;
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new $548f161e17fc6f48$export$fa7daccca11cdbe3();
        const _currentScissor = new $548f161e17fc6f48$export$fa7daccca11cdbe3();
        let _currentScissorTest = null;
        const _currentClearColor = new $548f161e17fc6f48$export$892596cec99bc70e(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new $548f161e17fc6f48$export$fa7daccca11cdbe3(0, 0, _width, _height);
        const _scissor = new $548f161e17fc6f48$export$fa7daccca11cdbe3(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new $548f161e17fc6f48$export$35efe6f4c85463d2();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // transmission
        let _transmissionRenderTarget = null;
        // camera matrices cache
        const _projScreenMatrix = new $548f161e17fc6f48$export$2ae72fc923e5eb5();
        const _vector2 = new $548f161e17fc6f48$export$c977b3e384af9ae1();
        const _vector3 = new $548f161e17fc6f48$export$64b5c384219d3699();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextNames, contextAttributes) {
            for(let i = 0; i < contextNames.length; i++){
                const contextName = contextNames[i];
                const context = canvas.getContext(contextName, contextAttributes);
                if (context !== null) return context;
            }
            return null;
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', `three.js r${$548f161e17fc6f48$export$3545e07a80636437}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                const contextNames = [
                    'webgl2',
                    'webgl',
                    'experimental-webgl'
                ];
                if (_this.isWebGL1Renderer === true) contextNames.shift();
                _gl = getContext(contextNames, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextNames)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
            if (typeof WebGLRenderingContext !== 'undefined' && _gl instanceof WebGLRenderingContext) console.warn('THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163.');
            // Some experimental-webgl implementations do not have getShaderPrecisionFormat
            if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
                return {
                    'rangeMin': 1,
                    'rangeMax': 1,
                    'precision': 1
                };
            };
        } catch (error) {
            console.error('THREE.WebGLRenderer: ' + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $548f161e17fc6f48$var$WebGLExtensions(_gl);
            capabilities = new $548f161e17fc6f48$var$WebGLCapabilities(_gl, extensions, parameters);
            extensions.init(capabilities);
            utils = new $548f161e17fc6f48$export$ddaebcad857649a8(_gl, extensions, capabilities);
            state = new $548f161e17fc6f48$var$WebGLState(_gl, extensions, capabilities);
            info = new $548f161e17fc6f48$var$WebGLInfo(_gl);
            properties = new $548f161e17fc6f48$var$WebGLProperties();
            textures = new $548f161e17fc6f48$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $548f161e17fc6f48$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $548f161e17fc6f48$var$WebGLCubeUVMaps(_this);
            attributes = new $548f161e17fc6f48$var$WebGLAttributes(_gl, capabilities);
            bindingStates = new $548f161e17fc6f48$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
            geometries = new $548f161e17fc6f48$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $548f161e17fc6f48$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $548f161e17fc6f48$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $548f161e17fc6f48$var$WebGLClipping(properties);
            programCache = new $548f161e17fc6f48$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $548f161e17fc6f48$var$WebGLMaterials(_this, properties);
            renderLists = new $548f161e17fc6f48$var$WebGLRenderLists();
            renderStates = new $548f161e17fc6f48$var$WebGLRenderStates(extensions, capabilities);
            background = new $548f161e17fc6f48$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $548f161e17fc6f48$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $548f161e17fc6f48$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $548f161e17fc6f48$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
            indexedBufferRenderer = new $548f161e17fc6f48$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $548f161e17fc6f48$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === $548f161e17fc6f48$export$c200e7d26f592f21 || targetFormat === $548f161e17fc6f48$export$1ba1c45f9f77d4d7 || targetFormat === $548f161e17fc6f48$export$aa92e870a709d190;
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === $548f161e17fc6f48$export$2e8ce08d3f6f5e10 || targetType === $548f161e17fc6f48$export$c3c7fc4518ebba96 || targetType === $548f161e17fc6f48$export$c63dc51868b06a9d || targetType === $548f161e17fc6f48$export$6c8ea339bfab1301 || targetType === $548f161e17fc6f48$export$b3969b01faf587f2 || targetType === $548f161e17fc6f48$export$18886f8ae33e90de;
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) bits |= _gl.STENCIL_BUFFER_BIT;
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            if (_transmissionRenderTarget) {
                _transmissionRenderTarget.dispose();
                _transmissionRenderTarget = null;
            }
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log('THREE.WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log('THREE.WebGLRenderer: Context Restored.');
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        this.compile = function(scene, camera) {
            function prepare(material, scene, object) {
                if (material.transparent === true && material.side === $548f161e17fc6f48$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                    material.side = $548f161e17fc6f48$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $548f161e17fc6f48$export$2ede184fc2998901;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $548f161e17fc6f48$export$3b296b6f144d5b03;
                } else getProgram(material, scene, object);
            }
            currentRenderState = renderStates.get(scene);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights(_this._useLegacyLights);
            scene.traverse(function(object) {
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepare(material2, scene, object);
                    }
                    else prepare(material, scene, object);
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $548f161e17fc6f48$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            //
            background.render(currentRenderList, scene);
            // render scene
            currentRenderState.setupLights(_this._useLegacyLights);
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else renderScene(currentRenderList, scene, camera);
            //
            if (_currentRenderTarget !== null) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
            else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector3.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector3.copy(geometry.boundingSphere.center);
                            }
                            _vector3.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const isWebGL2 = capabilities.isWebGL2;
            if (_transmissionRenderTarget === null) _transmissionRenderTarget = new $548f161e17fc6f48$export$3c052beb2e51e23f(1, 1, {
                generateMipmaps: true,
                type: extensions.has('EXT_color_buffer_half_float') ? $548f161e17fc6f48$export$2697304443f382bc : $548f161e17fc6f48$export$2e8ce08d3f6f5e10,
                minFilter: $548f161e17fc6f48$export$5d8599b6a933fb1b,
                samples: isWebGL2 ? 4 : 0
            });
            _this.getDrawingBufferSize(_vector2);
            if (isWebGL2) _transmissionRenderTarget.setSize(_vector2.x, _vector2.y);
            else _transmissionRenderTarget.setSize($548f161e17fc6f48$var$floorPowerOfTwo(_vector2.x), $548f161e17fc6f48$var$floorPowerOfTwo(_vector2.y));
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(_transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = $548f161e17fc6f48$export$9fcb6b4294603b2;
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
            textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            let renderTargetNeedsUpdate = false;
            for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                const renderItem = transmissiveObjects[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = renderItem.material;
                const group = renderItem.group;
                if (material.side === $548f161e17fc6f48$export$3b296b6f144d5b03 && object.layers.test(camera.layers)) {
                    const currentSide = material.side;
                    material.side = $548f161e17fc6f48$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    renderObject(object, scene, camera, geometry, material, group);
                    material.side = currentSide;
                    material.needsUpdate = true;
                    renderTargetNeedsUpdate = true;
                }
            }
            if (renderTargetNeedsUpdate === true) {
                textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
                textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === $548f161e17fc6f48$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $548f161e17fc6f48$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $548f161e17fc6f48$export$2ede184fc2998901;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $548f161e17fc6f48$export$3b296b6f144d5b03;
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBuild(object, parameters, _this);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            const progUniforms = program.getUniforms();
            const uniformsList = $548f161e17fc6f48$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = uniformsList;
            return program;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace1 = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : $548f161e17fc6f48$export$42429b3acfb233a4;
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = $548f161e17fc6f48$export$9fcb6b4294603b2;
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace1) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (capabilities.floatVertexTextures) {
                        if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                        p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                        p_uniforms.setValue(_gl, 'boneTextureSize', skeleton.boneTextureSize);
                    } else console.warn('THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.');
                }
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
                $548f161e17fc6f48$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $548f161e17fc6f48$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++)if (capabilities.isWebGL2) {
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                } else console.warn('THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.');
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            if (renderTargetProperties.__hasExternalTextures) {
                renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
                if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
                // are midframe flushes and an external depth buffer. Disable use of the extension.
                {
                    if (extensions.has('WEBGL_multisampled_render_to_texture') === true) {
                        console.warn('THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided');
                        renderTargetProperties.__useRenderToTexture = false;
                    }
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace || 0;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (textureFormat !== $548f161e17fc6f48$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_FORMAT)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    const halfFloatSupportedByExt = textureType === $548f161e17fc6f48$export$2697304443f382bc && (extensions.has('EXT_color_buffer_half_float') || capabilities.isWebGL2 && extensions.has('EXT_color_buffer_float'));
                    if (textureType !== $548f161e17fc6f48$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
                    !(textureType === $548f161e17fc6f48$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has('OES_texture_float') || extensions.has('WEBGL_color_buffer_float'))) && // Chrome Mac >= 52 and Firefox
                    !halfFloatSupportedByExt) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.copyFramebufferToTexture = function(position, texture, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, position.x, position.y, width, height);
            state.unbindTexture();
        };
        this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
            const width = srcTexture.image.width;
            const height = srcTexture.image.height;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            textures.setTexture2D(dstTexture, 0);
            // As another texture upload may have changed pixelStorei
            // parameters, make sure they are correct for the dstTexture
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
            else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
            else _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, glFormat, glType, srcTexture.image);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(_gl.TEXTURE_2D);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
            if (_this.isWebGL1Renderer) {
                console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.');
                return;
            }
            const width = sourceBox.max.x - sourceBox.min.x + 1;
            const height = sourceBox.max.y - sourceBox.min.y + 1;
            const depth = sourceBox.max.z - sourceBox.min.z + 1;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.');
                return;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            const unpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const unpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const unpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const unpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const unpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, sourceBox.min.x);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, sourceBox.min.y);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, sourceBox.min.z);
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
            else if (srcTexture.isCompressedArrayTexture) {
                console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.');
                _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
            } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, unpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, unpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, unpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, unpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, unpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    get coordinateSystem() {
        return $548f161e17fc6f48$export$5a0e9190d10875d3;
    }
    get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace1) {
        this._outputColorSpace = colorSpace1;
        const gl = this.getContext();
        gl.drawingBufferColorSpace = colorSpace1 === $548f161e17fc6f48$export$626af19ae879bdf6 ? 'display-p3' : 'srgb';
        gl.unpackColorSpace = $548f161e17fc6f48$export$5e6fd513f44698c.workingColorSpace === $548f161e17fc6f48$export$c0dc1bc7e964761 ? 'display-p3' : 'srgb';
    }
    get physicallyCorrectLights() {
        console.warn('THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.');
        return !this.useLegacyLights;
    }
    set physicallyCorrectLights(value) {
        console.warn('THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.');
        this.useLegacyLights = !value;
    }
    get outputEncoding() {
        console.warn('THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.');
        return this.outputColorSpace === $548f161e17fc6f48$export$561f394b24edfcaa ? $548f161e17fc6f48$export$f32388edbb32674 : $548f161e17fc6f48$export$7207336e4151a112;
    }
    set outputEncoding(encoding) {
        console.warn('THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.');
        this.outputColorSpace = encoding === $548f161e17fc6f48$export$f32388edbb32674 ? $548f161e17fc6f48$export$561f394b24edfcaa : $548f161e17fc6f48$export$42429b3acfb233a4;
    }
    get useLegacyLights() {
        console.warn('THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733.');
        return this._useLegacyLights;
    }
    set useLegacyLights(value) {
        console.warn('THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733.');
        this._useLegacyLights = value;
    }
}
class $548f161e17fc6f48$export$a2f65229194348f9 extends $548f161e17fc6f48$export$f6cc00ef28d7cf97 {
}
$548f161e17fc6f48$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $548f161e17fc6f48$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = '';
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $548f161e17fc6f48$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: 'FogExp2',
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $548f161e17fc6f48$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = '';
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $548f161e17fc6f48$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: 'Fog',
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $548f161e17fc6f48$export$38af1803e3442a7f extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = 'Scene';
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        return data;
    }
}
class $548f161e17fc6f48$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $548f161e17fc6f48$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $548f161e17fc6f48$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $548f161e17fc6f48$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $548f161e17fc6f48$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $548f161e17fc6f48$var$_vector$5 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = '';
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $548f161e17fc6f48$var$_vector$5.fromBufferAttribute(this, i);
            $548f161e17fc6f48$var$_vector$5.applyMatrix4(m);
            this.setXYZ(i, $548f161e17fc6f48$var$_vector$5.x, $548f161e17fc6f48$var$_vector$5.y, $548f161e17fc6f48$var$_vector$5.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $548f161e17fc6f48$var$_vector$5.fromBufferAttribute(this, i);
            $548f161e17fc6f48$var$_vector$5.applyNormalMatrix(m);
            this.setXYZ(i, $548f161e17fc6f48$var$_vector$5.x, $548f161e17fc6f48$var$_vector$5.y, $548f161e17fc6f48$var$_vector$5.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $548f161e17fc6f48$var$_vector$5.fromBufferAttribute(this, i);
            $548f161e17fc6f48$var$_vector$5.transformDirection(m);
            this.setXYZ(i, $548f161e17fc6f48$var$_vector$5.x, $548f161e17fc6f48$var$_vector$5.y, $548f161e17fc6f48$var$_vector$5.z);
        }
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $548f161e17fc6f48$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $548f161e17fc6f48$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $548f161e17fc6f48$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $548f161e17fc6f48$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $548f161e17fc6f48$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $548f161e17fc6f48$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $548f161e17fc6f48$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $548f161e17fc6f48$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $548f161e17fc6f48$var$normalize(x, this.array);
            y = $548f161e17fc6f48$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $548f161e17fc6f48$var$normalize(x, this.array);
            y = $548f161e17fc6f48$var$normalize(y, this.array);
            z = $548f161e17fc6f48$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $548f161e17fc6f48$var$normalize(x, this.array);
            y = $548f161e17fc6f48$var$normalize(y, this.array);
            z = $548f161e17fc6f48$var$normalize(z, this.array);
            w = $548f161e17fc6f48$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $548f161e17fc6f48$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $548f161e17fc6f48$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $548f161e17fc6f48$export$5ec7dd1c6994bf8e extends $548f161e17fc6f48$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $548f161e17fc6f48$var$_geometry;
const $548f161e17fc6f48$var$_intersectPoint = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_worldScale = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_mvPosition = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_alignedPosition = /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1();
const $548f161e17fc6f48$var$_rotatedPosition = /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1();
const $548f161e17fc6f48$var$_viewWorldMatrix = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_vA = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_vB = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_vC = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_uvA = /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1();
const $548f161e17fc6f48$var$_uvB = /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1();
const $548f161e17fc6f48$var$_uvC = /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1();
class $548f161e17fc6f48$export$3075603db8e6204c extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(material = new $548f161e17fc6f48$export$5ec7dd1c6994bf8e()){
        super();
        this.isSprite = true;
        this.type = 'Sprite';
        if ($548f161e17fc6f48$var$_geometry === undefined) {
            $548f161e17fc6f48$var$_geometry = new $548f161e17fc6f48$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $548f161e17fc6f48$export$3d5cd879f108f53f(float32Array, 5);
            $548f161e17fc6f48$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $548f161e17fc6f48$var$_geometry.setAttribute('position', new $548f161e17fc6f48$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $548f161e17fc6f48$var$_geometry.setAttribute('uv', new $548f161e17fc6f48$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $548f161e17fc6f48$var$_geometry;
        this.material = material;
        this.center = new $548f161e17fc6f48$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $548f161e17fc6f48$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $548f161e17fc6f48$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $548f161e17fc6f48$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $548f161e17fc6f48$var$_worldScale.multiplyScalar(-$548f161e17fc6f48$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $548f161e17fc6f48$var$transformVertex($548f161e17fc6f48$var$_vA.set(-0.5, -0.5, 0), $548f161e17fc6f48$var$_mvPosition, center, $548f161e17fc6f48$var$_worldScale, sin, cos);
        $548f161e17fc6f48$var$transformVertex($548f161e17fc6f48$var$_vB.set(0.5, -0.5, 0), $548f161e17fc6f48$var$_mvPosition, center, $548f161e17fc6f48$var$_worldScale, sin, cos);
        $548f161e17fc6f48$var$transformVertex($548f161e17fc6f48$var$_vC.set(0.5, 0.5, 0), $548f161e17fc6f48$var$_mvPosition, center, $548f161e17fc6f48$var$_worldScale, sin, cos);
        $548f161e17fc6f48$var$_uvA.set(0, 0);
        $548f161e17fc6f48$var$_uvB.set(1, 0);
        $548f161e17fc6f48$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($548f161e17fc6f48$var$_vA, $548f161e17fc6f48$var$_vB, $548f161e17fc6f48$var$_vC, false, $548f161e17fc6f48$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $548f161e17fc6f48$var$transformVertex($548f161e17fc6f48$var$_vB.set(-0.5, 0.5, 0), $548f161e17fc6f48$var$_mvPosition, center, $548f161e17fc6f48$var$_worldScale, sin, cos);
            $548f161e17fc6f48$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($548f161e17fc6f48$var$_vA, $548f161e17fc6f48$var$_vC, $548f161e17fc6f48$var$_vB, false, $548f161e17fc6f48$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($548f161e17fc6f48$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $548f161e17fc6f48$var$_intersectPoint.clone(),
            uv: $548f161e17fc6f48$export$5a465592bfe74b48.getInterpolation($548f161e17fc6f48$var$_intersectPoint, $548f161e17fc6f48$var$_vA, $548f161e17fc6f48$var$_vB, $548f161e17fc6f48$var$_vC, $548f161e17fc6f48$var$_uvA, $548f161e17fc6f48$var$_uvB, $548f161e17fc6f48$var$_uvC, new $548f161e17fc6f48$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $548f161e17fc6f48$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $548f161e17fc6f48$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $548f161e17fc6f48$var$_rotatedPosition.x = cos * $548f161e17fc6f48$var$_alignedPosition.x - sin * $548f161e17fc6f48$var$_alignedPosition.y;
        $548f161e17fc6f48$var$_rotatedPosition.y = sin * $548f161e17fc6f48$var$_alignedPosition.x + cos * $548f161e17fc6f48$var$_alignedPosition.y;
    } else $548f161e17fc6f48$var$_rotatedPosition.copy($548f161e17fc6f48$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $548f161e17fc6f48$var$_rotatedPosition.x;
    vertexPosition.y += $548f161e17fc6f48$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($548f161e17fc6f48$var$_viewWorldMatrix);
}
const $548f161e17fc6f48$var$_v1$2 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_v2$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$export$112e7237be0c5f30 extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $548f161e17fc6f48$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($548f161e17fc6f48$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $548f161e17fc6f48$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $548f161e17fc6f48$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $548f161e17fc6f48$var$_v1$2.distanceTo($548f161e17fc6f48$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $548f161e17fc6f48$var$_basePosition = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_skinIndex = /*@__PURE__*/ new $548f161e17fc6f48$export$fa7daccca11cdbe3();
const $548f161e17fc6f48$var$_skinWeight = /*@__PURE__*/ new $548f161e17fc6f48$export$fa7daccca11cdbe3();
const $548f161e17fc6f48$var$_vector3 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_matrix4 = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_vertex = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_sphere$3 = /*@__PURE__*/ new $548f161e17fc6f48$export$805e8b72413ccaba();
const $548f161e17fc6f48$var$_inverseMatrix$2 = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_ray$2 = /*@__PURE__*/ new $548f161e17fc6f48$export$a186db52eed6d40e();
class $548f161e17fc6f48$export$b303577035157ecf extends $548f161e17fc6f48$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        this.bindMode = 'attached';
        this.bindMatrix = new $548f161e17fc6f48$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $548f161e17fc6f48$export$2ae72fc923e5eb5();
        this.boundingBox = null;
        this.boundingSphere = null;
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $548f161e17fc6f48$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            $548f161e17fc6f48$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $548f161e17fc6f48$var$_vertex);
            this.boundingBox.expandByPoint($548f161e17fc6f48$var$_vertex);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $548f161e17fc6f48$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            $548f161e17fc6f48$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $548f161e17fc6f48$var$_vertex);
            this.boundingSphere.expandByPoint($548f161e17fc6f48$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $548f161e17fc6f48$var$_sphere$3.copy(this.boundingSphere);
        $548f161e17fc6f48$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($548f161e17fc6f48$var$_sphere$3) === false) return;
        // convert ray to local space of skinned mesh
        $548f161e17fc6f48$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $548f161e17fc6f48$var$_ray$2.copy(raycaster.ray).applyMatrix4($548f161e17fc6f48$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($548f161e17fc6f48$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $548f161e17fc6f48$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $548f161e17fc6f48$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === 'attached') this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === 'detached') this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    applyBoneTransform(index, vector) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $548f161e17fc6f48$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $548f161e17fc6f48$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $548f161e17fc6f48$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
        vector.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $548f161e17fc6f48$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $548f161e17fc6f48$var$_skinIndex.getComponent(i);
                $548f161e17fc6f48$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                vector.addScaledVector($548f161e17fc6f48$var$_vector3.copy($548f161e17fc6f48$var$_basePosition).applyMatrix4($548f161e17fc6f48$var$_matrix4), weight);
            }
        }
        return vector.applyMatrix4(this.bindMatrixInverse);
    }
    boneTransform(index, vector) {
        console.warn('THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151.');
        return this.applyBoneTransform(index, vector);
    }
}
class $548f161e17fc6f48$export$b127726e56765aa4 extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = 'Bone';
    }
}
class $548f161e17fc6f48$export$b691f601014eabe1 extends $548f161e17fc6f48$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $548f161e17fc6f48$export$727aa5ec3fe39bf0, minFilter = $548f161e17fc6f48$export$727aa5ec3fe39bf0, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $548f161e17fc6f48$var$_offsetMatrix = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_identityMatrix = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
class $548f161e17fc6f48$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $548f161e17fc6f48$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $548f161e17fc6f48$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $548f161e17fc6f48$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $548f161e17fc6f48$var$_identityMatrix;
            $548f161e17fc6f48$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $548f161e17fc6f48$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $548f161e17fc6f48$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $548f161e17fc6f48$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $548f161e17fc6f48$export$b691f601014eabe1(boneMatrices, size, size, $548f161e17fc6f48$export$3f8bb04b555a363c, $548f161e17fc6f48$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                bone = new $548f161e17fc6f48$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $548f161e17fc6f48$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $548f161e17fc6f48$export$32ea87a8b54d744a extends $548f161e17fc6f48$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $548f161e17fc6f48$var$_instanceLocalMatrix = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_instanceWorldMatrix = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_instanceIntersects = [];
const $548f161e17fc6f48$var$_box3 = /*@__PURE__*/ new $548f161e17fc6f48$export$6f7d5a9418ab2aa3();
const $548f161e17fc6f48$var$_identity = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_mesh = /*@__PURE__*/ new $548f161e17fc6f48$export$e176487c05830cc5();
const $548f161e17fc6f48$var$_sphere$2 = /*@__PURE__*/ new $548f161e17fc6f48$export$805e8b72413ccaba();
class $548f161e17fc6f48$export$f3c979c331175ad7 extends $548f161e17fc6f48$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $548f161e17fc6f48$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $548f161e17fc6f48$var$_identity);
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $548f161e17fc6f48$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $548f161e17fc6f48$var$_instanceLocalMatrix);
            $548f161e17fc6f48$var$_box3.copy(geometry.boundingBox).applyMatrix4($548f161e17fc6f48$var$_instanceLocalMatrix);
            this.boundingBox.union($548f161e17fc6f48$var$_box3);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $548f161e17fc6f48$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $548f161e17fc6f48$var$_instanceLocalMatrix);
            $548f161e17fc6f48$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4($548f161e17fc6f48$var$_instanceLocalMatrix);
            this.boundingSphere.union($548f161e17fc6f48$var$_sphere$2);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $548f161e17fc6f48$var$_mesh.geometry = this.geometry;
        $548f161e17fc6f48$var$_mesh.material = this.material;
        if ($548f161e17fc6f48$var$_mesh.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $548f161e17fc6f48$var$_sphere$2.copy(this.boundingSphere);
        $548f161e17fc6f48$var$_sphere$2.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($548f161e17fc6f48$var$_sphere$2) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $548f161e17fc6f48$var$_instanceLocalMatrix);
            $548f161e17fc6f48$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $548f161e17fc6f48$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $548f161e17fc6f48$var$_mesh.matrixWorld = $548f161e17fc6f48$var$_instanceWorldMatrix;
            $548f161e17fc6f48$var$_mesh.raycast(raycaster, $548f161e17fc6f48$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $548f161e17fc6f48$var$_instanceIntersects.length; i < l; i++){
                const intersect = $548f161e17fc6f48$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $548f161e17fc6f48$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $548f161e17fc6f48$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class $548f161e17fc6f48$export$fbaaa33907730a0c extends $548f161e17fc6f48$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = 'round';
        this.linejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $548f161e17fc6f48$var$_start$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_end$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_inverseMatrix$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_ray$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$a186db52eed6d40e();
const $548f161e17fc6f48$var$_sphere$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$805e8b72413ccaba();
class $548f161e17fc6f48$export$17d680238e50603e extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(geometry = new $548f161e17fc6f48$export$b7be63a67df8959(), material = new $548f161e17fc6f48$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = 'Line';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $548f161e17fc6f48$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                $548f161e17fc6f48$var$_end$1.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $548f161e17fc6f48$var$_start$1.distanceTo($548f161e17fc6f48$var$_end$1);
            }
            geometry.setAttribute('lineDistance', new $548f161e17fc6f48$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $548f161e17fc6f48$var$_sphere$1.copy(geometry.boundingSphere);
        $548f161e17fc6f48$var$_sphere$1.applyMatrix4(matrixWorld);
        $548f161e17fc6f48$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($548f161e17fc6f48$var$_sphere$1) === false) return;
        //
        $548f161e17fc6f48$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $548f161e17fc6f48$var$_ray$1.copy(raycaster.ray).applyMatrix4($548f161e17fc6f48$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $548f161e17fc6f48$export$64b5c384219d3699();
        const vEnd = new $548f161e17fc6f48$export$64b5c384219d3699();
        const interSegment = new $548f161e17fc6f48$export$64b5c384219d3699();
        const interRay = new $548f161e17fc6f48$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                vStart.fromBufferAttribute(positionAttribute, a);
                vEnd.fromBufferAttribute(positionAttribute, b);
                const distSq = $548f161e17fc6f48$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                vStart.fromBufferAttribute(positionAttribute, i);
                vEnd.fromBufferAttribute(positionAttribute, i + 1);
                const distSq = $548f161e17fc6f48$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
const $548f161e17fc6f48$var$_start = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_end = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$export$ff1ed10fedfdd604 extends $548f161e17fc6f48$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $548f161e17fc6f48$var$_start.fromBufferAttribute(positionAttribute, i);
                $548f161e17fc6f48$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $548f161e17fc6f48$var$_start.distanceTo($548f161e17fc6f48$var$_end);
            }
            geometry.setAttribute('lineDistance', new $548f161e17fc6f48$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
class $548f161e17fc6f48$export$f85a24d745e4f17d extends $548f161e17fc6f48$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
class $548f161e17fc6f48$export$a178c45366ce5d6b extends $548f161e17fc6f48$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $548f161e17fc6f48$var$_inverseMatrix = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_ray = /*@__PURE__*/ new $548f161e17fc6f48$export$a186db52eed6d40e();
const $548f161e17fc6f48$var$_sphere = /*@__PURE__*/ new $548f161e17fc6f48$export$805e8b72413ccaba();
const $548f161e17fc6f48$var$_position$2 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$export$1c787534cb11aa3e extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(geometry = new $548f161e17fc6f48$export$b7be63a67df8959(), material = new $548f161e17fc6f48$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = 'Points';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $548f161e17fc6f48$var$_sphere.copy(geometry.boundingSphere);
        $548f161e17fc6f48$var$_sphere.applyMatrix4(matrixWorld);
        $548f161e17fc6f48$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($548f161e17fc6f48$var$_sphere) === false) return;
        //
        $548f161e17fc6f48$var$_inverseMatrix.copy(matrixWorld).invert();
        $548f161e17fc6f48$var$_ray.copy(raycaster.ray).applyMatrix4($548f161e17fc6f48$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $548f161e17fc6f48$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $548f161e17fc6f48$var$testPoint($548f161e17fc6f48$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $548f161e17fc6f48$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $548f161e17fc6f48$var$testPoint($548f161e17fc6f48$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $548f161e17fc6f48$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $548f161e17fc6f48$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $548f161e17fc6f48$export$64b5c384219d3699();
        $548f161e17fc6f48$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $548f161e17fc6f48$export$6e09d1edf8d5a25c extends $548f161e17fc6f48$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $548f161e17fc6f48$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $548f161e17fc6f48$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $548f161e17fc6f48$export$9270d786f73ce6fe extends $548f161e17fc6f48$export$5431306cf43de24a {
    constructor(width, height){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.magFilter = $548f161e17fc6f48$export$727aa5ec3fe39bf0;
        this.minFilter = $548f161e17fc6f48$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $548f161e17fc6f48$export$3466bac9141a5cc4 extends $548f161e17fc6f48$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $548f161e17fc6f48$export$5fe6b8e34b274fcb extends $548f161e17fc6f48$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $548f161e17fc6f48$export$9d9334239a5a5e06;
    }
}
class $548f161e17fc6f48$export$d80173634de65bff extends $548f161e17fc6f48$export$3466bac9141a5cc4 {
    constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $548f161e17fc6f48$export$8759762a6477f2c4);
        this.isCompressedCubeTexture = true;
        this.isCubeTexture = true;
        this.image = images;
    }
}
class $548f161e17fc6f48$export$f7189e49152d1c13 extends $548f161e17fc6f48$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $548f161e17fc6f48$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = 'Curve';
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn('THREE.Curve: .getPoint() not implemented.');
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $548f161e17fc6f48$export$c977b3e384af9ae1() : new $548f161e17fc6f48$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $548f161e17fc6f48$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $548f161e17fc6f48$export$64b5c384219d3699();
        const mat = new $548f161e17fc6f48$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $548f161e17fc6f48$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $548f161e17fc6f48$export$64b5c384219d3699();
        binormals[0] = new $548f161e17fc6f48$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($548f161e17fc6f48$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($548f161e17fc6f48$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $548f161e17fc6f48$export$3f87a931616cde04 extends $548f161e17fc6f48$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $548f161e17fc6f48$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $548f161e17fc6f48$export$b1eedc9aab6300e8 extends $548f161e17fc6f48$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $548f161e17fc6f48$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $548f161e17fc6f48$var$tmp = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$px = /*@__PURE__*/ new $548f161e17fc6f48$var$CubicPoly();
const $548f161e17fc6f48$var$py = /*@__PURE__*/ new $548f161e17fc6f48$var$CubicPoly();
const $548f161e17fc6f48$var$pz = /*@__PURE__*/ new $548f161e17fc6f48$var$CubicPoly();
class $548f161e17fc6f48$export$b9146b27c24b744c extends $548f161e17fc6f48$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $548f161e17fc6f48$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $548f161e17fc6f48$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $548f161e17fc6f48$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $548f161e17fc6f48$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $548f161e17fc6f48$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $548f161e17fc6f48$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $548f161e17fc6f48$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $548f161e17fc6f48$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $548f161e17fc6f48$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $548f161e17fc6f48$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $548f161e17fc6f48$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($548f161e17fc6f48$var$px.calc(weight), $548f161e17fc6f48$var$py.calc(weight), $548f161e17fc6f48$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $548f161e17fc6f48$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $548f161e17fc6f48$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $548f161e17fc6f48$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $548f161e17fc6f48$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $548f161e17fc6f48$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $548f161e17fc6f48$var$QuadraticBezier(t, p0, p1, p2) {
    return $548f161e17fc6f48$var$QuadraticBezierP0(t, p0) + $548f161e17fc6f48$var$QuadraticBezierP1(t, p1) + $548f161e17fc6f48$var$QuadraticBezierP2(t, p2);
}
//
function $548f161e17fc6f48$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $548f161e17fc6f48$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $548f161e17fc6f48$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $548f161e17fc6f48$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $548f161e17fc6f48$var$CubicBezier(t, p0, p1, p2, p3) {
    return $548f161e17fc6f48$var$CubicBezierP0(t, p0) + $548f161e17fc6f48$var$CubicBezierP1(t, p1) + $548f161e17fc6f48$var$CubicBezierP2(t, p2) + $548f161e17fc6f48$var$CubicBezierP3(t, p3);
}
class $548f161e17fc6f48$export$e36650d36468bb39 extends $548f161e17fc6f48$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $548f161e17fc6f48$export$c977b3e384af9ae1(), v1 = new $548f161e17fc6f48$export$c977b3e384af9ae1(), v2 = new $548f161e17fc6f48$export$c977b3e384af9ae1(), v3 = new $548f161e17fc6f48$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $548f161e17fc6f48$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($548f161e17fc6f48$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $548f161e17fc6f48$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $548f161e17fc6f48$export$13d5f1c9525f246c extends $548f161e17fc6f48$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $548f161e17fc6f48$export$64b5c384219d3699(), v1 = new $548f161e17fc6f48$export$64b5c384219d3699(), v2 = new $548f161e17fc6f48$export$64b5c384219d3699(), v3 = new $548f161e17fc6f48$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $548f161e17fc6f48$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($548f161e17fc6f48$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $548f161e17fc6f48$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $548f161e17fc6f48$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $548f161e17fc6f48$export$ab2e07e76531a47e extends $548f161e17fc6f48$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $548f161e17fc6f48$export$c977b3e384af9ae1(), v2 = new $548f161e17fc6f48$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = 'LineCurve';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $548f161e17fc6f48$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $548f161e17fc6f48$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $548f161e17fc6f48$export$1fdfd9d9cf487600 extends $548f161e17fc6f48$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $548f161e17fc6f48$export$64b5c384219d3699(), v2 = new $548f161e17fc6f48$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $548f161e17fc6f48$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $548f161e17fc6f48$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $548f161e17fc6f48$export$5938c4ee491a43ad extends $548f161e17fc6f48$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $548f161e17fc6f48$export$c977b3e384af9ae1(), v1 = new $548f161e17fc6f48$export$c977b3e384af9ae1(), v2 = new $548f161e17fc6f48$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $548f161e17fc6f48$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($548f161e17fc6f48$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $548f161e17fc6f48$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $548f161e17fc6f48$export$bf3f4c7e459f90fc extends $548f161e17fc6f48$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $548f161e17fc6f48$export$64b5c384219d3699(), v1 = new $548f161e17fc6f48$export$64b5c384219d3699(), v2 = new $548f161e17fc6f48$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $548f161e17fc6f48$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($548f161e17fc6f48$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $548f161e17fc6f48$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $548f161e17fc6f48$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $548f161e17fc6f48$export$d3bdd77da77afc1b extends $548f161e17fc6f48$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = 'SplineCurve';
        this.points = points;
    }
    getPoint(t, optionalTarget = new $548f161e17fc6f48$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($548f161e17fc6f48$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $548f161e17fc6f48$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $548f161e17fc6f48$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $548f161e17fc6f48$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $548f161e17fc6f48$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $548f161e17fc6f48$export$b9146b27c24b744c,
    CubicBezierCurve: $548f161e17fc6f48$export$e36650d36468bb39,
    CubicBezierCurve3: $548f161e17fc6f48$export$13d5f1c9525f246c,
    EllipseCurve: $548f161e17fc6f48$export$3f87a931616cde04,
    LineCurve: $548f161e17fc6f48$export$ab2e07e76531a47e,
    LineCurve3: $548f161e17fc6f48$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $548f161e17fc6f48$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $548f161e17fc6f48$export$bf3f4c7e459f90fc,
    SplineCurve: $548f161e17fc6f48$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $548f161e17fc6f48$export$4aaf9b66af1bbf2c extends $548f161e17fc6f48$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = 'CurvePath';
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
            this.curves.push(new $548f161e17fc6f48$var$Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $548f161e17fc6f48$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $548f161e17fc6f48$export$4b2950bdac9b6ee9 extends $548f161e17fc6f48$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = 'Path';
        this.currentPoint = new $548f161e17fc6f48$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $548f161e17fc6f48$export$ab2e07e76531a47e(this.currentPoint.clone(), new $548f161e17fc6f48$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $548f161e17fc6f48$export$5938c4ee491a43ad(this.currentPoint.clone(), new $548f161e17fc6f48$export$c977b3e384af9ae1(aCPx, aCPy), new $548f161e17fc6f48$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $548f161e17fc6f48$export$e36650d36468bb39(this.currentPoint.clone(), new $548f161e17fc6f48$export$c977b3e384af9ae1(aCP1x, aCP1y), new $548f161e17fc6f48$export$c977b3e384af9ae1(aCP2x, aCP2y), new $548f161e17fc6f48$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $548f161e17fc6f48$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $548f161e17fc6f48$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $548f161e17fc6f48$export$6d839803fcd1882c extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(points = [
        new $548f161e17fc6f48$export$c977b3e384af9ae1(0, -0.5),
        new $548f161e17fc6f48$export$c977b3e384af9ae1(0.5, 0),
        new $548f161e17fc6f48$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $548f161e17fc6f48$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $548f161e17fc6f48$export$64b5c384219d3699();
        const uv = new $548f161e17fc6f48$export$c977b3e384af9ae1();
        const normal = new $548f161e17fc6f48$export$64b5c384219d3699();
        const curNormal = new $548f161e17fc6f48$export$64b5c384219d3699();
        const prevNormal = new $548f161e17fc6f48$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $548f161e17fc6f48$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $548f161e17fc6f48$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $548f161e17fc6f48$export$41680e8551036033 extends $548f161e17fc6f48$export$6d839803fcd1882c {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $548f161e17fc6f48$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = 'CapsuleGeometry';
        this.parameters = {
            radius: radius,
            length: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $548f161e17fc6f48$export$d5c0e8d607467193 extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $548f161e17fc6f48$export$64b5c384219d3699();
        const uv = new $548f161e17fc6f48$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $548f161e17fc6f48$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $548f161e17fc6f48$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $548f161e17fc6f48$export$68f745719dbe5198 extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $548f161e17fc6f48$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $548f161e17fc6f48$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $548f161e17fc6f48$export$64b5c384219d3699();
            const vertex = new $548f161e17fc6f48$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $548f161e17fc6f48$export$c977b3e384af9ae1();
            const vertex = new $548f161e17fc6f48$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $548f161e17fc6f48$export$a7a48974f285c9b3 extends $548f161e17fc6f48$export$68f745719dbe5198 {
    constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $548f161e17fc6f48$export$60e57a7d3f20ff65 extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $548f161e17fc6f48$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $548f161e17fc6f48$export$64b5c384219d3699();
            const b = new $548f161e17fc6f48$export$64b5c384219d3699();
            const c = new $548f161e17fc6f48$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $548f161e17fc6f48$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $548f161e17fc6f48$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $548f161e17fc6f48$export$64b5c384219d3699();
            const b = new $548f161e17fc6f48$export$64b5c384219d3699();
            const c = new $548f161e17fc6f48$export$64b5c384219d3699();
            const centroid = new $548f161e17fc6f48$export$64b5c384219d3699();
            const uvA = new $548f161e17fc6f48$export$c977b3e384af9ae1();
            const uvB = new $548f161e17fc6f48$export$c977b3e384af9ae1();
            const uvC = new $548f161e17fc6f48$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
class $548f161e17fc6f48$export$c0babfeb8708fc9c extends $548f161e17fc6f48$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $548f161e17fc6f48$var$_v0 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_v1$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_normal = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_triangle = /*@__PURE__*/ new $548f161e17fc6f48$export$5a465592bfe74b48();
class $548f161e17fc6f48$export$4730b1542707547f extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($548f161e17fc6f48$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $548f161e17fc6f48$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $548f161e17fc6f48$var$_triangle.getNormal($548f161e17fc6f48$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $548f161e17fc6f48$var$_triangle[vertKeys[j]];
                    const v1 = $548f161e17fc6f48$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($548f161e17fc6f48$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $548f161e17fc6f48$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $548f161e17fc6f48$var$_v0.fromBufferAttribute(positionAttr, index0);
                $548f161e17fc6f48$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($548f161e17fc6f48$var$_v0.x, $548f161e17fc6f48$var$_v0.y, $548f161e17fc6f48$var$_v0.z);
                vertices.push($548f161e17fc6f48$var$_v1$1.x, $548f161e17fc6f48$var$_v1$1.y, $548f161e17fc6f48$var$_v1$1.z);
            }
            this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
class $548f161e17fc6f48$export$6428a7f2611ef1fa extends $548f161e17fc6f48$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $548f161e17fc6f48$var$generateUUID();
        this.type = 'Shape';
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $548f161e17fc6f48$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ const $548f161e17fc6f48$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $548f161e17fc6f48$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $548f161e17fc6f48$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $548f161e17fc6f48$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $548f161e17fc6f48$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $548f161e17fc6f48$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $548f161e17fc6f48$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $548f161e17fc6f48$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $548f161e17fc6f48$var$equals(last, last.next)) {
        $548f161e17fc6f48$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $548f161e17fc6f48$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($548f161e17fc6f48$var$equals(p, p.next) || $548f161e17fc6f48$var$area(p.prev, p, p.next) === 0)) {
            $548f161e17fc6f48$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $548f161e17fc6f48$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $548f161e17fc6f48$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $548f161e17fc6f48$var$isEarHashed(ear, minX, minY, invSize) : $548f161e17fc6f48$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $548f161e17fc6f48$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $548f161e17fc6f48$var$earcutLinked($548f161e17fc6f48$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $548f161e17fc6f48$var$cureLocalIntersections($548f161e17fc6f48$var$filterPoints(ear), triangles, dim);
                $548f161e17fc6f48$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $548f161e17fc6f48$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $548f161e17fc6f48$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($548f161e17fc6f48$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $548f161e17fc6f48$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $548f161e17fc6f48$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $548f161e17fc6f48$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($548f161e17fc6f48$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $548f161e17fc6f48$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $548f161e17fc6f48$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $548f161e17fc6f48$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $548f161e17fc6f48$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $548f161e17fc6f48$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $548f161e17fc6f48$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $548f161e17fc6f48$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $548f161e17fc6f48$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $548f161e17fc6f48$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $548f161e17fc6f48$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $548f161e17fc6f48$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$548f161e17fc6f48$var$equals(a, b) && $548f161e17fc6f48$var$intersects(a, p, p.next, b) && $548f161e17fc6f48$var$locallyInside(a, b) && $548f161e17fc6f48$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $548f161e17fc6f48$var$removeNode(p);
            $548f161e17fc6f48$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $548f161e17fc6f48$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $548f161e17fc6f48$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $548f161e17fc6f48$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $548f161e17fc6f48$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $548f161e17fc6f48$var$filterPoints(a, a.next);
                c = $548f161e17fc6f48$var$filterPoints(c, c.next);
                // run earcut on each half
                $548f161e17fc6f48$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $548f161e17fc6f48$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $548f161e17fc6f48$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $548f161e17fc6f48$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($548f161e17fc6f48$var$getLeftmost(list));
    }
    queue.sort($548f161e17fc6f48$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $548f161e17fc6f48$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $548f161e17fc6f48$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $548f161e17fc6f48$var$eliminateHole(hole, outerNode) {
    const bridge = $548f161e17fc6f48$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $548f161e17fc6f48$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $548f161e17fc6f48$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $548f161e17fc6f48$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $548f161e17fc6f48$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $548f161e17fc6f48$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($548f161e17fc6f48$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $548f161e17fc6f48$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $548f161e17fc6f48$var$sectorContainsSector(m, p) {
    return $548f161e17fc6f48$var$area(m.prev, m, p.prev) < 0 && $548f161e17fc6f48$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $548f161e17fc6f48$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $548f161e17fc6f48$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $548f161e17fc6f48$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $548f161e17fc6f48$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $548f161e17fc6f48$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $548f161e17fc6f48$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $548f161e17fc6f48$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $548f161e17fc6f48$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$548f161e17fc6f48$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($548f161e17fc6f48$var$locallyInside(a, b) && $548f161e17fc6f48$var$locallyInside(b, a) && $548f161e17fc6f48$var$middleInside(a, b) && // locally visible
    ($548f161e17fc6f48$var$area(a.prev, a, b.prev) || $548f161e17fc6f48$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $548f161e17fc6f48$var$equals(a, b) && $548f161e17fc6f48$var$area(a.prev, a, a.next) > 0 && $548f161e17fc6f48$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $548f161e17fc6f48$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $548f161e17fc6f48$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $548f161e17fc6f48$var$intersects(p1, q1, p2, q2) {
    const o1 = $548f161e17fc6f48$var$sign($548f161e17fc6f48$var$area(p1, q1, p2));
    const o2 = $548f161e17fc6f48$var$sign($548f161e17fc6f48$var$area(p1, q1, q2));
    const o3 = $548f161e17fc6f48$var$sign($548f161e17fc6f48$var$area(p2, q2, p1));
    const o4 = $548f161e17fc6f48$var$sign($548f161e17fc6f48$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $548f161e17fc6f48$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $548f161e17fc6f48$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $548f161e17fc6f48$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $548f161e17fc6f48$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $548f161e17fc6f48$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $548f161e17fc6f48$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $548f161e17fc6f48$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $548f161e17fc6f48$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $548f161e17fc6f48$var$locallyInside(a, b) {
    return $548f161e17fc6f48$var$area(a.prev, a, a.next) < 0 ? $548f161e17fc6f48$var$area(a, b, a.next) >= 0 && $548f161e17fc6f48$var$area(a, a.prev, b) >= 0 : $548f161e17fc6f48$var$area(a, b, a.prev) < 0 || $548f161e17fc6f48$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $548f161e17fc6f48$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $548f161e17fc6f48$var$splitPolygon(a, b) {
    const a2 = new $548f161e17fc6f48$var$Node(a.i, a.x, a.y), b2 = new $548f161e17fc6f48$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $548f161e17fc6f48$var$insertNode(i, x, y, last) {
    const p = new $548f161e17fc6f48$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $548f161e17fc6f48$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $548f161e17fc6f48$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $548f161e17fc6f48$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $548f161e17fc6f48$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $548f161e17fc6f48$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $548f161e17fc6f48$var$removeDupEndPts(contour);
        $548f161e17fc6f48$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($548f161e17fc6f48$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $548f161e17fc6f48$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $548f161e17fc6f48$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $548f161e17fc6f48$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $548f161e17fc6f48$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $548f161e17fc6f48$export$598697a1efa63ca7 extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(shapes = new $548f161e17fc6f48$export$6428a7f2611ef1fa([
        new $548f161e17fc6f48$export$c977b3e384af9ae1(0.5, 0.5),
        new $548f161e17fc6f48$export$c977b3e384af9ae1(-0.5, 0.5),
        new $548f161e17fc6f48$export$c977b3e384af9ae1(-0.5, -0.5),
        new $548f161e17fc6f48$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $548f161e17fc6f48$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $548f161e17fc6f48$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $548f161e17fc6f48$export$64b5c384219d3699();
                normal = new $548f161e17fc6f48$export$64b5c384219d3699();
                position2 = new $548f161e17fc6f48$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$548f161e17fc6f48$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($548f161e17fc6f48$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $548f161e17fc6f48$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $548f161e17fc6f48$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $548f161e17fc6f48$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $548f161e17fc6f48$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $548f161e17fc6f48$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $548f161e17fc6f48$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $548f161e17fc6f48$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $548f161e17fc6f48$export$c977b3e384af9ae1(a_x, a_y),
            new $548f161e17fc6f48$export$c977b3e384af9ae1(b_x, b_y),
            new $548f161e17fc6f48$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $548f161e17fc6f48$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $548f161e17fc6f48$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $548f161e17fc6f48$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $548f161e17fc6f48$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $548f161e17fc6f48$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $548f161e17fc6f48$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $548f161e17fc6f48$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $548f161e17fc6f48$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $548f161e17fc6f48$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $548f161e17fc6f48$export$9567cc828c9535da extends $548f161e17fc6f48$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$9567cc828c9535da(data.radius, data.detail);
    }
}
class $548f161e17fc6f48$export$1954e2b809fe361e extends $548f161e17fc6f48$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
class $548f161e17fc6f48$export$68cb731f50f614af extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $548f161e17fc6f48$export$64b5c384219d3699();
        const uv = new $548f161e17fc6f48$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $548f161e17fc6f48$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $548f161e17fc6f48$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $548f161e17fc6f48$export$57a29a1c803e9065 extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(shapes = new $548f161e17fc6f48$export$6428a7f2611ef1fa([
        new $548f161e17fc6f48$export$c977b3e384af9ae1(0, 0.5),
        new $548f161e17fc6f48$export$c977b3e384af9ae1(-0.5, -0.5),
        new $548f161e17fc6f48$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $548f161e17fc6f48$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $548f161e17fc6f48$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($548f161e17fc6f48$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($548f161e17fc6f48$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $548f161e17fc6f48$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $548f161e17fc6f48$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $548f161e17fc6f48$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $548f161e17fc6f48$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $548f161e17fc6f48$export$1b417fc3b307a251 extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $548f161e17fc6f48$export$64b5c384219d3699();
        const normal = new $548f161e17fc6f48$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $548f161e17fc6f48$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $548f161e17fc6f48$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $548f161e17fc6f48$export$fb3f7adc68bd6e02 extends $548f161e17fc6f48$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
class $548f161e17fc6f48$export$a2312a2a1fa56495 extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $548f161e17fc6f48$export$64b5c384219d3699();
        const vertex = new $548f161e17fc6f48$export$64b5c384219d3699();
        const normal = new $548f161e17fc6f48$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $548f161e17fc6f48$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $548f161e17fc6f48$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $548f161e17fc6f48$export$77e9bfadfb9ab8c8 extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $548f161e17fc6f48$export$64b5c384219d3699();
        const normal = new $548f161e17fc6f48$export$64b5c384219d3699();
        const P1 = new $548f161e17fc6f48$export$64b5c384219d3699();
        const P2 = new $548f161e17fc6f48$export$64b5c384219d3699();
        const B = new $548f161e17fc6f48$export$64b5c384219d3699();
        const T = new $548f161e17fc6f48$export$64b5c384219d3699();
        const N = new $548f161e17fc6f48$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $548f161e17fc6f48$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $548f161e17fc6f48$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $548f161e17fc6f48$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $548f161e17fc6f48$export$7897d9d48904490c extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(path = new $548f161e17fc6f48$export$bf3f4c7e459f90fc(new $548f161e17fc6f48$export$64b5c384219d3699(-1, -1, 0), new $548f161e17fc6f48$export$64b5c384219d3699(-1, 1, 0), new $548f161e17fc6f48$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $548f161e17fc6f48$export$64b5c384219d3699();
        const normal = new $548f161e17fc6f48$export$64b5c384219d3699();
        const uv = new $548f161e17fc6f48$export$c977b3e384af9ae1();
        let P = new $548f161e17fc6f48$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $548f161e17fc6f48$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $548f161e17fc6f48$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $548f161e17fc6f48$export$7897d9d48904490c(new $548f161e17fc6f48$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $548f161e17fc6f48$export$4b739da06d24892b extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $548f161e17fc6f48$export$64b5c384219d3699();
            const end = new $548f161e17fc6f48$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($548f161e17fc6f48$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($548f161e17fc6f48$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $548f161e17fc6f48$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $548f161e17fc6f48$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $548f161e17fc6f48$export$33e43285f7406bd5,
    CapsuleGeometry: $548f161e17fc6f48$export$41680e8551036033,
    CircleGeometry: $548f161e17fc6f48$export$d5c0e8d607467193,
    ConeGeometry: $548f161e17fc6f48$export$a7a48974f285c9b3,
    CylinderGeometry: $548f161e17fc6f48$export$68f745719dbe5198,
    DodecahedronGeometry: $548f161e17fc6f48$export$c0babfeb8708fc9c,
    EdgesGeometry: $548f161e17fc6f48$export$4730b1542707547f,
    ExtrudeGeometry: $548f161e17fc6f48$export$598697a1efa63ca7,
    IcosahedronGeometry: $548f161e17fc6f48$export$9567cc828c9535da,
    LatheGeometry: $548f161e17fc6f48$export$6d839803fcd1882c,
    OctahedronGeometry: $548f161e17fc6f48$export$1954e2b809fe361e,
    PlaneGeometry: $548f161e17fc6f48$export$967d831af31f69ce,
    PolyhedronGeometry: $548f161e17fc6f48$export$60e57a7d3f20ff65,
    RingGeometry: $548f161e17fc6f48$export$68cb731f50f614af,
    ShapeGeometry: $548f161e17fc6f48$export$57a29a1c803e9065,
    SphereGeometry: $548f161e17fc6f48$export$1b417fc3b307a251,
    TetrahedronGeometry: $548f161e17fc6f48$export$fb3f7adc68bd6e02,
    TorusGeometry: $548f161e17fc6f48$export$a2312a2a1fa56495,
    TorusKnotGeometry: $548f161e17fc6f48$export$77e9bfadfb9ab8c8,
    TubeGeometry: $548f161e17fc6f48$export$7897d9d48904490c,
    WireframeGeometry: $548f161e17fc6f48$export$4b739da06d24892b
});
class $548f161e17fc6f48$export$e8564da406055a3 extends $548f161e17fc6f48$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $548f161e17fc6f48$export$21c421a2e1df9d22 extends $548f161e17fc6f48$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
class $548f161e17fc6f48$export$f2980790215acccd extends $548f161e17fc6f48$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            'STANDARD': ''
        };
        this.type = 'MeshStandardMaterial';
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $548f161e17fc6f48$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $548f161e17fc6f48$export$2852a58ebdac27b8;
        this.normalScale = new $548f161e17fc6f48$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $548f161e17fc6f48$export$28d04986c4269c9f extends $548f161e17fc6f48$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $548f161e17fc6f48$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $548f161e17fc6f48$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $548f161e17fc6f48$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $548f161e17fc6f48$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $548f161e17fc6f48$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $548f161e17fc6f48$export$24c72f71cbaf0678 extends $548f161e17fc6f48$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $548f161e17fc6f48$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $548f161e17fc6f48$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $548f161e17fc6f48$export$2852a58ebdac27b8;
        this.normalScale = new $548f161e17fc6f48$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $548f161e17fc6f48$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $548f161e17fc6f48$export$df893cf97e765622 extends $548f161e17fc6f48$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $548f161e17fc6f48$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $548f161e17fc6f48$export$2852a58ebdac27b8;
        this.normalScale = new $548f161e17fc6f48$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $548f161e17fc6f48$export$bfe8c0a091f41ae7 extends $548f161e17fc6f48$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $548f161e17fc6f48$export$2852a58ebdac27b8;
        this.normalScale = new $548f161e17fc6f48$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $548f161e17fc6f48$export$5023a9a8114806b8 extends $548f161e17fc6f48$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $548f161e17fc6f48$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $548f161e17fc6f48$export$2852a58ebdac27b8;
        this.normalScale = new $548f161e17fc6f48$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $548f161e17fc6f48$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $548f161e17fc6f48$export$6f5fef6235ec12ee extends $548f161e17fc6f48$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $548f161e17fc6f48$export$2852a58ebdac27b8;
        this.normalScale = new $548f161e17fc6f48$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $548f161e17fc6f48$export$327886a3efaeaebe extends $548f161e17fc6f48$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// converts an array to a specific type
function $548f161e17fc6f48$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $548f161e17fc6f48$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $548f161e17fc6f48$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $548f161e17fc6f48$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $548f161e17fc6f48$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $548f161e17fc6f48$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $548f161e17fc6f48$var$convertArray(times, track.times.constructor);
        track.values = $548f161e17fc6f48$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $548f161e17fc6f48$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $548f161e17fc6f48$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $548f161e17fc6f48$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $548f161e17fc6f48$export$d875e029ef558d3;
    return targetClip;
}
const $548f161e17fc6f48$export$7ee8caa573e71ad1 = {
    convertArray: $548f161e17fc6f48$var$convertArray,
    isTypedArray: $548f161e17fc6f48$var$isTypedArray,
    getKeyframeOrder: $548f161e17fc6f48$var$getKeyframeOrder,
    sortedArray: $548f161e17fc6f48$var$sortedArray,
    flattenJSON: $548f161e17fc6f48$var$flattenJSON,
    subclip: $548f161e17fc6f48$var$subclip,
    makeClipAdditive: $548f161e17fc6f48$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $548f161e17fc6f48$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $548f161e17fc6f48$export$3646682e7a3959 extends $548f161e17fc6f48$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $548f161e17fc6f48$export$7f795934b84ab523,
            endingEnd: $548f161e17fc6f48$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $548f161e17fc6f48$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $548f161e17fc6f48$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $548f161e17fc6f48$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $548f161e17fc6f48$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $548f161e17fc6f48$export$a8e6009059f51e1a extends $548f161e17fc6f48$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $548f161e17fc6f48$export$fb9758ef7ef8d5cc extends $548f161e17fc6f48$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $548f161e17fc6f48$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        this.name = name;
        this.times = $548f161e17fc6f48$var$convertArray(times, this.TimeBufferType);
        this.values = $548f161e17fc6f48$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $548f161e17fc6f48$var$convertArray(track.times, Array),
                'values': $548f161e17fc6f48$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $548f161e17fc6f48$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $548f161e17fc6f48$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $548f161e17fc6f48$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $548f161e17fc6f48$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $548f161e17fc6f48$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $548f161e17fc6f48$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn('THREE.KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $548f161e17fc6f48$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $548f161e17fc6f48$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $548f161e17fc6f48$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error('THREE.KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($548f161e17fc6f48$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $548f161e17fc6f48$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$548f161e17fc6f48$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$548f161e17fc6f48$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$548f161e17fc6f48$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $548f161e17fc6f48$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $548f161e17fc6f48$export$d3a344b98cf0b775 extends $548f161e17fc6f48$export$b0e479f45b7006d6 {
}
$548f161e17fc6f48$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
$548f161e17fc6f48$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$548f161e17fc6f48$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $548f161e17fc6f48$export$995b32462a65e855;
$548f161e17fc6f48$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$548f161e17fc6f48$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $548f161e17fc6f48$export$83444c5d885347d8 extends $548f161e17fc6f48$export$b0e479f45b7006d6 {
}
$548f161e17fc6f48$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A Track of numeric keyframe values.
 */ class $548f161e17fc6f48$export$d45f0d1a4d9a9314 extends $548f161e17fc6f48$export$b0e479f45b7006d6 {
}
$548f161e17fc6f48$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 */ class $548f161e17fc6f48$export$2db1cfb7923d931e extends $548f161e17fc6f48$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$548f161e17fc6f48$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $548f161e17fc6f48$export$b8043f12b5aafbd7 extends $548f161e17fc6f48$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $548f161e17fc6f48$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$548f161e17fc6f48$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
$548f161e17fc6f48$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $548f161e17fc6f48$export$30fac1aace31cf4d;
$548f161e17fc6f48$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $548f161e17fc6f48$export$6ce41d4f3a8df9cd extends $548f161e17fc6f48$export$b0e479f45b7006d6 {
}
$548f161e17fc6f48$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
$548f161e17fc6f48$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$548f161e17fc6f48$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $548f161e17fc6f48$export$995b32462a65e855;
$548f161e17fc6f48$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$548f161e17fc6f48$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $548f161e17fc6f48$export$5ce2dcb4cc9f2bff extends $548f161e17fc6f48$export$b0e479f45b7006d6 {
}
$548f161e17fc6f48$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
class $548f161e17fc6f48$export$d942c706bf23829c {
    constructor(name, duration = -1, tracks, blendMode = $548f161e17fc6f48$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $548f161e17fc6f48$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($548f161e17fc6f48$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($548f161e17fc6f48$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $548f161e17fc6f48$var$getKeyframeOrder(times);
            times = $548f161e17fc6f48$var$sortedArray(times, 1, order);
            values = $548f161e17fc6f48$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $548f161e17fc6f48$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error('THREE.AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $548f161e17fc6f48$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $548f161e17fc6f48$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($548f161e17fc6f48$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($548f161e17fc6f48$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($548f161e17fc6f48$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $548f161e17fc6f48$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $548f161e17fc6f48$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $548f161e17fc6f48$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $548f161e17fc6f48$export$83444c5d885347d8;
        case 'quaternion':
            return $548f161e17fc6f48$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $548f161e17fc6f48$export$d3a344b98cf0b775;
        case 'string':
            return $548f161e17fc6f48$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $548f161e17fc6f48$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $548f161e17fc6f48$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $548f161e17fc6f48$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $548f161e17fc6f48$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $548f161e17fc6f48$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $548f161e17fc6f48$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $548f161e17fc6f48$export$99cc795e99919eed();
class $548f161e17fc6f48$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $548f161e17fc6f48$export$b033c3f9a95c6a16;
        this.crossOrigin = 'anonymous';
        this.withCredentials = false;
        this.path = '';
        this.resourcePath = '';
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
$548f161e17fc6f48$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
const $548f161e17fc6f48$var$loading = {};
class $548f161e17fc6f48$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $548f161e17fc6f48$export$98435a25b5cf7b2b extends $548f161e17fc6f48$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $548f161e17fc6f48$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($548f161e17fc6f48$var$loading[url] !== undefined) {
            $548f161e17fc6f48$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $548f161e17fc6f48$var$loading[url] = [];
        $548f161e17fc6f48$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin'
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $548f161e17fc6f48$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get('Content-Length') || response.headers.get('X-File-Size');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $548f161e17fc6f48$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $548f161e17fc6f48$export$94affb487e701bf2.add(url, data);
            const callbacks = $548f161e17fc6f48$var$loading[url];
            delete $548f161e17fc6f48$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $548f161e17fc6f48$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $548f161e17fc6f48$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $548f161e17fc6f48$export$29711c7e14f61db extends $548f161e17fc6f48$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $548f161e17fc6f48$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $548f161e17fc6f48$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $548f161e17fc6f48$export$bd73ce947a280350 extends $548f161e17fc6f48$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $548f161e17fc6f48$export$3466bac9141a5cc4();
        const loader = new $548f161e17fc6f48$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $548f161e17fc6f48$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $548f161e17fc6f48$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $548f161e17fc6f48$export$8905ce1c7a2464a1 extends $548f161e17fc6f48$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $548f161e17fc6f48$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $548f161e17fc6f48$var$createElementNS('img');
        function onImageLoad() {
            removeEventListeners();
            $548f161e17fc6f48$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $548f161e17fc6f48$export$2ec114afc2cf6308 extends $548f161e17fc6f48$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $548f161e17fc6f48$export$ee2e5a18258a4049();
        texture.colorSpace = $548f161e17fc6f48$export$561f394b24edfcaa;
        const loader = new $548f161e17fc6f48$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $548f161e17fc6f48$export$792d8a18f2c55855 extends $548f161e17fc6f48$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $548f161e17fc6f48$export$b691f601014eabe1();
        const loader = new $548f161e17fc6f48$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    console.error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $548f161e17fc6f48$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $548f161e17fc6f48$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $548f161e17fc6f48$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $548f161e17fc6f48$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            else if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $548f161e17fc6f48$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $548f161e17fc6f48$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $548f161e17fc6f48$export$fd1bfc71f64c538c extends $548f161e17fc6f48$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $548f161e17fc6f48$export$5431306cf43de24a();
        const loader = new $548f161e17fc6f48$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $548f161e17fc6f48$export$6ecadb6ed240d696 extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = 'Light';
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
class $548f161e17fc6f48$export$8d474f55edbb9624 extends $548f161e17fc6f48$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($548f161e17fc6f48$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new $548f161e17fc6f48$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $548f161e17fc6f48$var$_projScreenMatrix$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_lightPositionWorld$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_lookTarget$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $548f161e17fc6f48$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $548f161e17fc6f48$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $548f161e17fc6f48$export$35efe6f4c85463d2();
        this._frameExtents = new $548f161e17fc6f48$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $548f161e17fc6f48$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $548f161e17fc6f48$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($548f161e17fc6f48$var$_lightPositionWorld$1);
        $548f161e17fc6f48$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($548f161e17fc6f48$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $548f161e17fc6f48$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($548f161e17fc6f48$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($548f161e17fc6f48$var$_projScreenMatrix$1);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $548f161e17fc6f48$var$SpotLightShadow extends $548f161e17fc6f48$var$LightShadow {
    constructor(){
        super(new $548f161e17fc6f48$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $548f161e17fc6f48$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $548f161e17fc6f48$export$81495cbb73897362 extends $548f161e17fc6f48$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($548f161e17fc6f48$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $548f161e17fc6f48$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new $548f161e17fc6f48$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $548f161e17fc6f48$var$_projScreenMatrix = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_lightPositionWorld = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_lookTarget = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$var$PointLightShadow extends $548f161e17fc6f48$var$LightShadow {
    constructor(){
        super(new $548f161e17fc6f48$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $548f161e17fc6f48$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $548f161e17fc6f48$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $548f161e17fc6f48$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $548f161e17fc6f48$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $548f161e17fc6f48$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $548f161e17fc6f48$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $548f161e17fc6f48$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $548f161e17fc6f48$export$64b5c384219d3699(1, 0, 0),
            new $548f161e17fc6f48$export$64b5c384219d3699(-1, 0, 0),
            new $548f161e17fc6f48$export$64b5c384219d3699(0, 0, 1),
            new $548f161e17fc6f48$export$64b5c384219d3699(0, 0, -1),
            new $548f161e17fc6f48$export$64b5c384219d3699(0, 1, 0),
            new $548f161e17fc6f48$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $548f161e17fc6f48$export$64b5c384219d3699(0, 1, 0),
            new $548f161e17fc6f48$export$64b5c384219d3699(0, 1, 0),
            new $548f161e17fc6f48$export$64b5c384219d3699(0, 1, 0),
            new $548f161e17fc6f48$export$64b5c384219d3699(0, 1, 0),
            new $548f161e17fc6f48$export$64b5c384219d3699(0, 0, 1),
            new $548f161e17fc6f48$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $548f161e17fc6f48$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($548f161e17fc6f48$var$_lightPositionWorld);
        $548f161e17fc6f48$var$_lookTarget.copy(camera.position);
        $548f161e17fc6f48$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($548f161e17fc6f48$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$548f161e17fc6f48$var$_lightPositionWorld.x, -$548f161e17fc6f48$var$_lightPositionWorld.y, -$548f161e17fc6f48$var$_lightPositionWorld.z);
        $548f161e17fc6f48$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($548f161e17fc6f48$var$_projScreenMatrix);
    }
}
class $548f161e17fc6f48$export$4c9c1cb3f0b6f455 extends $548f161e17fc6f48$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = 'PointLight';
        this.distance = distance;
        this.decay = decay;
        this.shadow = new $548f161e17fc6f48$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $548f161e17fc6f48$var$DirectionalLightShadow extends $548f161e17fc6f48$var$LightShadow {
    constructor(){
        super(new $548f161e17fc6f48$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $548f161e17fc6f48$export$3fea33cc9972c868 extends $548f161e17fc6f48$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($548f161e17fc6f48$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $548f161e17fc6f48$export$e4dd07dff30cc924();
        this.shadow = new $548f161e17fc6f48$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $548f161e17fc6f48$export$af279bfef9ec2c96 extends $548f161e17fc6f48$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
class $548f161e17fc6f48$export$61db2d908bbd2429 extends $548f161e17fc6f48$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $548f161e17fc6f48$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $548f161e17fc6f48$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $548f161e17fc6f48$export$e7ef036e309b38d2 extends $548f161e17fc6f48$export$6ecadb6ed240d696 {
    constructor(sh = new $548f161e17fc6f48$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $548f161e17fc6f48$export$3bd6d323353dcf96 extends $548f161e17fc6f48$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $548f161e17fc6f48$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = $548f161e17fc6f48$export$3bd6d323353dcf96.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $548f161e17fc6f48$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $548f161e17fc6f48$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $548f161e17fc6f48$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $548f161e17fc6f48$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $548f161e17fc6f48$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $548f161e17fc6f48$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $548f161e17fc6f48$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $548f161e17fc6f48$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $548f161e17fc6f48$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $548f161e17fc6f48$export$e8564da406055a3,
            SpriteMaterial: $548f161e17fc6f48$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $548f161e17fc6f48$export$21c421a2e1df9d22,
            ShaderMaterial: $548f161e17fc6f48$export$83c7d75d550a8b0d,
            PointsMaterial: $548f161e17fc6f48$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $548f161e17fc6f48$export$28d04986c4269c9f,
            MeshStandardMaterial: $548f161e17fc6f48$export$f2980790215acccd,
            MeshPhongMaterial: $548f161e17fc6f48$export$24c72f71cbaf0678,
            MeshToonMaterial: $548f161e17fc6f48$export$df893cf97e765622,
            MeshNormalMaterial: $548f161e17fc6f48$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $548f161e17fc6f48$export$5023a9a8114806b8,
            MeshDepthMaterial: $548f161e17fc6f48$export$2698c22ec13825db,
            MeshDistanceMaterial: $548f161e17fc6f48$export$33e187ed002f2a19,
            MeshBasicMaterial: $548f161e17fc6f48$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $548f161e17fc6f48$export$6f5fef6235ec12ee,
            LineDashedMaterial: $548f161e17fc6f48$export$327886a3efaeaebe,
            LineBasicMaterial: $548f161e17fc6f48$export$fbaaa33907730a0c,
            Material: $548f161e17fc6f48$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $548f161e17fc6f48$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = '';
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $548f161e17fc6f48$export$231f009cbe414146 extends $548f161e17fc6f48$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $548f161e17fc6f48$export$dc275bb96327833a extends $548f161e17fc6f48$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $548f161e17fc6f48$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $548f161e17fc6f48$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $548f161e17fc6f48$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $548f161e17fc6f48$export$231f009cbe414146() : new $548f161e17fc6f48$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $548f161e17fc6f48$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $548f161e17fc6f48$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $548f161e17fc6f48$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $548f161e17fc6f48$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $548f161e17fc6f48$export$32ea87a8b54d744a : $548f161e17fc6f48$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $548f161e17fc6f48$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $548f161e17fc6f48$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $548f161e17fc6f48$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $548f161e17fc6f48$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $548f161e17fc6f48$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $548f161e17fc6f48$export$40110c8505c5ad19 extends $548f161e17fc6f48$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $548f161e17fc6f48$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $548f161e17fc6f48$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                console.error('THREE.ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $548f161e17fc6f48$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $548f161e17fc6f48$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $548f161e17fc6f48$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $548f161e17fc6f48$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $548f161e17fc6f48$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $548f161e17fc6f48$var$Geometries) geometry = $548f161e17fc6f48$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $548f161e17fc6f48$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $548f161e17fc6f48$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $548f161e17fc6f48$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $548f161e17fc6f48$export$99cc795e99919eed(onLoad);
            loader = new $548f161e17fc6f48$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $548f161e17fc6f48$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $548f161e17fc6f48$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $548f161e17fc6f48$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $548f161e17fc6f48$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $548f161e17fc6f48$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $548f161e17fc6f48$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $548f161e17fc6f48$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $548f161e17fc6f48$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $548f161e17fc6f48$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $548f161e17fc6f48$export$b691f601014eabe1();
                else texture = new $548f161e17fc6f48$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $548f161e17fc6f48$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $548f161e17fc6f48$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $548f161e17fc6f48$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.encoding !== undefined) texture.encoding = data.encoding; // @deprecated, r152
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $548f161e17fc6f48$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $548f161e17fc6f48$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $548f161e17fc6f48$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $548f161e17fc6f48$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $548f161e17fc6f48$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $548f161e17fc6f48$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                    if (data.fog.name !== '') object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                break;
            case 'PerspectiveCamera':
                object = new $548f161e17fc6f48$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $548f161e17fc6f48$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $548f161e17fc6f48$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $548f161e17fc6f48$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case 'PointLight':
                object = new $548f161e17fc6f48$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $548f161e17fc6f48$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $548f161e17fc6f48$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case 'HemisphereLight':
                object = new $548f161e17fc6f48$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new $548f161e17fc6f48$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $548f161e17fc6f48$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $548f161e17fc6f48$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $548f161e17fc6f48$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $548f161e17fc6f48$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $548f161e17fc6f48$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'LOD':
                object = new $548f161e17fc6f48$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $548f161e17fc6f48$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $548f161e17fc6f48$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $548f161e17fc6f48$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $548f161e17fc6f48$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $548f161e17fc6f48$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $548f161e17fc6f48$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $548f161e17fc6f48$export$b127726e56765aa4();
                break;
            default:
                object = new $548f161e17fc6f48$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
}
const $548f161e17fc6f48$var$TEXTURE_MAPPING = {
    UVMapping: $548f161e17fc6f48$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $548f161e17fc6f48$export$8759762a6477f2c4,
    CubeRefractionMapping: $548f161e17fc6f48$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $548f161e17fc6f48$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $548f161e17fc6f48$export$ee99d97d46898098,
    CubeUVReflectionMapping: $548f161e17fc6f48$export$dbf3e70ff37af79
};
const $548f161e17fc6f48$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $548f161e17fc6f48$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $548f161e17fc6f48$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $548f161e17fc6f48$export$c7e7c00b14f51a4f
};
const $548f161e17fc6f48$var$TEXTURE_FILTER = {
    NearestFilter: $548f161e17fc6f48$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $548f161e17fc6f48$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $548f161e17fc6f48$export$d2327c1afe5bfdf2,
    LinearFilter: $548f161e17fc6f48$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $548f161e17fc6f48$export$19a719f377145a13,
    LinearMipmapLinearFilter: $548f161e17fc6f48$export$5d8599b6a933fb1b
};
class $548f161e17fc6f48$export$52286b55c4a9b51f extends $548f161e17fc6f48$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        this.options = {
            premultiplyAlpha: 'none'
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $548f161e17fc6f48$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $548f161e17fc6f48$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
}
let $548f161e17fc6f48$var$_context;
class $548f161e17fc6f48$export$fcbc63750ec2a81f {
    static getContext() {
        if ($548f161e17fc6f48$var$_context === undefined) $548f161e17fc6f48$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $548f161e17fc6f48$var$_context;
    }
    static setContext(value) {
        $548f161e17fc6f48$var$_context = value;
    }
}
class $548f161e17fc6f48$export$d8d5fccfbf47714e extends $548f161e17fc6f48$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $548f161e17fc6f48$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $548f161e17fc6f48$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }, handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
}
const $548f161e17fc6f48$var$_eyeRight = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_eyeLeft = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_projectionMatrix = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
class $548f161e17fc6f48$export$bc7f73a1065bee0c {
    constructor(){
        this.type = 'StereoCamera';
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $548f161e17fc6f48$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $548f161e17fc6f48$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $548f161e17fc6f48$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($548f161e17fc6f48$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $548f161e17fc6f48$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $548f161e17fc6f48$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $548f161e17fc6f48$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $548f161e17fc6f48$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($548f161e17fc6f48$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $548f161e17fc6f48$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $548f161e17fc6f48$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($548f161e17fc6f48$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($548f161e17fc6f48$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($548f161e17fc6f48$var$_eyeRight);
    }
}
class $548f161e17fc6f48$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $548f161e17fc6f48$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $548f161e17fc6f48$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $548f161e17fc6f48$var$now() {
    return (typeof performance === 'undefined' ? Date : performance).now(); // see #10732
}
const $548f161e17fc6f48$var$_position$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_quaternion$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$23d6a54f0bbc85a3();
const $548f161e17fc6f48$var$_scale$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_orientation$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$export$8a1b810c6fde8951 extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = 'AudioListener';
        this.context = $548f161e17fc6f48$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $548f161e17fc6f48$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($548f161e17fc6f48$var$_position$1, $548f161e17fc6f48$var$_quaternion$1, $548f161e17fc6f48$var$_scale$1);
        $548f161e17fc6f48$var$_orientation$1.set(0, 0, -1).applyQuaternion($548f161e17fc6f48$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($548f161e17fc6f48$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($548f161e17fc6f48$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($548f161e17fc6f48$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($548f161e17fc6f48$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($548f161e17fc6f48$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($548f161e17fc6f48$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($548f161e17fc6f48$var$_position$1.x, $548f161e17fc6f48$var$_position$1.y, $548f161e17fc6f48$var$_position$1.z);
            listener.setOrientation($548f161e17fc6f48$var$_orientation$1.x, $548f161e17fc6f48$var$_orientation$1.y, $548f161e17fc6f48$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $548f161e17fc6f48$export$153755f98d9861de extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = 'Audio';
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn('THREE.Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop();
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $548f161e17fc6f48$var$_position = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_quaternion = /*@__PURE__*/ new $548f161e17fc6f48$export$23d6a54f0bbc85a3();
const $548f161e17fc6f48$var$_scale = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_orientation = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$export$4b3e397ef1832507 extends $548f161e17fc6f48$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($548f161e17fc6f48$var$_position, $548f161e17fc6f48$var$_quaternion, $548f161e17fc6f48$var$_scale);
        $548f161e17fc6f48$var$_orientation.set(0, 0, 1).applyQuaternion($548f161e17fc6f48$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($548f161e17fc6f48$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($548f161e17fc6f48$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($548f161e17fc6f48$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($548f161e17fc6f48$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($548f161e17fc6f48$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($548f161e17fc6f48$var$_orientation.z, endTime);
        } else {
            panner.setPosition($548f161e17fc6f48$var$_position.x, $548f161e17fc6f48$var$_position.y, $548f161e17fc6f48$var$_position.z);
            panner.setOrientation($548f161e17fc6f48$var$_orientation.x, $548f161e17fc6f48$var$_orientation.y, $548f161e17fc6f48$var$_orientation.z);
        }
    }
}
class $548f161e17fc6f48$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $548f161e17fc6f48$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $548f161e17fc6f48$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $548f161e17fc6f48$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $548f161e17fc6f48$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $548f161e17fc6f48$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $548f161e17fc6f48$var$_reservedRe = new RegExp('[' + $548f161e17fc6f48$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $548f161e17fc6f48$var$_wordChar = '[^' + $548f161e17fc6f48$var$_RESERVED_CHARS_RE + ']';
const $548f161e17fc6f48$var$_wordCharOrDot = '[^' + $548f161e17fc6f48$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $548f161e17fc6f48$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $548f161e17fc6f48$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $548f161e17fc6f48$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $548f161e17fc6f48$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $548f161e17fc6f48$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $548f161e17fc6f48$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $548f161e17fc6f48$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $548f161e17fc6f48$var$_wordChar);
const $548f161e17fc6f48$var$_trackRe = new RegExp("^" + $548f161e17fc6f48$var$_directoryRe + $548f161e17fc6f48$var$_nodeRe + $548f161e17fc6f48$var$_objectRe + $548f161e17fc6f48$var$_propertyRe + '$');
const $548f161e17fc6f48$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class $548f161e17fc6f48$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $548f161e17fc6f48$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $548f161e17fc6f48$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $548f161e17fc6f48$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $548f161e17fc6f48$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $548f161e17fc6f48$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $548f161e17fc6f48$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($548f161e17fc6f48$var$_reservedRe, '');
    }
    static parseTrackName(trackName) {
        const matches = $548f161e17fc6f48$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($548f161e17fc6f48$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $548f161e17fc6f48$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.warn('THREE.PropertyBinding: No target node found for track: ' + this.path + '.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error('THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$548f161e17fc6f48$export$7bf70fcf9f891893.Composite = $548f161e17fc6f48$var$Composite;
$548f161e17fc6f48$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$548f161e17fc6f48$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$548f161e17fc6f48$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._getValue_direct,
    $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._getValue_array,
    $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$548f161e17fc6f48$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._setValue_direct,
        $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._setValue_array,
        $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $548f161e17fc6f48$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $548f161e17fc6f48$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $548f161e17fc6f48$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $548f161e17fc6f48$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $548f161e17fc6f48$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $548f161e17fc6f48$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $548f161e17fc6f48$export$6946940a69e799e {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $548f161e17fc6f48$export$7f795934b84ab523,
            endingEnd: $548f161e17fc6f48$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $548f161e17fc6f48$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $548f161e17fc6f48$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $548f161e17fc6f48$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $548f161e17fc6f48$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $548f161e17fc6f48$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $548f161e17fc6f48$export$24a4ccb5099273b5;
            settings.endingEnd = $548f161e17fc6f48$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $548f161e17fc6f48$export$24a4ccb5099273b5 : $548f161e17fc6f48$export$7f795934b84ab523;
            else settings.endingStart = $548f161e17fc6f48$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $548f161e17fc6f48$export$24a4ccb5099273b5 : $548f161e17fc6f48$export$7f795934b84ab523;
            else settings.endingEnd = $548f161e17fc6f48$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $548f161e17fc6f48$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $548f161e17fc6f48$export$fbd77e5aefaa0102 extends $548f161e17fc6f48$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $548f161e17fc6f48$export$dfe0af1ca1acb78a($548f161e17fc6f48$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $548f161e17fc6f48$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $548f161e17fc6f48$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $548f161e17fc6f48$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $548f161e17fc6f48$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $548f161e17fc6f48$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $548f161e17fc6f48$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $548f161e17fc6f48$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $548f161e17fc6f48$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $548f161e17fc6f48$var$_id = 0;
class $548f161e17fc6f48$export$c412d5ffe1f79209 extends $548f161e17fc6f48$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, 'id', {
            value: $548f161e17fc6f48$var$_id++
        });
        this.name = '';
        this.usage = $548f161e17fc6f48$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++)this.uniforms.push(uniformsSource[i].clone());
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $548f161e17fc6f48$export$25ec0e1af1389358 extends $548f161e17fc6f48$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $548f161e17fc6f48$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = '';
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
class $548f161e17fc6f48$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $548f161e17fc6f48$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $548f161e17fc6f48$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
    }
    intersectObject(object, recursive = true, intersects = []) {
        $548f161e17fc6f48$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($548f161e17fc6f48$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$548f161e17fc6f48$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($548f161e17fc6f48$var$ascSort);
        return intersects;
    }
}
function $548f161e17fc6f48$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $548f161e17fc6f48$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$548f161e17fc6f48$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $548f161e17fc6f48$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($548f161e17fc6f48$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $548f161e17fc6f48$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $548f161e17fc6f48$var$_vector$4 = /*@__PURE__*/ new $548f161e17fc6f48$export$c977b3e384af9ae1();
class $548f161e17fc6f48$export$60f553fa130f08b0 {
    constructor(min = new $548f161e17fc6f48$export$c977b3e384af9ae1(Infinity, Infinity), max = new $548f161e17fc6f48$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $548f161e17fc6f48$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $548f161e17fc6f48$var$_vector$4).distanceTo(point);
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $548f161e17fc6f48$var$_startP = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_startEnd = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$export$e0ba6359f1954fd3 {
    constructor(start = new $548f161e17fc6f48$export$64b5c384219d3699(), end = new $548f161e17fc6f48$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $548f161e17fc6f48$var$_startP.subVectors(point, this.start);
        $548f161e17fc6f48$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $548f161e17fc6f48$var$_startEnd.dot($548f161e17fc6f48$var$_startEnd);
        const startEnd_startP = $548f161e17fc6f48$var$_startEnd.dot($548f161e17fc6f48$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $548f161e17fc6f48$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $548f161e17fc6f48$var$_vector$3 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$export$4b14638ffdd81e68 extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'SpotLightHelper';
        const geometry = new $548f161e17fc6f48$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(positions, 3));
        const material = new $548f161e17fc6f48$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $548f161e17fc6f48$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $548f161e17fc6f48$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($548f161e17fc6f48$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $548f161e17fc6f48$var$_vector$2 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_boneMatrix = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
const $548f161e17fc6f48$var$_matrixWorldInv = /*@__PURE__*/ new $548f161e17fc6f48$export$2ae72fc923e5eb5();
class $548f161e17fc6f48$export$5277df3c9e732259 extends $548f161e17fc6f48$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $548f161e17fc6f48$var$getBoneList(object);
        const geometry = new $548f161e17fc6f48$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $548f161e17fc6f48$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $548f161e17fc6f48$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $548f161e17fc6f48$export$cbe7a62641830ebd(colors, 3));
        const material = new $548f161e17fc6f48$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $548f161e17fc6f48$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $548f161e17fc6f48$var$_boneMatrix.multiplyMatrices($548f161e17fc6f48$var$_matrixWorldInv, bone.matrixWorld);
                $548f161e17fc6f48$var$_vector$2.setFromMatrixPosition($548f161e17fc6f48$var$_boneMatrix);
                position.setXYZ(j, $548f161e17fc6f48$var$_vector$2.x, $548f161e17fc6f48$var$_vector$2.y, $548f161e17fc6f48$var$_vector$2.z);
                $548f161e17fc6f48$var$_boneMatrix.multiplyMatrices($548f161e17fc6f48$var$_matrixWorldInv, bone.parent.matrixWorld);
                $548f161e17fc6f48$var$_vector$2.setFromMatrixPosition($548f161e17fc6f48$var$_boneMatrix);
                position.setXYZ(j + 1, $548f161e17fc6f48$var$_vector$2.x, $548f161e17fc6f48$var$_vector$2.y, $548f161e17fc6f48$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $548f161e17fc6f48$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $548f161e17fc6f48$var$getBoneList(object.children[i]));
    return boneList;
}
class $548f161e17fc6f48$export$9a9291685b9e4023 extends $548f161e17fc6f48$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $548f161e17fc6f48$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $548f161e17fc6f48$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $548f161e17fc6f48$var$_vector$1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_color1 = /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e();
const $548f161e17fc6f48$var$_color2 = /*@__PURE__*/ new $548f161e17fc6f48$export$892596cec99bc70e();
class $548f161e17fc6f48$export$8dca15f13f4f8172 extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'HemisphereLightHelper';
        const geometry = new $548f161e17fc6f48$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $548f161e17fc6f48$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $548f161e17fc6f48$export$8dea267bd6bde117(colors, 3));
        this.add(new $548f161e17fc6f48$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $548f161e17fc6f48$var$_color1.copy(this.light.color);
            $548f161e17fc6f48$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $548f161e17fc6f48$var$_color1 : $548f161e17fc6f48$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($548f161e17fc6f48$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $548f161e17fc6f48$export$3875d39926561055 extends $548f161e17fc6f48$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $548f161e17fc6f48$export$892596cec99bc70e(color1);
        color2 = new $548f161e17fc6f48$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $548f161e17fc6f48$export$b7be63a67df8959();
        geometry.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $548f161e17fc6f48$export$cbe7a62641830ebd(colors, 3));
        const material = new $548f161e17fc6f48$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $548f161e17fc6f48$export$361430a10f533cd3 extends $548f161e17fc6f48$export$ff1ed10fedfdd604 {
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $548f161e17fc6f48$export$892596cec99bc70e(color1);
        color2 = new $548f161e17fc6f48$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $548f161e17fc6f48$export$b7be63a67df8959();
        geometry.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $548f161e17fc6f48$export$cbe7a62641830ebd(colors, 3));
        const material = new $548f161e17fc6f48$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $548f161e17fc6f48$var$_v1 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_v2 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_v3 = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
class $548f161e17fc6f48$export$f8e434dc14203e7d extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        let geometry = new $548f161e17fc6f48$export$b7be63a67df8959();
        geometry.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $548f161e17fc6f48$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $548f161e17fc6f48$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $548f161e17fc6f48$export$b7be63a67df8959();
        geometry.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $548f161e17fc6f48$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $548f161e17fc6f48$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $548f161e17fc6f48$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $548f161e17fc6f48$var$_v3.subVectors($548f161e17fc6f48$var$_v2, $548f161e17fc6f48$var$_v1);
        this.lightPlane.lookAt($548f161e17fc6f48$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($548f161e17fc6f48$var$_v2);
        this.targetLine.scale.z = $548f161e17fc6f48$var$_v3.length();
    }
}
const $548f161e17fc6f48$var$_vector = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
const $548f161e17fc6f48$var$_camera = /*@__PURE__*/ new $548f161e17fc6f48$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $548f161e17fc6f48$export$ed8e93f853cd795 extends $548f161e17fc6f48$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $548f161e17fc6f48$export$b7be63a67df8959();
        const material = new $548f161e17fc6f48$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $548f161e17fc6f48$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $548f161e17fc6f48$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $548f161e17fc6f48$export$892596cec99bc70e(0xff0000);
        const colorUp = new $548f161e17fc6f48$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $548f161e17fc6f48$export$892596cec99bc70e(0xffffff);
        const colorCross = new $548f161e17fc6f48$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $548f161e17fc6f48$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $548f161e17fc6f48$var$setPoint('c', pointMap, geometry, $548f161e17fc6f48$var$_camera, 0, 0, -1);
        $548f161e17fc6f48$var$setPoint('t', pointMap, geometry, $548f161e17fc6f48$var$_camera, 0, 0, 1);
        // near
        $548f161e17fc6f48$var$setPoint('n1', pointMap, geometry, $548f161e17fc6f48$var$_camera, -w, -h, -1);
        $548f161e17fc6f48$var$setPoint('n2', pointMap, geometry, $548f161e17fc6f48$var$_camera, w, -h, -1);
        $548f161e17fc6f48$var$setPoint('n3', pointMap, geometry, $548f161e17fc6f48$var$_camera, -w, h, -1);
        $548f161e17fc6f48$var$setPoint('n4', pointMap, geometry, $548f161e17fc6f48$var$_camera, w, h, -1);
        // far
        $548f161e17fc6f48$var$setPoint('f1', pointMap, geometry, $548f161e17fc6f48$var$_camera, -w, -h, 1);
        $548f161e17fc6f48$var$setPoint('f2', pointMap, geometry, $548f161e17fc6f48$var$_camera, w, -h, 1);
        $548f161e17fc6f48$var$setPoint('f3', pointMap, geometry, $548f161e17fc6f48$var$_camera, -w, h, 1);
        $548f161e17fc6f48$var$setPoint('f4', pointMap, geometry, $548f161e17fc6f48$var$_camera, w, h, 1);
        // up
        $548f161e17fc6f48$var$setPoint('u1', pointMap, geometry, $548f161e17fc6f48$var$_camera, w * 0.7, h * 1.1, -1);
        $548f161e17fc6f48$var$setPoint('u2', pointMap, geometry, $548f161e17fc6f48$var$_camera, -w * 0.7, h * 1.1, -1);
        $548f161e17fc6f48$var$setPoint('u3', pointMap, geometry, $548f161e17fc6f48$var$_camera, 0, h * 2, -1);
        // cross
        $548f161e17fc6f48$var$setPoint('cf1', pointMap, geometry, $548f161e17fc6f48$var$_camera, -w, 0, 1);
        $548f161e17fc6f48$var$setPoint('cf2', pointMap, geometry, $548f161e17fc6f48$var$_camera, w, 0, 1);
        $548f161e17fc6f48$var$setPoint('cf3', pointMap, geometry, $548f161e17fc6f48$var$_camera, 0, -h, 1);
        $548f161e17fc6f48$var$setPoint('cf4', pointMap, geometry, $548f161e17fc6f48$var$_camera, 0, h, 1);
        $548f161e17fc6f48$var$setPoint('cn1', pointMap, geometry, $548f161e17fc6f48$var$_camera, -w, 0, -1);
        $548f161e17fc6f48$var$setPoint('cn2', pointMap, geometry, $548f161e17fc6f48$var$_camera, w, 0, -1);
        $548f161e17fc6f48$var$setPoint('cn3', pointMap, geometry, $548f161e17fc6f48$var$_camera, 0, -h, -1);
        $548f161e17fc6f48$var$setPoint('cn4', pointMap, geometry, $548f161e17fc6f48$var$_camera, 0, h, -1);
        geometry.getAttribute('position').needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $548f161e17fc6f48$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $548f161e17fc6f48$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $548f161e17fc6f48$var$_vector.x, $548f161e17fc6f48$var$_vector.y, $548f161e17fc6f48$var$_vector.z);
    }
}
const $548f161e17fc6f48$var$_box = /*@__PURE__*/ new $548f161e17fc6f48$export$6f7d5a9418ab2aa3();
class $548f161e17fc6f48$export$38a664cc862a6a9d extends $548f161e17fc6f48$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $548f161e17fc6f48$export$b7be63a67df8959();
        geometry.setIndex(new $548f161e17fc6f48$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $548f161e17fc6f48$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $548f161e17fc6f48$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn('THREE.BoxHelper: .update() has no longer arguments.');
        if (this.object !== undefined) $548f161e17fc6f48$var$_box.setFromObject(this.object);
        if ($548f161e17fc6f48$var$_box.isEmpty()) return;
        const min = $548f161e17fc6f48$var$_box.min;
        const max = $548f161e17fc6f48$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $548f161e17fc6f48$export$ce39f4bb96c9a290 extends $548f161e17fc6f48$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $548f161e17fc6f48$export$b7be63a67df8959();
        geometry.setIndex(new $548f161e17fc6f48$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $548f161e17fc6f48$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $548f161e17fc6f48$export$a34fe8156c66e5d7 extends $548f161e17fc6f48$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $548f161e17fc6f48$export$b7be63a67df8959();
        geometry.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $548f161e17fc6f48$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $548f161e17fc6f48$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $548f161e17fc6f48$export$e176487c05830cc5(geometry2, new $548f161e17fc6f48$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $548f161e17fc6f48$var$_axis = /*@__PURE__*/ new $548f161e17fc6f48$export$64b5c384219d3699();
let $548f161e17fc6f48$var$_lineGeometry, $548f161e17fc6f48$var$_coneGeometry;
class $548f161e17fc6f48$export$a3008e7bd8d2cbe7 extends $548f161e17fc6f48$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $548f161e17fc6f48$export$64b5c384219d3699(0, 0, 1), origin = new $548f161e17fc6f48$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($548f161e17fc6f48$var$_lineGeometry === undefined) {
            $548f161e17fc6f48$var$_lineGeometry = new $548f161e17fc6f48$export$b7be63a67df8959();
            $548f161e17fc6f48$var$_lineGeometry.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $548f161e17fc6f48$var$_coneGeometry = new $548f161e17fc6f48$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $548f161e17fc6f48$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $548f161e17fc6f48$export$17d680238e50603e($548f161e17fc6f48$var$_lineGeometry, new $548f161e17fc6f48$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $548f161e17fc6f48$export$e176487c05830cc5($548f161e17fc6f48$var$_coneGeometry, new $548f161e17fc6f48$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $548f161e17fc6f48$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($548f161e17fc6f48$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
class $548f161e17fc6f48$export$6c8303f35b8578fd extends $548f161e17fc6f48$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $548f161e17fc6f48$export$b7be63a67df8959();
        geometry.setAttribute('position', new $548f161e17fc6f48$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $548f161e17fc6f48$export$cbe7a62641830ebd(colors, 3));
        const material = new $548f161e17fc6f48$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $548f161e17fc6f48$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $548f161e17fc6f48$export$148534a3c727230b {
    constructor(){
        this.type = 'ShapePath';
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $548f161e17fc6f48$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $548f161e17fc6f48$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $548f161e17fc6f48$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $548f161e17fc6f48$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $548f161e17fc6f48$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $548f161e17fc6f48$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $548f161e17fc6f48$export$3545e07a80636437;
}




var $aqdBs = parcelRequire("aqdBs");
var $eeb07fcb2b6a118a$exports = {};
'use strict';

$eeb07fcb2b6a118a$exports = (parcelRequire("2A4qT"));


var $a82936f98dfe91f3$exports = {};
'use strict';
Object.defineProperty($a82936f98dfe91f3$exports, '__esModule', {
    value: true
});

var $aqdBs = parcelRequire("aqdBs");
function $a82936f98dfe91f3$var$createStore(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (nextState !== state) {
            var _previousState = state;
            state = replace ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribeWithSelector = function subscribeWithSelector(listener, selector, equalityFn) {
        if (selector === void 0) selector = getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        console.warn('[DEPRECATED] Please use `subscribeWithSelector` middleware');
        var currentSlice = selector(state);
        function listenerToAdd() {
            var nextSlice = selector(state);
            if (!equalityFn(currentSlice, nextSlice)) {
                var _previousSlice = currentSlice;
                listener(currentSlice = nextSlice, _previousSlice);
            }
        }
        listeners.add(listenerToAdd);
        return function() {
            return listeners.delete(listenerToAdd);
        };
    };
    var subscribe = function subscribe(listener, selector, equalityFn) {
        if (selector || equalityFn) return subscribeWithSelector(listener, selector, equalityFn);
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        return listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
}
var $a82936f98dfe91f3$var$isSSR = typeof window === 'undefined' || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
var $a82936f98dfe91f3$var$useIsomorphicLayoutEffect = $a82936f98dfe91f3$var$isSSR ? $aqdBs.useEffect : $aqdBs.useLayoutEffect;
function $a82936f98dfe91f3$var$create(createState) {
    var api = typeof createState === 'function' ? $a82936f98dfe91f3$var$createStore(createState) : createState;
    var useStore = function useStore(selector, equalityFn) {
        if (selector === void 0) selector = api.getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        var _ref = $aqdBs.useReducer(function(c) {
            return c + 1;
        }, 0), forceUpdate = _ref[1];
        var state = api.getState();
        var stateRef = $aqdBs.useRef(state);
        var selectorRef = $aqdBs.useRef(selector);
        var equalityFnRef = $aqdBs.useRef(equalityFn);
        var erroredRef = $aqdBs.useRef(false);
        var currentSliceRef = $aqdBs.useRef();
        if (currentSliceRef.current === undefined) currentSliceRef.current = selector(state);
        var newStateSlice;
        var hasNewStateSlice = false;
        if (stateRef.current !== state || selectorRef.current !== selector || equalityFnRef.current !== equalityFn || erroredRef.current) {
            newStateSlice = selector(state);
            hasNewStateSlice = !equalityFn(currentSliceRef.current, newStateSlice);
        }
        $a82936f98dfe91f3$var$useIsomorphicLayoutEffect(function() {
            if (hasNewStateSlice) currentSliceRef.current = newStateSlice;
            stateRef.current = state;
            selectorRef.current = selector;
            equalityFnRef.current = equalityFn;
            erroredRef.current = false;
        });
        var stateBeforeSubscriptionRef = $aqdBs.useRef(state);
        $a82936f98dfe91f3$var$useIsomorphicLayoutEffect(function() {
            var listener = function listener() {
                try {
                    var nextState = api.getState();
                    var nextStateSlice = selectorRef.current(nextState);
                    if (!equalityFnRef.current(currentSliceRef.current, nextStateSlice)) {
                        stateRef.current = nextState;
                        currentSliceRef.current = nextStateSlice;
                        forceUpdate();
                    }
                } catch (error) {
                    erroredRef.current = true;
                    forceUpdate();
                }
            };
            var unsubscribe = api.subscribe(listener);
            if (api.getState() !== stateBeforeSubscriptionRef.current) listener();
            return unsubscribe;
        }, []);
        var sliceToReturn = hasNewStateSlice ? newStateSlice : currentSliceRef.current;
        $aqdBs.useDebugValue(sliceToReturn);
        return sliceToReturn;
    };
    Object.assign(useStore, api);
    useStore[Symbol.iterator] = function() {
        console.warn('[useStore, api] = create() is deprecated and will be removed in v4');
        var items = [
            useStore,
            api
        ];
        return {
            next: function next() {
                var done = items.length <= 0;
                return {
                    value: items.shift(),
                    done: done
                };
            }
        };
    };
    return useStore;
}
$a82936f98dfe91f3$exports["default"] = $a82936f98dfe91f3$var$create;


const $79fc2eee8c1d2a78$var$isPromise = (promise)=>typeof promise === 'object' && typeof promise.then === 'function';
const $79fc2eee8c1d2a78$var$globalCache = [];
function $79fc2eee8c1d2a78$var$shallowEqualArrays(arrA, arrB, equal = (a, b)=>a === b) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++)if (!equal(arrA[i], arrB[i])) return false;
    return true;
}
function $79fc2eee8c1d2a78$var$query(fn, keys = null, preload = false, config = {}) {
    // If no keys were given, the function is the key
    if (keys === null) keys = [
        fn
    ];
    for (const entry of $79fc2eee8c1d2a78$var$globalCache)// Find a match
    if ($79fc2eee8c1d2a78$var$shallowEqualArrays(keys, entry.keys, entry.equal)) {
        // If we're pre-loading and the element is present, just return
        if (preload) return undefined; // If an error occurred, throw
        if (Object.prototype.hasOwnProperty.call(entry, 'error')) throw entry.error; // If a response was successful, return
        if (Object.prototype.hasOwnProperty.call(entry, 'response')) {
            if (config.lifespan && config.lifespan > 0) {
                if (entry.timeout) clearTimeout(entry.timeout);
                entry.timeout = setTimeout(entry.remove, config.lifespan);
            }
            return entry.response;
        } // If the promise is still unresolved, throw
        if (!preload) throw entry.promise;
    }
     // The request is new or has changed.
    const entry = {
        keys: keys,
        equal: config.equal,
        remove: ()=>{
            const index = $79fc2eee8c1d2a78$var$globalCache.indexOf(entry);
            if (index !== -1) $79fc2eee8c1d2a78$var$globalCache.splice(index, 1);
        },
        promise: ($79fc2eee8c1d2a78$var$isPromise(fn) ? fn : fn(...keys) // When it resolves, store its value
        ).then((response)=>{
            entry.response = response; // Remove the entry in time if a lifespan was given
            if (config.lifespan && config.lifespan > 0) entry.timeout = setTimeout(entry.remove, config.lifespan);
        }) // Store caught errors, they will be thrown in the render-phase to bubble into an error-bound
        .catch((error)=>entry.error = error)
    }; // Register the entry
    $79fc2eee8c1d2a78$var$globalCache.push(entry); // And throw the promise, this yields control back to React
    if (!preload) throw entry.promise;
    return undefined;
}
const $79fc2eee8c1d2a78$export$a1428c8f7ba796e8 = (fn, keys, config)=>$79fc2eee8c1d2a78$var$query(fn, keys, false, config);
const $79fc2eee8c1d2a78$export$513ccb98c53b8039 = (fn, keys, config)=>void $79fc2eee8c1d2a78$var$query(fn, keys, true, config);
const $79fc2eee8c1d2a78$export$4d3fb11e950abb9e = (keys)=>{
    var _globalCache$find;
    return (_globalCache$find = $79fc2eee8c1d2a78$var$globalCache.find((entry)=>$79fc2eee8c1d2a78$var$shallowEqualArrays(keys, entry.keys, entry.equal))) == null ? void 0 : _globalCache$find.response;
};
const $79fc2eee8c1d2a78$export$42ffd38884aecdac = (keys)=>{
    if (keys === undefined || keys.length === 0) $79fc2eee8c1d2a78$var$globalCache.splice(0, $79fc2eee8c1d2a78$var$globalCache.length);
    else {
        const entry = $79fc2eee8c1d2a78$var$globalCache.find((entry)=>$79fc2eee8c1d2a78$var$shallowEqualArrays(keys, entry.keys, entry.equal));
        if (entry) entry.remove();
    }
};



var $3672f90649f8b6c2$exports = {};
'use strict';

$3672f90649f8b6c2$exports = (parcelRequire("iSsHE"));



var $bdSvy = parcelRequire("bdSvy");
var $62815e5999fdef70$export$625550452a3fa3ec = /*#__PURE__*/ Object.freeze({
    __proto__: null
});
const $62815e5999fdef70$var$catalogue = {};
const $62815e5999fdef70$export$f1e1789686576879 = (objects)=>void Object.assign($62815e5999fdef70$var$catalogue, objects);
function $62815e5999fdef70$var$createRenderer(_roots, _getEventPriority) {
    function createInstance(type, { args: args = [], attach: attach, ...props }, root) {
        let name = `${type[0].toUpperCase()}${type.slice(1)}`;
        let instance;
        if (type === 'primitive') {
            if (props.object === undefined) throw new Error("R3F: Primitives without 'object' are invalid!");
            const object = props.object;
            instance = $62815e5999fdef70$var$prepare(object, {
                type: type,
                root: root,
                attach: attach,
                primitive: true
            });
        } else {
            const target = $62815e5999fdef70$var$catalogue[name];
            if (!target) throw new Error(`R3F: ${name} is not part of the THREE namespace! Did you forget to extend? See: https://docs.pmnd.rs/react-three-fiber/api/objects#using-3rd-party-objects-declaratively`);
            // Throw if an object or literal was passed for args
            if (!Array.isArray(args)) throw new Error('R3F: The args prop must be an array!');
            // Instanciate new object, link it to the root
            // Append memoized props with args so it's not forgotten
            instance = $62815e5999fdef70$var$prepare(new target(...args), {
                type: type,
                root: root,
                attach: attach,
                // Save args in case we need to reconstruct later for HMR
                memoizedProps: {
                    args: args
                }
            });
        }
        // Auto-attach geometries and materials
        if (instance.__r3f.attach === undefined) {
            if (instance.isBufferGeometry) instance.__r3f.attach = 'geometry';
            else if (instance.isMaterial) instance.__r3f.attach = 'material';
        }
        // It should NOT call onUpdate on object instanciation, because it hasn't been added to the
        // view yet. If the callback relies on references for instance, they won't be ready yet, this is
        // why it passes "true" here
        // There is no reason to apply props to injects
        if (name !== 'inject') $62815e5999fdef70$var$applyProps$1(instance, props);
        return instance;
    }
    function appendChild(parentInstance, child) {
        let added = false;
        if (child) {
            var _child$__r3f, _parentInstance$__r3f;
            // The attach attribute implies that the object attaches itself on the parent
            if ((_child$__r3f = child.__r3f) != null && _child$__r3f.attach) $62815e5999fdef70$var$attach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                // add in the usual parent-child way
                parentInstance.add(child);
                added = true;
            }
            // This is for anything that used attach, and for non-Object3Ds that don't get attached to props;
            // that is, anything that's a child in React but not a child in the scenegraph.
            if (!added) (_parentInstance$__r3f = parentInstance.__r3f) == null || _parentInstance$__r3f.objects.push(child);
            if (!child.__r3f) $62815e5999fdef70$var$prepare(child, {});
            child.__r3f.parent = parentInstance;
            $62815e5999fdef70$var$updateInstance(child);
            $62815e5999fdef70$var$invalidateInstance(child);
        }
    }
    function insertBefore(parentInstance, child, beforeChild) {
        let added = false;
        if (child) {
            var _child$__r3f2, _parentInstance$__r3f2;
            if ((_child$__r3f2 = child.__r3f) != null && _child$__r3f2.attach) $62815e5999fdef70$var$attach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                child.parent = parentInstance;
                child.dispatchEvent({
                    type: 'added'
                });
                parentInstance.dispatchEvent({
                    type: 'childadded',
                    child: child
                });
                const restSiblings = parentInstance.children.filter((sibling)=>sibling !== child);
                const index = restSiblings.indexOf(beforeChild);
                parentInstance.children = [
                    ...restSiblings.slice(0, index),
                    child,
                    ...restSiblings.slice(index)
                ];
                added = true;
            }
            if (!added) (_parentInstance$__r3f2 = parentInstance.__r3f) == null || _parentInstance$__r3f2.objects.push(child);
            if (!child.__r3f) $62815e5999fdef70$var$prepare(child, {});
            child.__r3f.parent = parentInstance;
            $62815e5999fdef70$var$updateInstance(child);
            $62815e5999fdef70$var$invalidateInstance(child);
        }
    }
    function removeRecursive(array, parent, dispose = false) {
        if (array) [
            ...array
        ].forEach((child)=>removeChild(parent, child, dispose));
    }
    function removeChild(parentInstance, child, dispose) {
        if (child) {
            var _parentInstance$__r3f3, _child$__r3f3, _child$__r3f5;
            // Clear the parent reference
            if (child.__r3f) child.__r3f.parent = null;
            // Remove child from the parents objects
            if ((_parentInstance$__r3f3 = parentInstance.__r3f) != null && _parentInstance$__r3f3.objects) parentInstance.__r3f.objects = parentInstance.__r3f.objects.filter((x)=>x !== child);
            // Remove attachment
            if ((_child$__r3f3 = child.__r3f) != null && _child$__r3f3.attach) $62815e5999fdef70$var$detach(parentInstance, child, child.__r3f.attach);
            else if (child.isObject3D && parentInstance.isObject3D) {
                var _child$__r3f4;
                parentInstance.remove(child);
                // @ts-expect-error
                // Remove interactivity on the initial root
                if ((_child$__r3f4 = child.__r3f) != null && _child$__r3f4.root) $62815e5999fdef70$var$removeInteractivity($62815e5999fdef70$var$findInitialRoot(child), child);
            }
            // Allow objects to bail out of recursive dispose altogether by passing dispose={null}
            // Never dispose of primitives because their state may be kept outside of React!
            // In order for an object to be able to dispose it has to have
            //   - a dispose method,
            //   - it cannot be a <primitive object={...} />
            //   - it cannot be a THREE.Scene, because three has broken it's own api
            //
            // Since disposal is recursive, we can check the optional dispose arg, which will be undefined
            // when the reconciler calls it, but then carry our own check recursively
            const isPrimitive = (_child$__r3f5 = child.__r3f) == null ? void 0 : _child$__r3f5.primitive;
            const shouldDispose = !isPrimitive && (dispose === undefined ? child.dispose !== null : dispose);
            // Remove nested child objects. Primitives should not have objects and children that are
            // attached to them declaratively ...
            if (!isPrimitive) {
                var _child$__r3f6;
                removeRecursive((_child$__r3f6 = child.__r3f) == null ? void 0 : _child$__r3f6.objects, child, shouldDispose);
                removeRecursive(child.children, child, shouldDispose);
            }
            // Remove references
            delete child.__r3f;
            // Dispose item whenever the reconciler feels like it
            if (shouldDispose && child.dispose && child.type !== 'Scene') {
                const callback = ()=>{
                    try {
                        child.dispose();
                    } catch (e) {
                    /* ... */ }
                };
                // Schedule async at runtime, flush sync in testing
                if (typeof IS_REACT_ACT_ENVIRONMENT === 'undefined') (0, $bdSvy.unstable_scheduleCallback)((0, $bdSvy.unstable_IdlePriority), callback);
                else callback();
            }
            $62815e5999fdef70$var$invalidateInstance(parentInstance);
        }
    }
    function switchInstance(instance, type, newProps, fiber) {
        var _instance$__r3f;
        const parent = (_instance$__r3f = instance.__r3f) == null ? void 0 : _instance$__r3f.parent;
        if (!parent) return;
        const newInstance = createInstance(type, newProps, instance.__r3f.root);
        // https://github.com/pmndrs/react-three-fiber/issues/1348
        // When args change the instance has to be re-constructed, which then
        // forces r3f to re-parent the children and non-scene objects
        if (instance.children) {
            for (const child of instance.children)if (child.__r3f) appendChild(newInstance, child);
            instance.children = instance.children.filter((child)=>!child.__r3f);
        }
        instance.__r3f.objects.forEach((child)=>appendChild(newInstance, child));
        instance.__r3f.objects = [];
        if (!instance.__r3f.autoRemovedBeforeAppend) removeChild(parent, instance);
        if (newInstance.parent) newInstance.__r3f.autoRemovedBeforeAppend = true;
        appendChild(parent, newInstance);
        // Re-bind event handlers on the initial root
        if (newInstance.raycast && newInstance.__r3f.eventCount) {
            const rootState = $62815e5999fdef70$var$findInitialRoot(newInstance).getState();
            rootState.internal.interaction.push(newInstance);
        }
        [
            fiber,
            fiber.alternate
        ].forEach((fiber)=>{
            if (fiber !== null) {
                fiber.stateNode = newInstance;
                if (fiber.ref) {
                    if (typeof fiber.ref === 'function') fiber.ref(newInstance);
                    else fiber.ref.current = newInstance;
                }
            }
        });
    }
    // Don't handle text instances, make it no-op
    const handleTextInstance = ()=>{};
    const reconciler = (0, (/*@__PURE__*/$parcel$interopDefault($3672f90649f8b6c2$exports)))({
        createInstance: createInstance,
        removeChild: removeChild,
        appendChild: appendChild,
        appendInitialChild: appendChild,
        insertBefore: insertBefore,
        supportsMutation: true,
        isPrimaryRenderer: false,
        supportsPersistence: false,
        supportsHydration: false,
        noTimeout: -1,
        appendChildToContainer: (container, child)=>{
            if (!child) return;
            // Don't append to unmounted container
            const scene = container.getState().scene;
            if (!scene.__r3f) return;
            // Link current root to the default scene
            scene.__r3f.root = container;
            appendChild(scene, child);
        },
        removeChildFromContainer: (container, child)=>{
            if (!child) return;
            removeChild(container.getState().scene, child);
        },
        insertInContainerBefore: (container, child, beforeChild)=>{
            if (!child || !beforeChild) return;
            // Don't append to unmounted container
            const scene = container.getState().scene;
            if (!scene.__r3f) return;
            insertBefore(scene, child, beforeChild);
        },
        getRootHostContext: ()=>null,
        getChildHostContext: (parentHostContext)=>parentHostContext,
        finalizeInitialChildren (instance) {
            var _instance$__r3f2;
            const localState = (_instance$__r3f2 = instance == null ? void 0 : instance.__r3f) != null ? _instance$__r3f2 : {};
            // https://github.com/facebook/react/issues/20271
            // Returning true will trigger commitMount
            return Boolean(localState.handlers);
        },
        prepareUpdate (instance, _type, oldProps, newProps) {
            var _instance$__r3f3;
            const localState = (_instance$__r3f3 = instance == null ? void 0 : instance.__r3f) != null ? _instance$__r3f3 : {};
            // Create diff-sets
            if (localState.primitive && newProps.object && newProps.object !== instance) return [
                true
            ];
            else {
                // This is a data object, let's extract critical information about it
                const { args: argsNew = [], children: cN, ...restNew } = newProps;
                const { args: argsOld = [], children: cO, ...restOld } = oldProps;
                // Throw if an object or literal was passed for args
                if (!Array.isArray(argsNew)) throw new Error('R3F: the args prop must be an array!');
                // If it has new props or arguments, then it needs to be re-instantiated
                if (argsNew.some((value, index)=>value !== argsOld[index])) return [
                    true
                ];
                // Create a diff-set, flag if there are any changes
                const diff = $62815e5999fdef70$var$diffProps(instance, restNew, restOld, true);
                if (diff.changes.length) return [
                    false,
                    diff
                ];
                // Otherwise do not touch the instance
                return null;
            }
        },
        commitUpdate (instance, [reconstruct, diff], type, _oldProps, newProps, fiber) {
            // Reconstruct when args or <primitive object={...} have changes
            if (reconstruct) switchInstance(instance, type, newProps, fiber);
            else $62815e5999fdef70$var$applyProps$1(instance, diff);
        },
        commitMount (instance, _type, _props, _int) {
            var _instance$__r3f4;
            // https://github.com/facebook/react/issues/20271
            // This will make sure events are only added once to the central container on the initial root
            const localState = (_instance$__r3f4 = instance.__r3f) != null ? _instance$__r3f4 : {};
            if (instance.raycast && localState.handlers && localState.eventCount) $62815e5999fdef70$var$findInitialRoot(instance).getState().internal.interaction.push(instance);
        },
        getPublicInstance: (instance)=>instance,
        prepareForCommit: ()=>null,
        preparePortalMount: (container)=>$62815e5999fdef70$var$prepare(container.getState().scene),
        resetAfterCommit: ()=>{},
        shouldSetTextContent: ()=>false,
        clearContainer: ()=>false,
        hideInstance (instance) {
            var _instance$__r3f5;
            // Detach while the instance is hidden
            const { attach: type, parent: parent } = (_instance$__r3f5 = instance.__r3f) != null ? _instance$__r3f5 : {};
            if (type && parent) $62815e5999fdef70$var$detach(parent, instance, type);
            if (instance.isObject3D) instance.visible = false;
            $62815e5999fdef70$var$invalidateInstance(instance);
        },
        unhideInstance (instance, props) {
            var _instance$__r3f6;
            // Re-attach when the instance is unhidden
            const { attach: type, parent: parent } = (_instance$__r3f6 = instance.__r3f) != null ? _instance$__r3f6 : {};
            if (type && parent) $62815e5999fdef70$var$attach(parent, instance, type);
            if (instance.isObject3D && props.visible == null || props.visible) instance.visible = true;
            $62815e5999fdef70$var$invalidateInstance(instance);
        },
        createTextInstance: handleTextInstance,
        hideTextInstance: handleTextInstance,
        unhideTextInstance: handleTextInstance,
        // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r916356874
        // @ts-expect-error
        getCurrentEventPriority: ()=>_getEventPriority ? _getEventPriority() : (0, $eeb07fcb2b6a118a$exports.DefaultEventPriority),
        beforeActiveInstanceBlur: ()=>{},
        afterActiveInstanceBlur: ()=>{},
        detachDeletedInstance: ()=>{},
        now: typeof performance !== 'undefined' && $62815e5999fdef70$var$is.fun(performance.now) ? performance.now : $62815e5999fdef70$var$is.fun(Date.now) ? Date.now : ()=>0,
        // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r920883503
        scheduleTimeout: $62815e5999fdef70$var$is.fun(setTimeout) ? setTimeout : undefined,
        cancelTimeout: $62815e5999fdef70$var$is.fun(clearTimeout) ? clearTimeout : undefined
    });
    return {
        reconciler: reconciler,
        applyProps: $62815e5999fdef70$var$applyProps$1
    };
}
var $62815e5999fdef70$var$_window$document, $62815e5999fdef70$var$_window$navigator;
/**
 * Returns `true` with correct TS type inference if an object has a configurable color space (since r152).
 */ const $62815e5999fdef70$var$hasColorSpace = (object)=>'colorSpace' in object || 'outputColorSpace' in object;
/**
 * The current THREE.ColorManagement instance, if present.
 */ const $62815e5999fdef70$var$getColorManagement = ()=>{
    var _ColorManagement;
    return (_ColorManagement = $62815e5999fdef70$var$catalogue.ColorManagement) != null ? _ColorManagement : null;
};
const $62815e5999fdef70$var$isOrthographicCamera = (def)=>def && def.isOrthographicCamera;
const $62815e5999fdef70$export$23f2a1d2818174ef = (obj)=>obj && obj.hasOwnProperty('current');
/**
 * An SSR-friendly useLayoutEffect.
 *
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect elsewhere.
 *
 * @see https://github.com/facebook/react/issues/14927
 */ const $62815e5999fdef70$export$407448d2b89b1813 = typeof window !== 'undefined' && (($62815e5999fdef70$var$_window$document = window.document) != null && $62815e5999fdef70$var$_window$document.createElement || (($62815e5999fdef70$var$_window$navigator = window.navigator) == null ? void 0 : $62815e5999fdef70$var$_window$navigator.product) === 'ReactNative') ? $aqdBs.useLayoutEffect : $aqdBs.useEffect;
function $62815e5999fdef70$export$3b14a55fb2447963(fn) {
    const ref = $aqdBs.useRef(fn);
    $62815e5999fdef70$export$407448d2b89b1813(()=>void (ref.current = fn), [
        fn
    ]);
    return ref;
}
function $62815e5999fdef70$export$ef35774e6d314e91({ set: set }) {
    $62815e5999fdef70$export$407448d2b89b1813(()=>{
        set(new Promise(()=>null));
        return ()=>set(false);
    }, [
        set
    ]);
    return null;
}
class $62815e5999fdef70$export$a9c23c6ac3fc3eca extends $aqdBs.Component {
    constructor(...args){
        super(...args);
        this.state = {
            error: false
        };
    }
    componentDidCatch(err) {
        this.props.set(err);
    }
    render() {
        return this.state.error ? null : this.props.children;
    }
}
$62815e5999fdef70$export$a9c23c6ac3fc3eca.getDerivedStateFromError = ()=>({
        error: true
    });
const $62815e5999fdef70$var$DEFAULT = '__default';
const $62815e5999fdef70$var$DEFAULTS = new Map();
const $62815e5999fdef70$var$isDiffSet = (def)=>def && !!def.memoized && !!def.changes;
function $62815e5999fdef70$var$calculateDpr(dpr) {
    var _window$devicePixelRa;
    // Err on the side of progress by assuming 2x dpr if we can't detect it
    // This will happen in workers where window is defined but dpr isn't.
    const target = typeof window !== 'undefined' ? (_window$devicePixelRa = window.devicePixelRatio) != null ? _window$devicePixelRa : 2 : 1;
    return Array.isArray(dpr) ? Math.min(Math.max(dpr[0], target), dpr[1]) : dpr;
}
/**
 * Returns instance root state
 */ const $62815e5999fdef70$export$efccba1c4a2ef57b = (obj)=>{
    var _r3f;
    return (_r3f = obj.__r3f) == null ? void 0 : _r3f.root.getState();
};
/**
 * Returns the instances initial (outmost) root
 */ function $62815e5999fdef70$var$findInitialRoot(child) {
    let root = child.__r3f.root;
    while(root.getState().previousRoot)root = root.getState().previousRoot;
    return root;
}
// A collection of compare functions
const $62815e5999fdef70$var$is = {
    obj: (a)=>a === Object(a) && !$62815e5999fdef70$var$is.arr(a) && typeof a !== 'function',
    fun: (a)=>typeof a === 'function',
    str: (a)=>typeof a === 'string',
    num: (a)=>typeof a === 'number',
    boo: (a)=>typeof a === 'boolean',
    und: (a)=>a === void 0,
    arr: (a)=>Array.isArray(a),
    equ (a, b, { arrays: arrays = 'shallow', objects: objects = 'reference', strict: strict = true } = {}) {
        // Wrong type or one of the two undefined, doesn't match
        if (typeof a !== typeof b || !!a !== !!b) return false;
        // Atomic, just compare a against b
        if ($62815e5999fdef70$var$is.str(a) || $62815e5999fdef70$var$is.num(a) || $62815e5999fdef70$var$is.boo(a)) return a === b;
        const isObj = $62815e5999fdef70$var$is.obj(a);
        if (isObj && objects === 'reference') return a === b;
        const isArr = $62815e5999fdef70$var$is.arr(a);
        if (isArr && arrays === 'reference') return a === b;
        // Array or Object, shallow compare first to see if it's a match
        if ((isArr || isObj) && a === b) return true;
        // Last resort, go through keys
        let i;
        // Check if a has all the keys of b
        for(i in a)if (!(i in b)) return false;
        // Check if values between keys match
        if (isObj && arrays === 'shallow' && objects === 'shallow') {
            for(i in strict ? b : a)if (!$62815e5999fdef70$var$is.equ(a[i], b[i], {
                strict: strict,
                objects: 'reference'
            })) return false;
        } else {
            for(i in strict ? b : a)if (a[i] !== b[i]) return false;
        }
        // If i is undefined
        if ($62815e5999fdef70$var$is.und(i)) {
            // If both arrays are empty we consider them equal
            if (isArr && a.length === 0 && b.length === 0) return true;
            // If both objects are empty we consider them equal
            if (isObj && Object.keys(a).length === 0 && Object.keys(b).length === 0) return true;
            // Otherwise match them by value
            if (a !== b) return false;
        }
        return true;
    }
};
/**
 * Collects nodes and materials from a THREE.Object3D.
 */ function $62815e5999fdef70$export$4a5767248b18ef41(object) {
    const data = {
        nodes: {},
        materials: {}
    };
    if (object) object.traverse((obj)=>{
        if (obj.name) data.nodes[obj.name] = obj;
        if (obj.material && !data.materials[obj.material.name]) data.materials[obj.material.name] = obj.material;
    });
    return data;
}
// Disposes an object and all its properties
function $62815e5999fdef70$export$882b5998b3b9117c(obj) {
    if (obj.dispose && obj.type !== 'Scene') obj.dispose();
    for(const p in obj){
        p.dispose == null || p.dispose();
        delete obj[p];
    }
}
// Each object in the scene carries a small LocalState descriptor
function $62815e5999fdef70$var$prepare(object, state) {
    const instance = object;
    instance.__r3f = {
        type: '',
        root: null,
        previousAttach: null,
        memoizedProps: {},
        eventCount: 0,
        handlers: {},
        objects: [],
        parent: null,
        ...state
    };
    return object;
}
function $62815e5999fdef70$var$resolve(instance, key) {
    let target = instance;
    if (key.includes('-')) {
        const entries = key.split('-');
        const last = entries.pop();
        target = entries.reduce((acc, key)=>acc[key], instance);
        return {
            target: target,
            key: last
        };
    } else return {
        target: target,
        key: key
    };
}
// Checks if a dash-cased string ends with an integer
const $62815e5999fdef70$var$INDEX_REGEX = /-\d+$/;
function $62815e5999fdef70$var$attach(parent, child, type) {
    if ($62815e5999fdef70$var$is.str(type)) {
        // If attaching into an array (foo-0), create one
        if ($62815e5999fdef70$var$INDEX_REGEX.test(type)) {
            const root = type.replace($62815e5999fdef70$var$INDEX_REGEX, '');
            const { target: target, key: key } = $62815e5999fdef70$var$resolve(parent, root);
            if (!Array.isArray(target[key])) target[key] = [];
        }
        const { target: target, key: key } = $62815e5999fdef70$var$resolve(parent, type);
        child.__r3f.previousAttach = target[key];
        target[key] = child;
    } else child.__r3f.previousAttach = type(parent, child);
}
function $62815e5999fdef70$var$detach(parent, child, type) {
    var _child$__r3f, _child$__r3f2;
    if ($62815e5999fdef70$var$is.str(type)) {
        const { target: target, key: key } = $62815e5999fdef70$var$resolve(parent, type);
        const previous = child.__r3f.previousAttach;
        // When the previous value was undefined, it means the value was never set to begin with
        if (previous === undefined) delete target[key];
        else target[key] = previous;
    } else (_child$__r3f = child.__r3f) == null || _child$__r3f.previousAttach == null || _child$__r3f.previousAttach(parent, child);
    (_child$__r3f2 = child.__r3f) == null || delete _child$__r3f2.previousAttach;
}
// This function prepares a set of changes to be applied to the instance
function $62815e5999fdef70$var$diffProps(instance, { children: cN, key: kN, ref: rN, ...props }, { children: cP, key: kP, ref: rP, ...previous } = {}, remove = false) {
    const localState = instance.__r3f;
    const entries = Object.entries(props);
    const changes = [];
    // Catch removed props, prepend them so they can be reset or removed
    if (remove) {
        const previousKeys = Object.keys(previous);
        for(let i = 0; i < previousKeys.length; i++)if (!props.hasOwnProperty(previousKeys[i])) entries.unshift([
            previousKeys[i],
            $62815e5999fdef70$var$DEFAULT + 'remove'
        ]);
    }
    entries.forEach(([key, value])=>{
        var _instance$__r3f;
        // Bail out on primitive object
        if ((_instance$__r3f = instance.__r3f) != null && _instance$__r3f.primitive && key === 'object') return;
        // When props match bail out
        if ($62815e5999fdef70$var$is.equ(value, previous[key])) return;
        // Collect handlers and bail out
        if (/^on(Pointer|Click|DoubleClick|ContextMenu|Wheel)/.test(key)) return changes.push([
            key,
            value,
            true,
            []
        ]);
        // Split dashed props
        let entries = [];
        if (key.includes('-')) entries = key.split('-');
        changes.push([
            key,
            value,
            false,
            entries
        ]);
        // Reset pierced props
        for(const prop in props){
            const value = props[prop];
            if (prop.startsWith(`${key}-`)) changes.push([
                prop,
                value,
                false,
                prop.split('-')
            ]);
        }
    });
    const memoized = {
        ...props
    };
    if (localState != null && localState.memoizedProps && localState != null && localState.memoizedProps.args) memoized.args = localState.memoizedProps.args;
    if (localState != null && localState.memoizedProps && localState != null && localState.memoizedProps.attach) memoized.attach = localState.memoizedProps.attach;
    return {
        memoized: memoized,
        changes: changes
    };
}
const $62815e5999fdef70$var$__DEV__ = false;
// This function applies a set of changes to the instance
function $62815e5999fdef70$var$applyProps$1(instance, data) {
    var _instance$__r3f2;
    // Filter equals, events and reserved props
    const localState = instance.__r3f;
    const root = localState == null ? void 0 : localState.root;
    const rootState = root == null ? void 0 : root.getState == null ? void 0 : root.getState();
    const { memoized: memoized, changes: changes } = $62815e5999fdef70$var$isDiffSet(data) ? data : $62815e5999fdef70$var$diffProps(instance, data);
    const prevHandlers = localState == null ? void 0 : localState.eventCount;
    // Prepare memoized props
    if (instance.__r3f) instance.__r3f.memoizedProps = memoized;
    for(let i = 0; i < changes.length; i++){
        let [key, value, isEvent, keys] = changes[i];
        // Alias (output)encoding => (output)colorSpace (since r152)
        // https://github.com/pmndrs/react-three-fiber/pull/2829
        if ($62815e5999fdef70$var$hasColorSpace(instance)) {
            const sRGBEncoding = 3001;
            const SRGBColorSpace = 'srgb';
            const LinearSRGBColorSpace = 'srgb-linear';
            if (key === 'encoding') {
                key = 'colorSpace';
                value = value === sRGBEncoding ? SRGBColorSpace : LinearSRGBColorSpace;
            } else if (key === 'outputEncoding') {
                key = 'outputColorSpace';
                value = value === sRGBEncoding ? SRGBColorSpace : LinearSRGBColorSpace;
            }
        }
        let currentInstance = instance;
        let targetProp = currentInstance[key];
        // Revolve dashed props
        if (keys.length) {
            targetProp = keys.reduce((acc, key)=>acc[key], instance);
            // If the target is atomic, it forces us to switch the root
            if (!(targetProp && targetProp.set)) {
                const [name, ...reverseEntries] = keys.reverse();
                currentInstance = reverseEntries.reverse().reduce((acc, key)=>acc[key], instance);
                key = name;
            }
        }
        // https://github.com/mrdoob/three.js/issues/21209
        // HMR/fast-refresh relies on the ability to cancel out props, but threejs
        // has no means to do this. Hence we curate a small collection of value-classes
        // with their respective constructor/set arguments
        // For removed props, try to set default values, if possible
        if (value === $62815e5999fdef70$var$DEFAULT + 'remove') {
            if (currentInstance.constructor) {
                // create a blank slate of the instance and copy the particular parameter.
                let ctor = $62815e5999fdef70$var$DEFAULTS.get(currentInstance.constructor);
                if (!ctor) {
                    // @ts-expect-error
                    ctor = new currentInstance.constructor();
                    $62815e5999fdef70$var$DEFAULTS.set(currentInstance.constructor, ctor);
                }
                value = ctor[key];
            } else // instance does not have constructor, just set it to 0
            value = 0;
        }
        // Deal with pointer events ...
        if (isEvent && localState) {
            if (value) localState.handlers[key] = value;
            else delete localState.handlers[key];
            localState.eventCount = Object.keys(localState.handlers).length;
        } else if (targetProp && targetProp.set && (targetProp.copy || targetProp instanceof $548f161e17fc6f48$export$89312ce47c0ca777)) {
            // If value is an array
            if (Array.isArray(value)) {
                if (targetProp.fromArray) targetProp.fromArray(value);
                else targetProp.set(...value);
            } else if (targetProp.copy && value && value.constructor && // Some environments may break strict identity checks by duplicating versions of three.js.
            // Loosen to unminified names, ignoring descendents.
            // https://github.com/pmndrs/react-three-fiber/issues/2856
            // TODO: fix upstream and remove in v9
            ($62815e5999fdef70$var$__DEV__ ? targetProp.constructor.name === value.constructor.name : targetProp.constructor === value.constructor)) targetProp.copy(value);
            else if (value !== undefined) {
                var _targetProp;
                const isColor = (_targetProp = targetProp) == null ? void 0 : _targetProp.isColor;
                // Allow setting array scalars
                if (!isColor && targetProp.setScalar) targetProp.setScalar(value);
                else if (targetProp instanceof $548f161e17fc6f48$export$89312ce47c0ca777 && value instanceof $548f161e17fc6f48$export$89312ce47c0ca777) targetProp.mask = value.mask;
                else targetProp.set(value);
                // For versions of three which don't support THREE.ColorManagement,
                // Auto-convert sRGB colors
                // https://github.com/pmndrs/react-three-fiber/issues/344
                if (!$62815e5999fdef70$var$getColorManagement() && rootState && !rootState.linear && isColor) targetProp.convertSRGBToLinear();
            }
        // Else, just overwrite the value
        } else {
            var _currentInstance$key;
            currentInstance[key] = value;
            // Auto-convert sRGB textures, for now ...
            // https://github.com/pmndrs/react-three-fiber/issues/344
            if ((_currentInstance$key = currentInstance[key]) != null && _currentInstance$key.isTexture && // sRGB textures must be RGBA8 since r137 https://github.com/mrdoob/three.js/pull/23129
            currentInstance[key].format === $548f161e17fc6f48$export$3f8bb04b555a363c && currentInstance[key].type === $548f161e17fc6f48$export$2e8ce08d3f6f5e10 && rootState) {
                const texture = currentInstance[key];
                if ($62815e5999fdef70$var$hasColorSpace(texture) && $62815e5999fdef70$var$hasColorSpace(rootState.gl)) texture.colorSpace = rootState.gl.outputColorSpace;
                else texture.encoding = rootState.gl.outputEncoding;
            }
        }
        $62815e5999fdef70$var$invalidateInstance(instance);
    }
    if (localState && localState.parent && instance.raycast && prevHandlers !== localState.eventCount) {
        // Get the initial root state's internals
        const internal = $62815e5999fdef70$var$findInitialRoot(instance).getState().internal;
        // Pre-emptively remove the instance from the interaction manager
        const index = internal.interaction.indexOf(instance);
        if (index > -1) internal.interaction.splice(index, 1);
        // Add the instance to the interaction manager only when it has handlers
        if (localState.eventCount) internal.interaction.push(instance);
    }
    // Call the update lifecycle when it is being updated, but only when it is part of the scene.
    // Skip updates to the `onUpdate` prop itself
    const isCircular = changes.length === 1 && changes[0][0] === 'onUpdate';
    if (!isCircular && changes.length && (_instance$__r3f2 = instance.__r3f) != null && _instance$__r3f2.parent) $62815e5999fdef70$var$updateInstance(instance);
    return instance;
}
function $62815e5999fdef70$var$invalidateInstance(instance) {
    var _instance$__r3f3, _instance$__r3f3$root;
    const state = (_instance$__r3f3 = instance.__r3f) == null ? void 0 : (_instance$__r3f3$root = _instance$__r3f3.root) == null ? void 0 : _instance$__r3f3$root.getState == null ? void 0 : _instance$__r3f3$root.getState();
    if (state && state.internal.frames === 0) state.invalidate();
}
function $62815e5999fdef70$var$updateInstance(instance) {
    instance.onUpdate == null || instance.onUpdate(instance);
}
function $62815e5999fdef70$var$updateCamera(camera, size) {
    // https://github.com/pmndrs/react-three-fiber/issues/92
    // Do not mess with the camera if it belongs to the user
    if (!camera.manual) {
        if ($62815e5999fdef70$var$isOrthographicCamera(camera)) {
            camera.left = size.width / -2;
            camera.right = size.width / 2;
            camera.top = size.height / 2;
            camera.bottom = size.height / -2;
        } else camera.aspect = size.width / size.height;
        camera.updateProjectionMatrix();
        // https://github.com/pmndrs/react-three-fiber/issues/178
        // Update matrix world since the renderer is a frame late
        camera.updateMatrixWorld();
    }
}
function $62815e5999fdef70$var$makeId(event) {
    return (event.eventObject || event.object).uuid + '/' + event.index + event.instanceId;
}
// https://github.com/facebook/react/tree/main/packages/react-reconciler#getcurrenteventpriority
// Gives React a clue as to how import the current interaction is
function $62815e5999fdef70$var$getEventPriority() {
    var _globalScope$event;
    // Get a handle to the current global scope in window and worker contexts if able
    // https://github.com/pmndrs/react-three-fiber/pull/2493
    const globalScope = typeof self !== 'undefined' && self || typeof window !== 'undefined' && window;
    if (!globalScope) return 0, $eeb07fcb2b6a118a$exports.DefaultEventPriority;
    const name = (_globalScope$event = globalScope.event) == null ? void 0 : _globalScope$event.type;
    switch(name){
        case 'click':
        case 'contextmenu':
        case 'dblclick':
        case 'pointercancel':
        case 'pointerdown':
        case 'pointerup':
            return 0, $eeb07fcb2b6a118a$exports.DiscreteEventPriority;
        case 'pointermove':
        case 'pointerout':
        case 'pointerover':
        case 'pointerenter':
        case 'pointerleave':
        case 'wheel':
            return 0, $eeb07fcb2b6a118a$exports.ContinuousEventPriority;
        default:
            return 0, $eeb07fcb2b6a118a$exports.DefaultEventPriority;
    }
}
/**
 * Release pointer captures.
 * This is called by releasePointerCapture in the API, and when an object is removed.
 */ function $62815e5999fdef70$var$releaseInternalPointerCapture(capturedMap, obj, captures, pointerId) {
    const captureData = captures.get(obj);
    if (captureData) {
        captures.delete(obj);
        // If this was the last capturing object for this pointer
        if (captures.size === 0) {
            capturedMap.delete(pointerId);
            captureData.target.releasePointerCapture(pointerId);
        }
    }
}
function $62815e5999fdef70$var$removeInteractivity(store, object) {
    const { internal: internal } = store.getState();
    // Removes every trace of an object from the data store
    internal.interaction = internal.interaction.filter((o)=>o !== object);
    internal.initialHits = internal.initialHits.filter((o)=>o !== object);
    internal.hovered.forEach((value, key)=>{
        if (value.eventObject === object || value.object === object) // Clear out intersects, they are outdated by now
        internal.hovered.delete(key);
    });
    internal.capturedMap.forEach((captures, pointerId)=>{
        $62815e5999fdef70$var$releaseInternalPointerCapture(internal.capturedMap, object, captures, pointerId);
    });
}
function $62815e5999fdef70$export$2d1720544b23b823(store) {
    /** Calculates delta */ function calculateDistance(event) {
        const { internal: internal } = store.getState();
        const dx = event.offsetX - internal.initialClick[0];
        const dy = event.offsetY - internal.initialClick[1];
        return Math.round(Math.sqrt(dx * dx + dy * dy));
    }
    /** Returns true if an instance has a valid pointer-event registered, this excludes scroll, clicks etc */ function filterPointerEvents(objects) {
        return objects.filter((obj)=>[
                'Move',
                'Over',
                'Enter',
                'Out',
                'Leave'
            ].some((name)=>{
                var _r3f;
                return (_r3f = obj.__r3f) == null ? void 0 : _r3f.handlers['onPointer' + name];
            }));
    }
    function intersect(event, filter) {
        const state = store.getState();
        const duplicates = new Set();
        const intersections = [];
        // Allow callers to eliminate event objects
        const eventsObjects = filter ? filter(state.internal.interaction) : state.internal.interaction;
        // Reset all raycaster cameras to undefined
        for(let i = 0; i < eventsObjects.length; i++){
            const state = $62815e5999fdef70$export$efccba1c4a2ef57b(eventsObjects[i]);
            if (state) state.raycaster.camera = undefined;
        }
        if (!state.previousRoot) // Make sure root-level pointer and ray are set up
        state.events.compute == null || state.events.compute(event, state);
        function handleRaycast(obj) {
            const state = $62815e5999fdef70$export$efccba1c4a2ef57b(obj);
            // Skip event handling when noEvents is set, or when the raycasters camera is null
            if (!state || !state.events.enabled || state.raycaster.camera === null) return [];
            // When the camera is undefined we have to call the event layers update function
            if (state.raycaster.camera === undefined) {
                var _state$previousRoot;
                state.events.compute == null || state.events.compute(event, state, (_state$previousRoot = state.previousRoot) == null ? void 0 : _state$previousRoot.getState());
                // If the camera is still undefined we have to skip this layer entirely
                if (state.raycaster.camera === undefined) state.raycaster.camera = null;
            }
            // Intersect object by object
            return state.raycaster.camera ? state.raycaster.intersectObject(obj, true) : [];
        }
        // Collect events
        let hits = eventsObjects// Intersect objects
        .flatMap(handleRaycast)// Sort by event priority and distance
        .sort((a, b)=>{
            const aState = $62815e5999fdef70$export$efccba1c4a2ef57b(a.object);
            const bState = $62815e5999fdef70$export$efccba1c4a2ef57b(b.object);
            if (!aState || !bState) return a.distance - b.distance;
            return bState.events.priority - aState.events.priority || a.distance - b.distance;
        })// Filter out duplicates
        .filter((item)=>{
            const id = $62815e5999fdef70$var$makeId(item);
            if (duplicates.has(id)) return false;
            duplicates.add(id);
            return true;
        });
        // https://github.com/mrdoob/three.js/issues/16031
        // Allow custom userland intersect sort order, this likely only makes sense on the root filter
        if (state.events.filter) hits = state.events.filter(hits, state);
        // Bubble up the events, find the event source (eventObject)
        for (const hit of hits){
            let eventObject = hit.object;
            // Bubble event up
            while(eventObject){
                var _r3f2;
                if ((_r3f2 = eventObject.__r3f) != null && _r3f2.eventCount) intersections.push({
                    ...hit,
                    eventObject: eventObject
                });
                eventObject = eventObject.parent;
            }
        }
        // If the interaction is captured, make all capturing targets part of the intersect.
        if ('pointerId' in event && state.internal.capturedMap.has(event.pointerId)) {
            for (let captureData of state.internal.capturedMap.get(event.pointerId).values())if (!duplicates.has($62815e5999fdef70$var$makeId(captureData.intersection))) intersections.push(captureData.intersection);
        }
        return intersections;
    }
    /**  Handles intersections by forwarding them to handlers */ function handleIntersects(intersections, event, delta, callback) {
        const rootState = store.getState();
        // If anything has been found, forward it to the event listeners
        if (intersections.length) {
            const localState = {
                stopped: false
            };
            for (const hit of intersections){
                const state = $62815e5999fdef70$export$efccba1c4a2ef57b(hit.object) || rootState;
                const { raycaster: raycaster, pointer: pointer, camera: camera, internal: internal } = state;
                const unprojectedPoint = new $548f161e17fc6f48$export$64b5c384219d3699(pointer.x, pointer.y, 0).unproject(camera);
                const hasPointerCapture = (id)=>{
                    var _internal$capturedMap, _internal$capturedMap2;
                    return (_internal$capturedMap = (_internal$capturedMap2 = internal.capturedMap.get(id)) == null ? void 0 : _internal$capturedMap2.has(hit.eventObject)) != null ? _internal$capturedMap : false;
                };
                const setPointerCapture = (id)=>{
                    const captureData = {
                        intersection: hit,
                        target: event.target
                    };
                    if (internal.capturedMap.has(id)) // if the pointerId was previously captured, we add the hit to the
                    // event capturedMap.
                    internal.capturedMap.get(id).set(hit.eventObject, captureData);
                    else // if the pointerId was not previously captured, we create a map
                    // containing the hitObject, and the hit. hitObject is used for
                    // faster access.
                    internal.capturedMap.set(id, new Map([
                        [
                            hit.eventObject,
                            captureData
                        ]
                    ]));
                    event.target.setPointerCapture(id);
                };
                const releasePointerCapture = (id)=>{
                    const captures = internal.capturedMap.get(id);
                    if (captures) $62815e5999fdef70$var$releaseInternalPointerCapture(internal.capturedMap, hit.eventObject, captures, id);
                };
                // Add native event props
                let extractEventProps = {};
                // This iterates over the event's properties including the inherited ones. Native PointerEvents have most of their props as getters which are inherited, but polyfilled PointerEvents have them all as their own properties (i.e. not inherited). We can't use Object.keys() or Object.entries() as they only return "own" properties; nor Object.getPrototypeOf(event) as that *doesn't* return "own" properties, only inherited ones.
                for(let prop in event){
                    let property = event[prop];
                    // Only copy over atomics, leave functions alone as these should be
                    // called as event.nativeEvent.fn()
                    if (typeof property !== 'function') extractEventProps[prop] = property;
                }
                let raycastEvent = {
                    ...hit,
                    ...extractEventProps,
                    pointer: pointer,
                    intersections: intersections,
                    stopped: localState.stopped,
                    delta: delta,
                    unprojectedPoint: unprojectedPoint,
                    ray: raycaster.ray,
                    camera: camera,
                    // Hijack stopPropagation, which just sets a flag
                    stopPropagation () {
                        // https://github.com/pmndrs/react-three-fiber/issues/596
                        // Events are not allowed to stop propagation if the pointer has been captured
                        const capturesForPointer = 'pointerId' in event && internal.capturedMap.get(event.pointerId);
                        // We only authorize stopPropagation...
                        if (// ...if this pointer hasn't been captured
                        !capturesForPointer || // ... or if the hit object is capturing the pointer
                        capturesForPointer.has(hit.eventObject)) {
                            raycastEvent.stopped = localState.stopped = true;
                            // Propagation is stopped, remove all other hover records
                            // An event handler is only allowed to flush other handlers if it is hovered itself
                            if (internal.hovered.size && Array.from(internal.hovered.values()).find((i)=>i.eventObject === hit.eventObject)) {
                                // Objects cannot flush out higher up objects that have already caught the event
                                const higher = intersections.slice(0, intersections.indexOf(hit));
                                cancelPointer([
                                    ...higher,
                                    hit
                                ]);
                            }
                        }
                    },
                    // there should be a distinction between target and currentTarget
                    target: {
                        hasPointerCapture: hasPointerCapture,
                        setPointerCapture: setPointerCapture,
                        releasePointerCapture: releasePointerCapture
                    },
                    currentTarget: {
                        hasPointerCapture: hasPointerCapture,
                        setPointerCapture: setPointerCapture,
                        releasePointerCapture: releasePointerCapture
                    },
                    nativeEvent: event
                };
                // Call subscribers
                callback(raycastEvent);
                // Event bubbling may be interrupted by stopPropagation
                if (localState.stopped === true) break;
            }
        }
        return intersections;
    }
    function cancelPointer(intersections) {
        const { internal: internal } = store.getState();
        for (const hoveredObj of internal.hovered.values())// When no objects were hit or the the hovered object wasn't found underneath the cursor
        // we call onPointerOut and delete the object from the hovered-elements map
        if (!intersections.length || !intersections.find((hit)=>hit.object === hoveredObj.object && hit.index === hoveredObj.index && hit.instanceId === hoveredObj.instanceId)) {
            const eventObject = hoveredObj.eventObject;
            const instance = eventObject.__r3f;
            const handlers = instance == null ? void 0 : instance.handlers;
            internal.hovered.delete($62815e5999fdef70$var$makeId(hoveredObj));
            if (instance != null && instance.eventCount) {
                // Clear out intersects, they are outdated by now
                const data = {
                    ...hoveredObj,
                    intersections: intersections
                };
                handlers.onPointerOut == null || handlers.onPointerOut(data);
                handlers.onPointerLeave == null || handlers.onPointerLeave(data);
            }
        }
    }
    function pointerMissed(event, objects) {
        for(let i = 0; i < objects.length; i++){
            const instance = objects[i].__r3f;
            instance == null || instance.handlers.onPointerMissed == null || instance.handlers.onPointerMissed(event);
        }
    }
    function handlePointer(name) {
        // Deal with cancelation
        switch(name){
            case 'onPointerLeave':
            case 'onPointerCancel':
                return ()=>cancelPointer([]);
            case 'onLostPointerCapture':
                return (event)=>{
                    const { internal: internal } = store.getState();
                    if ('pointerId' in event && internal.capturedMap.has(event.pointerId)) // If the object event interface had onLostPointerCapture, we'd call it here on every
                    // object that's getting removed. We call it on the next frame because onLostPointerCapture
                    // fires before onPointerUp. Otherwise pointerUp would never be called if the event didn't
                    // happen in the object it originated from, leaving components in a in-between state.
                    requestAnimationFrame(()=>{
                        // Only release if pointer-up didn't do it already
                        if (internal.capturedMap.has(event.pointerId)) {
                            internal.capturedMap.delete(event.pointerId);
                            cancelPointer([]);
                        }
                    });
                };
        }
        // Any other pointer goes here ...
        return function handleEvent(event) {
            const { onPointerMissed: onPointerMissed, internal: internal } = store.getState();
            // prepareRay(event)
            internal.lastEvent.current = event;
            // Get fresh intersects
            const isPointerMove = name === 'onPointerMove';
            const isClickEvent = name === 'onClick' || name === 'onContextMenu' || name === 'onDoubleClick';
            const filter = isPointerMove ? filterPointerEvents : undefined;
            const hits = intersect(event, filter);
            const delta = isClickEvent ? calculateDistance(event) : 0;
            // Save initial coordinates on pointer-down
            if (name === 'onPointerDown') {
                internal.initialClick = [
                    event.offsetX,
                    event.offsetY
                ];
                internal.initialHits = hits.map((hit)=>hit.eventObject);
            }
            // If a click yields no results, pass it back to the user as a miss
            // Missed events have to come first in order to establish user-land side-effect clean up
            if (isClickEvent && !hits.length) {
                if (delta <= 2) {
                    pointerMissed(event, internal.interaction);
                    if (onPointerMissed) onPointerMissed(event);
                }
            }
            // Take care of unhover
            if (isPointerMove) cancelPointer(hits);
            function onIntersect(data) {
                const eventObject = data.eventObject;
                const instance = eventObject.__r3f;
                const handlers = instance == null ? void 0 : instance.handlers;
                // Check presence of handlers
                if (!(instance != null && instance.eventCount)) return;
                /*
        MAYBE TODO, DELETE IF NOT: 
          Check if the object is captured, captured events should not have intersects running in parallel
          But wouldn't it be better to just replace capturedMap with a single entry?
          Also, are we OK with straight up making picking up multiple objects impossible?
          
        const pointerId = (data as ThreeEvent<PointerEvent>).pointerId        
        if (pointerId !== undefined) {
          const capturedMeshSet = internal.capturedMap.get(pointerId)
          if (capturedMeshSet) {
            const captured = capturedMeshSet.get(eventObject)
            if (captured && captured.localState.stopped) return
          }
        }*/ if (isPointerMove) {
                    // Move event ...
                    if (handlers.onPointerOver || handlers.onPointerEnter || handlers.onPointerOut || handlers.onPointerLeave) {
                        // When enter or out is present take care of hover-state
                        const id = $62815e5999fdef70$var$makeId(data);
                        const hoveredItem = internal.hovered.get(id);
                        if (!hoveredItem) {
                            // If the object wasn't previously hovered, book it and call its handler
                            internal.hovered.set(id, data);
                            handlers.onPointerOver == null || handlers.onPointerOver(data);
                            handlers.onPointerEnter == null || handlers.onPointerEnter(data);
                        } else if (hoveredItem.stopped) // If the object was previously hovered and stopped, we shouldn't allow other items to proceed
                        data.stopPropagation();
                    }
                    // Call mouse move
                    handlers.onPointerMove == null || handlers.onPointerMove(data);
                } else {
                    // All other events ...
                    const handler = handlers[name];
                    if (handler) // Forward all events back to their respective handlers with the exception of click events,
                    // which must use the initial target
                    {
                        if (!isClickEvent || internal.initialHits.includes(eventObject)) {
                            // Missed events have to come first
                            pointerMissed(event, internal.interaction.filter((object)=>!internal.initialHits.includes(object)));
                            // Now call the handler
                            handler(data);
                        }
                    } else // Trigger onPointerMissed on all elements that have pointer over/out handlers, but not click and weren't hit
                    if (isClickEvent && internal.initialHits.includes(eventObject)) pointerMissed(event, internal.interaction.filter((object)=>!internal.initialHits.includes(object)));
                }
            }
            handleIntersects(hits, event, delta, onIntersect);
        };
    }
    return {
        handlePointer: handlePointer
    };
}
// Keys that shouldn't be copied between R3F stores
const $62815e5999fdef70$var$privateKeys = [
    'set',
    'get',
    'setSize',
    'setFrameloop',
    'setDpr',
    'events',
    'invalidate',
    'advance',
    'size',
    'viewport'
];
const $62815e5999fdef70$var$isRenderer = (def)=>!!(def != null && def.render);
const $62815e5999fdef70$export$39b482c5e57630a8 = /*#__PURE__*/ $aqdBs.createContext(null);
const $62815e5999fdef70$var$createStore = (invalidate, advance)=>{
    const rootState = (0, (/*@__PURE__*/$parcel$interopDefault($a82936f98dfe91f3$exports)))((set, get)=>{
        const position = new $548f161e17fc6f48$export$64b5c384219d3699();
        const defaultTarget = new $548f161e17fc6f48$export$64b5c384219d3699();
        const tempTarget = new $548f161e17fc6f48$export$64b5c384219d3699();
        function getCurrentViewport(camera = get().camera, target = defaultTarget, size = get().size) {
            const { width: width, height: height, top: top, left: left } = size;
            const aspect = width / height;
            if (target.isVector3) tempTarget.copy(target);
            else tempTarget.set(...target);
            const distance = camera.getWorldPosition(position).distanceTo(tempTarget);
            if ($62815e5999fdef70$var$isOrthographicCamera(camera)) return {
                width: width / camera.zoom,
                height: height / camera.zoom,
                top: top,
                left: left,
                factor: 1,
                distance: distance,
                aspect: aspect
            };
            else {
                const fov = camera.fov * Math.PI / 180; // convert vertical fov to radians
                const h = 2 * Math.tan(fov / 2) * distance; // visible height
                const w = h * (width / height);
                return {
                    width: w,
                    height: h,
                    top: top,
                    left: left,
                    factor: width / w,
                    distance: distance,
                    aspect: aspect
                };
            }
        }
        let performanceTimeout = undefined;
        const setPerformanceCurrent = (current)=>set((state)=>({
                    performance: {
                        ...state.performance,
                        current: current
                    }
                }));
        const pointer = new $548f161e17fc6f48$export$c977b3e384af9ae1();
        const rootState = {
            set: set,
            get: get,
            // Mock objects that have to be configured
            gl: null,
            camera: null,
            raycaster: null,
            events: {
                priority: 1,
                enabled: true,
                connected: false
            },
            xr: null,
            scene: null,
            invalidate: (frames = 1)=>invalidate(get(), frames),
            advance: (timestamp, runGlobalEffects)=>advance(timestamp, runGlobalEffects, get()),
            legacy: false,
            linear: false,
            flat: false,
            controls: null,
            clock: new $548f161e17fc6f48$export$9735c82c4bae3302(),
            pointer: pointer,
            mouse: pointer,
            frameloop: 'always',
            onPointerMissed: undefined,
            performance: {
                current: 1,
                min: 0.5,
                max: 1,
                debounce: 200,
                regress: ()=>{
                    const state = get();
                    // Clear timeout
                    if (performanceTimeout) clearTimeout(performanceTimeout);
                    // Set lower bound performance
                    if (state.performance.current !== state.performance.min) setPerformanceCurrent(state.performance.min);
                    // Go back to upper bound performance after a while unless something regresses meanwhile
                    performanceTimeout = setTimeout(()=>setPerformanceCurrent(get().performance.max), state.performance.debounce);
                }
            },
            size: {
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                updateStyle: false
            },
            viewport: {
                initialDpr: 0,
                dpr: 0,
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                aspect: 0,
                distance: 0,
                factor: 0,
                getCurrentViewport: getCurrentViewport
            },
            setEvents: (events)=>set((state)=>({
                        ...state,
                        events: {
                            ...state.events,
                            ...events
                        }
                    })),
            setSize: (width, height, updateStyle, top, left)=>{
                const camera = get().camera;
                const size = {
                    width: width,
                    height: height,
                    top: top || 0,
                    left: left || 0,
                    updateStyle: updateStyle
                };
                set((state)=>({
                        size: size,
                        viewport: {
                            ...state.viewport,
                            ...getCurrentViewport(camera, defaultTarget, size)
                        }
                    }));
            },
            setDpr: (dpr)=>set((state)=>{
                    const resolved = $62815e5999fdef70$var$calculateDpr(dpr);
                    return {
                        viewport: {
                            ...state.viewport,
                            dpr: resolved,
                            initialDpr: state.viewport.initialDpr || resolved
                        }
                    };
                }),
            setFrameloop: (frameloop = 'always')=>{
                const clock = get().clock;
                // if frameloop === "never" clock.elapsedTime is updated using advance(timestamp)
                clock.stop();
                clock.elapsedTime = 0;
                if (frameloop !== 'never') {
                    clock.start();
                    clock.elapsedTime = 0;
                }
                set(()=>({
                        frameloop: frameloop
                    }));
            },
            previousRoot: undefined,
            internal: {
                active: false,
                priority: 0,
                frames: 0,
                lastEvent: /*#__PURE__*/ $aqdBs.createRef(),
                interaction: [],
                hovered: new Map(),
                subscribers: [],
                initialClick: [
                    0,
                    0
                ],
                initialHits: [],
                capturedMap: new Map(),
                subscribe: (ref, priority, store)=>{
                    const internal = get().internal;
                    // If this subscription was given a priority, it takes rendering into its own hands
                    // For that reason we switch off automatic rendering and increase the manual flag
                    // As long as this flag is positive there can be no internal rendering at all
                    // because there could be multiple render subscriptions
                    internal.priority = internal.priority + (priority > 0 ? 1 : 0);
                    internal.subscribers.push({
                        ref: ref,
                        priority: priority,
                        store: store
                    });
                    // Register subscriber and sort layers from lowest to highest, meaning,
                    // highest priority renders last (on top of the other frames)
                    internal.subscribers = internal.subscribers.sort((a, b)=>a.priority - b.priority);
                    return ()=>{
                        const internal = get().internal;
                        if (internal != null && internal.subscribers) {
                            // Decrease manual flag if this subscription had a priority
                            internal.priority = internal.priority - (priority > 0 ? 1 : 0);
                            // Remove subscriber from list
                            internal.subscribers = internal.subscribers.filter((s)=>s.ref !== ref);
                        }
                    };
                }
            }
        };
        return rootState;
    });
    const state = rootState.getState();
    let oldSize = state.size;
    let oldDpr = state.viewport.dpr;
    let oldCamera = state.camera;
    rootState.subscribe(()=>{
        const { camera: camera, size: size, viewport: viewport, gl: gl, set: set } = rootState.getState();
        // Resize camera and renderer on changes to size and pixelratio
        if (size.width !== oldSize.width || size.height !== oldSize.height || viewport.dpr !== oldDpr) {
            var _size$updateStyle;
            oldSize = size;
            oldDpr = viewport.dpr;
            // Update camera & renderer
            $62815e5999fdef70$var$updateCamera(camera, size);
            gl.setPixelRatio(viewport.dpr);
            const updateStyle = (_size$updateStyle = size.updateStyle) != null ? _size$updateStyle : typeof HTMLCanvasElement !== 'undefined' && gl.domElement instanceof HTMLCanvasElement;
            gl.setSize(size.width, size.height, updateStyle);
        }
        // Update viewport once the camera changes
        if (camera !== oldCamera) {
            oldCamera = camera;
            // Update viewport
            set((state)=>({
                    viewport: {
                        ...state.viewport,
                        ...state.viewport.getCurrentViewport(camera)
                    }
                }));
        }
    });
    // Invalidate on any change
    rootState.subscribe((state)=>invalidate(state));
    // Return root state
    return rootState;
};
function $62815e5999fdef70$var$createSubs(callback, subs) {
    const sub = {
        callback: callback
    };
    subs.add(sub);
    return ()=>void subs.delete(sub);
}
let $62815e5999fdef70$var$i;
let $62815e5999fdef70$var$globalEffects = new Set();
let $62815e5999fdef70$var$globalAfterEffects = new Set();
let $62815e5999fdef70$var$globalTailEffects = new Set();
/**
 * Adds a global render callback which is called each frame.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addEffect
 */ const $62815e5999fdef70$export$ae1af26003f05816 = (callback)=>$62815e5999fdef70$var$createSubs(callback, $62815e5999fdef70$var$globalEffects);
/**
 * Adds a global after-render callback which is called each frame.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addAfterEffect
 */ const $62815e5999fdef70$export$ffb5f4729a158638 = (callback)=>$62815e5999fdef70$var$createSubs(callback, $62815e5999fdef70$var$globalAfterEffects);
/**
 * Adds a global callback which is called when rendering stops.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addTail
 */ const $62815e5999fdef70$export$9e5f44173e64f162 = (callback)=>$62815e5999fdef70$var$createSubs(callback, $62815e5999fdef70$var$globalTailEffects);
function $62815e5999fdef70$var$run(effects, timestamp) {
    if (!effects.size) return;
    for (const { callback: callback } of effects.values())callback(timestamp);
}
function $62815e5999fdef70$export$2408f22a0fab9ae5(type, timestamp) {
    switch(type){
        case 'before':
            return $62815e5999fdef70$var$run($62815e5999fdef70$var$globalEffects, timestamp);
        case 'after':
            return $62815e5999fdef70$var$run($62815e5999fdef70$var$globalAfterEffects, timestamp);
        case 'tail':
            return $62815e5999fdef70$var$run($62815e5999fdef70$var$globalTailEffects, timestamp);
    }
}
let $62815e5999fdef70$var$subscribers;
let $62815e5999fdef70$var$subscription;
function $62815e5999fdef70$var$render$1(timestamp, state, frame) {
    // Run local effects
    let delta = state.clock.getDelta();
    // In frameloop='never' mode, clock times are updated using the provided timestamp
    if (state.frameloop === 'never' && typeof timestamp === 'number') {
        delta = timestamp - state.clock.elapsedTime;
        state.clock.oldTime = state.clock.elapsedTime;
        state.clock.elapsedTime = timestamp;
    }
    // Call subscribers (useFrame)
    $62815e5999fdef70$var$subscribers = state.internal.subscribers;
    for($62815e5999fdef70$var$i = 0; $62815e5999fdef70$var$i < $62815e5999fdef70$var$subscribers.length; $62815e5999fdef70$var$i++){
        $62815e5999fdef70$var$subscription = $62815e5999fdef70$var$subscribers[$62815e5999fdef70$var$i];
        $62815e5999fdef70$var$subscription.ref.current($62815e5999fdef70$var$subscription.store.getState(), delta, frame);
    }
    // Render content
    if (!state.internal.priority && state.gl.render) state.gl.render(state.scene, state.camera);
    // Decrease frame count
    state.internal.frames = Math.max(0, state.internal.frames - 1);
    return state.frameloop === 'always' ? 1 : state.internal.frames;
}
function $62815e5999fdef70$var$createLoop(roots) {
    let running = false;
    let useFrameInProgress = false;
    let repeat;
    let frame;
    let state;
    function loop(timestamp) {
        frame = requestAnimationFrame(loop);
        running = true;
        repeat = 0;
        // Run effects
        $62815e5999fdef70$export$2408f22a0fab9ae5('before', timestamp);
        // Render all roots
        useFrameInProgress = true;
        for (const root of roots.values()){
            var _state$gl$xr;
            state = root.store.getState();
            // If the frameloop is invalidated, do not run another frame
            if (state.internal.active && (state.frameloop === 'always' || state.internal.frames > 0) && !((_state$gl$xr = state.gl.xr) != null && _state$gl$xr.isPresenting)) repeat += $62815e5999fdef70$var$render$1(timestamp, state);
        }
        useFrameInProgress = false;
        // Run after-effects
        $62815e5999fdef70$export$2408f22a0fab9ae5('after', timestamp);
        // Stop the loop if nothing invalidates it
        if (repeat === 0) {
            // Tail call effects, they are called when rendering stops
            $62815e5999fdef70$export$2408f22a0fab9ae5('tail', timestamp);
            // Flag end of operation
            running = false;
            return cancelAnimationFrame(frame);
        }
    }
    function invalidate(state, frames = 1) {
        var _state$gl$xr2;
        if (!state) return roots.forEach((root)=>invalidate(root.store.getState(), frames));
        if ((_state$gl$xr2 = state.gl.xr) != null && _state$gl$xr2.isPresenting || !state.internal.active || state.frameloop === 'never') return;
        if (frames > 1) // legacy support for people using frames parameters
        // Increase frames, do not go higher than 60
        state.internal.frames = Math.min(60, state.internal.frames + frames);
        else if (useFrameInProgress) //called from within a useFrame, it means the user wants an additional frame
        state.internal.frames = 2;
        else //the user need a new frame, no need to increment further than 1
        state.internal.frames = 1;
        // If the render-loop isn't active, start it
        if (!running) {
            running = true;
            requestAnimationFrame(loop);
        }
    }
    function advance(timestamp, runGlobalEffects = true, state, frame) {
        if (runGlobalEffects) $62815e5999fdef70$export$2408f22a0fab9ae5('before', timestamp);
        if (!state) for (const root of roots.values())$62815e5999fdef70$var$render$1(timestamp, root.store.getState());
        else $62815e5999fdef70$var$render$1(timestamp, state, frame);
        if (runGlobalEffects) $62815e5999fdef70$export$2408f22a0fab9ae5('after', timestamp);
    }
    return {
        loop: loop,
        invalidate: invalidate,
        advance: advance
    };
}
/**
 * Exposes an object's {@link LocalState}.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#useInstanceHandle
 *
 * **Note**: this is an escape hatch to react-internal fields. Expect this to change significantly between versions.
 */ function $62815e5999fdef70$export$ebd11618f299a286(ref) {
    const instance = $aqdBs.useRef(null);
    $62815e5999fdef70$export$407448d2b89b1813(()=>void (instance.current = ref.current.__r3f), [
        ref
    ]);
    return instance;
}
function $62815e5999fdef70$export$e7094788287c5e9b() {
    const store = $aqdBs.useContext($62815e5999fdef70$export$39b482c5e57630a8);
    if (!store) throw new Error('R3F: Hooks can only be used within the Canvas component!');
    return store;
}
/**
 * Accesses R3F's internal state, containing renderer, canvas, scene, etc.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usethree
 */ function $62815e5999fdef70$export$96f57966bedc81b4(selector = (state)=>state, equalityFn) {
    return $62815e5999fdef70$export$e7094788287c5e9b()(selector, equalityFn);
}
/**
 * Executes a callback before render in a shared frame loop.
 * Can order effects with render priority or manually render with a positive priority.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#useframe
 */ function $62815e5999fdef70$export$d66501df72047452(callback, renderPriority = 0) {
    const store = $62815e5999fdef70$export$e7094788287c5e9b();
    const subscribe = store.getState().internal.subscribe;
    // Memoize ref
    const ref = $62815e5999fdef70$export$3b14a55fb2447963(callback);
    // Subscribe on mount, unsubscribe on unmount
    $62815e5999fdef70$export$407448d2b89b1813(()=>subscribe(ref, renderPriority, store), [
        renderPriority,
        subscribe,
        store
    ]);
    return null;
}
/**
 * Returns a node graph of an object with named nodes & materials.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usegraph
 */ function $62815e5999fdef70$export$2329c99376c9d0a4(object) {
    return $aqdBs.useMemo(()=>$62815e5999fdef70$export$4a5767248b18ef41(object), [
        object
    ]);
}
const $62815e5999fdef70$var$memoizedLoaders = new WeakMap();
function $62815e5999fdef70$var$loadingFn(extensions, onProgress) {
    return function(Proto, ...input) {
        // Construct new loader and run extensions
        let loader = $62815e5999fdef70$var$memoizedLoaders.get(Proto);
        if (!loader) {
            loader = new Proto();
            $62815e5999fdef70$var$memoizedLoaders.set(Proto, loader);
        }
        if (extensions) extensions(loader);
        // Go through the urls and load them
        return Promise.all(input.map((input)=>new Promise((res, reject)=>loader.load(input, (data)=>{
                    if (data.scene) Object.assign(data, $62815e5999fdef70$export$4a5767248b18ef41(data.scene));
                    res(data);
                }, onProgress, (error)=>reject(new Error(`Could not load ${input}: ${error == null ? void 0 : error.message}`))))));
    };
}
/**
 * Synchronously loads and caches assets with a three loader.
 *
 * Note: this hook's caller must be wrapped with `React.Suspense`
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#useloader
 */ function $62815e5999fdef70$export$7f8ddf7c7c20b3cd(Proto, input, extensions, onProgress) {
    // Use suspense to load async assets
    const keys = Array.isArray(input) ? input : [
        input
    ];
    const results = (0, $79fc2eee8c1d2a78$export$a1428c8f7ba796e8)($62815e5999fdef70$var$loadingFn(extensions, onProgress), [
        Proto,
        ...keys
    ], {
        equal: $62815e5999fdef70$var$is.equ
    });
    // Return the object/s
    return Array.isArray(input) ? results : results[0];
}
/**
 * Preloads an asset into cache as a side-effect.
 */ $62815e5999fdef70$export$7f8ddf7c7c20b3cd.preload = function(Proto, input, extensions) {
    const keys = Array.isArray(input) ? input : [
        input
    ];
    return (0, $79fc2eee8c1d2a78$export$513ccb98c53b8039)($62815e5999fdef70$var$loadingFn(extensions), [
        Proto,
        ...keys
    ]);
};
/**
 * Removes a loaded asset from cache.
 */ $62815e5999fdef70$export$7f8ddf7c7c20b3cd.clear = function(Proto, input) {
    const keys = Array.isArray(input) ? input : [
        input
    ];
    return (0, $79fc2eee8c1d2a78$export$42ffd38884aecdac)([
        Proto,
        ...keys
    ]);
};
const $62815e5999fdef70$export$df995fae86a55f06 = new Map();
const { invalidate: $62815e5999fdef70$export$953cecd6e717a553, advance: $62815e5999fdef70$export$7ccc53e8f1e7dfc5 } = $62815e5999fdef70$var$createLoop($62815e5999fdef70$export$df995fae86a55f06);
const { reconciler: $62815e5999fdef70$export$35e795649ee09318, applyProps: $62815e5999fdef70$export$342063e11d6c3cad } = $62815e5999fdef70$var$createRenderer($62815e5999fdef70$export$df995fae86a55f06, $62815e5999fdef70$var$getEventPriority);
const $62815e5999fdef70$var$shallowLoose = {
    objects: 'shallow',
    strict: false
};
const $62815e5999fdef70$var$createRendererInstance = (gl, canvas)=>{
    const customRenderer = typeof gl === 'function' ? gl(canvas) : gl;
    if ($62815e5999fdef70$var$isRenderer(customRenderer)) return customRenderer;
    else return new $548f161e17fc6f48$export$f6cc00ef28d7cf97({
        powerPreference: 'high-performance',
        canvas: canvas,
        antialias: true,
        alpha: true,
        ...gl
    });
};
function $62815e5999fdef70$var$computeInitialSize(canvas, defaultSize) {
    const defaultStyle = typeof HTMLCanvasElement !== 'undefined' && canvas instanceof HTMLCanvasElement;
    if (defaultSize) {
        const { width: width, height: height, top: top, left: left, updateStyle: updateStyle = defaultStyle } = defaultSize;
        return {
            width: width,
            height: height,
            top: top,
            left: left,
            updateStyle: updateStyle
        };
    } else if (typeof HTMLCanvasElement !== 'undefined' && canvas instanceof HTMLCanvasElement && canvas.parentElement) {
        const { width: width, height: height, top: top, left: left } = canvas.parentElement.getBoundingClientRect();
        return {
            width: width,
            height: height,
            top: top,
            left: left,
            updateStyle: defaultStyle
        };
    } else if (typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return {
        width: canvas.width,
        height: canvas.height,
        top: 0,
        left: 0,
        updateStyle: defaultStyle
    };
    return {
        width: 0,
        height: 0,
        top: 0,
        left: 0
    };
}
function $62815e5999fdef70$export$8b22cf2602fb60ce(canvas) {
    // Check against mistaken use of createRoot
    const prevRoot = $62815e5999fdef70$export$df995fae86a55f06.get(canvas);
    const prevFiber = prevRoot == null ? void 0 : prevRoot.fiber;
    const prevStore = prevRoot == null ? void 0 : prevRoot.store;
    if (prevRoot) console.warn('R3F.createRoot should only be called once!');
    // Report when an error was detected in a previous render
    // https://github.com/pmndrs/react-three-fiber/pull/2261
    const logRecoverableError = typeof reportError === 'function' ? // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError : // In older browsers and test environments, fallback to console.error.
    console.error;
    // Create store
    const store = prevStore || $62815e5999fdef70$var$createStore($62815e5999fdef70$export$953cecd6e717a553, $62815e5999fdef70$export$7ccc53e8f1e7dfc5);
    // Create renderer
    const fiber = prevFiber || $62815e5999fdef70$export$35e795649ee09318.createContainer(store, (0, $eeb07fcb2b6a118a$exports.ConcurrentRoot), null, false, null, '', logRecoverableError, null);
    // Map it
    if (!prevRoot) $62815e5999fdef70$export$df995fae86a55f06.set(canvas, {
        fiber: fiber,
        store: store
    });
    // Locals
    let onCreated;
    let configured = false;
    let lastCamera;
    return {
        configure (props = {}) {
            let { gl: glConfig, size: propsSize, scene: sceneOptions, events: events, onCreated: onCreatedCallback, shadows: shadows = false, linear: linear = false, flat: flat = false, legacy: legacy = false, orthographic: orthographic = false, frameloop: frameloop = 'always', dpr: dpr = [
                1,
                2
            ], performance: performance1, raycaster: raycastOptions, camera: cameraOptions, onPointerMissed: onPointerMissed } = props;
            let state = store.getState();
            // Set up renderer (one time only!)
            let gl = state.gl;
            if (!state.gl) state.set({
                gl: gl = $62815e5999fdef70$var$createRendererInstance(glConfig, canvas)
            });
            // Set up raycaster (one time only!)
            let raycaster = state.raycaster;
            if (!raycaster) state.set({
                raycaster: raycaster = new $548f161e17fc6f48$export$8b7aaceff00bd2f()
            });
            // Set raycaster options
            const { params: params, ...options } = raycastOptions || {};
            if (!$62815e5999fdef70$var$is.equ(options, raycaster, $62815e5999fdef70$var$shallowLoose)) $62815e5999fdef70$export$342063e11d6c3cad(raycaster, {
                ...options
            });
            if (!$62815e5999fdef70$var$is.equ(params, raycaster.params, $62815e5999fdef70$var$shallowLoose)) $62815e5999fdef70$export$342063e11d6c3cad(raycaster, {
                params: {
                    ...raycaster.params,
                    ...params
                }
            });
            // Create default camera, don't overwrite any user-set state
            if (!state.camera || state.camera === lastCamera && !$62815e5999fdef70$var$is.equ(lastCamera, cameraOptions, $62815e5999fdef70$var$shallowLoose)) {
                lastCamera = cameraOptions;
                const isCamera = cameraOptions instanceof $548f161e17fc6f48$export$79f141de891a5fed;
                const camera = isCamera ? cameraOptions : orthographic ? new $548f161e17fc6f48$export$9ebf355ee4ed261b(0, 0, 0, 0, 0.1, 1000) : new $548f161e17fc6f48$export$74e4ae24825f68d7(75, 0, 0.1, 1000);
                if (!isCamera) {
                    camera.position.z = 5;
                    if (cameraOptions) {
                        $62815e5999fdef70$export$342063e11d6c3cad(camera, cameraOptions);
                        // Preserve user-defined frustum if possible
                        // https://github.com/pmndrs/react-three-fiber/issues/3160
                        if ('aspect' in cameraOptions || 'left' in cameraOptions || 'right' in cameraOptions || 'bottom' in cameraOptions || 'top' in cameraOptions) {
                            camera.manual = true;
                            camera.updateProjectionMatrix();
                        }
                    }
                    // Always look at center by default
                    if (!state.camera && !(cameraOptions != null && cameraOptions.rotation)) camera.lookAt(0, 0, 0);
                }
                state.set({
                    camera: camera
                });
                // Configure raycaster
                // https://github.com/pmndrs/react-xr/issues/300
                raycaster.camera = camera;
            }
            // Set up scene (one time only!)
            if (!state.scene) {
                let scene;
                if (sceneOptions != null && sceneOptions.isScene) scene = sceneOptions;
                else {
                    scene = new $548f161e17fc6f48$export$38af1803e3442a7f();
                    if (sceneOptions) $62815e5999fdef70$export$342063e11d6c3cad(scene, sceneOptions);
                }
                state.set({
                    scene: $62815e5999fdef70$var$prepare(scene)
                });
            }
            // Set up XR (one time only!)
            if (!state.xr) {
                var _gl$xr;
                // Handle frame behavior in WebXR
                const handleXRFrame = (timestamp, frame)=>{
                    const state = store.getState();
                    if (state.frameloop === 'never') return;
                    $62815e5999fdef70$export$7ccc53e8f1e7dfc5(timestamp, true, state, frame);
                };
                // Toggle render switching on session
                const handleSessionChange = ()=>{
                    const state = store.getState();
                    state.gl.xr.enabled = state.gl.xr.isPresenting;
                    state.gl.xr.setAnimationLoop(state.gl.xr.isPresenting ? handleXRFrame : null);
                    if (!state.gl.xr.isPresenting) $62815e5999fdef70$export$953cecd6e717a553(state);
                };
                // WebXR session manager
                const xr = {
                    connect () {
                        const gl = store.getState().gl;
                        gl.xr.addEventListener('sessionstart', handleSessionChange);
                        gl.xr.addEventListener('sessionend', handleSessionChange);
                    },
                    disconnect () {
                        const gl = store.getState().gl;
                        gl.xr.removeEventListener('sessionstart', handleSessionChange);
                        gl.xr.removeEventListener('sessionend', handleSessionChange);
                    }
                };
                // Subscribe to WebXR session events
                if (typeof ((_gl$xr = gl.xr) == null ? void 0 : _gl$xr.addEventListener) === 'function') xr.connect();
                state.set({
                    xr: xr
                });
            }
            // Set shadowmap
            if (gl.shadowMap) {
                const oldEnabled = gl.shadowMap.enabled;
                const oldType = gl.shadowMap.type;
                gl.shadowMap.enabled = !!shadows;
                if ($62815e5999fdef70$var$is.boo(shadows)) gl.shadowMap.type = $548f161e17fc6f48$export$a47c4b43a1be34f0;
                else if ($62815e5999fdef70$var$is.str(shadows)) {
                    var _types$shadows;
                    const types = {
                        basic: $548f161e17fc6f48$export$346307dbae2b7447,
                        percentage: $548f161e17fc6f48$export$5813f879eee7cd88,
                        soft: $548f161e17fc6f48$export$a47c4b43a1be34f0,
                        variance: $548f161e17fc6f48$export$896ae1ade6c829c4
                    };
                    gl.shadowMap.type = (_types$shadows = types[shadows]) != null ? _types$shadows : $548f161e17fc6f48$export$a47c4b43a1be34f0;
                } else if ($62815e5999fdef70$var$is.obj(shadows)) Object.assign(gl.shadowMap, shadows);
                if (oldEnabled !== gl.shadowMap.enabled || oldType !== gl.shadowMap.type) gl.shadowMap.needsUpdate = true;
            }
            // Safely set color management if available.
            // Avoid accessing THREE.ColorManagement to play nice with older versions
            const ColorManagement = $62815e5999fdef70$var$getColorManagement();
            if (ColorManagement) {
                if ('enabled' in ColorManagement) ColorManagement.enabled = !legacy;
                else if ('legacyMode' in ColorManagement) ColorManagement.legacyMode = legacy;
            }
            if (!configured) {
                // Set color space and tonemapping preferences, once
                const LinearEncoding = 3000;
                const sRGBEncoding = 3001;
                $62815e5999fdef70$export$342063e11d6c3cad(gl, {
                    outputEncoding: linear ? LinearEncoding : sRGBEncoding,
                    toneMapping: flat ? $548f161e17fc6f48$export$9fcb6b4294603b2 : $548f161e17fc6f48$export$a0d98fe6d7e4af64
                });
            }
            // Update color management state
            if (state.legacy !== legacy) state.set(()=>({
                    legacy: legacy
                }));
            if (state.linear !== linear) state.set(()=>({
                    linear: linear
                }));
            if (state.flat !== flat) state.set(()=>({
                    flat: flat
                }));
            // Set gl props
            if (glConfig && !$62815e5999fdef70$var$is.fun(glConfig) && !$62815e5999fdef70$var$isRenderer(glConfig) && !$62815e5999fdef70$var$is.equ(glConfig, gl, $62815e5999fdef70$var$shallowLoose)) $62815e5999fdef70$export$342063e11d6c3cad(gl, glConfig);
            // Store events internally
            if (events && !state.events.handlers) state.set({
                events: events(store)
            });
            // Check size, allow it to take on container bounds initially
            const size = $62815e5999fdef70$var$computeInitialSize(canvas, propsSize);
            if (!$62815e5999fdef70$var$is.equ(size, state.size, $62815e5999fdef70$var$shallowLoose)) state.setSize(size.width, size.height, size.updateStyle, size.top, size.left);
            // Check pixelratio
            if (dpr && state.viewport.dpr !== $62815e5999fdef70$var$calculateDpr(dpr)) state.setDpr(dpr);
            // Check frameloop
            if (state.frameloop !== frameloop) state.setFrameloop(frameloop);
            // Check pointer missed
            if (!state.onPointerMissed) state.set({
                onPointerMissed: onPointerMissed
            });
            // Check performance
            if (performance1 && !$62815e5999fdef70$var$is.equ(performance1, state.performance, $62815e5999fdef70$var$shallowLoose)) state.set((state)=>({
                    performance: {
                        ...state.performance,
                        ...performance1
                    }
                }));
            // Set locals
            onCreated = onCreatedCallback;
            configured = true;
            return this;
        },
        render (children) {
            // The root has to be configured before it can be rendered
            if (!configured) this.configure();
            $62815e5999fdef70$export$35e795649ee09318.updateContainer(/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($62815e5999fdef70$var$Provider, {
                store: store,
                children: children,
                onCreated: onCreated,
                rootElement: canvas
            }), fiber, null, ()=>undefined);
            return store;
        },
        unmount () {
            $62815e5999fdef70$export$4368d992c4eafac0(canvas);
        }
    };
}
function $62815e5999fdef70$export$43caf9889c228507(children, canvas, config) {
    console.warn('R3F.render is no longer supported in React 18. Use createRoot instead!');
    const root = $62815e5999fdef70$export$8b22cf2602fb60ce(canvas);
    root.configure(config);
    return root.render(children);
}
function $62815e5999fdef70$var$Provider({ store: store, children: children, onCreated: onCreated, rootElement: rootElement }) {
    $62815e5999fdef70$export$407448d2b89b1813(()=>{
        const state = store.getState();
        // Flag the canvas active, rendering will now begin
        state.set((state)=>({
                internal: {
                    ...state.internal,
                    active: true
                }
            }));
        // Notifiy that init is completed, the scene graph exists, but nothing has yet rendered
        if (onCreated) onCreated(state);
        // Connect events to the targets parent, this is done to ensure events are registered on
        // a shared target, and not on the canvas itself
        if (!store.getState().events.connected) state.events.connect == null || state.events.connect(rootElement);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($62815e5999fdef70$export$39b482c5e57630a8.Provider, {
        value: store,
        children: children
    });
}
function $62815e5999fdef70$export$4368d992c4eafac0(canvas, callback) {
    const root = $62815e5999fdef70$export$df995fae86a55f06.get(canvas);
    const fiber = root == null ? void 0 : root.fiber;
    if (fiber) {
        const state = root == null ? void 0 : root.store.getState();
        if (state) state.internal.active = false;
        $62815e5999fdef70$export$35e795649ee09318.updateContainer(null, fiber, null, ()=>{
            if (state) setTimeout(()=>{
                try {
                    var _state$gl, _state$gl$renderLists, _state$gl2, _state$gl3;
                    state.events.disconnect == null || state.events.disconnect();
                    (_state$gl = state.gl) == null || (_state$gl$renderLists = _state$gl.renderLists) == null || _state$gl$renderLists.dispose == null || _state$gl$renderLists.dispose();
                    (_state$gl2 = state.gl) == null || _state$gl2.forceContextLoss == null || _state$gl2.forceContextLoss();
                    if ((_state$gl3 = state.gl) != null && _state$gl3.xr) state.xr.disconnect();
                    $62815e5999fdef70$export$882b5998b3b9117c(state);
                    $62815e5999fdef70$export$df995fae86a55f06.delete(canvas);
                    if (callback) callback(canvas);
                } catch (e) {
                /* ... */ }
            }, 500);
        });
    }
}
function $62815e5999fdef70$export$dda1d9f60106f0e9(children, container, state) {
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($62815e5999fdef70$var$Portal, {
        children: children,
        container: container,
        state: state
    }, container.uuid);
}
function $62815e5999fdef70$var$Portal({ state: state = {}, children: children, container: container }) {
    /** This has to be a component because it would not be able to call useThree/useStore otherwise since
   *  if this is our environment, then we are not in r3f's renderer but in react-dom, it would trigger
   *  the "R3F hooks can only be used within the Canvas component!" warning:
   *  <Canvas>
   *    {createPortal(...)} */ const { events: events, size: size, ...rest } = state;
    const previousRoot = $62815e5999fdef70$export$e7094788287c5e9b();
    const [raycaster] = $aqdBs.useState(()=>new $548f161e17fc6f48$export$8b7aaceff00bd2f());
    const [pointer] = $aqdBs.useState(()=>new $548f161e17fc6f48$export$c977b3e384af9ae1());
    const inject = $aqdBs.useCallback((rootState, injectState)=>{
        const intersect = {
            ...rootState
        }; // all prev state props
        // Only the fields of "rootState" that do not differ from injectState
        // Some props should be off-limits
        // Otherwise filter out the props that are different and let the inject layer take precedence
        Object.keys(rootState).forEach((key)=>{
            if (// Some props should be off-limits
            $62815e5999fdef70$var$privateKeys.includes(key) || // Otherwise filter out the props that are different and let the inject layer take precedence
            // Unless the inject layer props is undefined, then we keep the root layer
            rootState[key] !== injectState[key] && injectState[key]) delete intersect[key];
        });
        let viewport = undefined;
        if (injectState && size) {
            const camera = injectState.camera;
            // Calculate the override viewport, if present
            viewport = rootState.viewport.getCurrentViewport(camera, new $548f161e17fc6f48$export$64b5c384219d3699(), size);
            // Update the portal camera, if it differs from the previous layer
            if (camera !== rootState.camera) $62815e5999fdef70$var$updateCamera(camera, size);
        }
        return {
            // The intersect consists of the previous root state
            ...intersect,
            // Portals have their own scene, which forms the root, a raycaster and a pointer
            scene: container,
            raycaster: raycaster,
            pointer: pointer,
            mouse: pointer,
            previousRoot: // Their previous root is the layer before it
            previousRoot,
            // Events, size and viewport can be overridden by the inject layer
            events: {
                ...rootState.events,
                ...injectState == null ? void 0 : injectState.events,
                ...events
            },
            size: {
                ...rootState.size,
                ...size
            },
            viewport: {
                ...rootState.viewport,
                ...viewport
            },
            ...rest
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        state
    ]);
    const [usePortalStore] = $aqdBs.useState(()=>{
        // Create a mirrored store, based on the previous root with a few overrides ...
        const previousState = previousRoot.getState();
        const store = (0, (/*@__PURE__*/$parcel$interopDefault($a82936f98dfe91f3$exports)))((set, get)=>({
                ...previousState,
                scene: container,
                raycaster: raycaster,
                pointer: pointer,
                mouse: pointer,
                previousRoot: previousRoot,
                events: {
                    ...previousState.events,
                    ...events
                },
                size: {
                    ...previousState.size,
                    ...size
                },
                ...rest,
                set: // Set and get refer to this root-state
                set,
                get: get,
                // Layers are allowed to override events
                setEvents: (events)=>set((state)=>({
                            ...state,
                            events: {
                                ...state.events,
                                ...events
                            }
                        }))
            }));
        return store;
    });
    $aqdBs.useEffect(()=>{
        // Subscribe to previous root-state and copy changes over to the mirrored portal-state
        const unsub = previousRoot.subscribe((prev)=>usePortalStore.setState((state)=>inject(prev, state)));
        return ()=>{
            unsub();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inject
    ]);
    $aqdBs.useEffect(()=>{
        usePortalStore.setState((injectState)=>inject(previousRoot.getState(), injectState));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        inject
    ]);
    $aqdBs.useEffect(()=>{
        return ()=>{
            usePortalStore.destroy();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $14024a6d51999040$exports.Fragment), {
        children: $62815e5999fdef70$export$35e795649ee09318.createPortal(/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($62815e5999fdef70$export$39b482c5e57630a8.Provider, {
            value: usePortalStore,
            children: children
        }), usePortalStore, null)
    });
}
/**
 * Force React to flush any updates inside the provided callback synchronously and immediately.
 * All the same caveats documented for react-dom's `flushSync` apply here (see https://react.dev/reference/react-dom/flushSync).
 * Nevertheless, sometimes one needs to render synchronously, for example to keep DOM and 3D changes in lock-step without
 * having to revert to a non-React solution.
 */ function $62815e5999fdef70$export$90a7f3efeed30595(fn) {
    // `flushSync` implementation only takes one argument. I don't know what's up with the type declaration for it.
    return $62815e5999fdef70$export$35e795649ee09318.flushSync(fn, undefined);
}
$62815e5999fdef70$export$35e795649ee09318.injectIntoDevTools({
    bundleType: 0,
    rendererPackageName: '@react-three/fiber',
    version: $aqdBs.version
});
const $62815e5999fdef70$export$d141bba7fdc215a3 = $aqdBs.unstable_act;
const $62815e5999fdef70$var$DOM_EVENTS = {
    onClick: [
        'click',
        false
    ],
    onContextMenu: [
        'contextmenu',
        false
    ],
    onDoubleClick: [
        'dblclick',
        false
    ],
    onWheel: [
        'wheel',
        true
    ],
    onPointerDown: [
        'pointerdown',
        true
    ],
    onPointerUp: [
        'pointerup',
        true
    ],
    onPointerLeave: [
        'pointerleave',
        true
    ],
    onPointerMove: [
        'pointermove',
        true
    ],
    onPointerCancel: [
        'pointercancel',
        true
    ],
    onLostPointerCapture: [
        'lostpointercapture',
        true
    ]
};
/** Default R3F event manager for web */ function $62815e5999fdef70$export$db3b6bfb95261072(store) {
    const { handlePointer: handlePointer } = $62815e5999fdef70$export$2d1720544b23b823(store);
    return {
        priority: 1,
        enabled: true,
        compute (event, state, previous) {
            // https://github.com/pmndrs/react-three-fiber/pull/782
            // Events trigger outside of canvas when moved, use offsetX/Y by default and allow overrides
            state.pointer.set(event.offsetX / state.size.width * 2 - 1, -(event.offsetY / state.size.height) * 2 + 1);
            state.raycaster.setFromCamera(state.pointer, state.camera);
        },
        connected: undefined,
        handlers: Object.keys($62815e5999fdef70$var$DOM_EVENTS).reduce((acc, key)=>({
                ...acc,
                [key]: handlePointer(key)
            }), {}),
        update: ()=>{
            var _internal$lastEvent;
            const { events: events, internal: internal } = store.getState();
            if ((_internal$lastEvent = internal.lastEvent) != null && _internal$lastEvent.current && events.handlers) events.handlers.onPointerMove(internal.lastEvent.current);
        },
        connect: (target)=>{
            var _events$handlers;
            const { set: set, events: events } = store.getState();
            events.disconnect == null || events.disconnect();
            set((state)=>({
                    events: {
                        ...state.events,
                        connected: target
                    }
                }));
            Object.entries((_events$handlers = events.handlers) != null ? _events$handlers : []).forEach(([name, event])=>{
                const [eventName, passive] = $62815e5999fdef70$var$DOM_EVENTS[name];
                target.addEventListener(eventName, event, {
                    passive: passive
                });
            });
        },
        disconnect: ()=>{
            const { set: set, events: events } = store.getState();
            if (events.connected) {
                var _events$handlers2;
                Object.entries((_events$handlers2 = events.handlers) != null ? _events$handlers2 : []).forEach(([name, event])=>{
                    if (events && events.connected instanceof HTMLElement) {
                        const [eventName] = $62815e5999fdef70$var$DOM_EVENTS[name];
                        events.connected.removeEventListener(eventName, event);
                    }
                });
                set((state)=>({
                        events: {
                            ...state.events,
                            connected: undefined
                        }
                    }));
            }
        }
    };
}


const $f9091fb34da85890$var$v1 = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$64b5c384219d3699)();
const $f9091fb34da85890$var$v2 = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$64b5c384219d3699)();
const $f9091fb34da85890$var$v3 = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$64b5c384219d3699)();
const $f9091fb34da85890$var$v4 = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$c977b3e384af9ae1)();
function $f9091fb34da85890$var$defaultCalculatePosition(el, camera, size) {
    const objectPos = $f9091fb34da85890$var$v1.setFromMatrixPosition(el.matrixWorld);
    objectPos.project(camera);
    const widthHalf = size.width / 2;
    const heightHalf = size.height / 2;
    return [
        objectPos.x * widthHalf + widthHalf,
        -(objectPos.y * heightHalf) + heightHalf
    ];
}
function $f9091fb34da85890$var$isObjectBehindCamera(el, camera) {
    const objectPos = $f9091fb34da85890$var$v1.setFromMatrixPosition(el.matrixWorld);
    const cameraPos = $f9091fb34da85890$var$v2.setFromMatrixPosition(camera.matrixWorld);
    const deltaCamObj = objectPos.sub(cameraPos);
    const camDir = camera.getWorldDirection($f9091fb34da85890$var$v3);
    return deltaCamObj.angleTo(camDir) > Math.PI / 2;
}
function $f9091fb34da85890$var$isObjectVisible(el, camera, raycaster, occlude) {
    const elPos = $f9091fb34da85890$var$v1.setFromMatrixPosition(el.matrixWorld);
    const screenPos = elPos.clone();
    screenPos.project(camera);
    $f9091fb34da85890$var$v4.set(screenPos.x, screenPos.y);
    raycaster.setFromCamera($f9091fb34da85890$var$v4, camera);
    const intersects = raycaster.intersectObjects(occlude, true);
    if (intersects.length) {
        const intersectionDistance = intersects[0].distance;
        const pointDistance = elPos.distanceTo(raycaster.ray.origin);
        return pointDistance < intersectionDistance;
    }
    return true;
}
function $f9091fb34da85890$var$objectScale(el, camera) {
    if (camera instanceof (0, $548f161e17fc6f48$export$9ebf355ee4ed261b)) return camera.zoom;
    else if (camera instanceof (0, $548f161e17fc6f48$export$74e4ae24825f68d7)) {
        const objectPos = $f9091fb34da85890$var$v1.setFromMatrixPosition(el.matrixWorld);
        const cameraPos = $f9091fb34da85890$var$v2.setFromMatrixPosition(camera.matrixWorld);
        const vFOV = camera.fov * Math.PI / 180;
        const dist = objectPos.distanceTo(cameraPos);
        const scaleFOV = 2 * Math.tan(vFOV / 2) * dist;
        return 1 / scaleFOV;
    } else return 1;
}
function $f9091fb34da85890$var$objectZIndex(el, camera, zIndexRange) {
    if (camera instanceof (0, $548f161e17fc6f48$export$74e4ae24825f68d7) || camera instanceof (0, $548f161e17fc6f48$export$9ebf355ee4ed261b)) {
        const objectPos = $f9091fb34da85890$var$v1.setFromMatrixPosition(el.matrixWorld);
        const cameraPos = $f9091fb34da85890$var$v2.setFromMatrixPosition(camera.matrixWorld);
        const dist = objectPos.distanceTo(cameraPos);
        const A = (zIndexRange[1] - zIndexRange[0]) / (camera.far - camera.near);
        const B = zIndexRange[1] - A * camera.far;
        return Math.round(A * dist + B);
    }
    return undefined;
}
const $f9091fb34da85890$var$epsilon = (value)=>Math.abs(value) < 1e-10 ? 0 : value;
function $f9091fb34da85890$var$getCSSMatrix(matrix, multipliers, prepend = '') {
    let matrix3d = 'matrix3d(';
    for(let i = 0; i !== 16; i++)matrix3d += $f9091fb34da85890$var$epsilon(multipliers[i] * matrix.elements[i]) + (i !== 15 ? ',' : ')');
    return prepend + matrix3d;
}
const $f9091fb34da85890$var$getCameraCSSMatrix = ((multipliers)=>{
    return (matrix)=>$f9091fb34da85890$var$getCSSMatrix(matrix, multipliers);
})([
    1,
    -1,
    1,
    1,
    1,
    -1,
    1,
    1,
    1,
    -1,
    1,
    1,
    1,
    -1,
    1,
    1
]);
const $f9091fb34da85890$var$getObjectCSSMatrix = ((scaleMultipliers)=>{
    return (matrix, factor)=>$f9091fb34da85890$var$getCSSMatrix(matrix, scaleMultipliers(factor), 'translate(-50%,-50%)');
})((f)=>[
        1 / f,
        1 / f,
        1 / f,
        1,
        -1 / f,
        -1 / f,
        -1 / f,
        -1,
        1 / f,
        1 / f,
        1 / f,
        1,
        1,
        1,
        1,
        1
    ]);
function $f9091fb34da85890$var$isRefObject(ref) {
    return ref && typeof ref === 'object' && 'current' in ref;
}
const $f9091fb34da85890$export$13f9d3c4397c4713 = /* @__PURE__ */ $aqdBs.forwardRef(({ children: children, eps: eps = 0.001, style: style, className: className, prepend: prepend, center: center, fullscreen: fullscreen, portal: portal, distanceFactor: distanceFactor, sprite: sprite = false, transform: transform = false, occlude: occlude, onOcclude: onOcclude, castShadow: castShadow, receiveShadow: receiveShadow, material: material, geometry: geometry, zIndexRange: zIndexRange = [
    16777271,
    0
], calculatePosition: calculatePosition = $f9091fb34da85890$var$defaultCalculatePosition, as: as = 'div', wrapperClass: wrapperClass, pointerEvents: pointerEvents = 'auto', ...props }, ref)=>{
    const { gl: gl, camera: camera, scene: scene, size: size, raycaster: raycaster, events: events, viewport: viewport } = (0, $62815e5999fdef70$export$96f57966bedc81b4)();
    const [el] = $aqdBs.useState(()=>document.createElement(as));
    const root = $aqdBs.useRef();
    const group = $aqdBs.useRef(null);
    const oldZoom = $aqdBs.useRef(0);
    const oldPosition = $aqdBs.useRef([
        0,
        0
    ]);
    const transformOuterRef = $aqdBs.useRef(null);
    const transformInnerRef = $aqdBs.useRef(null);
    // Append to the connected element, which makes HTML work with views
    const target = (portal == null ? void 0 : portal.current) || events.connected || gl.domElement.parentNode;
    const occlusionMeshRef = $aqdBs.useRef(null);
    const isMeshSizeSet = $aqdBs.useRef(false);
    const isRayCastOcclusion = $aqdBs.useMemo(()=>{
        return occlude && occlude !== 'blending' || Array.isArray(occlude) && occlude.length && $f9091fb34da85890$var$isRefObject(occlude[0]);
    }, [
        occlude
    ]);
    $aqdBs.useLayoutEffect(()=>{
        const el = gl.domElement;
        if (occlude && occlude === 'blending') {
            el.style.zIndex = `${Math.floor(zIndexRange[0] / 2)}`;
            el.style.position = 'absolute';
            el.style.pointerEvents = 'none';
        } else {
            el.style.zIndex = null;
            el.style.position = null;
            el.style.pointerEvents = null;
        }
    }, [
        occlude
    ]);
    $aqdBs.useLayoutEffect(()=>{
        if (group.current) {
            const currentRoot = root.current = $c920eedc27eaef64$export$882461b6382ed46c(el);
            scene.updateMatrixWorld();
            if (transform) el.style.cssText = `position:absolute;top:0;left:0;pointer-events:none;overflow:hidden;`;
            else {
                const vec = calculatePosition(group.current, camera, size);
                el.style.cssText = `position:absolute;top:0;left:0;transform:translate3d(${vec[0]}px,${vec[1]}px,0);transform-origin:0 0;`;
            }
            if (target) {
                if (prepend) target.prepend(el);
                else target.appendChild(el);
            }
            return ()=>{
                if (target) target.removeChild(el);
                currentRoot.unmount();
            };
        }
    }, [
        target,
        transform
    ]);
    $aqdBs.useLayoutEffect(()=>{
        if (wrapperClass) el.className = wrapperClass;
    }, [
        wrapperClass
    ]);
    const styles = $aqdBs.useMemo(()=>{
        if (transform) return {
            position: 'absolute',
            top: 0,
            left: 0,
            width: size.width,
            height: size.height,
            transformStyle: 'preserve-3d',
            pointerEvents: 'none'
        };
        else return {
            position: 'absolute',
            transform: center ? 'translate3d(-50%,-50%,0)' : 'none',
            ...fullscreen && {
                top: -size.height / 2,
                left: -size.width / 2,
                width: size.width,
                height: size.height
            },
            ...style
        };
    }, [
        style,
        center,
        fullscreen,
        size,
        transform
    ]);
    const transformInnerStyles = $aqdBs.useMemo(()=>({
            position: 'absolute',
            pointerEvents: pointerEvents
        }), [
        pointerEvents
    ]);
    $aqdBs.useLayoutEffect(()=>{
        isMeshSizeSet.current = false;
        if (transform) {
            var _root$current;
            (_root$current = root.current) == null || _root$current.render(/*#__PURE__*/ $aqdBs.createElement("div", {
                ref: transformOuterRef,
                style: styles
            }, /*#__PURE__*/ $aqdBs.createElement("div", {
                ref: transformInnerRef,
                style: transformInnerStyles
            }, /*#__PURE__*/ $aqdBs.createElement("div", {
                ref: ref,
                className: className,
                style: style,
                children: children
            }))));
        } else {
            var _root$current2;
            (_root$current2 = root.current) == null || _root$current2.render(/*#__PURE__*/ $aqdBs.createElement("div", {
                ref: ref,
                style: styles,
                className: className,
                children: children
            }));
        }
    });
    const visible = $aqdBs.useRef(true);
    (0, $62815e5999fdef70$export$d66501df72047452)((gl)=>{
        if (group.current) {
            camera.updateMatrixWorld();
            group.current.updateWorldMatrix(true, false);
            const vec = transform ? oldPosition.current : calculatePosition(group.current, camera, size);
            if (transform || Math.abs(oldZoom.current - camera.zoom) > eps || Math.abs(oldPosition.current[0] - vec[0]) > eps || Math.abs(oldPosition.current[1] - vec[1]) > eps) {
                const isBehindCamera = $f9091fb34da85890$var$isObjectBehindCamera(group.current, camera);
                let raytraceTarget = false;
                if (isRayCastOcclusion) {
                    if (Array.isArray(occlude)) raytraceTarget = occlude.map((item)=>item.current);
                    else if (occlude !== 'blending') raytraceTarget = [
                        scene
                    ];
                }
                const previouslyVisible = visible.current;
                if (raytraceTarget) {
                    const isvisible = $f9091fb34da85890$var$isObjectVisible(group.current, camera, raycaster, raytraceTarget);
                    visible.current = isvisible && !isBehindCamera;
                } else visible.current = !isBehindCamera;
                if (previouslyVisible !== visible.current) {
                    if (onOcclude) onOcclude(!visible.current);
                    else el.style.display = visible.current ? 'block' : 'none';
                }
                const halfRange = Math.floor(zIndexRange[0] / 2);
                const zRange = occlude ? isRayCastOcclusion //
                 ? [
                    zIndexRange[0],
                    halfRange
                ] : [
                    halfRange - 1,
                    0
                ] : zIndexRange;
                el.style.zIndex = `${$f9091fb34da85890$var$objectZIndex(group.current, camera, zRange)}`;
                if (transform) {
                    const [widthHalf, heightHalf] = [
                        size.width / 2,
                        size.height / 2
                    ];
                    const fov = camera.projectionMatrix.elements[5] * heightHalf;
                    const { isOrthographicCamera: isOrthographicCamera, top: top, left: left, bottom: bottom, right: right } = camera;
                    const cameraMatrix = $f9091fb34da85890$var$getCameraCSSMatrix(camera.matrixWorldInverse);
                    const cameraTransform = isOrthographicCamera ? `scale(${fov})translate(${$f9091fb34da85890$var$epsilon(-(right + left) / 2)}px,${$f9091fb34da85890$var$epsilon((top + bottom) / 2)}px)` : `translateZ(${fov}px)`;
                    let matrix = group.current.matrixWorld;
                    if (sprite) {
                        matrix = camera.matrixWorldInverse.clone().transpose().copyPosition(matrix).scale(group.current.scale);
                        matrix.elements[3] = matrix.elements[7] = matrix.elements[11] = 0;
                        matrix.elements[15] = 1;
                    }
                    el.style.width = size.width + 'px';
                    el.style.height = size.height + 'px';
                    el.style.perspective = isOrthographicCamera ? '' : `${fov}px`;
                    if (transformOuterRef.current && transformInnerRef.current) {
                        transformOuterRef.current.style.transform = `${cameraTransform}${cameraMatrix}translate(${widthHalf}px,${heightHalf}px)`;
                        transformInnerRef.current.style.transform = $f9091fb34da85890$var$getObjectCSSMatrix(matrix, 1 / ((distanceFactor || 10) / 400));
                    }
                } else {
                    const scale = distanceFactor === undefined ? 1 : $f9091fb34da85890$var$objectScale(group.current, camera) * distanceFactor;
                    el.style.transform = `translate3d(${vec[0]}px,${vec[1]}px,0) scale(${scale})`;
                }
                oldPosition.current = vec;
                oldZoom.current = camera.zoom;
            }
        }
        if (!isRayCastOcclusion && occlusionMeshRef.current && !isMeshSizeSet.current) {
            if (transform) {
                if (transformOuterRef.current) {
                    const el = transformOuterRef.current.children[0];
                    if (el != null && el.clientWidth && el != null && el.clientHeight) {
                        const { isOrthographicCamera: isOrthographicCamera } = camera;
                        if (isOrthographicCamera || geometry) {
                            if (props.scale) {
                                if (!Array.isArray(props.scale)) occlusionMeshRef.current.scale.setScalar(1 / props.scale);
                                else if (props.scale instanceof (0, $548f161e17fc6f48$export$64b5c384219d3699)) occlusionMeshRef.current.scale.copy(props.scale.clone().divideScalar(1));
                                else occlusionMeshRef.current.scale.set(1 / props.scale[0], 1 / props.scale[1], 1 / props.scale[2]);
                            }
                        } else {
                            const ratio = (distanceFactor || 10) / 400;
                            const w = el.clientWidth * ratio;
                            const h = el.clientHeight * ratio;
                            occlusionMeshRef.current.scale.set(w, h, 1);
                        }
                        isMeshSizeSet.current = true;
                    }
                }
            } else {
                const ele = el.children[0];
                if (ele != null && ele.clientWidth && ele != null && ele.clientHeight) {
                    const ratio = 1 / viewport.factor;
                    const w = ele.clientWidth * ratio;
                    const h = ele.clientHeight * ratio;
                    occlusionMeshRef.current.scale.set(w, h, 1);
                    isMeshSizeSet.current = true;
                }
                occlusionMeshRef.current.lookAt(gl.camera.position);
            }
        }
    });
    const shaders = $aqdBs.useMemo(()=>({
            vertexShader: !transform ? /* glsl */ `
          /*
            This shader is from the THREE's SpriteMaterial.
            We need to turn the backing plane into a Sprite
            (make it always face the camera) if "transfrom"
            is false.
          */
          #include <common>

          void main() {
            vec2 center = vec2(0., 1.);
            float rotation = 0.0;

            // This is somewhat arbitrary, but it seems to work well
            // Need to figure out how to derive this dynamically if it even matters
            float size = 0.03;

            vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
            vec2 scale;
            scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
            scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );

            bool isPerspective = isPerspectiveMatrix( projectionMatrix );
            if ( isPerspective ) scale *= - mvPosition.z;

            vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale * size;
            vec2 rotatedPosition;
            rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
            rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
            mvPosition.xy += rotatedPosition;

            gl_Position = projectionMatrix * mvPosition;
          }
      ` : undefined,
            fragmentShader: /* glsl */ `
        void main() {
          gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
        }
      `
        }), [
        transform
    ]);
    return /*#__PURE__*/ $aqdBs.createElement("group", (0, $c2edeac9f1827d96$export$2e2bcd8739ae039)({}, props, {
        ref: group
    }), occlude && !isRayCastOcclusion && /*#__PURE__*/ $aqdBs.createElement("mesh", {
        castShadow: castShadow,
        receiveShadow: receiveShadow,
        ref: occlusionMeshRef
    }, geometry || /*#__PURE__*/ $aqdBs.createElement("planeGeometry", null), material || /*#__PURE__*/ $aqdBs.createElement("shaderMaterial", {
        side: (0, $548f161e17fc6f48$export$3b296b6f144d5b03),
        vertexShader: shaders.vertexShader,
        fragmentShader: shaders.fragmentShader
    })));
});


var $aqdBs = parcelRequire("aqdBs");
var $fcfabbebc8c71b7f$exports = {};
'use strict';
var $c2534c81f3c66274$exports = {};

$parcel$export($c2534c81f3c66274$exports, "createStore", () => $c2534c81f3c66274$export$f51a9068ac82ea43, (v) => $c2534c81f3c66274$export$f51a9068ac82ea43 = v);
var $c2534c81f3c66274$export$f51a9068ac82ea43;
'use strict';
const $c2534c81f3c66274$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $c2534c81f3c66274$var$createStore = (createState)=>createState ? $c2534c81f3c66274$var$createStoreImpl(createState) : $c2534c81f3c66274$var$createStoreImpl;
$c2534c81f3c66274$export$f51a9068ac82ea43 = $c2534c81f3c66274$var$createStore;


var $67aaadd0c3fca770$exports = {};

$parcel$export($67aaadd0c3fca770$exports, "create", () => $67aaadd0c3fca770$export$185802fd694ee1f5, (v) => $67aaadd0c3fca770$export$185802fd694ee1f5 = v);
$parcel$export($67aaadd0c3fca770$exports, "useStore", () => $67aaadd0c3fca770$export$6ccbb43953eebf8, (v) => $67aaadd0c3fca770$export$6ccbb43953eebf8 = v);
var $67aaadd0c3fca770$export$185802fd694ee1f5;
var $67aaadd0c3fca770$export$6ccbb43953eebf8;
'use strict';

var $aqdBs = parcelRequire("aqdBs");

const $67aaadd0c3fca770$var$identity = (arg)=>arg;
function $67aaadd0c3fca770$var$useStore(api, selector = $67aaadd0c3fca770$var$identity) {
    const slice = $aqdBs.useSyncExternalStore(api.subscribe, ()=>selector(api.getState()), ()=>selector(api.getInitialState()));
    $aqdBs.useDebugValue(slice);
    return slice;
}
const $67aaadd0c3fca770$var$createImpl = (createState)=>{
    const api = $c2534c81f3c66274$export$f51a9068ac82ea43(createState);
    const useBoundStore = (selector)=>$67aaadd0c3fca770$var$useStore(api, selector);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $67aaadd0c3fca770$var$create = (createState)=>createState ? $67aaadd0c3fca770$var$createImpl(createState) : $67aaadd0c3fca770$var$createImpl;
$67aaadd0c3fca770$export$185802fd694ee1f5 = $67aaadd0c3fca770$var$create;
$67aaadd0c3fca770$export$6ccbb43953eebf8 = $67aaadd0c3fca770$var$useStore;


Object.keys($c2534c81f3c66274$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($fcfabbebc8c71b7f$exports, k)) Object.defineProperty($fcfabbebc8c71b7f$exports, k, {
        enumerable: true,
        get: function() {
            return $c2534c81f3c66274$exports[k];
        }
    });
});
Object.keys($67aaadd0c3fca770$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($fcfabbebc8c71b7f$exports, k)) Object.defineProperty($fcfabbebc8c71b7f$exports, k, {
        enumerable: true,
        get: function() {
            return $67aaadd0c3fca770$exports[k];
        }
    });
});


var $09edd54d44133fed$export$1be1fc439b849fdf;
var $09edd54d44133fed$export$95a3b7b12ab518f9;
var $09edd54d44133fed$export$6922d3b3a607469e;
var $09edd54d44133fed$export$9a6132153fba2e0;
var $09edd54d44133fed$export$4feba8a1bc8e9afd;
var $09edd54d44133fed$export$5c593627aef9f076;
'use strict';
const $09edd54d44133fed$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $09edd54d44133fed$var$redux = $09edd54d44133fed$var$reduxImpl;
const $09edd54d44133fed$var$trackedConnections = /* @__PURE__ */ new Map();
const $09edd54d44133fed$var$getTrackedConnectionState = (name)=>{
    const api = $09edd54d44133fed$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $09edd54d44133fed$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === undefined) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $09edd54d44133fed$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $09edd54d44133fed$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $09edd54d44133fed$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        const { connection: connection, ...connectionInformation } = $09edd54d44133fed$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === undefined ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === undefined) {
                connection == null ? undefined : connection.send(action, get());
                return r;
            }
            connection == null ? undefined : connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$09edd54d44133fed$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null ? undefined : connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null ? undefined : connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $09edd54d44133fed$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === undefined) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === undefined || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === undefined) return connection == null ? undefined : connection.init(api.getState());
                            return connection == null ? undefined : connection.init($09edd54d44133fed$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === undefined) {
                                connection == null ? undefined : connection.init(api.getState());
                                return;
                            }
                            return connection == null ? undefined : connection.init($09edd54d44133fed$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $09edd54d44133fed$var$parseJsonThen(message.state, (state)=>{
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    connection == null ? undefined : connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null ? undefined : connection.init($09edd54d44133fed$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $09edd54d44133fed$var$parseJsonThen(message.state, (state)=>{
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? undefined : _a.state;
                                if (!lastComputedState) return;
                                if (store === undefined) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null ? undefined : connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $09edd54d44133fed$var$devtools = $09edd54d44133fed$var$devtoolsImpl;
const $09edd54d44133fed$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== undefined) f(parsed);
};
const $09edd54d44133fed$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? undefined : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? undefined : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $09edd54d44133fed$var$subscribeWithSelector = $09edd54d44133fed$var$subscribeWithSelectorImpl;
const $09edd54d44133fed$var$combine = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $09edd54d44133fed$var$createJSONStorage(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? undefined : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? undefined : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $09edd54d44133fed$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $09edd54d44133fed$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $09edd54d44133fed$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $09edd54d44133fed$var$persistImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $09edd54d44133fed$var$createJSONStorage(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? undefined : _b.call(options, (_a = get()) != null ? _a : configResult)) || undefined;
            return $09edd54d44133fed$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) {
                            const migration = options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            if (migration instanceof Promise) return migration.then((result)=>[
                                    true,
                                    result
                                ]);
                            return [
                                true,
                                migration
                            ];
                        }
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    undefined
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null ? undefined : postRehydrationCallback(stateFromStorage, undefined);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null ? undefined : postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null ? undefined : storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $09edd54d44133fed$var$persist = $09edd54d44133fed$var$persistImpl;
$09edd54d44133fed$export$1be1fc439b849fdf = $09edd54d44133fed$var$combine;
$09edd54d44133fed$export$95a3b7b12ab518f9 = $09edd54d44133fed$var$createJSONStorage;
$09edd54d44133fed$export$6922d3b3a607469e = $09edd54d44133fed$var$devtools;
$09edd54d44133fed$export$9a6132153fba2e0 = $09edd54d44133fed$var$persist;
$09edd54d44133fed$export$4feba8a1bc8e9afd = $09edd54d44133fed$var$redux;
$09edd54d44133fed$export$5c593627aef9f076 = $09edd54d44133fed$var$subscribeWithSelector;


// These are removed in Zustand v4
// unknown
// Zustand v3 marked deprecations in 3.x, but there's no visible upgrade path
const $c2a67ed70ad506b3$var$context = /* @__PURE__ */ $aqdBs.createContext(null);
function $c2a67ed70ad506b3$export$a34fcda2dd58fb18({ map: map, children: children, onChange: onChange, domElement: domElement }) {
    const key = map.map((item)=>item.name + item.keys).join('-');
    const useControls = $aqdBs.useMemo(()=>{
        return (0, $fcfabbebc8c71b7f$exports.create)((0, $09edd54d44133fed$export$5c593627aef9f076)(()=>map.reduce((prev, cur)=>({
                    ...prev,
                    [cur.name]: false
                }), {})));
    }, [
        key
    ]);
    const api = $aqdBs.useMemo(()=>[
            useControls.subscribe,
            useControls.getState,
            useControls
        ], [
        key
    ]);
    const set = useControls.setState;
    $aqdBs.useEffect(()=>{
        const config = map.map(({ name: name, keys: keys, up: up })=>({
                keys: keys,
                up: up,
                fn: (value)=>{
                    // Set zustand state
                    set({
                        [name]: value
                    });
                    // Inform callback
                    if (onChange) onChange(name, value, api[1]());
                }
            }));
        const keyMap = config.reduce((out, { keys: keys, fn: fn, up: up = true })=>{
            keys.forEach((key)=>out[key] = {
                    fn: fn,
                    pressed: false,
                    up: up
                });
            return out;
        }, {});
        const downHandler = ({ key: key, code: code })=>{
            const obj = keyMap[key] || keyMap[code];
            if (!obj) return;
            const { fn: fn, pressed: pressed, up: up } = obj;
            obj.pressed = true;
            if (up || !pressed) fn(true);
        };
        const upHandler = ({ key: key, code: code })=>{
            const obj = keyMap[key] || keyMap[code];
            if (!obj) return;
            const { fn: fn, up: up } = obj;
            obj.pressed = false;
            if (up) fn(false);
        };
        const source = domElement || window;
        source.addEventListener('keydown', downHandler, {
            passive: true
        });
        source.addEventListener('keyup', upHandler, {
            passive: true
        });
        return ()=>{
            source.removeEventListener('keydown', downHandler);
            source.removeEventListener('keyup', upHandler);
        };
    }, [
        domElement,
        key
    ]);
    return /*#__PURE__*/ $aqdBs.createElement($c2a67ed70ad506b3$var$context.Provider, {
        value: api,
        children: children
    });
}
function $c2a67ed70ad506b3$export$179a1940ffcac7a3(sel) {
    const [sub, get, store] = $aqdBs.useContext($c2a67ed70ad506b3$var$context);
    if (sel) return store(sel);
    else return [
        sub,
        get
    ];
}



var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");


// TODO: consume this from three >r154 when SemVer allows
// 👇 uncomment when TS version supports function overloads
// export function useFBO(settings?: FBOSettings)
function $82fd1db6541908f0$export$46efc781def3def7(/** Width in pixels, or settings (will render fullscreen by default) */ width, /** Height in pixels */ height, /**Settings */ settings) {
    const size = (0, $62815e5999fdef70$export$96f57966bedc81b4)((state)=>state.size);
    const viewport = (0, $62815e5999fdef70$export$96f57966bedc81b4)((state)=>state.viewport);
    const _width = typeof width === 'number' ? width : size.width * viewport.dpr;
    const _height = typeof height === 'number' ? height : size.height * viewport.dpr;
    const _settings = (typeof width === 'number' ? settings : width) || {};
    const { samples: samples = 0, depth: depth, ...targetSettings } = _settings;
    const target = $aqdBs.useMemo(()=>{
        const target = new $548f161e17fc6f48$export$3c052beb2e51e23f(_width, _height, {
            minFilter: $548f161e17fc6f48$export$8a72f490b25c56c8,
            magFilter: $548f161e17fc6f48$export$8a72f490b25c56c8,
            type: $548f161e17fc6f48$export$2697304443f382bc,
            ...targetSettings
        });
        if (depth) target.depthTexture = new $548f161e17fc6f48$export$fc830aa069cc8c2f(_width, _height, $548f161e17fc6f48$export$f6d331659b644596);
        target.samples = samples;
        return target;
    }, []);
    $aqdBs.useLayoutEffect(()=>{
        target.setSize(_width, _height);
        if (samples) target.samples = samples;
    }, [
        samples,
        target,
        _width,
        _height
    ]);
    $aqdBs.useEffect(()=>{
        return ()=>target.dispose();
    }, []);
    return target;
}
const $82fd1db6541908f0$export$30db5cdfa645f68a = ({ children: children, width: width, height: height, ...settings })=>{
    const target = $82fd1db6541908f0$export$46efc781def3def7(width, height, settings);
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, children == null ? void 0 : children(target));
};


const $70f9e801e680b612$var$isFunction = (node)=>typeof node === 'function';
const $70f9e801e680b612$export$74e4ae24825f68d7 = /* @__PURE__ */ $aqdBs.forwardRef(({ envMap: envMap, resolution: resolution = 256, frames: frames = Infinity, makeDefault: makeDefault, children: children, ...props }, ref)=>{
    const set = (0, $62815e5999fdef70$export$96f57966bedc81b4)(({ set: set })=>set);
    const camera = (0, $62815e5999fdef70$export$96f57966bedc81b4)(({ camera: camera })=>camera);
    const size = (0, $62815e5999fdef70$export$96f57966bedc81b4)(({ size: size })=>size);
    const cameraRef = $aqdBs.useRef(null);
    $aqdBs.useImperativeHandle(ref, ()=>cameraRef.current, []);
    const groupRef = $aqdBs.useRef(null);
    const fbo = (0, $82fd1db6541908f0$export$46efc781def3def7)(resolution);
    $aqdBs.useLayoutEffect(()=>{
        if (!props.manual) cameraRef.current.aspect = size.width / size.height;
    }, [
        size,
        props
    ]);
    $aqdBs.useLayoutEffect(()=>{
        cameraRef.current.updateProjectionMatrix();
    });
    let count = 0;
    let oldEnvMap = null;
    const functional = $70f9e801e680b612$var$isFunction(children);
    (0, $62815e5999fdef70$export$d66501df72047452)((state)=>{
        if (functional && (frames === Infinity || count < frames)) {
            groupRef.current.visible = false;
            state.gl.setRenderTarget(fbo);
            oldEnvMap = state.scene.background;
            if (envMap) state.scene.background = envMap;
            state.gl.render(state.scene, cameraRef.current);
            state.scene.background = oldEnvMap;
            state.gl.setRenderTarget(null);
            groupRef.current.visible = true;
            count++;
        }
    });
    $aqdBs.useLayoutEffect(()=>{
        if (makeDefault) {
            const oldCam = camera;
            set(()=>({
                    camera: cameraRef.current
                }));
            return ()=>set(()=>({
                        camera: oldCam
                    }));
        }
    // The camera should not be part of the dependency list because this components camera is a stable reference
    // that must exchange the default, and clean up after itself on unmount.
    }, [
        cameraRef,
        makeDefault,
        set
    ]);
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement("perspectiveCamera", (0, $c2edeac9f1827d96$export$2e2bcd8739ae039)({
        ref: cameraRef
    }, props), !functional && children), /*#__PURE__*/ $aqdBs.createElement("group", {
        ref: groupRef
    }, functional && children(fbo.texture)));
});




var $aqdBs = parcelRequire("aqdBs");


var $aqdBs = parcelRequire("aqdBs");
function $6c5a66ef2351b837$var$g(n, t) {
    let o;
    return (...i)=>{
        window.clearTimeout(o), o = window.setTimeout(()=>n(...i), t);
    };
}
function $6c5a66ef2351b837$export$2e2bcd8739ae039({ debounce: n, scroll: t, polyfill: o, offsetSize: i } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
}) {
    const a = o || (typeof window == "undefined" ? class {
    } : window.ResizeObserver);
    if (!a) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    const [c, h] = (0, $aqdBs.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }), e = (0, $aqdBs.useRef)({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: c,
        orientationHandler: null
    }), d = n ? typeof n == "number" ? n : n.scroll : null, f = n ? typeof n == "number" ? n : n.resize : null, w = (0, $aqdBs.useRef)(!1);
    (0, $aqdBs.useEffect)(()=>(w.current = !0, ()=>void (w.current = !1)));
    const [z, m, s] = (0, $aqdBs.useMemo)(()=>{
        const r = ()=>{
            if (!e.current.element) return;
            const { left: y, top: C, width: H, height: O, bottom: S, right: x, x: B, y: R } = e.current.element.getBoundingClientRect(), l = {
                left: y,
                top: C,
                width: H,
                height: O,
                bottom: S,
                right: x,
                x: B,
                y: R
            };
            e.current.element instanceof HTMLElement && i && (l.height = e.current.element.offsetHeight, l.width = e.current.element.offsetWidth), Object.freeze(l), w.current && !$6c5a66ef2351b837$var$D(e.current.lastBounds, l) && h(e.current.lastBounds = l);
        };
        return [
            r,
            f ? $6c5a66ef2351b837$var$g(r, f) : r,
            d ? $6c5a66ef2351b837$var$g(r, d) : r
        ];
    }, [
        h,
        i,
        d,
        f
    ]);
    function v() {
        e.current.scrollContainers && (e.current.scrollContainers.forEach((r)=>r.removeEventListener("scroll", s, !0)), e.current.scrollContainers = null), e.current.resizeObserver && (e.current.resizeObserver.disconnect(), e.current.resizeObserver = null), e.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", e.current.orientationHandler));
    }
    function b() {
        e.current.element && (e.current.resizeObserver = new a(s), e.current.resizeObserver.observe(e.current.element), t && e.current.scrollContainers && e.current.scrollContainers.forEach((r)=>r.addEventListener("scroll", s, {
                capture: !0,
                passive: !0
            })), e.current.orientationHandler = ()=>{
            s();
        }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", e.current.orientationHandler));
    }
    const L = (r)=>{
        !r || r === e.current.element || (v(), e.current.element = r, e.current.scrollContainers = $6c5a66ef2351b837$var$E(r), b());
    };
    return $6c5a66ef2351b837$var$X(s, !!t), $6c5a66ef2351b837$var$W(m), (0, $aqdBs.useEffect)(()=>{
        v(), b();
    }, [
        t,
        s,
        m
    ]), (0, $aqdBs.useEffect)(()=>v, []), [
        L,
        c,
        z
    ];
}
function $6c5a66ef2351b837$var$W(n) {
    (0, $aqdBs.useEffect)(()=>{
        const t = n;
        return window.addEventListener("resize", t), ()=>void window.removeEventListener("resize", t);
    }, [
        n
    ]);
}
function $6c5a66ef2351b837$var$X(n, t) {
    (0, $aqdBs.useEffect)(()=>{
        if (t) {
            const o = n;
            return window.addEventListener("scroll", o, {
                capture: !0,
                passive: !0
            }), ()=>void window.removeEventListener("scroll", o, !0);
        }
    }, [
        n,
        t
    ]);
}
function $6c5a66ef2351b837$var$E(n) {
    const t = [];
    if (!n || n === document.body) return t;
    const { overflow: o, overflowX: i, overflowY: a } = window.getComputedStyle(n);
    return [
        o,
        i,
        a
    ].some((c)=>c === "auto" || c === "scroll") && t.push(n), [
        ...t,
        ...$6c5a66ef2351b837$var$E(n.parentElement)
    ];
}
const $6c5a66ef2351b837$var$k = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
], $6c5a66ef2351b837$var$D = (n, t)=>$6c5a66ef2351b837$var$k.every((o)=>n[o] === t[o]);



var $aqdBs = parcelRequire("aqdBs");
var $5180c63364f801a2$var$__defProp = Object.defineProperty;
var $5180c63364f801a2$var$__defProps = Object.defineProperties;
var $5180c63364f801a2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5180c63364f801a2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5180c63364f801a2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5180c63364f801a2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5180c63364f801a2$var$__defNormalProp = (obj, key, value)=>key in obj ? $5180c63364f801a2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5180c63364f801a2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5180c63364f801a2$var$__hasOwnProp.call(b, prop)) $5180c63364f801a2$var$__defNormalProp(a, prop, b[prop]);
    if ($5180c63364f801a2$var$__getOwnPropSymbols) {
        for (var prop of $5180c63364f801a2$var$__getOwnPropSymbols(b))if ($5180c63364f801a2$var$__propIsEnum.call(b, prop)) $5180c63364f801a2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5180c63364f801a2$var$__spreadProps = (a, b)=>$5180c63364f801a2$var$__defProps(a, $5180c63364f801a2$var$__getOwnPropDescs(b));
var $5180c63364f801a2$var$_a, $5180c63364f801a2$var$_b;
const $5180c63364f801a2$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && ((($5180c63364f801a2$var$_a = window.document) == null ? void 0 : $5180c63364f801a2$var$_a.createElement) || (($5180c63364f801a2$var$_b = window.navigator) == null ? void 0 : $5180c63364f801a2$var$_b.product) === "ReactNative") ? $aqdBs.useLayoutEffect : $aqdBs.useEffect;
function $5180c63364f801a2$export$e2f435051054a3fd(fiber, ascending, selector) {
    if (!fiber) return;
    if (selector(fiber) === true) return fiber;
    let child = ascending ? fiber.return : fiber.child;
    while(child){
        const match = $5180c63364f801a2$export$e2f435051054a3fd(child, ascending, selector);
        if (match) return match;
        child = ascending ? null : child.sibling;
    }
}
function $5180c63364f801a2$var$wrapContext(context) {
    try {
        return Object.defineProperties(context, {
            _currentRenderer: {
                get () {
                    return null;
                },
                set () {}
            },
            _currentRenderer2: {
                get () {
                    return null;
                },
                set () {}
            }
        });
    } catch (_) {
        return context;
    }
}
const $5180c63364f801a2$var$error = console.error;
console.error = function() {
    const message = [
        ...arguments
    ].join("");
    if ((message == null ? void 0 : message.startsWith("Warning:")) && message.includes("useContext")) {
        console.error = $5180c63364f801a2$var$error;
        return;
    }
    return $5180c63364f801a2$var$error.apply(this, arguments);
};
const $5180c63364f801a2$var$FiberContext = $5180c63364f801a2$var$wrapContext($aqdBs.createContext(null));
class $5180c63364f801a2$export$5a20fcbfd44d38b7 extends $aqdBs.Component {
    render() {
        return /* @__PURE__ */ $aqdBs.createElement($5180c63364f801a2$var$FiberContext.Provider, {
            value: this._reactInternals
        }, this.props.children);
    }
}
function $5180c63364f801a2$export$69c8591d5df5c7d6() {
    const root = $aqdBs.useContext($5180c63364f801a2$var$FiberContext);
    if (root === null) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
    const id = $aqdBs.useId();
    const fiber = $aqdBs.useMemo(()=>{
        for (const maybeFiber of [
            root,
            root == null ? void 0 : root.alternate
        ]){
            if (!maybeFiber) continue;
            const fiber2 = $5180c63364f801a2$export$e2f435051054a3fd(maybeFiber, false, (node)=>{
                let state = node.memoizedState;
                while(state){
                    if (state.memoizedState === id) return true;
                    state = state.next;
                }
            });
            if (fiber2) return fiber2;
        }
    }, [
        root,
        id
    ]);
    return fiber;
}
function $5180c63364f801a2$export$b537cf6ebaf7ff54() {
    const fiber = $5180c63364f801a2$export$69c8591d5df5c7d6();
    const root = $aqdBs.useMemo(()=>$5180c63364f801a2$export$e2f435051054a3fd(fiber, true, (node)=>{
            var _a2;
            return ((_a2 = node.stateNode) == null ? void 0 : _a2.containerInfo) != null;
        }), [
        fiber
    ]);
    return root == null ? void 0 : root.stateNode.containerInfo;
}
function $5180c63364f801a2$export$aec415ac1d7388b6(type) {
    const fiber = $5180c63364f801a2$export$69c8591d5df5c7d6();
    const childRef = $aqdBs.useRef();
    $5180c63364f801a2$var$useIsomorphicLayoutEffect(()=>{
        var _a2;
        childRef.current = (_a2 = $5180c63364f801a2$export$e2f435051054a3fd(fiber, false, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a2.stateNode;
    }, [
        fiber
    ]);
    return childRef;
}
function $5180c63364f801a2$export$b57c9fdd1434988b(type) {
    const fiber = $5180c63364f801a2$export$69c8591d5df5c7d6();
    const parentRef = $aqdBs.useRef();
    $5180c63364f801a2$var$useIsomorphicLayoutEffect(()=>{
        var _a2;
        parentRef.current = (_a2 = $5180c63364f801a2$export$e2f435051054a3fd(fiber, true, (node)=>typeof node.type === "string" && (type === void 0 || node.type === type))) == null ? void 0 : _a2.stateNode;
    }, [
        fiber
    ]);
    return parentRef;
}
function $5180c63364f801a2$export$8859381a76e56404() {
    const fiber = $5180c63364f801a2$export$69c8591d5df5c7d6();
    const [contextMap] = $aqdBs.useState(()=>/* @__PURE__ */ new Map());
    contextMap.clear();
    let node = fiber;
    while(node){
        if (node.type && typeof node.type === "object") {
            const enableRenderableContext = node.type._context === void 0 && node.type.Provider === node.type;
            const context = enableRenderableContext ? node.type : node.type._context;
            if (context && context !== $5180c63364f801a2$var$FiberContext && !contextMap.has(context)) contextMap.set(context, $aqdBs.useContext($5180c63364f801a2$var$wrapContext(context)));
        }
        node = node.return;
    }
    return contextMap;
}
function $5180c63364f801a2$export$39579d26c695d393() {
    const contextMap = $5180c63364f801a2$export$8859381a76e56404();
    return $aqdBs.useMemo(()=>Array.from(contextMap.keys()).reduce((Prev, context)=>(props)=>/* @__PURE__ */ $aqdBs.createElement(Prev, null, /* @__PURE__ */ $aqdBs.createElement(context.Provider, $5180c63364f801a2$var$__spreadProps($5180c63364f801a2$var$__spreadValues({}, props), {
                    value: contextMap.get(context)
                }))), (props)=>/* @__PURE__ */ $aqdBs.createElement($5180c63364f801a2$export$5a20fcbfd44d38b7, $5180c63364f801a2$var$__spreadValues({}, props))), [
        contextMap
    ]);
}







parcelRequire("bdSvy");
const $202e52471ee65b86$var$CanvasImpl = /*#__PURE__*/ $aqdBs.forwardRef(function Canvas({ children: children, fallback: fallback, resize: resize, style: style, gl: gl, events: events = (0, $62815e5999fdef70$export$db3b6bfb95261072), eventSource: eventSource, eventPrefix: eventPrefix, shadows: shadows, linear: linear, flat: flat, legacy: legacy, orthographic: orthographic, frameloop: frameloop, dpr: dpr, performance: performance, raycaster: raycaster, camera: camera, scene: scene, onPointerMissed: onPointerMissed, onCreated: onCreated, ...props }, forwardedRef) {
    // Create a known catalogue of Threejs-native elements
    // This will include the entire THREE namespace by default, users can extend
    // their own elements by using the createRoot API instead
    $aqdBs.useMemo(()=>(0, $62815e5999fdef70$export$f1e1789686576879)($548f161e17fc6f48$exports), []);
    const Bridge = (0, $5180c63364f801a2$export$39579d26c695d393)();
    const [containerRef, containerRect] = (0, $6c5a66ef2351b837$export$2e2bcd8739ae039)({
        scroll: true,
        debounce: {
            scroll: 50,
            resize: 0
        },
        ...resize
    });
    const canvasRef = $aqdBs.useRef(null);
    const divRef = $aqdBs.useRef(null);
    $aqdBs.useImperativeHandle(forwardedRef, ()=>canvasRef.current);
    const handlePointerMissed = (0, $62815e5999fdef70$export$3b14a55fb2447963)(onPointerMissed);
    const [block, setBlock] = $aqdBs.useState(false);
    const [error, setError] = $aqdBs.useState(false);
    // Suspend this component if block is a promise (2nd run)
    if (block) throw block;
    // Throw exception outwards if anything within canvas throws
    if (error) throw error;
    const root = $aqdBs.useRef(null);
    (0, $62815e5999fdef70$export$407448d2b89b1813)(()=>{
        const canvas = canvasRef.current;
        if (containerRect.width > 0 && containerRect.height > 0 && canvas) {
            if (!root.current) root.current = (0, $62815e5999fdef70$export$8b22cf2602fb60ce)(canvas);
            root.current.configure({
                gl: gl,
                events: events,
                shadows: shadows,
                linear: linear,
                flat: flat,
                legacy: legacy,
                orthographic: orthographic,
                frameloop: frameloop,
                dpr: dpr,
                performance: performance,
                raycaster: raycaster,
                camera: camera,
                scene: scene,
                size: containerRect,
                // Pass mutable reference to onPointerMissed so it's free to update
                onPointerMissed: (...args)=>handlePointerMissed.current == null ? void 0 : handlePointerMissed.current(...args),
                onCreated: (state)=>{
                    // Connect to event source
                    state.events.connect == null || state.events.connect(eventSource ? (0, $62815e5999fdef70$export$23f2a1d2818174ef)(eventSource) ? eventSource.current : eventSource : divRef.current);
                    // Set up compute function
                    if (eventPrefix) state.setEvents({
                        compute: (event, state)=>{
                            const x = event[eventPrefix + 'X'];
                            const y = event[eventPrefix + 'Y'];
                            state.pointer.set(x / state.size.width * 2 - 1, -(y / state.size.height) * 2 + 1);
                            state.raycaster.setFromCamera(state.pointer, state.camera);
                        }
                    });
                    // Call onCreated callback
                    onCreated == null || onCreated(state);
                }
            });
            root.current.render(/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)(Bridge, {
                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $62815e5999fdef70$export$a9c23c6ac3fc3eca), {
                    set: setError,
                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($aqdBs.Suspense, {
                        fallback: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $62815e5999fdef70$export$ef35774e6d314e91), {
                            set: setBlock
                        }),
                        children: children != null ? children : null
                    })
                })
            }));
        }
    });
    $aqdBs.useEffect(()=>{
        const canvas = canvasRef.current;
        if (canvas) return ()=>(0, $62815e5999fdef70$export$4368d992c4eafac0)(canvas);
    }, []);
    // When the event source is not this div, we need to set pointer-events to none
    // Or else the canvas will block events from reaching the event source
    const pointerEvents = eventSource ? 'none' : 'auto';
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
        ref: divRef,
        style: {
            position: 'relative',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            pointerEvents: pointerEvents,
            ...style
        },
        ...props,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            ref: containerRef,
            style: {
                width: '100%',
                height: '100%'
            },
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("canvas", {
                ref: canvasRef,
                style: {
                    display: 'block'
                },
                children: fallback
            })
        })
    });
});
/**
 * A DOM canvas which accepts threejs elements as children.
 * @see https://docs.pmnd.rs/react-three-fiber/api/canvas
 */ const $202e52471ee65b86$export$8d01c972ee8b14a9 = /*#__PURE__*/ $aqdBs.forwardRef(function CanvasWrapper(props, ref) {
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $5180c63364f801a2$export$5a20fcbfd44d38b7), {
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($202e52471ee65b86$var$CanvasImpl, {
            ...props,
            ref: ref
        })
    });
});





var $aqdBs = parcelRequire("aqdBs");



var $aqdBs = parcelRequire("aqdBs");



const $103e5777fe43b6ae$var$_box = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$6f7d5a9418ab2aa3)();
const $103e5777fe43b6ae$var$_vector = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$64b5c384219d3699)();
class $103e5777fe43b6ae$export$5b1256aa5274bf8 extends (0, $548f161e17fc6f48$export$231f009cbe414146) {
    constructor(){
        super();
        this.isLineSegmentsGeometry = true;
        this.type = "LineSegmentsGeometry";
        const positions = [
            -1,
            2,
            0,
            1,
            2,
            0,
            -1,
            1,
            0,
            1,
            1,
            0,
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const uvs = [
            -1,
            2,
            1,
            2,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -2,
            1,
            -2
        ];
        const index = [
            0,
            2,
            1,
            2,
            3,
            1,
            2,
            4,
            3,
            4,
            5,
            3,
            4,
            6,
            5,
            6,
            7,
            5
        ];
        this.setIndex(index);
        this.setAttribute("position", new (0, $548f161e17fc6f48$export$cbe7a62641830ebd)(positions, 3));
        this.setAttribute("uv", new (0, $548f161e17fc6f48$export$cbe7a62641830ebd)(uvs, 2));
    }
    applyMatrix4(matrix) {
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== void 0) {
            start.applyMatrix4(matrix);
            end.applyMatrix4(matrix);
            start.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    setPositions(array) {
        let lineSegments;
        if (array instanceof Float32Array) lineSegments = array;
        else if (Array.isArray(array)) lineSegments = new Float32Array(array);
        const instanceBuffer = new (0, $548f161e17fc6f48$export$25ec0e1af1389358)(lineSegments, 6, 1);
        this.setAttribute("instanceStart", new (0, $548f161e17fc6f48$export$920b6d07334599c7)(instanceBuffer, 3, 0));
        this.setAttribute("instanceEnd", new (0, $548f161e17fc6f48$export$920b6d07334599c7)(instanceBuffer, 3, 3));
        this.computeBoundingBox();
        this.computeBoundingSphere();
        return this;
    }
    setColors(array, itemSize = 3) {
        let colors;
        if (array instanceof Float32Array) colors = array;
        else if (Array.isArray(array)) colors = new Float32Array(array);
        const instanceColorBuffer = new (0, $548f161e17fc6f48$export$25ec0e1af1389358)(colors, itemSize * 2, 1);
        this.setAttribute("instanceColorStart", new (0, $548f161e17fc6f48$export$920b6d07334599c7)(instanceColorBuffer, itemSize, 0));
        this.setAttribute("instanceColorEnd", new (0, $548f161e17fc6f48$export$920b6d07334599c7)(instanceColorBuffer, itemSize, itemSize));
        return this;
    }
    fromWireframeGeometry(geometry) {
        this.setPositions(geometry.attributes.position.array);
        return this;
    }
    fromEdgesGeometry(geometry) {
        this.setPositions(geometry.attributes.position.array);
        return this;
    }
    fromMesh(mesh) {
        this.fromWireframeGeometry(new (0, $548f161e17fc6f48$export$4b739da06d24892b)(mesh.geometry));
        return this;
    }
    fromLineSegments(lineSegments) {
        const geometry = lineSegments.geometry;
        this.setPositions(geometry.attributes.position.array);
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new (0, $548f161e17fc6f48$export$6f7d5a9418ab2aa3)();
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== void 0 && end !== void 0) {
            this.boundingBox.setFromBufferAttribute(start);
            $103e5777fe43b6ae$var$_box.setFromBufferAttribute(end);
            this.boundingBox.union($103e5777fe43b6ae$var$_box);
        }
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new (0, $548f161e17fc6f48$export$805e8b72413ccaba)();
        if (this.boundingBox === null) this.computeBoundingBox();
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== void 0 && end !== void 0) {
            const center = this.boundingSphere.center;
            this.boundingBox.getCenter(center);
            let maxRadiusSq = 0;
            for(let i = 0, il = start.count; i < il; i++){
                $103e5777fe43b6ae$var$_vector.fromBufferAttribute(start, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($103e5777fe43b6ae$var$_vector));
                $103e5777fe43b6ae$var$_vector.fromBufferAttribute(end, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($103e5777fe43b6ae$var$_vector));
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error("THREE.LineSegmentsGeometry.computeBoundingSphere(): Computed radius is NaN. The instanced position data is likely to have NaN values.", this);
        }
    }
    toJSON() {}
    applyMatrix(matrix) {
        console.warn("THREE.LineSegmentsGeometry: applyMatrix() has been renamed to applyMatrix4().");
        return this.applyMatrix4(matrix);
    }
}




const $12228736fe03cf4d$export$83d89fbfd8236492 = /* @__PURE__ */ (()=>parseInt((0, $548f161e17fc6f48$export$3545e07a80636437).replace(/\D+/g, "")))();


class $23e34b81570e349d$export$d19cd1378966f3d3 extends (0, $548f161e17fc6f48$export$83c7d75d550a8b0d) {
    constructor(parameters){
        super({
            type: "LineMaterial",
            uniforms: (0, $548f161e17fc6f48$export$d8ecdf8615bfea69).clone((0, $548f161e17fc6f48$export$d8ecdf8615bfea69).merge([
                (0, $548f161e17fc6f48$export$6643083551874bf5).common,
                (0, $548f161e17fc6f48$export$6643083551874bf5).fog,
                {
                    worldUnits: {
                        value: 1
                    },
                    linewidth: {
                        value: 1
                    },
                    resolution: {
                        value: new (0, $548f161e17fc6f48$export$c977b3e384af9ae1)(1, 1)
                    },
                    dashOffset: {
                        value: 0
                    },
                    dashScale: {
                        value: 1
                    },
                    dashSize: {
                        value: 1
                    },
                    gapSize: {
                        value: 1
                    }
                }
            ])),
            vertexShader: /* glsl */ `
				#include <common>
				#include <fog_pars_vertex>
				#include <logdepthbuf_pars_vertex>
				#include <clipping_planes_pars_vertex>

				uniform float linewidth;
				uniform vec2 resolution;

				attribute vec3 instanceStart;
				attribute vec3 instanceEnd;

				#ifdef USE_COLOR
					#ifdef USE_LINE_COLOR_ALPHA
						varying vec4 vLineColor;
						attribute vec4 instanceColorStart;
						attribute vec4 instanceColorEnd;
					#else
						varying vec3 vLineColor;
						attribute vec3 instanceColorStart;
						attribute vec3 instanceColorEnd;
					#endif
				#endif

				#ifdef WORLD_UNITS

					varying vec4 worldPos;
					varying vec3 worldStart;
					varying vec3 worldEnd;

					#ifdef USE_DASH

						varying vec2 vUv;

					#endif

				#else

					varying vec2 vUv;

				#endif

				#ifdef USE_DASH

					uniform float dashScale;
					attribute float instanceDistanceStart;
					attribute float instanceDistanceEnd;
					varying float vLineDistance;

				#endif

				void trimSegment( const in vec4 start, inout vec4 end ) {

					// trim end segment so it terminates between the camera plane and the near plane

					// conservative estimate of the near plane
					float a = projectionMatrix[ 2 ][ 2 ]; // 3nd entry in 3th column
					float b = projectionMatrix[ 3 ][ 2 ]; // 3nd entry in 4th column
					float nearEstimate = - 0.5 * b / a;

					float alpha = ( nearEstimate - start.z ) / ( end.z - start.z );

					end.xyz = mix( start.xyz, end.xyz, alpha );

				}

				void main() {

					#ifdef USE_COLOR

						vLineColor = ( position.y < 0.5 ) ? instanceColorStart : instanceColorEnd;

					#endif

					#ifdef USE_DASH

						vLineDistance = ( position.y < 0.5 ) ? dashScale * instanceDistanceStart : dashScale * instanceDistanceEnd;
						vUv = uv;

					#endif

					float aspect = resolution.x / resolution.y;

					// camera space
					vec4 start = modelViewMatrix * vec4( instanceStart, 1.0 );
					vec4 end = modelViewMatrix * vec4( instanceEnd, 1.0 );

					#ifdef WORLD_UNITS

						worldStart = start.xyz;
						worldEnd = end.xyz;

					#else

						vUv = uv;

					#endif

					// special case for perspective projection, and segments that terminate either in, or behind, the camera plane
					// clearly the gpu firmware has a way of addressing this issue when projecting into ndc space
					// but we need to perform ndc-space calculations in the shader, so we must address this issue directly
					// perhaps there is a more elegant solution -- WestLangley

					bool perspective = ( projectionMatrix[ 2 ][ 3 ] == - 1.0 ); // 4th entry in the 3rd column

					if ( perspective ) {

						if ( start.z < 0.0 && end.z >= 0.0 ) {

							trimSegment( start, end );

						} else if ( end.z < 0.0 && start.z >= 0.0 ) {

							trimSegment( end, start );

						}

					}

					// clip space
					vec4 clipStart = projectionMatrix * start;
					vec4 clipEnd = projectionMatrix * end;

					// ndc space
					vec3 ndcStart = clipStart.xyz / clipStart.w;
					vec3 ndcEnd = clipEnd.xyz / clipEnd.w;

					// direction
					vec2 dir = ndcEnd.xy - ndcStart.xy;

					// account for clip-space aspect ratio
					dir.x *= aspect;
					dir = normalize( dir );

					#ifdef WORLD_UNITS

						// get the offset direction as perpendicular to the view vector
						vec3 worldDir = normalize( end.xyz - start.xyz );
						vec3 offset;
						if ( position.y < 0.5 ) {

							offset = normalize( cross( start.xyz, worldDir ) );

						} else {

							offset = normalize( cross( end.xyz, worldDir ) );

						}

						// sign flip
						if ( position.x < 0.0 ) offset *= - 1.0;

						float forwardOffset = dot( worldDir, vec3( 0.0, 0.0, 1.0 ) );

						// don't extend the line if we're rendering dashes because we
						// won't be rendering the endcaps
						#ifndef USE_DASH

							// extend the line bounds to encompass  endcaps
							start.xyz += - worldDir * linewidth * 0.5;
							end.xyz += worldDir * linewidth * 0.5;

							// shift the position of the quad so it hugs the forward edge of the line
							offset.xy -= dir * forwardOffset;
							offset.z += 0.5;

						#endif

						// endcaps
						if ( position.y > 1.0 || position.y < 0.0 ) {

							offset.xy += dir * 2.0 * forwardOffset;

						}

						// adjust for linewidth
						offset *= linewidth * 0.5;

						// set the world position
						worldPos = ( position.y < 0.5 ) ? start : end;
						worldPos.xyz += offset;

						// project the worldpos
						vec4 clip = projectionMatrix * worldPos;

						// shift the depth of the projected points so the line
						// segments overlap neatly
						vec3 clipPose = ( position.y < 0.5 ) ? ndcStart : ndcEnd;
						clip.z = clipPose.z * clip.w;

					#else

						vec2 offset = vec2( dir.y, - dir.x );
						// undo aspect ratio adjustment
						dir.x /= aspect;
						offset.x /= aspect;

						// sign flip
						if ( position.x < 0.0 ) offset *= - 1.0;

						// endcaps
						if ( position.y < 0.0 ) {

							offset += - dir;

						} else if ( position.y > 1.0 ) {

							offset += dir;

						}

						// adjust for linewidth
						offset *= linewidth;

						// adjust for clip-space to screen-space conversion // maybe resolution should be based on viewport ...
						offset /= resolution.y;

						// select end
						vec4 clip = ( position.y < 0.5 ) ? clipStart : clipEnd;

						// back to clip space
						offset *= clip.w;

						clip.xy += offset;

					#endif

					gl_Position = clip;

					vec4 mvPosition = ( position.y < 0.5 ) ? start : end; // this is an approximation

					#include <logdepthbuf_vertex>
					#include <clipping_planes_vertex>
					#include <fog_vertex>

				}
			`,
            fragmentShader: /* glsl */ `
				uniform vec3 diffuse;
				uniform float opacity;
				uniform float linewidth;

				#ifdef USE_DASH

					uniform float dashOffset;
					uniform float dashSize;
					uniform float gapSize;

				#endif

				varying float vLineDistance;

				#ifdef WORLD_UNITS

					varying vec4 worldPos;
					varying vec3 worldStart;
					varying vec3 worldEnd;

					#ifdef USE_DASH

						varying vec2 vUv;

					#endif

				#else

					varying vec2 vUv;

				#endif

				#include <common>
				#include <fog_pars_fragment>
				#include <logdepthbuf_pars_fragment>
				#include <clipping_planes_pars_fragment>

				#ifdef USE_COLOR
					#ifdef USE_LINE_COLOR_ALPHA
						varying vec4 vLineColor;
					#else
						varying vec3 vLineColor;
					#endif
				#endif

				vec2 closestLineToLine(vec3 p1, vec3 p2, vec3 p3, vec3 p4) {

					float mua;
					float mub;

					vec3 p13 = p1 - p3;
					vec3 p43 = p4 - p3;

					vec3 p21 = p2 - p1;

					float d1343 = dot( p13, p43 );
					float d4321 = dot( p43, p21 );
					float d1321 = dot( p13, p21 );
					float d4343 = dot( p43, p43 );
					float d2121 = dot( p21, p21 );

					float denom = d2121 * d4343 - d4321 * d4321;

					float numer = d1343 * d4321 - d1321 * d4343;

					mua = numer / denom;
					mua = clamp( mua, 0.0, 1.0 );
					mub = ( d1343 + d4321 * ( mua ) ) / d4343;
					mub = clamp( mub, 0.0, 1.0 );

					return vec2( mua, mub );

				}

				void main() {

					#include <clipping_planes_fragment>

					#ifdef USE_DASH

						if ( vUv.y < - 1.0 || vUv.y > 1.0 ) discard; // discard endcaps

						if ( mod( vLineDistance + dashOffset, dashSize + gapSize ) > dashSize ) discard; // todo - FIX

					#endif

					float alpha = opacity;

					#ifdef WORLD_UNITS

						// Find the closest points on the view ray and the line segment
						vec3 rayEnd = normalize( worldPos.xyz ) * 1e5;
						vec3 lineDir = worldEnd - worldStart;
						vec2 params = closestLineToLine( worldStart, worldEnd, vec3( 0.0, 0.0, 0.0 ), rayEnd );

						vec3 p1 = worldStart + lineDir * params.x;
						vec3 p2 = rayEnd * params.y;
						vec3 delta = p1 - p2;
						float len = length( delta );
						float norm = len / linewidth;

						#ifndef USE_DASH

							#ifdef USE_ALPHA_TO_COVERAGE

								float dnorm = fwidth( norm );
								alpha = 1.0 - smoothstep( 0.5 - dnorm, 0.5 + dnorm, norm );

							#else

								if ( norm > 0.5 ) {

									discard;

								}

							#endif

						#endif

					#else

						#ifdef USE_ALPHA_TO_COVERAGE

							// artifacts appear on some hardware if a derivative is taken within a conditional
							float a = vUv.x;
							float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
							float len2 = a * a + b * b;
							float dlen = fwidth( len2 );

							if ( abs( vUv.y ) > 1.0 ) {

								alpha = 1.0 - smoothstep( 1.0 - dlen, 1.0 + dlen, len2 );

							}

						#else

							if ( abs( vUv.y ) > 1.0 ) {

								float a = vUv.x;
								float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
								float len2 = a * a + b * b;

								if ( len2 > 1.0 ) discard;

							}

						#endif

					#endif

					vec4 diffuseColor = vec4( diffuse, alpha );
					#ifdef USE_COLOR
						#ifdef USE_LINE_COLOR_ALPHA
							diffuseColor *= vLineColor;
						#else
							diffuseColor.rgb *= vLineColor;
						#endif
					#endif

					#include <logdepthbuf_fragment>

					gl_FragColor = diffuseColor;

					#include <tonemapping_fragment>
					#include <${(0, $12228736fe03cf4d$export$83d89fbfd8236492) >= 154 ? "colorspace_fragment" : "encodings_fragment"}>
					#include <fog_fragment>
					#include <premultiplied_alpha_fragment>

				}
			`,
            clipping: true
        });
        this.isLineMaterial = true;
        this.onBeforeCompile = function() {
            if (this.transparent) this.defines.USE_LINE_COLOR_ALPHA = "1";
            else delete this.defines.USE_LINE_COLOR_ALPHA;
        };
        Object.defineProperties(this, {
            color: {
                enumerable: true,
                get: function() {
                    return this.uniforms.diffuse.value;
                },
                set: function(value) {
                    this.uniforms.diffuse.value = value;
                }
            },
            worldUnits: {
                enumerable: true,
                get: function() {
                    return "WORLD_UNITS" in this.defines;
                },
                set: function(value) {
                    if (value === true) this.defines.WORLD_UNITS = "";
                    else delete this.defines.WORLD_UNITS;
                }
            },
            linewidth: {
                enumerable: true,
                get: function() {
                    return this.uniforms.linewidth.value;
                },
                set: function(value) {
                    this.uniforms.linewidth.value = value;
                }
            },
            dashed: {
                enumerable: true,
                get: function() {
                    return Boolean("USE_DASH" in this.defines);
                },
                set (value) {
                    if (Boolean(value) !== Boolean("USE_DASH" in this.defines)) this.needsUpdate = true;
                    if (value === true) this.defines.USE_DASH = "";
                    else delete this.defines.USE_DASH;
                }
            },
            dashScale: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashScale.value;
                },
                set: function(value) {
                    this.uniforms.dashScale.value = value;
                }
            },
            dashSize: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashSize.value;
                },
                set: function(value) {
                    this.uniforms.dashSize.value = value;
                }
            },
            dashOffset: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashOffset.value;
                },
                set: function(value) {
                    this.uniforms.dashOffset.value = value;
                }
            },
            gapSize: {
                enumerable: true,
                get: function() {
                    return this.uniforms.gapSize.value;
                },
                set: function(value) {
                    this.uniforms.gapSize.value = value;
                }
            },
            opacity: {
                enumerable: true,
                get: function() {
                    return this.uniforms.opacity.value;
                },
                set: function(value) {
                    this.uniforms.opacity.value = value;
                }
            },
            resolution: {
                enumerable: true,
                get: function() {
                    return this.uniforms.resolution.value;
                },
                set: function(value) {
                    this.uniforms.resolution.value.copy(value);
                }
            },
            alphaToCoverage: {
                enumerable: true,
                get: function() {
                    return Boolean("USE_ALPHA_TO_COVERAGE" in this.defines);
                },
                set: function(value) {
                    if (Boolean(value) !== Boolean("USE_ALPHA_TO_COVERAGE" in this.defines)) this.needsUpdate = true;
                    if (value === true) {
                        this.defines.USE_ALPHA_TO_COVERAGE = "";
                        this.extensions.derivatives = true;
                    } else {
                        delete this.defines.USE_ALPHA_TO_COVERAGE;
                        this.extensions.derivatives = false;
                    }
                }
            }
        });
        this.setValues(parameters);
    }
}



const $2ff5c87620338cf5$export$70dc8fe4adde7c17 = (0, $12228736fe03cf4d$export$83d89fbfd8236492) >= 125 ? "uv1" : "uv2";


const $87ecb77707109d40$var$_viewport = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$fa7daccca11cdbe3)();
const $87ecb77707109d40$var$_start = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$64b5c384219d3699)();
const $87ecb77707109d40$var$_end = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$64b5c384219d3699)();
const $87ecb77707109d40$var$_start4 = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$fa7daccca11cdbe3)();
const $87ecb77707109d40$var$_end4 = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$fa7daccca11cdbe3)();
const $87ecb77707109d40$var$_ssOrigin = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$fa7daccca11cdbe3)();
const $87ecb77707109d40$var$_ssOrigin3 = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$64b5c384219d3699)();
const $87ecb77707109d40$var$_mvMatrix = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$2ae72fc923e5eb5)();
const $87ecb77707109d40$var$_line = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$e0ba6359f1954fd3)();
const $87ecb77707109d40$var$_closestPoint = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$64b5c384219d3699)();
const $87ecb77707109d40$var$_box = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$6f7d5a9418ab2aa3)();
const $87ecb77707109d40$var$_sphere = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$805e8b72413ccaba)();
const $87ecb77707109d40$var$_clipToWorldVector = /* @__PURE__ */ new (0, $548f161e17fc6f48$export$fa7daccca11cdbe3)();
let $87ecb77707109d40$var$_ray, $87ecb77707109d40$var$_lineWidth;
function $87ecb77707109d40$var$getWorldSpaceHalfWidth(camera, distance, resolution) {
    $87ecb77707109d40$var$_clipToWorldVector.set(0, 0, -distance, 1).applyMatrix4(camera.projectionMatrix);
    $87ecb77707109d40$var$_clipToWorldVector.multiplyScalar(1 / $87ecb77707109d40$var$_clipToWorldVector.w);
    $87ecb77707109d40$var$_clipToWorldVector.x = $87ecb77707109d40$var$_lineWidth / resolution.width;
    $87ecb77707109d40$var$_clipToWorldVector.y = $87ecb77707109d40$var$_lineWidth / resolution.height;
    $87ecb77707109d40$var$_clipToWorldVector.applyMatrix4(camera.projectionMatrixInverse);
    $87ecb77707109d40$var$_clipToWorldVector.multiplyScalar(1 / $87ecb77707109d40$var$_clipToWorldVector.w);
    return Math.abs(Math.max($87ecb77707109d40$var$_clipToWorldVector.x, $87ecb77707109d40$var$_clipToWorldVector.y));
}
function $87ecb77707109d40$var$raycastWorldUnits(lineSegments, intersects) {
    const matrixWorld = lineSegments.matrixWorld;
    const geometry = lineSegments.geometry;
    const instanceStart = geometry.attributes.instanceStart;
    const instanceEnd = geometry.attributes.instanceEnd;
    const segmentCount = Math.min(geometry.instanceCount, instanceStart.count);
    for(let i = 0, l = segmentCount; i < l; i++){
        $87ecb77707109d40$var$_line.start.fromBufferAttribute(instanceStart, i);
        $87ecb77707109d40$var$_line.end.fromBufferAttribute(instanceEnd, i);
        $87ecb77707109d40$var$_line.applyMatrix4(matrixWorld);
        const pointOnLine = new (0, $548f161e17fc6f48$export$64b5c384219d3699)();
        const point = new (0, $548f161e17fc6f48$export$64b5c384219d3699)();
        $87ecb77707109d40$var$_ray.distanceSqToSegment($87ecb77707109d40$var$_line.start, $87ecb77707109d40$var$_line.end, point, pointOnLine);
        const isInside = point.distanceTo(pointOnLine) < $87ecb77707109d40$var$_lineWidth * 0.5;
        if (isInside) intersects.push({
            point: point,
            pointOnLine: pointOnLine,
            distance: $87ecb77707109d40$var$_ray.origin.distanceTo(point),
            object: lineSegments,
            face: null,
            faceIndex: i,
            uv: null,
            [(0, $2ff5c87620338cf5$export$70dc8fe4adde7c17)]: null
        });
    }
}
function $87ecb77707109d40$var$raycastScreenSpace(lineSegments, camera, intersects) {
    const projectionMatrix = camera.projectionMatrix;
    const material = lineSegments.material;
    const resolution = material.resolution;
    const matrixWorld = lineSegments.matrixWorld;
    const geometry = lineSegments.geometry;
    const instanceStart = geometry.attributes.instanceStart;
    const instanceEnd = geometry.attributes.instanceEnd;
    const segmentCount = Math.min(geometry.instanceCount, instanceStart.count);
    const near = -camera.near;
    $87ecb77707109d40$var$_ray.at(1, $87ecb77707109d40$var$_ssOrigin);
    $87ecb77707109d40$var$_ssOrigin.w = 1;
    $87ecb77707109d40$var$_ssOrigin.applyMatrix4(camera.matrixWorldInverse);
    $87ecb77707109d40$var$_ssOrigin.applyMatrix4(projectionMatrix);
    $87ecb77707109d40$var$_ssOrigin.multiplyScalar(1 / $87ecb77707109d40$var$_ssOrigin.w);
    $87ecb77707109d40$var$_ssOrigin.x *= resolution.x / 2;
    $87ecb77707109d40$var$_ssOrigin.y *= resolution.y / 2;
    $87ecb77707109d40$var$_ssOrigin.z = 0;
    $87ecb77707109d40$var$_ssOrigin3.copy($87ecb77707109d40$var$_ssOrigin);
    $87ecb77707109d40$var$_mvMatrix.multiplyMatrices(camera.matrixWorldInverse, matrixWorld);
    for(let i = 0, l = segmentCount; i < l; i++){
        $87ecb77707109d40$var$_start4.fromBufferAttribute(instanceStart, i);
        $87ecb77707109d40$var$_end4.fromBufferAttribute(instanceEnd, i);
        $87ecb77707109d40$var$_start4.w = 1;
        $87ecb77707109d40$var$_end4.w = 1;
        $87ecb77707109d40$var$_start4.applyMatrix4($87ecb77707109d40$var$_mvMatrix);
        $87ecb77707109d40$var$_end4.applyMatrix4($87ecb77707109d40$var$_mvMatrix);
        const isBehindCameraNear = $87ecb77707109d40$var$_start4.z > near && $87ecb77707109d40$var$_end4.z > near;
        if (isBehindCameraNear) continue;
        if ($87ecb77707109d40$var$_start4.z > near) {
            const deltaDist = $87ecb77707109d40$var$_start4.z - $87ecb77707109d40$var$_end4.z;
            const t = ($87ecb77707109d40$var$_start4.z - near) / deltaDist;
            $87ecb77707109d40$var$_start4.lerp($87ecb77707109d40$var$_end4, t);
        } else if ($87ecb77707109d40$var$_end4.z > near) {
            const deltaDist = $87ecb77707109d40$var$_end4.z - $87ecb77707109d40$var$_start4.z;
            const t = ($87ecb77707109d40$var$_end4.z - near) / deltaDist;
            $87ecb77707109d40$var$_end4.lerp($87ecb77707109d40$var$_start4, t);
        }
        $87ecb77707109d40$var$_start4.applyMatrix4(projectionMatrix);
        $87ecb77707109d40$var$_end4.applyMatrix4(projectionMatrix);
        $87ecb77707109d40$var$_start4.multiplyScalar(1 / $87ecb77707109d40$var$_start4.w);
        $87ecb77707109d40$var$_end4.multiplyScalar(1 / $87ecb77707109d40$var$_end4.w);
        $87ecb77707109d40$var$_start4.x *= resolution.x / 2;
        $87ecb77707109d40$var$_start4.y *= resolution.y / 2;
        $87ecb77707109d40$var$_end4.x *= resolution.x / 2;
        $87ecb77707109d40$var$_end4.y *= resolution.y / 2;
        $87ecb77707109d40$var$_line.start.copy($87ecb77707109d40$var$_start4);
        $87ecb77707109d40$var$_line.start.z = 0;
        $87ecb77707109d40$var$_line.end.copy($87ecb77707109d40$var$_end4);
        $87ecb77707109d40$var$_line.end.z = 0;
        const param = $87ecb77707109d40$var$_line.closestPointToPointParameter($87ecb77707109d40$var$_ssOrigin3, true);
        $87ecb77707109d40$var$_line.at(param, $87ecb77707109d40$var$_closestPoint);
        const zPos = (0, $548f161e17fc6f48$export$6a7ef315a0d1ef07).lerp($87ecb77707109d40$var$_start4.z, $87ecb77707109d40$var$_end4.z, param);
        const isInClipSpace = zPos >= -1 && zPos <= 1;
        const isInside = $87ecb77707109d40$var$_ssOrigin3.distanceTo($87ecb77707109d40$var$_closestPoint) < $87ecb77707109d40$var$_lineWidth * 0.5;
        if (isInClipSpace && isInside) {
            $87ecb77707109d40$var$_line.start.fromBufferAttribute(instanceStart, i);
            $87ecb77707109d40$var$_line.end.fromBufferAttribute(instanceEnd, i);
            $87ecb77707109d40$var$_line.start.applyMatrix4(matrixWorld);
            $87ecb77707109d40$var$_line.end.applyMatrix4(matrixWorld);
            const pointOnLine = new (0, $548f161e17fc6f48$export$64b5c384219d3699)();
            const point = new (0, $548f161e17fc6f48$export$64b5c384219d3699)();
            $87ecb77707109d40$var$_ray.distanceSqToSegment($87ecb77707109d40$var$_line.start, $87ecb77707109d40$var$_line.end, point, pointOnLine);
            intersects.push({
                point: point,
                pointOnLine: pointOnLine,
                distance: $87ecb77707109d40$var$_ray.origin.distanceTo(point),
                object: lineSegments,
                face: null,
                faceIndex: i,
                uv: null,
                [(0, $2ff5c87620338cf5$export$70dc8fe4adde7c17)]: null
            });
        }
    }
}
class $87ecb77707109d40$export$6eda8f258bdba8c5 extends (0, $548f161e17fc6f48$export$e176487c05830cc5) {
    constructor(geometry = new (0, $103e5777fe43b6ae$export$5b1256aa5274bf8)(), material = new (0, $23e34b81570e349d$export$d19cd1378966f3d3)({
        color: Math.random() * 16777215
    })){
        super(geometry, material);
        this.isLineSegments2 = true;
        this.type = "LineSegments2";
    }
    // for backwards-compatibility, but could be a method of LineSegmentsGeometry...
    computeLineDistances() {
        const geometry = this.geometry;
        const instanceStart = geometry.attributes.instanceStart;
        const instanceEnd = geometry.attributes.instanceEnd;
        const lineDistances = new Float32Array(2 * instanceStart.count);
        for(let i = 0, j = 0, l = instanceStart.count; i < l; i++, j += 2){
            $87ecb77707109d40$var$_start.fromBufferAttribute(instanceStart, i);
            $87ecb77707109d40$var$_end.fromBufferAttribute(instanceEnd, i);
            lineDistances[j] = j === 0 ? 0 : lineDistances[j - 1];
            lineDistances[j + 1] = lineDistances[j] + $87ecb77707109d40$var$_start.distanceTo($87ecb77707109d40$var$_end);
        }
        const instanceDistanceBuffer = new (0, $548f161e17fc6f48$export$25ec0e1af1389358)(lineDistances, 2, 1);
        geometry.setAttribute("instanceDistanceStart", new (0, $548f161e17fc6f48$export$920b6d07334599c7)(instanceDistanceBuffer, 1, 0));
        geometry.setAttribute("instanceDistanceEnd", new (0, $548f161e17fc6f48$export$920b6d07334599c7)(instanceDistanceBuffer, 1, 1));
        return this;
    }
    raycast(raycaster, intersects) {
        const worldUnits = this.material.worldUnits;
        const camera = raycaster.camera;
        if (camera === null && !worldUnits) console.error('LineSegments2: "Raycaster.camera" needs to be set in order to raycast against LineSegments2 while worldUnits is set to false.');
        const threshold = raycaster.params.Line2 !== void 0 ? raycaster.params.Line2.threshold || 0 : 0;
        $87ecb77707109d40$var$_ray = raycaster.ray;
        const matrixWorld = this.matrixWorld;
        const geometry = this.geometry;
        const material = this.material;
        $87ecb77707109d40$var$_lineWidth = material.linewidth + threshold;
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $87ecb77707109d40$var$_sphere.copy(geometry.boundingSphere).applyMatrix4(matrixWorld);
        let sphereMargin;
        if (worldUnits) sphereMargin = $87ecb77707109d40$var$_lineWidth * 0.5;
        else {
            const distanceToSphere = Math.max(camera.near, $87ecb77707109d40$var$_sphere.distanceToPoint($87ecb77707109d40$var$_ray.origin));
            sphereMargin = $87ecb77707109d40$var$getWorldSpaceHalfWidth(camera, distanceToSphere, material.resolution);
        }
        $87ecb77707109d40$var$_sphere.radius += sphereMargin;
        if ($87ecb77707109d40$var$_ray.intersectsSphere($87ecb77707109d40$var$_sphere) === false) return;
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        $87ecb77707109d40$var$_box.copy(geometry.boundingBox).applyMatrix4(matrixWorld);
        let boxMargin;
        if (worldUnits) boxMargin = $87ecb77707109d40$var$_lineWidth * 0.5;
        else {
            const distanceToBox = Math.max(camera.near, $87ecb77707109d40$var$_box.distanceToPoint($87ecb77707109d40$var$_ray.origin));
            boxMargin = $87ecb77707109d40$var$getWorldSpaceHalfWidth(camera, distanceToBox, material.resolution);
        }
        $87ecb77707109d40$var$_box.expandByScalar(boxMargin);
        if ($87ecb77707109d40$var$_ray.intersectsBox($87ecb77707109d40$var$_box) === false) return;
        if (worldUnits) $87ecb77707109d40$var$raycastWorldUnits(this, intersects);
        else $87ecb77707109d40$var$raycastScreenSpace(this, camera, intersects);
    }
    onBeforeRender(renderer) {
        const uniforms = this.material.uniforms;
        if (uniforms && uniforms.resolution) {
            renderer.getViewport($87ecb77707109d40$var$_viewport);
            this.material.uniforms.resolution.value.set($87ecb77707109d40$var$_viewport.z, $87ecb77707109d40$var$_viewport.w);
        }
    }
}



class $e42e579bbbcd25f0$export$dcc17b59d0a74bb5 extends (0, $103e5777fe43b6ae$export$5b1256aa5274bf8) {
    constructor(){
        super();
        this.isLineGeometry = true;
        this.type = "LineGeometry";
    }
    setPositions(array) {
        const length = array.length - 3;
        const points = new Float32Array(2 * length);
        for(let i = 0; i < length; i += 3){
            points[2 * i] = array[i];
            points[2 * i + 1] = array[i + 1];
            points[2 * i + 2] = array[i + 2];
            points[2 * i + 3] = array[i + 3];
            points[2 * i + 4] = array[i + 4];
            points[2 * i + 5] = array[i + 5];
        }
        super.setPositions(points);
        return this;
    }
    setColors(array, itemSize = 3) {
        const length = array.length - itemSize;
        const colors = new Float32Array(2 * length);
        if (itemSize === 3) for(let i = 0; i < length; i += itemSize){
            colors[2 * i] = array[i];
            colors[2 * i + 1] = array[i + 1];
            colors[2 * i + 2] = array[i + 2];
            colors[2 * i + 3] = array[i + 3];
            colors[2 * i + 4] = array[i + 4];
            colors[2 * i + 5] = array[i + 5];
        }
        else for(let i = 0; i < length; i += itemSize){
            colors[2 * i] = array[i];
            colors[2 * i + 1] = array[i + 1];
            colors[2 * i + 2] = array[i + 2];
            colors[2 * i + 3] = array[i + 3];
            colors[2 * i + 4] = array[i + 4];
            colors[2 * i + 5] = array[i + 5];
            colors[2 * i + 6] = array[i + 6];
            colors[2 * i + 7] = array[i + 7];
        }
        super.setColors(colors, itemSize);
        return this;
    }
    fromLine(line) {
        const geometry = line.geometry;
        this.setPositions(geometry.attributes.position.array);
        return this;
    }
}



class $4516f467f1789faa$export$4e6fcde58d84e955 extends (0, $87ecb77707109d40$export$6eda8f258bdba8c5) {
    constructor(geometry = new (0, $e42e579bbbcd25f0$export$dcc17b59d0a74bb5)(), material = new (0, $23e34b81570e349d$export$d19cd1378966f3d3)({
        color: Math.random() * 16777215
    })){
        super(geometry, material);
        this.isLine2 = true;
        this.type = "Line2";
    }
}


const $6011a4bf8b5bc07b$var$context = /* @__PURE__ */ $aqdBs.createContext(null);
const $6011a4bf8b5bc07b$export$cfdc085ffca97c47 = /* @__PURE__ */ $aqdBs.forwardRef((props, forwardedRef)=>{
    $aqdBs.useMemo(()=>(0, $62815e5999fdef70$export$f1e1789686576879)({
            SegmentObject: $6011a4bf8b5bc07b$export$99347f97be32b5ff
        }), []);
    const { limit: limit = 1000, lineWidth: lineWidth = 1.0, children: children, ...rest } = props;
    const [segments, setSegments] = $aqdBs.useState([]);
    const [line] = $aqdBs.useState(()=>new (0, $4516f467f1789faa$export$4e6fcde58d84e955)());
    const [material] = $aqdBs.useState(()=>new (0, $23e34b81570e349d$export$d19cd1378966f3d3)());
    const [geometry] = $aqdBs.useState(()=>new (0, $103e5777fe43b6ae$export$5b1256aa5274bf8)());
    const [resolution] = $aqdBs.useState(()=>new $548f161e17fc6f48$export$c977b3e384af9ae1(512, 512));
    const [positions] = $aqdBs.useState(()=>Array(limit * 6).fill(0));
    const [colors] = $aqdBs.useState(()=>Array(limit * 6).fill(0));
    const api = $aqdBs.useMemo(()=>({
            subscribe: (ref)=>{
                setSegments((segments)=>[
                        ...segments,
                        ref
                    ]);
                return ()=>setSegments((segments)=>segments.filter((item)=>item.current !== ref.current));
            }
        }), []);
    (0, $62815e5999fdef70$export$d66501df72047452)(()=>{
        for(let i = 0; i < limit; i++){
            var _segments$i;
            const segment = (_segments$i = segments[i]) == null ? void 0 : _segments$i.current;
            if (segment) {
                positions[i * 6 + 0] = segment.start.x;
                positions[i * 6 + 1] = segment.start.y;
                positions[i * 6 + 2] = segment.start.z;
                positions[i * 6 + 3] = segment.end.x;
                positions[i * 6 + 4] = segment.end.y;
                positions[i * 6 + 5] = segment.end.z;
                colors[i * 6 + 0] = segment.color.r;
                colors[i * 6 + 1] = segment.color.g;
                colors[i * 6 + 2] = segment.color.b;
                colors[i * 6 + 3] = segment.color.r;
                colors[i * 6 + 4] = segment.color.g;
                colors[i * 6 + 5] = segment.color.b;
            }
        }
        geometry.setColors(colors);
        geometry.setPositions(positions);
        line.computeLineDistances();
    });
    return /*#__PURE__*/ $aqdBs.createElement("primitive", {
        object: line,
        ref: forwardedRef
    }, /*#__PURE__*/ $aqdBs.createElement("primitive", {
        object: geometry,
        attach: "geometry"
    }), /*#__PURE__*/ $aqdBs.createElement("primitive", (0, $c2edeac9f1827d96$export$2e2bcd8739ae039)({
        object: material,
        attach: "material",
        vertexColors: true,
        resolution: resolution,
        linewidth: lineWidth
    }, rest)), /*#__PURE__*/ $aqdBs.createElement($6011a4bf8b5bc07b$var$context.Provider, {
        value: api
    }, children));
});
class $6011a4bf8b5bc07b$export$99347f97be32b5ff {
    constructor(){
        this.color = new $548f161e17fc6f48$export$892596cec99bc70e('white');
        this.start = new $548f161e17fc6f48$export$64b5c384219d3699(0, 0, 0);
        this.end = new $548f161e17fc6f48$export$64b5c384219d3699(0, 0, 0);
    }
}
const $6011a4bf8b5bc07b$var$normPos = (pos)=>pos instanceof $548f161e17fc6f48$export$64b5c384219d3699 ? pos : new $548f161e17fc6f48$export$64b5c384219d3699(...typeof pos === 'number' ? [
        pos,
        pos,
        pos
    ] : pos);
const $6011a4bf8b5bc07b$export$d53aa5c5ab432700 = /* @__PURE__ */ $aqdBs.forwardRef(({ color: color, start: start, end: end }, forwardedRef)=>{
    const api = $aqdBs.useContext($6011a4bf8b5bc07b$var$context);
    if (!api) throw 'Segment must used inside Segments component.';
    const ref = $aqdBs.useRef(null);
    $aqdBs.useImperativeHandle(forwardedRef, ()=>ref.current, []);
    $aqdBs.useLayoutEffect(()=>api.subscribe(ref), []);
    return /*#__PURE__*/ $aqdBs.createElement("segmentObject", {
        ref: ref,
        color: color,
        start: $6011a4bf8b5bc07b$var$normPos(start),
        end: $6011a4bf8b5bc07b$var$normPos(end)
    });
});



function $7c39fcf879589ebd$var$getCuboidVertices(cuboid) {
    const cx = cuboid["position.x"];
    const cy = cuboid["position.y"];
    const cz = cuboid["position.z"];
    const dx = cuboid["dimensions.x"] / 2;
    const dy = cuboid["dimensions.y"] / 2;
    const dz = cuboid["dimensions.z"] / 2;
    const yaw = cuboid.yaw;
    const corners = [
        new (0, $548f161e17fc6f48$export$64b5c384219d3699)(-dx, -dy, -dz),
        new (0, $548f161e17fc6f48$export$64b5c384219d3699)(dx, -dy, -dz),
        new (0, $548f161e17fc6f48$export$64b5c384219d3699)(dx, -dy, dz),
        new (0, $548f161e17fc6f48$export$64b5c384219d3699)(-dx, -dy, dz),
        new (0, $548f161e17fc6f48$export$64b5c384219d3699)(-dx, dy, -dz),
        new (0, $548f161e17fc6f48$export$64b5c384219d3699)(dx, dy, -dz),
        new (0, $548f161e17fc6f48$export$64b5c384219d3699)(dx, dy, dz),
        new (0, $548f161e17fc6f48$export$64b5c384219d3699)(-dx, dy, dz)
    ];
    const rotationMatrix = new (0, $548f161e17fc6f48$export$2ae72fc923e5eb5)().makeRotationZ(yaw);
    corners.forEach((v)=>v.applyMatrix4(rotationMatrix).add(new (0, $548f161e17fc6f48$export$64b5c384219d3699)(cx, cy, cz)));
    return corners;
}
const $7c39fcf879589ebd$var$popoverGraceTime = 800;
function $7c39fcf879589ebd$export$bdc9a4b508f3022a({ cuboid: cuboid }) {
    const [hovered, setHovered] = (0, $aqdBs.useState)(false);
    const timeoutRef = (0, $aqdBs.useRef)(null);
    const [hoveringPopover, setHoveringPopover] = (0, $aqdBs.useState)(false);
    const onOver = (0, $aqdBs.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setHovered(true);
    }, []);
    const onOut = (0, $aqdBs.useCallback)(()=>{
        timeoutRef.current = setTimeout(()=>{
            setHovered(false);
        }, $7c39fcf879589ebd$var$popoverGraceTime);
    }, []);
    const cuboidVertices = (0, $aqdBs.useMemo)(()=>$7c39fcf879589ebd$var$getCuboidVertices(cuboid), [
        cuboid
    ]);
    const edges = (0, $aqdBs.useMemo)(()=>[
            [
                0,
                1
            ],
            [
                1,
                2
            ],
            [
                2,
                3
            ],
            [
                3,
                0
            ],
            [
                4,
                5
            ],
            [
                5,
                6
            ],
            [
                6,
                7
            ],
            [
                7,
                4
            ],
            [
                0,
                4
            ],
            [
                1,
                5
            ],
            [
                2,
                6
            ],
            [
                3,
                7
            ]
        ], [
        cuboid
    ]);
    const frontGeometry = (0, $aqdBs.useMemo)(()=>{
        const geometry = new (0, $548f161e17fc6f48$export$b7be63a67df8959)();
        const frontFace = [
            4,
            7,
            5,
            6
        ];
        const vertices = frontFace.flatMap((i)=>cuboidVertices[i].toArray());
        geometry.setAttribute("position", new (0, $548f161e17fc6f48$export$cbe7a62641830ebd)(vertices, 3));
        geometry.setIndex([
            0,
            1,
            2,
            1,
            2,
            3
        ]);
        geometry.computeVertexNormals();
        return geometry;
    }, [
        cuboidVertices
    ]);
    const frontMaterial = (0, $aqdBs.useMemo)(()=>new (0, $548f161e17fc6f48$export$55cbcc9b622fe1f5)({
            color: "#87CEEB",
            transparent: true,
            opacity: 0.5,
            side: 2,
            depthTest: false
        }), []);
    const tagPosition = (0, $aqdBs.useMemo)(()=>{
        return new (0, $548f161e17fc6f48$export$64b5c384219d3699)().addVectors(cuboidVertices[4], cuboidVertices[6]).multiplyScalar(0.5);
    }, [
        cuboidVertices
    ]);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $14024a6d51999040$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("mesh", {
                geometry: frontGeometry,
                material: frontMaterial,
                onPointerOver: onOver,
                onPointerOut: onOut,
                onPointerMove: onOver
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f9091fb34da85890$export$13f9d3c4397c4713), {
                position: tagPosition,
                children: (hovered || hoveringPopover) && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                    onPointerEnter: ()=>setHoveringPopover(true),
                    onPointerLeave: ()=>{
                        setHoveringPopover(false);
                        timeoutRef.current = setTimeout(()=>setHovered(false), 1000);
                    },
                    className: "cuboid-tag__popover",
                    children: [
                        cuboid.label,
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("br", {}),
                        cuboid.stationary ? "Stationary" : "Moving"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6011a4bf8b5bc07b$export$cfdc085ffca97c47), {
                children: edges.map(([start, end], i)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $6011a4bf8b5bc07b$export$d53aa5c5ab432700), {
                        start: cuboidVertices[start],
                        end: cuboidVertices[end],
                        color: "#0033AA"
                    }, i))
            })
        ]
    });
}




var $aqdBs = parcelRequire("aqdBs");

function $1d70b38c6e32754c$export$5c812f854e08d33d({ points: points, maxZ: maxZ = 20, minZ: minZ = -5 }) {
    const geometryRef = (0, $aqdBs.useRef)(new (0, $548f161e17fc6f48$export$b7be63a67df8959)());
    (0, $aqdBs.useEffect)(()=>{
        if (!points || points.length === 0) return;
        (0, $aqdBs.startTransition)(()=>{
            const flat = new Float32Array(points.flat());
            // Create color array
            const colors = new Float32Array(points.length * 3);
            for(let i = 0; i < points.length; i++){
                const z = flat[i * 3 + 2];
                const t = (z - minZ) / (maxZ - minZ); // Normalized height (0 to 1)
                // Create a gradient from blue (cold/low) to red (hot/high)
                // Hue: 0.6 (blue) to 0 (red)
                const color = new (0, $548f161e17fc6f48$export$892596cec99bc70e)();
                color.setHSL(0.6 * (1 - t), 1, 0.5);
                colors[i * 3] = color.r;
                colors[i * 3 + 1] = color.g;
                colors[i * 3 + 2] = color.b;
            }
            if (geometryRef.current.getAttribute("position")?.count !== points.length) {
                geometryRef.current.setAttribute("position", new (0, $548f161e17fc6f48$export$cbe7a62641830ebd)(flat, 3));
                geometryRef.current.setAttribute("color", new (0, $548f161e17fc6f48$export$cbe7a62641830ebd)(colors, 3));
            } else {
                // Update without reallocating new objects
                const posAttr = geometryRef.current.getAttribute("position");
                posAttr.array.set(flat);
                posAttr.needsUpdate = true;
                const colorAttr = geometryRef.current.getAttribute("color");
                colorAttr.array.set(colors);
                colorAttr.needsUpdate = true;
            }
            geometryRef.current.computeBoundingSphere();
        });
    }, [
        points
    ]);
    const pointMaterial = (0, $aqdBs.useMemo)(()=>{
        const material = new (0, $548f161e17fc6f48$export$a178c45366ce5d6b)({
            size: 0.07,
            sizeAttenuation: true,
            vertexColors: true
        });
        return material;
    }, []);
    if (!points || points.length === 0) return null;
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("points", {
        geometry: geometryRef.current,
        frustumCulled: false,
        material: pointMaterial
    });
}





/**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $aqdBs = parcelRequire("aqdBs");
/**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $f29bdab8066070ea$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $f29bdab8066070ea$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const $f29bdab8066070ea$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = $f29bdab8066070ea$export$86f54f62aa7a7514(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const $f29bdab8066070ea$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const $f29bdab8066070ea$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};


/**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $aqdBs = parcelRequire("aqdBs");
/**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $c15228fc2a954b7a$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $9645957013e5f275$export$2e2bcd8739ae039 = (0, $aqdBs.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    return (0, $aqdBs.createElement)("svg", {
        ref: ref,
        ...(0, $c15228fc2a954b7a$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $f29bdab8066070ea$export$3d46f4579dba46e5)("lucide", className),
        ...!children && !(0, $f29bdab8066070ea$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $aqdBs.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


const $dc1d14bc3e20066f$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $aqdBs.forwardRef)(({ className: className, ...props }, ref)=>(0, $aqdBs.createElement)((0, $9645957013e5f275$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $f29bdab8066070ea$export$3d46f4579dba46e5)(`lucide-${(0, $f29bdab8066070ea$export$73bda83cddbc7187)((0, $f29bdab8066070ea$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $f29bdab8066070ea$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $52eb29793c705ab3$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ],
    [
        "path",
        {
            d: "m19 12-7 7-7-7",
            key: "1idqje"
        }
    ]
];
const $52eb29793c705ab3$export$2e2bcd8739ae039 = (0, $dc1d14bc3e20066f$export$2e2bcd8739ae039)("arrow-down", $52eb29793c705ab3$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $806286ec114bebaa$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
];
const $806286ec114bebaa$export$2e2bcd8739ae039 = (0, $dc1d14bc3e20066f$export$2e2bcd8739ae039)("arrow-left", $806286ec114bebaa$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ca2d77d38fd631b1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
];
const $ca2d77d38fd631b1$export$2e2bcd8739ae039 = (0, $dc1d14bc3e20066f$export$2e2bcd8739ae039)("arrow-right", $ca2d77d38fd631b1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $18141533722c0719$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m5 12 7-7 7 7",
            key: "hav0vg"
        }
    ],
    [
        "path",
        {
            d: "M12 19V5",
            key: "x0mq9r"
        }
    ]
];
const $18141533722c0719$export$2e2bcd8739ae039 = (0, $dc1d14bc3e20066f$export$2e2bcd8739ae039)("arrow-up", $18141533722c0719$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3f5a08153f7e9a4e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const $3f5a08153f7e9a4e$export$2e2bcd8739ae039 = (0, $dc1d14bc3e20066f$export$2e2bcd8739ae039)("chevron-left", $3f5a08153f7e9a4e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c59edb3aa4cd7868$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const $c59edb3aa4cd7868$export$2e2bcd8739ae039 = (0, $dc1d14bc3e20066f$export$2e2bcd8739ae039)("chevron-right", $c59edb3aa4cd7868$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c6b995c94611a87a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
];
const $c6b995c94611a87a$export$2e2bcd8739ae039 = (0, $dc1d14bc3e20066f$export$2e2bcd8739ae039)("loader-circle", $c6b995c94611a87a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dcc080e529ad86bb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 3H5a2 2 0 0 0-2 2v3",
            key: "1dcmit"
        }
    ],
    [
        "path",
        {
            d: "M21 8V5a2 2 0 0 0-2-2h-3",
            key: "1e4gt3"
        }
    ],
    [
        "path",
        {
            d: "M3 16v3a2 2 0 0 0 2 2h3",
            key: "wsl5sc"
        }
    ],
    [
        "path",
        {
            d: "M16 21h3a2 2 0 0 0 2-2v-3",
            key: "18trek"
        }
    ]
];
const $dcc080e529ad86bb$export$2e2bcd8739ae039 = (0, $dc1d14bc3e20066f$export$2e2bcd8739ae039)("maximize", $dcc080e529ad86bb$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4e4d6aa8f9f9a208$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 3v3a2 2 0 0 1-2 2H3",
            key: "hohbtr"
        }
    ],
    [
        "path",
        {
            d: "M21 8h-3a2 2 0 0 1-2-2V3",
            key: "5jw1f3"
        }
    ],
    [
        "path",
        {
            d: "M3 16h3a2 2 0 0 1 2 2v3",
            key: "198tvr"
        }
    ],
    [
        "path",
        {
            d: "M16 21v-3a2 2 0 0 1 2-2h3",
            key: "ph8mxp"
        }
    ]
];
const $4e4d6aa8f9f9a208$export$2e2bcd8739ae039 = (0, $dc1d14bc3e20066f$export$2e2bcd8739ae039)("minimize", $4e4d6aa8f9f9a208$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4c87689bacf2ad06$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            x: "14",
            y: "4",
            width: "4",
            height: "16",
            rx: "1",
            key: "zuxfzm"
        }
    ],
    [
        "rect",
        {
            x: "6",
            y: "4",
            width: "4",
            height: "16",
            rx: "1",
            key: "1okwgv"
        }
    ]
];
const $4c87689bacf2ad06$export$2e2bcd8739ae039 = (0, $dc1d14bc3e20066f$export$2e2bcd8739ae039)("pause", $4c87689bacf2ad06$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.501.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f7de208dacc37ede$export$3efd853dbb351e94 = [
    [
        "polygon",
        {
            points: "6 3 20 12 6 21 6 3",
            key: "1oa8hb"
        }
    ]
];
const $f7de208dacc37ede$export$2e2bcd8739ae039 = (0, $dc1d14bc3e20066f$export$2e2bcd8739ae039)("play", $f7de208dacc37ede$export$3efd853dbb351e94);



var $aqdBs = parcelRequire("aqdBs");

var $aqdBs = parcelRequire("aqdBs");
var $c7940c78395137a6$exports = {};
/*!
* screenfull
* v5.2.0 - 2021-11-03
* (c) Sindre Sorhus; MIT License
*/ (function() {
    'use strict';
    var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
    var isCommonjs = (0, $c7940c78395137a6$exports);
    var fn = function() {
        var val;
        var fnMap = [
            [
                'requestFullscreen',
                'exitFullscreen',
                'fullscreenElement',
                'fullscreenEnabled',
                'fullscreenchange',
                'fullscreenerror'
            ],
            // New WebKit
            [
                'webkitRequestFullscreen',
                'webkitExitFullscreen',
                'webkitFullscreenElement',
                'webkitFullscreenEnabled',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            // Old WebKit
            [
                'webkitRequestFullScreen',
                'webkitCancelFullScreen',
                'webkitCurrentFullScreenElement',
                'webkitCancelFullScreen',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            [
                'mozRequestFullScreen',
                'mozCancelFullScreen',
                'mozFullScreenElement',
                'mozFullScreenEnabled',
                'mozfullscreenchange',
                'mozfullscreenerror'
            ],
            [
                'msRequestFullscreen',
                'msExitFullscreen',
                'msFullscreenElement',
                'msFullscreenEnabled',
                'MSFullscreenChange',
                'MSFullscreenError'
            ]
        ];
        var i = 0;
        var l = fnMap.length;
        var ret = {};
        for(; i < l; i++){
            val = fnMap[i];
            if (val && val[1] in document) {
                for(i = 0; i < val.length; i++)ret[fnMap[0][i]] = val[i];
                return ret;
            }
        }
        return false;
    }();
    var eventNameMap = {
        change: fn.fullscreenchange,
        error: fn.fullscreenerror
    };
    var screenfull = {
        request: function(element, options) {
            return new Promise((function(resolve, reject) {
                var onFullScreenEntered = (function() {
                    this.off('change', onFullScreenEntered);
                    resolve();
                }).bind(this);
                this.on('change', onFullScreenEntered);
                element = element || document.documentElement;
                var returnPromise = element[fn.requestFullscreen](options);
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenEntered).catch(reject);
            }).bind(this));
        },
        exit: function() {
            return new Promise((function(resolve, reject) {
                if (!this.isFullscreen) {
                    resolve();
                    return;
                }
                var onFullScreenExit = (function() {
                    this.off('change', onFullScreenExit);
                    resolve();
                }).bind(this);
                this.on('change', onFullScreenExit);
                var returnPromise = document[fn.exitFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenExit).catch(reject);
            }).bind(this));
        },
        toggle: function(element, options) {
            return this.isFullscreen ? this.exit() : this.request(element, options);
        },
        onchange: function(callback) {
            this.on('change', callback);
        },
        onerror: function(callback) {
            this.on('error', callback);
        },
        on: function(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.addEventListener(eventName, callback, false);
        },
        off: function(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.removeEventListener(eventName, callback, false);
        },
        raw: fn
    };
    if (!fn) {
        if (isCommonjs) $c7940c78395137a6$exports = {
            isEnabled: false
        };
        else window.screenfull = {
            isEnabled: false
        };
        return;
    }
    Object.defineProperties(screenfull, {
        isFullscreen: {
            get: function() {
                return Boolean(document[fn.fullscreenElement]);
            }
        },
        element: {
            enumerable: true,
            get: function() {
                return document[fn.fullscreenElement];
            }
        },
        isEnabled: {
            enumerable: true,
            get: function() {
                // Coerce to boolean in case of old WebKit
                return Boolean(document[fn.fullscreenEnabled]);
            }
        }
    });
    if (isCommonjs) $c7940c78395137a6$exports = screenfull;
    else window.screenfull = screenfull;
})();



var $aqdBs = parcelRequire("aqdBs");
var $fcdd75d7987a6500$export$8793edee2d425525 = function() {};
function $fcdd75d7987a6500$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $fcdd75d7987a6500$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $fcdd75d7987a6500$export$4e09c449d6c407f7 = typeof window !== 'undefined';
var $fcdd75d7987a6500$export$42e7ac6120dd324e = typeof navigator !== 'undefined';


var $c31015107512cd14$var$useIsomorphicLayoutEffect = (0, $fcdd75d7987a6500$export$4e09c449d6c407f7) ? (0, $aqdBs.useLayoutEffect) : (0, $aqdBs.useEffect);
var $c31015107512cd14$export$2e2bcd8739ae039 = $c31015107512cd14$var$useIsomorphicLayoutEffect;



var $3358e825ee82c74a$var$useFullscreen = function(ref, enabled, options) {
    if (options === void 0) options = {};
    var video = options.video, _a = options.onClose, onClose = _a === void 0 ? (0, $fcdd75d7987a6500$export$8793edee2d425525) : _a;
    var _b = (0, $aqdBs.useState)(enabled), isFullscreen = _b[0], setIsFullscreen = _b[1];
    (0, $c31015107512cd14$export$2e2bcd8739ae039)(function() {
        if (!enabled) return;
        if (!ref.current) return;
        var onWebkitEndFullscreen = function() {
            if (video === null || video === void 0 ? void 0 : video.current) (0, $fcdd75d7987a6500$export$8c8705df4a2dcec9)(video.current, 'webkitendfullscreen', onWebkitEndFullscreen);
            onClose();
        };
        var onChange = function() {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($c7940c78395137a6$exports))).isEnabled) {
                var isScreenfullFullscreen = (0, (/*@__PURE__*/$parcel$interopDefault($c7940c78395137a6$exports))).isFullscreen;
                setIsFullscreen(isScreenfullFullscreen);
                if (!isScreenfullFullscreen) onClose();
            }
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($c7940c78395137a6$exports))).isEnabled) {
            try {
                (0, (/*@__PURE__*/$parcel$interopDefault($c7940c78395137a6$exports))).request(ref.current);
                setIsFullscreen(true);
            } catch (error) {
                onClose(error);
                setIsFullscreen(false);
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($c7940c78395137a6$exports))).on('change', onChange);
        } else if (video && video.current && video.current.webkitEnterFullscreen) {
            video.current.webkitEnterFullscreen();
            (0, $fcdd75d7987a6500$export$af631764ddc44097)(video.current, 'webkitendfullscreen', onWebkitEndFullscreen);
            setIsFullscreen(true);
        } else {
            onClose();
            setIsFullscreen(false);
        }
        return function() {
            setIsFullscreen(false);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($c7940c78395137a6$exports))).isEnabled) try {
                (0, (/*@__PURE__*/$parcel$interopDefault($c7940c78395137a6$exports))).off('change', onChange);
                (0, (/*@__PURE__*/$parcel$interopDefault($c7940c78395137a6$exports))).exit();
            } catch (_a) {}
            else if (video && video.current && video.current.webkitExitFullscreen) {
                (0, $fcdd75d7987a6500$export$8c8705df4a2dcec9)(video.current, 'webkitendfullscreen', onWebkitEndFullscreen);
                video.current.webkitExitFullscreen();
            }
        };
    }, [
        enabled,
        video,
        ref
    ]);
    return isFullscreen;
};
var $3358e825ee82c74a$export$2e2bcd8739ae039 = $3358e825ee82c74a$var$useFullscreen;


var $aqdBs = parcelRequire("aqdBs");
var $275b25f2d168f2c5$var$toggleReducer = function(state, nextValue) {
    return typeof nextValue === 'boolean' ? nextValue : !state;
};
var $275b25f2d168f2c5$var$useToggle = function(initialValue) {
    return (0, $aqdBs.useReducer)($275b25f2d168f2c5$var$toggleReducer, initialValue);
};
var $275b25f2d168f2c5$export$2e2bcd8739ae039 = $275b25f2d168f2c5$var$useToggle;



const $fc13f8e392596fd1$export$800f23a9cd5ed734 = [
    {
        name: "forward",
        keys: [
            "q",
            "Q"
        ]
    },
    {
        name: "backward",
        keys: [
            "e",
            "E"
        ]
    },
    {
        name: "up",
        keys: [
            "w",
            "W"
        ]
    },
    {
        name: "down",
        keys: [
            "s",
            "S"
        ]
    },
    {
        name: "left",
        keys: [
            "a",
            "A"
        ]
    },
    {
        name: "right",
        keys: [
            "d",
            "D"
        ]
    },
    {
        name: "rotateLeft",
        keys: [
            "ArrowLeft"
        ]
    },
    {
        name: "rotateRight",
        keys: [
            "ArrowRight"
        ]
    },
    {
        name: "rotateUp",
        keys: [
            "ArrowUp"
        ]
    },
    {
        name: "rotateDown",
        keys: [
            "ArrowDown"
        ]
    },
    {
        name: "space",
        keys: [
            "Space"
        ]
    }
];
function $fc13f8e392596fd1$var$handleControls({ camera: camera, action: action, togglePlay: togglePlay, spacePressedRef: spacePressedRef }) {
    const moveSpeed = 0.5;
    const rotSpeed = 0.02;
    if (action.forward) camera.translateY(moveSpeed);
    if (action.backward) camera.translateY(-moveSpeed);
    if (action.left) camera.translateX(-moveSpeed);
    if (action.right) camera.translateX(moveSpeed);
    if (action.up) camera.translateZ(-moveSpeed);
    if (action.down) camera.translateZ(moveSpeed);
    const zAxis = new (0, $548f161e17fc6f48$export$64b5c384219d3699)(0, 0, 1);
    if (action.rotateLeft) camera.rotateOnWorldAxis(zAxis, rotSpeed);
    if (action.rotateRight) camera.rotateOnWorldAxis(zAxis, -rotSpeed);
    if (action.rotateUp) camera.rotateX(rotSpeed);
    if (action.rotateDown) camera.rotateX(-rotSpeed);
    if (action.space && !spacePressedRef.current) {
        togglePlay();
        spacePressedRef.current = true;
    } else if (!action.space) spacePressedRef.current = false;
    camera.updateMatrixWorld();
}
function $fc13f8e392596fd1$export$a27ff602381b60de({ onChange: onChange, frameCount: frameCount, currentFrame: currentFrame, onPlay: onPlay, onStop: onStop, togglePlay: togglePlay, playing: playing, containerRef: containerRef, loading: loading }) {
    const { camera: camera } = (0, $62815e5999fdef70$export$96f57966bedc81b4)();
    const spacePressedRef = (0, $aqdBs.useRef)(false);
    const [show, toggle] = (0, $275b25f2d168f2c5$export$2e2bcd8739ae039)(false);
    const heldRef = (0, $aqdBs.useRef)(null);
    (0, $aqdBs.useEffect)(()=>{
        let frame;
        const loop = ()=>{
            if (heldRef.current) $fc13f8e392596fd1$var$handleControls({
                camera: camera,
                action: heldRef.current,
                togglePlay: togglePlay,
                spacePressedRef: spacePressedRef
            });
            frame = requestAnimationFrame(loop);
        };
        loop();
        return ()=>cancelAnimationFrame(frame);
    }, [
        camera,
        togglePlay
    ]);
    const handleHoldStart = (action)=>{
        heldRef.current = action;
    };
    const handleHoldEnd = ()=>{
        heldRef.current = null;
    };
    // @ts-expect-error nullable is required to initialize ref
    const isFullscreen = (0, $3358e825ee82c74a$export$2e2bcd8739ae039)(containerRef, show, {
        onClose: ()=>toggle(false)
    });
    const position = new (0, $548f161e17fc6f48$export$64b5c384219d3699)(camera.position.x, camera.position.y, camera.position.z);
    const onPrevious = (0, $aqdBs.useCallback)(()=>{
        if (playing) return;
        if (currentFrame == 0) {
            onChange(frameCount - 1);
            return;
        }
        onChange(currentFrame - 1);
    }, [
        currentFrame,
        frameCount,
        onChange,
        playing
    ]);
    const onNext = (0, $aqdBs.useCallback)(()=>{
        if (playing) return;
        if (currentFrame == frameCount - 1) {
            onChange(0);
            return;
        }
        onChange(currentFrame + 1);
    }, [
        currentFrame,
        frameCount,
        onChange,
        playing
    ]);
    const onChangeRange = (0, $aqdBs.useCallback)((e)=>{
        onChange(Number(e.target.value) - 1);
    }, [
        onChange
    ]);
    const [, get] = (0, $c2a67ed70ad506b3$export$179a1940ffcac7a3)();
    (0, $62815e5999fdef70$export$d66501df72047452)(({ camera: camera })=>{
        $fc13f8e392596fd1$var$handleControls({
            camera: camera,
            action: get(),
            togglePlay: togglePlay,
            spacePressedRef: spacePressedRef
        });
    });
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f9091fb34da85890$export$13f9d3c4397c4713), {
        position: position,
        transform: false,
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 10
        },
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
            className: "controls",
            children: [
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                    className: "controls__moving",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                            onPointerDown: ()=>handleHoldStart({
                                    forward: true
                                }),
                            onPointerUp: handleHoldEnd,
                            onPointerLeave: handleHoldEnd,
                            children: "Q"
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                            onPointerDown: ()=>handleHoldStart({
                                    up: true
                                }),
                            onPointerUp: handleHoldEnd,
                            onPointerLeave: handleHoldEnd,
                            children: "W"
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                            onPointerDown: ()=>handleHoldStart({
                                    backward: true
                                }),
                            onPointerUp: handleHoldEnd,
                            onPointerLeave: handleHoldEnd,
                            children: "E"
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                            onPointerDown: ()=>handleHoldStart({
                                    left: true
                                }),
                            onPointerUp: handleHoldEnd,
                            onPointerLeave: handleHoldEnd,
                            children: "A"
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                            onPointerDown: ()=>handleHoldStart({
                                    down: true
                                }),
                            onPointerUp: handleHoldEnd,
                            onPointerLeave: handleHoldEnd,
                            children: "S"
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                            onPointerDown: ()=>handleHoldStart({
                                    right: true
                                }),
                            onPointerUp: handleHoldEnd,
                            onPointerLeave: handleHoldEnd,
                            children: "D"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                    className: "controls__frame",
                    children: [
                        !playing && loading && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                            className: "loading-indicator",
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c6b995c94611a87a$export$2e2bcd8739ae039), {
                                size: 18
                            })
                        }),
                        !playing && !loading && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                            className: "play-button",
                            onClick: onPlay,
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f7de208dacc37ede$export$2e2bcd8739ae039), {
                                size: 18
                            })
                        }),
                        playing && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                            className: "stop-button",
                            onClick: onStop,
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4c87689bacf2ad06$export$2e2bcd8739ae039), {
                                size: 18
                            })
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                            className: "controls__frame__indicator",
                            children: [
                                currentFrame + 1,
                                "/",
                                frameCount
                            ]
                        }),
                        !loading && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                            className: "controls__frame__discrete",
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                                    onClick: onPrevious,
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $3f5a08153f7e9a4e$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                                    onClick: onNext,
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c59edb3aa4cd7868$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                            className: "controls__frame__input",
                            children: !loading && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("input", {
                                type: "range",
                                min: 1,
                                max: frameCount,
                                value: currentFrame + 1,
                                onChange: onChangeRange
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                    className: "controls__rotating",
                    children: [
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                                onPointerDown: ()=>handleHoldStart({
                                        rotateUp: true
                                    }),
                                onPointerUp: handleHoldEnd,
                                onPointerLeave: handleHoldEnd,
                                children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $18141533722c0719$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                                    onPointerDown: ()=>handleHoldStart({
                                            rotateLeft: true
                                        }),
                                    onPointerUp: handleHoldEnd,
                                    onPointerLeave: handleHoldEnd,
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $806286ec114bebaa$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                                    onPointerDown: ()=>handleHoldStart({
                                            rotateDown: true
                                        }),
                                    onPointerUp: handleHoldEnd,
                                    onPointerLeave: handleHoldEnd,
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $52eb29793c705ab3$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                }),
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("button", {
                                    onPointerDown: ()=>handleHoldStart({
                                            rotateRight: true
                                        }),
                                    onPointerUp: handleHoldEnd,
                                    onPointerLeave: handleHoldEnd,
                                    children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $ca2d77d38fd631b1$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
                    className: "controls__fullscreen",
                    children: [
                        !isFullscreen && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("button", {
                            onClick: ()=>toggle(),
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $dcc080e529ad86bb$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            ]
                        }),
                        isFullscreen && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("button", {
                            onClick: ()=>toggle(),
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $4e4d6aa8f9f9a208$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


const $1788df53bcc3cea7$var$minimumFrames = 10;
const $1788df53bcc3cea7$var$frameCount = 50;
function $1788df53bcc3cea7$var$useProgressiveFrameLoader() {
    const [frames, setFrames] = (0, $aqdBs.useState)([]);
    const [loading, setLoading] = (0, $aqdBs.useState)(true);
    const [error, setError] = (0, $aqdBs.useState)(null);
    (0, $aqdBs.useEffect)(()=>{
        const temp = Array($1788df53bcc3cea7$var$frameCount).fill(undefined);
        let ready = 0;
        const loadFrame = async (i)=>{
            const url = `data/frames/frame_${String(i).padStart(2, "0")}.json`;
            try {
                // Frames are vendored under static/data/frames so the demo runs
                // offline, without depending on Scale AI's external domain.
                // Original source (kept as reference / fallback):
                // `https://static.scale.com/uploads/pandaset-challenge/frame_${String(i).padStart(2, "0")}.json`
                const res = await fetch(url);
                if (!res.ok) throw new Error(`Failed to fetch ${url}: HTTP ${res.status}`);
                // Defensive parse: if the host serves something that is not valid
                // JSON (e.g. a Git LFS pointer when the data was committed via LFS
                // but never pulled), fail with a clear message instead of letting a
                // raw SyntaxError bubble up and crash the React tree.
                const raw = await res.text();
                let json;
                try {
                    json = JSON.parse(raw);
                } catch  {
                    throw new Error(`Frame ${url} is not valid JSON. ` + `Got: "${raw.slice(0, 60).replace(/\n/g, " ")}\u{2026}". ` + `If you see a Git LFS pointer, the data was not materialized; ` + `the frames must be served as real JSON.`);
                }
                temp[i] = json;
                ready++;
                if (ready === $1788df53bcc3cea7$var$minimumFrames) {
                    setFrames([
                        ...temp
                    ]);
                    setLoading(false);
                } else if (ready > $1788df53bcc3cea7$var$minimumFrames) setFrames([
                    ...temp
                ]);
            } catch (err) {
                const error = err instanceof Error ? err : new Error("Unknown error");
                // Surface a clear, un-minified message in the console so the failure
                // is debuggable in production builds too.
                console.error(`[frame-loader] ${error.message}`, error);
                setError(error);
            }
        };
        for(let i = 0; i < $1788df53bcc3cea7$var$frameCount; i++)loadFrame(i);
    }, []);
    return {
        frames: frames,
        loading: loading,
        error: error
    };
}
function $1788df53bcc3cea7$var$LoadingState() {
    const { camera: camera } = (0, $62815e5999fdef70$export$96f57966bedc81b4)();
    const position = new (0, $548f161e17fc6f48$export$64b5c384219d3699)(camera.position.x, camera.position.y, camera.position.z);
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $f9091fb34da85890$export$13f9d3c4397c4713), {
        position: position,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("div", {
            className: "loading",
            children: "Loading..."
        })
    });
}
const $1788df53bcc3cea7$var$FRAME_INTERVAL_MS = 100;
function $1788df53bcc3cea7$export$2e2bcd8739ae039() {
    const { frames: frames, loading: loading, error: error } = $1788df53bcc3cea7$var$useProgressiveFrameLoader();
    const [playing, setPlaying] = (0, $aqdBs.useState)(false);
    const [currentFrame, setCurrentFrame] = (0, $aqdBs.useState)(0);
    const requestRef = (0, $aqdBs.useRef)(undefined);
    const lastTimestampRef = (0, $aqdBs.useRef)(undefined);
    const containerRef = (0, $aqdBs.useRef)(null);
    const advanceFrame = ()=>{
        setCurrentFrame((prev)=>(prev + 1) % $1788df53bcc3cea7$var$frameCount);
    };
    const animate = (timestamp)=>{
        if (!lastTimestampRef.current) lastTimestampRef.current = timestamp;
        const delta = timestamp - lastTimestampRef.current;
        if (delta >= $1788df53bcc3cea7$var$FRAME_INTERVAL_MS) {
            advanceFrame();
            lastTimestampRef.current = timestamp;
        }
        requestRef.current = requestAnimationFrame(animate);
    };
    (0, $aqdBs.useEffect)(()=>{
        if (playing) requestRef.current = requestAnimationFrame(animate);
        else {
            if (requestRef.current) cancelAnimationFrame(requestRef.current);
            requestRef.current = undefined;
            lastTimestampRef.current = undefined;
        }
        return ()=>{
            if (requestRef.current) cancelAnimationFrame(requestRef.current);
        };
    }, [
        playing
    ]);
    const onChangeCurrentFrame = (0, $aqdBs.useCallback)((frame)=>{
        setCurrentFrame(frame);
    }, [
        setCurrentFrame
    ]);
    const onPlay = (0, $aqdBs.useCallback)(()=>setPlaying(true), [
        setPlaying
    ]);
    const onStop = (0, $aqdBs.useCallback)(()=>setPlaying(false), [
        setPlaying
    ]);
    const togglePlay = (0, $aqdBs.useCallback)(()=>setPlaying((prev)=>!prev), [
        setPlaying
    ]);
    // NOTE: every hook above must run on every render. Returning early *before*
    // these `useCallback`s (as this code used to) changes the number of hooks
    // between renders the moment `error` becomes truthy, which throws React
    // error #300 ("Rendered fewer hooks than expected") and tears down the
    // WebGL canvas ("THREE.WebGLRenderer: Context Lost"). Keep all early
    // returns below the last hook.
    if (error) return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("main", {
        className: "container",
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)("div", {
            className: "loading",
            children: [
                "Error loading frames: ",
                error.message
            ]
        })
    });
    const showLoading = loading || !frames[currentFrame];
    return /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("main", {
        className: "container",
        ref: containerRef,
        children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $c2a67ed70ad506b3$export$a34fcda2dd58fb18), {
            map: (0, $fc13f8e392596fd1$export$800f23a9cd5ed734),
            children: /*#__PURE__*/ (0, $14024a6d51999040$exports.jsxs)((0, $202e52471ee65b86$export$8d01c972ee8b14a9), {
                children: [
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $70f9e801e680b612$export$74e4ae24825f68d7), {
                        makeDefault: true,
                        position: [
                            0,
                            -37,
                            30
                        ],
                        fov: 75,
                        far: 150,
                        rotation: [
                            1.26,
                            0,
                            0
                        ]
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $fc13f8e392596fd1$export$a27ff602381b60de), {
                        onChange: onChangeCurrentFrame,
                        currentFrame: currentFrame,
                        frameCount: $1788df53bcc3cea7$var$frameCount,
                        onPlay: onPlay,
                        onStop: onStop,
                        togglePlay: togglePlay,
                        playing: playing,
                        containerRef: containerRef,
                        loading: loading
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("ambientLight", {
                        intensity: 0.3
                    }),
                    /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)("pointLight", {
                        position: [
                            10,
                            10,
                            10
                        ]
                    }),
                    showLoading && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($1788df53bcc3cea7$var$LoadingState, {}),
                    frames[currentFrame]?.points && /*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1d70b38c6e32754c$export$5c812f854e08d33d), {
                        points: frames[currentFrame].points
                    }),
                    frames[currentFrame]?.cuboids.map((cuboid)=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $7c39fcf879589ebd$export$bdc9a4b508f3022a), {
                            cuboid: cuboid
                        }, cuboid.uuid))
                ]
            })
        })
    });
}


const $70fc9a727fa662ae$var$App = ()=>/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)((0, $1788df53bcc3cea7$export$2e2bcd8739ae039), {});
(0, $c920eedc27eaef64$export$882461b6382ed46c)(document.getElementById("root")).render(/*#__PURE__*/ (0, $14024a6d51999040$exports.jsx)($70fc9a727fa662ae$var$App, {}));


//# sourceMappingURL=path0.7b60c647.js.map
